(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.service = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],2:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"base64-js":1,"buffer":2,"ieee754":8}],3:[function(require,module,exports){
(function (global,Buffer){(function (){
var $jscomp=$jscomp||{};$jscomp.scope={};$jscomp.findInternal=function(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var f=a[e];if(b.call(c,f,e,a))return{i:e,v:f}}return{i:-1,v:void 0}};$jscomp.ASSUME_ES5=!1;$jscomp.ASSUME_NO_NATIVE_MAP=!1;$jscomp.ASSUME_NO_NATIVE_SET=!1;$jscomp.SIMPLE_FROUND_POLYFILL=!1;
$jscomp.defineProperty=$jscomp.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)};$jscomp.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};$jscomp.global=$jscomp.getGlobal(this);
$jscomp.polyfill=function(a,b,c,d){if(b){c=$jscomp.global;a=a.split(".");for(d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&$jscomp.defineProperty(c,a,{configurable:!0,writable:!0,value:b})}};$jscomp.polyfill("Array.prototype.findIndex",function(a){return a?a:function(a,c){return $jscomp.findInternal(this,a,c).i}},"es6","es3");
$jscomp.checkStringArgs=function(a,b,c){if(null==a)throw new TypeError("The 'this' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""};
$jscomp.polyfill("String.prototype.endsWith",function(a){return a?a:function(a,c){var b=$jscomp.checkStringArgs(this,a,"endsWith");a+="";void 0===c&&(c=b.length);c=Math.max(0,Math.min(c|0,b.length));for(var e=a.length;0<e&&0<c;)if(b[--c]!=a[--e])return!1;return 0>=e}},"es6","es3");$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(a,c){return $jscomp.findInternal(this,a,c).v}},"es6","es3");
$jscomp.polyfill("String.prototype.startsWith",function(a){return a?a:function(a,c){var b=$jscomp.checkStringArgs(this,a,"startsWith");a+="";var e=b.length,f=a.length;c=Math.max(0,Math.min(c|0,b.length));for(var g=0;g<f&&c<e;)if(b[c++]!=a[g++])return!1;return g>=f}},"es6","es3");
$jscomp.polyfill("String.prototype.repeat",function(a){return a?a:function(a){var b=$jscomp.checkStringArgs(this,null,"repeat");if(0>a||1342177279<a)throw new RangeError("Invalid count value");a|=0;for(var d="";a;)if(a&1&&(d+=b),a>>>=1)b+=b;return d}},"es6","es3");var COMPILED=!0,goog=goog||{};goog.global=this||self;goog.isDef=function(a){return void 0!==a};goog.isString=function(a){return"string"==typeof a};goog.isBoolean=function(a){return"boolean"==typeof a};
goog.isNumber=function(a){return"number"==typeof a};goog.exportPath_=function(a,b,c){a=a.split(".");c=c||goog.global;a[0]in c||"undefined"==typeof c.execScript||c.execScript("var "+a[0]);for(var d;a.length&&(d=a.shift());)!a.length&&goog.isDef(b)?c[d]=b:c=c[d]&&c[d]!==Object.prototype[d]?c[d]:c[d]={}};
goog.define=function(a,b){if(!COMPILED){var c=goog.global.CLOSURE_UNCOMPILED_DEFINES,d=goog.global.CLOSURE_DEFINES;c&&void 0===c.nodeType&&Object.prototype.hasOwnProperty.call(c,a)?b=c[a]:d&&void 0===d.nodeType&&Object.prototype.hasOwnProperty.call(d,a)&&(b=d[a])}return b};goog.FEATURESET_YEAR=2012;goog.DEBUG=!0;goog.LOCALE="en";goog.TRUSTED_SITE=!0;goog.STRICT_MODE_COMPATIBLE=!1;goog.DISALLOW_TEST_ONLY_CODE=COMPILED&&!goog.DEBUG;goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING=!1;
goog.provide=function(a){if(goog.isInModuleLoader_())throw Error("goog.provide cannot be used within a module.");if(!COMPILED&&goog.isProvided_(a))throw Error('Namespace "'+a+'" already declared.');goog.constructNamespace_(a)};goog.constructNamespace_=function(a,b){if(!COMPILED){delete goog.implicitNamespaces_[a];for(var c=a;(c=c.substring(0,c.lastIndexOf(".")))&&!goog.getObjectByName(c);)goog.implicitNamespaces_[c]=!0}goog.exportPath_(a,b)};
goog.getScriptNonce=function(a){if(a&&a!=goog.global)return goog.getScriptNonce_(a.document);null===goog.cspNonce_&&(goog.cspNonce_=goog.getScriptNonce_(goog.global.document));return goog.cspNonce_};goog.NONCE_PATTERN_=/^[\w+/_-]+[=]{0,2}$/;goog.cspNonce_=null;goog.getScriptNonce_=function(a){return(a=a.querySelector&&a.querySelector("script[nonce]"))&&(a=a.nonce||a.getAttribute("nonce"))&&goog.NONCE_PATTERN_.test(a)?a:""};goog.VALID_MODULE_RE_=/^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
goog.module=function(a){if(!goog.isString(a)||!a||-1==a.search(goog.VALID_MODULE_RE_))throw Error("Invalid module identifier");if(!goog.isInGoogModuleLoader_())throw Error("Module "+a+" has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
if(goog.moduleLoaderState_.moduleName)throw Error("goog.module may only be called once per module.");goog.moduleLoaderState_.moduleName=a;if(!COMPILED){if(goog.isProvided_(a))throw Error('Namespace "'+a+'" already declared.');delete goog.implicitNamespaces_[a]}};goog.module.get=function(a){return goog.module.getInternal_(a)};
goog.module.getInternal_=function(a){if(!COMPILED){if(a in goog.loadedModules_)return goog.loadedModules_[a].exports;if(!goog.implicitNamespaces_[a])return a=goog.getObjectByName(a),null!=a?a:null}return null};goog.ModuleType={ES6:"es6",GOOG:"goog"};goog.moduleLoaderState_=null;goog.isInModuleLoader_=function(){return goog.isInGoogModuleLoader_()||goog.isInEs6ModuleLoader_()};goog.isInGoogModuleLoader_=function(){return!!goog.moduleLoaderState_&&goog.moduleLoaderState_.type==goog.ModuleType.GOOG};
goog.isInEs6ModuleLoader_=function(){if(goog.moduleLoaderState_&&goog.moduleLoaderState_.type==goog.ModuleType.ES6)return!0;var a=goog.global.$jscomp;return a?"function"!=typeof a.getCurrentModulePath?!1:!!a.getCurrentModulePath():!1};
goog.module.declareLegacyNamespace=function(){if(!COMPILED&&!goog.isInGoogModuleLoader_())throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");if(!COMPILED&&!goog.moduleLoaderState_.moduleName)throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");goog.moduleLoaderState_.declareLegacyNamespace=!0};
goog.declareModuleId=function(a){if(!COMPILED){if(!goog.isInEs6ModuleLoader_())throw Error("goog.declareModuleId may only be called from within an ES6 module");if(goog.moduleLoaderState_&&goog.moduleLoaderState_.moduleName)throw Error("goog.declareModuleId may only be called once per module.");if(a in goog.loadedModules_)throw Error('Module with namespace "'+a+'" already exists.');}if(goog.moduleLoaderState_)goog.moduleLoaderState_.moduleName=a;else{var b=goog.global.$jscomp;if(!b||"function"!=typeof b.getCurrentModulePath)throw Error('Module with namespace "'+
a+'" has been loaded incorrectly.');b=b.require(b.getCurrentModulePath());goog.loadedModules_[a]={exports:b,type:goog.ModuleType.ES6,moduleId:a}}};goog.setTestOnly=function(a){if(goog.DISALLOW_TEST_ONLY_CODE)throw a=a||"",Error("Importing test-only code into non-debug environment"+(a?": "+a:"."));};goog.forwardDeclare=function(a){};
COMPILED||(goog.isProvided_=function(a){return a in goog.loadedModules_||!goog.implicitNamespaces_[a]&&goog.isDefAndNotNull(goog.getObjectByName(a))},goog.implicitNamespaces_={"goog.module":!0});goog.getObjectByName=function(a,b){a=a.split(".");b=b||goog.global;for(var c=0;c<a.length;c++)if(b=b[a[c]],!goog.isDefAndNotNull(b))return null;return b};goog.globalize=function(a,b){b=b||goog.global;for(var c in a)b[c]=a[c]};
goog.addDependency=function(a,b,c,d){!COMPILED&&goog.DEPENDENCIES_ENABLED&&goog.debugLoader_.addDependency(a,b,c,d)};goog.ENABLE_DEBUG_LOADER=!0;goog.logToConsole_=function(a){goog.global.console&&goog.global.console.error(a)};
goog.require=function(a){if(!COMPILED){goog.ENABLE_DEBUG_LOADER&&goog.debugLoader_.requested(a);if(goog.isProvided_(a)){if(goog.isInModuleLoader_())return goog.module.getInternal_(a)}else if(goog.ENABLE_DEBUG_LOADER){var b=goog.moduleLoaderState_;goog.moduleLoaderState_=null;try{goog.debugLoader_.load_(a)}finally{goog.moduleLoaderState_=b}}return null}};goog.requireType=function(a){return{}};goog.basePath="";goog.nullFunction=function(){};
goog.abstractMethod=function(){throw Error("unimplemented abstract method");};goog.addSingletonGetter=function(a){a.instance_=void 0;a.getInstance=function(){if(a.instance_)return a.instance_;goog.DEBUG&&(goog.instantiatedSingletons_[goog.instantiatedSingletons_.length]=a);return a.instance_=new a}};goog.instantiatedSingletons_=[];goog.LOAD_MODULE_USING_EVAL=!0;goog.SEAL_MODULE_EXPORTS=goog.DEBUG;goog.loadedModules_={};goog.DEPENDENCIES_ENABLED=!COMPILED&&goog.ENABLE_DEBUG_LOADER;goog.TRANSPILE="detect";
goog.ASSUME_ES_MODULES_TRANSPILED=!1;goog.TRANSPILE_TO_LANGUAGE="";goog.TRANSPILER="transpile.js";goog.hasBadLetScoping=null;goog.useSafari10Workaround=function(){if(null==goog.hasBadLetScoping){try{var a=!eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";')}catch(b){a=!1}goog.hasBadLetScoping=a}return goog.hasBadLetScoping};goog.workaroundSafari10EvalBug=function(a){return"(function(){"+a+"\n;})();\n"};
goog.loadModule=function(a){var b=goog.moduleLoaderState_;try{goog.moduleLoaderState_={moduleName:"",declareLegacyNamespace:!1,type:goog.ModuleType.GOOG};if(goog.isFunction(a))var c=a.call(void 0,{});else if(goog.isString(a))goog.useSafari10Workaround()&&(a=goog.workaroundSafari10EvalBug(a)),c=goog.loadModuleFromSource_.call(void 0,a);else throw Error("Invalid module definition");var d=goog.moduleLoaderState_.moduleName;if(goog.isString(d)&&d)goog.moduleLoaderState_.declareLegacyNamespace?goog.constructNamespace_(d,
c):goog.SEAL_MODULE_EXPORTS&&Object.seal&&"object"==typeof c&&null!=c&&Object.seal(c),goog.loadedModules_[d]={exports:c,type:goog.ModuleType.GOOG,moduleId:goog.moduleLoaderState_.moduleName};else throw Error('Invalid module name "'+d+'"');}finally{goog.moduleLoaderState_=b}};goog.loadModuleFromSource_=function(a){eval(a);return{}};goog.normalizePath_=function(a){a=a.split("/");for(var b=0;b<a.length;)"."==a[b]?a.splice(b,1):b&&".."==a[b]&&a[b-1]&&".."!=a[b-1]?a.splice(--b,2):b++;return a.join("/")};
goog.loadFileSync_=function(a){if(goog.global.CLOSURE_LOAD_FILE_SYNC)return goog.global.CLOSURE_LOAD_FILE_SYNC(a);try{var b=new goog.global.XMLHttpRequest;b.open("get",a,!1);b.send();return 0==b.status||200==b.status?b.responseText:null}catch(c){return null}};
goog.transpile_=function(a,b,c){var d=goog.global.$jscomp;d||(goog.global.$jscomp=d={});var e=d.transpile;if(!e){var f=goog.basePath+goog.TRANSPILER,g=goog.loadFileSync_(f);if(g){(function(){(0,eval)(g+"\n//# sourceURL="+f)}).call(goog.global);if(goog.global.$gwtExport&&goog.global.$gwtExport.$jscomp&&!goog.global.$gwtExport.$jscomp.transpile)throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: '+JSON.stringify(goog.global.$gwtExport));goog.global.$jscomp.transpile=
goog.global.$gwtExport.$jscomp.transpile;d=goog.global.$jscomp;e=d.transpile}}e||(e=d.transpile=function(a,b){goog.logToConsole_(b+" requires transpilation but no transpiler was found.");return a});return e(a,b,c)};
goog.typeOf=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b};goog.isNull=function(a){return null===a};goog.isDefAndNotNull=function(a){return null!=a};goog.isArray=function(a){return"array"==goog.typeOf(a)};goog.isArrayLike=function(a){var b=goog.typeOf(a);return"array"==b||"object"==b&&"number"==typeof a.length};goog.isDateLike=function(a){return goog.isObject(a)&&"function"==typeof a.getFullYear};goog.isFunction=function(a){return"function"==goog.typeOf(a)};
goog.isObject=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b};goog.getUid=function(a){return a[goog.UID_PROPERTY_]||(a[goog.UID_PROPERTY_]=++goog.uidCounter_)};goog.hasUid=function(a){return!!a[goog.UID_PROPERTY_]};goog.removeUid=function(a){null!==a&&"removeAttribute"in a&&a.removeAttribute(goog.UID_PROPERTY_);try{delete a[goog.UID_PROPERTY_]}catch(b){}};goog.UID_PROPERTY_="closure_uid_"+(1E9*Math.random()>>>0);goog.uidCounter_=0;goog.getHashCode=goog.getUid;
goog.removeHashCode=goog.removeUid;goog.cloneObject=function(a){var b=goog.typeOf(a);if("object"==b||"array"==b){if("function"===typeof a.clone)return a.clone();b="array"==b?[]:{};for(var c in a)b[c]=goog.cloneObject(a[c]);return b}return a};goog.bindNative_=function(a,b,c){return a.call.apply(a.bind,arguments)};
goog.bindJs_=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}};goog.bind=function(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?goog.bind=goog.bindNative_:goog.bind=goog.bindJs_;return goog.bind.apply(null,arguments)};
goog.partial=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}};goog.mixin=function(a,b){for(var c in b)a[c]=b[c]};goog.now=goog.TRUSTED_SITE&&Date.now||function(){return+new Date};
goog.globalEval=function(a){if(goog.global.execScript)goog.global.execScript(a,"JavaScript");else if(goog.global.eval){if(null==goog.evalWorksForGlobals_){try{goog.global.eval("var _evalTest_ = 1;")}catch(d){}if("undefined"!=typeof goog.global._evalTest_){try{delete goog.global._evalTest_}catch(d){}goog.evalWorksForGlobals_=!0}else goog.evalWorksForGlobals_=!1}if(goog.evalWorksForGlobals_)goog.global.eval(a);else{var b=goog.global.document,c=b.createElement("SCRIPT");c.type="text/javascript";c.defer=
!1;c.appendChild(b.createTextNode(a));b.head.appendChild(c);b.head.removeChild(c)}}else throw Error("goog.globalEval not available");};goog.evalWorksForGlobals_=null;
goog.getCssName=function(a,b){if("."==String(a).charAt(0))throw Error('className passed in goog.getCssName must not start with ".". You passed: '+a);var c=function(a){return goog.cssNameMapping_[a]||a},d=function(a){a=a.split("-");for(var b=[],d=0;d<a.length;d++)b.push(c(a[d]));return b.join("-")};d=goog.cssNameMapping_?"BY_WHOLE"==goog.cssNameMappingStyle_?c:d:function(a){return a};a=b?a+"-"+d(b):d(a);return goog.global.CLOSURE_CSS_NAME_MAP_FN?goog.global.CLOSURE_CSS_NAME_MAP_FN(a):a};
goog.setCssNameMapping=function(a,b){goog.cssNameMapping_=a;goog.cssNameMappingStyle_=b};!COMPILED&&goog.global.CLOSURE_CSS_NAME_MAPPING&&(goog.cssNameMapping_=goog.global.CLOSURE_CSS_NAME_MAPPING);goog.getMsg=function(a,b,c){c&&c.html&&(a=a.replace(/</g,"&lt;"));b&&(a=a.replace(/\{\$([^}]+)}/g,function(a,c){return null!=b&&c in b?b[c]:a}));return a};goog.getMsgWithFallback=function(a,b){return a};goog.exportSymbol=function(a,b,c){goog.exportPath_(a,b,c)};
goog.exportProperty=function(a,b,c){a[b]=c};goog.inherits=function(a,b){function c(){}c.prototype=b.prototype;a.superClass_=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.base=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};
goog.base=function(a,b,c){var d=arguments.callee.caller;if(goog.STRICT_MODE_COMPATIBLE||goog.DEBUG&&!d)throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");if("undefined"!==typeof d.superClass_){for(var e=Array(arguments.length-1),f=1;f<arguments.length;f++)e[f-1]=arguments[f];return d.superClass_.constructor.apply(a,e)}if("string"!=typeof b&&"symbol"!=typeof b)throw Error("method names provided to goog.base must be a string or a symbol");
e=Array(arguments.length-2);for(f=2;f<arguments.length;f++)e[f-2]=arguments[f];f=!1;for(var g=a.constructor.prototype;g;g=Object.getPrototypeOf(g))if(g[b]===d)f=!0;else if(f)return g[b].apply(a,e);if(a[b]===d)return a.constructor.prototype[b].apply(a,e);throw Error("goog.base called from a method of one name to a method of a different name");};goog.scope=function(a){if(goog.isInModuleLoader_())throw Error("goog.scope is not supported within a module.");a.call(goog.global)};
COMPILED||(goog.global.COMPILED=COMPILED);goog.defineClass=function(a,b){var c=b.constructor,d=b.statics;c&&c!=Object.prototype.constructor||(c=function(){throw Error("cannot instantiate an interface (no constructor defined).");});c=goog.defineClass.createSealingConstructor_(c,a);a&&goog.inherits(c,a);delete b.constructor;delete b.statics;goog.defineClass.applyProperties_(c.prototype,b);null!=d&&(d instanceof Function?d(c):goog.defineClass.applyProperties_(c,d));return c};
goog.defineClass.SEAL_CLASS_INSTANCES=goog.DEBUG;goog.defineClass.createSealingConstructor_=function(a,b){if(!goog.defineClass.SEAL_CLASS_INSTANCES)return a;var c=!goog.defineClass.isUnsealable_(b),d=function(){var b=a.apply(this,arguments)||this;b[goog.UID_PROPERTY_]=b[goog.UID_PROPERTY_];this.constructor===d&&c&&Object.seal instanceof Function&&Object.seal(b);return b};return d};goog.defineClass.isUnsealable_=function(a){return a&&a.prototype&&a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_]};
goog.defineClass.OBJECT_PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");goog.defineClass.applyProperties_=function(a,b){for(var c in b)Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c]);for(var d=0;d<goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;d++)c=goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d],Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c])};
goog.tagUnsealableClass=function(a){!COMPILED&&goog.defineClass.SEAL_CLASS_INSTANCES&&(a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_]=!0)};goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_="goog_defineClass_legacy_unsealable";
!COMPILED&&goog.DEPENDENCIES_ENABLED&&(goog.inHtmlDocument_=function(){var a=goog.global.document;return null!=a&&"write"in a},goog.isDocumentLoading_=function(){var a=goog.global.document;return a.attachEvent?"complete"!=a.readyState:"loading"==a.readyState},goog.findBasePath_=function(){if(goog.isDef(goog.global.CLOSURE_BASE_PATH)&&goog.isString(goog.global.CLOSURE_BASE_PATH))goog.basePath=goog.global.CLOSURE_BASE_PATH;else if(goog.inHtmlDocument_()){var a=goog.global.document,b=a.currentScript;
a=b?[b]:a.getElementsByTagName("SCRIPT");for(b=a.length-1;0<=b;--b){var c=a[b].src,d=c.lastIndexOf("?");d=-1==d?c.length:d;if("base.js"==c.substr(d-7,7)){goog.basePath=c.substr(0,d-7);break}}}},goog.findBasePath_(),goog.Transpiler=function(){this.requiresTranspilation_=null;this.transpilationTarget_=goog.TRANSPILE_TO_LANGUAGE},goog.Transpiler.prototype.createRequiresTranspilation_=function(){function a(a,b){e?d[a]=!0:b()?(c=a,d[a]=!1):e=d[a]=!0}function b(a){try{return!!eval(a)}catch(h){return!1}}
var c="es3",d={es3:!1},e=!1,f=goog.global.navigator&&goog.global.navigator.userAgent?goog.global.navigator.userAgent:"";a("es5",function(){return b("[1,].length==1")});a("es6",function(){return f.match(/Edge\/(\d+)(\.\d)*/i)?!1:b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()')});
a("es7",function(){return b("2 ** 2 == 4")});a("es8",function(){return b("async () => 1, true")});a("es9",function(){return b("({...rest} = {}), true")});a("es_next",function(){return!1});return{target:c,map:d}},goog.Transpiler.prototype.needsTranspile=function(a,b){if("always"==goog.TRANSPILE)return!0;if("never"==goog.TRANSPILE)return!1;if(!this.requiresTranspilation_){var c=this.createRequiresTranspilation_();this.requiresTranspilation_=c.map;this.transpilationTarget_=this.transpilationTarget_||
c.target}if(a in this.requiresTranspilation_)return this.requiresTranspilation_[a]?!0:!goog.inHtmlDocument_()||"es6"!=b||"noModule"in goog.global.document.createElement("script")?!1:!0;throw Error("Unknown language mode: "+a);},goog.Transpiler.prototype.transpile=function(a,b){return goog.transpile_(a,b,this.transpilationTarget_)},goog.transpiler_=new goog.Transpiler,goog.protectScriptTag_=function(a){return a.replace(/<\/(SCRIPT)/ig,"\\x3c/$1")},goog.DebugLoader_=function(){this.dependencies_={};
this.idToPath_={};this.written_={};this.loadingDeps_=[];this.depsToLoad_=[];this.paused_=!1;this.factory_=new goog.DependencyFactory(goog.transpiler_);this.deferredCallbacks_={};this.deferredQueue_=[]},goog.DebugLoader_.prototype.bootstrap=function(a,b){function c(){d&&(goog.global.setTimeout(d,0),d=null)}var d=b;if(a.length){b=[];for(var e=0;e<a.length;e++){var f=this.getPathFromDeps_(a[e]);if(!f)throw Error("Unregonized namespace: "+a[e]);b.push(this.dependencies_[f])}f=goog.require;var g=0;for(e=
0;e<a.length;e++)f(a[e]),b[e].onLoad(function(){++g==a.length&&c()})}else c()},goog.DebugLoader_.prototype.loadClosureDeps=function(){this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath+"deps.js"),"deps.js",[],[],{},!1));this.loadDeps_()},goog.DebugLoader_.prototype.requested=function(a,b){(a=this.getPathFromDeps_(a))&&(b||this.areDepsLoaded_(this.dependencies_[a].requires))&&(b=this.deferredCallbacks_[a])&&(delete this.deferredCallbacks_[a],b())},goog.DebugLoader_.prototype.setDependencyFactory=
function(a){this.factory_=a},goog.DebugLoader_.prototype.load_=function(a){if(this.getPathFromDeps_(a)){var b=this,c=[],d=function(a){var e=b.getPathFromDeps_(a);if(!e)throw Error("Bad dependency path or symbol: "+a);if(!b.written_[e]){b.written_[e]=!0;a=b.dependencies_[e];for(e=0;e<a.requires.length;e++)goog.isProvided_(a.requires[e])||d(a.requires[e]);c.push(a)}};d(a);a=!!this.depsToLoad_.length;this.depsToLoad_=this.depsToLoad_.concat(c);this.paused_||a||this.loadDeps_()}else throw a="goog.require could not find: "+
a,goog.logToConsole_(a),Error(a);},goog.DebugLoader_.prototype.loadDeps_=function(){for(var a=this,b=this.paused_;this.depsToLoad_.length&&!b;)(function(){var c=!1,d=a.depsToLoad_.shift(),e=!1;a.loading_(d);var f={pause:function(){if(c)throw Error("Cannot call pause after the call to load.");b=!0},resume:function(){c?a.resume_():b=!1},loaded:function(){if(e)throw Error("Double call to loaded.");e=!0;a.loaded_(d)},pending:function(){for(var b=[],c=0;c<a.loadingDeps_.length;c++)b.push(a.loadingDeps_[c]);
return b},setModuleState:function(a){goog.moduleLoaderState_={type:a,moduleName:"",declareLegacyNamespace:!1}},registerEs6ModuleExports:function(a,b,c){c&&(goog.loadedModules_[c]={exports:b,type:goog.ModuleType.ES6,moduleId:c||""})},registerGoogModuleExports:function(a,b){goog.loadedModules_[a]={exports:b,type:goog.ModuleType.GOOG,moduleId:a}},clearModuleState:function(){goog.moduleLoaderState_=null},defer:function(b){if(c)throw Error("Cannot register with defer after the call to load.");a.defer_(d,
b)},areDepsLoaded:function(){return a.areDepsLoaded_(d.requires)}};try{d.load(f)}finally{c=!0}})();b&&this.pause_()},goog.DebugLoader_.prototype.pause_=function(){this.paused_=!0},goog.DebugLoader_.prototype.resume_=function(){this.paused_&&(this.paused_=!1,this.loadDeps_())},goog.DebugLoader_.prototype.loading_=function(a){this.loadingDeps_.push(a)},goog.DebugLoader_.prototype.loaded_=function(a){for(var b=0;b<this.loadingDeps_.length;b++)if(this.loadingDeps_[b]==a){this.loadingDeps_.splice(b,1);
break}for(b=0;b<this.deferredQueue_.length;b++)if(this.deferredQueue_[b]==a.path){this.deferredQueue_.splice(b,1);break}if(this.loadingDeps_.length==this.deferredQueue_.length&&!this.depsToLoad_.length)for(;this.deferredQueue_.length;)this.requested(this.deferredQueue_.shift(),!0);a.loaded()},goog.DebugLoader_.prototype.areDepsLoaded_=function(a){for(var b=0;b<a.length;b++){var c=this.getPathFromDeps_(a[b]);if(!c||!(c in this.deferredCallbacks_||goog.isProvided_(a[b])))return!1}return!0},goog.DebugLoader_.prototype.getPathFromDeps_=
function(a){return a in this.idToPath_?this.idToPath_[a]:a in this.dependencies_?a:null},goog.DebugLoader_.prototype.defer_=function(a,b){this.deferredCallbacks_[a.path]=b;this.deferredQueue_.push(a.path)},goog.LoadController=function(){},goog.LoadController.prototype.pause=function(){},goog.LoadController.prototype.resume=function(){},goog.LoadController.prototype.loaded=function(){},goog.LoadController.prototype.pending=function(){},goog.LoadController.prototype.registerEs6ModuleExports=function(a,
b,c){},goog.LoadController.prototype.setModuleState=function(a){},goog.LoadController.prototype.clearModuleState=function(){},goog.LoadController.prototype.defer=function(a){},goog.LoadController.prototype.areDepsLoaded=function(){},goog.Dependency=function(a,b,c,d,e){this.path=a;this.relativePath=b;this.provides=c;this.requires=d;this.loadFlags=e;this.loaded_=!1;this.loadCallbacks_=[]},goog.Dependency.prototype.getPathName=function(){var a=this.path,b=a.indexOf("://");0<=b&&(a=a.substring(b+3),b=
a.indexOf("/"),0<=b&&(a=a.substring(b+1)));return a},goog.Dependency.prototype.onLoad=function(a){this.loaded_?a():this.loadCallbacks_.push(a)},goog.Dependency.prototype.loaded=function(){this.loaded_=!0;var a=this.loadCallbacks_;this.loadCallbacks_=[];for(var b=0;b<a.length;b++)a[b]()},goog.Dependency.defer_=!1,goog.Dependency.callbackMap_={},goog.Dependency.registerCallback_=function(a){var b=Math.random().toString(32);goog.Dependency.callbackMap_[b]=a;return b},goog.Dependency.unregisterCallback_=
function(a){delete goog.Dependency.callbackMap_[a]},goog.Dependency.callback_=function(a,b){if(a in goog.Dependency.callbackMap_){for(var c=goog.Dependency.callbackMap_[a],d=[],e=1;e<arguments.length;e++)d.push(arguments[e]);c.apply(void 0,d)}else throw Error("Callback key "+a+" does not exist (was base.js loaded more than once?).");},goog.Dependency.prototype.load=function(a){if(goog.global.CLOSURE_IMPORT_SCRIPT)goog.global.CLOSURE_IMPORT_SCRIPT(this.path)?a.loaded():a.pause();else if(goog.inHtmlDocument_()){var b=
goog.global.document;if("complete"==b.readyState&&!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING){if(/\bdeps.js$/.test(this.path)){a.loaded();return}throw Error('Cannot write "'+this.path+'" after document load');}if(!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING&&goog.isDocumentLoading_()){var c=goog.Dependency.registerCallback_(function(b){goog.DebugLoader_.IS_OLD_IE_&&"complete"!=b.readyState||(goog.Dependency.unregisterCallback_(c),a.loaded())}),d=!goog.DebugLoader_.IS_OLD_IE_&&goog.getScriptNonce()?
' nonce="'+goog.getScriptNonce()+'"':"";d='<script src="'+this.path+'" '+(goog.DebugLoader_.IS_OLD_IE_?"onreadystatechange":"onload")+"=\"goog.Dependency.callback_('"+c+'\', this)" type="text/javascript" '+(goog.Dependency.defer_?"defer":"")+d+">\x3c/script>";b.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(d):d)}else{var e=b.createElement("script");e.defer=goog.Dependency.defer_;e.async=!1;e.type="text/javascript";(d=goog.getScriptNonce())&&e.setAttribute("nonce",d);goog.DebugLoader_.IS_OLD_IE_?
(a.pause(),e.onreadystatechange=function(){if("loaded"==e.readyState||"complete"==e.readyState)a.loaded(),a.resume()}):e.onload=function(){e.onload=null;a.loaded()};e.src=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path):this.path;b.head.appendChild(e)}}else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."),"deps.js"==this.relativePath?(goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."),
a.loaded()):a.pause()},goog.Es6ModuleDependency=function(a,b,c,d,e){goog.Dependency.call(this,a,b,c,d,e)},goog.inherits(goog.Es6ModuleDependency,goog.Dependency),goog.Es6ModuleDependency.prototype.load=function(a){function b(a,b){a=b?'<script type="module" crossorigin>'+b+"\x3c/script>":'<script type="module" crossorigin src="'+a+'">\x3c/script>';d.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(a):a)}function c(a,b){var c=d.createElement("script");c.defer=!0;c.async=!1;c.type=
"module";c.setAttribute("crossorigin",!0);var e=goog.getScriptNonce();e&&c.setAttribute("nonce",e);b?c.textContent=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScript(b):b:c.src=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScriptURL(a):a;d.head.appendChild(c)}if(goog.global.CLOSURE_IMPORT_SCRIPT)goog.global.CLOSURE_IMPORT_SCRIPT(this.path)?a.loaded():a.pause();else if(goog.inHtmlDocument_()){var d=goog.global.document,e=this;if(goog.isDocumentLoading_()){var f=b;goog.Dependency.defer_=
!0}else f=c;var g=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(g);a.setModuleState(goog.ModuleType.ES6)});f(void 0,'goog.Dependency.callback_("'+g+'")');f(this.path,void 0);var h=goog.Dependency.registerCallback_(function(b){goog.Dependency.unregisterCallback_(h);a.registerEs6ModuleExports(e.path,b,goog.moduleLoaderState_.moduleName)});f(void 0,'import * as m from "'+this.path+'"; goog.Dependency.callback_("'+h+'", m)');var k=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(k);
a.clearModuleState();a.loaded()});f(void 0,'goog.Dependency.callback_("'+k+'")')}else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."),a.pause()},goog.TransformedDependency=function(a,b,c,d,e){goog.Dependency.call(this,a,b,c,d,e);this.contents_=null;this.lazyFetch_=!goog.inHtmlDocument_()||!("noModule"in goog.global.document.createElement("script"))},goog.inherits(goog.TransformedDependency,goog.Dependency),goog.TransformedDependency.prototype.load=function(a){function b(){e.contents_=
goog.loadFileSync_(e.path);e.contents_&&(e.contents_=e.transform(e.contents_),e.contents_&&(e.contents_+="\n//# sourceURL="+e.path))}function c(){e.lazyFetch_&&b();if(e.contents_){f&&a.setModuleState(goog.ModuleType.ES6);try{var c=e.contents_;e.contents_=null;goog.globalEval(c);if(f)var d=goog.moduleLoaderState_.moduleName}finally{f&&a.clearModuleState()}f&&goog.global.$jscomp.require.ensure([e.getPathName()],function(){a.registerEs6ModuleExports(e.path,goog.global.$jscomp.require(e.getPathName()),
d)});a.loaded()}}function d(){var a=goog.global.document,b=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(b);c()}),d='<script type="text/javascript">'+goog.protectScriptTag_('goog.Dependency.callback_("'+b+'");')+"\x3c/script>";a.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(d):d)}var e=this;if(goog.global.CLOSURE_IMPORT_SCRIPT)b(),this.contents_&&goog.global.CLOSURE_IMPORT_SCRIPT("",this.contents_)?(this.contents_=null,a.loaded()):a.pause();
else{var f=this.loadFlags.module==goog.ModuleType.ES6;this.lazyFetch_||b();var g=1<a.pending().length,h=g&&goog.DebugLoader_.IS_OLD_IE_;g=goog.Dependency.defer_&&(g||goog.isDocumentLoading_());if(h||g)a.defer(function(){c()});else{var k=goog.global.document;h=goog.inHtmlDocument_()&&"ActiveXObject"in goog.global;if(f&&goog.inHtmlDocument_()&&goog.isDocumentLoading_()&&!h){goog.Dependency.defer_=!0;a.pause();var l=k.onreadystatechange;k.onreadystatechange=function(){"interactive"==k.readyState&&(k.onreadystatechange=
l,c(),a.resume());goog.isFunction(l)&&l.apply(void 0,arguments)}}else!goog.DebugLoader_.IS_OLD_IE_&&goog.inHtmlDocument_()&&goog.isDocumentLoading_()?d():c()}}},goog.TransformedDependency.prototype.transform=function(a){},goog.TranspiledDependency=function(a,b,c,d,e,f){goog.TransformedDependency.call(this,a,b,c,d,e);this.transpiler=f},goog.inherits(goog.TranspiledDependency,goog.TransformedDependency),goog.TranspiledDependency.prototype.transform=function(a){return this.transpiler.transpile(a,this.getPathName())},
goog.PreTranspiledEs6ModuleDependency=function(a,b,c,d,e){goog.TransformedDependency.call(this,a,b,c,d,e)},goog.inherits(goog.PreTranspiledEs6ModuleDependency,goog.TransformedDependency),goog.PreTranspiledEs6ModuleDependency.prototype.transform=function(a){return a},goog.GoogModuleDependency=function(a,b,c,d,e,f,g){goog.TransformedDependency.call(this,a,b,c,d,e);this.needsTranspile_=f;this.transpiler_=g},goog.inherits(goog.GoogModuleDependency,goog.TransformedDependency),goog.GoogModuleDependency.prototype.transform=
function(a){this.needsTranspile_&&(a=this.transpiler_.transpile(a,this.getPathName()));return goog.LOAD_MODULE_USING_EVAL&&goog.isDef(goog.global.JSON)?"goog.loadModule("+goog.global.JSON.stringify(a+"\n//# sourceURL="+this.path+"\n")+");":'goog.loadModule(function(exports) {"use strict";'+a+"\n;return exports});\n//# sourceURL="+this.path+"\n"},goog.DebugLoader_.IS_OLD_IE_=!(goog.global.atob||!goog.global.document||!goog.global.document.all),goog.DebugLoader_.prototype.addDependency=function(a,b,
c,d){b=b||[];a=a.replace(/\\/g,"/");var e=goog.normalizePath_(goog.basePath+a);d&&"boolean"!==typeof d||(d=d?{module:goog.ModuleType.GOOG}:{});c=this.factory_.createDependency(e,a,b,c,d,goog.transpiler_.needsTranspile(d.lang||"es3",d.module));this.dependencies_[e]=c;for(c=0;c<b.length;c++)this.idToPath_[b[c]]=e;this.idToPath_[a]=e},goog.DependencyFactory=function(a){this.transpiler=a},goog.DependencyFactory.prototype.createDependency=function(a,b,c,d,e,f){return e.module==goog.ModuleType.GOOG?new goog.GoogModuleDependency(a,
b,c,d,e,f,this.transpiler):f?new goog.TranspiledDependency(a,b,c,d,e,this.transpiler):e.module==goog.ModuleType.ES6?"never"==goog.TRANSPILE&&goog.ASSUME_ES_MODULES_TRANSPILED?new goog.PreTranspiledEs6ModuleDependency(a,b,c,d,e):new goog.Es6ModuleDependency(a,b,c,d,e):new goog.Dependency(a,b,c,d,e)},goog.debugLoader_=new goog.DebugLoader_,goog.loadClosureDeps=function(){goog.debugLoader_.loadClosureDeps()},goog.setDependencyFactory=function(a){goog.debugLoader_.setDependencyFactory(a)},goog.global.CLOSURE_NO_DEPS||
goog.debugLoader_.loadClosureDeps(),goog.bootstrap=function(a,b){goog.debugLoader_.bootstrap(a,b)});goog.TRUSTED_TYPES_POLICY_NAME="";goog.identity_=function(a){return a};goog.createTrustedTypesPolicy=function(a){var b=null;if("undefined"===typeof TrustedTypes||!TrustedTypes.createPolicy)return b;try{b=TrustedTypes.createPolicy(a,{createHTML:goog.identity_,createScript:goog.identity_,createScriptURL:goog.identity_,createURL:goog.identity_})}catch(c){goog.logToConsole_(c.message)}return b};
goog.TRUSTED_TYPES_POLICY_=goog.TRUSTED_TYPES_POLICY_NAME?goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME+"#base"):null;goog.object={};goog.object.is=function(a,b){return a===b?0!==a||1/a===1/b:a!==a&&b!==b};goog.object.forEach=function(a,b,c){for(var d in a)b.call(c,a[d],d,a)};goog.object.filter=function(a,b,c){var d={},e;for(e in a)b.call(c,a[e],e,a)&&(d[e]=a[e]);return d};goog.object.map=function(a,b,c){var d={},e;for(e in a)d[e]=b.call(c,a[e],e,a);return d};goog.object.some=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return!0;return!1};
goog.object.every=function(a,b,c){for(var d in a)if(!b.call(c,a[d],d,a))return!1;return!0};goog.object.getCount=function(a){var b=0,c;for(c in a)b++;return b};goog.object.getAnyKey=function(a){for(var b in a)return b};goog.object.getAnyValue=function(a){for(var b in a)return a[b]};goog.object.contains=function(a,b){return goog.object.containsValue(a,b)};goog.object.getValues=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b};
goog.object.getKeys=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b};goog.object.getValueByKeys=function(a,b){var c=goog.isArrayLike(b),d=c?b:arguments;for(c=c?0:1;c<d.length;c++){if(null==a)return;a=a[d[c]]}return a};goog.object.containsKey=function(a,b){return null!==a&&b in a};goog.object.containsValue=function(a,b){for(var c in a)if(a[c]==b)return!0;return!1};goog.object.findKey=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d};
goog.object.findValue=function(a,b,c){return(b=goog.object.findKey(a,b,c))&&a[b]};goog.object.isEmpty=function(a){for(var b in a)return!1;return!0};goog.object.clear=function(a){for(var b in a)delete a[b]};goog.object.remove=function(a,b){var c;(c=b in a)&&delete a[b];return c};goog.object.add=function(a,b,c){if(null!==a&&b in a)throw Error('The object already contains the key "'+b+'"');goog.object.set(a,b,c)};goog.object.get=function(a,b,c){return null!==a&&b in a?a[b]:c};
goog.object.set=function(a,b,c){a[b]=c};goog.object.setIfUndefined=function(a,b,c){return b in a?a[b]:a[b]=c};goog.object.setWithReturnValueIfNotSet=function(a,b,c){if(b in a)return a[b];c=c();return a[b]=c};goog.object.equals=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(var d in b)if(!(d in a))return!1;return!0};goog.object.clone=function(a){var b={},c;for(c in a)b[c]=a[c];return b};
goog.object.unsafeClone=function(a){var b=goog.typeOf(a);if("object"==b||"array"==b){if(goog.isFunction(a.clone))return a.clone();b="array"==b?[]:{};for(var c in a)b[c]=goog.object.unsafeClone(a[c]);return b}return a};goog.object.transpose=function(a){var b={},c;for(c in a)b[a[c]]=c;return b};goog.object.PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.object.extend=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<goog.object.PROTOTYPE_FIELDS_.length;f++)c=goog.object.PROTOTYPE_FIELDS_[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};
goog.object.create=function(a){var b=arguments.length;if(1==b&&goog.isArray(arguments[0]))return goog.object.create.apply(null,arguments[0]);if(b%2)throw Error("Uneven number of arguments");for(var c={},d=0;d<b;d+=2)c[arguments[d]]=arguments[d+1];return c};goog.object.createSet=function(a){var b=arguments.length;if(1==b&&goog.isArray(arguments[0]))return goog.object.createSet.apply(null,arguments[0]);for(var c={},d=0;d<b;d++)c[arguments[d]]=!0;return c};
goog.object.createImmutableView=function(a){var b=a;Object.isFrozen&&!Object.isFrozen(a)&&(b=Object.create(a),Object.freeze(b));return b};goog.object.isImmutableView=function(a){return!!Object.isFrozen&&Object.isFrozen(a)};
goog.object.getAllPropertyNames=function(a,b,c){if(!a)return[];if(!Object.getOwnPropertyNames||!Object.getPrototypeOf)return goog.object.getKeys(a);for(var d={};a&&(a!==Object.prototype||b)&&(a!==Function.prototype||c);){for(var e=Object.getOwnPropertyNames(a),f=0;f<e.length;f++)d[e[f]]=!0;a=Object.getPrototypeOf(a)}return goog.object.getKeys(d)};goog.object.getSuperClass=function(a){return(a=Object.getPrototypeOf(a.prototype))&&a.constructor};goog.debug={};goog.debug.Error=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,goog.debug.Error);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a));this.reportErrorToServer=!0};goog.inherits(goog.debug.Error,Error);goog.debug.Error.prototype.name="CustomError";goog.dom={};goog.dom.NodeType={ELEMENT:1,ATTRIBUTE:2,TEXT:3,CDATA_SECTION:4,ENTITY_REFERENCE:5,ENTITY:6,PROCESSING_INSTRUCTION:7,COMMENT:8,DOCUMENT:9,DOCUMENT_TYPE:10,DOCUMENT_FRAGMENT:11,NOTATION:12};goog.asserts={};goog.asserts.ENABLE_ASSERTS=goog.DEBUG;goog.asserts.AssertionError=function(a,b){goog.debug.Error.call(this,goog.asserts.subs_(a,b));this.messagePattern=a};goog.inherits(goog.asserts.AssertionError,goog.debug.Error);goog.asserts.AssertionError.prototype.name="AssertionError";goog.asserts.DEFAULT_ERROR_HANDLER=function(a){throw a;};goog.asserts.errorHandler_=goog.asserts.DEFAULT_ERROR_HANDLER;
goog.asserts.subs_=function(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");return c+a[d]};goog.asserts.doAssertFailure_=function(a,b,c,d){var e="Assertion failed";if(c){e+=": "+c;var f=d}else a&&(e+=": "+a,f=b);a=new goog.asserts.AssertionError(""+e,f||[]);goog.asserts.errorHandler_(a)};goog.asserts.setErrorHandler=function(a){goog.asserts.ENABLE_ASSERTS&&(goog.asserts.errorHandler_=a)};
goog.asserts.assert=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!a&&goog.asserts.doAssertFailure_("",null,b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertExists=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&null==a&&goog.asserts.doAssertFailure_("Expected to exist: %s.",[a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.fail=function(a,b){goog.asserts.ENABLE_ASSERTS&&goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1)))};goog.asserts.assertNumber=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isNumber(a)&&goog.asserts.doAssertFailure_("Expected number but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertString=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isString(a)&&goog.asserts.doAssertFailure_("Expected string but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertFunction=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isFunction(a)&&goog.asserts.doAssertFailure_("Expected function but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertObject=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isObject(a)&&goog.asserts.doAssertFailure_("Expected object but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertArray=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isArray(a)&&goog.asserts.doAssertFailure_("Expected array but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertBoolean=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isBoolean(a)&&goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertElement=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||goog.isObject(a)&&a.nodeType==goog.dom.NodeType.ELEMENT||goog.asserts.doAssertFailure_("Expected Element but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertInstanceof=function(a,b,c,d){!goog.asserts.ENABLE_ASSERTS||a instanceof b||goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.",[goog.asserts.getType_(b),goog.asserts.getType_(a)],c,Array.prototype.slice.call(arguments,3));return a};goog.asserts.assertFinite=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||"number"==typeof a&&isFinite(a)||goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.",[a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertObjectPrototypeIsIntact=function(){for(var a in Object.prototype)goog.asserts.fail(a+" should not be enumerable in Object.prototype.")};goog.asserts.getType_=function(a){return a instanceof Function?a.displayName||a.name||"unknown type name":a instanceof Object?a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a):null===a?"null":typeof a};var jspb={BinaryConstants:{},ConstBinaryMessage:function(){},BinaryMessage:function(){}};jspb.BinaryConstants.FieldType={INVALID:-1,DOUBLE:1,FLOAT:2,INT64:3,UINT64:4,INT32:5,FIXED64:6,FIXED32:7,BOOL:8,STRING:9,GROUP:10,MESSAGE:11,BYTES:12,UINT32:13,ENUM:14,SFIXED32:15,SFIXED64:16,SINT32:17,SINT64:18,FHASH64:30,VHASH64:31};jspb.BinaryConstants.WireType={INVALID:-1,VARINT:0,FIXED64:1,DELIMITED:2,START_GROUP:3,END_GROUP:4,FIXED32:5};
jspb.BinaryConstants.FieldTypeToWireType=function(a){var b=jspb.BinaryConstants.FieldType,c=jspb.BinaryConstants.WireType;switch(a){case b.INT32:case b.INT64:case b.UINT32:case b.UINT64:case b.SINT32:case b.SINT64:case b.BOOL:case b.ENUM:case b.VHASH64:return c.VARINT;case b.DOUBLE:case b.FIXED64:case b.SFIXED64:case b.FHASH64:return c.FIXED64;case b.STRING:case b.MESSAGE:case b.BYTES:return c.DELIMITED;case b.FLOAT:case b.FIXED32:case b.SFIXED32:return c.FIXED32;default:return c.INVALID}};
jspb.BinaryConstants.INVALID_FIELD_NUMBER=-1;jspb.BinaryConstants.FLOAT32_EPS=1.401298464324817E-45;jspb.BinaryConstants.FLOAT32_MIN=1.1754943508222875E-38;jspb.BinaryConstants.FLOAT32_MAX=3.4028234663852886E38;jspb.BinaryConstants.FLOAT64_EPS=4.9E-324;jspb.BinaryConstants.FLOAT64_MIN=2.2250738585072014E-308;jspb.BinaryConstants.FLOAT64_MAX=1.7976931348623157E308;jspb.BinaryConstants.TWO_TO_20=1048576;jspb.BinaryConstants.TWO_TO_23=8388608;jspb.BinaryConstants.TWO_TO_31=2147483648;
jspb.BinaryConstants.TWO_TO_32=4294967296;jspb.BinaryConstants.TWO_TO_52=4503599627370496;jspb.BinaryConstants.TWO_TO_63=0x7fffffffffffffff;jspb.BinaryConstants.TWO_TO_64=1.8446744073709552E19;jspb.BinaryConstants.ZERO_HASH="\x00\x00\x00\x00\x00\x00\x00\x00";goog.array={};goog.NATIVE_ARRAY_PROTOTYPES=goog.TRUSTED_SITE;goog.array.ASSUME_NATIVE_FUNCTIONS=2012<goog.FEATURESET_YEAR;goog.array.peek=function(a){return a[a.length-1]};goog.array.last=goog.array.peek;
goog.array.indexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.indexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(goog.isString(a))return goog.isString(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1};
goog.array.lastIndexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.lastIndexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.lastIndexOf.call(a,b,null==c?a.length-1:c)}:function(a,b,c){c=null==c?a.length-1:c;0>c&&(c=Math.max(0,a.length+c));if(goog.isString(a))return goog.isString(b)&&1==b.length?a.lastIndexOf(b,c):-1;for(;0<=c;c--)if(c in a&&a[c]===b)return c;return-1};
goog.array.forEach=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.forEach)?function(a,b,c){goog.asserts.assert(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};goog.array.forEachRight=function(a,b,c){var d=a.length,e=goog.isString(a)?a.split(""):a;for(--d;0<=d;--d)d in e&&b.call(c,e[d],d,a)};
goog.array.filter=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.filter)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,g=goog.isString(a)?a.split(""):a,h=0;h<d;h++)if(h in g){var k=g[h];b.call(c,k,h,a)&&(e[f++]=k)}return e};
goog.array.map=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.map)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=goog.isString(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e};
goog.array.reduce=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduce)?function(a,b,c,d){goog.asserts.assert(null!=a.length);d&&(b=goog.bind(b,d));return Array.prototype.reduce.call(a,b,c)}:function(a,b,c,d){var e=c;goog.array.forEach(a,function(c,g){e=b.call(d,e,c,g,a)});return e};
goog.array.reduceRight=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduceRight)?function(a,b,c,d){goog.asserts.assert(null!=a.length);goog.asserts.assert(null!=b);d&&(b=goog.bind(b,d));return Array.prototype.reduceRight.call(a,b,c)}:function(a,b,c,d){var e=c;goog.array.forEachRight(a,function(c,g){e=b.call(d,e,c,g,a)});return e};
goog.array.some=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.some)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1};
goog.array.every=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.every)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};goog.array.count=function(a,b,c){var d=0;goog.array.forEach(a,function(a,f,g){b.call(c,a,f,g)&&++d},c);return d};
goog.array.find=function(a,b,c){b=goog.array.findIndex(a,b,c);return 0>b?null:goog.isString(a)?a.charAt(b):a[b]};goog.array.findIndex=function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1};goog.array.findRight=function(a,b,c){b=goog.array.findIndexRight(a,b,c);return 0>b?null:goog.isString(a)?a.charAt(b):a[b]};
goog.array.findIndexRight=function(a,b,c){var d=a.length,e=goog.isString(a)?a.split(""):a;for(--d;0<=d;d--)if(d in e&&b.call(c,e[d],d,a))return d;return-1};goog.array.contains=function(a,b){return 0<=goog.array.indexOf(a,b)};goog.array.isEmpty=function(a){return 0==a.length};goog.array.clear=function(a){if(!goog.isArray(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0};goog.array.insert=function(a,b){goog.array.contains(a,b)||a.push(b)};
goog.array.insertAt=function(a,b,c){goog.array.splice(a,c,0,b)};goog.array.insertArrayAt=function(a,b,c){goog.partial(goog.array.splice,a,c,0).apply(null,b)};goog.array.insertBefore=function(a,b,c){var d;2==arguments.length||0>(d=goog.array.indexOf(a,c))?a.push(b):goog.array.insertAt(a,b,d)};goog.array.remove=function(a,b){b=goog.array.indexOf(a,b);var c;(c=0<=b)&&goog.array.removeAt(a,b);return c};
goog.array.removeLast=function(a,b){b=goog.array.lastIndexOf(a,b);return 0<=b?(goog.array.removeAt(a,b),!0):!1};goog.array.removeAt=function(a,b){goog.asserts.assert(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length};goog.array.removeIf=function(a,b,c){b=goog.array.findIndex(a,b,c);return 0<=b?(goog.array.removeAt(a,b),!0):!1};goog.array.removeAllIf=function(a,b,c){var d=0;goog.array.forEachRight(a,function(e,f){b.call(c,e,f,a)&&goog.array.removeAt(a,f)&&d++});return d};
goog.array.concat=function(a){return Array.prototype.concat.apply([],arguments)};goog.array.join=function(a){return Array.prototype.concat.apply([],arguments)};goog.array.toArray=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};goog.array.clone=goog.array.toArray;goog.array.extend=function(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(goog.isArrayLike(d)){var e=a.length||0,f=d.length||0;a.length=e+f;for(var g=0;g<f;g++)a[e+g]=d[g]}else a.push(d)}};
goog.array.splice=function(a,b,c,d){goog.asserts.assert(null!=a.length);return Array.prototype.splice.apply(a,goog.array.slice(arguments,1))};goog.array.slice=function(a,b,c){goog.asserts.assert(null!=a.length);return 2>=arguments.length?Array.prototype.slice.call(a,b):Array.prototype.slice.call(a,b,c)};
goog.array.removeDuplicates=function(a,b,c){b=b||a;var d=function(a){return goog.isObject(a)?"o"+goog.getUid(a):(typeof a).charAt(0)+a};c=c||d;d={};for(var e=0,f=0;f<a.length;){var g=a[f++],h=c(g);Object.prototype.hasOwnProperty.call(d,h)||(d[h]=!0,b[e++]=g)}b.length=e};goog.array.binarySearch=function(a,b,c){return goog.array.binarySearch_(a,c||goog.array.defaultCompare,!1,b)};goog.array.binarySelect=function(a,b,c){return goog.array.binarySearch_(a,b,!0,void 0,c)};
goog.array.binarySearch_=function(a,b,c,d,e){for(var f=0,g=a.length,h;f<g;){var k=f+g>>1;var l=c?b.call(e,a[k],k,a):b(d,a[k]);0<l?f=k+1:(g=k,h=!l)}return h?f:~f};goog.array.sort=function(a,b){a.sort(b||goog.array.defaultCompare)};goog.array.stableSort=function(a,b){for(var c=Array(a.length),d=0;d<a.length;d++)c[d]={index:d,value:a[d]};var e=b||goog.array.defaultCompare;goog.array.sort(c,function(a,b){return e(a.value,b.value)||a.index-b.index});for(d=0;d<a.length;d++)a[d]=c[d].value};
goog.array.sortByKey=function(a,b,c){var d=c||goog.array.defaultCompare;goog.array.sort(a,function(a,c){return d(b(a),b(c))})};goog.array.sortObjectsByKey=function(a,b,c){goog.array.sortByKey(a,function(a){return a[b]},c)};goog.array.isSorted=function(a,b,c){b=b||goog.array.defaultCompare;for(var d=1;d<a.length;d++){var e=b(a[d-1],a[d]);if(0<e||0==e&&c)return!1}return!0};
goog.array.equals=function(a,b,c){if(!goog.isArrayLike(a)||!goog.isArrayLike(b)||a.length!=b.length)return!1;var d=a.length;c=c||goog.array.defaultCompareEquality;for(var e=0;e<d;e++)if(!c(a[e],b[e]))return!1;return!0};goog.array.compare3=function(a,b,c){c=c||goog.array.defaultCompare;for(var d=Math.min(a.length,b.length),e=0;e<d;e++){var f=c(a[e],b[e]);if(0!=f)return f}return goog.array.defaultCompare(a.length,b.length)};goog.array.defaultCompare=function(a,b){return a>b?1:a<b?-1:0};
goog.array.inverseDefaultCompare=function(a,b){return-goog.array.defaultCompare(a,b)};goog.array.defaultCompareEquality=function(a,b){return a===b};goog.array.binaryInsert=function(a,b,c){c=goog.array.binarySearch(a,b,c);return 0>c?(goog.array.insertAt(a,b,-(c+1)),!0):!1};goog.array.binaryRemove=function(a,b,c){b=goog.array.binarySearch(a,b,c);return 0<=b?goog.array.removeAt(a,b):!1};
goog.array.bucket=function(a,b,c){for(var d={},e=0;e<a.length;e++){var f=a[e],g=b.call(c,f,e,a);goog.isDef(g)&&(d[g]||(d[g]=[])).push(f)}return d};goog.array.toObject=function(a,b,c){var d={};goog.array.forEach(a,function(e,f){d[b.call(c,e,f,a)]=e});return d};goog.array.range=function(a,b,c){var d=[],e=0,f=a;c=c||1;void 0!==b&&(e=a,f=b);if(0>c*(f-e))return[];if(0<c)for(a=e;a<f;a+=c)d.push(a);else for(a=e;a>f;a+=c)d.push(a);return d};
goog.array.repeat=function(a,b){for(var c=[],d=0;d<b;d++)c[d]=a;return c};goog.array.flatten=function(a){for(var b=[],c=0;c<arguments.length;c++){var d=arguments[c];if(goog.isArray(d))for(var e=0;e<d.length;e+=8192){var f=goog.array.slice(d,e,e+8192);f=goog.array.flatten.apply(null,f);for(var g=0;g<f.length;g++)b.push(f[g])}else b.push(d)}return b};
goog.array.rotate=function(a,b){goog.asserts.assert(null!=a.length);a.length&&(b%=a.length,0<b?Array.prototype.unshift.apply(a,a.splice(-b,b)):0>b&&Array.prototype.push.apply(a,a.splice(0,-b)));return a};goog.array.moveItem=function(a,b,c){goog.asserts.assert(0<=b&&b<a.length);goog.asserts.assert(0<=c&&c<a.length);b=Array.prototype.splice.call(a,b,1);Array.prototype.splice.call(a,c,0,b[0])};
goog.array.zip=function(a){if(!arguments.length)return[];for(var b=[],c=arguments[0].length,d=1;d<arguments.length;d++)arguments[d].length<c&&(c=arguments[d].length);for(d=0;d<c;d++){for(var e=[],f=0;f<arguments.length;f++)e.push(arguments[f][d]);b.push(e)}return b};goog.array.shuffle=function(a,b){b=b||Math.random;for(var c=a.length-1;0<c;c--){var d=Math.floor(b()*(c+1)),e=a[c];a[c]=a[d];a[d]=e}};goog.array.copyByIndex=function(a,b){var c=[];goog.array.forEach(b,function(b){c.push(a[b])});return c};
goog.array.concatMap=function(a,b,c){return goog.array.concat.apply([],goog.array.map(a,b,c))};goog.crypt={};goog.crypt.stringToByteArray=function(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);255<e&&(b[c++]=e&255,e>>=8);b[c++]=e}return b};goog.crypt.byteArrayToString=function(a){if(8192>=a.length)return String.fromCharCode.apply(null,a);for(var b="",c=0;c<a.length;c+=8192){var d=goog.array.slice(a,c,c+8192);b+=String.fromCharCode.apply(null,d)}return b};
goog.crypt.byteArrayToHex=function(a,b){return goog.array.map(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join(b||"")};goog.crypt.hexToByteArray=function(a){goog.asserts.assert(0==a.length%2,"Key string length must be multiple of 2");for(var b=[],c=0;c<a.length;c+=2)b.push(parseInt(a.substring(c,c+2),16));return b};
goog.crypt.stringToUtf8ByteArray=function(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);128>e?b[c++]=e:(2048>e?b[c++]=e>>6|192:(55296==(e&64512)&&d+1<a.length&&56320==(a.charCodeAt(d+1)&64512)?(e=65536+((e&1023)<<10)+(a.charCodeAt(++d)&1023),b[c++]=e>>18|240,b[c++]=e>>12&63|128):b[c++]=e>>12|224,b[c++]=e>>6&63|128),b[c++]=e&63|128)}return b};
goog.crypt.utf8ByteArrayToString=function(a){for(var b=[],c=0,d=0;c<a.length;){var e=a[c++];if(128>e)b[d++]=String.fromCharCode(e);else if(191<e&&224>e){var f=a[c++];b[d++]=String.fromCharCode((e&31)<<6|f&63)}else if(239<e&&365>e){f=a[c++];var g=a[c++],h=a[c++];e=((e&7)<<18|(f&63)<<12|(g&63)<<6|h&63)-65536;b[d++]=String.fromCharCode(55296+(e>>10));b[d++]=String.fromCharCode(56320+(e&1023))}else f=a[c++],g=a[c++],b[d++]=String.fromCharCode((e&15)<<12|(f&63)<<6|g&63)}return b.join("")};
goog.crypt.xorByteArray=function(a,b){goog.asserts.assert(a.length==b.length,"XOR array lengths must match");for(var c=[],d=0;d<a.length;d++)c.push(a[d]^b[d]);return c};goog.dom.asserts={};goog.dom.asserts.assertIsLocation=function(a){if(goog.asserts.ENABLE_ASSERTS){var b=goog.dom.asserts.getWindow_(a);b&&(!a||!(a instanceof b.Location)&&a instanceof b.Element)&&goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s",goog.dom.asserts.debugStringForType_(a))}return a};
goog.dom.asserts.assertIsElementType_=function(a,b){if(goog.asserts.ENABLE_ASSERTS){var c=goog.dom.asserts.getWindow_(a);c&&"undefined"!=typeof c[b]&&(a&&(a instanceof c[b]||!(a instanceof c.Location||a instanceof c.Element))||goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s",b,goog.dom.asserts.debugStringForType_(a)))}return a};goog.dom.asserts.assertIsHTMLAnchorElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLAnchorElement")};
goog.dom.asserts.assertIsHTMLButtonElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLButtonElement")};goog.dom.asserts.assertIsHTMLLinkElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLLinkElement")};goog.dom.asserts.assertIsHTMLImageElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLImageElement")};goog.dom.asserts.assertIsHTMLAudioElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLAudioElement")};
goog.dom.asserts.assertIsHTMLVideoElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLVideoElement")};goog.dom.asserts.assertIsHTMLInputElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLInputElement")};goog.dom.asserts.assertIsHTMLTextAreaElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLTextAreaElement")};goog.dom.asserts.assertIsHTMLCanvasElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLCanvasElement")};
goog.dom.asserts.assertIsHTMLEmbedElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLEmbedElement")};goog.dom.asserts.assertIsHTMLFormElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLFormElement")};goog.dom.asserts.assertIsHTMLFrameElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLFrameElement")};goog.dom.asserts.assertIsHTMLIFrameElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLIFrameElement")};
goog.dom.asserts.assertIsHTMLObjectElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLObjectElement")};goog.dom.asserts.assertIsHTMLScriptElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLScriptElement")};
goog.dom.asserts.debugStringForType_=function(a){if(goog.isObject(a))try{return a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(b){return"<object could not be stringified>"}else return void 0===a?"undefined":null===a?"null":typeof a};goog.dom.asserts.getWindow_=function(a){try{var b=a&&a.ownerDocument,c=b&&(b.defaultView||b.parentWindow);c=c||goog.global;if(c.Element&&c.Location)return c}catch(d){}return null};goog.functions={};goog.functions.constant=function(a){return function(){return a}};goog.functions.FALSE=function(){return!1};goog.functions.TRUE=function(){return!0};goog.functions.NULL=function(){return null};goog.functions.identity=function(a,b){return a};goog.functions.error=function(a){return function(){throw Error(a);}};goog.functions.fail=function(a){return function(){throw a;}};
goog.functions.lock=function(a,b){b=b||0;return function(){return a.apply(this,Array.prototype.slice.call(arguments,0,b))}};goog.functions.nth=function(a){return function(){return arguments[a]}};goog.functions.partialRight=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=Array.prototype.slice.call(arguments);b.push.apply(b,c);return a.apply(this,b)}};goog.functions.withReturnValue=function(a,b){return goog.functions.sequence(a,goog.functions.constant(b))};
goog.functions.equalTo=function(a,b){return function(c){return b?a==c:a===c}};goog.functions.compose=function(a,b){var c=arguments,d=c.length;return function(){var a;d&&(a=c[d-1].apply(this,arguments));for(var b=d-2;0<=b;b--)a=c[b].call(this,a);return a}};goog.functions.sequence=function(a){var b=arguments,c=b.length;return function(){for(var a,e=0;e<c;e++)a=b[e].apply(this,arguments);return a}};
goog.functions.and=function(a){var b=arguments,c=b.length;return function(){for(var a=0;a<c;a++)if(!b[a].apply(this,arguments))return!1;return!0}};goog.functions.or=function(a){var b=arguments,c=b.length;return function(){for(var a=0;a<c;a++)if(b[a].apply(this,arguments))return!0;return!1}};goog.functions.not=function(a){return function(){return!a.apply(this,arguments)}};
goog.functions.create=function(a,b){var c=function(){};c.prototype=a.prototype;c=new c;a.apply(c,Array.prototype.slice.call(arguments,1));return c};goog.functions.CACHE_RETURN_VALUE=!0;goog.functions.cacheReturnValue=function(a){var b=!1,c;return function(){if(!goog.functions.CACHE_RETURN_VALUE)return a();b||(c=a(),b=!0);return c}};goog.functions.once=function(a){var b=a;return function(){if(b){var a=b;b=null;a()}}};
goog.functions.debounce=function(a,b,c){var d=0;return function(e){goog.global.clearTimeout(d);var f=arguments;d=goog.global.setTimeout(function(){a.apply(c,f)},b)}};goog.functions.throttle=function(a,b,c){var d=0,e=!1,f=[],g=function(){d=0;e&&(e=!1,h())},h=function(){d=goog.global.setTimeout(g,b);a.apply(c,f)};return function(a){f=arguments;d?e=!0:h()}};goog.functions.rateLimit=function(a,b,c){var d=0,e=function(){d=0};return function(f){d||(d=goog.global.setTimeout(e,b),a.apply(c,arguments))}};goog.dom.HtmlElement=function(){};goog.dom.TagName=function(a){this.tagName_=a};goog.dom.TagName.prototype.toString=function(){return this.tagName_};goog.dom.TagName.A=new goog.dom.TagName("A");goog.dom.TagName.ABBR=new goog.dom.TagName("ABBR");goog.dom.TagName.ACRONYM=new goog.dom.TagName("ACRONYM");goog.dom.TagName.ADDRESS=new goog.dom.TagName("ADDRESS");goog.dom.TagName.APPLET=new goog.dom.TagName("APPLET");goog.dom.TagName.AREA=new goog.dom.TagName("AREA");goog.dom.TagName.ARTICLE=new goog.dom.TagName("ARTICLE");
goog.dom.TagName.ASIDE=new goog.dom.TagName("ASIDE");goog.dom.TagName.AUDIO=new goog.dom.TagName("AUDIO");goog.dom.TagName.B=new goog.dom.TagName("B");goog.dom.TagName.BASE=new goog.dom.TagName("BASE");goog.dom.TagName.BASEFONT=new goog.dom.TagName("BASEFONT");goog.dom.TagName.BDI=new goog.dom.TagName("BDI");goog.dom.TagName.BDO=new goog.dom.TagName("BDO");goog.dom.TagName.BIG=new goog.dom.TagName("BIG");goog.dom.TagName.BLOCKQUOTE=new goog.dom.TagName("BLOCKQUOTE");goog.dom.TagName.BODY=new goog.dom.TagName("BODY");
goog.dom.TagName.BR=new goog.dom.TagName("BR");goog.dom.TagName.BUTTON=new goog.dom.TagName("BUTTON");goog.dom.TagName.CANVAS=new goog.dom.TagName("CANVAS");goog.dom.TagName.CAPTION=new goog.dom.TagName("CAPTION");goog.dom.TagName.CENTER=new goog.dom.TagName("CENTER");goog.dom.TagName.CITE=new goog.dom.TagName("CITE");goog.dom.TagName.CODE=new goog.dom.TagName("CODE");goog.dom.TagName.COL=new goog.dom.TagName("COL");goog.dom.TagName.COLGROUP=new goog.dom.TagName("COLGROUP");
goog.dom.TagName.COMMAND=new goog.dom.TagName("COMMAND");goog.dom.TagName.DATA=new goog.dom.TagName("DATA");goog.dom.TagName.DATALIST=new goog.dom.TagName("DATALIST");goog.dom.TagName.DD=new goog.dom.TagName("DD");goog.dom.TagName.DEL=new goog.dom.TagName("DEL");goog.dom.TagName.DETAILS=new goog.dom.TagName("DETAILS");goog.dom.TagName.DFN=new goog.dom.TagName("DFN");goog.dom.TagName.DIALOG=new goog.dom.TagName("DIALOG");goog.dom.TagName.DIR=new goog.dom.TagName("DIR");goog.dom.TagName.DIV=new goog.dom.TagName("DIV");
goog.dom.TagName.DL=new goog.dom.TagName("DL");goog.dom.TagName.DT=new goog.dom.TagName("DT");goog.dom.TagName.EM=new goog.dom.TagName("EM");goog.dom.TagName.EMBED=new goog.dom.TagName("EMBED");goog.dom.TagName.FIELDSET=new goog.dom.TagName("FIELDSET");goog.dom.TagName.FIGCAPTION=new goog.dom.TagName("FIGCAPTION");goog.dom.TagName.FIGURE=new goog.dom.TagName("FIGURE");goog.dom.TagName.FONT=new goog.dom.TagName("FONT");goog.dom.TagName.FOOTER=new goog.dom.TagName("FOOTER");goog.dom.TagName.FORM=new goog.dom.TagName("FORM");
goog.dom.TagName.FRAME=new goog.dom.TagName("FRAME");goog.dom.TagName.FRAMESET=new goog.dom.TagName("FRAMESET");goog.dom.TagName.H1=new goog.dom.TagName("H1");goog.dom.TagName.H2=new goog.dom.TagName("H2");goog.dom.TagName.H3=new goog.dom.TagName("H3");goog.dom.TagName.H4=new goog.dom.TagName("H4");goog.dom.TagName.H5=new goog.dom.TagName("H5");goog.dom.TagName.H6=new goog.dom.TagName("H6");goog.dom.TagName.HEAD=new goog.dom.TagName("HEAD");goog.dom.TagName.HEADER=new goog.dom.TagName("HEADER");
goog.dom.TagName.HGROUP=new goog.dom.TagName("HGROUP");goog.dom.TagName.HR=new goog.dom.TagName("HR");goog.dom.TagName.HTML=new goog.dom.TagName("HTML");goog.dom.TagName.I=new goog.dom.TagName("I");goog.dom.TagName.IFRAME=new goog.dom.TagName("IFRAME");goog.dom.TagName.IMG=new goog.dom.TagName("IMG");goog.dom.TagName.INPUT=new goog.dom.TagName("INPUT");goog.dom.TagName.INS=new goog.dom.TagName("INS");goog.dom.TagName.ISINDEX=new goog.dom.TagName("ISINDEX");goog.dom.TagName.KBD=new goog.dom.TagName("KBD");
goog.dom.TagName.KEYGEN=new goog.dom.TagName("KEYGEN");goog.dom.TagName.LABEL=new goog.dom.TagName("LABEL");goog.dom.TagName.LEGEND=new goog.dom.TagName("LEGEND");goog.dom.TagName.LI=new goog.dom.TagName("LI");goog.dom.TagName.LINK=new goog.dom.TagName("LINK");goog.dom.TagName.MAIN=new goog.dom.TagName("MAIN");goog.dom.TagName.MAP=new goog.dom.TagName("MAP");goog.dom.TagName.MARK=new goog.dom.TagName("MARK");goog.dom.TagName.MATH=new goog.dom.TagName("MATH");goog.dom.TagName.MENU=new goog.dom.TagName("MENU");
goog.dom.TagName.MENUITEM=new goog.dom.TagName("MENUITEM");goog.dom.TagName.META=new goog.dom.TagName("META");goog.dom.TagName.METER=new goog.dom.TagName("METER");goog.dom.TagName.NAV=new goog.dom.TagName("NAV");goog.dom.TagName.NOFRAMES=new goog.dom.TagName("NOFRAMES");goog.dom.TagName.NOSCRIPT=new goog.dom.TagName("NOSCRIPT");goog.dom.TagName.OBJECT=new goog.dom.TagName("OBJECT");goog.dom.TagName.OL=new goog.dom.TagName("OL");goog.dom.TagName.OPTGROUP=new goog.dom.TagName("OPTGROUP");
goog.dom.TagName.OPTION=new goog.dom.TagName("OPTION");goog.dom.TagName.OUTPUT=new goog.dom.TagName("OUTPUT");goog.dom.TagName.P=new goog.dom.TagName("P");goog.dom.TagName.PARAM=new goog.dom.TagName("PARAM");goog.dom.TagName.PICTURE=new goog.dom.TagName("PICTURE");goog.dom.TagName.PRE=new goog.dom.TagName("PRE");goog.dom.TagName.PROGRESS=new goog.dom.TagName("PROGRESS");goog.dom.TagName.Q=new goog.dom.TagName("Q");goog.dom.TagName.RP=new goog.dom.TagName("RP");goog.dom.TagName.RT=new goog.dom.TagName("RT");
goog.dom.TagName.RTC=new goog.dom.TagName("RTC");goog.dom.TagName.RUBY=new goog.dom.TagName("RUBY");goog.dom.TagName.S=new goog.dom.TagName("S");goog.dom.TagName.SAMP=new goog.dom.TagName("SAMP");goog.dom.TagName.SCRIPT=new goog.dom.TagName("SCRIPT");goog.dom.TagName.SECTION=new goog.dom.TagName("SECTION");goog.dom.TagName.SELECT=new goog.dom.TagName("SELECT");goog.dom.TagName.SMALL=new goog.dom.TagName("SMALL");goog.dom.TagName.SOURCE=new goog.dom.TagName("SOURCE");goog.dom.TagName.SPAN=new goog.dom.TagName("SPAN");
goog.dom.TagName.STRIKE=new goog.dom.TagName("STRIKE");goog.dom.TagName.STRONG=new goog.dom.TagName("STRONG");goog.dom.TagName.STYLE=new goog.dom.TagName("STYLE");goog.dom.TagName.SUB=new goog.dom.TagName("SUB");goog.dom.TagName.SUMMARY=new goog.dom.TagName("SUMMARY");goog.dom.TagName.SUP=new goog.dom.TagName("SUP");goog.dom.TagName.SVG=new goog.dom.TagName("SVG");goog.dom.TagName.TABLE=new goog.dom.TagName("TABLE");goog.dom.TagName.TBODY=new goog.dom.TagName("TBODY");goog.dom.TagName.TD=new goog.dom.TagName("TD");
goog.dom.TagName.TEMPLATE=new goog.dom.TagName("TEMPLATE");goog.dom.TagName.TEXTAREA=new goog.dom.TagName("TEXTAREA");goog.dom.TagName.TFOOT=new goog.dom.TagName("TFOOT");goog.dom.TagName.TH=new goog.dom.TagName("TH");goog.dom.TagName.THEAD=new goog.dom.TagName("THEAD");goog.dom.TagName.TIME=new goog.dom.TagName("TIME");goog.dom.TagName.TITLE=new goog.dom.TagName("TITLE");goog.dom.TagName.TR=new goog.dom.TagName("TR");goog.dom.TagName.TRACK=new goog.dom.TagName("TRACK");goog.dom.TagName.TT=new goog.dom.TagName("TT");
goog.dom.TagName.U=new goog.dom.TagName("U");goog.dom.TagName.UL=new goog.dom.TagName("UL");goog.dom.TagName.VAR=new goog.dom.TagName("VAR");goog.dom.TagName.VIDEO=new goog.dom.TagName("VIDEO");goog.dom.TagName.WBR=new goog.dom.TagName("WBR");goog.dom.tags={};goog.dom.tags.VOID_TAGS_={area:!0,base:!0,br:!0,col:!0,command:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0};goog.dom.tags.isVoidTag=function(a){return!0===goog.dom.tags.VOID_TAGS_[a]};goog.html={};goog.html.trustedtypes={};goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY=goog.TRUSTED_TYPES_POLICY_NAME?goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME+"#html"):null;goog.string={};goog.string.TypedString=function(){};goog.string.Const=function(a,b){this.stringConstValueWithSecurityContract__googStringSecurityPrivate_=a===goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_&&b||"";this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_=goog.string.Const.TYPE_MARKER_};goog.string.Const.prototype.implementsGoogStringTypedString=!0;goog.string.Const.prototype.getTypedStringValue=function(){return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_};
goog.string.Const.prototype.toString=function(){return"Const{"+this.stringConstValueWithSecurityContract__googStringSecurityPrivate_+"}"};goog.string.Const.unwrap=function(a){if(a instanceof goog.string.Const&&a.constructor===goog.string.Const&&a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_===goog.string.Const.TYPE_MARKER_)return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;goog.asserts.fail("expected object of type Const, got '"+a+"'");return"type_error:Const"};
goog.string.Const.from=function(a){return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_,a)};goog.string.Const.TYPE_MARKER_={};goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_={};goog.string.Const.EMPTY=goog.string.Const.from("");goog.html.SafeScript=function(){this.privateDoNotAccessOrElseSafeScriptWrappedValue_="";this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_};goog.html.SafeScript.prototype.implementsGoogStringTypedString=!0;goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeScript.fromConstant=function(a){a=goog.string.Const.unwrap(a);return 0===a.length?goog.html.SafeScript.EMPTY:goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeScript.fromConstantAndArgs=function(a,b){for(var c=[],d=1;d<arguments.length;d++)c.push(goog.html.SafeScript.stringify_(arguments[d]));return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("("+goog.string.Const.unwrap(a)+")("+c.join(", ")+");")};goog.html.SafeScript.fromJson=function(a){return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(a))};goog.html.SafeScript.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString()};
goog.DEBUG&&(goog.html.SafeScript.prototype.toString=function(){return"SafeScript{"+this.privateDoNotAccessOrElseSafeScriptWrappedValue_+"}"});goog.html.SafeScript.unwrap=function(a){return goog.html.SafeScript.unwrapTrustedScript(a).toString()};
goog.html.SafeScript.unwrapTrustedScript=function(a){if(a instanceof goog.html.SafeScript&&a.constructor===goog.html.SafeScript&&a.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;goog.asserts.fail("expected object of type SafeScript, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeScript"};
goog.html.SafeScript.stringify_=function(a){return JSON.stringify(a).replace(/</g,"\\x3c")};goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse=function(a){return(new goog.html.SafeScript).initSecurityPrivateDoNotAccessOrElse_(a)};
goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_=function(a){this.privateDoNotAccessOrElseSafeScriptWrappedValue_=goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY?goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(a):a;return this};goog.html.SafeScript.EMPTY=goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");goog.fs={};goog.fs.url={};goog.fs.url.createObjectUrl=function(a){return goog.fs.url.getUrlObject_().createObjectURL(a)};goog.fs.url.revokeObjectUrl=function(a){goog.fs.url.getUrlObject_().revokeObjectURL(a)};goog.fs.url.getUrlObject_=function(){var a=goog.fs.url.findUrlObject_();if(null!=a)return a;throw Error("This browser doesn't seem to support blob URLs");};
goog.fs.url.findUrlObject_=function(){return goog.isDef(goog.global.URL)&&goog.isDef(goog.global.URL.createObjectURL)?goog.global.URL:goog.isDef(goog.global.webkitURL)&&goog.isDef(goog.global.webkitURL.createObjectURL)?goog.global.webkitURL:goog.isDef(goog.global.createObjectURL)?goog.global:null};goog.fs.url.browserSupportsObjectUrls=function(){return null!=goog.fs.url.findUrlObject_()};goog.i18n={};goog.i18n.bidi={};goog.i18n.bidi.FORCE_RTL=!1;
goog.i18n.bidi.IS_RTL=goog.i18n.bidi.FORCE_RTL||("ar"==goog.LOCALE.substring(0,2).toLowerCase()||"fa"==goog.LOCALE.substring(0,2).toLowerCase()||"he"==goog.LOCALE.substring(0,2).toLowerCase()||"iw"==goog.LOCALE.substring(0,2).toLowerCase()||"ps"==goog.LOCALE.substring(0,2).toLowerCase()||"sd"==goog.LOCALE.substring(0,2).toLowerCase()||"ug"==goog.LOCALE.substring(0,2).toLowerCase()||"ur"==goog.LOCALE.substring(0,2).toLowerCase()||"yi"==goog.LOCALE.substring(0,2).toLowerCase())&&(2==goog.LOCALE.length||
"-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))||3<=goog.LOCALE.length&&"ckb"==goog.LOCALE.substring(0,3).toLowerCase()&&(3==goog.LOCALE.length||"-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4))||7<=goog.LOCALE.length&&("-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))&&("adlm"==goog.LOCALE.substring(3,7).toLowerCase()||"arab"==goog.LOCALE.substring(3,7).toLowerCase()||"hebr"==goog.LOCALE.substring(3,7).toLowerCase()||"nkoo"==goog.LOCALE.substring(3,
7).toLowerCase()||"rohg"==goog.LOCALE.substring(3,7).toLowerCase()||"thaa"==goog.LOCALE.substring(3,7).toLowerCase())||8<=goog.LOCALE.length&&("-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4))&&("adlm"==goog.LOCALE.substring(4,8).toLowerCase()||"arab"==goog.LOCALE.substring(4,8).toLowerCase()||"hebr"==goog.LOCALE.substring(4,8).toLowerCase()||"nkoo"==goog.LOCALE.substring(4,8).toLowerCase()||"rohg"==goog.LOCALE.substring(4,8).toLowerCase()||"thaa"==goog.LOCALE.substring(4,8).toLowerCase());
goog.i18n.bidi.Format={LRE:"\u202a",RLE:"\u202b",PDF:"\u202c",LRM:"\u200e",RLM:"\u200f"};goog.i18n.bidi.Dir={LTR:1,RTL:-1,NEUTRAL:0};goog.i18n.bidi.RIGHT="right";goog.i18n.bidi.LEFT="left";goog.i18n.bidi.I18N_RIGHT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.LEFT:goog.i18n.bidi.RIGHT;goog.i18n.bidi.I18N_LEFT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT;
goog.i18n.bidi.toDir=function(a,b){return"number"==typeof a?0<a?goog.i18n.bidi.Dir.LTR:0>a?goog.i18n.bidi.Dir.RTL:b?null:goog.i18n.bidi.Dir.NEUTRAL:null==a?null:a?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR};goog.i18n.bidi.ltrChars_="A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0900-\u1fff\u200e\u2c00-\ud801\ud804-\ud839\ud83c-\udbff\uf900-\ufb1c\ufe00-\ufe6f\ufefd-\uffff";goog.i18n.bidi.rtlChars_="\u0591-\u06ef\u06fa-\u08ff\u200f\ud802-\ud803\ud83a-\ud83b\ufb1d-\ufdff\ufe70-\ufefc";
goog.i18n.bidi.htmlSkipReg_=/<[^>]*>|&[^;]+;/g;goog.i18n.bidi.stripHtmlIfNeeded_=function(a,b){return b?a.replace(goog.i18n.bidi.htmlSkipReg_,""):a};goog.i18n.bidi.rtlCharReg_=new RegExp("["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.ltrCharReg_=new RegExp("["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.hasAnyRtl=function(a,b){return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.hasRtlChar=goog.i18n.bidi.hasAnyRtl;
goog.i18n.bidi.hasAnyLtr=function(a,b){return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.ltrRe_=new RegExp("^["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlRe_=new RegExp("^["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.isRtlChar=function(a){return goog.i18n.bidi.rtlRe_.test(a)};goog.i18n.bidi.isLtrChar=function(a){return goog.i18n.bidi.ltrRe_.test(a)};goog.i18n.bidi.isNeutralChar=function(a){return!goog.i18n.bidi.isLtrChar(a)&&!goog.i18n.bidi.isRtlChar(a)};
goog.i18n.bidi.ltrDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.rtlChars_+"]*["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.ltrChars_+"]*["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.startsWithRtl=function(a,b){return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isRtlText=goog.i18n.bidi.startsWithRtl;
goog.i18n.bidi.startsWithLtr=function(a,b){return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isLtrText=goog.i18n.bidi.startsWithLtr;goog.i18n.bidi.isRequiredLtrRe_=/^http:\/\/.*/;goog.i18n.bidi.isNeutralText=function(a,b){a=goog.i18n.bidi.stripHtmlIfNeeded_(a,b);return goog.i18n.bidi.isRequiredLtrRe_.test(a)||!goog.i18n.bidi.hasAnyLtr(a)&&!goog.i18n.bidi.hasAnyRtl(a)};
goog.i18n.bidi.ltrExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.ltrChars_+"][^"+goog.i18n.bidi.rtlChars_+"]*$");goog.i18n.bidi.rtlExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.rtlChars_+"][^"+goog.i18n.bidi.ltrChars_+"]*$");goog.i18n.bidi.endsWithLtr=function(a,b){return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isLtrExitText=goog.i18n.bidi.endsWithLtr;
goog.i18n.bidi.endsWithRtl=function(a,b){return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isRtlExitText=goog.i18n.bidi.endsWithRtl;goog.i18n.bidi.rtlLocalesRe_=/^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;goog.i18n.bidi.isRtlLanguage=function(a){return goog.i18n.bidi.rtlLocalesRe_.test(a)};goog.i18n.bidi.bracketGuardTextRe_=/(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
goog.i18n.bidi.guardBracketInText=function(a,b){b=(void 0===b?goog.i18n.bidi.hasAnyRtl(a):b)?goog.i18n.bidi.Format.RLM:goog.i18n.bidi.Format.LRM;return a.replace(goog.i18n.bidi.bracketGuardTextRe_,b+"$&"+b)};goog.i18n.bidi.enforceRtlInHtml=function(a){return"<"==a.charAt(0)?a.replace(/<\w+/,"$& dir=rtl"):"\n<span dir=rtl>"+a+"</span>"};goog.i18n.bidi.enforceRtlInText=function(a){return goog.i18n.bidi.Format.RLE+a+goog.i18n.bidi.Format.PDF};
goog.i18n.bidi.enforceLtrInHtml=function(a){return"<"==a.charAt(0)?a.replace(/<\w+/,"$& dir=ltr"):"\n<span dir=ltr>"+a+"</span>"};goog.i18n.bidi.enforceLtrInText=function(a){return goog.i18n.bidi.Format.LRE+a+goog.i18n.bidi.Format.PDF};goog.i18n.bidi.dimensionsRe_=/:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;goog.i18n.bidi.leftRe_=/left/gi;goog.i18n.bidi.rightRe_=/right/gi;goog.i18n.bidi.tempRe_=/%%%%/g;
goog.i18n.bidi.mirrorCSS=function(a){return a.replace(goog.i18n.bidi.dimensionsRe_,":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_,"%%%%").replace(goog.i18n.bidi.rightRe_,goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_,goog.i18n.bidi.RIGHT)};goog.i18n.bidi.doubleQuoteSubstituteRe_=/([\u0591-\u05f2])"/g;goog.i18n.bidi.singleQuoteSubstituteRe_=/([\u0591-\u05f2])'/g;
goog.i18n.bidi.normalizeHebrewQuote=function(a){return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_,"$1\u05f4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_,"$1\u05f3")};goog.i18n.bidi.wordSeparatorRe_=/\s+/;goog.i18n.bidi.hasNumeralsRe_=/[\d\u06f0-\u06f9]/;goog.i18n.bidi.rtlDetectionThreshold_=.4;
goog.i18n.bidi.estimateDirection=function(a,b){var c=0,d=0,e=!1;a=goog.i18n.bidi.stripHtmlIfNeeded_(a,b).split(goog.i18n.bidi.wordSeparatorRe_);for(b=0;b<a.length;b++){var f=a[b];goog.i18n.bidi.startsWithRtl(f)?(c++,d++):goog.i18n.bidi.isRequiredLtrRe_.test(f)?e=!0:goog.i18n.bidi.hasAnyLtr(f)?d++:goog.i18n.bidi.hasNumeralsRe_.test(f)&&(e=!0)}return 0==d?e?goog.i18n.bidi.Dir.LTR:goog.i18n.bidi.Dir.NEUTRAL:c/d>goog.i18n.bidi.rtlDetectionThreshold_?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR};
goog.i18n.bidi.detectRtlDirectionality=function(a,b){return goog.i18n.bidi.estimateDirection(a,b)==goog.i18n.bidi.Dir.RTL};goog.i18n.bidi.setElementDirAndAlign=function(a,b){a&&(b=goog.i18n.bidi.toDir(b))&&(a.style.textAlign=b==goog.i18n.bidi.Dir.RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT,a.dir=b==goog.i18n.bidi.Dir.RTL?"rtl":"ltr")};
goog.i18n.bidi.setElementDirByTextDirectionality=function(a,b){switch(goog.i18n.bidi.estimateDirection(b)){case goog.i18n.bidi.Dir.LTR:a.dir="ltr";break;case goog.i18n.bidi.Dir.RTL:a.dir="rtl";break;default:a.removeAttribute("dir")}};goog.i18n.bidi.DirectionalString=function(){};goog.html.TrustedResourceUrl=function(){this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_="";this.trustedURL_=null;this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_};goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString=!0;goog.html.TrustedResourceUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString()};
goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.TrustedResourceUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR};
goog.html.TrustedResourceUrl.prototype.cloneWithParams=function(a,b){var c=goog.html.TrustedResourceUrl.unwrap(this);c=goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);var d=c[3]||"";return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1]+goog.html.TrustedResourceUrl.stringifyParams_("?",c[2]||"",a)+goog.html.TrustedResourceUrl.stringifyParams_("#",d,b))};
goog.DEBUG&&(goog.html.TrustedResourceUrl.prototype.toString=function(){return"TrustedResourceUrl{"+this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_+"}"});goog.html.TrustedResourceUrl.unwrap=function(a){return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString()};
goog.html.TrustedResourceUrl.unwrapTrustedScriptURL=function(a){if(a instanceof goog.html.TrustedResourceUrl&&a.constructor===goog.html.TrustedResourceUrl&&a.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;goog.asserts.fail("expected object of type TrustedResourceUrl, got '"+a+"' of type "+goog.typeOf(a));return"type_error:TrustedResourceUrl"};
goog.html.TrustedResourceUrl.unwrapTrustedURL=function(a){return a.trustedURL_?a.trustedURL_:goog.html.TrustedResourceUrl.unwrap(a)};
goog.html.TrustedResourceUrl.format=function(a,b){var c=goog.string.Const.unwrap(a);if(!goog.html.TrustedResourceUrl.BASE_URL_.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof goog.string.Const?goog.string.Const.unwrap(a):
encodeURIComponent(String(a))});return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.TrustedResourceUrl.FORMAT_MARKER_=/%{(\w+)}/g;goog.html.TrustedResourceUrl.BASE_URL_=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;goog.html.TrustedResourceUrl.URL_PARAM_PARSER_=/^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
goog.html.TrustedResourceUrl.formatWithParams=function(a,b,c,d){return goog.html.TrustedResourceUrl.format(a,b).cloneWithParams(c,d)};goog.html.TrustedResourceUrl.fromConstant=function(a){return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a))};goog.html.TrustedResourceUrl.fromConstants=function(a){for(var b="",c=0;c<a.length;c++)b+=goog.string.Const.unwrap(a[c]);return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b)};
goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};
goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse=function(a){var b=new goog.html.TrustedResourceUrl;b.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_=goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY?goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(a):a;goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY&&(b.trustedURL_=goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a));return b};
goog.html.TrustedResourceUrl.stringifyParams_=function(a,b,c){if(null==c)return b;if(goog.isString(c))return c?a+encodeURIComponent(c):"";for(var d in c){var e=c[d];e=goog.isArray(e)?e:[e];for(var f=0;f<e.length;f++){var g=e[f];null!=g&&(b||(b=a),b+=(b.length>a.length?"&":"")+encodeURIComponent(d)+"="+encodeURIComponent(String(g)))}}return b};goog.string.internal={};goog.string.internal.startsWith=function(a,b){return 0==a.lastIndexOf(b,0)};goog.string.internal.endsWith=function(a,b){var c=a.length-b.length;return 0<=c&&a.indexOf(b,c)==c};goog.string.internal.caseInsensitiveStartsWith=function(a,b){return 0==goog.string.internal.caseInsensitiveCompare(b,a.substr(0,b.length))};goog.string.internal.caseInsensitiveEndsWith=function(a,b){return 0==goog.string.internal.caseInsensitiveCompare(b,a.substr(a.length-b.length,b.length))};
goog.string.internal.caseInsensitiveEquals=function(a,b){return a.toLowerCase()==b.toLowerCase()};goog.string.internal.isEmptyOrWhitespace=function(a){return/^[\s\xa0]*$/.test(a)};goog.string.internal.trim=goog.TRUSTED_SITE&&String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};goog.string.internal.caseInsensitiveCompare=function(a,b){a=String(a).toLowerCase();b=String(b).toLowerCase();return a<b?-1:a==b?0:1};
goog.string.internal.newLineToBr=function(a,b){return a.replace(/(\r\n|\r|\n)/g,b?"<br />":"<br>")};
goog.string.internal.htmlEscape=function(a,b){if(b)a=a.replace(goog.string.internal.AMP_RE_,"&amp;").replace(goog.string.internal.LT_RE_,"&lt;").replace(goog.string.internal.GT_RE_,"&gt;").replace(goog.string.internal.QUOT_RE_,"&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_,"&#39;").replace(goog.string.internal.NULL_RE_,"&#0;");else{if(!goog.string.internal.ALL_RE_.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(goog.string.internal.AMP_RE_,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(goog.string.internal.LT_RE_,
"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(goog.string.internal.GT_RE_,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(goog.string.internal.QUOT_RE_,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(goog.string.internal.SINGLE_QUOTE_RE_,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(goog.string.internal.NULL_RE_,"&#0;"))}return a};goog.string.internal.AMP_RE_=/&/g;goog.string.internal.LT_RE_=/</g;goog.string.internal.GT_RE_=/>/g;goog.string.internal.QUOT_RE_=/"/g;goog.string.internal.SINGLE_QUOTE_RE_=/'/g;
goog.string.internal.NULL_RE_=/\x00/g;goog.string.internal.ALL_RE_=/[\x00&<>"']/;goog.string.internal.whitespaceEscape=function(a,b){return goog.string.internal.newLineToBr(a.replace(/  /g," &#160;"),b)};goog.string.internal.contains=function(a,b){return-1!=a.indexOf(b)};goog.string.internal.caseInsensitiveContains=function(a,b){return goog.string.internal.contains(a.toLowerCase(),b.toLowerCase())};
goog.string.internal.compareVersions=function(a,b){var c=0;a=goog.string.internal.trim(String(a)).split(".");b=goog.string.internal.trim(String(b)).split(".");for(var d=Math.max(a.length,b.length),e=0;0==c&&e<d;e++){var f=a[e]||"",g=b[e]||"";do{f=/(\d*)(\D*)(.*)/.exec(f)||["","","",""];g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];if(0==f[0].length&&0==g[0].length)break;c=0==f[1].length?0:parseInt(f[1],10);var h=0==g[1].length?0:parseInt(g[1],10);c=goog.string.internal.compareElements_(c,h)||goog.string.internal.compareElements_(0==
f[2].length,0==g[2].length)||goog.string.internal.compareElements_(f[2],g[2]);f=f[3];g=g[3]}while(0==c)}return c};goog.string.internal.compareElements_=function(a,b){return a<b?-1:a>b?1:0};goog.html.SafeUrl=function(){this.privateDoNotAccessOrElseSafeUrlWrappedValue_="";this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_};goog.html.SafeUrl.INNOCUOUS_STRING="about:invalid#zClosurez";goog.html.SafeUrl.prototype.implementsGoogStringTypedString=!0;goog.html.SafeUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString()};
goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR};goog.DEBUG&&(goog.html.SafeUrl.prototype.toString=function(){return"SafeUrl{"+this.privateDoNotAccessOrElseSafeUrlWrappedValue_+"}"});goog.html.SafeUrl.unwrap=function(a){return goog.html.SafeUrl.unwrapTrustedURL(a).toString()};
goog.html.SafeUrl.unwrapTrustedURL=function(a){if(a instanceof goog.html.SafeUrl&&a.constructor===goog.html.SafeUrl&&a.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;goog.asserts.fail("expected object of type SafeUrl, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeUrl"};goog.html.SafeUrl.fromConstant=function(a){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a))};
goog.html.SAFE_MIME_TYPE_PATTERN_=/^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i;goog.html.SafeUrl.isSafeMimeType=function(a){return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a)};goog.html.SafeUrl.fromBlob=function(a){a=goog.html.SAFE_MIME_TYPE_PATTERN_.test(a.type)?goog.fs.url.createObjectUrl(a):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.DATA_URL_PATTERN_=/^data:([^,]*);base64,[a-z0-9+\/]+=*$/i;goog.html.SafeUrl.fromDataUrl=function(a){a=a.replace(/(%0A|%0D)/g,"");var b=a.match(goog.html.DATA_URL_PATTERN_);b=b&&goog.html.SAFE_MIME_TYPE_PATTERN_.test(b[1]);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b?a:goog.html.SafeUrl.INNOCUOUS_STRING)};goog.html.SafeUrl.fromTelUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"tel:")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SIP_URL_PATTERN_=/^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;goog.html.SafeUrl.fromSipUrl=function(a){goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a))||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.fromFacebookMessengerUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"fb-messenger://share")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.fromWhatsAppUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"whatsapp://send")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.fromSmsUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"sms:")&&goog.html.SafeUrl.isSmsUrlBodyValid_(a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.isSmsUrlBodyValid_=function(a){var b=a.indexOf("#");0<b&&(a=a.substring(0,b));b=a.match(/[?&]body=/gi);if(!b)return!0;if(1<b.length)return!1;a=a.match(/[?&]body=([^&]*)/)[1];if(!a)return!0;try{decodeURIComponent(a)}catch(c){return!1}return/^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a)};goog.html.SafeUrl.fromSshUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"ssh://")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.sanitizeChromeExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//,a,b)};goog.html.SafeUrl.sanitizeFirefoxExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//,a,b)};goog.html.SafeUrl.sanitizeEdgeExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//,a,b)};
goog.html.SafeUrl.sanitizeExtensionUrl_=function(a,b,c){(a=a.exec(b))?(a=a[1],-1==(c instanceof goog.string.Const?[goog.string.Const.unwrap(c)]:c.map(function(a){return goog.string.Const.unwrap(a)})).indexOf(a)&&(b=goog.html.SafeUrl.INNOCUOUS_STRING)):b=goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b)};goog.html.SafeUrl.fromTrustedResourceUrl=function(a){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a))};
goog.html.SAFE_URL_PATTERN_=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;goog.html.SafeUrl.SAFE_URL_PATTERN=goog.html.SAFE_URL_PATTERN_;goog.html.SafeUrl.sanitize=function(a){if(a instanceof goog.html.SafeUrl)return a;a="object"==typeof a&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);goog.html.SAFE_URL_PATTERN_.test(a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.sanitizeAssertUnchanged=function(a,b){if(a instanceof goog.html.SafeUrl)return a;a="object"==typeof a&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);if(b&&/^data:/i.test(a)&&(b=goog.html.SafeUrl.fromDataUrl(a),b.getTypedStringValue()==a))return b;goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a),"%s does not match the safe URL pattern",a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse=function(a){var b=new goog.html.SafeUrl;b.privateDoNotAccessOrElseSafeUrlWrappedValue_=goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY?goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a):a;return b};goog.html.SafeUrl.ABOUT_BLANK=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");goog.html.SafeStyle=function(){this.privateDoNotAccessOrElseSafeStyleWrappedValue_="";this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_};goog.html.SafeStyle.prototype.implementsGoogStringTypedString=!0;goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};
goog.html.SafeStyle.fromConstant=function(a){a=goog.string.Const.unwrap(a);if(0===a.length)return goog.html.SafeStyle.EMPTY;goog.asserts.assert(goog.string.internal.endsWith(a,";"),"Last character of style string is not ';': "+a);goog.asserts.assert(goog.string.internal.contains(a,":"),"Style string must contain at least one ':', to specify a \"name: value\" pair: "+a);return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeStyle.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleWrappedValue_};goog.DEBUG&&(goog.html.SafeStyle.prototype.toString=function(){return"SafeStyle{"+this.privateDoNotAccessOrElseSafeStyleWrappedValue_+"}"});
goog.html.SafeStyle.unwrap=function(a){if(a instanceof goog.html.SafeStyle&&a.constructor===goog.html.SafeStyle&&a.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;goog.asserts.fail("expected object of type SafeStyle, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeStyle"};goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse=function(a){return(new goog.html.SafeStyle).initSecurityPrivateDoNotAccessOrElse_(a)};
goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_=function(a){this.privateDoNotAccessOrElseSafeStyleWrappedValue_=a;return this};goog.html.SafeStyle.EMPTY=goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyle.INNOCUOUS_STRING="zClosurez";
goog.html.SafeStyle.create=function(a){var b="",c;for(c in a){if(!/^[-_a-zA-Z0-9]+$/.test(c))throw Error("Name allows only [-_a-zA-Z0-9], got: "+c);var d=a[c];null!=d&&(d=goog.isArray(d)?goog.array.map(d,goog.html.SafeStyle.sanitizePropertyValue_).join(" "):goog.html.SafeStyle.sanitizePropertyValue_(d),b+=c+":"+d+";")}return b?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b):goog.html.SafeStyle.EMPTY};
goog.html.SafeStyle.sanitizePropertyValue_=function(a){if(a instanceof goog.html.SafeUrl)return'url("'+goog.html.SafeUrl.unwrap(a).replace(/</g,"%3c").replace(/[\\"]/g,"\\$&")+'")';a=a instanceof goog.string.Const?goog.string.Const.unwrap(a):goog.html.SafeStyle.sanitizePropertyValueString_(String(a));if(/[{;}]/.test(a))throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.",[a]);return a};
goog.html.SafeStyle.sanitizePropertyValueString_=function(a){var b=a.replace(goog.html.SafeStyle.FUNCTIONS_RE_,"$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_,"$1").replace(goog.html.SafeStyle.URL_RE_,"url");if(goog.html.SafeStyle.VALUE_RE_.test(b)){if(goog.html.SafeStyle.COMMENT_RE_.test(a))return goog.asserts.fail("String value disallows comments, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING;if(!goog.html.SafeStyle.hasBalancedQuotes_(a))return goog.asserts.fail("String value requires balanced quotes, got: "+
a),goog.html.SafeStyle.INNOCUOUS_STRING;if(!goog.html.SafeStyle.hasBalancedSquareBrackets_(a))return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING}else return goog.asserts.fail("String value allows only "+goog.html.SafeStyle.VALUE_ALLOWED_CHARS_+" and simple functions, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING;return goog.html.SafeStyle.sanitizeUrl_(a)};
goog.html.SafeStyle.hasBalancedQuotes_=function(a){for(var b=!0,c=!0,d=0;d<a.length;d++){var e=a.charAt(d);"'"==e&&c?b=!b:'"'==e&&b&&(c=!c)}return b&&c};goog.html.SafeStyle.hasBalancedSquareBrackets_=function(a){for(var b=!0,c=/^[-_a-zA-Z0-9]$/,d=0;d<a.length;d++){var e=a.charAt(d);if("]"==e){if(b)return!1;b=!0}else if("["==e){if(!b)return!1;b=!1}else if(!b&&!c.test(e))return!1}return b};goog.html.SafeStyle.VALUE_ALLOWED_CHARS_="[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
goog.html.SafeStyle.VALUE_RE_=new RegExp("^"+goog.html.SafeStyle.VALUE_ALLOWED_CHARS_+"+$");goog.html.SafeStyle.URL_RE_=/\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;goog.html.SafeStyle.FUNCTIONS_RE_=/\b(hsl|hsla|rgb|rgba|matrix|calc|minmax|fit-content|repeat|(rotate|scale|translate)(X|Y|Z|3d)?)\([-+*/0-9a-z.%\[\], ]+\)/g;goog.html.SafeStyle.COMMENT_RE_=/\/\*/;
goog.html.SafeStyle.sanitizeUrl_=function(a){return a.replace(goog.html.SafeStyle.URL_RE_,function(a,c,d,e){var b="";d=d.replace(/^(['"])(.*)\1$/,function(a,c,d){b=c;return d});a=goog.html.SafeUrl.sanitize(d).getTypedStringValue();return c+b+a+b+e})};goog.html.SafeStyle.concat=function(a){var b="",c=function(a){goog.isArray(a)?goog.array.forEach(a,c):b+=goog.html.SafeStyle.unwrap(a)};goog.array.forEach(arguments,c);return b?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b):goog.html.SafeStyle.EMPTY};goog.html.SafeStyleSheet=function(){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_="";this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_};goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString=!0;goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};
goog.html.SafeStyleSheet.createRule=function(a,b){if(goog.string.internal.contains(a,"<"))throw Error("Selector does not allow '<', got: "+a);var c=a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g,"");if(!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c))throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: "+a);if(!goog.html.SafeStyleSheet.hasBalancedBrackets_(c))throw Error("() and [] in selector must be balanced, got: "+a);b instanceof goog.html.SafeStyle||(b=goog.html.SafeStyle.create(b));
a=a+"{"+goog.html.SafeStyle.unwrap(b).replace(/</g,"\\3C ")+"}";return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeStyleSheet.hasBalancedBrackets_=function(a){for(var b={"(":")","[":"]"},c=[],d=0;d<a.length;d++){var e=a[d];if(b[e])c.push(b[e]);else if(goog.object.contains(b,e)&&c.pop()!=e)return!1}return 0==c.length};
goog.html.SafeStyleSheet.concat=function(a){var b="",c=function(a){goog.isArray(a)?goog.array.forEach(a,c):b+=goog.html.SafeStyleSheet.unwrap(a)};goog.array.forEach(arguments,c);return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b)};
goog.html.SafeStyleSheet.fromConstant=function(a){a=goog.string.Const.unwrap(a);if(0===a.length)return goog.html.SafeStyleSheet.EMPTY;goog.asserts.assert(!goog.string.internal.contains(a,"<"),"Forbidden '<' character in style sheet string: "+a);return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeStyleSheet.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_};
goog.DEBUG&&(goog.html.SafeStyleSheet.prototype.toString=function(){return"SafeStyleSheet{"+this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_+"}"});
goog.html.SafeStyleSheet.unwrap=function(a){if(a instanceof goog.html.SafeStyleSheet&&a.constructor===goog.html.SafeStyleSheet&&a.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;goog.asserts.fail("expected object of type SafeStyleSheet, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeStyleSheet"};
goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse=function(a){return(new goog.html.SafeStyleSheet).initSecurityPrivateDoNotAccessOrElse_(a)};goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_=function(a){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_=a;return this};goog.html.SafeStyleSheet.EMPTY=goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var a=goog.labs.userAgent.util.getNavigator_();return a&&(a=a.userAgent)?a:""};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(a){goog.labs.userAgent.util.userAgent_=a||goog.labs.userAgent.util.getNativeUserAgentString_()};
goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_};goog.labs.userAgent.util.matchUserAgent=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.internal.contains(b,a)};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.internal.caseInsensitiveContains(b,a)};
goog.labs.userAgent.util.extractVersionTuples=function(a){for(var b=/(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g,c=[],d;d=b.exec(a);)c.push([d[1],d[2],d[3]||void 0]);return c};goog.labs.userAgent.browser={};goog.labs.userAgent.browser.matchOpera_=function(){return goog.labs.userAgent.util.matchUserAgent("Opera")};goog.labs.userAgent.browser.matchIE_=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE")};goog.labs.userAgent.browser.matchEdgeHtml_=function(){return goog.labs.userAgent.util.matchUserAgent("Edge")};goog.labs.userAgent.browser.matchEdgeChromium_=function(){return goog.labs.userAgent.util.matchUserAgent("Edg/")};
goog.labs.userAgent.browser.matchOperaChromium_=function(){return goog.labs.userAgent.util.matchUserAgent("OPR")};goog.labs.userAgent.browser.matchFirefox_=function(){return goog.labs.userAgent.util.matchUserAgent("Firefox")||goog.labs.userAgent.util.matchUserAgent("FxiOS")};
goog.labs.userAgent.browser.matchSafari_=function(){return goog.labs.userAgent.util.matchUserAgent("Safari")&&!(goog.labs.userAgent.browser.matchChrome_()||goog.labs.userAgent.browser.matchCoast_()||goog.labs.userAgent.browser.matchOpera_()||goog.labs.userAgent.browser.matchEdgeHtml_()||goog.labs.userAgent.browser.matchEdgeChromium_()||goog.labs.userAgent.browser.matchOperaChromium_()||goog.labs.userAgent.browser.matchFirefox_()||goog.labs.userAgent.browser.isSilk()||goog.labs.userAgent.util.matchUserAgent("Android"))};
goog.labs.userAgent.browser.matchCoast_=function(){return goog.labs.userAgent.util.matchUserAgent("Coast")};goog.labs.userAgent.browser.matchIosWebview_=function(){return(goog.labs.userAgent.util.matchUserAgent("iPad")||goog.labs.userAgent.util.matchUserAgent("iPhone"))&&!goog.labs.userAgent.browser.matchSafari_()&&!goog.labs.userAgent.browser.matchChrome_()&&!goog.labs.userAgent.browser.matchCoast_()&&!goog.labs.userAgent.browser.matchFirefox_()&&goog.labs.userAgent.util.matchUserAgent("AppleWebKit")};
goog.labs.userAgent.browser.matchChrome_=function(){return(goog.labs.userAgent.util.matchUserAgent("Chrome")||goog.labs.userAgent.util.matchUserAgent("CriOS"))&&!goog.labs.userAgent.browser.matchEdgeHtml_()};goog.labs.userAgent.browser.matchAndroidBrowser_=function(){return goog.labs.userAgent.util.matchUserAgent("Android")&&!(goog.labs.userAgent.browser.isChrome()||goog.labs.userAgent.browser.isFirefox()||goog.labs.userAgent.browser.isOpera()||goog.labs.userAgent.browser.isSilk())};
goog.labs.userAgent.browser.isOpera=goog.labs.userAgent.browser.matchOpera_;goog.labs.userAgent.browser.isIE=goog.labs.userAgent.browser.matchIE_;goog.labs.userAgent.browser.isEdge=goog.labs.userAgent.browser.matchEdgeHtml_;goog.labs.userAgent.browser.isEdgeChromium=goog.labs.userAgent.browser.matchEdgeChromium_;goog.labs.userAgent.browser.isOperaChromium=goog.labs.userAgent.browser.matchOperaChromium_;goog.labs.userAgent.browser.isFirefox=goog.labs.userAgent.browser.matchFirefox_;
goog.labs.userAgent.browser.isSafari=goog.labs.userAgent.browser.matchSafari_;goog.labs.userAgent.browser.isCoast=goog.labs.userAgent.browser.matchCoast_;goog.labs.userAgent.browser.isIosWebview=goog.labs.userAgent.browser.matchIosWebview_;goog.labs.userAgent.browser.isChrome=goog.labs.userAgent.browser.matchChrome_;goog.labs.userAgent.browser.isAndroidBrowser=goog.labs.userAgent.browser.matchAndroidBrowser_;goog.labs.userAgent.browser.isSilk=function(){return goog.labs.userAgent.util.matchUserAgent("Silk")};
goog.labs.userAgent.browser.getVersion=function(){function a(a){a=goog.array.find(a,d);return c[a]||""}var b=goog.labs.userAgent.util.getUserAgent();if(goog.labs.userAgent.browser.isIE())return goog.labs.userAgent.browser.getIEVersion_(b);b=goog.labs.userAgent.util.extractVersionTuples(b);var c={};goog.array.forEach(b,function(a){c[a[0]]=a[1]});var d=goog.partial(goog.object.containsKey,c);return goog.labs.userAgent.browser.isOpera()?a(["Version","Opera"]):goog.labs.userAgent.browser.isEdge()?a(["Edge"]):
goog.labs.userAgent.browser.isEdgeChromium()?a(["Edg"]):goog.labs.userAgent.browser.isChrome()?a(["Chrome","CriOS"]):(b=b[2])&&b[1]||""};goog.labs.userAgent.browser.isVersionOrHigher=function(a){return 0<=goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(),a)};
goog.labs.userAgent.browser.getIEVersion_=function(a){var b=/rv: *([\d\.]*)/.exec(a);if(b&&b[1])return b[1];b="";var c=/MSIE +([\d\.]+)/.exec(a);if(c&&c[1])if(a=/Trident\/(\d.\d)/.exec(a),"7.0"==c[1])if(a&&a[1])switch(a[1]){case "4.0":b="8.0";break;case "5.0":b="9.0";break;case "6.0":b="10.0";break;case "7.0":b="11.0"}else b="7.0";else b=c[1];return b};goog.html.SafeHtml=function(){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_="";this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_=goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;this.dir_=null};goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeHtml.prototype.getDirection=function(){return this.dir_};goog.html.SafeHtml.prototype.implementsGoogStringTypedString=!0;goog.html.SafeHtml.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString()};
goog.DEBUG&&(goog.html.SafeHtml.prototype.toString=function(){return"SafeHtml{"+this.privateDoNotAccessOrElseSafeHtmlWrappedValue_+"}"});goog.html.SafeHtml.unwrap=function(a){return goog.html.SafeHtml.unwrapTrustedHTML(a).toString()};
goog.html.SafeHtml.unwrapTrustedHTML=function(a){if(a instanceof goog.html.SafeHtml&&a.constructor===goog.html.SafeHtml&&a.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_===goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;goog.asserts.fail("expected object of type SafeHtml, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeHtml"};
goog.html.SafeHtml.htmlEscape=function(a){if(a instanceof goog.html.SafeHtml)return a;var b="object"==typeof a,c=null;b&&a.implementsGoogI18nBidiDirectionalString&&(c=a.getDirection());a=b&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a),c)};
goog.html.SafeHtml.htmlEscapePreservingNewlines=function(a){if(a instanceof goog.html.SafeHtml)return a;a=goog.html.SafeHtml.htmlEscape(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)),a.getDirection())};
goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces=function(a){if(a instanceof goog.html.SafeHtml)return a;a=goog.html.SafeHtml.htmlEscape(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)),a.getDirection())};goog.html.SafeHtml.from=goog.html.SafeHtml.htmlEscape;goog.html.SafeHtml.VALID_NAMES_IN_TAG_=/^[a-zA-Z0-9-]+$/;
goog.html.SafeHtml.URL_ATTRIBUTES_={action:!0,cite:!0,data:!0,formaction:!0,href:!0,manifest:!0,poster:!0,src:!0};goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_={APPLET:!0,BASE:!0,EMBED:!0,IFRAME:!0,LINK:!0,MATH:!0,META:!0,OBJECT:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};goog.html.SafeHtml.create=function(a,b,c){goog.html.SafeHtml.verifyTagName(String(a));return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a),b,c)};
goog.html.SafeHtml.verifyTagName=function(a){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a))throw Error("Invalid tag name <"+a+">.");if(a.toUpperCase()in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_)throw Error("Tag name <"+a+"> is not allowed for SafeHtml.");};
goog.html.SafeHtml.createIframe=function(a,b,c,d){a&&goog.html.TrustedResourceUrl.unwrap(a);var e={};e.src=a||null;e.srcdoc=b&&goog.html.SafeHtml.unwrap(b);a=goog.html.SafeHtml.combineAttributes(e,{sandbox:""},c);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",a,d)};
goog.html.SafeHtml.createSandboxIframe=function(a,b,c,d){if(!goog.html.SafeHtml.canUseSandboxIframe())throw Error("The browser does not support sandboxed iframes.");var e={};e.src=a?goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)):null;e.srcdoc=b||null;e.sandbox="";a=goog.html.SafeHtml.combineAttributes(e,{},c);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",a,d)};
goog.html.SafeHtml.canUseSandboxIframe=function(){return goog.global.HTMLIFrameElement&&"sandbox"in goog.global.HTMLIFrameElement.prototype};goog.html.SafeHtml.createScriptSrc=function(a,b){goog.html.TrustedResourceUrl.unwrap(a);a=goog.html.SafeHtml.combineAttributes({src:a},{},b);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",a)};
goog.html.SafeHtml.createScript=function(a,b){for(var c in b){var d=c.toLowerCase();if("language"==d||"src"==d||"text"==d||"type"==d)throw Error('Cannot set "'+d+'" attribute');}c="";a=goog.array.concat(a);for(d=0;d<a.length;d++)c+=goog.html.SafeScript.unwrap(a[d]);a=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",b,a)};
goog.html.SafeHtml.createStyle=function(a,b){b=goog.html.SafeHtml.combineAttributes({type:"text/css"},{},b);var c="";a=goog.array.concat(a);for(var d=0;d<a.length;d++)c+=goog.html.SafeStyleSheet.unwrap(a[d]);a=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style",b,a)};
goog.html.SafeHtml.createMetaRefresh=function(a,b){a=goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));(goog.labs.userAgent.browser.isIE()||goog.labs.userAgent.browser.isEdge())&&goog.string.internal.contains(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'");return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta",{"http-equiv":"refresh",content:(b||0)+"; url="+a})};
goog.html.SafeHtml.getAttrNameAndValue_=function(a,b,c){if(c instanceof goog.string.Const)c=goog.string.Const.unwrap(c);else if("style"==b.toLowerCase())c=goog.html.SafeHtml.getStyleValue_(c);else{if(/^on/i.test(b))throw Error('Attribute "'+b+'" requires goog.string.Const value, "'+c+'" given.');if(b.toLowerCase()in goog.html.SafeHtml.URL_ATTRIBUTES_)if(c instanceof goog.html.TrustedResourceUrl)c=goog.html.TrustedResourceUrl.unwrap(c);else if(c instanceof goog.html.SafeUrl)c=goog.html.SafeUrl.unwrap(c);
else if(goog.isString(c))c=goog.html.SafeUrl.sanitize(c).getTypedStringValue();else throw Error('Attribute "'+b+'" on tag "'+a+'" requires goog.html.SafeUrl, goog.string.Const, or string, value "'+c+'" given.');}c.implementsGoogStringTypedString&&(c=c.getTypedStringValue());goog.asserts.assert(goog.isString(c)||goog.isNumber(c),"String or number value expected, got "+typeof c+" with value: "+c);return b+'="'+goog.string.internal.htmlEscape(String(c))+'"'};
goog.html.SafeHtml.getStyleValue_=function(a){if(!goog.isObject(a))throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, '+typeof a+" given: "+a);a instanceof goog.html.SafeStyle||(a=goog.html.SafeStyle.create(a));return goog.html.SafeStyle.unwrap(a)};goog.html.SafeHtml.createWithDir=function(a,b,c,d){b=goog.html.SafeHtml.create(b,c,d);b.dir_=a;return b};
goog.html.SafeHtml.join=function(a,b){a=goog.html.SafeHtml.htmlEscape(a);var c=a.getDirection(),d=[],e=function(a){goog.isArray(a)?goog.array.forEach(a,e):(a=goog.html.SafeHtml.htmlEscape(a),d.push(goog.html.SafeHtml.unwrap(a)),a=a.getDirection(),c==goog.i18n.bidi.Dir.NEUTRAL?c=a:a!=goog.i18n.bidi.Dir.NEUTRAL&&c!=a&&(c=null))};goog.array.forEach(b,e);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)),c)};
goog.html.SafeHtml.concat=function(a){return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY,Array.prototype.slice.call(arguments))};goog.html.SafeHtml.concatWithDir=function(a,b){var c=goog.html.SafeHtml.concat(goog.array.slice(arguments,1));c.dir_=a;return c};goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_={};goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse=function(a,b){return(new goog.html.SafeHtml).initSecurityPrivateDoNotAccessOrElse_(a,b)};
goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_=function(a,b){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_=goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY?goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(a):a;this.dir_=b;return this};
goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse=function(a,b,c){var d=null;var e="<"+a+goog.html.SafeHtml.stringifyAttributes(a,b);goog.isDefAndNotNull(c)?goog.isArray(c)||(c=[c]):c=[];goog.dom.tags.isVoidTag(a.toLowerCase())?(goog.asserts.assert(!c.length,"Void tag <"+a+"> does not allow content."),e+=">"):(d=goog.html.SafeHtml.concat(c),e+=">"+goog.html.SafeHtml.unwrap(d)+"</"+a+">",d=d.getDirection());(a=b&&b.dir)&&(d=/^(ltr|rtl|auto)$/i.test(a)?goog.i18n.bidi.Dir.NEUTRAL:
null);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e,d)};goog.html.SafeHtml.stringifyAttributes=function(a,b){var c="";if(b)for(var d in b){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d))throw Error('Invalid attribute name "'+d+'".');var e=b[d];goog.isDefAndNotNull(e)&&(c+=" "+goog.html.SafeHtml.getAttrNameAndValue_(a,d,e))}return c};
goog.html.SafeHtml.combineAttributes=function(a,b,c){var d={},e;for(e in a)goog.asserts.assert(e.toLowerCase()==e,"Must be lower case"),d[e]=a[e];for(e in b)goog.asserts.assert(e.toLowerCase()==e,"Must be lower case"),d[e]=b[e];for(e in c){var f=e.toLowerCase();if(f in a)throw Error('Cannot override "'+f+'" attribute, got "'+e+'" with value "'+c[e]+'"');f in b&&delete d[f];d[e]=c[e]}return d};
goog.html.SafeHtml.DOCTYPE_HTML=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>",goog.i18n.bidi.Dir.NEUTRAL);goog.html.SafeHtml.EMPTY=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("",goog.i18n.bidi.Dir.NEUTRAL);goog.html.SafeHtml.BR=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>",goog.i18n.bidi.Dir.NEUTRAL);goog.html.uncheckedconversions={};goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract=function(a,b,c){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b,c||null)};
goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b)};goog.dom.safe={};goog.dom.safe.InsertAdjacentHtmlPosition={AFTERBEGIN:"afterbegin",AFTEREND:"afterend",BEFOREBEGIN:"beforebegin",BEFOREEND:"beforeend"};goog.dom.safe.insertAdjacentHtml=function(a,b,c){a.insertAdjacentHTML(b,goog.html.SafeHtml.unwrapTrustedHTML(c))};goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_={MATH:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};
goog.dom.safe.isInnerHtmlCleanupRecursive_=goog.functions.cacheReturnValue(function(){if(goog.DEBUG&&"undefined"===typeof document)return!1;var a=document.createElement("div"),b=document.createElement("div");b.appendChild(document.createElement("div"));a.appendChild(b);if(goog.DEBUG&&!a.firstChild)return!1;b=a.firstChild.firstChild;a.innerHTML=goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);return!b.parentElement});
goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse=function(a,b){if(goog.dom.safe.isInnerHtmlCleanupRecursive_())for(;a.lastChild;)a.removeChild(a.lastChild);a.innerHTML=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setInnerHtml=function(a,b){if(goog.asserts.ENABLE_ASSERTS){var c=a.tagName.toUpperCase();if(goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c])throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of "+a.tagName+".");}goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a,b)};goog.dom.safe.setOuterHtml=function(a,b){a.outerHTML=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setFormElementAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLFormElement(a).action=goog.html.SafeUrl.unwrapTrustedURL(b)};goog.dom.safe.setButtonFormAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLButtonElement(a).formAction=goog.html.SafeUrl.unwrapTrustedURL(b)};
goog.dom.safe.setInputFormAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLInputElement(a).formAction=goog.html.SafeUrl.unwrapTrustedURL(b)};goog.dom.safe.setStyle=function(a,b){a.style.cssText=goog.html.SafeStyle.unwrap(b)};goog.dom.safe.documentWrite=function(a,b){a.write(goog.html.SafeHtml.unwrapTrustedHTML(b))};
goog.dom.safe.setAnchorHref=function(a,b){goog.dom.asserts.assertIsHTMLAnchorElement(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.href=goog.html.SafeUrl.unwrapTrustedURL(b)};goog.dom.safe.setImageSrc=function(a,b){goog.dom.asserts.assertIsHTMLImageElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:image\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrapTrustedURL(b)};
goog.dom.safe.setAudioSrc=function(a,b){goog.dom.asserts.assertIsHTMLAudioElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:audio\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrapTrustedURL(b)};goog.dom.safe.setVideoSrc=function(a,b){goog.dom.asserts.assertIsHTMLVideoElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:video\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrapTrustedURL(b)};
goog.dom.safe.setEmbedSrc=function(a,b){goog.dom.asserts.assertIsHTMLEmbedElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b)};goog.dom.safe.setFrameSrc=function(a,b){goog.dom.asserts.assertIsHTMLFrameElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedURL(b)};goog.dom.safe.setIframeSrc=function(a,b){goog.dom.asserts.assertIsHTMLIFrameElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedURL(b)};
goog.dom.safe.setIframeSrcdoc=function(a,b){goog.dom.asserts.assertIsHTMLIFrameElement(a);a.srcdoc=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setLinkHrefAndRel=function(a,b,c){goog.dom.asserts.assertIsHTMLLinkElement(a);a.rel=c;goog.string.internal.caseInsensitiveContains(c,"stylesheet")?(goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl,'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'),a.href=goog.html.TrustedResourceUrl.unwrapTrustedURL(b)):a.href=b instanceof goog.html.TrustedResourceUrl?goog.html.TrustedResourceUrl.unwrapTrustedURL(b):b instanceof goog.html.SafeUrl?goog.html.SafeUrl.unwrapTrustedURL(b):
goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(b))};goog.dom.safe.setObjectData=function(a,b){goog.dom.asserts.assertIsHTMLObjectElement(a);a.data=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b)};goog.dom.safe.setScriptSrc=function(a,b){goog.dom.asserts.assertIsHTMLScriptElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);(b=goog.getScriptNonce())&&a.setAttribute("nonce",b)};
goog.dom.safe.setScriptContent=function(a,b){goog.dom.asserts.assertIsHTMLScriptElement(a);a.text=goog.html.SafeScript.unwrapTrustedScript(b);(b=goog.getScriptNonce())&&a.setAttribute("nonce",b)};goog.dom.safe.setLocationHref=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.href=goog.html.SafeUrl.unwrapTrustedURL(b)};
goog.dom.safe.assignLocation=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.assign(goog.html.SafeUrl.unwrapTrustedURL(b))};goog.dom.safe.replaceLocation=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.replace(goog.html.SafeUrl.unwrapTrustedURL(b))};
goog.dom.safe.openInWindow=function(a,b,c,d,e){a=a instanceof goog.html.SafeUrl?a:goog.html.SafeUrl.sanitizeAssertUnchanged(a);return(b||goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(a),c?goog.string.Const.unwrap(c):"",d,e)};goog.dom.safe.parseFromStringHtml=function(a,b){return goog.dom.safe.parseFromString(a,b,"text/html")};goog.dom.safe.parseFromString=function(a,b,c){return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b),c)};
goog.dom.safe.createImageFromBlob=function(a){if(!/^image\/.*/g.test(a.type))throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");var b=goog.global.URL.createObjectURL(a);a=new goog.global.Image;a.onload=function(){goog.global.URL.revokeObjectURL(b)};goog.dom.safe.setImageSrc(a,goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."),b));return a};goog.string.DETECT_DOUBLE_ESCAPING=!1;goog.string.FORCE_NON_DOM_HTML_UNESCAPING=!1;goog.string.Unicode={NBSP:"\u00a0"};goog.string.startsWith=goog.string.internal.startsWith;goog.string.endsWith=goog.string.internal.endsWith;goog.string.caseInsensitiveStartsWith=goog.string.internal.caseInsensitiveStartsWith;goog.string.caseInsensitiveEndsWith=goog.string.internal.caseInsensitiveEndsWith;goog.string.caseInsensitiveEquals=goog.string.internal.caseInsensitiveEquals;
goog.string.subs=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};goog.string.collapseWhitespace=function(a){return a.replace(/[\s\xa0]+/g," ").replace(/^\s+|\s+$/g,"")};goog.string.isEmptyOrWhitespace=goog.string.internal.isEmptyOrWhitespace;goog.string.isEmptyString=function(a){return 0==a.length};goog.string.isEmpty=goog.string.isEmptyOrWhitespace;goog.string.isEmptyOrWhitespaceSafe=function(a){return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a))};
goog.string.isEmptySafe=goog.string.isEmptyOrWhitespaceSafe;goog.string.isBreakingWhitespace=function(a){return!/[^\t\n\r ]/.test(a)};goog.string.isAlpha=function(a){return!/[^a-zA-Z]/.test(a)};goog.string.isNumeric=function(a){return!/[^0-9]/.test(a)};goog.string.isAlphaNumeric=function(a){return!/[^a-zA-Z0-9]/.test(a)};goog.string.isSpace=function(a){return" "==a};goog.string.isUnicodeChar=function(a){return 1==a.length&&" "<=a&&"~">=a||"\u0080"<=a&&"\ufffd">=a};
goog.string.stripNewlines=function(a){return a.replace(/(\r\n|\r|\n)+/g," ")};goog.string.canonicalizeNewlines=function(a){return a.replace(/(\r\n|\r|\n)/g,"\n")};goog.string.normalizeWhitespace=function(a){return a.replace(/\xa0|\s/g," ")};goog.string.normalizeSpaces=function(a){return a.replace(/\xa0|[ \t]+/g," ")};goog.string.collapseBreakingSpaces=function(a){return a.replace(/[\t\r\n ]+/g," ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g,"")};goog.string.trim=goog.string.internal.trim;
goog.string.trimLeft=function(a){return a.replace(/^[\s\xa0]+/,"")};goog.string.trimRight=function(a){return a.replace(/[\s\xa0]+$/,"")};goog.string.caseInsensitiveCompare=goog.string.internal.caseInsensitiveCompare;
goog.string.numberAwareCompare_=function(a,b,c){if(a==b)return 0;if(!a)return-1;if(!b)return 1;for(var d=a.toLowerCase().match(c),e=b.toLowerCase().match(c),f=Math.min(d.length,e.length),g=0;g<f;g++){c=d[g];var h=e[g];if(c!=h)return a=parseInt(c,10),!isNaN(a)&&(b=parseInt(h,10),!isNaN(b)&&a-b)?a-b:c<h?-1:1}return d.length!=e.length?d.length-e.length:a<b?-1:1};goog.string.intAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\D+/g)};
goog.string.floatAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\.\d+|\D+/g)};goog.string.numerateCompare=goog.string.floatAwareCompare;goog.string.urlEncode=function(a){return encodeURIComponent(String(a))};goog.string.urlDecode=function(a){return decodeURIComponent(a.replace(/\+/g," "))};goog.string.newLineToBr=goog.string.internal.newLineToBr;
goog.string.htmlEscape=function(a,b){a=goog.string.internal.htmlEscape(a,b);goog.string.DETECT_DOUBLE_ESCAPING&&(a=a.replace(goog.string.E_RE_,"&#101;"));return a};goog.string.E_RE_=/e/g;goog.string.unescapeEntities=function(a){return goog.string.contains(a,"&")?!goog.string.FORCE_NON_DOM_HTML_UNESCAPING&&"document"in goog.global?goog.string.unescapeEntitiesUsingDom_(a):goog.string.unescapePureXmlEntities_(a):a};
goog.string.unescapeEntitiesWithDocument=function(a,b){return goog.string.contains(a,"&")?goog.string.unescapeEntitiesUsingDom_(a,b):a};
goog.string.unescapeEntitiesUsingDom_=function(a,b){var c={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"'};var d=b?b.createElement("div"):goog.global.document.createElement("div");return a.replace(goog.string.HTML_ENTITY_PATTERN_,function(a,b){var e=c[a];if(e)return e;"#"==b.charAt(0)&&(b=Number("0"+b.substr(1)),isNaN(b)||(e=String.fromCharCode(b)));e||(goog.dom.safe.setInnerHtml(d,goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."),
a+" ")),e=d.firstChild.nodeValue.slice(0,-1));return c[a]=e})};goog.string.unescapePureXmlEntities_=function(a){return a.replace(/&([^;]+);/g,function(a,c){switch(c){case "amp":return"&";case "lt":return"<";case "gt":return">";case "quot":return'"';default:return"#"!=c.charAt(0)||(c=Number("0"+c.substr(1)),isNaN(c))?a:String.fromCharCode(c)}})};goog.string.HTML_ENTITY_PATTERN_=/&([^;\s<&]+);?/g;goog.string.whitespaceEscape=function(a,b){return goog.string.newLineToBr(a.replace(/  /g," &#160;"),b)};
goog.string.preserveSpaces=function(a){return a.replace(/(^|[\n ]) /g,"$1"+goog.string.Unicode.NBSP)};goog.string.stripQuotes=function(a,b){for(var c=b.length,d=0;d<c;d++){var e=1==c?b:b.charAt(d);if(a.charAt(0)==e&&a.charAt(a.length-1)==e)return a.substring(1,a.length-1)}return a};goog.string.truncate=function(a,b,c){c&&(a=goog.string.unescapeEntities(a));a.length>b&&(a=a.substring(0,b-3)+"...");c&&(a=goog.string.htmlEscape(a));return a};
goog.string.truncateMiddle=function(a,b,c,d){c&&(a=goog.string.unescapeEntities(a));if(d&&a.length>b){d>b&&(d=b);var e=a.length-d;a=a.substring(0,b-d)+"..."+a.substring(e)}else a.length>b&&(d=Math.floor(b/2),e=a.length-d,a=a.substring(0,d+b%2)+"..."+a.substring(e));c&&(a=goog.string.htmlEscape(a));return a};goog.string.specialEscapeChars_={"\x00":"\\0","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\x0B",'"':'\\"',"\\":"\\\\","<":"\\u003C"};goog.string.jsEscapeCache_={"'":"\\'"};
goog.string.quote=function(a){a=String(a);for(var b=['"'],c=0;c<a.length;c++){var d=a.charAt(c),e=d.charCodeAt(0);b[c+1]=goog.string.specialEscapeChars_[d]||(31<e&&127>e?d:goog.string.escapeChar(d))}b.push('"');return b.join("")};goog.string.escapeString=function(a){for(var b=[],c=0;c<a.length;c++)b[c]=goog.string.escapeChar(a.charAt(c));return b.join("")};
goog.string.escapeChar=function(a){if(a in goog.string.jsEscapeCache_)return goog.string.jsEscapeCache_[a];if(a in goog.string.specialEscapeChars_)return goog.string.jsEscapeCache_[a]=goog.string.specialEscapeChars_[a];var b=a.charCodeAt(0);if(31<b&&127>b)var c=a;else{if(256>b){if(c="\\x",16>b||256<b)c+="0"}else c="\\u",4096>b&&(c+="0");c+=b.toString(16).toUpperCase()}return goog.string.jsEscapeCache_[a]=c};goog.string.contains=goog.string.internal.contains;goog.string.caseInsensitiveContains=goog.string.internal.caseInsensitiveContains;
goog.string.countOf=function(a,b){return a&&b?a.split(b).length-1:0};goog.string.removeAt=function(a,b,c){var d=a;0<=b&&b<a.length&&0<c&&(d=a.substr(0,b)+a.substr(b+c,a.length-b-c));return d};goog.string.remove=function(a,b){return a.replace(b,"")};goog.string.removeAll=function(a,b){b=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(b,"")};goog.string.replaceAll=function(a,b,c){b=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(b,c.replace(/\$/g,"$$$$"))};
goog.string.regExpEscape=function(a){return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1").replace(/\x08/g,"\\x08")};goog.string.repeat=String.prototype.repeat?function(a,b){return a.repeat(b)}:function(a,b){return Array(b+1).join(a)};goog.string.padNumber=function(a,b,c){a=goog.isDef(c)?a.toFixed(c):String(a);c=a.indexOf(".");-1==c&&(c=a.length);return goog.string.repeat("0",Math.max(0,b-c))+a};goog.string.makeSafe=function(a){return null==a?"":String(a)};
goog.string.buildString=function(a){return Array.prototype.join.call(arguments,"")};goog.string.getRandomString=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^goog.now()).toString(36)};goog.string.compareVersions=goog.string.internal.compareVersions;goog.string.hashCode=function(a){for(var b=0,c=0;c<a.length;++c)b=31*b+a.charCodeAt(c)>>>0;return b};goog.string.uniqueStringCounter_=2147483648*Math.random()|0;
goog.string.createUniqueString=function(){return"goog_"+goog.string.uniqueStringCounter_++};goog.string.toNumber=function(a){var b=Number(a);return 0==b&&goog.string.isEmptyOrWhitespace(a)?NaN:b};goog.string.isLowerCamelCase=function(a){return/^[a-z]+([A-Z][a-z]*)*$/.test(a)};goog.string.isUpperCamelCase=function(a){return/^([A-Z][a-z]*)+$/.test(a)};goog.string.toCamelCase=function(a){return String(a).replace(/\-([a-z])/g,function(a,c){return c.toUpperCase()})};
goog.string.toSelectorCase=function(a){return String(a).replace(/([A-Z])/g,"-$1").toLowerCase()};goog.string.toTitleCase=function(a,b){b=goog.isString(b)?goog.string.regExpEscape(b):"\\s";return a.replace(new RegExp("(^"+(b?"|["+b+"]+":"")+")([a-z])","g"),function(a,b,e){return b+e.toUpperCase()})};goog.string.capitalize=function(a){return String(a.charAt(0)).toUpperCase()+String(a.substr(1)).toLowerCase()};
goog.string.parseInt=function(a){isFinite(a)&&(a=String(a));return goog.isString(a)?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN};goog.string.splitLimit=function(a,b,c){a=a.split(b);for(var d=[];0<c&&a.length;)d.push(a.shift()),c--;a.length&&d.push(a.join(b));return d};goog.string.lastComponent=function(a,b){if(b)"string"==typeof b&&(b=[b]);else return a;for(var c=-1,d=0;d<b.length;d++)if(""!=b[d]){var e=a.lastIndexOf(b[d]);e>c&&(c=e)}return-1==c?a:a.slice(c+1)};
goog.string.editDistance=function(a,b){var c=[],d=[];if(a==b)return 0;if(!a.length||!b.length)return Math.max(a.length,b.length);for(var e=0;e<b.length+1;e++)c[e]=e;for(e=0;e<a.length;e++){d[0]=e+1;for(var f=0;f<b.length;f++)d[f+1]=Math.min(d[f]+1,c[f+1]+1,c[f]+Number(a[e]!=b[f]));for(f=0;f<c.length;f++)c[f]=d[f]}return d[b.length]};goog.labs.userAgent.engine={};goog.labs.userAgent.engine.isPresto=function(){return goog.labs.userAgent.util.matchUserAgent("Presto")};goog.labs.userAgent.engine.isTrident=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE")};goog.labs.userAgent.engine.isEdge=function(){return goog.labs.userAgent.util.matchUserAgent("Edge")};
goog.labs.userAgent.engine.isWebKit=function(){return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit")&&!goog.labs.userAgent.engine.isEdge()};goog.labs.userAgent.engine.isGecko=function(){return goog.labs.userAgent.util.matchUserAgent("Gecko")&&!goog.labs.userAgent.engine.isWebKit()&&!goog.labs.userAgent.engine.isTrident()&&!goog.labs.userAgent.engine.isEdge()};
goog.labs.userAgent.engine.getVersion=function(){var a=goog.labs.userAgent.util.getUserAgent();if(a){a=goog.labs.userAgent.util.extractVersionTuples(a);var b=goog.labs.userAgent.engine.getEngineTuple_(a);if(b)return"Gecko"==b[0]?goog.labs.userAgent.engine.getVersionForKey_(a,"Firefox"):b[1];a=a[0];var c;if(a&&(c=a[2])&&(c=/Trident\/([^\s;]+)/.exec(c)))return c[1]}return""};
goog.labs.userAgent.engine.getEngineTuple_=function(a){if(!goog.labs.userAgent.engine.isEdge())return a[1];for(var b=0;b<a.length;b++){var c=a[b];if("Edge"==c[0])return c}};goog.labs.userAgent.engine.isVersionOrHigher=function(a){return 0<=goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(),a)};goog.labs.userAgent.engine.getVersionForKey_=function(a,b){return(a=goog.array.find(a,function(a){return b==a[0]}))&&a[1]||""};goog.labs.userAgent.platform={};goog.labs.userAgent.platform.isAndroid=function(){return goog.labs.userAgent.util.matchUserAgent("Android")};goog.labs.userAgent.platform.isIpod=function(){return goog.labs.userAgent.util.matchUserAgent("iPod")};goog.labs.userAgent.platform.isIphone=function(){return goog.labs.userAgent.util.matchUserAgent("iPhone")&&!goog.labs.userAgent.util.matchUserAgent("iPod")&&!goog.labs.userAgent.util.matchUserAgent("iPad")};goog.labs.userAgent.platform.isIpad=function(){return goog.labs.userAgent.util.matchUserAgent("iPad")};
goog.labs.userAgent.platform.isIos=function(){return goog.labs.userAgent.platform.isIphone()||goog.labs.userAgent.platform.isIpad()||goog.labs.userAgent.platform.isIpod()};goog.labs.userAgent.platform.isMacintosh=function(){return goog.labs.userAgent.util.matchUserAgent("Macintosh")};goog.labs.userAgent.platform.isLinux=function(){return goog.labs.userAgent.util.matchUserAgent("Linux")};goog.labs.userAgent.platform.isWindows=function(){return goog.labs.userAgent.util.matchUserAgent("Windows")};
goog.labs.userAgent.platform.isChromeOS=function(){return goog.labs.userAgent.util.matchUserAgent("CrOS")};goog.labs.userAgent.platform.isChromecast=function(){return goog.labs.userAgent.util.matchUserAgent("CrKey")};goog.labs.userAgent.platform.isKaiOS=function(){return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS")};goog.labs.userAgent.platform.isGo2Phone=function(){return goog.labs.userAgent.util.matchUserAgentIgnoreCase("GAFP")};
goog.labs.userAgent.platform.getVersion=function(){var a=goog.labs.userAgent.util.getUserAgent(),b="";goog.labs.userAgent.platform.isWindows()?(b=/Windows (?:NT|Phone) ([0-9.]+)/,b=(a=b.exec(a))?a[1]:"0.0"):goog.labs.userAgent.platform.isIos()?(b=/(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/,b=(a=b.exec(a))&&a[1].replace(/_/g,".")):goog.labs.userAgent.platform.isMacintosh()?(b=/Mac OS X ([0-9_.]+)/,b=(a=b.exec(a))?a[1].replace(/_/g,"."):"10"):goog.labs.userAgent.platform.isKaiOS()?(b=/(?:KaiOS)\/(\S+)/i,
b=(a=b.exec(a))&&a[1]):goog.labs.userAgent.platform.isAndroid()?(b=/Android\s+([^\);]+)(\)|;)/,b=(a=b.exec(a))&&a[1]):goog.labs.userAgent.platform.isChromeOS()&&(b=/(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/,b=(a=b.exec(a))&&a[1]);return b||""};goog.labs.userAgent.platform.isVersionOrHigher=function(a){return 0<=goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(),a)};goog.reflect={};goog.reflect.object=function(a,b){return b};goog.reflect.objectProperty=function(a,b){return a};goog.reflect.sinkValue=function(a){goog.reflect.sinkValue[" "](a);return a};goog.reflect.sinkValue[" "]=goog.nullFunction;goog.reflect.canAccessProperty=function(a,b){try{return goog.reflect.sinkValue(a[b]),!0}catch(c){}return!1};goog.reflect.cache=function(a,b,c,d){d=d?d(b):b;return Object.prototype.hasOwnProperty.call(a,d)?a[d]:a[d]=c(b)};goog.userAgent={};goog.userAgent.ASSUME_IE=!1;goog.userAgent.ASSUME_EDGE=!1;goog.userAgent.ASSUME_GECKO=!1;goog.userAgent.ASSUME_WEBKIT=!1;goog.userAgent.ASSUME_MOBILE_WEBKIT=!1;goog.userAgent.ASSUME_OPERA=!1;goog.userAgent.ASSUME_ANY_VERSION=!1;goog.userAgent.BROWSER_KNOWN_=goog.userAgent.ASSUME_IE||goog.userAgent.ASSUME_EDGE||goog.userAgent.ASSUME_GECKO||goog.userAgent.ASSUME_MOBILE_WEBKIT||goog.userAgent.ASSUME_WEBKIT||goog.userAgent.ASSUME_OPERA;goog.userAgent.getUserAgentString=function(){return goog.labs.userAgent.util.getUserAgent()};
goog.userAgent.getNavigatorTyped=function(){return goog.global.navigator||null};goog.userAgent.getNavigator=function(){return goog.userAgent.getNavigatorTyped()};goog.userAgent.OPERA=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_OPERA:goog.labs.userAgent.browser.isOpera();goog.userAgent.IE=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_IE:goog.labs.userAgent.browser.isIE();goog.userAgent.EDGE=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_EDGE:goog.labs.userAgent.engine.isEdge();
goog.userAgent.EDGE_OR_IE=goog.userAgent.EDGE||goog.userAgent.IE;goog.userAgent.GECKO=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_GECKO:goog.labs.userAgent.engine.isGecko();goog.userAgent.WEBKIT=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_WEBKIT||goog.userAgent.ASSUME_MOBILE_WEBKIT:goog.labs.userAgent.engine.isWebKit();goog.userAgent.isMobile_=function(){return goog.userAgent.WEBKIT&&goog.labs.userAgent.util.matchUserAgent("Mobile")};
goog.userAgent.MOBILE=goog.userAgent.ASSUME_MOBILE_WEBKIT||goog.userAgent.isMobile_();goog.userAgent.SAFARI=goog.userAgent.WEBKIT;goog.userAgent.determinePlatform_=function(){var a=goog.userAgent.getNavigatorTyped();return a&&a.platform||""};goog.userAgent.PLATFORM=goog.userAgent.determinePlatform_();goog.userAgent.ASSUME_MAC=!1;goog.userAgent.ASSUME_WINDOWS=!1;goog.userAgent.ASSUME_LINUX=!1;goog.userAgent.ASSUME_X11=!1;goog.userAgent.ASSUME_ANDROID=!1;goog.userAgent.ASSUME_IPHONE=!1;
goog.userAgent.ASSUME_IPAD=!1;goog.userAgent.ASSUME_IPOD=!1;goog.userAgent.ASSUME_KAIOS=!1;goog.userAgent.ASSUME_GO2PHONE=!1;goog.userAgent.PLATFORM_KNOWN_=goog.userAgent.ASSUME_MAC||goog.userAgent.ASSUME_WINDOWS||goog.userAgent.ASSUME_LINUX||goog.userAgent.ASSUME_X11||goog.userAgent.ASSUME_ANDROID||goog.userAgent.ASSUME_IPHONE||goog.userAgent.ASSUME_IPAD||goog.userAgent.ASSUME_IPOD;goog.userAgent.MAC=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_MAC:goog.labs.userAgent.platform.isMacintosh();
goog.userAgent.WINDOWS=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_WINDOWS:goog.labs.userAgent.platform.isWindows();goog.userAgent.isLegacyLinux_=function(){return goog.labs.userAgent.platform.isLinux()||goog.labs.userAgent.platform.isChromeOS()};goog.userAgent.LINUX=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_LINUX:goog.userAgent.isLegacyLinux_();goog.userAgent.isX11_=function(){var a=goog.userAgent.getNavigatorTyped();return!!a&&goog.string.contains(a.appVersion||"","X11")};
goog.userAgent.X11=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_X11:goog.userAgent.isX11_();goog.userAgent.ANDROID=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_ANDROID:goog.labs.userAgent.platform.isAndroid();goog.userAgent.IPHONE=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPHONE:goog.labs.userAgent.platform.isIphone();goog.userAgent.IPAD=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPAD:goog.labs.userAgent.platform.isIpad();
goog.userAgent.IPOD=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPOD:goog.labs.userAgent.platform.isIpod();goog.userAgent.IOS=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPHONE||goog.userAgent.ASSUME_IPAD||goog.userAgent.ASSUME_IPOD:goog.labs.userAgent.platform.isIos();goog.userAgent.KAIOS=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_KAIOS:goog.labs.userAgent.platform.isKaiOS();goog.userAgent.GO2PHONE=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_GO2PHONE:goog.labs.userAgent.platform.isGo2Phone();
goog.userAgent.determineVersion_=function(){var a="",b=goog.userAgent.getVersionRegexResult_();b&&(a=b?b[1]:"");return goog.userAgent.IE&&(b=goog.userAgent.getDocumentMode_(),null!=b&&b>parseFloat(a))?String(b):a};
goog.userAgent.getVersionRegexResult_=function(){var a=goog.userAgent.getUserAgentString();if(goog.userAgent.GECKO)return/rv:([^\);]+)(\)|;)/.exec(a);if(goog.userAgent.EDGE)return/Edge\/([\d\.]+)/.exec(a);if(goog.userAgent.IE)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(goog.userAgent.WEBKIT)return/WebKit\/(\S+)/.exec(a);if(goog.userAgent.OPERA)return/(?:Version)[ \/]?(\S+)/.exec(a)};goog.userAgent.getDocumentMode_=function(){var a=goog.global.document;return a?a.documentMode:void 0};
goog.userAgent.VERSION=goog.userAgent.determineVersion_();goog.userAgent.compare=function(a,b){return goog.string.compareVersions(a,b)};goog.userAgent.isVersionOrHigherCache_={};goog.userAgent.isVersionOrHigher=function(a){return goog.userAgent.ASSUME_ANY_VERSION||goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_,a,function(){return 0<=goog.string.compareVersions(goog.userAgent.VERSION,a)})};goog.userAgent.isVersion=goog.userAgent.isVersionOrHigher;
goog.userAgent.isDocumentModeOrHigher=function(a){return Number(goog.userAgent.DOCUMENT_MODE)>=a};goog.userAgent.isDocumentMode=goog.userAgent.isDocumentModeOrHigher;goog.userAgent.DOCUMENT_MODE=function(){if(goog.global.document&&goog.userAgent.IE)return goog.userAgent.getDocumentMode_()}();goog.userAgent.product={};goog.userAgent.product.ASSUME_FIREFOX=!1;goog.userAgent.product.ASSUME_IPHONE=!1;goog.userAgent.product.ASSUME_IPAD=!1;goog.userAgent.product.ASSUME_ANDROID=!1;goog.userAgent.product.ASSUME_CHROME=!1;goog.userAgent.product.ASSUME_SAFARI=!1;
goog.userAgent.product.PRODUCT_KNOWN_=goog.userAgent.ASSUME_IE||goog.userAgent.ASSUME_EDGE||goog.userAgent.ASSUME_OPERA||goog.userAgent.product.ASSUME_FIREFOX||goog.userAgent.product.ASSUME_IPHONE||goog.userAgent.product.ASSUME_IPAD||goog.userAgent.product.ASSUME_ANDROID||goog.userAgent.product.ASSUME_CHROME||goog.userAgent.product.ASSUME_SAFARI;goog.userAgent.product.OPERA=goog.userAgent.OPERA;goog.userAgent.product.IE=goog.userAgent.IE;goog.userAgent.product.EDGE=goog.userAgent.EDGE;
goog.userAgent.product.FIREFOX=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_FIREFOX:goog.labs.userAgent.browser.isFirefox();goog.userAgent.product.isIphoneOrIpod_=function(){return goog.labs.userAgent.platform.isIphone()||goog.labs.userAgent.platform.isIpod()};goog.userAgent.product.IPHONE=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_IPHONE:goog.userAgent.product.isIphoneOrIpod_();
goog.userAgent.product.IPAD=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_IPAD:goog.labs.userAgent.platform.isIpad();goog.userAgent.product.ANDROID=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_ANDROID:goog.labs.userAgent.browser.isAndroidBrowser();goog.userAgent.product.CHROME=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_CHROME:goog.labs.userAgent.browser.isChrome();
goog.userAgent.product.isSafariDesktop_=function(){return goog.labs.userAgent.browser.isSafari()&&!goog.labs.userAgent.platform.isIos()};goog.userAgent.product.SAFARI=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_SAFARI:goog.userAgent.product.isSafariDesktop_();goog.crypt.base64={};goog.crypt.base64.DEFAULT_ALPHABET_COMMON_="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";goog.crypt.base64.ENCODED_VALS=goog.crypt.base64.DEFAULT_ALPHABET_COMMON_+"+/=";goog.crypt.base64.ENCODED_VALS_WEBSAFE=goog.crypt.base64.DEFAULT_ALPHABET_COMMON_+"-_.";goog.crypt.base64.Alphabet={DEFAULT:0,NO_PADDING:1,WEBSAFE:2,WEBSAFE_DOT_PADDING:3,WEBSAFE_NO_PADDING:4};goog.crypt.base64.paddingChars_="=.";
goog.crypt.base64.isPadding_=function(a){return goog.string.contains(goog.crypt.base64.paddingChars_,a)};goog.crypt.base64.byteToCharMaps_={};goog.crypt.base64.charToByteMap_=null;goog.crypt.base64.ASSUME_NATIVE_SUPPORT_=goog.userAgent.GECKO||goog.userAgent.WEBKIT&&!goog.userAgent.product.SAFARI||goog.userAgent.OPERA;goog.crypt.base64.HAS_NATIVE_ENCODE_=goog.crypt.base64.ASSUME_NATIVE_SUPPORT_||"function"==typeof goog.global.btoa;
goog.crypt.base64.HAS_NATIVE_DECODE_=goog.crypt.base64.ASSUME_NATIVE_SUPPORT_||!goog.userAgent.product.SAFARI&&!goog.userAgent.IE&&"function"==typeof goog.global.atob;
goog.crypt.base64.encodeByteArray=function(a,b){goog.asserts.assert(goog.isArrayLike(a),"encodeByteArray takes an array as a parameter");void 0===b&&(b=goog.crypt.base64.Alphabet.DEFAULT);goog.crypt.base64.init_();b=goog.crypt.base64.byteToCharMaps_[b];for(var c=[],d=0;d<a.length;d+=3){var e=a[d],f=d+1<a.length,g=f?a[d+1]:0,h=d+2<a.length,k=h?a[d+2]:0,l=e>>2;e=(e&3)<<4|g>>4;g=(g&15)<<2|k>>6;k&=63;h||(k=64,f||(g=64));c.push(b[l],b[e],b[g]||"",b[k]||"")}return c.join("")};
goog.crypt.base64.encodeString=function(a,b){return goog.crypt.base64.HAS_NATIVE_ENCODE_&&!b?goog.global.btoa(a):goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(a),b)};goog.crypt.base64.decodeString=function(a,b){if(goog.crypt.base64.HAS_NATIVE_DECODE_&&!b)return goog.global.atob(a);var c="";goog.crypt.base64.decodeStringInternal_(a,function(a){c+=String.fromCharCode(a)});return c};
goog.crypt.base64.decodeStringToByteArray=function(a,b){var c=[];goog.crypt.base64.decodeStringInternal_(a,function(a){c.push(a)});return c};
goog.crypt.base64.decodeStringToUint8Array=function(a){goog.asserts.assert(!goog.userAgent.IE||goog.userAgent.isVersionOrHigher("10"),"Browser does not support typed arrays");var b=a.length,c=3*b/4;c%3?c=Math.floor(c):goog.crypt.base64.isPadding_(a[b-1])&&(c=goog.crypt.base64.isPadding_(a[b-2])?c-2:c-1);var d=new Uint8Array(c),e=0;goog.crypt.base64.decodeStringInternal_(a,function(a){d[e++]=a});return d.subarray(0,e)};
goog.crypt.base64.decodeStringInternal_=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=goog.crypt.base64.charToByteMap_[c];if(null!=e)return e;if(!goog.string.isEmptyOrWhitespace(c))throw Error("Unknown base64 encoding at char: "+c);}return b}goog.crypt.base64.init_();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),h=c(64);if(64===h&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=h&&b(g<<6&192|h))}};
goog.crypt.base64.init_=function(){if(!goog.crypt.base64.charToByteMap_){goog.crypt.base64.charToByteMap_={};for(var a=goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""),b=["+/=","+/","-_=","-_.","-_"],c=0;5>c;c++){var d=a.concat(b[c].split(""));goog.crypt.base64.byteToCharMaps_[c]=d;for(var e=0;e<d.length;e++){var f=d[e],g=goog.crypt.base64.charToByteMap_[f];void 0===g?goog.crypt.base64.charToByteMap_[f]=e:goog.asserts.assert(g===e)}}}};jspb.utils={};jspb.utils.split64Low=0;jspb.utils.split64High=0;jspb.utils.splitUint64=function(a){var b=a>>>0;a=Math.floor((a-b)/jspb.BinaryConstants.TWO_TO_32)>>>0;jspb.utils.split64Low=b;jspb.utils.split64High=a};jspb.utils.splitInt64=function(a){var b=0>a;a=Math.abs(a);var c=a>>>0;a=Math.floor((a-c)/jspb.BinaryConstants.TWO_TO_32);a>>>=0;b&&(a=~a>>>0,c=(~c>>>0)+1,4294967295<c&&(c=0,a++,4294967295<a&&(a=0)));jspb.utils.split64Low=c;jspb.utils.split64High=a};
jspb.utils.splitZigzag64=function(a){var b=0>a;a=2*Math.abs(a);jspb.utils.splitUint64(a);a=jspb.utils.split64Low;var c=jspb.utils.split64High;b&&(0==a?0==c?c=a=4294967295:(c--,a=4294967295):a--);jspb.utils.split64Low=a;jspb.utils.split64High=c};
jspb.utils.splitFloat32=function(a){var b=0>a?1:0;a=b?-a:a;if(0===a)0<1/a?(jspb.utils.split64High=0,jspb.utils.split64Low=0):(jspb.utils.split64High=0,jspb.utils.split64Low=2147483648);else if(isNaN(a))jspb.utils.split64High=0,jspb.utils.split64Low=2147483647;else if(a>jspb.BinaryConstants.FLOAT32_MAX)jspb.utils.split64High=0,jspb.utils.split64Low=(b<<31|2139095040)>>>0;else if(a<jspb.BinaryConstants.FLOAT32_MIN)a=Math.round(a/Math.pow(2,-149)),jspb.utils.split64High=0,jspb.utils.split64Low=(b<<31|
a)>>>0;else{var c=Math.floor(Math.log(a)/Math.LN2);a*=Math.pow(2,-c);a=Math.round(a*jspb.BinaryConstants.TWO_TO_23)&8388607;jspb.utils.split64High=0;jspb.utils.split64Low=(b<<31|c+127<<23|a)>>>0}};
jspb.utils.splitFloat64=function(a){var b=0>a?1:0;a=b?-a:a;if(0===a)jspb.utils.split64High=0<1/a?0:2147483648,jspb.utils.split64Low=0;else if(isNaN(a))jspb.utils.split64High=2147483647,jspb.utils.split64Low=4294967295;else if(a>jspb.BinaryConstants.FLOAT64_MAX)jspb.utils.split64High=(b<<31|2146435072)>>>0,jspb.utils.split64Low=0;else if(a<jspb.BinaryConstants.FLOAT64_MIN){var c=a/Math.pow(2,-1074);a=c/jspb.BinaryConstants.TWO_TO_32;jspb.utils.split64High=(b<<31|a)>>>0;jspb.utils.split64Low=c>>>0}else{c=
a;var d=0;if(2<=c)for(;2<=c&&1023>d;)d++,c/=2;else for(;1>c&&-1022<d;)c*=2,d--;c=a*Math.pow(2,-d);a=c*jspb.BinaryConstants.TWO_TO_20&1048575;c=c*jspb.BinaryConstants.TWO_TO_52>>>0;jspb.utils.split64High=(b<<31|d+1023<<20|a)>>>0;jspb.utils.split64Low=c}};
jspb.utils.splitHash64=function(a){var b=a.charCodeAt(0),c=a.charCodeAt(1),d=a.charCodeAt(2),e=a.charCodeAt(3),f=a.charCodeAt(4),g=a.charCodeAt(5),h=a.charCodeAt(6);a=a.charCodeAt(7);jspb.utils.split64Low=b+(c<<8)+(d<<16)+(e<<24)>>>0;jspb.utils.split64High=f+(g<<8)+(h<<16)+(a<<24)>>>0};jspb.utils.joinUint64=function(a,b){return b*jspb.BinaryConstants.TWO_TO_32+(a>>>0)};
jspb.utils.joinInt64=function(a,b){var c=b&2147483648;c&&(a=~a+1>>>0,b=~b>>>0,0==a&&(b=b+1>>>0));a=jspb.utils.joinUint64(a,b);return c?-a:a};jspb.utils.toZigzag64=function(a,b,c){var d=b>>31;return c(a<<1^d,(b<<1|a>>>31)^d)};jspb.utils.joinZigzag64=function(a,b){return jspb.utils.fromZigzag64(a,b,jspb.utils.joinInt64)};jspb.utils.fromZigzag64=function(a,b,c){var d=-(a&1);return c((a>>>1|b<<31)^d,b>>>1^d)};
jspb.utils.joinFloat32=function(a,b){b=2*(a>>31)+1;var c=a>>>23&255;a&=8388607;return 255==c?a?NaN:Infinity*b:0==c?b*Math.pow(2,-149)*a:b*Math.pow(2,c-150)*(a+Math.pow(2,23))};jspb.utils.joinFloat64=function(a,b){var c=2*(b>>31)+1,d=b>>>20&2047;a=jspb.BinaryConstants.TWO_TO_32*(b&1048575)+a;return 2047==d?a?NaN:Infinity*c:0==d?c*Math.pow(2,-1074)*a:c*Math.pow(2,d-1075)*(a+jspb.BinaryConstants.TWO_TO_52)};
jspb.utils.joinHash64=function(a,b){return String.fromCharCode(a>>>0&255,a>>>8&255,a>>>16&255,a>>>24&255,b>>>0&255,b>>>8&255,b>>>16&255,b>>>24&255)};jspb.utils.DIGITS="0123456789abcdef".split("");jspb.utils.ZERO_CHAR_CODE_=48;jspb.utils.A_CHAR_CODE_=97;
jspb.utils.joinUnsignedDecimalString=function(a,b){function c(a,b){a=a?String(a):"";return b?"0000000".slice(a.length)+a:a}if(2097151>=b)return""+jspb.utils.joinUint64(a,b);var d=(a>>>24|b<<8)>>>0&16777215;b=b>>16&65535;a=(a&16777215)+6777216*d+6710656*b;d+=8147497*b;b*=2;1E7<=a&&(d+=Math.floor(a/1E7),a%=1E7);1E7<=d&&(b+=Math.floor(d/1E7),d%=1E7);return c(b,0)+c(d,b)+c(a,1)};
jspb.utils.joinSignedDecimalString=function(a,b){var c=b&2147483648;c&&(a=~a+1>>>0,b=~b+(0==a?1:0)>>>0);a=jspb.utils.joinUnsignedDecimalString(a,b);return c?"-"+a:a};jspb.utils.hash64ToDecimalString=function(a,b){jspb.utils.splitHash64(a);a=jspb.utils.split64Low;var c=jspb.utils.split64High;return b?jspb.utils.joinSignedDecimalString(a,c):jspb.utils.joinUnsignedDecimalString(a,c)};
jspb.utils.hash64ArrayToDecimalStrings=function(a,b){for(var c=Array(a.length),d=0;d<a.length;d++)c[d]=jspb.utils.hash64ToDecimalString(a[d],b);return c};
jspb.utils.decimalStringToHash64=function(a){function b(a,b){for(var c=0;8>c&&(1!==a||0<b);c++)b=a*e[c]+b,e[c]=b&255,b>>>=8}function c(){for(var a=0;8>a;a++)e[a]=~e[a]&255}goog.asserts.assert(0<a.length);var d=!1;"-"===a[0]&&(d=!0,a=a.slice(1));for(var e=[0,0,0,0,0,0,0,0],f=0;f<a.length;f++)b(10,a.charCodeAt(f)-jspb.utils.ZERO_CHAR_CODE_);d&&(c(),b(1,1));return goog.crypt.byteArrayToString(e)};jspb.utils.splitDecimalString=function(a){jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a))};
jspb.utils.toHexDigit_=function(a){return String.fromCharCode(10>a?jspb.utils.ZERO_CHAR_CODE_+a:jspb.utils.A_CHAR_CODE_-10+a)};jspb.utils.fromHexCharCode_=function(a){return a>=jspb.utils.A_CHAR_CODE_?a-jspb.utils.A_CHAR_CODE_+10:a-jspb.utils.ZERO_CHAR_CODE_};jspb.utils.hash64ToHexString=function(a){var b=Array(18);b[0]="0";b[1]="x";for(var c=0;8>c;c++){var d=a.charCodeAt(7-c);b[2*c+2]=jspb.utils.toHexDigit_(d>>4);b[2*c+3]=jspb.utils.toHexDigit_(d&15)}return b.join("")};
jspb.utils.hexStringToHash64=function(a){a=a.toLowerCase();goog.asserts.assert(18==a.length);goog.asserts.assert("0"==a[0]);goog.asserts.assert("x"==a[1]);for(var b="",c=0;8>c;c++){var d=jspb.utils.fromHexCharCode_(a.charCodeAt(2*c+2)),e=jspb.utils.fromHexCharCode_(a.charCodeAt(2*c+3));b=String.fromCharCode(16*d+e)+b}return b};
jspb.utils.hash64ToNumber=function(a,b){jspb.utils.splitHash64(a);a=jspb.utils.split64Low;var c=jspb.utils.split64High;return b?jspb.utils.joinInt64(a,c):jspb.utils.joinUint64(a,c)};jspb.utils.numberToHash64=function(a){jspb.utils.splitInt64(a);return jspb.utils.joinHash64(jspb.utils.split64Low,jspb.utils.split64High)};jspb.utils.countVarints=function(a,b,c){for(var d=0,e=b;e<c;e++)d+=a[e]>>7;return c-b-d};
jspb.utils.countVarintFields=function(a,b,c,d){var e=0;d=8*d+jspb.BinaryConstants.WireType.VARINT;if(128>d)for(;b<c&&a[b++]==d;)for(e++;;){var f=a[b++];if(0==(f&128))break}else for(;b<c;){for(f=d;128<f;){if(a[b]!=(f&127|128))return e;b++;f>>=7}if(a[b++]!=f)break;for(e++;f=a[b++],0!=(f&128););}return e};jspb.utils.countFixedFields_=function(a,b,c,d,e){var f=0;if(128>d)for(;b<c&&a[b++]==d;)f++,b+=e;else for(;b<c;){for(var g=d;128<g;){if(a[b++]!=(g&127|128))return f;g>>=7}if(a[b++]!=g)break;f++;b+=e}return f};
jspb.utils.countFixed32Fields=function(a,b,c,d){return jspb.utils.countFixedFields_(a,b,c,8*d+jspb.BinaryConstants.WireType.FIXED32,4)};jspb.utils.countFixed64Fields=function(a,b,c,d){return jspb.utils.countFixedFields_(a,b,c,8*d+jspb.BinaryConstants.WireType.FIXED64,8)};
jspb.utils.countDelimitedFields=function(a,b,c,d){var e=0;for(d=8*d+jspb.BinaryConstants.WireType.DELIMITED;b<c;){for(var f=d;128<f;){if(a[b++]!=(f&127|128))return e;f>>=7}if(a[b++]!=f)break;e++;for(var g=0,h=1;f=a[b++],g+=(f&127)*h,h*=128,0!=(f&128););b+=g}return e};jspb.utils.debugBytesToTextFormat=function(a){var b='"';if(a){a=jspb.utils.byteSourceToUint8Array(a);for(var c=0;c<a.length;c++)b+="\\x",16>a[c]&&(b+="0"),b+=a[c].toString(16)}return b+'"'};
jspb.utils.debugScalarToTextFormat=function(a){return"string"===typeof a?goog.string.quote(a):a.toString()};jspb.utils.stringToByteArray=function(a){for(var b=new Uint8Array(a.length),c=0;c<a.length;c++){var d=a.charCodeAt(c);if(255<d)throw Error("Conversion error: string contains codepoint outside of byte range");b[c]=d}return b};
jspb.utils.byteSourceToUint8Array=function(a){if(a.constructor===Uint8Array)return a;if(a.constructor===ArrayBuffer||"undefined"!=typeof Buffer&&a.constructor===Buffer||a.constructor===Array)return new Uint8Array(a);if(a.constructor===String)return goog.crypt.base64.decodeStringToUint8Array(a);goog.asserts.fail("Type not convertible to Uint8Array.");return new Uint8Array(0)};jspb.BinaryDecoder=function(a,b,c){this.bytes_=null;this.cursor_=this.end_=this.start_=0;this.error_=!1;a&&this.setBlock(a,b,c)};jspb.BinaryDecoder.instanceCache_=[];jspb.BinaryDecoder.alloc=function(a,b,c){if(jspb.BinaryDecoder.instanceCache_.length){var d=jspb.BinaryDecoder.instanceCache_.pop();a&&d.setBlock(a,b,c);return d}return new jspb.BinaryDecoder(a,b,c)};jspb.BinaryDecoder.prototype.free=function(){this.clear();100>jspb.BinaryDecoder.instanceCache_.length&&jspb.BinaryDecoder.instanceCache_.push(this)};
jspb.BinaryDecoder.prototype.clone=function(){return jspb.BinaryDecoder.alloc(this.bytes_,this.start_,this.end_-this.start_)};jspb.BinaryDecoder.prototype.clear=function(){this.bytes_=null;this.cursor_=this.end_=this.start_=0;this.error_=!1};jspb.BinaryDecoder.prototype.getBuffer=function(){return this.bytes_};
jspb.BinaryDecoder.prototype.setBlock=function(a,b,c){this.bytes_=jspb.utils.byteSourceToUint8Array(a);this.start_=void 0!==b?b:0;this.end_=void 0!==c?this.start_+c:this.bytes_.length;this.cursor_=this.start_};jspb.BinaryDecoder.prototype.getEnd=function(){return this.end_};jspb.BinaryDecoder.prototype.setEnd=function(a){this.end_=a};jspb.BinaryDecoder.prototype.reset=function(){this.cursor_=this.start_};jspb.BinaryDecoder.prototype.getCursor=function(){return this.cursor_};
jspb.BinaryDecoder.prototype.setCursor=function(a){this.cursor_=a};jspb.BinaryDecoder.prototype.advance=function(a){this.cursor_+=a;goog.asserts.assert(this.cursor_<=this.end_)};jspb.BinaryDecoder.prototype.atEnd=function(){return this.cursor_==this.end_};jspb.BinaryDecoder.prototype.pastEnd=function(){return this.cursor_>this.end_};jspb.BinaryDecoder.prototype.getError=function(){return this.error_||0>this.cursor_||this.cursor_>this.end_};
jspb.BinaryDecoder.prototype.readSplitVarint64=function(a){for(var b=128,c=0,d=0,e=0;4>e&&128<=b;e++)b=this.bytes_[this.cursor_++],c|=(b&127)<<7*e;128<=b&&(b=this.bytes_[this.cursor_++],c|=(b&127)<<28,d|=(b&127)>>4);if(128<=b)for(e=0;5>e&&128<=b;e++)b=this.bytes_[this.cursor_++],d|=(b&127)<<7*e+3;if(128>b)return a(c>>>0,d>>>0);goog.asserts.fail("Failed to read varint, encoding is invalid.");this.error_=!0};
jspb.BinaryDecoder.prototype.readSplitZigzagVarint64=function(a){return this.readSplitVarint64(function(b,c){return jspb.utils.fromZigzag64(b,c,a)})};jspb.BinaryDecoder.prototype.readSplitFixed64=function(a){var b=this.bytes_,c=this.cursor_;this.cursor_+=8;for(var d=0,e=0,f=c+7;f>=c;f--)d=d<<8|b[f],e=e<<8|b[f+4];return a(d,e)};jspb.BinaryDecoder.prototype.skipVarint=function(){for(;this.bytes_[this.cursor_]&128;)this.cursor_++;this.cursor_++};
jspb.BinaryDecoder.prototype.unskipVarint=function(a){for(;128<a;)this.cursor_--,a>>>=7;this.cursor_--};
jspb.BinaryDecoder.prototype.readUnsignedVarint32=function(){var a=this.bytes_;var b=a[this.cursor_+0];var c=b&127;if(128>b)return this.cursor_+=1,goog.asserts.assert(this.cursor_<=this.end_),c;b=a[this.cursor_+1];c|=(b&127)<<7;if(128>b)return this.cursor_+=2,goog.asserts.assert(this.cursor_<=this.end_),c;b=a[this.cursor_+2];c|=(b&127)<<14;if(128>b)return this.cursor_+=3,goog.asserts.assert(this.cursor_<=this.end_),c;b=a[this.cursor_+3];c|=(b&127)<<21;if(128>b)return this.cursor_+=4,goog.asserts.assert(this.cursor_<=
this.end_),c;b=a[this.cursor_+4];c|=(b&15)<<28;if(128>b)return this.cursor_+=5,goog.asserts.assert(this.cursor_<=this.end_),c>>>0;this.cursor_+=5;128<=a[this.cursor_++]&&128<=a[this.cursor_++]&&128<=a[this.cursor_++]&&128<=a[this.cursor_++]&&128<=a[this.cursor_++]&&goog.asserts.assert(!1);goog.asserts.assert(this.cursor_<=this.end_);return c};jspb.BinaryDecoder.prototype.readSignedVarint32=jspb.BinaryDecoder.prototype.readUnsignedVarint32;jspb.BinaryDecoder.prototype.readUnsignedVarint32String=function(){return this.readUnsignedVarint32().toString()};
jspb.BinaryDecoder.prototype.readSignedVarint32String=function(){return this.readSignedVarint32().toString()};jspb.BinaryDecoder.prototype.readZigzagVarint32=function(){var a=this.readUnsignedVarint32();return a>>>1^-(a&1)};jspb.BinaryDecoder.prototype.readUnsignedVarint64=function(){return this.readSplitVarint64(jspb.utils.joinUint64)};jspb.BinaryDecoder.prototype.readUnsignedVarint64String=function(){return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString)};
jspb.BinaryDecoder.prototype.readSignedVarint64=function(){return this.readSplitVarint64(jspb.utils.joinInt64)};jspb.BinaryDecoder.prototype.readSignedVarint64String=function(){return this.readSplitVarint64(jspb.utils.joinSignedDecimalString)};jspb.BinaryDecoder.prototype.readZigzagVarint64=function(){return this.readSplitVarint64(jspb.utils.joinZigzag64)};jspb.BinaryDecoder.prototype.readZigzagVarintHash64=function(){return this.readSplitZigzagVarint64(jspb.utils.joinHash64)};
jspb.BinaryDecoder.prototype.readZigzagVarint64String=function(){return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString)};jspb.BinaryDecoder.prototype.readUint8=function(){var a=this.bytes_[this.cursor_+0];this.cursor_+=1;goog.asserts.assert(this.cursor_<=this.end_);return a};jspb.BinaryDecoder.prototype.readUint16=function(){var a=this.bytes_[this.cursor_+0],b=this.bytes_[this.cursor_+1];this.cursor_+=2;goog.asserts.assert(this.cursor_<=this.end_);return a<<0|b<<8};
jspb.BinaryDecoder.prototype.readUint32=function(){var a=this.bytes_[this.cursor_+0],b=this.bytes_[this.cursor_+1],c=this.bytes_[this.cursor_+2],d=this.bytes_[this.cursor_+3];this.cursor_+=4;goog.asserts.assert(this.cursor_<=this.end_);return(a<<0|b<<8|c<<16|d<<24)>>>0};jspb.BinaryDecoder.prototype.readUint64=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinUint64(a,b)};
jspb.BinaryDecoder.prototype.readUint64String=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinUnsignedDecimalString(a,b)};jspb.BinaryDecoder.prototype.readInt8=function(){var a=this.bytes_[this.cursor_+0];this.cursor_+=1;goog.asserts.assert(this.cursor_<=this.end_);return a<<24>>24};
jspb.BinaryDecoder.prototype.readInt16=function(){var a=this.bytes_[this.cursor_+0],b=this.bytes_[this.cursor_+1];this.cursor_+=2;goog.asserts.assert(this.cursor_<=this.end_);return(a<<0|b<<8)<<16>>16};jspb.BinaryDecoder.prototype.readInt32=function(){var a=this.bytes_[this.cursor_+0],b=this.bytes_[this.cursor_+1],c=this.bytes_[this.cursor_+2],d=this.bytes_[this.cursor_+3];this.cursor_+=4;goog.asserts.assert(this.cursor_<=this.end_);return a<<0|b<<8|c<<16|d<<24};
jspb.BinaryDecoder.prototype.readInt64=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinInt64(a,b)};jspb.BinaryDecoder.prototype.readInt64String=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinSignedDecimalString(a,b)};jspb.BinaryDecoder.prototype.readFloat=function(){var a=this.readUint32();return jspb.utils.joinFloat32(a,0)};
jspb.BinaryDecoder.prototype.readDouble=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinFloat64(a,b)};jspb.BinaryDecoder.prototype.readBool=function(){return!!this.bytes_[this.cursor_++]};jspb.BinaryDecoder.prototype.readEnum=function(){return this.readSignedVarint32()};
jspb.BinaryDecoder.prototype.readString=function(a){var b=this.bytes_,c=this.cursor_;a=c+a;for(var d=[],e="";c<a;){var f=b[c++];if(128>f)d.push(f);else if(192>f)continue;else if(224>f){var g=b[c++];d.push((f&31)<<6|g&63)}else if(240>f){g=b[c++];var h=b[c++];d.push((f&15)<<12|(g&63)<<6|h&63)}else if(248>f){g=b[c++];h=b[c++];var k=b[c++];f=(f&7)<<18|(g&63)<<12|(h&63)<<6|k&63;f-=65536;d.push((f>>10&1023)+55296,(f&1023)+56320)}8192<=d.length&&(e+=String.fromCharCode.apply(null,d),d.length=0)}e+=goog.crypt.byteArrayToString(d);
this.cursor_=c;return e};jspb.BinaryDecoder.prototype.readStringWithLength=function(){var a=this.readUnsignedVarint32();return this.readString(a)};jspb.BinaryDecoder.prototype.readBytes=function(a){if(0>a||this.cursor_+a>this.bytes_.length)return this.error_=!0,goog.asserts.fail("Invalid byte length!"),new Uint8Array(0);var b=this.bytes_.subarray(this.cursor_,this.cursor_+a);this.cursor_+=a;goog.asserts.assert(this.cursor_<=this.end_);return b};jspb.BinaryDecoder.prototype.readVarintHash64=function(){return this.readSplitVarint64(jspb.utils.joinHash64)};
jspb.BinaryDecoder.prototype.readFixedHash64=function(){var a=this.bytes_,b=this.cursor_,c=a[b+0],d=a[b+1],e=a[b+2],f=a[b+3],g=a[b+4],h=a[b+5],k=a[b+6];a=a[b+7];this.cursor_+=8;return String.fromCharCode(c,d,e,f,g,h,k,a)};jspb.BinaryReader=function(a,b,c){this.decoder_=jspb.BinaryDecoder.alloc(a,b,c);this.fieldCursor_=this.decoder_.getCursor();this.nextField_=jspb.BinaryConstants.INVALID_FIELD_NUMBER;this.nextWireType_=jspb.BinaryConstants.WireType.INVALID;this.error_=!1;this.readCallbacks_=null};jspb.BinaryReader.instanceCache_=[];
jspb.BinaryReader.alloc=function(a,b,c){if(jspb.BinaryReader.instanceCache_.length){var d=jspb.BinaryReader.instanceCache_.pop();a&&d.decoder_.setBlock(a,b,c);return d}return new jspb.BinaryReader(a,b,c)};jspb.BinaryReader.prototype.alloc=jspb.BinaryReader.alloc;
jspb.BinaryReader.prototype.free=function(){this.decoder_.clear();this.nextField_=jspb.BinaryConstants.INVALID_FIELD_NUMBER;this.nextWireType_=jspb.BinaryConstants.WireType.INVALID;this.error_=!1;this.readCallbacks_=null;100>jspb.BinaryReader.instanceCache_.length&&jspb.BinaryReader.instanceCache_.push(this)};jspb.BinaryReader.prototype.getFieldCursor=function(){return this.fieldCursor_};jspb.BinaryReader.prototype.getCursor=function(){return this.decoder_.getCursor()};
jspb.BinaryReader.prototype.getBuffer=function(){return this.decoder_.getBuffer()};jspb.BinaryReader.prototype.getFieldNumber=function(){return this.nextField_};jspb.BinaryReader.prototype.getWireType=function(){return this.nextWireType_};jspb.BinaryReader.prototype.isDelimited=function(){return this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED};jspb.BinaryReader.prototype.isEndGroup=function(){return this.nextWireType_==jspb.BinaryConstants.WireType.END_GROUP};
jspb.BinaryReader.prototype.getError=function(){return this.error_||this.decoder_.getError()};jspb.BinaryReader.prototype.setBlock=function(a,b,c){this.decoder_.setBlock(a,b,c);this.nextField_=jspb.BinaryConstants.INVALID_FIELD_NUMBER;this.nextWireType_=jspb.BinaryConstants.WireType.INVALID};jspb.BinaryReader.prototype.reset=function(){this.decoder_.reset();this.nextField_=jspb.BinaryConstants.INVALID_FIELD_NUMBER;this.nextWireType_=jspb.BinaryConstants.WireType.INVALID};
jspb.BinaryReader.prototype.advance=function(a){this.decoder_.advance(a)};
jspb.BinaryReader.prototype.nextField=function(){if(this.decoder_.atEnd())return!1;if(this.getError())return goog.asserts.fail("Decoder hit an error"),!1;this.fieldCursor_=this.decoder_.getCursor();var a=this.decoder_.readUnsignedVarint32(),b=a>>>3;a&=7;if(a!=jspb.BinaryConstants.WireType.VARINT&&a!=jspb.BinaryConstants.WireType.FIXED32&&a!=jspb.BinaryConstants.WireType.FIXED64&&a!=jspb.BinaryConstants.WireType.DELIMITED&&a!=jspb.BinaryConstants.WireType.START_GROUP&&a!=jspb.BinaryConstants.WireType.END_GROUP)return goog.asserts.fail("Invalid wire type: %s (at position %s)",
a,this.fieldCursor_),this.error_=!0,!1;this.nextField_=b;this.nextWireType_=a;return!0};jspb.BinaryReader.prototype.unskipHeader=function(){this.decoder_.unskipVarint(this.nextField_<<3|this.nextWireType_)};jspb.BinaryReader.prototype.skipMatchingFields=function(){var a=this.nextField_;for(this.unskipHeader();this.nextField()&&this.getFieldNumber()==a;)this.skipField();this.decoder_.atEnd()||this.unskipHeader()};
jspb.BinaryReader.prototype.skipVarintField=function(){this.nextWireType_!=jspb.BinaryConstants.WireType.VARINT?(goog.asserts.fail("Invalid wire type for skipVarintField"),this.skipField()):this.decoder_.skipVarint()};jspb.BinaryReader.prototype.skipDelimitedField=function(){if(this.nextWireType_!=jspb.BinaryConstants.WireType.DELIMITED)goog.asserts.fail("Invalid wire type for skipDelimitedField"),this.skipField();else{var a=this.decoder_.readUnsignedVarint32();this.decoder_.advance(a)}};
jspb.BinaryReader.prototype.skipFixed32Field=function(){this.nextWireType_!=jspb.BinaryConstants.WireType.FIXED32?(goog.asserts.fail("Invalid wire type for skipFixed32Field"),this.skipField()):this.decoder_.advance(4)};jspb.BinaryReader.prototype.skipFixed64Field=function(){this.nextWireType_!=jspb.BinaryConstants.WireType.FIXED64?(goog.asserts.fail("Invalid wire type for skipFixed64Field"),this.skipField()):this.decoder_.advance(8)};
jspb.BinaryReader.prototype.skipGroup=function(){var a=this.nextField_;do{if(!this.nextField()){goog.asserts.fail("Unmatched start-group tag: stream EOF");this.error_=!0;break}if(this.nextWireType_==jspb.BinaryConstants.WireType.END_GROUP){this.nextField_!=a&&(goog.asserts.fail("Unmatched end-group tag"),this.error_=!0);break}this.skipField()}while(1)};
jspb.BinaryReader.prototype.skipField=function(){switch(this.nextWireType_){case jspb.BinaryConstants.WireType.VARINT:this.skipVarintField();break;case jspb.BinaryConstants.WireType.FIXED64:this.skipFixed64Field();break;case jspb.BinaryConstants.WireType.DELIMITED:this.skipDelimitedField();break;case jspb.BinaryConstants.WireType.FIXED32:this.skipFixed32Field();break;case jspb.BinaryConstants.WireType.START_GROUP:this.skipGroup();break;default:goog.asserts.fail("Invalid wire encoding for field.")}};
jspb.BinaryReader.prototype.registerReadCallback=function(a,b){null===this.readCallbacks_&&(this.readCallbacks_={});goog.asserts.assert(!this.readCallbacks_[a]);this.readCallbacks_[a]=b};jspb.BinaryReader.prototype.runReadCallback=function(a){goog.asserts.assert(null!==this.readCallbacks_);a=this.readCallbacks_[a];goog.asserts.assert(a);return a(this)};
jspb.BinaryReader.prototype.readAny=function(a){this.nextWireType_=jspb.BinaryConstants.FieldTypeToWireType(a);var b=jspb.BinaryConstants.FieldType;switch(a){case b.DOUBLE:return this.readDouble();case b.FLOAT:return this.readFloat();case b.INT64:return this.readInt64();case b.UINT64:return this.readUint64();case b.INT32:return this.readInt32();case b.FIXED64:return this.readFixed64();case b.FIXED32:return this.readFixed32();case b.BOOL:return this.readBool();case b.STRING:return this.readString();
case b.GROUP:goog.asserts.fail("Group field type not supported in readAny()");case b.MESSAGE:goog.asserts.fail("Message field type not supported in readAny()");case b.BYTES:return this.readBytes();case b.UINT32:return this.readUint32();case b.ENUM:return this.readEnum();case b.SFIXED32:return this.readSfixed32();case b.SFIXED64:return this.readSfixed64();case b.SINT32:return this.readSint32();case b.SINT64:return this.readSint64();case b.FHASH64:return this.readFixedHash64();case b.VHASH64:return this.readVarintHash64();
default:goog.asserts.fail("Invalid field type in readAny()")}return 0};jspb.BinaryReader.prototype.readMessage=function(a,b){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var c=this.decoder_.getEnd(),d=this.decoder_.readUnsignedVarint32();d=this.decoder_.getCursor()+d;this.decoder_.setEnd(d);b(a,this);this.decoder_.setCursor(d);this.decoder_.setEnd(c)};
jspb.BinaryReader.prototype.readGroup=function(a,b,c){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.START_GROUP);goog.asserts.assert(this.nextField_==a);c(b,this);this.error_||this.nextWireType_==jspb.BinaryConstants.WireType.END_GROUP||(goog.asserts.fail("Group submessage did not end with an END_GROUP tag"),this.error_=!0)};
jspb.BinaryReader.prototype.getFieldDecoder=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var a=this.decoder_.readUnsignedVarint32(),b=this.decoder_.getCursor(),c=b+a;a=jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(),b,a);this.decoder_.setCursor(c);return a};jspb.BinaryReader.prototype.readInt32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint32()};
jspb.BinaryReader.prototype.readInt32String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint32String()};jspb.BinaryReader.prototype.readInt64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint64()};jspb.BinaryReader.prototype.readInt64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint64String()};
jspb.BinaryReader.prototype.readUint32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readUnsignedVarint32()};jspb.BinaryReader.prototype.readUint32String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readUnsignedVarint32String()};jspb.BinaryReader.prototype.readUint64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readUnsignedVarint64()};
jspb.BinaryReader.prototype.readUint64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readUnsignedVarint64String()};jspb.BinaryReader.prototype.readSint32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readZigzagVarint32()};jspb.BinaryReader.prototype.readSint64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readZigzagVarint64()};
jspb.BinaryReader.prototype.readSint64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readZigzagVarint64String()};jspb.BinaryReader.prototype.readFixed32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED32);return this.decoder_.readUint32()};jspb.BinaryReader.prototype.readFixed64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readUint64()};
jspb.BinaryReader.prototype.readFixed64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readUint64String()};jspb.BinaryReader.prototype.readSfixed32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED32);return this.decoder_.readInt32()};jspb.BinaryReader.prototype.readSfixed32String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED32);return this.decoder_.readInt32().toString()};
jspb.BinaryReader.prototype.readSfixed64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readInt64()};jspb.BinaryReader.prototype.readSfixed64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readInt64String()};jspb.BinaryReader.prototype.readFloat=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED32);return this.decoder_.readFloat()};
jspb.BinaryReader.prototype.readDouble=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readDouble()};jspb.BinaryReader.prototype.readBool=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return!!this.decoder_.readUnsignedVarint32()};jspb.BinaryReader.prototype.readEnum=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint64()};
jspb.BinaryReader.prototype.readString=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var a=this.decoder_.readUnsignedVarint32();return this.decoder_.readString(a)};jspb.BinaryReader.prototype.readBytes=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var a=this.decoder_.readUnsignedVarint32();return this.decoder_.readBytes(a)};
jspb.BinaryReader.prototype.readVarintHash64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readVarintHash64()};jspb.BinaryReader.prototype.readSintHash64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readZigzagVarintHash64()};jspb.BinaryReader.prototype.readSplitVarint64=function(a){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSplitVarint64(a)};
jspb.BinaryReader.prototype.readSplitZigzagVarint64=function(a){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSplitVarint64(function(b,c){return jspb.utils.fromZigzag64(b,c,a)})};jspb.BinaryReader.prototype.readFixedHash64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readFixedHash64()};
jspb.BinaryReader.prototype.readSplitFixed64=function(a){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readSplitFixed64(a)};jspb.BinaryReader.prototype.readPackedField_=function(a){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var b=this.decoder_.readUnsignedVarint32();b=this.decoder_.getCursor()+b;for(var c=[];this.decoder_.getCursor()<b;)c.push(a.call(this.decoder_));return c};
jspb.BinaryReader.prototype.readPackedInt32=function(){return this.readPackedField_(this.decoder_.readSignedVarint32)};jspb.BinaryReader.prototype.readPackedInt32String=function(){return this.readPackedField_(this.decoder_.readSignedVarint32String)};jspb.BinaryReader.prototype.readPackedInt64=function(){return this.readPackedField_(this.decoder_.readSignedVarint64)};jspb.BinaryReader.prototype.readPackedInt64String=function(){return this.readPackedField_(this.decoder_.readSignedVarint64String)};
jspb.BinaryReader.prototype.readPackedUint32=function(){return this.readPackedField_(this.decoder_.readUnsignedVarint32)};jspb.BinaryReader.prototype.readPackedUint32String=function(){return this.readPackedField_(this.decoder_.readUnsignedVarint32String)};jspb.BinaryReader.prototype.readPackedUint64=function(){return this.readPackedField_(this.decoder_.readUnsignedVarint64)};jspb.BinaryReader.prototype.readPackedUint64String=function(){return this.readPackedField_(this.decoder_.readUnsignedVarint64String)};
jspb.BinaryReader.prototype.readPackedSint32=function(){return this.readPackedField_(this.decoder_.readZigzagVarint32)};jspb.BinaryReader.prototype.readPackedSint64=function(){return this.readPackedField_(this.decoder_.readZigzagVarint64)};jspb.BinaryReader.prototype.readPackedSint64String=function(){return this.readPackedField_(this.decoder_.readZigzagVarint64String)};jspb.BinaryReader.prototype.readPackedFixed32=function(){return this.readPackedField_(this.decoder_.readUint32)};
jspb.BinaryReader.prototype.readPackedFixed64=function(){return this.readPackedField_(this.decoder_.readUint64)};jspb.BinaryReader.prototype.readPackedFixed64String=function(){return this.readPackedField_(this.decoder_.readUint64String)};jspb.BinaryReader.prototype.readPackedSfixed32=function(){return this.readPackedField_(this.decoder_.readInt32)};jspb.BinaryReader.prototype.readPackedSfixed64=function(){return this.readPackedField_(this.decoder_.readInt64)};
jspb.BinaryReader.prototype.readPackedSfixed64String=function(){return this.readPackedField_(this.decoder_.readInt64String)};jspb.BinaryReader.prototype.readPackedFloat=function(){return this.readPackedField_(this.decoder_.readFloat)};jspb.BinaryReader.prototype.readPackedDouble=function(){return this.readPackedField_(this.decoder_.readDouble)};jspb.BinaryReader.prototype.readPackedBool=function(){return this.readPackedField_(this.decoder_.readBool)};jspb.BinaryReader.prototype.readPackedEnum=function(){return this.readPackedField_(this.decoder_.readEnum)};
jspb.BinaryReader.prototype.readPackedVarintHash64=function(){return this.readPackedField_(this.decoder_.readVarintHash64)};jspb.BinaryReader.prototype.readPackedFixedHash64=function(){return this.readPackedField_(this.decoder_.readFixedHash64)};jspb.BinaryEncoder=function(){this.buffer_=[]};jspb.BinaryEncoder.prototype.length=function(){return this.buffer_.length};jspb.BinaryEncoder.prototype.end=function(){var a=this.buffer_;this.buffer_=[];return a};
jspb.BinaryEncoder.prototype.writeSplitVarint64=function(a,b){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(b==Math.floor(b));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_32);for(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32);0<b||127<a;)this.buffer_.push(a&127|128),a=(a>>>7|b<<25)>>>0,b>>>=7;this.buffer_.push(a)};
jspb.BinaryEncoder.prototype.writeSplitFixed64=function(a,b){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(b==Math.floor(b));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_32);goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32);this.writeUint32(a);this.writeUint32(b)};
jspb.BinaryEncoder.prototype.writeUnsignedVarint32=function(a){goog.asserts.assert(a==Math.floor(a));for(goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_32);127<a;)this.buffer_.push(a&127|128),a>>>=7;this.buffer_.push(a)};
jspb.BinaryEncoder.prototype.writeSignedVarint32=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_31&&a<jspb.BinaryConstants.TWO_TO_31);if(0<=a)this.writeUnsignedVarint32(a);else{for(var b=0;9>b;b++)this.buffer_.push(a&127|128),a>>=7;this.buffer_.push(1)}};
jspb.BinaryEncoder.prototype.writeUnsignedVarint64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_64);jspb.utils.splitInt64(a);this.writeSplitVarint64(jspb.utils.split64Low,jspb.utils.split64High)};
jspb.BinaryEncoder.prototype.writeSignedVarint64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_63&&a<jspb.BinaryConstants.TWO_TO_63);jspb.utils.splitInt64(a);this.writeSplitVarint64(jspb.utils.split64Low,jspb.utils.split64High)};
jspb.BinaryEncoder.prototype.writeZigzagVarint32=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_31&&a<jspb.BinaryConstants.TWO_TO_31);this.writeUnsignedVarint32((a<<1^a>>31)>>>0)};jspb.BinaryEncoder.prototype.writeZigzagVarint64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_63&&a<jspb.BinaryConstants.TWO_TO_63);jspb.utils.splitZigzag64(a);this.writeSplitVarint64(jspb.utils.split64Low,jspb.utils.split64High)};
jspb.BinaryEncoder.prototype.writeZigzagVarint64String=function(a){this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(a))};jspb.BinaryEncoder.prototype.writeZigzagVarintHash64=function(a){var b=this;jspb.utils.splitHash64(a);jspb.utils.toZigzag64(jspb.utils.split64Low,jspb.utils.split64High,function(a,d){b.writeSplitVarint64(a>>>0,d>>>0)})};
jspb.BinaryEncoder.prototype.writeUint8=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&256>a);this.buffer_.push(a>>>0&255)};jspb.BinaryEncoder.prototype.writeUint16=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&65536>a);this.buffer_.push(a>>>0&255);this.buffer_.push(a>>>8&255)};
jspb.BinaryEncoder.prototype.writeUint32=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_32);this.buffer_.push(a>>>0&255);this.buffer_.push(a>>>8&255);this.buffer_.push(a>>>16&255);this.buffer_.push(a>>>24&255)};jspb.BinaryEncoder.prototype.writeUint64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_64);jspb.utils.splitUint64(a);this.writeUint32(jspb.utils.split64Low);this.writeUint32(jspb.utils.split64High)};
jspb.BinaryEncoder.prototype.writeInt8=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(-128<=a&&128>a);this.buffer_.push(a>>>0&255)};jspb.BinaryEncoder.prototype.writeInt16=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(-32768<=a&&32768>a);this.buffer_.push(a>>>0&255);this.buffer_.push(a>>>8&255)};
jspb.BinaryEncoder.prototype.writeInt32=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_31&&a<jspb.BinaryConstants.TWO_TO_31);this.buffer_.push(a>>>0&255);this.buffer_.push(a>>>8&255);this.buffer_.push(a>>>16&255);this.buffer_.push(a>>>24&255)};
jspb.BinaryEncoder.prototype.writeInt64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_63&&a<jspb.BinaryConstants.TWO_TO_63);jspb.utils.splitInt64(a);this.writeSplitFixed64(jspb.utils.split64Low,jspb.utils.split64High)};
jspb.BinaryEncoder.prototype.writeInt64String=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(+a>=-jspb.BinaryConstants.TWO_TO_63&&+a<jspb.BinaryConstants.TWO_TO_63);jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a));this.writeSplitFixed64(jspb.utils.split64Low,jspb.utils.split64High)};
jspb.BinaryEncoder.prototype.writeFloat=function(a){goog.asserts.assert(Infinity===a||-Infinity===a||isNaN(a)||a>=-jspb.BinaryConstants.FLOAT32_MAX&&a<=jspb.BinaryConstants.FLOAT32_MAX);jspb.utils.splitFloat32(a);this.writeUint32(jspb.utils.split64Low)};
jspb.BinaryEncoder.prototype.writeDouble=function(a){goog.asserts.assert(Infinity===a||-Infinity===a||isNaN(a)||a>=-jspb.BinaryConstants.FLOAT64_MAX&&a<=jspb.BinaryConstants.FLOAT64_MAX);jspb.utils.splitFloat64(a);this.writeUint32(jspb.utils.split64Low);this.writeUint32(jspb.utils.split64High)};jspb.BinaryEncoder.prototype.writeBool=function(a){goog.asserts.assert("boolean"===typeof a||"number"===typeof a);this.buffer_.push(a?1:0)};
jspb.BinaryEncoder.prototype.writeEnum=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_31&&a<jspb.BinaryConstants.TWO_TO_31);this.writeSignedVarint32(a)};jspb.BinaryEncoder.prototype.writeBytes=function(a){this.buffer_.push.apply(this.buffer_,a)};jspb.BinaryEncoder.prototype.writeVarintHash64=function(a){jspb.utils.splitHash64(a);this.writeSplitVarint64(jspb.utils.split64Low,jspb.utils.split64High)};
jspb.BinaryEncoder.prototype.writeFixedHash64=function(a){jspb.utils.splitHash64(a);this.writeUint32(jspb.utils.split64Low);this.writeUint32(jspb.utils.split64High)};
jspb.BinaryEncoder.prototype.writeString=function(a){for(var b=this.buffer_.length,c=0;c<a.length;c++){var d=a.charCodeAt(c);if(128>d)this.buffer_.push(d);else if(2048>d)this.buffer_.push(d>>6|192),this.buffer_.push(d&63|128);else if(65536>d)if(55296<=d&&56319>=d&&c+1<a.length){var e=a.charCodeAt(c+1);56320<=e&&57343>=e&&(d=1024*(d-55296)+e-56320+65536,this.buffer_.push(d>>18|240),this.buffer_.push(d>>12&63|128),this.buffer_.push(d>>6&63|128),this.buffer_.push(d&63|128),c++)}else this.buffer_.push(d>>
12|224),this.buffer_.push(d>>6&63|128),this.buffer_.push(d&63|128)}return this.buffer_.length-b};jspb.arith={};jspb.arith.UInt64=function(a,b){this.lo=a;this.hi=b};jspb.arith.UInt64.prototype.cmp=function(a){return this.hi<a.hi||this.hi==a.hi&&this.lo<a.lo?-1:this.hi==a.hi&&this.lo==a.lo?0:1};jspb.arith.UInt64.prototype.rightShift=function(){return new jspb.arith.UInt64((this.lo>>>1|(this.hi&1)<<31)>>>0,this.hi>>>1>>>0)};jspb.arith.UInt64.prototype.leftShift=function(){return new jspb.arith.UInt64(this.lo<<1>>>0,(this.hi<<1|this.lo>>>31)>>>0)};
jspb.arith.UInt64.prototype.msb=function(){return!!(this.hi&2147483648)};jspb.arith.UInt64.prototype.lsb=function(){return!!(this.lo&1)};jspb.arith.UInt64.prototype.zero=function(){return 0==this.lo&&0==this.hi};jspb.arith.UInt64.prototype.add=function(a){return new jspb.arith.UInt64((this.lo+a.lo&4294967295)>>>0>>>0,((this.hi+a.hi&4294967295)>>>0)+(4294967296<=this.lo+a.lo?1:0)>>>0)};
jspb.arith.UInt64.prototype.sub=function(a){return new jspb.arith.UInt64((this.lo-a.lo&4294967295)>>>0>>>0,((this.hi-a.hi&4294967295)>>>0)-(0>this.lo-a.lo?1:0)>>>0)};jspb.arith.UInt64.mul32x32=function(a,b){var c=a&65535;a>>>=16;var d=b&65535,e=b>>>16;b=c*d+65536*(c*e&65535)+65536*(a*d&65535);for(c=a*e+(c*e>>>16)+(a*d>>>16);4294967296<=b;)b-=4294967296,c+=1;return new jspb.arith.UInt64(b>>>0,c>>>0)};
jspb.arith.UInt64.prototype.mul=function(a){var b=jspb.arith.UInt64.mul32x32(this.lo,a);a=jspb.arith.UInt64.mul32x32(this.hi,a);a.hi=a.lo;a.lo=0;return b.add(a)};
jspb.arith.UInt64.prototype.div=function(a){if(0==a)return[];var b=new jspb.arith.UInt64(0,0),c=new jspb.arith.UInt64(this.lo,this.hi);a=new jspb.arith.UInt64(a,0);for(var d=new jspb.arith.UInt64(1,0);!a.msb();)a=a.leftShift(),d=d.leftShift();for(;!d.zero();)0>=a.cmp(c)&&(b=b.add(d),c=c.sub(a)),a=a.rightShift(),d=d.rightShift();return[b,c]};jspb.arith.UInt64.prototype.toString=function(){for(var a="",b=this;!b.zero();){b=b.div(10);var c=b[0];a=b[1].lo+a;b=c}""==a&&(a="0");return a};
jspb.arith.UInt64.fromString=function(a){for(var b=new jspb.arith.UInt64(0,0),c=new jspb.arith.UInt64(0,0),d=0;d<a.length;d++){if("0">a[d]||"9"<a[d])return null;var e=parseInt(a[d],10);c.lo=e;b=b.mul(10).add(c)}return b};jspb.arith.UInt64.prototype.clone=function(){return new jspb.arith.UInt64(this.lo,this.hi)};jspb.arith.Int64=function(a,b){this.lo=a;this.hi=b};
jspb.arith.Int64.prototype.add=function(a){return new jspb.arith.Int64((this.lo+a.lo&4294967295)>>>0>>>0,((this.hi+a.hi&4294967295)>>>0)+(4294967296<=this.lo+a.lo?1:0)>>>0)};jspb.arith.Int64.prototype.sub=function(a){return new jspb.arith.Int64((this.lo-a.lo&4294967295)>>>0>>>0,((this.hi-a.hi&4294967295)>>>0)-(0>this.lo-a.lo?1:0)>>>0)};jspb.arith.Int64.prototype.clone=function(){return new jspb.arith.Int64(this.lo,this.hi)};
jspb.arith.Int64.prototype.toString=function(){var a=0!=(this.hi&2147483648),b=new jspb.arith.UInt64(this.lo,this.hi);a&&(b=(new jspb.arith.UInt64(0,0)).sub(b));return(a?"-":"")+b.toString()};jspb.arith.Int64.fromString=function(a){var b=0<a.length&&"-"==a[0];b&&(a=a.substring(1));a=jspb.arith.UInt64.fromString(a);if(null===a)return null;b&&(a=(new jspb.arith.UInt64(0,0)).sub(a));return new jspb.arith.Int64(a.lo,a.hi)};jspb.BinaryWriter=function(){this.blocks_=[];this.totalLength_=0;this.encoder_=new jspb.BinaryEncoder;this.bookmarks_=[]};jspb.BinaryWriter.prototype.appendUint8Array_=function(a){var b=this.encoder_.end();this.blocks_.push(b);this.blocks_.push(a);this.totalLength_+=b.length+a.length};
jspb.BinaryWriter.prototype.beginDelimited_=function(a){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);a=this.encoder_.end();this.blocks_.push(a);this.totalLength_+=a.length;a.push(this.totalLength_);return a};jspb.BinaryWriter.prototype.endDelimited_=function(a){var b=a.pop();b=this.totalLength_+this.encoder_.length()-b;for(goog.asserts.assert(0<=b);127<b;)a.push(b&127|128),b>>>=7,this.totalLength_++;a.push(b);this.totalLength_++};
jspb.BinaryWriter.prototype.writeSerializedMessage=function(a,b,c){this.appendUint8Array_(a.subarray(b,c))};jspb.BinaryWriter.prototype.maybeWriteSerializedMessage=function(a,b,c){null!=a&&null!=b&&null!=c&&this.writeSerializedMessage(a,b,c)};jspb.BinaryWriter.prototype.reset=function(){this.blocks_=[];this.encoder_.end();this.totalLength_=0;this.bookmarks_=[]};
jspb.BinaryWriter.prototype.getResultBuffer=function(){goog.asserts.assert(0==this.bookmarks_.length);for(var a=new Uint8Array(this.totalLength_+this.encoder_.length()),b=this.blocks_,c=b.length,d=0,e=0;e<c;e++){var f=b[e];a.set(f,d);d+=f.length}b=this.encoder_.end();a.set(b,d);d+=b.length;goog.asserts.assert(d==a.length);this.blocks_=[a];return a};jspb.BinaryWriter.prototype.getResultBase64String=function(a){return goog.crypt.base64.encodeByteArray(this.getResultBuffer(),a)};
jspb.BinaryWriter.prototype.beginSubMessage=function(a){this.bookmarks_.push(this.beginDelimited_(a))};jspb.BinaryWriter.prototype.endSubMessage=function(){goog.asserts.assert(0<=this.bookmarks_.length);this.endDelimited_(this.bookmarks_.pop())};jspb.BinaryWriter.prototype.writeFieldHeader_=function(a,b){goog.asserts.assert(1<=a&&a==Math.floor(a));this.encoder_.writeUnsignedVarint32(8*a+b)};
jspb.BinaryWriter.prototype.writeAny=function(a,b,c){var d=jspb.BinaryConstants.FieldType;switch(a){case d.DOUBLE:this.writeDouble(b,c);break;case d.FLOAT:this.writeFloat(b,c);break;case d.INT64:this.writeInt64(b,c);break;case d.UINT64:this.writeUint64(b,c);break;case d.INT32:this.writeInt32(b,c);break;case d.FIXED64:this.writeFixed64(b,c);break;case d.FIXED32:this.writeFixed32(b,c);break;case d.BOOL:this.writeBool(b,c);break;case d.STRING:this.writeString(b,c);break;case d.GROUP:goog.asserts.fail("Group field type not supported in writeAny()");
break;case d.MESSAGE:goog.asserts.fail("Message field type not supported in writeAny()");break;case d.BYTES:this.writeBytes(b,c);break;case d.UINT32:this.writeUint32(b,c);break;case d.ENUM:this.writeEnum(b,c);break;case d.SFIXED32:this.writeSfixed32(b,c);break;case d.SFIXED64:this.writeSfixed64(b,c);break;case d.SINT32:this.writeSint32(b,c);break;case d.SINT64:this.writeSint64(b,c);break;case d.FHASH64:this.writeFixedHash64(b,c);break;case d.VHASH64:this.writeVarintHash64(b,c);break;default:goog.asserts.fail("Invalid field type in writeAny()")}};
jspb.BinaryWriter.prototype.writeUnsignedVarint32_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeUnsignedVarint32(b))};jspb.BinaryWriter.prototype.writeSignedVarint32_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSignedVarint32(b))};jspb.BinaryWriter.prototype.writeUnsignedVarint64_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeUnsignedVarint64(b))};
jspb.BinaryWriter.prototype.writeSignedVarint64_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSignedVarint64(b))};jspb.BinaryWriter.prototype.writeZigzagVarint32_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeZigzagVarint32(b))};jspb.BinaryWriter.prototype.writeZigzagVarint64_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeZigzagVarint64(b))};
jspb.BinaryWriter.prototype.writeZigzagVarint64String_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeZigzagVarint64String(b))};jspb.BinaryWriter.prototype.writeZigzagVarintHash64_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeZigzagVarintHash64(b))};
jspb.BinaryWriter.prototype.writeInt32=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeSignedVarint32_(a,b))};jspb.BinaryWriter.prototype.writeInt32String=function(a,b){null!=b&&(b=parseInt(b,10),goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeSignedVarint32_(a,b))};
jspb.BinaryWriter.prototype.writeInt64=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_63&&b<jspb.BinaryConstants.TWO_TO_63),this.writeSignedVarint64_(a,b))};jspb.BinaryWriter.prototype.writeInt64String=function(a,b){null!=b&&(b=jspb.arith.Int64.fromString(b),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSplitVarint64(b.lo,b.hi))};
jspb.BinaryWriter.prototype.writeUint32=function(a,b){null!=b&&(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32),this.writeUnsignedVarint32_(a,b))};jspb.BinaryWriter.prototype.writeUint32String=function(a,b){null!=b&&(b=parseInt(b,10),goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32),this.writeUnsignedVarint32_(a,b))};jspb.BinaryWriter.prototype.writeUint64=function(a,b){null!=b&&(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_64),this.writeUnsignedVarint64_(a,b))};
jspb.BinaryWriter.prototype.writeUint64String=function(a,b){null!=b&&(b=jspb.arith.UInt64.fromString(b),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSplitVarint64(b.lo,b.hi))};jspb.BinaryWriter.prototype.writeSint32=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeZigzagVarint32_(a,b))};
jspb.BinaryWriter.prototype.writeSint64=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_63&&b<jspb.BinaryConstants.TWO_TO_63),this.writeZigzagVarint64_(a,b))};jspb.BinaryWriter.prototype.writeSintHash64=function(a,b){null!=b&&this.writeZigzagVarintHash64_(a,b)};jspb.BinaryWriter.prototype.writeSint64String=function(a,b){null!=b&&this.writeZigzagVarint64String_(a,b)};
jspb.BinaryWriter.prototype.writeFixed32=function(a,b){null!=b&&(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED32),this.encoder_.writeUint32(b))};jspb.BinaryWriter.prototype.writeFixed64=function(a,b){null!=b&&(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_64),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeUint64(b))};
jspb.BinaryWriter.prototype.writeFixed64String=function(a,b){null!=b&&(b=jspb.arith.UInt64.fromString(b),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeSplitFixed64(b.lo,b.hi))};jspb.BinaryWriter.prototype.writeSfixed32=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED32),this.encoder_.writeInt32(b))};
jspb.BinaryWriter.prototype.writeSfixed64=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_63&&b<jspb.BinaryConstants.TWO_TO_63),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeInt64(b))};jspb.BinaryWriter.prototype.writeSfixed64String=function(a,b){null!=b&&(b=jspb.arith.Int64.fromString(b),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeSplitFixed64(b.lo,b.hi))};
jspb.BinaryWriter.prototype.writeFloat=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED32),this.encoder_.writeFloat(b))};jspb.BinaryWriter.prototype.writeDouble=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeDouble(b))};
jspb.BinaryWriter.prototype.writeBool=function(a,b){null!=b&&(goog.asserts.assert("boolean"===typeof b||"number"===typeof b),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeBool(b))};jspb.BinaryWriter.prototype.writeEnum=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSignedVarint32(b))};
jspb.BinaryWriter.prototype.writeString=function(a,b){null!=b&&(a=this.beginDelimited_(a),this.encoder_.writeString(b),this.endDelimited_(a))};jspb.BinaryWriter.prototype.writeBytes=function(a,b){null!=b&&(b=jspb.utils.byteSourceToUint8Array(b),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(b.length),this.appendUint8Array_(b))};jspb.BinaryWriter.prototype.writeMessage=function(a,b,c){null!=b&&(a=this.beginDelimited_(a),c(b,this),this.endDelimited_(a))};
jspb.BinaryWriter.prototype.writeMessageSet=function(a,b,c){null!=b&&(this.writeFieldHeader_(1,jspb.BinaryConstants.WireType.START_GROUP),this.writeFieldHeader_(2,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSignedVarint32(a),a=this.beginDelimited_(3),c(b,this),this.endDelimited_(a),this.writeFieldHeader_(1,jspb.BinaryConstants.WireType.END_GROUP))};
jspb.BinaryWriter.prototype.writeGroup=function(a,b,c){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.START_GROUP),c(b,this),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.END_GROUP))};jspb.BinaryWriter.prototype.writeFixedHash64=function(a,b){null!=b&&(goog.asserts.assert(8==b.length),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeFixedHash64(b))};
jspb.BinaryWriter.prototype.writeVarintHash64=function(a,b){null!=b&&(goog.asserts.assert(8==b.length),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeVarintHash64(b))};jspb.BinaryWriter.prototype.writeSplitFixed64=function(a,b,c){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64);this.encoder_.writeSplitFixed64(b,c)};
jspb.BinaryWriter.prototype.writeSplitVarint64=function(a,b,c){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT);this.encoder_.writeSplitVarint64(b,c)};jspb.BinaryWriter.prototype.writeSplitZigzagVarint64=function(a,b,c){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT);var d=this.encoder_;jspb.utils.toZigzag64(b,c,function(a,b){d.writeSplitVarint64(a>>>0,b>>>0)})};
jspb.BinaryWriter.prototype.writeRepeatedInt32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSignedVarint32_(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedInt32String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeInt32String(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedInt64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSignedVarint64_(a,b[c])};
jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64=function(a,b,c,d){if(null!=b)for(var e=0;e<b.length;e++)this.writeSplitFixed64(a,c(b[e]),d(b[e]))};jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64=function(a,b,c,d){if(null!=b)for(var e=0;e<b.length;e++)this.writeSplitVarint64(a,c(b[e]),d(b[e]))};jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64=function(a,b,c,d){if(null!=b)for(var e=0;e<b.length;e++)this.writeSplitZigzagVarint64(a,c(b[e]),d(b[e]))};
jspb.BinaryWriter.prototype.writeRepeatedInt64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeInt64String(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedUint32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeUnsignedVarint32_(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedUint32String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeUint32String(a,b[c])};
jspb.BinaryWriter.prototype.writeRepeatedUint64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeUnsignedVarint64_(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedUint64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeUint64String(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedSint32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeZigzagVarint32_(a,b[c])};
jspb.BinaryWriter.prototype.writeRepeatedSint64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeZigzagVarint64_(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedSint64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeZigzagVarint64String_(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedSintHash64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeZigzagVarintHash64_(a,b[c])};
jspb.BinaryWriter.prototype.writeRepeatedFixed32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFixed32(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedFixed64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFixed64(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedFixed64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFixed64String(a,b[c])};
jspb.BinaryWriter.prototype.writeRepeatedSfixed32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSfixed32(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedSfixed64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSfixed64(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedSfixed64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSfixed64String(a,b[c])};
jspb.BinaryWriter.prototype.writeRepeatedFloat=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFloat(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedDouble=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeDouble(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedBool=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeBool(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedEnum=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeEnum(a,b[c])};
jspb.BinaryWriter.prototype.writeRepeatedString=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeString(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedBytes=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeBytes(a,b[c])};jspb.BinaryWriter.prototype.writeRepeatedMessage=function(a,b,c){if(null!=b)for(var d=0;d<b.length;d++){var e=this.beginDelimited_(a);c(b[d],this);this.endDelimited_(e)}};
jspb.BinaryWriter.prototype.writeRepeatedGroup=function(a,b,c){if(null!=b)for(var d=0;d<b.length;d++)this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.START_GROUP),c(b[d],this),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.END_GROUP)};jspb.BinaryWriter.prototype.writeRepeatedFixedHash64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFixedHash64(a,b[c])};
jspb.BinaryWriter.prototype.writeRepeatedVarintHash64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeVarintHash64(a,b[c])};jspb.BinaryWriter.prototype.writePackedInt32=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeSignedVarint32(b[c]);this.endDelimited_(a)}};
jspb.BinaryWriter.prototype.writePackedInt32String=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeSignedVarint32(parseInt(b[c],10));this.endDelimited_(a)}};jspb.BinaryWriter.prototype.writePackedInt64=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeSignedVarint64(b[c]);this.endDelimited_(a)}};
jspb.BinaryWriter.prototype.writePackedSplitFixed64=function(a,b,c,d){if(null!=b){a=this.beginDelimited_(a);for(var e=0;e<b.length;e++)this.encoder_.writeSplitFixed64(c(b[e]),d(b[e]));this.endDelimited_(a)}};jspb.BinaryWriter.prototype.writePackedSplitVarint64=function(a,b,c,d){if(null!=b){a=this.beginDelimited_(a);for(var e=0;e<b.length;e++)this.encoder_.writeSplitVarint64(c(b[e]),d(b[e]));this.endDelimited_(a)}};
jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64=function(a,b,c,d){if(null!=b){a=this.beginDelimited_(a);for(var e=this.encoder_,f=0;f<b.length;f++)jspb.utils.toZigzag64(c(b[f]),d(b[f]),function(a,b){e.writeSplitVarint64(a>>>0,b>>>0)});this.endDelimited_(a)}};jspb.BinaryWriter.prototype.writePackedInt64String=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++){var d=jspb.arith.Int64.fromString(b[c]);this.encoder_.writeSplitVarint64(d.lo,d.hi)}this.endDelimited_(a)}};
jspb.BinaryWriter.prototype.writePackedUint32=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeUnsignedVarint32(b[c]);this.endDelimited_(a)}};jspb.BinaryWriter.prototype.writePackedUint32String=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeUnsignedVarint32(parseInt(b[c],10));this.endDelimited_(a)}};
jspb.BinaryWriter.prototype.writePackedUint64=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeUnsignedVarint64(b[c]);this.endDelimited_(a)}};jspb.BinaryWriter.prototype.writePackedUint64String=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++){var d=jspb.arith.UInt64.fromString(b[c]);this.encoder_.writeSplitVarint64(d.lo,d.hi)}this.endDelimited_(a)}};
jspb.BinaryWriter.prototype.writePackedSint32=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeZigzagVarint32(b[c]);this.endDelimited_(a)}};jspb.BinaryWriter.prototype.writePackedSint64=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeZigzagVarint64(b[c]);this.endDelimited_(a)}};
jspb.BinaryWriter.prototype.writePackedSint64String=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(b[c]));this.endDelimited_(a)}};jspb.BinaryWriter.prototype.writePackedSintHash64=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeZigzagVarintHash64(b[c]);this.endDelimited_(a)}};
jspb.BinaryWriter.prototype.writePackedFixed32=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(4*b.length),a=0;a<b.length;a++)this.encoder_.writeUint32(b[a])};jspb.BinaryWriter.prototype.writePackedFixed64=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(8*b.length),a=0;a<b.length;a++)this.encoder_.writeUint64(b[a])};
jspb.BinaryWriter.prototype.writePackedFixed64String=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(8*b.length),a=0;a<b.length;a++){var c=jspb.arith.UInt64.fromString(b[a]);this.encoder_.writeSplitFixed64(c.lo,c.hi)}};
jspb.BinaryWriter.prototype.writePackedSfixed32=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(4*b.length),a=0;a<b.length;a++)this.encoder_.writeInt32(b[a])};jspb.BinaryWriter.prototype.writePackedSfixed64=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(8*b.length),a=0;a<b.length;a++)this.encoder_.writeInt64(b[a])};
jspb.BinaryWriter.prototype.writePackedSfixed64String=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(8*b.length),a=0;a<b.length;a++)this.encoder_.writeInt64String(b[a])};jspb.BinaryWriter.prototype.writePackedFloat=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(4*b.length),a=0;a<b.length;a++)this.encoder_.writeFloat(b[a])};
jspb.BinaryWriter.prototype.writePackedDouble=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(8*b.length),a=0;a<b.length;a++)this.encoder_.writeDouble(b[a])};jspb.BinaryWriter.prototype.writePackedBool=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(b.length),a=0;a<b.length;a++)this.encoder_.writeBool(b[a])};
jspb.BinaryWriter.prototype.writePackedEnum=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeEnum(b[c]);this.endDelimited_(a)}};jspb.BinaryWriter.prototype.writePackedFixedHash64=function(a,b){if(null!=b&&b.length)for(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED),this.encoder_.writeUnsignedVarint32(8*b.length),a=0;a<b.length;a++)this.encoder_.writeFixedHash64(b[a])};
jspb.BinaryWriter.prototype.writePackedVarintHash64=function(a,b){if(null!=b&&b.length){a=this.beginDelimited_(a);for(var c=0;c<b.length;c++)this.encoder_.writeVarintHash64(b[c]);this.endDelimited_(a)}};jspb.Map=function(a,b){this.arr_=a;this.valueCtor_=b;this.map_={};this.arrClean=!0;0<this.arr_.length&&this.loadFromArray_()};jspb.Map.prototype.loadFromArray_=function(){for(var a=0;a<this.arr_.length;a++){var b=this.arr_[a],c=b[0];this.map_[c.toString()]=new jspb.Map.Entry_(c,b[1])}this.arrClean=!0};
jspb.Map.prototype.toArray=function(){if(this.arrClean){if(this.valueCtor_){var a=this.map_,b;for(b in a)if(Object.prototype.hasOwnProperty.call(a,b)){var c=a[b].valueWrapper;c&&c.toArray()}}}else{this.arr_.length=0;a=this.stringKeys_();a.sort();for(b=0;b<a.length;b++){var d=this.map_[a[b]];(c=d.valueWrapper)&&c.toArray();this.arr_.push([d.key,d.value])}this.arrClean=!0}return this.arr_};
jspb.Map.prototype.toObject=function(a,b){for(var c=this.toArray(),d=[],e=0;e<c.length;e++){var f=this.map_[c[e][0].toString()];this.wrapEntry_(f);var g=f.valueWrapper;g?(goog.asserts.assert(b),d.push([f.key,b(a,g)])):d.push([f.key,f.value])}return d};jspb.Map.fromObject=function(a,b,c){b=new jspb.Map([],b);for(var d=0;d<a.length;d++){var e=a[d][0],f=c(a[d][1]);b.set(e,f)}return b};jspb.Map.ArrayIteratorIterable_=function(a){this.idx_=0;this.arr_=a};
jspb.Map.ArrayIteratorIterable_.prototype.next=function(){return this.idx_<this.arr_.length?{done:!1,value:this.arr_[this.idx_++]}:{done:!0,value:void 0}};"undefined"!=typeof Symbol&&(jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator]=function(){return this});jspb.Map.prototype.getLength=function(){return this.stringKeys_().length};jspb.Map.prototype.clear=function(){this.map_={};this.arrClean=!1};
jspb.Map.prototype.del=function(a){a=a.toString();var b=this.map_.hasOwnProperty(a);delete this.map_[a];this.arrClean=!1;return b};jspb.Map.prototype.getEntryList=function(){var a=[],b=this.stringKeys_();b.sort();for(var c=0;c<b.length;c++){var d=this.map_[b[c]];a.push([d.key,d.value])}return a};jspb.Map.prototype.entries=function(){var a=[],b=this.stringKeys_();b.sort();for(var c=0;c<b.length;c++){var d=this.map_[b[c]];a.push([d.key,this.wrapEntry_(d)])}return new jspb.Map.ArrayIteratorIterable_(a)};
jspb.Map.prototype.keys=function(){var a=[],b=this.stringKeys_();b.sort();for(var c=0;c<b.length;c++)a.push(this.map_[b[c]].key);return new jspb.Map.ArrayIteratorIterable_(a)};jspb.Map.prototype.values=function(){var a=[],b=this.stringKeys_();b.sort();for(var c=0;c<b.length;c++)a.push(this.wrapEntry_(this.map_[b[c]]));return new jspb.Map.ArrayIteratorIterable_(a)};
jspb.Map.prototype.forEach=function(a,b){var c=this.stringKeys_();c.sort();for(var d=0;d<c.length;d++){var e=this.map_[c[d]];a.call(b,this.wrapEntry_(e),e.key,this)}};jspb.Map.prototype.set=function(a,b){var c=new jspb.Map.Entry_(a);this.valueCtor_?(c.valueWrapper=b,c.value=b.toArray()):c.value=b;this.map_[a.toString()]=c;this.arrClean=!1;return this};jspb.Map.prototype.wrapEntry_=function(a){return this.valueCtor_?(a.valueWrapper||(a.valueWrapper=new this.valueCtor_(a.value)),a.valueWrapper):a.value};
jspb.Map.prototype.get=function(a){if(a=this.map_[a.toString()])return this.wrapEntry_(a)};jspb.Map.prototype.has=function(a){return a.toString()in this.map_};jspb.Map.prototype.serializeBinary=function(a,b,c,d,e){var f=this.stringKeys_();f.sort();for(var g=0;g<f.length;g++){var h=this.map_[f[g]];b.beginSubMessage(a);c.call(b,1,h.key);this.valueCtor_?d.call(b,2,this.wrapEntry_(h),e):d.call(b,2,h.value);b.endSubMessage()}};
jspb.Map.deserializeBinary=function(a,b,c,d,e,f,g){for(;b.nextField()&&!b.isEndGroup();){var h=b.getFieldNumber();1==h?f=c.call(b):2==h&&(a.valueCtor_?(goog.asserts.assert(e),g||(g=new a.valueCtor_),d.call(b,g,e)):g=d.call(b))}goog.asserts.assert(void 0!=f);goog.asserts.assert(void 0!=g);a.set(f,g)};jspb.Map.prototype.stringKeys_=function(){var a=this.map_,b=[],c;for(c in a)Object.prototype.hasOwnProperty.call(a,c)&&b.push(c);return b};
jspb.Map.Entry_=function(a,b){this.key=a;this.value=b;this.valueWrapper=void 0};jspb.ExtensionFieldInfo=function(a,b,c,d,e){this.fieldIndex=a;this.fieldName=b;this.ctor=c;this.toObjectFn=d;this.isRepeated=e};jspb.ExtensionFieldBinaryInfo=function(a,b,c,d,e,f){this.fieldInfo=a;this.binaryReaderFn=b;this.binaryWriterFn=c;this.binaryMessageSerializeFn=d;this.binaryMessageDeserializeFn=e;this.isPacked=f};jspb.ExtensionFieldInfo.prototype.isMessageType=function(){return!!this.ctor};jspb.Message=function(){};jspb.Message.GENERATE_TO_OBJECT=!0;jspb.Message.GENERATE_FROM_OBJECT=!goog.DISALLOW_TEST_ONLY_CODE;
jspb.Message.GENERATE_TO_STRING=!0;jspb.Message.ASSUME_LOCAL_ARRAYS=!1;jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS=!0;jspb.Message.SUPPORTS_UINT8ARRAY_="function"==typeof Uint8Array;jspb.Message.prototype.getJsPbMessageId=function(){return this.messageId_};jspb.Message.getIndex_=function(a,b){return b+a.arrayIndexOffset_};jspb.Message.hiddenES6Property_=function(){};jspb.Message.getFieldNumber_=function(a,b){return b-a.arrayIndexOffset_};
jspb.Message.initialize=function(a,b,c,d,e,f){a.wrappers_=null;b||(b=c?[c]:[]);a.messageId_=c?String(c):void 0;a.arrayIndexOffset_=0===c?-1:0;a.array=b;jspb.Message.initPivotAndExtensionObject_(a,d);a.convertedPrimitiveFields_={};jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS||(a.repeatedFields=e);if(e)for(b=0;b<e.length;b++)c=e[b],c<a.pivot_?(c=jspb.Message.getIndex_(a,c),a.array[c]=a.array[c]||jspb.Message.EMPTY_LIST_SENTINEL_):(jspb.Message.maybeInitEmptyExtensionObject_(a),a.extensionObject_[c]=
a.extensionObject_[c]||jspb.Message.EMPTY_LIST_SENTINEL_);if(f&&f.length)for(b=0;b<f.length;b++)jspb.Message.computeOneofCase(a,f[b])};jspb.Message.EMPTY_LIST_SENTINEL_=goog.DEBUG&&Object.freeze?Object.freeze([]):[];jspb.Message.isArray_=function(a){return jspb.Message.ASSUME_LOCAL_ARRAYS?a instanceof Array:Array.isArray(a)};jspb.Message.isExtensionObject_=function(a){return null!==a&&"object"==typeof a&&!jspb.Message.isArray_(a)&&!(jspb.Message.SUPPORTS_UINT8ARRAY_&&a instanceof Uint8Array)};
jspb.Message.initPivotAndExtensionObject_=function(a,b){var c=a.array.length,d=-1;if(c&&(d=c-1,c=a.array[d],jspb.Message.isExtensionObject_(c))){a.pivot_=jspb.Message.getFieldNumber_(a,d);a.extensionObject_=c;return}-1<b?(a.pivot_=Math.max(b,jspb.Message.getFieldNumber_(a,d+1)),a.extensionObject_=null):a.pivot_=Number.MAX_VALUE};jspb.Message.maybeInitEmptyExtensionObject_=function(a){var b=jspb.Message.getIndex_(a,a.pivot_);a.array[b]||(a.extensionObject_=a.array[b]={})};
jspb.Message.toObjectList=function(a,b,c){for(var d=[],e=0;e<a.length;e++)d[e]=b.call(a[e],c,a[e]);return d};jspb.Message.toObjectExtension=function(a,b,c,d,e){for(var f in c){var g=c[f],h=d.call(a,g);if(null!=h){for(var k in g.fieldName)if(g.fieldName.hasOwnProperty(k))break;b[k]=g.toObjectFn?g.isRepeated?jspb.Message.toObjectList(h,g.toObjectFn,e):g.toObjectFn(e,h):h}}};
jspb.Message.serializeBinaryExtensions=function(a,b,c,d){for(var e in c){var f=c[e],g=f.fieldInfo;if(!f.binaryWriterFn)throw Error("Message extension present that was generated without binary serialization support");var h=d.call(a,g);if(null!=h)if(g.isMessageType())if(f.binaryMessageSerializeFn)f.binaryWriterFn.call(b,g.fieldIndex,h,f.binaryMessageSerializeFn);else throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
else f.binaryWriterFn.call(b,g.fieldIndex,h)}};jspb.Message.readBinaryExtension=function(a,b,c,d,e){var f=c[b.getFieldNumber()];if(f){c=f.fieldInfo;if(!f.binaryReaderFn)throw Error("Deserializing extension whose generated code does not support binary format");if(c.isMessageType()){var g=new c.ctor;f.binaryReaderFn.call(b,g,f.binaryMessageDeserializeFn)}else g=f.binaryReaderFn.call(b);c.isRepeated&&!f.isPacked?(b=d.call(a,c))?b.push(g):e.call(a,c,[g]):e.call(a,c,g)}else b.skipField()};
jspb.Message.getField=function(a,b){if(b<a.pivot_){b=jspb.Message.getIndex_(a,b);var c=a.array[b];return c===jspb.Message.EMPTY_LIST_SENTINEL_?a.array[b]=[]:c}if(a.extensionObject_)return c=a.extensionObject_[b],c===jspb.Message.EMPTY_LIST_SENTINEL_?a.extensionObject_[b]=[]:c};jspb.Message.getRepeatedField=function(a,b){return jspb.Message.getField(a,b)};jspb.Message.getOptionalFloatingPointField=function(a,b){a=jspb.Message.getField(a,b);return null==a?a:+a};
jspb.Message.getBooleanField=function(a,b){a=jspb.Message.getField(a,b);return null==a?a:!!a};jspb.Message.getRepeatedFloatingPointField=function(a,b){var c=jspb.Message.getRepeatedField(a,b);a.convertedPrimitiveFields_||(a.convertedPrimitiveFields_={});if(!a.convertedPrimitiveFields_[b]){for(var d=0;d<c.length;d++)c[d]=+c[d];a.convertedPrimitiveFields_[b]=!0}return c};
jspb.Message.getRepeatedBooleanField=function(a,b){var c=jspb.Message.getRepeatedField(a,b);a.convertedPrimitiveFields_||(a.convertedPrimitiveFields_={});if(!a.convertedPrimitiveFields_[b]){for(var d=0;d<c.length;d++)c[d]=!!c[d];a.convertedPrimitiveFields_[b]=!0}return c};
jspb.Message.bytesAsB64=function(a){if(null==a||"string"===typeof a)return a;if(jspb.Message.SUPPORTS_UINT8ARRAY_&&a instanceof Uint8Array)return goog.crypt.base64.encodeByteArray(a);goog.asserts.fail("Cannot coerce to b64 string: "+goog.typeOf(a));return null};jspb.Message.bytesAsU8=function(a){if(null==a||a instanceof Uint8Array)return a;if("string"===typeof a)return goog.crypt.base64.decodeStringToUint8Array(a);goog.asserts.fail("Cannot coerce to Uint8Array: "+goog.typeOf(a));return null};
jspb.Message.bytesListAsB64=function(a){jspb.Message.assertConsistentTypes_(a);return a.length&&"string"!==typeof a[0]?goog.array.map(a,jspb.Message.bytesAsB64):a};jspb.Message.bytesListAsU8=function(a){jspb.Message.assertConsistentTypes_(a);return!a.length||a[0]instanceof Uint8Array?a:goog.array.map(a,jspb.Message.bytesAsU8)};
jspb.Message.assertConsistentTypes_=function(a){if(goog.DEBUG&&a&&1<a.length){var b=goog.typeOf(a[0]);goog.array.forEach(a,function(a){goog.typeOf(a)!=b&&goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got "+goog.typeOf(a)+" expected "+b)})}};jspb.Message.getFieldWithDefault=function(a,b,c){a=jspb.Message.getField(a,b);return null==a?c:a};jspb.Message.getBooleanFieldWithDefault=function(a,b,c){a=jspb.Message.getBooleanField(a,b);return null==a?c:a};
jspb.Message.getFloatingPointFieldWithDefault=function(a,b,c){a=jspb.Message.getOptionalFloatingPointField(a,b);return null==a?c:a};jspb.Message.getFieldProto3=jspb.Message.getFieldWithDefault;jspb.Message.getMapField=function(a,b,c,d){a.wrappers_||(a.wrappers_={});if(b in a.wrappers_)return a.wrappers_[b];var e=jspb.Message.getField(a,b);if(!e){if(c)return;e=[];jspb.Message.setField(a,b,e)}return a.wrappers_[b]=new jspb.Map(e,d)};
jspb.Message.setField=function(a,b,c){goog.asserts.assertInstanceof(a,jspb.Message);b<a.pivot_?a.array[jspb.Message.getIndex_(a,b)]=c:(jspb.Message.maybeInitEmptyExtensionObject_(a),a.extensionObject_[b]=c);return a};jspb.Message.setProto3IntField=function(a,b,c){return jspb.Message.setFieldIgnoringDefault_(a,b,c,0)};jspb.Message.setProto3FloatField=function(a,b,c){return jspb.Message.setFieldIgnoringDefault_(a,b,c,0)};
jspb.Message.setProto3BooleanField=function(a,b,c){return jspb.Message.setFieldIgnoringDefault_(a,b,c,!1)};jspb.Message.setProto3StringField=function(a,b,c){return jspb.Message.setFieldIgnoringDefault_(a,b,c,"")};jspb.Message.setProto3BytesField=function(a,b,c){return jspb.Message.setFieldIgnoringDefault_(a,b,c,"")};jspb.Message.setProto3EnumField=function(a,b,c){return jspb.Message.setFieldIgnoringDefault_(a,b,c,0)};
jspb.Message.setProto3StringIntField=function(a,b,c){return jspb.Message.setFieldIgnoringDefault_(a,b,c,"0")};jspb.Message.setFieldIgnoringDefault_=function(a,b,c,d){goog.asserts.assertInstanceof(a,jspb.Message);c!==d?jspb.Message.setField(a,b,c):b<a.pivot_?a.array[jspb.Message.getIndex_(a,b)]=null:(jspb.Message.maybeInitEmptyExtensionObject_(a),delete a.extensionObject_[b]);return a};
jspb.Message.addToRepeatedField=function(a,b,c,d){goog.asserts.assertInstanceof(a,jspb.Message);b=jspb.Message.getRepeatedField(a,b);void 0!=d?b.splice(d,0,c):b.push(c);return a};jspb.Message.setOneofField=function(a,b,c,d){goog.asserts.assertInstanceof(a,jspb.Message);(c=jspb.Message.computeOneofCase(a,c))&&c!==b&&void 0!==d&&(a.wrappers_&&c in a.wrappers_&&(a.wrappers_[c]=void 0),jspb.Message.setField(a,c,void 0));return jspb.Message.setField(a,b,d)};
jspb.Message.computeOneofCase=function(a,b){for(var c,d,e=0;e<b.length;e++){var f=b[e],g=jspb.Message.getField(a,f);null!=g&&(c=f,d=g,jspb.Message.setField(a,f,void 0))}return c?(jspb.Message.setField(a,c,d),c):0};jspb.Message.getWrapperField=function(a,b,c,d){a.wrappers_||(a.wrappers_={});if(!a.wrappers_[c]){var e=jspb.Message.getField(a,c);if(d||e)a.wrappers_[c]=new b(e)}return a.wrappers_[c]};
jspb.Message.getRepeatedWrapperField=function(a,b,c){jspb.Message.wrapRepeatedField_(a,b,c);b=a.wrappers_[c];b==jspb.Message.EMPTY_LIST_SENTINEL_&&(b=a.wrappers_[c]=[]);return b};jspb.Message.wrapRepeatedField_=function(a,b,c){a.wrappers_||(a.wrappers_={});if(!a.wrappers_[c]){for(var d=jspb.Message.getRepeatedField(a,c),e=[],f=0;f<d.length;f++)e[f]=new b(d[f]);a.wrappers_[c]=e}};
jspb.Message.setWrapperField=function(a,b,c){goog.asserts.assertInstanceof(a,jspb.Message);a.wrappers_||(a.wrappers_={});var d=c?c.toArray():c;a.wrappers_[b]=c;return jspb.Message.setField(a,b,d)};jspb.Message.setOneofWrapperField=function(a,b,c,d){goog.asserts.assertInstanceof(a,jspb.Message);a.wrappers_||(a.wrappers_={});var e=d?d.toArray():d;a.wrappers_[b]=d;return jspb.Message.setOneofField(a,b,c,e)};
jspb.Message.setRepeatedWrapperField=function(a,b,c){goog.asserts.assertInstanceof(a,jspb.Message);a.wrappers_||(a.wrappers_={});c=c||[];for(var d=[],e=0;e<c.length;e++)d[e]=c[e].toArray();a.wrappers_[b]=c;return jspb.Message.setField(a,b,d)};
jspb.Message.addToRepeatedWrapperField=function(a,b,c,d,e){jspb.Message.wrapRepeatedField_(a,d,b);var f=a.wrappers_[b];f||(f=a.wrappers_[b]=[]);c=c?c:new d;a=jspb.Message.getRepeatedField(a,b);void 0!=e?(f.splice(e,0,c),a.splice(e,0,c.toArray())):(f.push(c),a.push(c.toArray()));return c};jspb.Message.toMap=function(a,b,c,d){for(var e={},f=0;f<a.length;f++)e[b.call(a[f])]=c?c.call(a[f],d,a[f]):a[f];return e};
jspb.Message.prototype.syncMapFields_=function(){if(this.wrappers_)for(var a in this.wrappers_){var b=this.wrappers_[a];if(Array.isArray(b))for(var c=0;c<b.length;c++)b[c]&&b[c].toArray();else b&&b.toArray()}};jspb.Message.prototype.toArray=function(){this.syncMapFields_();return this.array};jspb.Message.GENERATE_TO_STRING&&(jspb.Message.prototype.toString=function(){this.syncMapFields_();return this.array.toString()});
jspb.Message.prototype.getExtension=function(a){if(this.extensionObject_){this.wrappers_||(this.wrappers_={});var b=a.fieldIndex;if(a.isRepeated){if(a.isMessageType())return this.wrappers_[b]||(this.wrappers_[b]=goog.array.map(this.extensionObject_[b]||[],function(b){return new a.ctor(b)})),this.wrappers_[b]}else if(a.isMessageType())return!this.wrappers_[b]&&this.extensionObject_[b]&&(this.wrappers_[b]=new a.ctor(this.extensionObject_[b])),this.wrappers_[b];return this.extensionObject_[b]}};
jspb.Message.prototype.setExtension=function(a,b){this.wrappers_||(this.wrappers_={});jspb.Message.maybeInitEmptyExtensionObject_(this);var c=a.fieldIndex;a.isRepeated?(b=b||[],a.isMessageType()?(this.wrappers_[c]=b,this.extensionObject_[c]=goog.array.map(b,function(a){return a.toArray()})):this.extensionObject_[c]=b):a.isMessageType()?(this.wrappers_[c]=b,this.extensionObject_[c]=b?b.toArray():b):this.extensionObject_[c]=b;return this};
jspb.Message.difference=function(a,b){if(!(a instanceof b.constructor))throw Error("Messages have different types.");var c=a.toArray();b=b.toArray();var d=[],e=0,f=c.length>b.length?c.length:b.length;a.getJsPbMessageId()&&(d[0]=a.getJsPbMessageId(),e=1);for(;e<f;e++)jspb.Message.compareFields(c[e],b[e])||(d[e]=b[e]);return new a.constructor(d)};jspb.Message.equals=function(a,b){return a==b||!(!a||!b)&&a instanceof b.constructor&&jspb.Message.compareFields(a.toArray(),b.toArray())};
jspb.Message.compareExtensions=function(a,b){a=a||{};b=b||{};var c={},d;for(d in a)c[d]=0;for(d in b)c[d]=0;for(d in c)if(!jspb.Message.compareFields(a[d],b[d]))return!1;return!0};
jspb.Message.compareFields=function(a,b){if(a==b)return!0;if(!goog.isObject(a)||!goog.isObject(b))return"number"===typeof a&&isNaN(a)||"number"===typeof b&&isNaN(b)?String(a)==String(b):!1;if(a.constructor!=b.constructor)return!1;if(jspb.Message.SUPPORTS_UINT8ARRAY_&&a.constructor===Uint8Array){if(a.length!=b.length)return!1;for(var c=0;c<a.length;c++)if(a[c]!=b[c])return!1;return!0}if(a.constructor===Array){var d=void 0,e=void 0,f=Math.max(a.length,b.length);for(c=0;c<f;c++){var g=a[c],h=b[c];g&&
g.constructor==Object&&(goog.asserts.assert(void 0===d),goog.asserts.assert(c===a.length-1),d=g,g=void 0);h&&h.constructor==Object&&(goog.asserts.assert(void 0===e),goog.asserts.assert(c===b.length-1),e=h,h=void 0);if(!jspb.Message.compareFields(g,h))return!1}return d||e?(d=d||{},e=e||{},jspb.Message.compareExtensions(d,e)):!0}if(a.constructor===Object)return jspb.Message.compareExtensions(a,b);throw Error("Invalid type in JSPB array");};jspb.Message.prototype.cloneMessage=function(){return jspb.Message.cloneMessage(this)};
jspb.Message.prototype.clone=function(){return jspb.Message.cloneMessage(this)};jspb.Message.clone=function(a){return jspb.Message.cloneMessage(a)};jspb.Message.cloneMessage=function(a){return new a.constructor(jspb.Message.clone_(a.toArray()))};
jspb.Message.copyInto=function(a,b){goog.asserts.assertInstanceof(a,jspb.Message);goog.asserts.assertInstanceof(b,jspb.Message);goog.asserts.assert(a.constructor==b.constructor,"Copy source and target message should have the same type.");a=jspb.Message.clone(a);for(var c=b.toArray(),d=a.toArray(),e=c.length=0;e<d.length;e++)c[e]=d[e];b.wrappers_=a.wrappers_;b.extensionObject_=a.extensionObject_};
jspb.Message.clone_=function(a){if(Array.isArray(a)){for(var b=Array(a.length),c=0;c<a.length;c++){var d=a[c];null!=d&&(b[c]="object"==typeof d?jspb.Message.clone_(goog.asserts.assert(d)):d)}return b}if(jspb.Message.SUPPORTS_UINT8ARRAY_&&a instanceof Uint8Array)return new Uint8Array(a);b={};for(c in a)d=a[c],null!=d&&(b[c]="object"==typeof d?jspb.Message.clone_(goog.asserts.assert(d)):d);return b};jspb.Message.registerMessageType=function(a,b){b.messageId=a};jspb.Message.messageSetExtensions={};
jspb.Message.messageSetExtensionsBinary={};jspb.Export={};exports.Map=jspb.Map;exports.Message=jspb.Message;exports.BinaryReader=jspb.BinaryReader;exports.BinaryWriter=jspb.BinaryWriter;exports.ExtensionFieldInfo=jspb.ExtensionFieldInfo;exports.ExtensionFieldBinaryInfo=jspb.ExtensionFieldBinaryInfo;exports.exportSymbol=goog.exportSymbol;exports.inherits=goog.inherits;exports.object={extend:goog.object.extend};exports.typeOf=goog.typeOf;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)
},{"buffer":2}],4:[function(require,module,exports){
// source: google/protobuf/duration.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.google.protobuf.Duration', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.google.protobuf.Duration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.google.protobuf.Duration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.google.protobuf.Duration.displayName = 'proto.google.protobuf.Duration';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.google.protobuf.Duration.prototype.toObject = function(opt_includeInstance) {
  return proto.google.protobuf.Duration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.Duration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.google.protobuf.Duration.toObject = function(includeInstance, msg) {
  var f, obj = {
    seconds: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nanos: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.Duration}
 */
proto.google.protobuf.Duration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.google.protobuf.Duration;
  return proto.google.protobuf.Duration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.Duration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.Duration}
 */
proto.google.protobuf.Duration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSeconds(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNanos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.google.protobuf.Duration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.google.protobuf.Duration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.Duration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.google.protobuf.Duration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeconds();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNanos();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 seconds = 1;
 * @return {number}
 */
proto.google.protobuf.Duration.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.google.protobuf.Duration} returns this
 */
proto.google.protobuf.Duration.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 nanos = 2;
 * @return {number}
 */
proto.google.protobuf.Duration.prototype.getNanos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.google.protobuf.Duration} returns this
 */
proto.google.protobuf.Duration.prototype.setNanos = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.google.protobuf);

},{"google-protobuf":3}],5:[function(require,module,exports){
// source: google/protobuf/empty.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.google.protobuf.Empty', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.google.protobuf.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.google.protobuf.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.google.protobuf.Empty.displayName = 'proto.google.protobuf.Empty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.google.protobuf.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.google.protobuf.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.google.protobuf.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.Empty}
 */
proto.google.protobuf.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.google.protobuf.Empty;
  return proto.google.protobuf.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.Empty}
 */
proto.google.protobuf.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.google.protobuf.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.google.protobuf.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.google.protobuf.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.google.protobuf);

},{"google-protobuf":3}],6:[function(require,module,exports){
// source: google/protobuf/timestamp.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.google.protobuf.Timestamp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.google.protobuf.Timestamp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.google.protobuf.Timestamp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.google.protobuf.Timestamp.displayName = 'proto.google.protobuf.Timestamp';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.google.protobuf.Timestamp.prototype.toObject = function(opt_includeInstance) {
  return proto.google.protobuf.Timestamp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.Timestamp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.google.protobuf.Timestamp.toObject = function(includeInstance, msg) {
  var f, obj = {
    seconds: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nanos: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.google.protobuf.Timestamp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.google.protobuf.Timestamp;
  return proto.google.protobuf.Timestamp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.Timestamp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.google.protobuf.Timestamp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSeconds(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNanos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.google.protobuf.Timestamp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.google.protobuf.Timestamp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.Timestamp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.google.protobuf.Timestamp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeconds();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNanos();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 seconds = 1;
 * @return {number}
 */
proto.google.protobuf.Timestamp.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.google.protobuf.Timestamp} returns this
 */
proto.google.protobuf.Timestamp.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 nanos = 2;
 * @return {number}
 */
proto.google.protobuf.Timestamp.prototype.getNanos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.google.protobuf.Timestamp} returns this
 */
proto.google.protobuf.Timestamp.prototype.setNanos = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.google.protobuf);
/* This code will be inserted into generated code for
 * google/protobuf/timestamp.proto. */

/**
 * Returns a JavaScript 'Date' object corresponding to this Timestamp.
 * @return {!Date}
 */
proto.google.protobuf.Timestamp.prototype.toDate = function() {
  var seconds = this.getSeconds();
  var nanos = this.getNanos();

  return new Date((seconds * 1000) + (nanos / 1000000));
};


/**
 * Sets the value of this Timestamp object to be the given Date.
 * @param {!Date} value The value to set.
 */
proto.google.protobuf.Timestamp.prototype.fromDate = function(value) {
  this.setSeconds(Math.floor(value.getTime() / 1000));
  this.setNanos(value.getMilliseconds() * 1000000);
};


/**
 * Factory method that returns a Timestamp object with value equal to
 * the given Date.
 * @param {!Date} value The value to set.
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.google.protobuf.Timestamp.fromDate = function(value) {
  var timestamp = new proto.google.protobuf.Timestamp();
  timestamp.fromDate(value);
  return timestamp;
};

},{"google-protobuf":3}],7:[function(require,module,exports){
(function (global){(function (){
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var n;function aa(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var ba="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)};function ca(a){a=["object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global,a];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var r=ca(this);
function t(){t=function(){};r.Symbol||(r.Symbol=da)}function ea(a,b){this.a=a;ba(this,"description",{configurable:!0,writable:!0,value:b})}ea.prototype.toString=function(){return this.a};var da=function(){function a(c){if(this instanceof a)throw new TypeError("Symbol is not a constructor");return new ea("jscomp_symbol_"+(c||"")+"_"+b++,c)}var b=0;return a}();
function u(){t();var a=r.Symbol.iterator;a||(a=r.Symbol.iterator=r.Symbol("Symbol.iterator"));"function"!=typeof Array.prototype[a]&&ba(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return fa(aa(this))}});u=function(){}}function fa(a){u();a={next:a};a[r.Symbol.iterator]=function(){return this};return a}function ha(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:aa(a)}}
var ia="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},ja;if("function"==typeof Object.setPrototypeOf)ja=Object.setPrototypeOf;else{var ka;a:{var la={V:!0},ma={};try{ma.__proto__=la;ka=ma.V;break a}catch(a){}ka=!1}ja=ka?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var na=ja;
function oa(a,b){a.prototype=ia(b.prototype);a.prototype.constructor=a;if(na)na(a,b);else for(var c in b)if("prototype"!=c)if(Object.defineProperties){var d=Object.getOwnPropertyDescriptor(b,c);d&&Object.defineProperty(a,c,d)}else a[c]=b[c];a.O=b.prototype}
function pa(a,b){u();a instanceof String&&(a+="");var c=0,d={next:function(){if(c<a.length){var f=c++;return{value:b(f,a[f]),done:!1}}d.next=function(){return{done:!0,value:void 0}};return d.next()}};d[Symbol.iterator]=function(){return d};return d}function v(a,b){if(b){var c=r;a=a.split(".");for(var d=0;d<a.length-1;d++){var f=a[d];f in c||(c[f]={});c=c[f]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&ba(c,a,{configurable:!0,writable:!0,value:b})}}
v("Array.prototype.keys",function(a){return a?a:function(){return pa(this,function(b){return b})}});v("Array.prototype.find",function(a){return a?a:function(b,c){a:{var d=this;d instanceof String&&(d=String(d));for(var f=d.length,g=0;g<f;g++){var e=d[g];if(b.call(c,e,g,d)){b=e;break a}}b=void 0}return b}});v("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}});
v("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var f=d.length;c=c||0;for(0>c&&(c=Math.max(c+f,0));c<f;c++){var g=d[c];if(g===b||Object.is(g,b))return!0}return!1}});
v("Promise",function(a){function b(e){this.b=0;this.c=void 0;this.a=[];var h=this.f();try{e(h.resolve,h.reject)}catch(k){h.reject(k)}}function c(){this.a=null}function d(e){return e instanceof b?e:new b(function(h){h(e)})}if(a)return a;c.prototype.b=function(e){if(null==this.a){this.a=[];var h=this;this.c(function(){h.g()})}this.a.push(e)};var f=r.setTimeout;c.prototype.c=function(e){f(e,0)};c.prototype.g=function(){for(;this.a&&this.a.length;){var e=this.a;this.a=[];for(var h=0;h<e.length;++h){var k=
e[h];e[h]=null;try{k()}catch(l){this.f(l)}}}this.a=null};c.prototype.f=function(e){this.c(function(){throw e;})};b.prototype.f=function(){function e(l){return function(m){k||(k=!0,l.call(h,m))}}var h=this,k=!1;return{resolve:e(this.s),reject:e(this.g)}};b.prototype.s=function(e){if(e===this)this.g(new TypeError("A Promise cannot resolve to itself"));else if(e instanceof b)this.v(e);else{a:switch(typeof e){case "object":var h=null!=e;break a;case "function":h=!0;break a;default:h=!1}h?this.m(e):this.h(e)}};
b.prototype.m=function(e){var h=void 0;try{h=e.then}catch(k){this.g(k);return}"function"==typeof h?this.w(h,e):this.h(e)};b.prototype.g=function(e){this.i(2,e)};b.prototype.h=function(e){this.i(1,e)};b.prototype.i=function(e,h){if(0!=this.b)throw Error("Cannot settle("+e+", "+h+"): Promise already settled in state"+this.b);this.b=e;this.c=h;this.l()};b.prototype.l=function(){if(null!=this.a){for(var e=0;e<this.a.length;++e)g.b(this.a[e]);this.a=null}};var g=new c;b.prototype.v=function(e){var h=this.f();
e.F(h.resolve,h.reject)};b.prototype.w=function(e,h){var k=this.f();try{e.call(h,k.resolve,k.reject)}catch(l){k.reject(l)}};b.prototype.then=function(e,h){function k(q,x){return"function"==typeof q?function(z){try{l(q(z))}catch(N){m(N)}}:x}var l,m,p=new b(function(q,x){l=q;m=x});this.F(k(e,l),k(h,m));return p};b.prototype.catch=function(e){return this.then(void 0,e)};b.prototype.F=function(e,h){function k(){switch(l.b){case 1:e(l.c);break;case 2:h(l.c);break;default:throw Error("Unexpected state: "+
l.b);}}var l=this;null==this.a?g.b(k):this.a.push(k)};b.resolve=d;b.reject=function(e){return new b(function(h,k){k(e)})};b.race=function(e){return new b(function(h,k){for(var l=ha(e),m=l.next();!m.done;m=l.next())d(m.value).F(h,k)})};b.all=function(e){var h=ha(e),k=h.next();return k.done?d([]):new b(function(l,m){function p(z){return function(N){q[z]=N;x--;0==x&&l(q)}}var q=[],x=0;do q.push(void 0),x++,d(k.value).F(p(q.length-1),m),k=h.next();while(!k.done)})};return b});var qa=qa||{},w=this||self;
function y(a,b){a=a.split(".");b=b||w;for(var c=0;c<a.length;c++)if(b=b[a[c]],null==b)return null;return b}function ra(){}function sa(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ta="closure_uid_"+(1E9*Math.random()>>>0),ua=0;function va(a,b,c){return a.call.apply(a.bind,arguments)}
function wa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var f=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(f,d);return a.apply(b,f)}}return function(){return a.apply(b,arguments)}}function A(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?A=va:A=wa;return A.apply(null,arguments)}
function B(a,b){function c(){}c.prototype=b.prototype;a.O=b.prototype;a.prototype=new c;a.prototype.constructor=a};function xa(a){this.a=a||{}}xa.prototype.get=function(a){return this.a[a]};xa.prototype.G=function(){return Object.keys(this.a)};function C(a,b,c,d){this.f=a;this.c=b;this.b=c;this.a=d}C.prototype.getRequestMessage=function(){return this.f};C.prototype.getMethodDescriptor=function(){return this.c};C.prototype.getMetadata=function(){return this.b};C.prototype.getCallOptions=function(){return this.a};function D(a,b,c,d){c=void 0===c?{}:c;this.c=a;this.a=c;this.b=b;this.f=void 0===d?null:d}D.prototype.getResponseMessage=function(){return this.c};D.prototype.getMetadata=function(){return this.a};D.prototype.getMethodDescriptor=function(){return this.b};D.prototype.getStatus=function(){return this.f};function E(a,b,c,d,f,g){this.name=a;this.a=b;this.f=c;this.b=d;this.c=f;this.g=g}function ya(a,b,c){c=void 0===c?{}:c;var d=void 0===d?new xa:d;return new C(b,a,c,d)}n=E.prototype;n.getName=function(){return this.name};n.getMethodType=function(){return this.a};n.getResponseMessageCtor=function(){return this.b};n.getRequestMessageCtor=function(){return this.f};n.getResponseDeserializeFn=function(){return this.g};n.getRequestSerializeFn=function(){return this.c};E.prototype.getRequestSerializeFn=E.prototype.getRequestSerializeFn;
E.prototype.getResponseDeserializeFn=E.prototype.getResponseDeserializeFn;E.prototype.getRequestMessageCtor=E.prototype.getRequestMessageCtor;E.prototype.getResponseMessageCtor=E.prototype.getResponseMessageCtor;E.prototype.getMethodType=E.prototype.getMethodType;E.prototype.getName=E.prototype.getName;function za(a){switch(a){case 200:return 0;case 400:return 3;case 401:return 16;case 403:return 7;case 404:return 5;case 409:return 10;case 412:return 9;case 429:return 8;case 499:return 1;case 500:return 2;case 501:return 12;case 503:return 14;case 504:return 4;default:return 2}};function F(a,b,c){c=void 0===c?{}:c;b=Error.call(this,b);this.message=b.message;"stack"in b&&(this.stack=b.stack);this.code=a;this.metadata=c}oa(F,Error);F.prototype.name="RpcError";function Aa(a){this.a=a}Aa.prototype.on=function(a,b){return"data"==a||"error"==a?this:this.a.on(a,b)};Aa.prototype.removeListener=function(a,b){return this.a.removeListener(a,b)};Aa.prototype.cancel=function(){this.a.cancel()};function Ba(a){switch(a){case 0:return"No Error";case 1:return"Access denied to content document";case 2:return"File not found";case 3:return"Firefox silently errored";case 4:return"Application custom error";case 5:return"An exception occurred";case 6:return"Http response at 400 or 500 level";case 7:return"Request was aborted";case 8:return"Request timed out";case 9:return"The resource is not available offline";default:return"Unrecognized error code"}};function G(a){if(Error.captureStackTrace)Error.captureStackTrace(this,G);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}B(G,Error);G.prototype.name="CustomError";function Ca(a,b){a=a.split("%s");for(var c="",d=a.length-1,f=0;f<d;f++)c+=a[f]+(f<b.length?b[f]:"%s");G.call(this,c+a[d])}B(Ca,G);Ca.prototype.name="AssertionError";function Da(a,b){throw new Ca("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function Ea(){this.l=null;this.i=[];this.m=0;this.b=Fa;this.f=this.a=this.h=0;this.c=null;this.g=0}
function Ga(a,b){function c(l){l==Ha?e.h=l:l==H?e.h=l:Ia(e,h,k,"invalid frame byte");e.b=Ja;e.a=0;e.f=0}function d(l){e.f++;e.a=(e.a<<8)+l;4==e.f&&(e.b=Ka,e.g=0,"undefined"!==typeof Uint8Array?e.c=new Uint8Array(e.a):e.c=Array(e.a),0==e.a&&g())}function f(l){e.c[e.g++]=l;e.g==e.a&&g()}function g(){var l={};l[e.h]=e.c;e.i.push(l);e.b=Fa}var e=a,h,k=0;for(b instanceof Uint8Array||b instanceof Array?h=b:h=new Uint8Array(b);k<h.length;){switch(e.b){case La:Ia(e,h,k,"stream already broken");break;case Fa:c(h[k]);
break;case Ja:d(h[k]);break;case Ka:f(h[k]);break;default:throw Error("unexpected parser state: "+e.b);}e.m++;k++}a=e.i;e.i=[];return 0<a.length?a:null}var Fa=0,Ja=1,Ka=2,La=3,Ha=0,H=128;function Ia(a,b,c,d){a.b=La;a.l="The stream is broken @"+a.m+"/"+c+". Error: "+d+". With input:\n"+b;throw Error(a.l);};var Ma=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.indexOf(b,0);for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1};var Na=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};function I(a,b){return-1!=a.indexOf(b)}function Oa(a,b){return a<b?-1:a>b?1:0};var J;a:{var Pa=w.navigator;if(Pa){var Qa=Pa.userAgent;if(Qa){J=Qa;break a}}J=""};function Ra(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Sa(a,b){var c={},d;for(d in a)c[d]=b.call(void 0,a[d],d,a);return c}var Ta="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function Ua(a,b){for(var c,d,f=1;f<arguments.length;f++){d=arguments[f];for(c in d)a[c]=d[c];for(var g=0;g<Ta.length;g++)c=Ta[g],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Va(a){var b=1;a=a.split(":");for(var c=[];0<b&&a.length;)c.push(a.shift()),b--;a.length&&c.push(a.join(":"));return c};function Wa(a){Wa[" "](a);return a}Wa[" "]=ra;function Xa(a){var b=Ya;return Object.prototype.hasOwnProperty.call(b,9)?b[9]:b[9]=a(9)};var Za=I(J,"Opera"),$a=I(J,"Trident")||I(J,"MSIE"),ab=I(J,"Edge"),bb=I(J,"Gecko")&&!(I(J.toLowerCase(),"webkit")&&!I(J,"Edge"))&&!(I(J,"Trident")||I(J,"MSIE"))&&!I(J,"Edge"),cb=I(J.toLowerCase(),"webkit")&&!I(J,"Edge"),db;
a:{var eb="",fb=function(){var a=J;if(bb)return/rv:([^\);]+)(\)|;)/.exec(a);if(ab)return/Edge\/([\d\.]+)/.exec(a);if($a)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(cb)return/WebKit\/(\S+)/.exec(a);if(Za)return/(?:Version)[ \/]?(\S+)/.exec(a)}();fb&&(eb=fb?fb[1]:"");if($a){var gb,hb=w.document;gb=hb?hb.documentMode:void 0;if(null!=gb&&gb>parseFloat(eb)){db=String(gb);break a}}db=eb}var Ya={};
function ib(){return Xa(function(){for(var a=0,b=Na(String(db)).split("."),c=Na("9").split("."),d=Math.max(b.length,c.length),f=0;0==a&&f<d;f++){var g=b[f]||"",e=c[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];e=/(\d*)(\D*)(.*)/.exec(e)||["","","",""];if(0==g[0].length&&0==e[0].length)break;a=Oa(0==g[1].length?0:parseInt(g[1],10),0==e[1].length?0:parseInt(e[1],10))||Oa(0==g[2].length,0==e[2].length)||Oa(g[2],e[2]);g=g[3];e=e[3]}while(0==a)}return 0<=a})};function jb(){0!=kb&&(Object.prototype.hasOwnProperty.call(this,ta)&&this[ta]||(this[ta]=++ua));this.K=this.K}var kb=0;jb.prototype.K=!1;var lb=Object.freeze||function(a){return a};function K(a,b){this.type=a;this.a=this.target=b;this.defaultPrevented=!1}K.prototype.b=function(){this.defaultPrevented=!0};var mb=function(){if(!w.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{w.addEventListener("test",ra,b),w.removeEventListener("test",ra,b)}catch(c){}return a}();function L(a,b){K.call(this,a?a.type:"");this.relatedTarget=this.a=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.c=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.a=b;if(b=a.relatedTarget){if(bb){a:{try{Wa(b.nodeName);var f=!0;break a}catch(g){}f=!1}f||(b=null)}}else"mouseover"==
c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType="string"===typeof a.pointerType?a.pointerType:nb[a.pointerType]||"";this.c=a;a.defaultPrevented&&L.O.b.call(this)}}B(L,K);var nb=lb({2:"touch",3:"pen",4:"mouse"});L.prototype.b=function(){L.O.b.call(this);var a=this.c;a.preventDefault?a.preventDefault():a.returnValue=!1};var ob="closure_listenable_"+(1E6*Math.random()|0);var pb=0;function qb(a,b,c,d,f){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.H=f;this.key=++pb;this.A=this.D=!1}function rb(a){a.A=!0;a.listener=null;a.proxy=null;a.src=null;a.H=null};function sb(a){this.src=a;this.a={};this.b=0}sb.prototype.add=function(a,b,c,d,f){var g=a.toString();a=this.a[g];a||(a=this.a[g]=[],this.b++);var e=tb(a,b,d,f);-1<e?(b=a[e],c||(b.D=!1)):(b=new qb(b,this.src,g,!!d,f),b.D=c,a.push(b));return b};sb.prototype.remove=function(a,b,c,d){a=a.toString();if(!(a in this.a))return!1;var f=this.a[a];b=tb(f,b,c,d);return-1<b?(rb(f[b]),Array.prototype.splice.call(f,b,1),0==f.length&&(delete this.a[a],this.b--),!0):!1};
function ub(a,b){var c=b.type;if(c in a.a){var d=a.a[c],f=Ma(d,b),g;(g=0<=f)&&Array.prototype.splice.call(d,f,1);g&&(rb(b),0==a.a[c].length&&(delete a.a[c],a.b--))}}function tb(a,b,c,d){for(var f=0;f<a.length;++f){var g=a[f];if(!g.A&&g.listener==b&&g.capture==!!c&&g.H==d)return f}return-1};var vb="closure_lm_"+(1E6*Math.random()|0),wb={},xb=0;function yb(a,b,c,d,f){if(d&&d.once)zb(a,b,c,d,f);else if(Array.isArray(b))for(var g=0;g<b.length;g++)yb(a,b[g],c,d,f);else c=Ab(c),a&&a[ob]?a.f.add(String(b),c,!1,sa(d)?!!d.capture:!!d,f):Bb(a,b,c,!1,d,f)}
function Bb(a,b,c,d,f,g){if(!b)throw Error("Invalid event type");var e=sa(f)?!!f.capture:!!f,h=Cb(a);h||(a[vb]=h=new sb(a));c=h.add(b,c,d,e,g);if(!c.proxy){d=Db();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)mb||(f=e),void 0===f&&(f=!1),a.addEventListener(b.toString(),d,f);else if(a.attachEvent)a.attachEvent(Eb(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");xb++}}
function Db(){function a(c){return b.call(a.src,a.listener,c)}var b=Fb;return a}function zb(a,b,c,d,f){if(Array.isArray(b))for(var g=0;g<b.length;g++)zb(a,b[g],c,d,f);else c=Ab(c),a&&a[ob]?a.f.add(String(b),c,!0,sa(d)?!!d.capture:!!d,f):Bb(a,b,c,!0,d,f)}
function Gb(a,b,c,d,f){if(Array.isArray(b))for(var g=0;g<b.length;g++)Gb(a,b[g],c,d,f);else(d=sa(d)?!!d.capture:!!d,c=Ab(c),a&&a[ob])?a.f.remove(String(b),c,d,f):a&&(a=Cb(a))&&(b=a.a[b.toString()],a=-1,b&&(a=tb(b,c,d,f)),(c=-1<a?b[a]:null)&&Hb(c))}
function Hb(a){if("number"!==typeof a&&a&&!a.A){var b=a.src;if(b&&b[ob])ub(b.f,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(Eb(c),d):b.addListener&&b.removeListener&&b.removeListener(d);xb--;(c=Cb(b))?(ub(c,a),0==c.b&&(c.src=null,b[vb]=null)):rb(a)}}}function Eb(a){return a in wb?wb[a]:wb[a]="on"+a}function Fb(a,b){if(a.A)a=!0;else{b=new L(b,this);var c=a.listener,d=a.H||a.src;a.D&&Hb(a);a=c.call(d,b)}return a}
function Cb(a){a=a[vb];return a instanceof sb?a:null}var Ib="__closure_events_fn_"+(1E9*Math.random()>>>0);function Ab(a){if("function"===typeof a)return a;a[Ib]||(a[Ib]=function(b){return a.handleEvent(b)});return a[Ib]};function M(){jb.call(this);this.f=new sb(this);this.U=this}B(M,jb);M.prototype[ob]=!0;M.prototype.addEventListener=function(a,b,c,d){yb(this,a,b,c,d)};M.prototype.removeEventListener=function(a,b,c,d){Gb(this,a,b,c,d)};function O(a,b){a=a.U;var c=b.type||b;if("string"===typeof b)b=new K(b,a);else if(b instanceof K)b.target=b.target||a;else{var d=b;b=new K(c,a);Ua(b,d)}a=b.a=a;Jb(a,c,!0,b);Jb(a,c,!1,b)}
function Jb(a,b,c,d){if(b=a.f.a[String(b)]){b=b.concat();for(var f=!0,g=0;g<b.length;++g){var e=b[g];if(e&&!e.A&&e.capture==c){var h=e.listener,k=e.H||e.src;e.D&&ub(a.f,e);f=!1!==h.call(k,d)&&f}}}};var Kb=w;function Lb(a,b,c){if("function"===typeof a)c&&(a=A(a,c));else if(a&&"function"==typeof a.handleEvent)a=A(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:Kb.setTimeout(a,b||0)};function Mb(a,b){this.name=a;this.value=b}Mb.prototype.toString=function(){return this.name};var Nb=new Mb("OFF",Infinity),Ob=new Mb("SEVERE",1E3),Pb=new Mb("CONFIG",700),Qb=new Mb("FINE",500);function Rb(){this.clear()}var Sb;Rb.prototype.clear=function(){};function Ub(a,b,c){this.reset(a||Nb,b,c,void 0,void 0)}Ub.prototype.reset=function(){};function Vb(a,b){this.a=null;this.f=[];this.b=(void 0===b?null:b)||null;this.c=[];this.g={getName:function(){return a}}}
function Wb(a){if(a.a)return a.a;if(a.b)return Wb(a.b);Da("Root logger has no level set.");return Nb}function Xb(a,b){for(;a;)a.f.forEach(function(c){c(b)}),a=a.b}function Yb(){this.entries={};var a=new Vb("");a.a=Pb;this.entries[""]=a}var Zb;function $b(a,b,c){var d=a.entries[b];if(d)return void 0!==c&&(d.a=c),d;d=$b(a,b.substr(0,b.lastIndexOf(".")));var f=new Vb(b,d);a.entries[b]=f;d.c.push(f);void 0!==c&&(f.a=c);return f}function ac(){Zb||(Zb=new Yb);return Zb}
function bc(a,b,c){var d;if(d=a)if(d=a&&b){d=b.value;var f=a?Wb($b(ac(),a.getName())):Nb;d=d>=f.value}d&&(b=b||Nb,d=$b(ac(),a.getName()),"function"===typeof c&&(c=c()),Sb||(Sb=new Rb),a=a.getName(),a=new Ub(b,c,a),Xb(d,a))}function P(a,b){a&&bc(a,Qb,b)};function cc(){}cc.prototype.a=null;function dc(a){var b;(b=a.a)||(b={},ec(a)&&(b[0]=!0,b[1]=!0),b=a.a=b);return b};var fc;function gc(){}B(gc,cc);function hc(a){return(a=ec(a))?new ActiveXObject(a):new XMLHttpRequest}function ec(a){if(!a.b&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.b=d}catch(f){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.b}fc=new gc;t();u();function ic(a,b){this.b=a[w.Symbol.iterator]();this.c=b;this.f=0}ic.prototype[Symbol.iterator]=function(){return this};ic.prototype.next=function(){var a=this.b.next();return{value:a.done?void 0:this.c.call(void 0,a.value,this.f++),done:a.done}};function jc(a,b){return new ic(a,b)}t();u();t();u();var kc="StopIteration"in w?w.StopIteration:{message:"StopIteration",stack:""};function Q(){}Q.prototype.next=function(){return Q.prototype.a.call(this)};Q.prototype.a=function(){throw kc;};Q.prototype.u=function(){return this};function lc(a){if(a instanceof R||a instanceof S||a instanceof T)return a;if("function"==typeof a.next)return new R(function(){return mc(a)});t();u();if("function"==typeof a[Symbol.iterator])return t(),u(),new R(function(){return a[Symbol.iterator]()});if("function"==typeof a.u)return new R(function(){return mc(a.u())});throw Error("Not an iterator or iterable.");}
function mc(a){if(!(a instanceof Q))return a;var b=!1;return{next:function(){for(var c;!b;)try{c=a.a();break}catch(d){if(d!==kc)throw d;b=!0}return{value:c,done:b}}}}t();u();function R(a){this.b=a}R.prototype.u=function(){return new S(this.b())};R.prototype[Symbol.iterator]=function(){return new T(this.b())};R.prototype.c=function(){return new T(this.b())};t();u();function S(a){this.b=a}oa(S,Q);S.prototype.a=function(){var a=this.b.next();if(a.done)throw kc;return a.value};S.prototype.next=function(){return S.prototype.a.call(this)};
S.prototype[Symbol.iterator]=function(){return new T(this.b)};S.prototype.c=function(){return new T(this.b)};function T(a){R.call(this,function(){return a});this.f=a}oa(T,R);T.prototype.next=function(){return this.f.next()};function nc(a,b){this.o={};this.j=[];this.B=this.size=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)}n=nc.prototype;n.G=function(){oc(this);return this.j.concat()};n.has=function(a){return U(this.o,a)};n.clear=function(){this.o={};this.B=this.size=this.j.length=0};n.remove=function(a){return this.delete(a)};
n.delete=function(a){return U(this.o,a)?(delete this.o[a],--this.size,this.B++,this.j.length>2*this.size&&oc(this),!0):!1};function oc(a){if(a.size!=a.j.length){for(var b=0,c=0;b<a.j.length;){var d=a.j[b];U(a.o,d)&&(a.j[c++]=d);b++}a.j.length=c}if(a.size!=a.j.length){var f={};for(c=b=0;b<a.j.length;)d=a.j[b],U(f,d)||(a.j[c++]=d,f[d]=1),b++;a.j.length=c}}n.get=function(a,b){return U(this.o,a)?this.o[a]:b};n.set=function(a,b){U(this.o,a)||(this.size+=1,this.j.push(a),this.B++);this.o[a]=b};
n.addAll=function(a){if(a instanceof nc)for(var b=a.G(),c=0;c<b.length;c++)this.set(b[c],a.get(b[c]));else for(b in a)this.set(b,a[b])};n.forEach=function(a,b){for(var c=this.G(),d=0;d<c.length;d++){var f=c[d],g=this.get(f);a.call(b,g,f,this)}};n.clone=function(){return new nc(this)};n.keys=function(){return lc(this.u(!0)).c()};n.values=function(){return lc(this.u(!1)).c()};n.entries=function(){var a=this;return jc(this.keys(),function(b){return[b,a.get(b)]})};
n.u=function(a){oc(this);var b=0,c=this.B,d=this,f=new Q;f.a=function(){if(c!=d.B)throw Error("The map has changed since the iterator was created");if(b>=d.j.length)throw kc;var g=d.j[b++];return a?g:d.o[g]};f.next=f.a.bind(f);return f};function U(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var pc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function qc(a){M.call(this);this.headers=new nc;this.C=a||null;this.c=!1;this.J=this.a=null;this.P=this.v="";this.g=0;this.l="";this.i=this.N=this.s=this.L=!1;this.h=0;this.w=null;this.m=rc;this.I=this.M=!1}B(qc,M);var rc="";qc.prototype.b=$b(ac(),"goog.net.XhrIo",void 0).g;var sc=/^https?$/i,tc=["POST","PUT"];
function uc(a,b,c){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.v+"; newUri="+b);a.v=b;a.l="";a.g=0;a.P="POST";a.L=!1;a.c=!0;a.a=a.C?hc(a.C):hc(fc);a.J=a.C?dc(a.C):dc(fc);a.a.onreadystatechange=A(a.R,a);try{P(a.b,V(a,"Opening Xhr")),a.N=!0,a.a.open("POST",String(b),!0),a.N=!1}catch(g){P(a.b,V(a,"Error opening Xhr: "+g.message));vc(a,g);return}b=c||"";c=a.headers.clone();var d=c.G().find(function(g){return"content-type"==g.toLowerCase()}),f=w.FormData&&b instanceof
w.FormData;!(0<=Ma(tc,"POST"))||d||f||c.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");c.forEach(function(g,e){this.a.setRequestHeader(e,g)},a);a.m&&(a.a.responseType=a.m);"withCredentials"in a.a&&a.a.withCredentials!==a.M&&(a.a.withCredentials=a.M);try{wc(a),0<a.h&&(a.I=xc(a.a),P(a.b,V(a,"Will abort after "+a.h+"ms if incomplete, xhr2 "+a.I)),a.I?(a.a.timeout=a.h,a.a.ontimeout=A(a.T,a)):a.w=Lb(a.T,a.h,a)),P(a.b,V(a,"Sending request")),a.s=!0,a.a.send(b),a.s=!1}catch(g){P(a.b,
V(a,"Send error: "+g.message)),vc(a,g)}}function xc(a){return $a&&ib()&&"number"===typeof a.timeout&&void 0!==a.ontimeout}n=qc.prototype;n.T=function(){"undefined"!=typeof qa&&this.a&&(this.l="Timed out after "+this.h+"ms, aborting",this.g=8,P(this.b,V(this,this.l)),O(this,"timeout"),this.abort(8))};function vc(a,b){a.c=!1;a.a&&(a.i=!0,a.a.abort(),a.i=!1);a.l=b;a.g=5;yc(a);zc(a)}function yc(a){a.L||(a.L=!0,O(a,"complete"),O(a,"error"))}
n.abort=function(a){this.a&&this.c&&(P(this.b,V(this,"Aborting")),this.c=!1,this.i=!0,this.a.abort(),this.i=!1,this.g=a||7,O(this,"complete"),O(this,"abort"),zc(this))};n.R=function(){this.K||(this.N||this.s||this.i?Ac(this):this.W())};n.W=function(){Ac(this)};
function Ac(a){if(a.c&&"undefined"!=typeof qa)if(a.J[1]&&4==W(a)&&2==a.getStatus())P(a.b,V(a,"Local request error detected and ignored"));else if(a.s&&4==W(a))Lb(a.R,0,a);else if(O(a,"readystatechange"),4==W(a)){P(a.b,V(a,"Request complete"));a.c=!1;try{var b=a.getStatus();a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var f;if(f=0===b){var g=String(a.v).match(pc)[1]||null;if(!g&&w.self&&w.self.location){var e=w.self.location.protocol;
g=e.substr(0,e.length-1)}f=!sc.test(g?g.toLowerCase():"")}d=f}if(d)O(a,"complete"),O(a,"success");else{a.g=6;try{var h=2<W(a)?a.a.statusText:""}catch(k){P(a.b,"Can not get status: "+k.message),h=""}a.l=h+" ["+a.getStatus()+"]";yc(a)}}finally{zc(a)}}}function zc(a){if(a.a){wc(a);var b=a.a,c=a.J[0]?ra:null;a.a=null;a.J=null;O(a,"ready");try{b.onreadystatechange=c}catch(d){(a=a.b)&&bc(a,Ob,"Problem encountered resetting onreadystatechange: "+d.message)}}}
function wc(a){a.a&&a.I&&(a.a.ontimeout=null);a.w&&(Kb.clearTimeout(a.w),a.w=null)}function W(a){return a.a?a.a.readyState:0}n.getStatus=function(){try{return 2<W(this)?this.a.status:-1}catch(a){return-1}};
function Bc(a){try{if(!a.a)return null;if("response"in a.a)return a.a.response;switch(a.m){case rc:case "text":return a.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in a.a)return a.a.mozResponseArrayBuffer}var b=a.b;b&&bc(b,Ob,"Response type "+a.m+" is not supported on this browser");return null}catch(c){return P(a.b,"Can not get response: "+c.message),null}}function Cc(a,b){if(a.a&&4==W(a))return a=a.a.getResponseHeader(b),null===a?void 0:a}
function Dc(a){var b={};a=(a.a&&4==W(a)?a.a.getAllResponseHeaders()||"":"").split("\r\n");for(var c=0;c<a.length;c++)if(!/^[\s\xa0]*$/.test(a[c])){var d=Va(a[c]),f=d[0];d=d[1];if("string"===typeof d){d=d.trim();var g=b[f]||[];b[f]=g;g.push(d)}}return Sa(b,function(e){return e.join(", ")})}function V(a,b){return b+" ["+a.P+" "+a.v+" "+a.getStatus()+"]"};var Ec={},Fc=null;function Gc(a){var b=a.length,c=3*b/4;c%3?c=Math.floor(c):I("=.",a[b-1])&&(c=I("=.",a[b-2])?c-2:c-1);var d=new Uint8Array(c),f=0;Hc(a,function(g){d[f++]=g});return d.subarray(0,f)}
function Hc(a,b){function c(k){for(;d<a.length;){var l=a.charAt(d++),m=Fc[l];if(null!=m)return m;if(!/^[\s\xa0]*$/.test(l))throw Error("Unknown base64 encoding at char: "+l);}return k}Ic();for(var d=0;;){var f=c(-1),g=c(0),e=c(64),h=c(64);if(64===h&&-1===f)break;b(f<<2|g>>4);64!=e&&(b(g<<4&240|e>>2),64!=h&&b(e<<6&192|h))}}
function Ic(){if(!Fc){Fc={};for(var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),b=["+/=","+/","-_=","-_.","-_"],c=0;5>c;c++){var d=a.concat(b[c].split(""));Ec[c]=d;for(var f=0;f<d.length;f++){var g=d[f];void 0===Fc[g]&&(Fc[g]=f)}}}};var Jc=["content-type","grpc-status","grpc-message"];
function X(a){this.a=a.Z;this.m=null;this.b=[];this.h=[];this.g=[];this.f=[];this.c=[];this.l=!1;this.i=0;this.s=new Ea;var b=this;yb(this.a,"readystatechange",function(){var c=b.a;if(c=c.a?c.a.getResponseHeader("Content-Type"):null){c=c.toLowerCase();if(0==c.lastIndexOf("application/grpc-web-text",0)){c=b.a;try{var d=c.a?c.a.responseText:""}catch(k){P(c.b,"Can not get responseText: "+k.message),d=""}c=d||"";d=c.length-c.length%4;c=c.substr(b.i,d-b.i);if(0==c.length)return;b.i=d;c=Gc(c)}else if(0==
c.lastIndexOf("application/grpc",0))c=new Uint8Array(Bc(b.a));else{Y(b,new F(2,"Unknown Content-type received."));return}d=null;try{d=Ga(b.s,c)}catch(k){Y(b,new F(2,"Error in parsing response body"))}if(d)for(c=0;c<d.length;c++){if(Ha in d[c]){var f=d[c][Ha];if(f){var g=void 0;try{g=b.m(f)}catch(k){Y(b,new F(13,"Error when deserializing response data; error: "+k+(", response: "+g)))}if(g){f=b;for(var e=0;e<f.b.length;e++)f.b[e](g)}}}if(H in d[c]&&0<d[c][H].length){f="";for(g=0;g<d[c][H].length;g++)f+=
String.fromCharCode(d[c][H][g]);f=f.trim().split("\r\n");g={};for(e=0;e<f.length;e++){var h=f[e].indexOf(":");g[f[e].substring(0,h).trim()]=f[e].substring(h+1).trim()}f=g;g=0;e="";"grpc-status"in f&&(g=Number(f["grpc-status"]),delete f["grpc-status"]);"grpc-message"in f&&(e=f["grpc-message"],delete f["grpc-message"]);Y(b,new F(g,e,f))}}}});yb(this.a,"complete",function(){var c=b.a.g,d=2,f="",g={},e=Dc(b.a);Object.keys(e).forEach(function(h){Jc.includes(h)||(g[h]=e[h])});Kc(b,g);if(0!=c){switch(c){case 7:d=
10;break;case 8:d=4;break;case 6:d=za(b.a.getStatus());break;default:d=14}10==d&&b.l||Y(b,new F(d,Ba(c)))}else c=!1,"grpc-status"in e&&(d=Number(Cc(b.a,"grpc-status")),"grpc-message"in e&&(f=Cc(b.a,"grpc-message")),0!=d&&(Y(b,new F(d,f||"",e)),c=!0)),c||Lc(b)})}X.prototype.on=function(a,b){"data"==a?this.b.push(b):"status"==a?this.h.push(b):"metadata"==a?this.g.push(b):"end"==a?this.c.push(b):"error"==a&&this.f.push(b);return this};function Mc(a,b){b=a.indexOf(b);-1<b&&a.splice(b,1)}
X.prototype.removeListener=function(a,b){"data"==a?Mc(this.b,b):"status"==a?Mc(this.h,b):"metadata"==a?Mc(this.g,b):"end"==a?Mc(this.c,b):"error"==a&&Mc(this.f,b);return this};X.prototype.cancel=function(){this.l=!0;this.a.abort()};function Y(a,b){if(0!=b.code)for(var c=new F(b.code,decodeURIComponent(b.message||""),b.metadata),d=0;d<a.f.length;d++)a.f[d](c);b={code:b.code,details:decodeURIComponent(b.message||""),metadata:b.metadata};for(c=0;c<a.h.length;c++)a.h[c](b)}
function Kc(a,b){for(var c=0;c<a.g.length;c++)a.g[c](b)}function Lc(a){for(var b=0;b<a.c.length;b++)a.c[b]()}X.prototype.cancel=X.prototype.cancel;X.prototype.removeListener=X.prototype.removeListener;X.prototype.on=X.prototype.on;function Nc(a){var b="";Ra(a,function(c,d){b+=d;b+=":";b+=c;b+="\r\n"});return b};function Z(a,b){a=void 0===a?{}:a;this.a=a.format||y("format",a)||"text";this.g=a.aa||y("suppressCorsPreflight",a)||!1;this.f=a.withCredentials||y("withCredentials",a)||!1;this.b=a.$||y("streamInterceptors",a)||[];this.h=a.ba||y("unaryInterceptors",a)||[];this.c=b||null}Z.prototype.X=function(a,b,c,d,f){var g=this,e=a.substr(0,a.length-d.name.length);a=Oc(function(h){return Pc(g,h,e)},this.b).call(this,ya(d,b,c));Qc(a,f,!1);return new Aa(a)};
Z.prototype.S=function(a,b,c,d){var f=this,g=a.substr(0,a.length-d.name.length);return Oc(function(e){return new Promise(function(h,k){var l=Pc(f,e,g),m,p,q;Qc(l,function(x,z,N,Tb){x?k(x):z?q=z:N?p=N:Tb?m=Tb:(x=e.getMethodDescriptor(),z=m,z=void 0===z?{}:z,h(new D(q,x,z,void 0===p?null:p)))},!0)})},this.h).call(this,ya(d,b,c)).then(function(e){return e.getResponseMessage()})};Z.prototype.unaryCall=function(a,b,c,d){return this.S(a,b,c,d)};
Z.prototype.Y=function(a,b,c,d){var f=this,g=a.substr(0,a.length-d.name.length);return Oc(function(e){return Pc(f,e,g)},this.b).call(this,ya(d,b,c))};
function Pc(a,b,c){var d=b.getMethodDescriptor(),f=c+d.getName();c=a.c?a.c:new qc;c.M=a.f;var g=new X({Z:c}),e=d.getResponseDeserializeFn();g.m=e;e=b.getMetadata();for(var h in e)c.headers.set(h,e[h]);"text"==a.a?(c.headers.set("Content-Type","application/grpc-web-text"),c.headers.set("Accept","application/grpc-web-text")):c.headers.set("Content-Type","application/grpc-web+proto");c.headers.set("X-User-Agent","grpc-web-javascript/0.1");c.headers.set("X-Grpc-Web","1");c.headers.has("deadline")&&(h=
Number(c.headers.get("deadline")),h=Math.ceil(h-(new Date).getTime()),c.headers.delete("deadline"),Infinity===h&&(h=0),0<h&&(c.headers.set("grpc-timeout",h+"m"),c.h=Math.max(0,Math.max(1E3,Math.ceil(1.1*h)))));if(a.g){e=c.headers;h={};for(var k=ha(e.keys()),l=k.next();!l.done;l=k.next())l=l.value,h[l]=e.get(l);c.headers.clear();b:{for(m in h){var m=!1;break b}m=!0}if(!m)if(h=Nc(h),"string"===typeof f){if(m=encodeURIComponent("$httpHeaders"),h=null!=h?"="+encodeURIComponent(String(h)):"",m+=h)h=f.indexOf("#"),
0>h&&(h=f.length),e=f.indexOf("?"),0>e||e>h?(e=h,k=""):k=f.substring(e+1,h),f=[f.substr(0,e),k,f.substr(h)],h=f[1],f[1]=m?h?h+"&"+m:m:h,f=f[0]+(f[1]?"?"+f[1]:"")+f[2]}else f.a("$httpHeaders",h)}b=d.getRequestSerializeFn()(b.getRequestMessage());d=b.length;m=[0,0,0,0];h=new Uint8Array(5+d);for(e=3;0<=e;e--)m[e]=d%256,d>>>=8;h.set(new Uint8Array(m),1);h.set(b,5);b=h;if("text"==a.a){a=b;var p;void 0===p&&(p=0);Ic();p=Ec[p];b=Array(Math.floor(a.length/3));d=p[64]||"";for(m=h=0;h<a.length-2;h+=3){l=a[h];
var q=a[h+1];k=a[h+2];e=p[l>>2];l=p[(l&3)<<4|q>>4];q=p[(q&15)<<2|k>>6];k=p[k&63];b[m++]=e+l+q+k}e=0;k=d;switch(a.length-h){case 2:e=a[h+1],k=p[(e&15)<<2]||d;case 1:a=a[h],b[m]=p[a>>2]+p[(a&3)<<4|e>>4]+k+d}b=b.join("")}else"binary"==a.a&&(c.m="arraybuffer");uc(c,f,b);return g}
function Qc(a,b,c){var d=!1,f=null,g=!1;a.on("data",function(e){d=!0;f=e});a.on("error",function(e){0==e.code||g||(g=!0,b(e,null))});a.on("status",function(e){0==e.code||g?c&&b(null,null,e):(g=!0,b({code:e.code,message:e.details,metadata:e.metadata},null))});if(c)a.on("metadata",function(e){b(null,null,null,e)});a.on("end",function(){g||(d?b(null,f):b({code:2,message:"Incomplete response"}));c&&b(null,null)})}
function Oc(a,b){var c=a;b.forEach(function(d){var f=c;c=function(g){return d.intercept(g,f)}});return c}Z.prototype.serverStreaming=Z.prototype.Y;Z.prototype.unaryCall=Z.prototype.unaryCall;Z.prototype.thenableCall=Z.prototype.S;Z.prototype.rpcCall=Z.prototype.X;module.exports.CallOptions=xa;module.exports.MethodDescriptor=E;module.exports.GrpcWebClientBase=Z;module.exports.RpcError=F;module.exports.StatusCode={OK:0,CANCELLED:1,UNKNOWN:2,INVALID_ARGUMENT:3,DEADLINE_EXCEEDED:4,NOT_FOUND:5,ALREADY_EXISTS:6,PERMISSION_DENIED:7,UNAUTHENTICATED:16,RESOURCE_EXHAUSTED:8,FAILED_PRECONDITION:9,ABORTED:10,OUT_OF_RANGE:11,UNIMPLEMENTED:12,INTERNAL:13,UNAVAILABLE:14,DATA_LOSS:15};module.exports.MethodType={UNARY:"unary",SERVER_STREAMING:"server_streaming",BIDI_STREAMING:"bidi_streaming"};
Kb="undefined"!==typeof globalThis&&globalThis||self;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],8:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],9:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for attendance
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.attendance = require('./attendance_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.attendance.ProgressClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.attendance.ProgressPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.attendance.Attend.Request,
 *   !proto.attendance.Attend.Response>}
 */
const methodDescriptor_Progress_Attend = new grpc.web.MethodDescriptor(
  '/attendance.Progress/Attend',
  grpc.web.MethodType.UNARY,
  proto.attendance.Attend.Request,
  proto.attendance.Attend.Response,
  /**
   * @param {!proto.attendance.Attend.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.attendance.Attend.Response.deserializeBinary
);


/**
 * @param {!proto.attendance.Attend.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.attendance.Attend.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.attendance.Attend.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.attendance.ProgressClient.prototype.attend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/attendance.Progress/Attend',
      request,
      metadata || {},
      methodDescriptor_Progress_Attend,
      callback);
};


/**
 * @param {!proto.attendance.Attend.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.attendance.Attend.Response>}
 *     Promise that resolves to the response
 */
proto.attendance.ProgressPromiseClient.prototype.attend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/attendance.Progress/Attend',
      request,
      metadata || {},
      methodDescriptor_Progress_Attend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.attendance.Reward.Request,
 *   !proto.attendance.Reward.Response>}
 */
const methodDescriptor_Progress_Reward = new grpc.web.MethodDescriptor(
  '/attendance.Progress/Reward',
  grpc.web.MethodType.UNARY,
  proto.attendance.Reward.Request,
  proto.attendance.Reward.Response,
  /**
   * @param {!proto.attendance.Reward.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.attendance.Reward.Response.deserializeBinary
);


/**
 * @param {!proto.attendance.Reward.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.attendance.Reward.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.attendance.Reward.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.attendance.ProgressClient.prototype.reward =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/attendance.Progress/Reward',
      request,
      metadata || {},
      methodDescriptor_Progress_Reward,
      callback);
};


/**
 * @param {!proto.attendance.Reward.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.attendance.Reward.Response>}
 *     Promise that resolves to the response
 */
proto.attendance.ProgressPromiseClient.prototype.reward =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/attendance.Progress/Reward',
      request,
      metadata || {},
      methodDescriptor_Progress_Reward);
};


module.exports = proto.attendance;


},{"./attendance_pb.js":10,"grpc-web":7}],10:[function(require,module,exports){
// source: attendance.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.attendance.Attend', null, global);
goog.exportSymbol('proto.attendance.Attend.Request', null, global);
goog.exportSymbol('proto.attendance.Attend.Response', null, global);
goog.exportSymbol('proto.attendance.Coins', null, global);
goog.exportSymbol('proto.attendance.Day', null, global);
goog.exportSymbol('proto.attendance.Day.RewardCase', null, global);
goog.exportSymbol('proto.attendance.Day.Status', null, global);
goog.exportSymbol('proto.attendance.Inventory', null, global);
goog.exportSymbol('proto.attendance.Reward', null, global);
goog.exportSymbol('proto.attendance.Reward.Request', null, global);
goog.exportSymbol('proto.attendance.Reward.Response', null, global);
goog.exportSymbol('proto.attendance.UUID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attendance.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.UUID.displayName = 'proto.attendance.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Coins = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attendance.Coins, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Coins.displayName = 'proto.attendance.Coins';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Inventory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attendance.Inventory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Inventory.displayName = 'proto.attendance.Inventory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Day = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.attendance.Day.oneofGroups_);
};
goog.inherits(proto.attendance.Day, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Day.displayName = 'proto.attendance.Day';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Attend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attendance.Attend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Attend.displayName = 'proto.attendance.Attend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Attend.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attendance.Attend.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Attend.Request.displayName = 'proto.attendance.Attend.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Attend.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attendance.Attend.Response.repeatedFields_, null);
};
goog.inherits(proto.attendance.Attend.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Attend.Response.displayName = 'proto.attendance.Attend.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Reward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attendance.Reward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Reward.displayName = 'proto.attendance.Reward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Reward.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.attendance.Reward.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Reward.Request.displayName = 'proto.attendance.Reward.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.attendance.Reward.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.attendance.Reward.Response.repeatedFields_, null);
};
goog.inherits(proto.attendance.Reward.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.attendance.Reward.Response.displayName = 'proto.attendance.Reward.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.UUID}
 */
proto.attendance.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.UUID;
  return proto.attendance.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.UUID}
 */
proto.attendance.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.attendance.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.attendance.UUID} returns this
 */
proto.attendance.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Coins.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Coins.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Coins} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Coins.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Coins}
 */
proto.attendance.Coins.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Coins;
  return proto.attendance.Coins.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Coins} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Coins}
 */
proto.attendance.Coins.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Coins.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Coins.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Coins} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Coins.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 amount = 1;
 * @return {number}
 */
proto.attendance.Coins.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.attendance.Coins} returns this
 */
proto.attendance.Coins.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Inventory.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Inventory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Inventory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Inventory.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: (f = msg.getItemId()) && proto.attendance.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Inventory}
 */
proto.attendance.Inventory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Inventory;
  return proto.attendance.Inventory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Inventory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Inventory}
 */
proto.attendance.Inventory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attendance.UUID;
      reader.readMessage(value,proto.attendance.UUID.deserializeBinaryFromReader);
      msg.setItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Inventory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Inventory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Inventory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Inventory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.attendance.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID item_id = 1;
 * @return {?proto.attendance.UUID}
 */
proto.attendance.Inventory.prototype.getItemId = function() {
  return /** @type{?proto.attendance.UUID} */ (
    jspb.Message.getWrapperField(this, proto.attendance.UUID, 1));
};


/**
 * @param {?proto.attendance.UUID|undefined} value
 * @return {!proto.attendance.Inventory} returns this
*/
proto.attendance.Inventory.prototype.setItemId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attendance.Inventory} returns this
 */
proto.attendance.Inventory.prototype.clearItemId = function() {
  return this.setItemId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attendance.Inventory.prototype.hasItemId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.attendance.Day.oneofGroups_ = [[3,4]];

/**
 * @enum {number}
 */
proto.attendance.Day.RewardCase = {
  REWARD_NOT_SET: 0,
  COINS: 3,
  INVENTORY: 4
};

/**
 * @return {proto.attendance.Day.RewardCase}
 */
proto.attendance.Day.prototype.getRewardCase = function() {
  return /** @type {proto.attendance.Day.RewardCase} */(jspb.Message.computeOneofCase(this, proto.attendance.Day.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Day.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Day.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Day} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Day.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    coins: (f = msg.getCoins()) && proto.attendance.Coins.toObject(includeInstance, f),
    inventory: (f = msg.getInventory()) && proto.attendance.Inventory.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Day}
 */
proto.attendance.Day.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Day;
  return proto.attendance.Day.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Day} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Day}
 */
proto.attendance.Day.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.attendance.Day.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = new proto.attendance.Coins;
      reader.readMessage(value,proto.attendance.Coins.deserializeBinaryFromReader);
      msg.setCoins(value);
      break;
    case 4:
      var value = new proto.attendance.Inventory;
      reader.readMessage(value,proto.attendance.Inventory.deserializeBinaryFromReader);
      msg.setInventory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Day.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Day.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Day} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Day.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCoins();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.attendance.Coins.serializeBinaryToWriter
    );
  }
  f = message.getInventory();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.attendance.Inventory.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.attendance.Day.Status = {
  NONE: 0,
  REWARDED: 1,
  VISITED: 2
};

/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.attendance.Day.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.attendance.Day} returns this
 */
proto.attendance.Day.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Status status = 2;
 * @return {!proto.attendance.Day.Status}
 */
proto.attendance.Day.prototype.getStatus = function() {
  return /** @type {!proto.attendance.Day.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.attendance.Day.Status} value
 * @return {!proto.attendance.Day} returns this
 */
proto.attendance.Day.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Coins coins = 3;
 * @return {?proto.attendance.Coins}
 */
proto.attendance.Day.prototype.getCoins = function() {
  return /** @type{?proto.attendance.Coins} */ (
    jspb.Message.getWrapperField(this, proto.attendance.Coins, 3));
};


/**
 * @param {?proto.attendance.Coins|undefined} value
 * @return {!proto.attendance.Day} returns this
*/
proto.attendance.Day.prototype.setCoins = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.attendance.Day.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attendance.Day} returns this
 */
proto.attendance.Day.prototype.clearCoins = function() {
  return this.setCoins(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attendance.Day.prototype.hasCoins = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Inventory inventory = 4;
 * @return {?proto.attendance.Inventory}
 */
proto.attendance.Day.prototype.getInventory = function() {
  return /** @type{?proto.attendance.Inventory} */ (
    jspb.Message.getWrapperField(this, proto.attendance.Inventory, 4));
};


/**
 * @param {?proto.attendance.Inventory|undefined} value
 * @return {!proto.attendance.Day} returns this
*/
proto.attendance.Day.prototype.setInventory = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.attendance.Day.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.attendance.Day} returns this
 */
proto.attendance.Day.prototype.clearInventory = function() {
  return this.setInventory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.attendance.Day.prototype.hasInventory = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Attend.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Attend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Attend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Attend.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Attend}
 */
proto.attendance.Attend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Attend;
  return proto.attendance.Attend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Attend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Attend}
 */
proto.attendance.Attend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Attend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Attend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Attend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Attend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Attend.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Attend.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Attend.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Attend.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Attend.Request}
 */
proto.attendance.Attend.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Attend.Request;
  return proto.attendance.Attend.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Attend.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Attend.Request}
 */
proto.attendance.Attend.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Attend.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Attend.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Attend.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Attend.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attendance.Attend.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Attend.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Attend.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Attend.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Attend.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    daysList: jspb.Message.toObjectList(msg.getDaysList(),
    proto.attendance.Day.toObject, includeInstance),
    timeoutSeconds: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Attend.Response}
 */
proto.attendance.Attend.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Attend.Response;
  return proto.attendance.Attend.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Attend.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Attend.Response}
 */
proto.attendance.Attend.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attendance.Day;
      reader.readMessage(value,proto.attendance.Day.deserializeBinaryFromReader);
      msg.addDays(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimeoutSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Attend.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Attend.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Attend.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Attend.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attendance.Day.serializeBinaryToWriter
    );
  }
  f = message.getTimeoutSeconds();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * repeated Day days = 1;
 * @return {!Array<!proto.attendance.Day>}
 */
proto.attendance.Attend.Response.prototype.getDaysList = function() {
  return /** @type{!Array<!proto.attendance.Day>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attendance.Day, 1));
};


/**
 * @param {!Array<!proto.attendance.Day>} value
 * @return {!proto.attendance.Attend.Response} returns this
*/
proto.attendance.Attend.Response.prototype.setDaysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attendance.Day=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attendance.Day}
 */
proto.attendance.Attend.Response.prototype.addDays = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attendance.Day, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attendance.Attend.Response} returns this
 */
proto.attendance.Attend.Response.prototype.clearDaysList = function() {
  return this.setDaysList([]);
};


/**
 * optional uint64 timeout_seconds = 2;
 * @return {number}
 */
proto.attendance.Attend.Response.prototype.getTimeoutSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.attendance.Attend.Response} returns this
 */
proto.attendance.Attend.Response.prototype.setTimeoutSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Reward.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Reward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Reward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Reward.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Reward}
 */
proto.attendance.Reward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Reward;
  return proto.attendance.Reward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Reward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Reward}
 */
proto.attendance.Reward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Reward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Reward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Reward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Reward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Reward.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Reward.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Reward.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Reward.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Reward.Request}
 */
proto.attendance.Reward.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Reward.Request;
  return proto.attendance.Reward.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Reward.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Reward.Request}
 */
proto.attendance.Reward.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Reward.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Reward.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Reward.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Reward.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.attendance.Reward.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.attendance.Reward.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.attendance.Reward.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.attendance.Reward.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Reward.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    daysList: jspb.Message.toObjectList(msg.getDaysList(),
    proto.attendance.Day.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.attendance.Reward.Response}
 */
proto.attendance.Reward.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.attendance.Reward.Response;
  return proto.attendance.Reward.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.attendance.Reward.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.attendance.Reward.Response}
 */
proto.attendance.Reward.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.attendance.Day;
      reader.readMessage(value,proto.attendance.Day.deserializeBinaryFromReader);
      msg.addDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.attendance.Reward.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.attendance.Reward.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.attendance.Reward.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.attendance.Reward.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.attendance.Day.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Day days = 1;
 * @return {!Array<!proto.attendance.Day>}
 */
proto.attendance.Reward.Response.prototype.getDaysList = function() {
  return /** @type{!Array<!proto.attendance.Day>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.attendance.Day, 1));
};


/**
 * @param {!Array<!proto.attendance.Day>} value
 * @return {!proto.attendance.Reward.Response} returns this
*/
proto.attendance.Reward.Response.prototype.setDaysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.attendance.Day=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attendance.Day}
 */
proto.attendance.Reward.Response.prototype.addDays = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.attendance.Day, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.attendance.Reward.Response} returns this
 */
proto.attendance.Reward.Response.prototype.clearDaysList = function() {
  return this.setDaysList([]);
};


goog.object.extend(exports, proto.attendance);

},{"google-protobuf":3}],11:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for public.cgs
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')
const proto = {};
proto.public = {};
proto.public.cgs = require('./cgs_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.cgs.TokensClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.cgs.TokensPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.cgs.GetToken.Request,
 *   !proto.public.cgs.GetToken.Response>}
 */
const methodDescriptor_Tokens_Get = new grpc.web.MethodDescriptor(
  '/public.cgs.Tokens/Get',
  grpc.web.MethodType.UNARY,
  proto.public.cgs.GetToken.Request,
  proto.public.cgs.GetToken.Response,
  /**
   * @param {!proto.public.cgs.GetToken.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.cgs.GetToken.Response.deserializeBinary
);


/**
 * @param {!proto.public.cgs.GetToken.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.cgs.GetToken.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.cgs.GetToken.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.cgs.TokensClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.cgs.Tokens/Get',
      request,
      metadata || {},
      methodDescriptor_Tokens_Get,
      callback);
};


/**
 * @param {!proto.public.cgs.GetToken.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.cgs.GetToken.Response>}
 *     Promise that resolves to the response
 */
proto.public.cgs.TokensPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.cgs.Tokens/Get',
      request,
      metadata || {},
      methodDescriptor_Tokens_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.cgs.GetTokenMetadata.Request,
 *   !proto.public.cgs.GetTokenMetadata.Response>}
 */
const methodDescriptor_Tokens_GetMetadata = new grpc.web.MethodDescriptor(
  '/public.cgs.Tokens/GetMetadata',
  grpc.web.MethodType.UNARY,
  proto.public.cgs.GetTokenMetadata.Request,
  proto.public.cgs.GetTokenMetadata.Response,
  /**
   * @param {!proto.public.cgs.GetTokenMetadata.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.cgs.GetTokenMetadata.Response.deserializeBinary
);


/**
 * @param {!proto.public.cgs.GetTokenMetadata.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.cgs.GetTokenMetadata.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.cgs.GetTokenMetadata.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.cgs.TokensClient.prototype.getMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.cgs.Tokens/GetMetadata',
      request,
      metadata || {},
      methodDescriptor_Tokens_GetMetadata,
      callback);
};


/**
 * @param {!proto.public.cgs.GetTokenMetadata.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.cgs.GetTokenMetadata.Response>}
 *     Promise that resolves to the response
 */
proto.public.cgs.TokensPromiseClient.prototype.getMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.cgs.Tokens/GetMetadata',
      request,
      metadata || {},
      methodDescriptor_Tokens_GetMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.cgs.GetConfigDescription.Request,
 *   !proto.public.cgs.GetConfigDescription.Response>}
 */
const methodDescriptor_Tokens_GetConfigDescription = new grpc.web.MethodDescriptor(
  '/public.cgs.Tokens/GetConfigDescription',
  grpc.web.MethodType.UNARY,
  proto.public.cgs.GetConfigDescription.Request,
  proto.public.cgs.GetConfigDescription.Response,
  /**
   * @param {!proto.public.cgs.GetConfigDescription.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.cgs.GetConfigDescription.Response.deserializeBinary
);


/**
 * @param {!proto.public.cgs.GetConfigDescription.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.cgs.GetConfigDescription.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.cgs.GetConfigDescription.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.cgs.TokensClient.prototype.getConfigDescription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.cgs.Tokens/GetConfigDescription',
      request,
      metadata || {},
      methodDescriptor_Tokens_GetConfigDescription,
      callback);
};


/**
 * @param {!proto.public.cgs.GetConfigDescription.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.cgs.GetConfigDescription.Response>}
 *     Promise that resolves to the response
 */
proto.public.cgs.TokensPromiseClient.prototype.getConfigDescription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.cgs.Tokens/GetConfigDescription',
      request,
      metadata || {},
      methodDescriptor_Tokens_GetConfigDescription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.cgs.BatchGetTokens.Request,
 *   !proto.public.cgs.BatchGetTokens.Response>}
 */
const methodDescriptor_Tokens_BatchGetTokens = new grpc.web.MethodDescriptor(
  '/public.cgs.Tokens/BatchGetTokens',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.public.cgs.BatchGetTokens.Request,
  proto.public.cgs.BatchGetTokens.Response,
  /**
   * @param {!proto.public.cgs.BatchGetTokens.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.cgs.BatchGetTokens.Response.deserializeBinary
);


/**
 * @param {!proto.public.cgs.BatchGetTokens.Request} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.public.cgs.BatchGetTokens.Response>}
 *     The XHR Node Readable Stream
 */
proto.public.cgs.TokensClient.prototype.batchGetTokens =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/public.cgs.Tokens/BatchGetTokens',
      request,
      metadata || {},
      methodDescriptor_Tokens_BatchGetTokens);
};


/**
 * @param {!proto.public.cgs.BatchGetTokens.Request} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.public.cgs.BatchGetTokens.Response>}
 *     The XHR Node Readable Stream
 */
proto.public.cgs.TokensPromiseClient.prototype.batchGetTokens =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/public.cgs.Tokens/BatchGetTokens',
      request,
      metadata || {},
      methodDescriptor_Tokens_BatchGetTokens);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.cgs.BatchGetConfigDescriptions.Request,
 *   !proto.public.cgs.BatchGetConfigDescriptions.Response>}
 */
const methodDescriptor_Tokens_BatchGetConfigDescriptions = new grpc.web.MethodDescriptor(
  '/public.cgs.Tokens/BatchGetConfigDescriptions',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.public.cgs.BatchGetConfigDescriptions.Request,
  proto.public.cgs.BatchGetConfigDescriptions.Response,
  /**
   * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.cgs.BatchGetConfigDescriptions.Response.deserializeBinary
);


/**
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.public.cgs.BatchGetConfigDescriptions.Response>}
 *     The XHR Node Readable Stream
 */
proto.public.cgs.TokensClient.prototype.batchGetConfigDescriptions =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/public.cgs.Tokens/BatchGetConfigDescriptions',
      request,
      metadata || {},
      methodDescriptor_Tokens_BatchGetConfigDescriptions);
};


/**
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.public.cgs.BatchGetConfigDescriptions.Response>}
 *     The XHR Node Readable Stream
 */
proto.public.cgs.TokensPromiseClient.prototype.batchGetConfigDescriptions =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/public.cgs.Tokens/BatchGetConfigDescriptions',
      request,
      metadata || {},
      methodDescriptor_Tokens_BatchGetConfigDescriptions);
};


module.exports = proto.public.cgs;


},{"../validate/validate_pb.js":13,"./cgs_pb.js":12,"grpc-web":7}],12:[function(require,module,exports){
// source: public/cgs.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.public.cgs.Asset', null, global);
goog.exportSymbol('proto.public.cgs.Asset.Skeleton', null, global);
goog.exportSymbol('proto.public.cgs.BatchGetConfigDescriptions', null, global);
goog.exportSymbol('proto.public.cgs.BatchGetConfigDescriptions.Request', null, global);
goog.exportSymbol('proto.public.cgs.BatchGetConfigDescriptions.Request.Filter', null, global);
goog.exportSymbol('proto.public.cgs.BatchGetConfigDescriptions.Response', null, global);
goog.exportSymbol('proto.public.cgs.BatchGetTokens', null, global);
goog.exportSymbol('proto.public.cgs.BatchGetTokens.Request', null, global);
goog.exportSymbol('proto.public.cgs.BatchGetTokens.Request.Filter', null, global);
goog.exportSymbol('proto.public.cgs.BatchGetTokens.Response', null, global);
goog.exportSymbol('proto.public.cgs.ConfigDescription', null, global);
goog.exportSymbol('proto.public.cgs.ConfigDescription.Key', null, global);
goog.exportSymbol('proto.public.cgs.GetConfigDescription', null, global);
goog.exportSymbol('proto.public.cgs.GetConfigDescription.Request', null, global);
goog.exportSymbol('proto.public.cgs.GetConfigDescription.Response', null, global);
goog.exportSymbol('proto.public.cgs.GetToken', null, global);
goog.exportSymbol('proto.public.cgs.GetToken.Request', null, global);
goog.exportSymbol('proto.public.cgs.GetToken.Response', null, global);
goog.exportSymbol('proto.public.cgs.GetTokenMetadata', null, global);
goog.exportSymbol('proto.public.cgs.GetTokenMetadata.Request', null, global);
goog.exportSymbol('proto.public.cgs.GetTokenMetadata.Response', null, global);
goog.exportSymbol('proto.public.cgs.Material', null, global);
goog.exportSymbol('proto.public.cgs.Metadata', null, global);
goog.exportSymbol('proto.public.cgs.Metadata.Attribute', null, global);
goog.exportSymbol('proto.public.cgs.Metadata.Attribute.ValueCase', null, global);
goog.exportSymbol('proto.public.cgs.Metadata.Collection', null, global);
goog.exportSymbol('proto.public.cgs.Metadata.Image', null, global);
goog.exportSymbol('proto.public.cgs.Metadata.Properties', null, global);
goog.exportSymbol('proto.public.cgs.Progress', null, global);
goog.exportSymbol('proto.public.cgs.Rarity', null, global);
goog.exportSymbol('proto.public.cgs.Token', null, global);
goog.exportSymbol('proto.public.cgs.Token.Category', null, global);
goog.exportSymbol('proto.public.cgs.Token.DropType', null, global);
goog.exportSymbol('proto.public.cgs.Token.Type', null, global);
goog.exportSymbol('proto.public.cgs.UUID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetToken.displayName = 'proto.public.cgs.GetToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetToken.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetToken.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetToken.Request.displayName = 'proto.public.cgs.GetToken.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetToken.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetToken.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetToken.Response.displayName = 'proto.public.cgs.GetToken.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.BatchGetTokens = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.BatchGetTokens, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.BatchGetTokens.displayName = 'proto.public.cgs.BatchGetTokens';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.BatchGetTokens.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.cgs.BatchGetTokens.Request.repeatedFields_, null);
};
goog.inherits(proto.public.cgs.BatchGetTokens.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.BatchGetTokens.Request.displayName = 'proto.public.cgs.BatchGetTokens.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.BatchGetTokens.Request.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.cgs.BatchGetTokens.Request.Filter.repeatedFields_, null);
};
goog.inherits(proto.public.cgs.BatchGetTokens.Request.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.BatchGetTokens.Request.Filter.displayName = 'proto.public.cgs.BatchGetTokens.Request.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.BatchGetTokens.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.BatchGetTokens.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.BatchGetTokens.Response.displayName = 'proto.public.cgs.BatchGetTokens.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetTokenMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetTokenMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetTokenMetadata.displayName = 'proto.public.cgs.GetTokenMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetTokenMetadata.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetTokenMetadata.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetTokenMetadata.Request.displayName = 'proto.public.cgs.GetTokenMetadata.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetTokenMetadata.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetTokenMetadata.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetTokenMetadata.Response.displayName = 'proto.public.cgs.GetTokenMetadata.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetConfigDescription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetConfigDescription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetConfigDescription.displayName = 'proto.public.cgs.GetConfigDescription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetConfigDescription.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetConfigDescription.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetConfigDescription.Request.displayName = 'proto.public.cgs.GetConfigDescription.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.GetConfigDescription.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.GetConfigDescription.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.GetConfigDescription.Response.displayName = 'proto.public.cgs.GetConfigDescription.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.BatchGetConfigDescriptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.BatchGetConfigDescriptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.BatchGetConfigDescriptions.displayName = 'proto.public.cgs.BatchGetConfigDescriptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.BatchGetConfigDescriptions.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.cgs.BatchGetConfigDescriptions.Request.repeatedFields_, null);
};
goog.inherits(proto.public.cgs.BatchGetConfigDescriptions.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.BatchGetConfigDescriptions.Request.displayName = 'proto.public.cgs.BatchGetConfigDescriptions.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.repeatedFields_, null);
};
goog.inherits(proto.public.cgs.BatchGetConfigDescriptions.Request.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.displayName = 'proto.public.cgs.BatchGetConfigDescriptions.Request.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.BatchGetConfigDescriptions.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.BatchGetConfigDescriptions.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.BatchGetConfigDescriptions.Response.displayName = 'proto.public.cgs.BatchGetConfigDescriptions.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.ConfigDescription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.ConfigDescription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.ConfigDescription.displayName = 'proto.public.cgs.ConfigDescription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.ConfigDescription.Key = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.ConfigDescription.Key, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.ConfigDescription.Key.displayName = 'proto.public.cgs.ConfigDescription.Key';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.UUID.displayName = 'proto.public.cgs.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Token = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.cgs.Token.repeatedFields_, null);
};
goog.inherits(proto.public.cgs.Token, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Token.displayName = 'proto.public.cgs.Token';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Progress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.Progress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Progress.displayName = 'proto.public.cgs.Progress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Asset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.Asset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Asset.displayName = 'proto.public.cgs.Asset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Material = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.Material, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Material.displayName = 'proto.public.cgs.Material';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Metadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.cgs.Metadata.repeatedFields_, null);
};
goog.inherits(proto.public.cgs.Metadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Metadata.displayName = 'proto.public.cgs.Metadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Metadata.Attribute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.public.cgs.Metadata.Attribute.oneofGroups_);
};
goog.inherits(proto.public.cgs.Metadata.Attribute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Metadata.Attribute.displayName = 'proto.public.cgs.Metadata.Attribute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Metadata.Collection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.Metadata.Collection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Metadata.Collection.displayName = 'proto.public.cgs.Metadata.Collection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Metadata.Properties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.Metadata.Properties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Metadata.Properties.displayName = 'proto.public.cgs.Metadata.Properties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.cgs.Metadata.Image = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.cgs.Metadata.Image, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.cgs.Metadata.Image.displayName = 'proto.public.cgs.Metadata.Image';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetToken.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetToken.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetToken}
 */
proto.public.cgs.GetToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetToken;
  return proto.public.cgs.GetToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetToken}
 */
proto.public.cgs.GetToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetToken.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetToken.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetToken.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetToken.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    tokenId: (f = msg.getTokenId()) && proto.public.cgs.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetToken.Request}
 */
proto.public.cgs.GetToken.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetToken.Request;
  return proto.public.cgs.GetToken.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetToken.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetToken.Request}
 */
proto.public.cgs.GetToken.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.UUID;
      reader.readMessage(value,proto.public.cgs.UUID.deserializeBinaryFromReader);
      msg.setTokenId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetToken.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetToken.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetToken.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetToken.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTokenId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.cgs.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID token_id = 1;
 * @return {?proto.public.cgs.UUID}
 */
proto.public.cgs.GetToken.Request.prototype.getTokenId = function() {
  return /** @type{?proto.public.cgs.UUID} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.UUID, 1));
};


/**
 * @param {?proto.public.cgs.UUID|undefined} value
 * @return {!proto.public.cgs.GetToken.Request} returns this
*/
proto.public.cgs.GetToken.Request.prototype.setTokenId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.GetToken.Request} returns this
 */
proto.public.cgs.GetToken.Request.prototype.clearTokenId = function() {
  return this.setTokenId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.GetToken.Request.prototype.hasTokenId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetToken.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetToken.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetToken.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetToken.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: (f = msg.getToken()) && proto.public.cgs.Token.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetToken.Response}
 */
proto.public.cgs.GetToken.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetToken.Response;
  return proto.public.cgs.GetToken.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetToken.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetToken.Response}
 */
proto.public.cgs.GetToken.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.Token;
      reader.readMessage(value,proto.public.cgs.Token.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetToken.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetToken.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetToken.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetToken.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.cgs.Token.serializeBinaryToWriter
    );
  }
};


/**
 * optional Token token = 1;
 * @return {?proto.public.cgs.Token}
 */
proto.public.cgs.GetToken.Response.prototype.getToken = function() {
  return /** @type{?proto.public.cgs.Token} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Token, 1));
};


/**
 * @param {?proto.public.cgs.Token|undefined} value
 * @return {!proto.public.cgs.GetToken.Response} returns this
*/
proto.public.cgs.GetToken.Response.prototype.setToken = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.GetToken.Response} returns this
 */
proto.public.cgs.GetToken.Response.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.GetToken.Response.prototype.hasToken = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.BatchGetTokens.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.BatchGetTokens.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.BatchGetTokens} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetTokens.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.BatchGetTokens}
 */
proto.public.cgs.BatchGetTokens.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.BatchGetTokens;
  return proto.public.cgs.BatchGetTokens.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.BatchGetTokens} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.BatchGetTokens}
 */
proto.public.cgs.BatchGetTokens.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.BatchGetTokens.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.BatchGetTokens.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.BatchGetTokens} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetTokens.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.cgs.BatchGetTokens.Request.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.BatchGetTokens.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.BatchGetTokens.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.BatchGetTokens.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetTokens.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    tokenIdsList: jspb.Message.toObjectList(msg.getTokenIdsList(),
    proto.public.cgs.UUID.toObject, includeInstance),
    filter: (f = msg.getFilter()) && proto.public.cgs.BatchGetTokens.Request.Filter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.BatchGetTokens.Request}
 */
proto.public.cgs.BatchGetTokens.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.BatchGetTokens.Request;
  return proto.public.cgs.BatchGetTokens.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.BatchGetTokens.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.BatchGetTokens.Request}
 */
proto.public.cgs.BatchGetTokens.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.UUID;
      reader.readMessage(value,proto.public.cgs.UUID.deserializeBinaryFromReader);
      msg.addTokenIds(value);
      break;
    case 2:
      var value = new proto.public.cgs.BatchGetTokens.Request.Filter;
      reader.readMessage(value,proto.public.cgs.BatchGetTokens.Request.Filter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.BatchGetTokens.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.BatchGetTokens.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.BatchGetTokens.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetTokens.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTokenIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.public.cgs.UUID.serializeBinaryToWriter
    );
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.cgs.BatchGetTokens.Request.Filter.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.cgs.BatchGetTokens.Request.Filter.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.BatchGetTokens.Request.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.BatchGetTokens.Request.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetTokens.Request.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    typesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    dropTypesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter}
 */
proto.public.cgs.BatchGetTokens.Request.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.BatchGetTokens.Request.Filter;
  return proto.public.cgs.BatchGetTokens.Request.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.BatchGetTokens.Request.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter}
 */
proto.public.cgs.BatchGetTokens.Request.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.public.cgs.Token.Type>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTypes(values[i]);
      }
      break;
    case 2:
      var values = /** @type {!Array<!proto.public.cgs.Token.Category>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCategories(values[i]);
      }
      break;
    case 3:
      var values = /** @type {!Array<!proto.public.cgs.Token.DropType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDropTypes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.BatchGetTokens.Request.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.BatchGetTokens.Request.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetTokens.Request.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getDropTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * repeated Token.Type types = 1;
 * @return {!Array<!proto.public.cgs.Token.Type>}
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.getTypesList = function() {
  return /** @type {!Array<!proto.public.cgs.Token.Type>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.public.cgs.Token.Type>} value
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.public.cgs.Token.Type} value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};


/**
 * repeated Token.Category categories = 2;
 * @return {!Array<!proto.public.cgs.Token.Category>}
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.getCategoriesList = function() {
  return /** @type {!Array<!proto.public.cgs.Token.Category>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.public.cgs.Token.Category>} value
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.public.cgs.Token.Category} value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * repeated Token.DropType drop_types = 3;
 * @return {!Array<!proto.public.cgs.Token.DropType>}
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.getDropTypesList = function() {
  return /** @type {!Array<!proto.public.cgs.Token.DropType>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.public.cgs.Token.DropType>} value
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.setDropTypesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.public.cgs.Token.DropType} value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.addDropTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.BatchGetTokens.Request.Filter} returns this
 */
proto.public.cgs.BatchGetTokens.Request.Filter.prototype.clearDropTypesList = function() {
  return this.setDropTypesList([]);
};


/**
 * repeated UUID token_ids = 1;
 * @return {!Array<!proto.public.cgs.UUID>}
 */
proto.public.cgs.BatchGetTokens.Request.prototype.getTokenIdsList = function() {
  return /** @type{!Array<!proto.public.cgs.UUID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.cgs.UUID, 1));
};


/**
 * @param {!Array<!proto.public.cgs.UUID>} value
 * @return {!proto.public.cgs.BatchGetTokens.Request} returns this
*/
proto.public.cgs.BatchGetTokens.Request.prototype.setTokenIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.public.cgs.UUID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.UUID}
 */
proto.public.cgs.BatchGetTokens.Request.prototype.addTokenIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.public.cgs.UUID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.BatchGetTokens.Request} returns this
 */
proto.public.cgs.BatchGetTokens.Request.prototype.clearTokenIdsList = function() {
  return this.setTokenIdsList([]);
};


/**
 * optional Filter filter = 2;
 * @return {?proto.public.cgs.BatchGetTokens.Request.Filter}
 */
proto.public.cgs.BatchGetTokens.Request.prototype.getFilter = function() {
  return /** @type{?proto.public.cgs.BatchGetTokens.Request.Filter} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.BatchGetTokens.Request.Filter, 2));
};


/**
 * @param {?proto.public.cgs.BatchGetTokens.Request.Filter|undefined} value
 * @return {!proto.public.cgs.BatchGetTokens.Request} returns this
*/
proto.public.cgs.BatchGetTokens.Request.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.BatchGetTokens.Request} returns this
 */
proto.public.cgs.BatchGetTokens.Request.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.BatchGetTokens.Request.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.BatchGetTokens.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.BatchGetTokens.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.BatchGetTokens.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetTokens.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: (f = msg.getToken()) && proto.public.cgs.Token.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.BatchGetTokens.Response}
 */
proto.public.cgs.BatchGetTokens.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.BatchGetTokens.Response;
  return proto.public.cgs.BatchGetTokens.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.BatchGetTokens.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.BatchGetTokens.Response}
 */
proto.public.cgs.BatchGetTokens.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.Token;
      reader.readMessage(value,proto.public.cgs.Token.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.BatchGetTokens.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.BatchGetTokens.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.BatchGetTokens.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetTokens.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.cgs.Token.serializeBinaryToWriter
    );
  }
};


/**
 * optional Token token = 1;
 * @return {?proto.public.cgs.Token}
 */
proto.public.cgs.BatchGetTokens.Response.prototype.getToken = function() {
  return /** @type{?proto.public.cgs.Token} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Token, 1));
};


/**
 * @param {?proto.public.cgs.Token|undefined} value
 * @return {!proto.public.cgs.BatchGetTokens.Response} returns this
*/
proto.public.cgs.BatchGetTokens.Response.prototype.setToken = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.BatchGetTokens.Response} returns this
 */
proto.public.cgs.BatchGetTokens.Response.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.BatchGetTokens.Response.prototype.hasToken = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetTokenMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetTokenMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetTokenMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetTokenMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetTokenMetadata}
 */
proto.public.cgs.GetTokenMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetTokenMetadata;
  return proto.public.cgs.GetTokenMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetTokenMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetTokenMetadata}
 */
proto.public.cgs.GetTokenMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetTokenMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetTokenMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetTokenMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetTokenMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetTokenMetadata.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetTokenMetadata.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetTokenMetadata.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetTokenMetadata.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    tokenId: (f = msg.getTokenId()) && proto.public.cgs.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetTokenMetadata.Request}
 */
proto.public.cgs.GetTokenMetadata.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetTokenMetadata.Request;
  return proto.public.cgs.GetTokenMetadata.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetTokenMetadata.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetTokenMetadata.Request}
 */
proto.public.cgs.GetTokenMetadata.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.UUID;
      reader.readMessage(value,proto.public.cgs.UUID.deserializeBinaryFromReader);
      msg.setTokenId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetTokenMetadata.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetTokenMetadata.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetTokenMetadata.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetTokenMetadata.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTokenId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.cgs.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID token_id = 1;
 * @return {?proto.public.cgs.UUID}
 */
proto.public.cgs.GetTokenMetadata.Request.prototype.getTokenId = function() {
  return /** @type{?proto.public.cgs.UUID} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.UUID, 1));
};


/**
 * @param {?proto.public.cgs.UUID|undefined} value
 * @return {!proto.public.cgs.GetTokenMetadata.Request} returns this
*/
proto.public.cgs.GetTokenMetadata.Request.prototype.setTokenId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.GetTokenMetadata.Request} returns this
 */
proto.public.cgs.GetTokenMetadata.Request.prototype.clearTokenId = function() {
  return this.setTokenId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.GetTokenMetadata.Request.prototype.hasTokenId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetTokenMetadata.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetTokenMetadata.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetTokenMetadata.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetTokenMetadata.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && proto.public.cgs.Metadata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetTokenMetadata.Response}
 */
proto.public.cgs.GetTokenMetadata.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetTokenMetadata.Response;
  return proto.public.cgs.GetTokenMetadata.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetTokenMetadata.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetTokenMetadata.Response}
 */
proto.public.cgs.GetTokenMetadata.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.Metadata;
      reader.readMessage(value,proto.public.cgs.Metadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetTokenMetadata.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetTokenMetadata.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetTokenMetadata.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetTokenMetadata.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.cgs.Metadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional Metadata metadata = 1;
 * @return {?proto.public.cgs.Metadata}
 */
proto.public.cgs.GetTokenMetadata.Response.prototype.getMetadata = function() {
  return /** @type{?proto.public.cgs.Metadata} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Metadata, 1));
};


/**
 * @param {?proto.public.cgs.Metadata|undefined} value
 * @return {!proto.public.cgs.GetTokenMetadata.Response} returns this
*/
proto.public.cgs.GetTokenMetadata.Response.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.GetTokenMetadata.Response} returns this
 */
proto.public.cgs.GetTokenMetadata.Response.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.GetTokenMetadata.Response.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetConfigDescription.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetConfigDescription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetConfigDescription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetConfigDescription.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetConfigDescription}
 */
proto.public.cgs.GetConfigDescription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetConfigDescription;
  return proto.public.cgs.GetConfigDescription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetConfigDescription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetConfigDescription}
 */
proto.public.cgs.GetConfigDescription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetConfigDescription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetConfigDescription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetConfigDescription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetConfigDescription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetConfigDescription.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetConfigDescription.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetConfigDescription.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetConfigDescription.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    configId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    level: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetConfigDescription.Request}
 */
proto.public.cgs.GetConfigDescription.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetConfigDescription.Request;
  return proto.public.cgs.GetConfigDescription.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetConfigDescription.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetConfigDescription.Request}
 */
proto.public.cgs.GetConfigDescription.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetConfigDescription.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetConfigDescription.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetConfigDescription.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetConfigDescription.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.public.cgs.GetConfigDescription.Request.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.GetConfigDescription.Request} returns this
 */
proto.public.cgs.GetConfigDescription.Request.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 level = 2;
 * @return {number}
 */
proto.public.cgs.GetConfigDescription.Request.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.GetConfigDescription.Request} returns this
 */
proto.public.cgs.GetConfigDescription.Request.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.GetConfigDescription.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.GetConfigDescription.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetConfigDescription.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    asset: (f = msg.getAsset()) && proto.public.cgs.Asset.toObject(includeInstance, f),
    rarity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    category: jspb.Message.getFieldWithDefault(msg, 5, 0),
    prototype: jspb.Message.getFieldWithDefault(msg, 6, ""),
    minMintLevel: jspb.Message.getFieldWithDefault(msg, 7, 0),
    dropType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    season: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.GetConfigDescription.Response}
 */
proto.public.cgs.GetConfigDescription.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.GetConfigDescription.Response;
  return proto.public.cgs.GetConfigDescription.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.GetConfigDescription.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.GetConfigDescription.Response}
 */
proto.public.cgs.GetConfigDescription.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.public.cgs.Asset;
      reader.readMessage(value,proto.public.cgs.Asset.deserializeBinaryFromReader);
      msg.setAsset(value);
      break;
    case 3:
      var value = /** @type {!proto.public.cgs.Rarity} */ (reader.readEnum());
      msg.setRarity(value);
      break;
    case 4:
      var value = /** @type {!proto.public.cgs.Token.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {!proto.public.cgs.Token.Category} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrototype(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinMintLevel(value);
      break;
    case 8:
      var value = /** @type {!proto.public.cgs.Token.DropType} */ (reader.readEnum());
      msg.setDropType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.GetConfigDescription.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.GetConfigDescription.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.GetConfigDescription.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAsset();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.cgs.Asset.serializeBinaryToWriter
    );
  }
  f = message.getRarity();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getPrototype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMinMintLevel();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getDropType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSeason();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Asset asset = 2;
 * @return {?proto.public.cgs.Asset}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getAsset = function() {
  return /** @type{?proto.public.cgs.Asset} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Asset, 2));
};


/**
 * @param {?proto.public.cgs.Asset|undefined} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
*/
proto.public.cgs.GetConfigDescription.Response.prototype.setAsset = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.clearAsset = function() {
  return this.setAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.hasAsset = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Rarity rarity = 3;
 * @return {!proto.public.cgs.Rarity}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getRarity = function() {
  return /** @type {!proto.public.cgs.Rarity} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.public.cgs.Rarity} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.setRarity = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Token.Type type = 4;
 * @return {!proto.public.cgs.Token.Type}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getType = function() {
  return /** @type {!proto.public.cgs.Token.Type} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.public.cgs.Token.Type} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Token.Category category = 5;
 * @return {!proto.public.cgs.Token.Category}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getCategory = function() {
  return /** @type {!proto.public.cgs.Token.Category} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.public.cgs.Token.Category} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string prototype = 6;
 * @return {string}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getPrototype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.setPrototype = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 min_mint_level = 7;
 * @return {number}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getMinMintLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.setMinMintLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional Token.DropType drop_type = 8;
 * @return {!proto.public.cgs.Token.DropType}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getDropType = function() {
  return /** @type {!proto.public.cgs.Token.DropType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.public.cgs.Token.DropType} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.setDropType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string season = 9;
 * @return {string}
 */
proto.public.cgs.GetConfigDescription.Response.prototype.getSeason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.GetConfigDescription.Response} returns this
 */
proto.public.cgs.GetConfigDescription.Response.prototype.setSeason = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.BatchGetConfigDescriptions.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.BatchGetConfigDescriptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.BatchGetConfigDescriptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetConfigDescriptions.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions}
 */
proto.public.cgs.BatchGetConfigDescriptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.BatchGetConfigDescriptions;
  return proto.public.cgs.BatchGetConfigDescriptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.BatchGetConfigDescriptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions}
 */
proto.public.cgs.BatchGetConfigDescriptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.BatchGetConfigDescriptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.BatchGetConfigDescriptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.BatchGetConfigDescriptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetConfigDescriptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.BatchGetConfigDescriptions.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    configKeysList: jspb.Message.toObjectList(msg.getConfigKeysList(),
    proto.public.cgs.ConfigDescription.Key.toObject, includeInstance),
    filter: (f = msg.getFilter()) && proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.BatchGetConfigDescriptions.Request;
  return proto.public.cgs.BatchGetConfigDescriptions.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.ConfigDescription.Key;
      reader.readMessage(value,proto.public.cgs.ConfigDescription.Key.deserializeBinaryFromReader);
      msg.addConfigKeys(value);
      break;
    case 2:
      var value = new proto.public.cgs.BatchGetConfigDescriptions.Request.Filter;
      reader.readMessage(value,proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.BatchGetConfigDescriptions.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigKeysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.public.cgs.ConfigDescription.Key.serializeBinaryToWriter
    );
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    typesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    dropTypesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.BatchGetConfigDescriptions.Request.Filter;
  return proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.public.cgs.Token.Type>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTypes(values[i]);
      }
      break;
    case 2:
      var values = /** @type {!Array<!proto.public.cgs.Token.Category>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCategories(values[i]);
      }
      break;
    case 3:
      var values = /** @type {!Array<!proto.public.cgs.Token.DropType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDropTypes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getDropTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * repeated Token.Type types = 1;
 * @return {!Array<!proto.public.cgs.Token.Type>}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.getTypesList = function() {
  return /** @type {!Array<!proto.public.cgs.Token.Type>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.public.cgs.Token.Type>} value
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.public.cgs.Token.Type} value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};


/**
 * repeated Token.Category categories = 2;
 * @return {!Array<!proto.public.cgs.Token.Category>}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.getCategoriesList = function() {
  return /** @type {!Array<!proto.public.cgs.Token.Category>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.public.cgs.Token.Category>} value
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.public.cgs.Token.Category} value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * repeated Token.DropType drop_types = 3;
 * @return {!Array<!proto.public.cgs.Token.DropType>}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.getDropTypesList = function() {
  return /** @type {!Array<!proto.public.cgs.Token.DropType>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.public.cgs.Token.DropType>} value
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.setDropTypesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.public.cgs.Token.DropType} value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.addDropTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.Filter.prototype.clearDropTypesList = function() {
  return this.setDropTypesList([]);
};


/**
 * repeated ConfigDescription.Key config_keys = 1;
 * @return {!Array<!proto.public.cgs.ConfigDescription.Key>}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.getConfigKeysList = function() {
  return /** @type{!Array<!proto.public.cgs.ConfigDescription.Key>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.cgs.ConfigDescription.Key, 1));
};


/**
 * @param {!Array<!proto.public.cgs.ConfigDescription.Key>} value
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request} returns this
*/
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.setConfigKeysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.public.cgs.ConfigDescription.Key=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.ConfigDescription.Key}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.addConfigKeys = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.public.cgs.ConfigDescription.Key, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.clearConfigKeysList = function() {
  return this.setConfigKeysList([]);
};


/**
 * optional Filter filter = 2;
 * @return {?proto.public.cgs.BatchGetConfigDescriptions.Request.Filter}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.getFilter = function() {
  return /** @type{?proto.public.cgs.BatchGetConfigDescriptions.Request.Filter} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.BatchGetConfigDescriptions.Request.Filter, 2));
};


/**
 * @param {?proto.public.cgs.BatchGetConfigDescriptions.Request.Filter|undefined} value
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request} returns this
*/
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Request} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.BatchGetConfigDescriptions.Request.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.BatchGetConfigDescriptions.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    configDescription: (f = msg.getConfigDescription()) && proto.public.cgs.ConfigDescription.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Response}
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.BatchGetConfigDescriptions.Response;
  return proto.public.cgs.BatchGetConfigDescriptions.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Response}
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.ConfigDescription;
      reader.readMessage(value,proto.public.cgs.ConfigDescription.deserializeBinaryFromReader);
      msg.setConfigDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.BatchGetConfigDescriptions.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.BatchGetConfigDescriptions.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigDescription();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.cgs.ConfigDescription.serializeBinaryToWriter
    );
  }
};


/**
 * optional ConfigDescription config_description = 1;
 * @return {?proto.public.cgs.ConfigDescription}
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.prototype.getConfigDescription = function() {
  return /** @type{?proto.public.cgs.ConfigDescription} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.ConfigDescription, 1));
};


/**
 * @param {?proto.public.cgs.ConfigDescription|undefined} value
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Response} returns this
*/
proto.public.cgs.BatchGetConfigDescriptions.Response.prototype.setConfigDescription = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.BatchGetConfigDescriptions.Response} returns this
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.prototype.clearConfigDescription = function() {
  return this.setConfigDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.BatchGetConfigDescriptions.Response.prototype.hasConfigDescription = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.ConfigDescription.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.ConfigDescription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.ConfigDescription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.ConfigDescription.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: (f = msg.getKey()) && proto.public.cgs.ConfigDescription.Key.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    asset: (f = msg.getAsset()) && proto.public.cgs.Asset.toObject(includeInstance, f),
    rarity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    category: jspb.Message.getFieldWithDefault(msg, 6, 0),
    prototype: jspb.Message.getFieldWithDefault(msg, 7, ""),
    minMintLevel: jspb.Message.getFieldWithDefault(msg, 8, 0),
    dropType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    season: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.ConfigDescription}
 */
proto.public.cgs.ConfigDescription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.ConfigDescription;
  return proto.public.cgs.ConfigDescription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.ConfigDescription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.ConfigDescription}
 */
proto.public.cgs.ConfigDescription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.cgs.ConfigDescription.Key;
      reader.readMessage(value,proto.public.cgs.ConfigDescription.Key.deserializeBinaryFromReader);
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.public.cgs.Asset;
      reader.readMessage(value,proto.public.cgs.Asset.deserializeBinaryFromReader);
      msg.setAsset(value);
      break;
    case 4:
      var value = /** @type {!proto.public.cgs.Rarity} */ (reader.readEnum());
      msg.setRarity(value);
      break;
    case 5:
      var value = /** @type {!proto.public.cgs.Token.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {!proto.public.cgs.Token.Category} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrototype(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinMintLevel(value);
      break;
    case 9:
      var value = /** @type {!proto.public.cgs.Token.DropType} */ (reader.readEnum());
      msg.setDropType(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.ConfigDescription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.ConfigDescription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.ConfigDescription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.ConfigDescription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.cgs.ConfigDescription.Key.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAsset();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.public.cgs.Asset.serializeBinaryToWriter
    );
  }
  f = message.getRarity();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPrototype();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMinMintLevel();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getDropType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getSeason();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.ConfigDescription.Key.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.ConfigDescription.Key.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.ConfigDescription.Key} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.ConfigDescription.Key.toObject = function(includeInstance, msg) {
  var f, obj = {
    configId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    level: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.ConfigDescription.Key}
 */
proto.public.cgs.ConfigDescription.Key.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.ConfigDescription.Key;
  return proto.public.cgs.ConfigDescription.Key.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.ConfigDescription.Key} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.ConfigDescription.Key}
 */
proto.public.cgs.ConfigDescription.Key.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.ConfigDescription.Key.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.ConfigDescription.Key.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.ConfigDescription.Key} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.ConfigDescription.Key.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.public.cgs.ConfigDescription.Key.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.ConfigDescription.Key} returns this
 */
proto.public.cgs.ConfigDescription.Key.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 level = 2;
 * @return {number}
 */
proto.public.cgs.ConfigDescription.Key.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.ConfigDescription.Key} returns this
 */
proto.public.cgs.ConfigDescription.Key.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Key key = 1;
 * @return {?proto.public.cgs.ConfigDescription.Key}
 */
proto.public.cgs.ConfigDescription.prototype.getKey = function() {
  return /** @type{?proto.public.cgs.ConfigDescription.Key} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.ConfigDescription.Key, 1));
};


/**
 * @param {?proto.public.cgs.ConfigDescription.Key|undefined} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
*/
proto.public.cgs.ConfigDescription.prototype.setKey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.clearKey = function() {
  return this.setKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.ConfigDescription.prototype.hasKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.public.cgs.ConfigDescription.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Asset asset = 3;
 * @return {?proto.public.cgs.Asset}
 */
proto.public.cgs.ConfigDescription.prototype.getAsset = function() {
  return /** @type{?proto.public.cgs.Asset} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Asset, 3));
};


/**
 * @param {?proto.public.cgs.Asset|undefined} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
*/
proto.public.cgs.ConfigDescription.prototype.setAsset = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.clearAsset = function() {
  return this.setAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.ConfigDescription.prototype.hasAsset = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Rarity rarity = 4;
 * @return {!proto.public.cgs.Rarity}
 */
proto.public.cgs.ConfigDescription.prototype.getRarity = function() {
  return /** @type {!proto.public.cgs.Rarity} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.public.cgs.Rarity} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.setRarity = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Token.Type type = 5;
 * @return {!proto.public.cgs.Token.Type}
 */
proto.public.cgs.ConfigDescription.prototype.getType = function() {
  return /** @type {!proto.public.cgs.Token.Type} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.public.cgs.Token.Type} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Token.Category category = 6;
 * @return {!proto.public.cgs.Token.Category}
 */
proto.public.cgs.ConfigDescription.prototype.getCategory = function() {
  return /** @type {!proto.public.cgs.Token.Category} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.public.cgs.Token.Category} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string prototype = 7;
 * @return {string}
 */
proto.public.cgs.ConfigDescription.prototype.getPrototype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.setPrototype = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 min_mint_level = 8;
 * @return {number}
 */
proto.public.cgs.ConfigDescription.prototype.getMinMintLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.setMinMintLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional Token.DropType drop_type = 9;
 * @return {!proto.public.cgs.Token.DropType}
 */
proto.public.cgs.ConfigDescription.prototype.getDropType = function() {
  return /** @type {!proto.public.cgs.Token.DropType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.public.cgs.Token.DropType} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.setDropType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string season = 10;
 * @return {string}
 */
proto.public.cgs.ConfigDescription.prototype.getSeason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.ConfigDescription} returns this
 */
proto.public.cgs.ConfigDescription.prototype.setSeason = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.UUID}
 */
proto.public.cgs.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.UUID;
  return proto.public.cgs.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.UUID}
 */
proto.public.cgs.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.public.cgs.UUID.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.UUID} returns this
 */
proto.public.cgs.UUID.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.cgs.Token.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Token.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Token.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Token} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Token.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    category: jspb.Message.getFieldWithDefault(msg, 3, 0),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    asset: (f = msg.getAsset()) && proto.public.cgs.Asset.toObject(includeInstance, f),
    rarity: jspb.Message.getFieldWithDefault(msg, 6, 0),
    prototype: jspb.Message.getFieldWithDefault(msg, 7, ""),
    perksList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    dropType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    season: jspb.Message.getFieldWithDefault(msg, 10, ""),
    progress: (f = msg.getProgress()) && proto.public.cgs.Progress.toObject(includeInstance, f),
    minMintLevel: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Token}
 */
proto.public.cgs.Token.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Token;
  return proto.public.cgs.Token.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Token} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Token}
 */
proto.public.cgs.Token.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.public.cgs.Token.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {!proto.public.cgs.Token.Category} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = new proto.public.cgs.Asset;
      reader.readMessage(value,proto.public.cgs.Asset.deserializeBinaryFromReader);
      msg.setAsset(value);
      break;
    case 6:
      var value = /** @type {!proto.public.cgs.Rarity} */ (reader.readEnum());
      msg.setRarity(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrototype(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addPerks(value);
      break;
    case 9:
      var value = /** @type {!proto.public.cgs.Token.DropType} */ (reader.readEnum());
      msg.setDropType(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeason(value);
      break;
    case 11:
      var value = new proto.public.cgs.Progress;
      reader.readMessage(value,proto.public.cgs.Progress.deserializeBinaryFromReader);
      msg.setProgress(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinMintLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Token.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Token.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Token} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Token.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAsset();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.public.cgs.Asset.serializeBinaryToWriter
    );
  }
  f = message.getRarity();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPrototype();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPerksList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getDropType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getSeason();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getProgress();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.public.cgs.Progress.serializeBinaryToWriter
    );
  }
  f = message.getMinMintLevel();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.public.cgs.Token.Type = {
  UNKNOWN_TYPE: 0,
  BATTLE_PASS_TYPE: 1,
  OUTFIT_TYPE: 2,
  CURRENCY_TYPE: 3,
  HAT_TYPE: 4,
  PARACHUTE_TYPE: 5,
  MAIN_WEAPON_TYPE: 6,
  SECONDARY_WEAPON_TYPE: 7
};

/**
 * @enum {number}
 */
proto.public.cgs.Token.Category = {
  UNKNOWN: 0,
  BODY: 1,
  ASSAULT_RIFLE: 2,
  HANDGUN: 3,
  HAT: 4,
  MELEE_WEAPONS: 5,
  PARACHUTE: 6,
  SHOTGUN: 7,
  SNIPER_RIFLE: 8,
  SOFT: 9,
  SUBMACHINE_GUN: 10
};

/**
 * @enum {number}
 */
proto.public.cgs.Token.DropType = {
  DROP_TYPE_UNKNOWN: 0,
  DROP_TYPE_LOOT_COLLECTION: 1,
  DROP_TYPE_PREMIUM: 2,
  DROP_TYPE_SPECIAL: 3
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.public.cgs.Token.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 2;
 * @return {!proto.public.cgs.Token.Type}
 */
proto.public.cgs.Token.prototype.getType = function() {
  return /** @type {!proto.public.cgs.Token.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.public.cgs.Token.Type} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Category category = 3;
 * @return {!proto.public.cgs.Token.Category}
 */
proto.public.cgs.Token.prototype.getCategory = function() {
  return /** @type {!proto.public.cgs.Token.Category} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.public.cgs.Token.Category} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.public.cgs.Token.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Asset asset = 5;
 * @return {?proto.public.cgs.Asset}
 */
proto.public.cgs.Token.prototype.getAsset = function() {
  return /** @type{?proto.public.cgs.Asset} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Asset, 5));
};


/**
 * @param {?proto.public.cgs.Asset|undefined} value
 * @return {!proto.public.cgs.Token} returns this
*/
proto.public.cgs.Token.prototype.setAsset = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.clearAsset = function() {
  return this.setAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.Token.prototype.hasAsset = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Rarity rarity = 6;
 * @return {!proto.public.cgs.Rarity}
 */
proto.public.cgs.Token.prototype.getRarity = function() {
  return /** @type {!proto.public.cgs.Rarity} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.public.cgs.Rarity} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setRarity = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string prototype = 7;
 * @return {string}
 */
proto.public.cgs.Token.prototype.getPrototype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setPrototype = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated string perks = 8;
 * @return {!Array<string>}
 */
proto.public.cgs.Token.prototype.getPerksList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setPerksList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.addPerks = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.clearPerksList = function() {
  return this.setPerksList([]);
};


/**
 * optional DropType drop_type = 9;
 * @return {!proto.public.cgs.Token.DropType}
 */
proto.public.cgs.Token.prototype.getDropType = function() {
  return /** @type {!proto.public.cgs.Token.DropType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.public.cgs.Token.DropType} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setDropType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string season = 10;
 * @return {string}
 */
proto.public.cgs.Token.prototype.getSeason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setSeason = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional Progress progress = 11;
 * @return {?proto.public.cgs.Progress}
 */
proto.public.cgs.Token.prototype.getProgress = function() {
  return /** @type{?proto.public.cgs.Progress} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Progress, 11));
};


/**
 * @param {?proto.public.cgs.Progress|undefined} value
 * @return {!proto.public.cgs.Token} returns this
*/
proto.public.cgs.Token.prototype.setProgress = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.clearProgress = function() {
  return this.setProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.Token.prototype.hasProgress = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int64 min_mint_level = 12;
 * @return {number}
 */
proto.public.cgs.Token.prototype.getMinMintLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Token} returns this
 */
proto.public.cgs.Token.prototype.setMinMintLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Progress.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Progress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Progress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Progress.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0),
    points: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nextLevelPoints: jspb.Message.getFieldWithDefault(msg, 3, 0),
    currLevelPoints: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Progress}
 */
proto.public.cgs.Progress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Progress;
  return proto.public.cgs.Progress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Progress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Progress}
 */
proto.public.cgs.Progress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLevel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPoints(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNextLevelPoints(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCurrLevelPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Progress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Progress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Progress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Progress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getPoints();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getNextLevelPoints();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getCurrLevelPoints();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional uint64 level = 1;
 * @return {number}
 */
proto.public.cgs.Progress.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Progress} returns this
 */
proto.public.cgs.Progress.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 points = 2;
 * @return {number}
 */
proto.public.cgs.Progress.prototype.getPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Progress} returns this
 */
proto.public.cgs.Progress.prototype.setPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 next_level_points = 3;
 * @return {number}
 */
proto.public.cgs.Progress.prototype.getNextLevelPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Progress} returns this
 */
proto.public.cgs.Progress.prototype.setNextLevelPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 curr_level_points = 4;
 * @return {number}
 */
proto.public.cgs.Progress.prototype.getCurrLevelPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Progress} returns this
 */
proto.public.cgs.Progress.prototype.setCurrLevelPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Asset.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Asset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Asset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Asset.toObject = function(includeInstance, msg) {
  var f, obj = {
    iconUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meshUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    materialMap: (f = msg.getMaterialMap()) ? f.toObject(includeInstance, proto.public.cgs.Material.toObject) : [],
    skeleton: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Asset}
 */
proto.public.cgs.Asset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Asset;
  return proto.public.cgs.Asset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Asset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Asset}
 */
proto.public.cgs.Asset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMeshUrl(value);
      break;
    case 3:
      var value = msg.getMaterialMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.public.cgs.Material.deserializeBinaryFromReader, "", new proto.public.cgs.Material());
         });
      break;
    case 4:
      var value = /** @type {!proto.public.cgs.Asset.Skeleton} */ (reader.readEnum());
      msg.setSkeleton(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Asset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Asset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Asset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Asset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIconUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeshUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMaterialMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.public.cgs.Material.serializeBinaryToWriter);
  }
  f = message.getSkeleton();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.public.cgs.Asset.Skeleton = {
  SKELETON_UNDEFINED: 0,
  SKELETON_OLD: 1,
  SKELETON_MAN: 2,
  SKELETON_GIRL: 3
};

/**
 * optional string icon_url = 1;
 * @return {string}
 */
proto.public.cgs.Asset.prototype.getIconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Asset} returns this
 */
proto.public.cgs.Asset.prototype.setIconUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string mesh_url = 2;
 * @return {string}
 */
proto.public.cgs.Asset.prototype.getMeshUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Asset} returns this
 */
proto.public.cgs.Asset.prototype.setMeshUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, Material> material = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.public.cgs.Material>}
 */
proto.public.cgs.Asset.prototype.getMaterialMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.public.cgs.Material>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.public.cgs.Material));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.public.cgs.Asset} returns this
 */
proto.public.cgs.Asset.prototype.clearMaterialMap = function() {
  this.getMaterialMap().clear();
  return this;};


/**
 * optional Skeleton skeleton = 4;
 * @return {!proto.public.cgs.Asset.Skeleton}
 */
proto.public.cgs.Asset.prototype.getSkeleton = function() {
  return /** @type {!proto.public.cgs.Asset.Skeleton} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.public.cgs.Asset.Skeleton} value
 * @return {!proto.public.cgs.Asset} returns this
 */
proto.public.cgs.Asset.prototype.setSkeleton = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Material.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Material.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Material} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Material.toObject = function(includeInstance, msg) {
  var f, obj = {
    baseColor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    normalMap: jspb.Message.getFieldWithDefault(msg, 2, ""),
    emissionMap: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ambientOcclusion: jspb.Message.getFieldWithDefault(msg, 4, ""),
    params: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Material}
 */
proto.public.cgs.Material.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Material;
  return proto.public.cgs.Material.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Material} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Material}
 */
proto.public.cgs.Material.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseColor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNormalMap(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmissionMap(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmbientOcclusion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Material.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Material.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Material} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Material.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBaseColor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNormalMap();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmissionMap();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmbientOcclusion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getParams();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string base_color = 1;
 * @return {string}
 */
proto.public.cgs.Material.prototype.getBaseColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Material} returns this
 */
proto.public.cgs.Material.prototype.setBaseColor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string normal_map = 2;
 * @return {string}
 */
proto.public.cgs.Material.prototype.getNormalMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Material} returns this
 */
proto.public.cgs.Material.prototype.setNormalMap = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string emission_map = 3;
 * @return {string}
 */
proto.public.cgs.Material.prototype.getEmissionMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Material} returns this
 */
proto.public.cgs.Material.prototype.setEmissionMap = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ambient_occlusion = 4;
 * @return {string}
 */
proto.public.cgs.Material.prototype.getAmbientOcclusion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Material} returns this
 */
proto.public.cgs.Material.prototype.setAmbientOcclusion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string params = 5;
 * @return {string}
 */
proto.public.cgs.Material.prototype.getParams = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Material} returns this
 */
proto.public.cgs.Material.prototype.setParams = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.cgs.Metadata.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Metadata.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Metadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Metadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    image: (f = msg.getImage()) && proto.public.cgs.Metadata.Image.toObject(includeInstance, f),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    collection: (f = msg.getCollection()) && proto.public.cgs.Metadata.Collection.toObject(includeInstance, f),
    attrsList: jspb.Message.toObjectList(msg.getAttrsList(),
    proto.public.cgs.Metadata.Attribute.toObject, includeInstance),
    properties: (f = msg.getProperties()) && proto.public.cgs.Metadata.Properties.toObject(includeInstance, f),
    externalurl: jspb.Message.getFieldWithDefault(msg, 9, ""),
    sellerfeebasispoints: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Metadata}
 */
proto.public.cgs.Metadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Metadata;
  return proto.public.cgs.Metadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Metadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Metadata}
 */
proto.public.cgs.Metadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.public.cgs.Metadata.Image;
      reader.readMessage(value,proto.public.cgs.Metadata.Image.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = new proto.public.cgs.Metadata.Collection;
      reader.readMessage(value,proto.public.cgs.Metadata.Collection.deserializeBinaryFromReader);
      msg.setCollection(value);
      break;
    case 7:
      var value = new proto.public.cgs.Metadata.Attribute;
      reader.readMessage(value,proto.public.cgs.Metadata.Attribute.deserializeBinaryFromReader);
      msg.addAttrs(value);
      break;
    case 8:
      var value = new proto.public.cgs.Metadata.Properties;
      reader.readMessage(value,proto.public.cgs.Metadata.Properties.deserializeBinaryFromReader);
      msg.setProperties(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalurl(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellerfeebasispoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Metadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Metadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Metadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.cgs.Metadata.Image.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCollection();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.public.cgs.Metadata.Collection.serializeBinaryToWriter
    );
  }
  f = message.getAttrsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.public.cgs.Metadata.Attribute.serializeBinaryToWriter
    );
  }
  f = message.getProperties();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.public.cgs.Metadata.Properties.serializeBinaryToWriter
    );
  }
  f = message.getExternalurl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSellerfeebasispoints();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.public.cgs.Metadata.Attribute.oneofGroups_ = [[2,3,4]];

/**
 * @enum {number}
 */
proto.public.cgs.Metadata.Attribute.ValueCase = {
  VALUE_NOT_SET: 0,
  STRINGVALUE: 2,
  INTVALUE: 3,
  DOUBLEVALUE: 4
};

/**
 * @return {proto.public.cgs.Metadata.Attribute.ValueCase}
 */
proto.public.cgs.Metadata.Attribute.prototype.getValueCase = function() {
  return /** @type {proto.public.cgs.Metadata.Attribute.ValueCase} */(jspb.Message.computeOneofCase(this, proto.public.cgs.Metadata.Attribute.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Metadata.Attribute.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Metadata.Attribute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Metadata.Attribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.Attribute.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    stringvalue: jspb.Message.getFieldWithDefault(msg, 2, ""),
    intvalue: jspb.Message.getFieldWithDefault(msg, 3, 0),
    doublevalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    maxvalue: jspb.Message.getFieldWithDefault(msg, 5, 0),
    displaytype: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Metadata.Attribute}
 */
proto.public.cgs.Metadata.Attribute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Metadata.Attribute;
  return proto.public.cgs.Metadata.Attribute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Metadata.Attribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Metadata.Attribute}
 */
proto.public.cgs.Metadata.Attribute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStringvalue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntvalue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDoublevalue(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxvalue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplaytype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Metadata.Attribute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Metadata.Attribute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Metadata.Attribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.Attribute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMaxvalue();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getDisplaytype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.public.cgs.Metadata.Attribute.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string stringValue = 2;
 * @return {string}
 */
proto.public.cgs.Metadata.Attribute.prototype.getStringvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.setStringvalue = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.public.cgs.Metadata.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.clearStringvalue = function() {
  return jspb.Message.setOneofField(this, 2, proto.public.cgs.Metadata.Attribute.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.Metadata.Attribute.prototype.hasStringvalue = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 intValue = 3;
 * @return {number}
 */
proto.public.cgs.Metadata.Attribute.prototype.getIntvalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.setIntvalue = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.public.cgs.Metadata.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.clearIntvalue = function() {
  return jspb.Message.setOneofField(this, 3, proto.public.cgs.Metadata.Attribute.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.Metadata.Attribute.prototype.hasIntvalue = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double doubleValue = 4;
 * @return {number}
 */
proto.public.cgs.Metadata.Attribute.prototype.getDoublevalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.setDoublevalue = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.public.cgs.Metadata.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.clearDoublevalue = function() {
  return jspb.Message.setOneofField(this, 4, proto.public.cgs.Metadata.Attribute.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.Metadata.Attribute.prototype.hasDoublevalue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 maxvalue = 5;
 * @return {number}
 */
proto.public.cgs.Metadata.Attribute.prototype.getMaxvalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.setMaxvalue = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string displayType = 6;
 * @return {string}
 */
proto.public.cgs.Metadata.Attribute.prototype.getDisplaytype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Attribute} returns this
 */
proto.public.cgs.Metadata.Attribute.prototype.setDisplaytype = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Metadata.Collection.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Metadata.Collection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Metadata.Collection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.Collection.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    family: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Metadata.Collection}
 */
proto.public.cgs.Metadata.Collection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Metadata.Collection;
  return proto.public.cgs.Metadata.Collection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Metadata.Collection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Metadata.Collection}
 */
proto.public.cgs.Metadata.Collection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamily(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Metadata.Collection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Metadata.Collection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Metadata.Collection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.Collection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFamily();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.public.cgs.Metadata.Collection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Collection} returns this
 */
proto.public.cgs.Metadata.Collection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string family = 2;
 * @return {string}
 */
proto.public.cgs.Metadata.Collection.prototype.getFamily = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Collection} returns this
 */
proto.public.cgs.Metadata.Collection.prototype.setFamily = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Metadata.Properties.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Metadata.Properties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Metadata.Properties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.Properties.toObject = function(includeInstance, msg) {
  var f, obj = {
    dna: jspb.Message.getFieldWithDefault(msg, 1, ""),
    discord: jspb.Message.getFieldWithDefault(msg, 2, ""),
    category: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Metadata.Properties}
 */
proto.public.cgs.Metadata.Properties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Metadata.Properties;
  return proto.public.cgs.Metadata.Properties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Metadata.Properties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Metadata.Properties}
 */
proto.public.cgs.Metadata.Properties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDna(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscord(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Metadata.Properties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Metadata.Properties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Metadata.Properties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.Properties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDna();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDiscord();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string dna = 1;
 * @return {string}
 */
proto.public.cgs.Metadata.Properties.prototype.getDna = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Properties} returns this
 */
proto.public.cgs.Metadata.Properties.prototype.setDna = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string discord = 2;
 * @return {string}
 */
proto.public.cgs.Metadata.Properties.prototype.getDiscord = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Properties} returns this
 */
proto.public.cgs.Metadata.Properties.prototype.setDiscord = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.public.cgs.Metadata.Properties.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Properties} returns this
 */
proto.public.cgs.Metadata.Properties.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.cgs.Metadata.Image.prototype.toObject = function(opt_includeInstance) {
  return proto.public.cgs.Metadata.Image.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.cgs.Metadata.Image} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.Image.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bucket: jspb.Message.getFieldWithDefault(msg, 2, ""),
    object: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.cgs.Metadata.Image}
 */
proto.public.cgs.Metadata.Image.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.cgs.Metadata.Image;
  return proto.public.cgs.Metadata.Image.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.cgs.Metadata.Image} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.cgs.Metadata.Image}
 */
proto.public.cgs.Metadata.Image.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBucket(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setObject(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.cgs.Metadata.Image.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.cgs.Metadata.Image.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.cgs.Metadata.Image} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.cgs.Metadata.Image.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBucket();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getObject();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.public.cgs.Metadata.Image.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Image} returns this
 */
proto.public.cgs.Metadata.Image.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bucket = 2;
 * @return {string}
 */
proto.public.cgs.Metadata.Image.prototype.getBucket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Image} returns this
 */
proto.public.cgs.Metadata.Image.prototype.setBucket = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string object = 3;
 * @return {string}
 */
proto.public.cgs.Metadata.Image.prototype.getObject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata.Image} returns this
 */
proto.public.cgs.Metadata.Image.prototype.setObject = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.public.cgs.Metadata.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Image image = 2;
 * @return {?proto.public.cgs.Metadata.Image}
 */
proto.public.cgs.Metadata.prototype.getImage = function() {
  return /** @type{?proto.public.cgs.Metadata.Image} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Metadata.Image, 2));
};


/**
 * @param {?proto.public.cgs.Metadata.Image|undefined} value
 * @return {!proto.public.cgs.Metadata} returns this
*/
proto.public.cgs.Metadata.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.Metadata.prototype.hasImage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.public.cgs.Metadata.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.public.cgs.Metadata.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Collection collection = 6;
 * @return {?proto.public.cgs.Metadata.Collection}
 */
proto.public.cgs.Metadata.prototype.getCollection = function() {
  return /** @type{?proto.public.cgs.Metadata.Collection} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Metadata.Collection, 6));
};


/**
 * @param {?proto.public.cgs.Metadata.Collection|undefined} value
 * @return {!proto.public.cgs.Metadata} returns this
*/
proto.public.cgs.Metadata.prototype.setCollection = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.clearCollection = function() {
  return this.setCollection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.Metadata.prototype.hasCollection = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated Attribute attrs = 7;
 * @return {!Array<!proto.public.cgs.Metadata.Attribute>}
 */
proto.public.cgs.Metadata.prototype.getAttrsList = function() {
  return /** @type{!Array<!proto.public.cgs.Metadata.Attribute>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.cgs.Metadata.Attribute, 7));
};


/**
 * @param {!Array<!proto.public.cgs.Metadata.Attribute>} value
 * @return {!proto.public.cgs.Metadata} returns this
*/
proto.public.cgs.Metadata.prototype.setAttrsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.public.cgs.Metadata.Attribute=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.cgs.Metadata.Attribute}
 */
proto.public.cgs.Metadata.prototype.addAttrs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.public.cgs.Metadata.Attribute, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.clearAttrsList = function() {
  return this.setAttrsList([]);
};


/**
 * optional Properties properties = 8;
 * @return {?proto.public.cgs.Metadata.Properties}
 */
proto.public.cgs.Metadata.prototype.getProperties = function() {
  return /** @type{?proto.public.cgs.Metadata.Properties} */ (
    jspb.Message.getWrapperField(this, proto.public.cgs.Metadata.Properties, 8));
};


/**
 * @param {?proto.public.cgs.Metadata.Properties|undefined} value
 * @return {!proto.public.cgs.Metadata} returns this
*/
proto.public.cgs.Metadata.prototype.setProperties = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.clearProperties = function() {
  return this.setProperties(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.cgs.Metadata.prototype.hasProperties = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string externalUrl = 9;
 * @return {string}
 */
proto.public.cgs.Metadata.prototype.getExternalurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.setExternalurl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint64 sellerFeeBasisPoints = 10;
 * @return {number}
 */
proto.public.cgs.Metadata.prototype.getSellerfeebasispoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.cgs.Metadata} returns this
 */
proto.public.cgs.Metadata.prototype.setSellerfeebasispoints = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * @enum {number}
 */
proto.public.cgs.Rarity = {
  UNKNOWN: 0,
  COMMON: 1,
  UNCOMMON: 2,
  RARE: 3,
  EPIC: 4,
  LEGENDARY: 5
};

goog.object.extend(exports, proto.public.cgs);

},{"../validate/validate_pb.js":13,"google-protobuf":3}],13:[function(require,module,exports){

},{}],14:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for public.clanevent
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var shared_shared_pb = require('../shared/shared_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.public = {};
proto.public.clanevent = require('./clanevent.public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.clanevent.ClanEventClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.clanevent.ClanEventPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetCurrentEvent.Request,
 *   !proto.public.clanevent.GetCurrentEvent.Response>}
 */
const methodDescriptor_ClanEvent_GetCurrentEvent = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetCurrentEvent',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetCurrentEvent.Request,
  proto.public.clanevent.GetCurrentEvent.Response,
  /**
   * @param {!proto.public.clanevent.GetCurrentEvent.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetCurrentEvent.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetCurrentEvent.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetCurrentEvent.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetCurrentEvent.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getCurrentEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetCurrentEvent',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetCurrentEvent,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetCurrentEvent.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetCurrentEvent.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getCurrentEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetCurrentEvent',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetCurrentEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetPreviousEvent.Request,
 *   !proto.public.clanevent.GetPreviousEvent.Response>}
 */
const methodDescriptor_ClanEvent_GetPreviousEvent = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetPreviousEvent',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetPreviousEvent.Request,
  proto.public.clanevent.GetPreviousEvent.Response,
  /**
   * @param {!proto.public.clanevent.GetPreviousEvent.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetPreviousEvent.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetPreviousEvent.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetPreviousEvent.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetPreviousEvent.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getPreviousEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetPreviousEvent',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetPreviousEvent,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetPreviousEvent.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetPreviousEvent.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getPreviousEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetPreviousEvent',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetPreviousEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetLeaderboardViewEvent.Request,
 *   !proto.public.clanevent.GetLeaderboardViewEvent.Response>}
 */
const methodDescriptor_ClanEvent_GetLeaderboardViewEvent = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetLeaderboardViewEvent',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetLeaderboardViewEvent.Request,
  proto.public.clanevent.GetLeaderboardViewEvent.Response,
  /**
   * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetLeaderboardViewEvent.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetLeaderboardViewEvent.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetLeaderboardViewEvent.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getLeaderboardViewEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetLeaderboardViewEvent',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetLeaderboardViewEvent,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetLeaderboardViewEvent.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getLeaderboardViewEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetLeaderboardViewEvent',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetLeaderboardViewEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetCurrentRaid.Request,
 *   !proto.public.clanevent.GetCurrentRaid.Response>}
 */
const methodDescriptor_ClanEvent_GetCurrentRaid = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetCurrentRaid',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetCurrentRaid.Request,
  proto.public.clanevent.GetCurrentRaid.Response,
  /**
   * @param {!proto.public.clanevent.GetCurrentRaid.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetCurrentRaid.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetCurrentRaid.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetCurrentRaid.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetCurrentRaid.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getCurrentRaid =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetCurrentRaid',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetCurrentRaid,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetCurrentRaid.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetCurrentRaid.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getCurrentRaid =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetCurrentRaid',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetCurrentRaid);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.StartRaid.Request,
 *   !proto.public.clanevent.StartRaid.Response>}
 */
const methodDescriptor_ClanEvent_StartRaid = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/StartRaid',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.StartRaid.Request,
  proto.public.clanevent.StartRaid.Response,
  /**
   * @param {!proto.public.clanevent.StartRaid.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.StartRaid.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.StartRaid.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.StartRaid.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.StartRaid.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.startRaid =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/StartRaid',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_StartRaid,
      callback);
};


/**
 * @param {!proto.public.clanevent.StartRaid.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.StartRaid.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.startRaid =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/StartRaid',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_StartRaid);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetClanEventInfo.Request,
 *   !proto.public.clanevent.GetClanEventInfo.Response>}
 */
const methodDescriptor_ClanEvent_GetClanEventInfo = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetClanEventInfo',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetClanEventInfo.Request,
  proto.public.clanevent.GetClanEventInfo.Response,
  /**
   * @param {!proto.public.clanevent.GetClanEventInfo.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetClanEventInfo.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetClanEventInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetClanEventInfo.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetClanEventInfo.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getClanEventInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetClanEventInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetClanEventInfo,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetClanEventInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetClanEventInfo.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getClanEventInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetClanEventInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetClanEventInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetClanLeaderboard.Request,
 *   !proto.public.clanevent.GetClanLeaderboard.Response>}
 */
const methodDescriptor_ClanEvent_GetClanLeaderboard = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetClanLeaderboard',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetClanLeaderboard.Request,
  proto.public.clanevent.GetClanLeaderboard.Response,
  /**
   * @param {!proto.public.clanevent.GetClanLeaderboard.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetClanLeaderboard.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetClanLeaderboard.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetClanLeaderboard.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetClanLeaderboard.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getClanLeaderboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetClanLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetClanLeaderboard,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetClanLeaderboard.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetClanLeaderboard.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getClanLeaderboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetClanLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetClanLeaderboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetPlayerLeaderboard.Request,
 *   !proto.public.clanevent.GetPlayerLeaderboard.Response>}
 */
const methodDescriptor_ClanEvent_GetPlayerLeaderboard = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetPlayerLeaderboard',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetPlayerLeaderboard.Request,
  proto.public.clanevent.GetPlayerLeaderboard.Response,
  /**
   * @param {!proto.public.clanevent.GetPlayerLeaderboard.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetPlayerLeaderboard.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetPlayerLeaderboard.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetPlayerLeaderboard.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getPlayerLeaderboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetPlayerLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetPlayerLeaderboard,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetPlayerLeaderboard.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getPlayerLeaderboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetPlayerLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetPlayerLeaderboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request,
 *   !proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response>}
 */
const methodDescriptor_ClanEvent_GetLastFinishedRaidPopupInfo = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetLastFinishedRaidPopupInfo',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request,
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response,
  /**
   * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getLastFinishedRaidPopupInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetLastFinishedRaidPopupInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetLastFinishedRaidPopupInfo,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getLastFinishedRaidPopupInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetLastFinishedRaidPopupInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetLastFinishedRaidPopupInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request,
 *   !proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response>}
 */
const methodDescriptor_ClanEvent_AckLastFinishedRaidPopupInfo = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/AckLastFinishedRaidPopupInfo',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request,
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response,
  /**
   * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.ackLastFinishedRaidPopupInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/AckLastFinishedRaidPopupInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_AckLastFinishedRaidPopupInfo,
      callback);
};


/**
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.ackLastFinishedRaidPopupInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/AckLastFinishedRaidPopupInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_AckLastFinishedRaidPopupInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetLastFinishedEventPopupInfo.Request,
 *   !proto.public.clanevent.GetLastFinishedEventPopupInfo.Response>}
 */
const methodDescriptor_ClanEvent_GetLastFinishedEventPopupInfo = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/GetLastFinishedEventPopupInfo',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Request,
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Response,
  /**
   * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetLastFinishedEventPopupInfo.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.getLastFinishedEventPopupInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetLastFinishedEventPopupInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetLastFinishedEventPopupInfo,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.getLastFinishedEventPopupInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/GetLastFinishedEventPopupInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_GetLastFinishedEventPopupInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.AckLastFinishedEventPopupInfo.Request,
 *   !proto.public.clanevent.AckLastFinishedEventPopupInfo.Response>}
 */
const methodDescriptor_ClanEvent_AckLastFinishedEventPopupInfo = new grpc.web.MethodDescriptor(
  '/public.clanevent.ClanEvent/AckLastFinishedEventPopupInfo',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.AckLastFinishedEventPopupInfo.Request,
  proto.public.clanevent.AckLastFinishedEventPopupInfo.Response,
  /**
   * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.AckLastFinishedEventPopupInfo.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.AckLastFinishedEventPopupInfo.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.ClanEventClient.prototype.ackLastFinishedEventPopupInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.ClanEvent/AckLastFinishedEventPopupInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_AckLastFinishedEventPopupInfo,
      callback);
};


/**
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.AckLastFinishedEventPopupInfo.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.ClanEventPromiseClient.prototype.ackLastFinishedEventPopupInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.ClanEvent/AckLastFinishedEventPopupInfo',
      request,
      metadata || {},
      methodDescriptor_ClanEvent_AckLastFinishedEventPopupInfo);
};


module.exports = proto.public.clanevent;


},{"../shared/shared_pb.js":18,"./clanevent.public_pb.js":15,"google-protobuf/google/protobuf/timestamp_pb.js":6,"grpc-web":7}],15:[function(require,module,exports){
// source: public/clanevent.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var shared_shared_pb = require('../shared/shared_pb.js');
goog.object.extend(proto, shared_shared_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.public.clanevent.AckLastFinishedEventPopupInfo', null, global);
goog.exportSymbol('proto.public.clanevent.AckLastFinishedEventPopupInfo.Request', null, global);
goog.exportSymbol('proto.public.clanevent.AckLastFinishedEventPopupInfo.Response', null, global);
goog.exportSymbol('proto.public.clanevent.AckLastFinishedRaidPopupInfo', null, global);
goog.exportSymbol('proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request', null, global);
goog.exportSymbol('proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response', null, global);
goog.exportSymbol('proto.public.clanevent.Event', null, global);
goog.exportSymbol('proto.public.clanevent.Event.Status', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanEventInfo', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanEventInfo.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanEventInfo.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanEventInfo.Response.Score', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanLeaderboard', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanLeaderboard.Params', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanLeaderboard.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanLeaderboard.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanLeaderboard.Response.Clan', null, global);
goog.exportSymbol('proto.public.clanevent.GetCurrentEvent', null, global);
goog.exportSymbol('proto.public.clanevent.GetCurrentEvent.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetCurrentEvent.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetCurrentRaid', null, global);
goog.exportSymbol('proto.public.clanevent.GetCurrentRaid.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetCurrentRaid.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetCurrentRaid.Response.DataCase', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedEventPopupInfo', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedEventPopupInfo.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedEventPopupInfo.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedRaidPopupInfo', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup', null, global);
goog.exportSymbol('proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.Status', null, global);
goog.exportSymbol('proto.public.clanevent.GetLeaderboardViewEvent', null, global);
goog.exportSymbol('proto.public.clanevent.GetLeaderboardViewEvent.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetLeaderboardViewEvent.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetPlayerLeaderboard', null, global);
goog.exportSymbol('proto.public.clanevent.GetPlayerLeaderboard.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetPlayerLeaderboard.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetPlayerLeaderboard.Response.Player', null, global);
goog.exportSymbol('proto.public.clanevent.GetPreviousEvent', null, global);
goog.exportSymbol('proto.public.clanevent.GetPreviousEvent.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetPreviousEvent.Response', null, global);
goog.exportSymbol('proto.public.clanevent.NewRaid', null, global);
goog.exportSymbol('proto.public.clanevent.OngoingRaid', null, global);
goog.exportSymbol('proto.public.clanevent.StartRaid', null, global);
goog.exportSymbol('proto.public.clanevent.StartRaid.ErrorCode', null, global);
goog.exportSymbol('proto.public.clanevent.StartRaid.Request', null, global);
goog.exportSymbol('proto.public.clanevent.StartRaid.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetCurrentRaid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetCurrentRaid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetCurrentRaid.displayName = 'proto.public.clanevent.GetCurrentRaid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetCurrentRaid.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetCurrentRaid.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetCurrentRaid.Request.displayName = 'proto.public.clanevent.GetCurrentRaid.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetCurrentRaid.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.public.clanevent.GetCurrentRaid.Response.oneofGroups_);
};
goog.inherits(proto.public.clanevent.GetCurrentRaid.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetCurrentRaid.Response.displayName = 'proto.public.clanevent.GetCurrentRaid.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.StartRaid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.StartRaid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.StartRaid.displayName = 'proto.public.clanevent.StartRaid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.StartRaid.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.StartRaid.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.StartRaid.Request.displayName = 'proto.public.clanevent.StartRaid.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.StartRaid.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.StartRaid.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.StartRaid.Response.displayName = 'proto.public.clanevent.StartRaid.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.NewRaid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.NewRaid.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.NewRaid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.NewRaid.displayName = 'proto.public.clanevent.NewRaid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.OngoingRaid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.OngoingRaid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.OngoingRaid.displayName = 'proto.public.clanevent.OngoingRaid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.Event.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.Event.displayName = 'proto.public.clanevent.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetCurrentEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetCurrentEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetCurrentEvent.displayName = 'proto.public.clanevent.GetCurrentEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetCurrentEvent.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetCurrentEvent.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetCurrentEvent.Request.displayName = 'proto.public.clanevent.GetCurrentEvent.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetCurrentEvent.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetCurrentEvent.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetCurrentEvent.Response.displayName = 'proto.public.clanevent.GetCurrentEvent.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetPreviousEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetPreviousEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetPreviousEvent.displayName = 'proto.public.clanevent.GetPreviousEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetPreviousEvent.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetPreviousEvent.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetPreviousEvent.Request.displayName = 'proto.public.clanevent.GetPreviousEvent.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetPreviousEvent.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetPreviousEvent.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetPreviousEvent.Response.displayName = 'proto.public.clanevent.GetPreviousEvent.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLeaderboardViewEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLeaderboardViewEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLeaderboardViewEvent.displayName = 'proto.public.clanevent.GetLeaderboardViewEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLeaderboardViewEvent.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLeaderboardViewEvent.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLeaderboardViewEvent.Request.displayName = 'proto.public.clanevent.GetLeaderboardViewEvent.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLeaderboardViewEvent.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLeaderboardViewEvent.Response.displayName = 'proto.public.clanevent.GetLeaderboardViewEvent.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanEventInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanEventInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanEventInfo.displayName = 'proto.public.clanevent.GetClanEventInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanEventInfo.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanEventInfo.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanEventInfo.Request.displayName = 'proto.public.clanevent.GetClanEventInfo.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanEventInfo.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanEventInfo.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanEventInfo.Response.displayName = 'proto.public.clanevent.GetClanEventInfo.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanEventInfo.Response.Score = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanEventInfo.Response.Score, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanEventInfo.Response.Score.displayName = 'proto.public.clanevent.GetClanEventInfo.Response.Score';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetPlayerLeaderboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetPlayerLeaderboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetPlayerLeaderboard.displayName = 'proto.public.clanevent.GetPlayerLeaderboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetPlayerLeaderboard.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetPlayerLeaderboard.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetPlayerLeaderboard.Request.displayName = 'proto.public.clanevent.GetPlayerLeaderboard.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetPlayerLeaderboard.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetPlayerLeaderboard.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetPlayerLeaderboard.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetPlayerLeaderboard.Response.displayName = 'proto.public.clanevent.GetPlayerLeaderboard.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetPlayerLeaderboard.Response.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetPlayerLeaderboard.Response.Player.displayName = 'proto.public.clanevent.GetPlayerLeaderboard.Response.Player';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanLeaderboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanLeaderboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanLeaderboard.displayName = 'proto.public.clanevent.GetClanLeaderboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanLeaderboard.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanLeaderboard.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanLeaderboard.Request.displayName = 'proto.public.clanevent.GetClanLeaderboard.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanLeaderboard.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetClanLeaderboard.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetClanLeaderboard.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanLeaderboard.Response.displayName = 'proto.public.clanevent.GetClanLeaderboard.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanLeaderboard.Response.Clan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanLeaderboard.Response.Clan.displayName = 'proto.public.clanevent.GetClanLeaderboard.Response.Clan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanLeaderboard.Params = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanLeaderboard.Params, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanLeaderboard.Params.displayName = 'proto.public.clanevent.GetClanLeaderboard.Params';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLastFinishedRaidPopupInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.displayName = 'proto.public.clanevent.GetLastFinishedRaidPopupInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.displayName = 'proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.displayName = 'proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.displayName = 'proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AckLastFinishedRaidPopupInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.displayName = 'proto.public.clanevent.AckLastFinishedRaidPopupInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.displayName = 'proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.displayName = 'proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLastFinishedEventPopupInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLastFinishedEventPopupInfo.displayName = 'proto.public.clanevent.GetLastFinishedEventPopupInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLastFinishedEventPopupInfo.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.displayName = 'proto.public.clanevent.GetLastFinishedEventPopupInfo.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLastFinishedEventPopupInfo.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.displayName = 'proto.public.clanevent.GetLastFinishedEventPopupInfo.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.displayName = 'proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AckLastFinishedEventPopupInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AckLastFinishedEventPopupInfo.displayName = 'proto.public.clanevent.AckLastFinishedEventPopupInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AckLastFinishedEventPopupInfo.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.displayName = 'proto.public.clanevent.AckLastFinishedEventPopupInfo.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AckLastFinishedEventPopupInfo.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.displayName = 'proto.public.clanevent.AckLastFinishedEventPopupInfo.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetCurrentRaid.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetCurrentRaid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetCurrentRaid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentRaid.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetCurrentRaid}
 */
proto.public.clanevent.GetCurrentRaid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetCurrentRaid;
  return proto.public.clanevent.GetCurrentRaid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetCurrentRaid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetCurrentRaid}
 */
proto.public.clanevent.GetCurrentRaid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetCurrentRaid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetCurrentRaid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetCurrentRaid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentRaid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetCurrentRaid.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetCurrentRaid.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetCurrentRaid.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentRaid.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetCurrentRaid.Request}
 */
proto.public.clanevent.GetCurrentRaid.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetCurrentRaid.Request;
  return proto.public.clanevent.GetCurrentRaid.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetCurrentRaid.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetCurrentRaid.Request}
 */
proto.public.clanevent.GetCurrentRaid.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetCurrentRaid.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetCurrentRaid.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetCurrentRaid.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentRaid.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.public.clanevent.GetCurrentRaid.Response.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.public.clanevent.GetCurrentRaid.Response.DataCase = {
  DATA_NOT_SET: 0,
  NEW_RAID: 1,
  ONGOING_RAID: 2
};

/**
 * @return {proto.public.clanevent.GetCurrentRaid.Response.DataCase}
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.getDataCase = function() {
  return /** @type {proto.public.clanevent.GetCurrentRaid.Response.DataCase} */(jspb.Message.computeOneofCase(this, proto.public.clanevent.GetCurrentRaid.Response.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetCurrentRaid.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetCurrentRaid.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentRaid.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    newRaid: (f = msg.getNewRaid()) && proto.public.clanevent.NewRaid.toObject(includeInstance, f),
    ongoingRaid: (f = msg.getOngoingRaid()) && proto.public.clanevent.OngoingRaid.toObject(includeInstance, f),
    canUserStartRaid: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetCurrentRaid.Response}
 */
proto.public.clanevent.GetCurrentRaid.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetCurrentRaid.Response;
  return proto.public.clanevent.GetCurrentRaid.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetCurrentRaid.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetCurrentRaid.Response}
 */
proto.public.clanevent.GetCurrentRaid.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.NewRaid;
      reader.readMessage(value,proto.public.clanevent.NewRaid.deserializeBinaryFromReader);
      msg.setNewRaid(value);
      break;
    case 2:
      var value = new proto.public.clanevent.OngoingRaid;
      reader.readMessage(value,proto.public.clanevent.OngoingRaid.deserializeBinaryFromReader);
      msg.setOngoingRaid(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanUserStartRaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetCurrentRaid.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetCurrentRaid.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentRaid.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewRaid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.NewRaid.serializeBinaryToWriter
    );
  }
  f = message.getOngoingRaid();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.clanevent.OngoingRaid.serializeBinaryToWriter
    );
  }
  f = message.getCanUserStartRaid();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional NewRaid new_raid = 1;
 * @return {?proto.public.clanevent.NewRaid}
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.getNewRaid = function() {
  return /** @type{?proto.public.clanevent.NewRaid} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.NewRaid, 1));
};


/**
 * @param {?proto.public.clanevent.NewRaid|undefined} value
 * @return {!proto.public.clanevent.GetCurrentRaid.Response} returns this
*/
proto.public.clanevent.GetCurrentRaid.Response.prototype.setNewRaid = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.public.clanevent.GetCurrentRaid.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetCurrentRaid.Response} returns this
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.clearNewRaid = function() {
  return this.setNewRaid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.hasNewRaid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OngoingRaid ongoing_raid = 2;
 * @return {?proto.public.clanevent.OngoingRaid}
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.getOngoingRaid = function() {
  return /** @type{?proto.public.clanevent.OngoingRaid} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.OngoingRaid, 2));
};


/**
 * @param {?proto.public.clanevent.OngoingRaid|undefined} value
 * @return {!proto.public.clanevent.GetCurrentRaid.Response} returns this
*/
proto.public.clanevent.GetCurrentRaid.Response.prototype.setOngoingRaid = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.public.clanevent.GetCurrentRaid.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetCurrentRaid.Response} returns this
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.clearOngoingRaid = function() {
  return this.setOngoingRaid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.hasOngoingRaid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool can_user_start_raid = 3;
 * @return {boolean}
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.getCanUserStartRaid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clanevent.GetCurrentRaid.Response} returns this
 */
proto.public.clanevent.GetCurrentRaid.Response.prototype.setCanUserStartRaid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.StartRaid.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.StartRaid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.StartRaid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.StartRaid.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.StartRaid}
 */
proto.public.clanevent.StartRaid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.StartRaid;
  return proto.public.clanevent.StartRaid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.StartRaid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.StartRaid}
 */
proto.public.clanevent.StartRaid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.StartRaid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.StartRaid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.StartRaid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.StartRaid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.public.clanevent.StartRaid.ErrorCode = {
  UNKNOWN: 0,
  PLAYER_NOT_LEADER: 1,
  INSUFFICIENT_FUNDS: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.StartRaid.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.StartRaid.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.StartRaid.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.StartRaid.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    raidLevel: jspb.Message.getFieldWithDefault(msg, 1, 0),
    raidCounter: jspb.Message.getFieldWithDefault(msg, 2, 0),
    difficultyValue: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.StartRaid.Request}
 */
proto.public.clanevent.StartRaid.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.StartRaid.Request;
  return proto.public.clanevent.StartRaid.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.StartRaid.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.StartRaid.Request}
 */
proto.public.clanevent.StartRaid.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRaidLevel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRaidCounter(value);
      break;
    case 3:
      var value = /** @type {!proto.shared.clanevent.DifficultyValue} */ (reader.readEnum());
      msg.setDifficultyValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.StartRaid.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.StartRaid.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.StartRaid.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.StartRaid.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRaidLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRaidCounter();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDifficultyValue();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 raid_level = 1;
 * @return {number}
 */
proto.public.clanevent.StartRaid.Request.prototype.getRaidLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.StartRaid.Request} returns this
 */
proto.public.clanevent.StartRaid.Request.prototype.setRaidLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 raid_counter = 2;
 * @return {number}
 */
proto.public.clanevent.StartRaid.Request.prototype.getRaidCounter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.StartRaid.Request} returns this
 */
proto.public.clanevent.StartRaid.Request.prototype.setRaidCounter = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional shared.clanevent.DifficultyValue difficulty_value = 3;
 * @return {!proto.shared.clanevent.DifficultyValue}
 */
proto.public.clanevent.StartRaid.Request.prototype.getDifficultyValue = function() {
  return /** @type {!proto.shared.clanevent.DifficultyValue} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.shared.clanevent.DifficultyValue} value
 * @return {!proto.public.clanevent.StartRaid.Request} returns this
 */
proto.public.clanevent.StartRaid.Request.prototype.setDifficultyValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.StartRaid.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.StartRaid.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.StartRaid.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.StartRaid.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    ongoingRaid: (f = msg.getOngoingRaid()) && proto.public.clanevent.OngoingRaid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.StartRaid.Response}
 */
proto.public.clanevent.StartRaid.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.StartRaid.Response;
  return proto.public.clanevent.StartRaid.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.StartRaid.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.StartRaid.Response}
 */
proto.public.clanevent.StartRaid.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.OngoingRaid;
      reader.readMessage(value,proto.public.clanevent.OngoingRaid.deserializeBinaryFromReader);
      msg.setOngoingRaid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.StartRaid.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.StartRaid.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.StartRaid.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.StartRaid.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOngoingRaid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.OngoingRaid.serializeBinaryToWriter
    );
  }
};


/**
 * optional OngoingRaid ongoing_raid = 1;
 * @return {?proto.public.clanevent.OngoingRaid}
 */
proto.public.clanevent.StartRaid.Response.prototype.getOngoingRaid = function() {
  return /** @type{?proto.public.clanevent.OngoingRaid} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.OngoingRaid, 1));
};


/**
 * @param {?proto.public.clanevent.OngoingRaid|undefined} value
 * @return {!proto.public.clanevent.StartRaid.Response} returns this
*/
proto.public.clanevent.StartRaid.Response.prototype.setOngoingRaid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.StartRaid.Response} returns this
 */
proto.public.clanevent.StartRaid.Response.prototype.clearOngoingRaid = function() {
  return this.setOngoingRaid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.StartRaid.Response.prototype.hasOngoingRaid = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.NewRaid.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.NewRaid.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.NewRaid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.NewRaid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.NewRaid.toObject = function(includeInstance, msg) {
  var f, obj = {
    raidLevel: jspb.Message.getFieldWithDefault(msg, 1, 0),
    raidCounter: jspb.Message.getFieldWithDefault(msg, 2, 0),
    difficultiesList: jspb.Message.toObjectList(msg.getDifficultiesList(),
    shared_shared_pb.DifficultyConfig.toObject, includeInstance),
    bonus: (f = msg.getBonus()) && shared_shared_pb.Bonus.toObject(includeInstance, f),
    price: jspb.Message.getFieldWithDefault(msg, 5, 0),
    durationSeconds: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.NewRaid}
 */
proto.public.clanevent.NewRaid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.NewRaid;
  return proto.public.clanevent.NewRaid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.NewRaid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.NewRaid}
 */
proto.public.clanevent.NewRaid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRaidLevel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRaidCounter(value);
      break;
    case 3:
      var value = new shared_shared_pb.DifficultyConfig;
      reader.readMessage(value,shared_shared_pb.DifficultyConfig.deserializeBinaryFromReader);
      msg.addDifficulties(value);
      break;
    case 4:
      var value = new shared_shared_pb.Bonus;
      reader.readMessage(value,shared_shared_pb.Bonus.deserializeBinaryFromReader);
      msg.setBonus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDurationSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.NewRaid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.NewRaid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.NewRaid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.NewRaid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRaidLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRaidCounter();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDifficultiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      shared_shared_pb.DifficultyConfig.serializeBinaryToWriter
    );
  }
  f = message.getBonus();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_shared_pb.Bonus.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getDurationSeconds();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int64 raid_level = 1;
 * @return {number}
 */
proto.public.clanevent.NewRaid.prototype.getRaidLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.NewRaid} returns this
 */
proto.public.clanevent.NewRaid.prototype.setRaidLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 raid_counter = 2;
 * @return {number}
 */
proto.public.clanevent.NewRaid.prototype.getRaidCounter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.NewRaid} returns this
 */
proto.public.clanevent.NewRaid.prototype.setRaidCounter = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated shared.clanevent.DifficultyConfig difficulties = 3;
 * @return {!Array<!proto.shared.clanevent.DifficultyConfig>}
 */
proto.public.clanevent.NewRaid.prototype.getDifficultiesList = function() {
  return /** @type{!Array<!proto.shared.clanevent.DifficultyConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.DifficultyConfig, 3));
};


/**
 * @param {!Array<!proto.shared.clanevent.DifficultyConfig>} value
 * @return {!proto.public.clanevent.NewRaid} returns this
*/
proto.public.clanevent.NewRaid.prototype.setDifficultiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.shared.clanevent.DifficultyConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.DifficultyConfig}
 */
proto.public.clanevent.NewRaid.prototype.addDifficulties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.shared.clanevent.DifficultyConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.NewRaid} returns this
 */
proto.public.clanevent.NewRaid.prototype.clearDifficultiesList = function() {
  return this.setDifficultiesList([]);
};


/**
 * optional shared.clanevent.Bonus bonus = 4;
 * @return {?proto.shared.clanevent.Bonus}
 */
proto.public.clanevent.NewRaid.prototype.getBonus = function() {
  return /** @type{?proto.shared.clanevent.Bonus} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.Bonus, 4));
};


/**
 * @param {?proto.shared.clanevent.Bonus|undefined} value
 * @return {!proto.public.clanevent.NewRaid} returns this
*/
proto.public.clanevent.NewRaid.prototype.setBonus = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.NewRaid} returns this
 */
proto.public.clanevent.NewRaid.prototype.clearBonus = function() {
  return this.setBonus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.NewRaid.prototype.hasBonus = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 price = 5;
 * @return {number}
 */
proto.public.clanevent.NewRaid.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.NewRaid} returns this
 */
proto.public.clanevent.NewRaid.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 duration_seconds = 6;
 * @return {number}
 */
proto.public.clanevent.NewRaid.prototype.getDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.NewRaid} returns this
 */
proto.public.clanevent.NewRaid.prototype.setDurationSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.OngoingRaid.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.OngoingRaid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.OngoingRaid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.OngoingRaid.toObject = function(includeInstance, msg) {
  var f, obj = {
    raidId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    raidLevel: jspb.Message.getFieldWithDefault(msg, 2, 0),
    raidCounter: jspb.Message.getFieldWithDefault(msg, 3, 0),
    difficulty: (f = msg.getDifficulty()) && shared_shared_pb.DifficultyConfig.toObject(includeInstance, f),
    finishDateUnix: (f = msg.getFinishDateUnix()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.OngoingRaid}
 */
proto.public.clanevent.OngoingRaid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.OngoingRaid;
  return proto.public.clanevent.OngoingRaid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.OngoingRaid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.OngoingRaid}
 */
proto.public.clanevent.OngoingRaid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRaidId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRaidLevel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRaidCounter(value);
      break;
    case 4:
      var value = new shared_shared_pb.DifficultyConfig;
      reader.readMessage(value,shared_shared_pb.DifficultyConfig.deserializeBinaryFromReader);
      msg.setDifficulty(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishDateUnix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.OngoingRaid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.OngoingRaid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.OngoingRaid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.OngoingRaid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRaidId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRaidLevel();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRaidCounter();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDifficulty();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_shared_pb.DifficultyConfig.serializeBinaryToWriter
    );
  }
  f = message.getFinishDateUnix();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string raid_id = 1;
 * @return {string}
 */
proto.public.clanevent.OngoingRaid.prototype.getRaidId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.OngoingRaid} returns this
 */
proto.public.clanevent.OngoingRaid.prototype.setRaidId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 raid_level = 2;
 * @return {number}
 */
proto.public.clanevent.OngoingRaid.prototype.getRaidLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.OngoingRaid} returns this
 */
proto.public.clanevent.OngoingRaid.prototype.setRaidLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 raid_counter = 3;
 * @return {number}
 */
proto.public.clanevent.OngoingRaid.prototype.getRaidCounter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.OngoingRaid} returns this
 */
proto.public.clanevent.OngoingRaid.prototype.setRaidCounter = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional shared.clanevent.DifficultyConfig difficulty = 4;
 * @return {?proto.shared.clanevent.DifficultyConfig}
 */
proto.public.clanevent.OngoingRaid.prototype.getDifficulty = function() {
  return /** @type{?proto.shared.clanevent.DifficultyConfig} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.DifficultyConfig, 4));
};


/**
 * @param {?proto.shared.clanevent.DifficultyConfig|undefined} value
 * @return {!proto.public.clanevent.OngoingRaid} returns this
*/
proto.public.clanevent.OngoingRaid.prototype.setDifficulty = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.OngoingRaid} returns this
 */
proto.public.clanevent.OngoingRaid.prototype.clearDifficulty = function() {
  return this.setDifficulty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.OngoingRaid.prototype.hasDifficulty = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp finish_date_unix = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.public.clanevent.OngoingRaid.prototype.getFinishDateUnix = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.public.clanevent.OngoingRaid} returns this
*/
proto.public.clanevent.OngoingRaid.prototype.setFinishDateUnix = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.OngoingRaid} returns this
 */
proto.public.clanevent.OngoingRaid.prototype.clearFinishDateUnix = function() {
  return this.setFinishDateUnix(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.OngoingRaid.prototype.hasFinishDateUnix = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.Event.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.Event.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    bannerUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endAt: (f = msg.getEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    rewardsList: jspb.Message.toObjectList(msg.getRewardsList(),
    shared_shared_pb.Event.RewardTier.toObject, includeInstance),
    raidProgressBoosts: (f = msg.getRaidProgressBoosts()) && shared_shared_pb.Raid.MissionProgressBoosts.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 8, ""),
    extensions: (f = msg.getExtensions()) && shared_shared_pb.EventExtension.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.Event}
 */
proto.public.clanevent.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.Event;
  return proto.public.clanevent.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.Event}
 */
proto.public.clanevent.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.public.clanevent.Event.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBannerUrl(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndAt(value);
      break;
    case 6:
      var value = new shared_shared_pb.Event.RewardTier;
      reader.readMessage(value,shared_shared_pb.Event.RewardTier.deserializeBinaryFromReader);
      msg.addRewards(value);
      break;
    case 7:
      var value = new shared_shared_pb.Raid.MissionProgressBoosts;
      reader.readMessage(value,shared_shared_pb.Raid.MissionProgressBoosts.deserializeBinaryFromReader);
      msg.setRaidProgressBoosts(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 9:
      var value = new shared_shared_pb.EventExtension;
      reader.readMessage(value,shared_shared_pb.EventExtension.deserializeBinaryFromReader);
      msg.setExtensions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBannerUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRewardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      shared_shared_pb.Event.RewardTier.serializeBinaryToWriter
    );
  }
  f = message.getRaidProgressBoosts();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      shared_shared_pb.Raid.MissionProgressBoosts.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExtensions();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      shared_shared_pb.EventExtension.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.public.clanevent.Event.Status = {
  STATUS_UNKNOWN: 0,
  STATUS_FINISHING: 1,
  STATUS_ONGOING: 2,
  STATUS_UPCOMING: 3
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.public.clanevent.Event.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Status status = 2;
 * @return {!proto.public.clanevent.Event.Status}
 */
proto.public.clanevent.Event.prototype.getStatus = function() {
  return /** @type {!proto.public.clanevent.Event.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.public.clanevent.Event.Status} value
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string banner_url = 3;
 * @return {string}
 */
proto.public.clanevent.Event.prototype.getBannerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.setBannerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.public.clanevent.Event.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.public.clanevent.Event} returns this
*/
proto.public.clanevent.Event.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.Event.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp end_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.public.clanevent.Event.prototype.getEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.public.clanevent.Event} returns this
*/
proto.public.clanevent.Event.prototype.setEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.clearEndAt = function() {
  return this.setEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.Event.prototype.hasEndAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated shared.clanevent.Event.RewardTier rewards = 6;
 * @return {!Array<!proto.shared.clanevent.Event.RewardTier>}
 */
proto.public.clanevent.Event.prototype.getRewardsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Event.RewardTier>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.Event.RewardTier, 6));
};


/**
 * @param {!Array<!proto.shared.clanevent.Event.RewardTier>} value
 * @return {!proto.public.clanevent.Event} returns this
*/
proto.public.clanevent.Event.prototype.setRewardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.shared.clanevent.Event.RewardTier=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Event.RewardTier}
 */
proto.public.clanevent.Event.prototype.addRewards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.shared.clanevent.Event.RewardTier, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.clearRewardsList = function() {
  return this.setRewardsList([]);
};


/**
 * optional shared.clanevent.Raid.MissionProgressBoosts raid_progress_boosts = 7;
 * @return {?proto.shared.clanevent.Raid.MissionProgressBoosts}
 */
proto.public.clanevent.Event.prototype.getRaidProgressBoosts = function() {
  return /** @type{?proto.shared.clanevent.Raid.MissionProgressBoosts} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.Raid.MissionProgressBoosts, 7));
};


/**
 * @param {?proto.shared.clanevent.Raid.MissionProgressBoosts|undefined} value
 * @return {!proto.public.clanevent.Event} returns this
*/
proto.public.clanevent.Event.prototype.setRaidProgressBoosts = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.clearRaidProgressBoosts = function() {
  return this.setRaidProgressBoosts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.Event.prototype.hasRaidProgressBoosts = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string id = 8;
 * @return {string}
 */
proto.public.clanevent.Event.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional shared.clanevent.EventExtension extensions = 9;
 * @return {?proto.shared.clanevent.EventExtension}
 */
proto.public.clanevent.Event.prototype.getExtensions = function() {
  return /** @type{?proto.shared.clanevent.EventExtension} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.EventExtension, 9));
};


/**
 * @param {?proto.shared.clanevent.EventExtension|undefined} value
 * @return {!proto.public.clanevent.Event} returns this
*/
proto.public.clanevent.Event.prototype.setExtensions = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.Event} returns this
 */
proto.public.clanevent.Event.prototype.clearExtensions = function() {
  return this.setExtensions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.Event.prototype.hasExtensions = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetCurrentEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetCurrentEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetCurrentEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentEvent.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetCurrentEvent}
 */
proto.public.clanevent.GetCurrentEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetCurrentEvent;
  return proto.public.clanevent.GetCurrentEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetCurrentEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetCurrentEvent}
 */
proto.public.clanevent.GetCurrentEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetCurrentEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetCurrentEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetCurrentEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetCurrentEvent.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetCurrentEvent.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetCurrentEvent.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentEvent.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetCurrentEvent.Request}
 */
proto.public.clanevent.GetCurrentEvent.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetCurrentEvent.Request;
  return proto.public.clanevent.GetCurrentEvent.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetCurrentEvent.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetCurrentEvent.Request}
 */
proto.public.clanevent.GetCurrentEvent.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetCurrentEvent.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetCurrentEvent.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetCurrentEvent.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentEvent.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetCurrentEvent.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetCurrentEvent.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetCurrentEvent.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentEvent.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    event: (f = msg.getEvent()) && proto.public.clanevent.Event.toObject(includeInstance, f),
    canUserContribute: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetCurrentEvent.Response}
 */
proto.public.clanevent.GetCurrentEvent.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetCurrentEvent.Response;
  return proto.public.clanevent.GetCurrentEvent.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetCurrentEvent.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetCurrentEvent.Response}
 */
proto.public.clanevent.GetCurrentEvent.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.Event;
      reader.readMessage(value,proto.public.clanevent.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanUserContribute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetCurrentEvent.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetCurrentEvent.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetCurrentEvent.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetCurrentEvent.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.Event.serializeBinaryToWriter
    );
  }
  f = message.getCanUserContribute();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional Event event = 1;
 * @return {?proto.public.clanevent.Event}
 */
proto.public.clanevent.GetCurrentEvent.Response.prototype.getEvent = function() {
  return /** @type{?proto.public.clanevent.Event} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.Event, 1));
};


/**
 * @param {?proto.public.clanevent.Event|undefined} value
 * @return {!proto.public.clanevent.GetCurrentEvent.Response} returns this
*/
proto.public.clanevent.GetCurrentEvent.Response.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetCurrentEvent.Response} returns this
 */
proto.public.clanevent.GetCurrentEvent.Response.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetCurrentEvent.Response.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool can_user_contribute = 2;
 * @return {boolean}
 */
proto.public.clanevent.GetCurrentEvent.Response.prototype.getCanUserContribute = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clanevent.GetCurrentEvent.Response} returns this
 */
proto.public.clanevent.GetCurrentEvent.Response.prototype.setCanUserContribute = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetPreviousEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetPreviousEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetPreviousEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPreviousEvent.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetPreviousEvent}
 */
proto.public.clanevent.GetPreviousEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetPreviousEvent;
  return proto.public.clanevent.GetPreviousEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetPreviousEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetPreviousEvent}
 */
proto.public.clanevent.GetPreviousEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetPreviousEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetPreviousEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetPreviousEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPreviousEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetPreviousEvent.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetPreviousEvent.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetPreviousEvent.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPreviousEvent.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetPreviousEvent.Request}
 */
proto.public.clanevent.GetPreviousEvent.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetPreviousEvent.Request;
  return proto.public.clanevent.GetPreviousEvent.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetPreviousEvent.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetPreviousEvent.Request}
 */
proto.public.clanevent.GetPreviousEvent.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetPreviousEvent.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetPreviousEvent.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetPreviousEvent.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPreviousEvent.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetPreviousEvent.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetPreviousEvent.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetPreviousEvent.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPreviousEvent.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    event: (f = msg.getEvent()) && proto.public.clanevent.Event.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetPreviousEvent.Response}
 */
proto.public.clanevent.GetPreviousEvent.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetPreviousEvent.Response;
  return proto.public.clanevent.GetPreviousEvent.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetPreviousEvent.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetPreviousEvent.Response}
 */
proto.public.clanevent.GetPreviousEvent.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.Event;
      reader.readMessage(value,proto.public.clanevent.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetPreviousEvent.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetPreviousEvent.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetPreviousEvent.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPreviousEvent.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.Event.serializeBinaryToWriter
    );
  }
};


/**
 * optional Event event = 1;
 * @return {?proto.public.clanevent.Event}
 */
proto.public.clanevent.GetPreviousEvent.Response.prototype.getEvent = function() {
  return /** @type{?proto.public.clanevent.Event} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.Event, 1));
};


/**
 * @param {?proto.public.clanevent.Event|undefined} value
 * @return {!proto.public.clanevent.GetPreviousEvent.Response} returns this
*/
proto.public.clanevent.GetPreviousEvent.Response.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetPreviousEvent.Response} returns this
 */
proto.public.clanevent.GetPreviousEvent.Response.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetPreviousEvent.Response.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLeaderboardViewEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLeaderboardViewEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLeaderboardViewEvent.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLeaderboardViewEvent}
 */
proto.public.clanevent.GetLeaderboardViewEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLeaderboardViewEvent;
  return proto.public.clanevent.GetLeaderboardViewEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLeaderboardViewEvent}
 */
proto.public.clanevent.GetLeaderboardViewEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLeaderboardViewEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLeaderboardViewEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLeaderboardViewEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLeaderboardViewEvent.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLeaderboardViewEvent.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLeaderboardViewEvent.Request}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLeaderboardViewEvent.Request;
  return proto.public.clanevent.GetLeaderboardViewEvent.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLeaderboardViewEvent.Request}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLeaderboardViewEvent.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLeaderboardViewEvent.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLeaderboardViewEvent.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    event: (f = msg.getEvent()) && proto.public.clanevent.Event.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLeaderboardViewEvent.Response}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLeaderboardViewEvent.Response;
  return proto.public.clanevent.GetLeaderboardViewEvent.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLeaderboardViewEvent.Response}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.Event;
      reader.readMessage(value,proto.public.clanevent.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLeaderboardViewEvent.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLeaderboardViewEvent.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.Event.serializeBinaryToWriter
    );
  }
};


/**
 * optional Event event = 1;
 * @return {?proto.public.clanevent.Event}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.prototype.getEvent = function() {
  return /** @type{?proto.public.clanevent.Event} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.Event, 1));
};


/**
 * @param {?proto.public.clanevent.Event|undefined} value
 * @return {!proto.public.clanevent.GetLeaderboardViewEvent.Response} returns this
*/
proto.public.clanevent.GetLeaderboardViewEvent.Response.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetLeaderboardViewEvent.Response} returns this
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetLeaderboardViewEvent.Response.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanEventInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanEventInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanEventInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanEventInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanEventInfo}
 */
proto.public.clanevent.GetClanEventInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanEventInfo;
  return proto.public.clanevent.GetClanEventInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanEventInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanEventInfo}
 */
proto.public.clanevent.GetClanEventInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanEventInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanEventInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanEventInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanEventInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanEventInfo.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanEventInfo.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanEventInfo.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanEventInfo.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanEventInfo.Request}
 */
proto.public.clanevent.GetClanEventInfo.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanEventInfo.Request;
  return proto.public.clanevent.GetClanEventInfo.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanEventInfo.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanEventInfo.Request}
 */
proto.public.clanevent.GetClanEventInfo.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanEventInfo.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanEventInfo.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanEventInfo.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanEventInfo.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.public.clanevent.GetClanEventInfo.Request.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetClanEventInfo.Request} returns this
 */
proto.public.clanevent.GetClanEventInfo.Request.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanEventInfo.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanEventInfo.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanEventInfo.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanEventInfo.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    clanScore: (f = msg.getClanScore()) && proto.public.clanevent.GetClanEventInfo.Response.Score.toObject(includeInstance, f),
    playerScore: (f = msg.getPlayerScore()) && proto.public.clanevent.GetClanEventInfo.Response.Score.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanEventInfo.Response}
 */
proto.public.clanevent.GetClanEventInfo.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanEventInfo.Response;
  return proto.public.clanevent.GetClanEventInfo.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanEventInfo.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanEventInfo.Response}
 */
proto.public.clanevent.GetClanEventInfo.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.GetClanEventInfo.Response.Score;
      reader.readMessage(value,proto.public.clanevent.GetClanEventInfo.Response.Score.deserializeBinaryFromReader);
      msg.setClanScore(value);
      break;
    case 2:
      var value = new proto.public.clanevent.GetClanEventInfo.Response.Score;
      reader.readMessage(value,proto.public.clanevent.GetClanEventInfo.Response.Score.deserializeBinaryFromReader);
      msg.setPlayerScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanEventInfo.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanEventInfo.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanEventInfo.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanEventInfo.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClanScore();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.GetClanEventInfo.Response.Score.serializeBinaryToWriter
    );
  }
  f = message.getPlayerScore();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.clanevent.GetClanEventInfo.Response.Score.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanEventInfo.Response.Score.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanEventInfo.Response.Score} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.toObject = function(includeInstance, msg) {
  var f, obj = {
    militaryPoints: jspb.Message.getFieldWithDefault(msg, 1, 0),
    economicPoints: jspb.Message.getFieldWithDefault(msg, 2, 0),
    position: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanEventInfo.Response.Score}
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanEventInfo.Response.Score;
  return proto.public.clanevent.GetClanEventInfo.Response.Score.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanEventInfo.Response.Score} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanEventInfo.Response.Score}
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMilitaryPoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEconomicPoints(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanEventInfo.Response.Score.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanEventInfo.Response.Score} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMilitaryPoints();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEconomicPoints();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 military_points = 1;
 * @return {number}
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.prototype.getMilitaryPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanEventInfo.Response.Score} returns this
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.prototype.setMilitaryPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 economic_points = 2;
 * @return {number}
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.prototype.getEconomicPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanEventInfo.Response.Score} returns this
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.prototype.setEconomicPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 position = 3;
 * @return {number}
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanEventInfo.Response.Score} returns this
 */
proto.public.clanevent.GetClanEventInfo.Response.Score.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Score clan_score = 1;
 * @return {?proto.public.clanevent.GetClanEventInfo.Response.Score}
 */
proto.public.clanevent.GetClanEventInfo.Response.prototype.getClanScore = function() {
  return /** @type{?proto.public.clanevent.GetClanEventInfo.Response.Score} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetClanEventInfo.Response.Score, 1));
};


/**
 * @param {?proto.public.clanevent.GetClanEventInfo.Response.Score|undefined} value
 * @return {!proto.public.clanevent.GetClanEventInfo.Response} returns this
*/
proto.public.clanevent.GetClanEventInfo.Response.prototype.setClanScore = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetClanEventInfo.Response} returns this
 */
proto.public.clanevent.GetClanEventInfo.Response.prototype.clearClanScore = function() {
  return this.setClanScore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetClanEventInfo.Response.prototype.hasClanScore = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Score player_score = 2;
 * @return {?proto.public.clanevent.GetClanEventInfo.Response.Score}
 */
proto.public.clanevent.GetClanEventInfo.Response.prototype.getPlayerScore = function() {
  return /** @type{?proto.public.clanevent.GetClanEventInfo.Response.Score} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetClanEventInfo.Response.Score, 2));
};


/**
 * @param {?proto.public.clanevent.GetClanEventInfo.Response.Score|undefined} value
 * @return {!proto.public.clanevent.GetClanEventInfo.Response} returns this
*/
proto.public.clanevent.GetClanEventInfo.Response.prototype.setPlayerScore = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetClanEventInfo.Response} returns this
 */
proto.public.clanevent.GetClanEventInfo.Response.prototype.clearPlayerScore = function() {
  return this.setPlayerScore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetClanEventInfo.Response.prototype.hasPlayerScore = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetPlayerLeaderboard.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetPlayerLeaderboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetPlayerLeaderboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPlayerLeaderboard.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard}
 */
proto.public.clanevent.GetPlayerLeaderboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetPlayerLeaderboard;
  return proto.public.clanevent.GetPlayerLeaderboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetPlayerLeaderboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard}
 */
proto.public.clanevent.GetPlayerLeaderboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetPlayerLeaderboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetPlayerLeaderboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetPlayerLeaderboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPlayerLeaderboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetPlayerLeaderboard.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetPlayerLeaderboard.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPlayerLeaderboard.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Request}
 */
proto.public.clanevent.GetPlayerLeaderboard.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetPlayerLeaderboard.Request;
  return proto.public.clanevent.GetPlayerLeaderboard.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Request}
 */
proto.public.clanevent.GetPlayerLeaderboard.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetPlayerLeaderboard.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetPlayerLeaderboard.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPlayerLeaderboard.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.public.clanevent.GetPlayerLeaderboard.Request.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Request} returns this
 */
proto.public.clanevent.GetPlayerLeaderboard.Request.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetPlayerLeaderboard.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    leaderboardList: jspb.Message.toObjectList(msg.getLeaderboardList(),
    proto.public.clanevent.GetPlayerLeaderboard.Response.Player.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetPlayerLeaderboard.Response;
  return proto.public.clanevent.GetPlayerLeaderboard.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.GetPlayerLeaderboard.Response.Player;
      reader.readMessage(value,proto.public.clanevent.GetPlayerLeaderboard.Response.Player.deserializeBinaryFromReader);
      msg.addLeaderboard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetPlayerLeaderboard.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeaderboardList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.public.clanevent.GetPlayerLeaderboard.Response.Player.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetPlayerLeaderboard.Response.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rank: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orbsDonated: jspb.Message.getFieldWithDefault(msg, 3, 0),
    militaryScore: jspb.Message.getFieldWithDefault(msg, 4, 0),
    economicScore: jspb.Message.getFieldWithDefault(msg, 5, 0),
    totalScore: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetPlayerLeaderboard.Response.Player;
  return proto.public.clanevent.GetPlayerLeaderboard.Response.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRank(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrbsDonated(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMilitaryScore(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEconomicScore(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetPlayerLeaderboard.Response.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOrbsDonated();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMilitaryScore();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEconomicScore();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getTotalScore();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} returns this
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 rank = 2;
 * @return {number}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} returns this
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 orbs_donated = 3;
 * @return {number}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.getOrbsDonated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} returns this
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.setOrbsDonated = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 military_score = 4;
 * @return {number}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.getMilitaryScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} returns this
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.setMilitaryScore = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 economic_score = 5;
 * @return {number}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.getEconomicScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} returns this
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.setEconomicScore = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 total_score = 6;
 * @return {number}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.getTotalScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player} returns this
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.Player.prototype.setTotalScore = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated Player leaderboard = 1;
 * @return {!Array<!proto.public.clanevent.GetPlayerLeaderboard.Response.Player>}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.prototype.getLeaderboardList = function() {
  return /** @type{!Array<!proto.public.clanevent.GetPlayerLeaderboard.Response.Player>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.clanevent.GetPlayerLeaderboard.Response.Player, 1));
};


/**
 * @param {!Array<!proto.public.clanevent.GetPlayerLeaderboard.Response.Player>} value
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response} returns this
*/
proto.public.clanevent.GetPlayerLeaderboard.Response.prototype.setLeaderboardList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response.Player}
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.prototype.addLeaderboard = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.public.clanevent.GetPlayerLeaderboard.Response.Player, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetPlayerLeaderboard.Response} returns this
 */
proto.public.clanevent.GetPlayerLeaderboard.Response.prototype.clearLeaderboardList = function() {
  return this.setLeaderboardList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanLeaderboard.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanLeaderboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanLeaderboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanLeaderboard}
 */
proto.public.clanevent.GetClanLeaderboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanLeaderboard;
  return proto.public.clanevent.GetClanLeaderboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanLeaderboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanLeaderboard}
 */
proto.public.clanevent.GetClanLeaderboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanLeaderboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanLeaderboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanLeaderboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanLeaderboard.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanLeaderboard.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanLeaderboard.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    params: (f = msg.getParams()) && proto.public.clanevent.GetClanLeaderboard.Params.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Request}
 */
proto.public.clanevent.GetClanLeaderboard.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanLeaderboard.Request;
  return proto.public.clanevent.GetClanLeaderboard.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanLeaderboard.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Request}
 */
proto.public.clanevent.GetClanLeaderboard.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    case 2:
      var value = new proto.public.clanevent.GetClanLeaderboard.Params;
      reader.readMessage(value,proto.public.clanevent.GetClanLeaderboard.Params.deserializeBinaryFromReader);
      msg.setParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanLeaderboard.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanLeaderboard.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanLeaderboard.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParams();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.clanevent.GetClanLeaderboard.Params.serializeBinaryToWriter
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.public.clanevent.GetClanLeaderboard.Request.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Request} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Request.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Params params = 2;
 * @return {?proto.public.clanevent.GetClanLeaderboard.Params}
 */
proto.public.clanevent.GetClanLeaderboard.Request.prototype.getParams = function() {
  return /** @type{?proto.public.clanevent.GetClanLeaderboard.Params} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetClanLeaderboard.Params, 2));
};


/**
 * @param {?proto.public.clanevent.GetClanLeaderboard.Params|undefined} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Request} returns this
*/
proto.public.clanevent.GetClanLeaderboard.Request.prototype.setParams = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Request} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Request.prototype.clearParams = function() {
  return this.setParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetClanLeaderboard.Request.prototype.hasParams = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetClanLeaderboard.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanLeaderboard.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanLeaderboard.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanLeaderboard.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    leaderboardList: jspb.Message.toObjectList(msg.getLeaderboardList(),
    proto.public.clanevent.GetClanLeaderboard.Response.Clan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response}
 */
proto.public.clanevent.GetClanLeaderboard.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanLeaderboard.Response;
  return proto.public.clanevent.GetClanLeaderboard.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanLeaderboard.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response}
 */
proto.public.clanevent.GetClanLeaderboard.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.GetClanLeaderboard.Response.Clan;
      reader.readMessage(value,proto.public.clanevent.GetClanLeaderboard.Response.Clan.deserializeBinaryFromReader);
      msg.addLeaderboard(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanLeaderboard.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanLeaderboard.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanLeaderboard.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeaderboardList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.public.clanevent.GetClanLeaderboard.Response.Clan.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanLeaderboard.Response.Clan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    slug: jspb.Message.getFieldWithDefault(msg, 3, ""),
    size: jspb.Message.getFieldWithDefault(msg, 4, 0),
    capacity: jspb.Message.getFieldWithDefault(msg, 5, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 6, 0),
    militaryScore: jspb.Message.getFieldWithDefault(msg, 7, 0),
    economicScore: jspb.Message.getFieldWithDefault(msg, 8, 0),
    totalScore: jspb.Message.getFieldWithDefault(msg, 9, 0),
    worldDomination: (f = msg.getWorldDomination()) && shared_shared_pb.WorldDominationBoard.LeaderboardExtension.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanLeaderboard.Response.Clan;
  return proto.public.clanevent.GetClanLeaderboard.Response.Clan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCapacity(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRank(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMilitaryScore(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEconomicScore(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalScore(value);
      break;
    case 10:
      var value = new shared_shared_pb.WorldDominationBoard.LeaderboardExtension;
      reader.readMessage(value,shared_shared_pb.WorldDominationBoard.LeaderboardExtension.deserializeBinaryFromReader);
      msg.setWorldDomination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanLeaderboard.Response.Clan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCapacity();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getMilitaryScore();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getEconomicScore();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getTotalScore();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getWorldDomination();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      shared_shared_pb.WorldDominationBoard.LeaderboardExtension.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slug = 3;
 * @return {string}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 size = 4;
 * @return {number}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 capacity = 5;
 * @return {number}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 rank = 6;
 * @return {number}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 military_score = 7;
 * @return {number}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getMilitaryScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setMilitaryScore = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 economic_score = 8;
 * @return {number}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getEconomicScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setEconomicScore = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 total_score = 9;
 * @return {number}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getTotalScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setTotalScore = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional shared.clanevent.WorldDominationBoard.LeaderboardExtension world_domination = 10;
 * @return {?proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.getWorldDomination = function() {
  return /** @type{?proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.WorldDominationBoard.LeaderboardExtension, 10));
};


/**
 * @param {?proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension|undefined} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
*/
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.setWorldDomination = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.clearWorldDomination = function() {
  return this.setWorldDomination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetClanLeaderboard.Response.Clan.prototype.hasWorldDomination = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated Clan leaderboard = 1;
 * @return {!Array<!proto.public.clanevent.GetClanLeaderboard.Response.Clan>}
 */
proto.public.clanevent.GetClanLeaderboard.Response.prototype.getLeaderboardList = function() {
  return /** @type{!Array<!proto.public.clanevent.GetClanLeaderboard.Response.Clan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.clanevent.GetClanLeaderboard.Response.Clan, 1));
};


/**
 * @param {!Array<!proto.public.clanevent.GetClanLeaderboard.Response.Clan>} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response} returns this
*/
proto.public.clanevent.GetClanLeaderboard.Response.prototype.setLeaderboardList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.public.clanevent.GetClanLeaderboard.Response.Clan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response.Clan}
 */
proto.public.clanevent.GetClanLeaderboard.Response.prototype.addLeaderboard = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.public.clanevent.GetClanLeaderboard.Response.Clan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Response} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Response.prototype.clearLeaderboardList = function() {
  return this.setLeaderboardList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanLeaderboard.Params.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanLeaderboard.Params.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanLeaderboard.Params} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.Params.toObject = function(includeInstance, msg) {
  var f, obj = {
    allItems: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Params}
 */
proto.public.clanevent.GetClanLeaderboard.Params.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanLeaderboard.Params;
  return proto.public.clanevent.GetClanLeaderboard.Params.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanLeaderboard.Params} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanLeaderboard.Params}
 */
proto.public.clanevent.GetClanLeaderboard.Params.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanLeaderboard.Params.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanLeaderboard.Params.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanLeaderboard.Params} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanLeaderboard.Params.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllItems();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool all_items = 2;
 * @return {boolean}
 */
proto.public.clanevent.GetClanLeaderboard.Params.prototype.getAllItems = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clanevent.GetClanLeaderboard.Params} returns this
 */
proto.public.clanevent.GetClanLeaderboard.Params.prototype.setAllItems = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLastFinishedRaidPopupInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLastFinishedRaidPopupInfo;
  return proto.public.clanevent.GetLastFinishedRaidPopupInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request;
  return proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    popup: (f = msg.getPopup()) && proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response;
  return proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup;
      reader.readMessage(value,proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.deserializeBinaryFromReader);
      msg.setPopup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPopup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    difficulty: (f = msg.getDifficulty()) && shared_shared_pb.DifficultyConfig.toObject(includeInstance, f),
    finishedAt: (f = msg.getFinishedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    completionTimeSeconds: jspb.Message.getFieldWithDefault(msg, 6, 0),
    completionReward: jspb.Message.getFieldWithDefault(msg, 7, 0),
    timeBonusReward: jspb.Message.getFieldWithDefault(msg, 8, 0),
    playerContributionPoints: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup;
  return proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new shared_shared_pb.DifficultyConfig;
      reader.readMessage(value,shared_shared_pb.DifficultyConfig.deserializeBinaryFromReader);
      msg.setDifficulty(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishedAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletionTimeSeconds(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletionReward(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeBonusReward(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPlayerContributionPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDifficulty();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_shared_pb.DifficultyConfig.serializeBinaryToWriter
    );
  }
  f = message.getFinishedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCompletionTimeSeconds();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCompletionReward();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTimeBonusReward();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getPlayerContributionPoints();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.Status = {
  UNKNOWN: 0,
  SUCCESS: 1,
  FAIL: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Status status = 3;
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.Status}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getStatus = function() {
  return /** @type {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.Status} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional shared.clanevent.DifficultyConfig difficulty = 4;
 * @return {?proto.shared.clanevent.DifficultyConfig}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getDifficulty = function() {
  return /** @type{?proto.shared.clanevent.DifficultyConfig} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.DifficultyConfig, 4));
};


/**
 * @param {?proto.shared.clanevent.DifficultyConfig|undefined} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
*/
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setDifficulty = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.clearDifficulty = function() {
  return this.setDifficulty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.hasDifficulty = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp finished_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getFinishedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
*/
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setFinishedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.clearFinishedAt = function() {
  return this.setFinishedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.hasFinishedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 completion_time_seconds = 6;
 * @return {number}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getCompletionTimeSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setCompletionTimeSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 completion_reward = 7;
 * @return {number}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getCompletionReward = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setCompletionReward = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 time_bonus_reward = 8;
 * @return {number}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getTimeBonusReward = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setTimeBonusReward = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 player_contribution_points = 9;
 * @return {number}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.getPlayerContributionPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup.prototype.setPlayerContributionPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional Popup popup = 1;
 * @return {?proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.prototype.getPopup = function() {
  return /** @type{?proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup, 1));
};


/**
 * @param {?proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.Popup|undefined} value
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response} returns this
*/
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.prototype.setPopup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response} returns this
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.prototype.clearPopup = function() {
  return this.setPopup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetLastFinishedRaidPopupInfo.Response.prototype.hasPopup = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AckLastFinishedRaidPopupInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AckLastFinishedRaidPopupInfo}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AckLastFinishedRaidPopupInfo;
  return proto.public.clanevent.AckLastFinishedRaidPopupInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AckLastFinishedRaidPopupInfo}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request;
  return proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response;
  return proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedRaidPopupInfo.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLastFinishedEventPopupInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLastFinishedEventPopupInfo;
  return proto.public.clanevent.GetLastFinishedEventPopupInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLastFinishedEventPopupInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Request}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLastFinishedEventPopupInfo.Request;
  return proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Request}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    popup: (f = msg.getPopup()) && proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLastFinishedEventPopupInfo.Response;
  return proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup;
      reader.readMessage(value,proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.deserializeBinaryFromReader);
      msg.setPopup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPopup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tier: (f = msg.getTier()) && shared_shared_pb.Event.RewardTier.toObject(includeInstance, f),
    rank: jspb.Message.getFieldWithDefault(msg, 4, 0),
    militarypoints: jspb.Message.getFieldWithDefault(msg, 5, 0),
    economicpoints: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup;
  return proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new shared_shared_pb.Event.RewardTier;
      reader.readMessage(value,shared_shared_pb.Event.RewardTier.deserializeBinaryFromReader);
      msg.setTier(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRank(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMilitarypoints(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEconomicpoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTier();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_shared_pb.Event.RewardTier.serializeBinaryToWriter
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getMilitarypoints();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getEconomicpoints();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional shared.clanevent.Event.RewardTier tier = 3;
 * @return {?proto.shared.clanevent.Event.RewardTier}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.getTier = function() {
  return /** @type{?proto.shared.clanevent.Event.RewardTier} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.Event.RewardTier, 3));
};


/**
 * @param {?proto.shared.clanevent.Event.RewardTier|undefined} value
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} returns this
*/
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.setTier = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.clearTier = function() {
  return this.setTier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.hasTier = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 rank = 4;
 * @return {number}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 militaryPoints = 5;
 * @return {number}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.getMilitarypoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.setMilitarypoints = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 economicPoints = 6;
 * @return {number}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.getEconomicpoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} returns this
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup.prototype.setEconomicpoints = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional Popup popup = 1;
 * @return {?proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.prototype.getPopup = function() {
  return /** @type{?proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup, 1));
};


/**
 * @param {?proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.Popup|undefined} value
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response} returns this
*/
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.prototype.setPopup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetLastFinishedEventPopupInfo.Response} returns this
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.prototype.clearPopup = function() {
  return this.setPopup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetLastFinishedEventPopupInfo.Response.prototype.hasPopup = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AckLastFinishedEventPopupInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AckLastFinishedEventPopupInfo}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AckLastFinishedEventPopupInfo;
  return proto.public.clanevent.AckLastFinishedEventPopupInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AckLastFinishedEventPopupInfo}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AckLastFinishedEventPopupInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AckLastFinishedEventPopupInfo.Request;
  return proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Request} returns this
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Request.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Response}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AckLastFinishedEventPopupInfo.Response;
  return proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Response}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AckLastFinishedEventPopupInfo.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AckLastFinishedEventPopupInfo.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.public.clanevent);

},{"../shared/shared_pb.js":18,"google-protobuf":3,"google-protobuf/google/protobuf/timestamp_pb.js":6}],16:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for public.clanevent
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var validate_validate_pb = require('../validate/validate_pb.js')

var shared_shared_pb = require('../shared/shared_pb.js')
const proto = {};
proto.public = {};
proto.public.clanevent = require('./world_domination.public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.clanevent.WorldDominationClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.clanevent.WorldDominationPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetEventTurn.Request,
 *   !proto.public.clanevent.GetEventTurn.Response>}
 */
const methodDescriptor_WorldDomination_GetEventTurn = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/GetEventTurn',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetEventTurn.Request,
  proto.public.clanevent.GetEventTurn.Response,
  /**
   * @param {!proto.public.clanevent.GetEventTurn.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetEventTurn.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetEventTurn.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetEventTurn.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetEventTurn.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.getEventTurn =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetEventTurn',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetEventTurn,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetEventTurn.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetEventTurn.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.getEventTurn =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetEventTurn',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetEventTurn);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetClanAssets.Request,
 *   !proto.public.clanevent.GetClanAssets.Response>}
 */
const methodDescriptor_WorldDomination_GetClanAssets = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/GetClanAssets',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetClanAssets.Request,
  proto.public.clanevent.GetClanAssets.Response,
  /**
   * @param {!proto.public.clanevent.GetClanAssets.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetClanAssets.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetClanAssets.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetClanAssets.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetClanAssets.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.getClanAssets =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetClanAssets',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetClanAssets,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetClanAssets.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetClanAssets.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.getClanAssets =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetClanAssets',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetClanAssets);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetProductPrice.Request,
 *   !proto.public.clanevent.GetProductPrice.Response>}
 */
const methodDescriptor_WorldDomination_GetProductPrice = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/GetProductPrice',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetProductPrice.Request,
  proto.public.clanevent.GetProductPrice.Response,
  /**
   * @param {!proto.public.clanevent.GetProductPrice.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetProductPrice.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetProductPrice.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetProductPrice.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetProductPrice.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.getProductPrice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetProductPrice',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetProductPrice,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetProductPrice.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetProductPrice.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.getProductPrice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetProductPrice',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetProductPrice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.AddToRoundQueue.Request,
 *   !proto.public.clanevent.AddToRoundQueue.Response>}
 */
const methodDescriptor_WorldDomination_AddToRoundQueue = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/AddToRoundQueue',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.AddToRoundQueue.Request,
  proto.public.clanevent.AddToRoundQueue.Response,
  /**
   * @param {!proto.public.clanevent.AddToRoundQueue.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.AddToRoundQueue.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.AddToRoundQueue.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.AddToRoundQueue.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.AddToRoundQueue.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.addToRoundQueue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/AddToRoundQueue',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_AddToRoundQueue,
      callback);
};


/**
 * @param {!proto.public.clanevent.AddToRoundQueue.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.AddToRoundQueue.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.addToRoundQueue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/AddToRoundQueue',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_AddToRoundQueue);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.RemoveFromRoundQueue.Request,
 *   !proto.public.clanevent.RemoveFromRoundQueue.Response>}
 */
const methodDescriptor_WorldDomination_RemoveFromRoundQueue = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/RemoveFromRoundQueue',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.RemoveFromRoundQueue.Request,
  proto.public.clanevent.RemoveFromRoundQueue.Response,
  /**
   * @param {!proto.public.clanevent.RemoveFromRoundQueue.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.RemoveFromRoundQueue.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.RemoveFromRoundQueue.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.RemoveFromRoundQueue.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.RemoveFromRoundQueue.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.removeFromRoundQueue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/RemoveFromRoundQueue',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_RemoveFromRoundQueue,
      callback);
};


/**
 * @param {!proto.public.clanevent.RemoveFromRoundQueue.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.RemoveFromRoundQueue.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.removeFromRoundQueue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/RemoveFromRoundQueue',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_RemoveFromRoundQueue);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetRoundQueue.Request,
 *   !proto.public.clanevent.GetRoundQueue.Response>}
 */
const methodDescriptor_WorldDomination_GetRoundQueue = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/GetRoundQueue',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetRoundQueue.Request,
  proto.public.clanevent.GetRoundQueue.Response,
  /**
   * @param {!proto.public.clanevent.GetRoundQueue.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetRoundQueue.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetRoundQueue.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetRoundQueue.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetRoundQueue.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.getRoundQueue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetRoundQueue',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetRoundQueue,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetRoundQueue.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetRoundQueue.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.getRoundQueue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetRoundQueue',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetRoundQueue);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.SetRestrictions.Request,
 *   !proto.public.clanevent.SetRestrictions.Response>}
 */
const methodDescriptor_WorldDomination_SetRestrictions = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/SetRestrictions',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.SetRestrictions.Request,
  proto.public.clanevent.SetRestrictions.Response,
  /**
   * @param {!proto.public.clanevent.SetRestrictions.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.SetRestrictions.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.SetRestrictions.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.SetRestrictions.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.SetRestrictions.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.setRestrictions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/SetRestrictions',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_SetRestrictions,
      callback);
};


/**
 * @param {!proto.public.clanevent.SetRestrictions.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.SetRestrictions.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.setRestrictions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/SetRestrictions',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_SetRestrictions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetRestrictions.Request,
 *   !proto.public.clanevent.GetRestrictions.Response>}
 */
const methodDescriptor_WorldDomination_GetRestrictions = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/GetRestrictions',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetRestrictions.Request,
  proto.public.clanevent.GetRestrictions.Response,
  /**
   * @param {!proto.public.clanevent.GetRestrictions.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetRestrictions.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetRestrictions.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetRestrictions.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetRestrictions.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.getRestrictions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetRestrictions',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetRestrictions,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetRestrictions.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetRestrictions.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.getRestrictions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetRestrictions',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetRestrictions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clanevent.GetUserRestrictions.Request,
 *   !proto.public.clanevent.GetUserRestrictions.Response>}
 */
const methodDescriptor_WorldDomination_GetUserRestrictions = new grpc.web.MethodDescriptor(
  '/public.clanevent.WorldDomination/GetUserRestrictions',
  grpc.web.MethodType.UNARY,
  proto.public.clanevent.GetUserRestrictions.Request,
  proto.public.clanevent.GetUserRestrictions.Response,
  /**
   * @param {!proto.public.clanevent.GetUserRestrictions.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clanevent.GetUserRestrictions.Response.deserializeBinary
);


/**
 * @param {!proto.public.clanevent.GetUserRestrictions.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clanevent.GetUserRestrictions.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clanevent.GetUserRestrictions.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clanevent.WorldDominationClient.prototype.getUserRestrictions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetUserRestrictions',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetUserRestrictions,
      callback);
};


/**
 * @param {!proto.public.clanevent.GetUserRestrictions.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clanevent.GetUserRestrictions.Response>}
 *     Promise that resolves to the response
 */
proto.public.clanevent.WorldDominationPromiseClient.prototype.getUserRestrictions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clanevent.WorldDomination/GetUserRestrictions',
      request,
      metadata || {},
      methodDescriptor_WorldDomination_GetUserRestrictions);
};


module.exports = proto.public.clanevent;


},{"../shared/shared_pb.js":18,"../validate/validate_pb.js":19,"./world_domination.public_pb.js":17,"google-protobuf/google/protobuf/timestamp_pb.js":6,"grpc-web":7}],17:[function(require,module,exports){
// source: public/world_domination.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var shared_shared_pb = require('../shared/shared_pb.js');
goog.object.extend(proto, shared_shared_pb);
goog.exportSymbol('proto.public.clanevent.AddToRoundQueue', null, global);
goog.exportSymbol('proto.public.clanevent.AddToRoundQueue.Request', null, global);
goog.exportSymbol('proto.public.clanevent.AddToRoundQueue.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanAssets', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanAssets.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetClanAssets.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Battle', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Battle.Defence', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Battle.Offence', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Battle.SummaryItem', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Market', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.MyClan', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetEventTurn.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetProductPrice', null, global);
goog.exportSymbol('proto.public.clanevent.GetProductPrice.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetProductPrice.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetRestrictions', null, global);
goog.exportSymbol('proto.public.clanevent.GetRestrictions.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetRestrictions.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetRoundQueue', null, global);
goog.exportSymbol('proto.public.clanevent.GetRoundQueue.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetRoundQueue.Response', null, global);
goog.exportSymbol('proto.public.clanevent.GetUserRestrictions', null, global);
goog.exportSymbol('proto.public.clanevent.GetUserRestrictions.Request', null, global);
goog.exportSymbol('proto.public.clanevent.GetUserRestrictions.Response', null, global);
goog.exportSymbol('proto.public.clanevent.QueueRestrictions', null, global);
goog.exportSymbol('proto.public.clanevent.QueueRestrictions.FundLimits', null, global);
goog.exportSymbol('proto.public.clanevent.RemoveFromRoundQueue', null, global);
goog.exportSymbol('proto.public.clanevent.RemoveFromRoundQueue.Request', null, global);
goog.exportSymbol('proto.public.clanevent.RemoveFromRoundQueue.Response', null, global);
goog.exportSymbol('proto.public.clanevent.SetRestrictions', null, global);
goog.exportSymbol('proto.public.clanevent.SetRestrictions.Request', null, global);
goog.exportSymbol('proto.public.clanevent.SetRestrictions.Response', null, global);
goog.exportSymbol('proto.public.clanevent.Turn', null, global);
goog.exportSymbol('proto.public.clanevent.Turn.Info', null, global);
goog.exportSymbol('proto.public.clanevent.Turn.Status', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.displayName = 'proto.public.clanevent.GetEventTurn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Request.displayName = 'proto.public.clanevent.GetEventTurn.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetEventTurn.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Response.displayName = 'proto.public.clanevent.GetEventTurn.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Market = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetEventTurn.Market.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Market, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Market.displayName = 'proto.public.clanevent.GetEventTurn.Market';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.MyClan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetEventTurn.MyClan.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.MyClan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.MyClan.displayName = 'proto.public.clanevent.GetEventTurn.MyClan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Battle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Battle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Battle.displayName = 'proto.public.clanevent.GetEventTurn.Battle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Battle.SummaryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Battle.SummaryItem.displayName = 'proto.public.clanevent.GetEventTurn.Battle.SummaryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Battle.Offence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetEventTurn.Battle.Offence.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Battle.Offence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Battle.Offence.displayName = 'proto.public.clanevent.GetEventTurn.Battle.Offence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.displayName = 'proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.displayName = 'proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Battle.Defence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetEventTurn.Battle.Defence.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Battle.Defence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Battle.Defence.displayName = 'proto.public.clanevent.GetEventTurn.Battle.Defence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.displayName = 'proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.Turn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.Turn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.Turn.displayName = 'proto.public.clanevent.Turn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.Turn.Info = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.Turn.Info, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.Turn.Info.displayName = 'proto.public.clanevent.Turn.Info';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AddToRoundQueue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AddToRoundQueue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AddToRoundQueue.displayName = 'proto.public.clanevent.AddToRoundQueue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AddToRoundQueue.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AddToRoundQueue.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AddToRoundQueue.Request.displayName = 'proto.public.clanevent.AddToRoundQueue.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.AddToRoundQueue.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.AddToRoundQueue.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.AddToRoundQueue.Response.displayName = 'proto.public.clanevent.AddToRoundQueue.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.RemoveFromRoundQueue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.RemoveFromRoundQueue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.RemoveFromRoundQueue.displayName = 'proto.public.clanevent.RemoveFromRoundQueue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.RemoveFromRoundQueue.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.RemoveFromRoundQueue.Request.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.RemoveFromRoundQueue.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.RemoveFromRoundQueue.Request.displayName = 'proto.public.clanevent.RemoveFromRoundQueue.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.RemoveFromRoundQueue.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.RemoveFromRoundQueue.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.RemoveFromRoundQueue.Response.displayName = 'proto.public.clanevent.RemoveFromRoundQueue.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetRoundQueue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetRoundQueue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetRoundQueue.displayName = 'proto.public.clanevent.GetRoundQueue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetRoundQueue.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetRoundQueue.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetRoundQueue.Request.displayName = 'proto.public.clanevent.GetRoundQueue.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetRoundQueue.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetRoundQueue.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetRoundQueue.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetRoundQueue.Response.displayName = 'proto.public.clanevent.GetRoundQueue.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanAssets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanAssets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanAssets.displayName = 'proto.public.clanevent.GetClanAssets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanAssets.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetClanAssets.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanAssets.Request.displayName = 'proto.public.clanevent.GetClanAssets.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetClanAssets.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetClanAssets.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetClanAssets.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetClanAssets.Response.displayName = 'proto.public.clanevent.GetClanAssets.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.QueueRestrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.QueueRestrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.QueueRestrictions.displayName = 'proto.public.clanevent.QueueRestrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.QueueRestrictions.FundLimits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.QueueRestrictions.FundLimits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.QueueRestrictions.FundLimits.displayName = 'proto.public.clanevent.QueueRestrictions.FundLimits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.SetRestrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.SetRestrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.SetRestrictions.displayName = 'proto.public.clanevent.SetRestrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.SetRestrictions.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.SetRestrictions.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.SetRestrictions.Request.displayName = 'proto.public.clanevent.SetRestrictions.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.SetRestrictions.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.SetRestrictions.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.SetRestrictions.Response.displayName = 'proto.public.clanevent.SetRestrictions.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetRestrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetRestrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetRestrictions.displayName = 'proto.public.clanevent.GetRestrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetRestrictions.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetRestrictions.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetRestrictions.Request.displayName = 'proto.public.clanevent.GetRestrictions.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetRestrictions.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetRestrictions.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetRestrictions.Response.displayName = 'proto.public.clanevent.GetRestrictions.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetUserRestrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetUserRestrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetUserRestrictions.displayName = 'proto.public.clanevent.GetUserRestrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetUserRestrictions.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetUserRestrictions.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetUserRestrictions.Request.displayName = 'proto.public.clanevent.GetUserRestrictions.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetUserRestrictions.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetUserRestrictions.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetUserRestrictions.Response.displayName = 'proto.public.clanevent.GetUserRestrictions.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetProductPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetProductPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetProductPrice.displayName = 'proto.public.clanevent.GetProductPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetProductPrice.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clanevent.GetProductPrice.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetProductPrice.Request.displayName = 'proto.public.clanevent.GetProductPrice.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clanevent.GetProductPrice.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clanevent.GetProductPrice.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clanevent.GetProductPrice.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clanevent.GetProductPrice.Response.displayName = 'proto.public.clanevent.GetProductPrice.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn}
 */
proto.public.clanevent.GetEventTurn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn;
  return proto.public.clanevent.GetEventTurn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn}
 */
proto.public.clanevent.GetEventTurn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Request}
 */
proto.public.clanevent.GetEventTurn.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Request;
  return proto.public.clanevent.GetEventTurn.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Request}
 */
proto.public.clanevent.GetEventTurn.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.public.clanevent.GetEventTurn.Request.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetEventTurn.Request} returns this
 */
proto.public.clanevent.GetEventTurn.Request.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetEventTurn.Response.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    round: jspb.Message.getFieldWithDefault(msg, 1, 0),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0),
    turn: (f = msg.getTurn()) && proto.public.clanevent.Turn.Info.toObject(includeInstance, f),
    market: (f = msg.getMarket()) && proto.public.clanevent.GetEventTurn.Market.toObject(includeInstance, f),
    clan: (f = msg.getClan()) && proto.public.clanevent.GetEventTurn.MyClan.toObject(includeInstance, f),
    battleSummaryList: jspb.Message.toObjectList(msg.getBattleSummaryList(),
    proto.public.clanevent.GetEventTurn.Battle.SummaryItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Response}
 */
proto.public.clanevent.GetEventTurn.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Response;
  return proto.public.clanevent.GetEventTurn.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Response}
 */
proto.public.clanevent.GetEventTurn.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRound(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 3:
      var value = new proto.public.clanevent.Turn.Info;
      reader.readMessage(value,proto.public.clanevent.Turn.Info.deserializeBinaryFromReader);
      msg.setTurn(value);
      break;
    case 4:
      var value = new proto.public.clanevent.GetEventTurn.Market;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.Market.deserializeBinaryFromReader);
      msg.setMarket(value);
      break;
    case 5:
      var value = new proto.public.clanevent.GetEventTurn.MyClan;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.MyClan.deserializeBinaryFromReader);
      msg.setClan(value);
      break;
    case 6:
      var value = new proto.public.clanevent.GetEventTurn.Battle.SummaryItem;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.Battle.SummaryItem.deserializeBinaryFromReader);
      msg.addBattleSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRound();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTurn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.public.clanevent.Turn.Info.serializeBinaryToWriter
    );
  }
  f = message.getMarket();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.public.clanevent.GetEventTurn.Market.serializeBinaryToWriter
    );
  }
  f = message.getClan();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.public.clanevent.GetEventTurn.MyClan.serializeBinaryToWriter
    );
  }
  f = message.getBattleSummaryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.public.clanevent.GetEventTurn.Battle.SummaryItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 round = 1;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.getRound = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
 */
proto.public.clanevent.GetEventTurn.Response.prototype.setRound = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
 */
proto.public.clanevent.GetEventTurn.Response.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional Turn.Info turn = 3;
 * @return {?proto.public.clanevent.Turn.Info}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.getTurn = function() {
  return /** @type{?proto.public.clanevent.Turn.Info} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.Turn.Info, 3));
};


/**
 * @param {?proto.public.clanevent.Turn.Info|undefined} value
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
*/
proto.public.clanevent.GetEventTurn.Response.prototype.setTurn = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
 */
proto.public.clanevent.GetEventTurn.Response.prototype.clearTurn = function() {
  return this.setTurn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.hasTurn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Market market = 4;
 * @return {?proto.public.clanevent.GetEventTurn.Market}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.getMarket = function() {
  return /** @type{?proto.public.clanevent.GetEventTurn.Market} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetEventTurn.Market, 4));
};


/**
 * @param {?proto.public.clanevent.GetEventTurn.Market|undefined} value
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
*/
proto.public.clanevent.GetEventTurn.Response.prototype.setMarket = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
 */
proto.public.clanevent.GetEventTurn.Response.prototype.clearMarket = function() {
  return this.setMarket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.hasMarket = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional MyClan clan = 5;
 * @return {?proto.public.clanevent.GetEventTurn.MyClan}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.getClan = function() {
  return /** @type{?proto.public.clanevent.GetEventTurn.MyClan} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetEventTurn.MyClan, 5));
};


/**
 * @param {?proto.public.clanevent.GetEventTurn.MyClan|undefined} value
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
*/
proto.public.clanevent.GetEventTurn.Response.prototype.setClan = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
 */
proto.public.clanevent.GetEventTurn.Response.prototype.clearClan = function() {
  return this.setClan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.hasClan = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated Battle.SummaryItem battle_summary = 6;
 * @return {!Array<!proto.public.clanevent.GetEventTurn.Battle.SummaryItem>}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.getBattleSummaryList = function() {
  return /** @type{!Array<!proto.public.clanevent.GetEventTurn.Battle.SummaryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.clanevent.GetEventTurn.Battle.SummaryItem, 6));
};


/**
 * @param {!Array<!proto.public.clanevent.GetEventTurn.Battle.SummaryItem>} value
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
*/
proto.public.clanevent.GetEventTurn.Response.prototype.setBattleSummaryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem}
 */
proto.public.clanevent.GetEventTurn.Response.prototype.addBattleSummary = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.public.clanevent.GetEventTurn.Battle.SummaryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetEventTurn.Response} returns this
 */
proto.public.clanevent.GetEventTurn.Response.prototype.clearBattleSummaryList = function() {
  return this.setBattleSummaryList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetEventTurn.Market.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Market.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Market.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Market} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Market.toObject = function(includeInstance, msg) {
  var f, obj = {
    productsList: jspb.Message.toObjectList(msg.getProductsList(),
    shared_shared_pb.Market.ProductPrices.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Market}
 */
proto.public.clanevent.GetEventTurn.Market.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Market;
  return proto.public.clanevent.GetEventTurn.Market.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Market} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Market}
 */
proto.public.clanevent.GetEventTurn.Market.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_shared_pb.Market.ProductPrices;
      reader.readMessage(value,shared_shared_pb.Market.ProductPrices.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Market.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Market.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Market} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Market.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      shared_shared_pb.Market.ProductPrices.serializeBinaryToWriter
    );
  }
};


/**
 * repeated shared.clanevent.Market.ProductPrices products = 1;
 * @return {!Array<!proto.shared.clanevent.Market.ProductPrices>}
 */
proto.public.clanevent.GetEventTurn.Market.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Market.ProductPrices>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.Market.ProductPrices, 1));
};


/**
 * @param {!Array<!proto.shared.clanevent.Market.ProductPrices>} value
 * @return {!proto.public.clanevent.GetEventTurn.Market} returns this
*/
proto.public.clanevent.GetEventTurn.Market.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.shared.clanevent.Market.ProductPrices=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Market.ProductPrices}
 */
proto.public.clanevent.GetEventTurn.Market.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.shared.clanevent.Market.ProductPrices, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetEventTurn.Market} returns this
 */
proto.public.clanevent.GetEventTurn.Market.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetEventTurn.MyClan.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.MyClan.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.MyClan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.MyClan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.MyClan.toObject = function(includeInstance, msg) {
  var f, obj = {
    balancesList: jspb.Message.toObjectList(msg.getBalancesList(),
    shared_shared_pb.Money.toObject, includeInstance),
    slotsList: jspb.Message.toObjectList(msg.getSlotsList(),
    shared_shared_pb.WorldDominationBoard.ClanSlot.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.MyClan}
 */
proto.public.clanevent.GetEventTurn.MyClan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.MyClan;
  return proto.public.clanevent.GetEventTurn.MyClan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.MyClan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.MyClan}
 */
proto.public.clanevent.GetEventTurn.MyClan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_shared_pb.Money;
      reader.readMessage(value,shared_shared_pb.Money.deserializeBinaryFromReader);
      msg.addBalances(value);
      break;
    case 2:
      var value = new shared_shared_pb.WorldDominationBoard.ClanSlot;
      reader.readMessage(value,shared_shared_pb.WorldDominationBoard.ClanSlot.deserializeBinaryFromReader);
      msg.addSlots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.MyClan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.MyClan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.MyClan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.MyClan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      shared_shared_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getSlotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      shared_shared_pb.WorldDominationBoard.ClanSlot.serializeBinaryToWriter
    );
  }
};


/**
 * repeated shared.clanevent.Money balances = 1;
 * @return {!Array<!proto.shared.clanevent.Money>}
 */
proto.public.clanevent.GetEventTurn.MyClan.prototype.getBalancesList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Money>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.Money, 1));
};


/**
 * @param {!Array<!proto.shared.clanevent.Money>} value
 * @return {!proto.public.clanevent.GetEventTurn.MyClan} returns this
*/
proto.public.clanevent.GetEventTurn.MyClan.prototype.setBalancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.shared.clanevent.Money=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Money}
 */
proto.public.clanevent.GetEventTurn.MyClan.prototype.addBalances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.shared.clanevent.Money, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetEventTurn.MyClan} returns this
 */
proto.public.clanevent.GetEventTurn.MyClan.prototype.clearBalancesList = function() {
  return this.setBalancesList([]);
};


/**
 * repeated shared.clanevent.WorldDominationBoard.ClanSlot slots = 2;
 * @return {!Array<!proto.shared.clanevent.WorldDominationBoard.ClanSlot>}
 */
proto.public.clanevent.GetEventTurn.MyClan.prototype.getSlotsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.WorldDominationBoard.ClanSlot>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.WorldDominationBoard.ClanSlot, 2));
};


/**
 * @param {!Array<!proto.shared.clanevent.WorldDominationBoard.ClanSlot>} value
 * @return {!proto.public.clanevent.GetEventTurn.MyClan} returns this
*/
proto.public.clanevent.GetEventTurn.MyClan.prototype.setSlotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.shared.clanevent.WorldDominationBoard.ClanSlot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot}
 */
proto.public.clanevent.GetEventTurn.MyClan.prototype.addSlots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.shared.clanevent.WorldDominationBoard.ClanSlot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetEventTurn.MyClan} returns this
 */
proto.public.clanevent.GetEventTurn.MyClan.prototype.clearSlotsList = function() {
  return this.setSlotsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Battle.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Battle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Battle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Battle}
 */
proto.public.clanevent.GetEventTurn.Battle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Battle;
  return proto.public.clanevent.GetEventTurn.Battle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Battle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Battle}
 */
proto.public.clanevent.GetEventTurn.Battle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Battle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Battle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Battle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Battle.SummaryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    round: jspb.Message.getFieldWithDefault(msg, 1, 0),
    offence: (f = msg.getOffence()) && proto.public.clanevent.GetEventTurn.Battle.Offence.toObject(includeInstance, f),
    defence: (f = msg.getDefence()) && proto.public.clanevent.GetEventTurn.Battle.Defence.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Battle.SummaryItem;
  return proto.public.clanevent.GetEventTurn.Battle.SummaryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRound(value);
      break;
    case 2:
      var value = new proto.public.clanevent.GetEventTurn.Battle.Offence;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.Battle.Offence.deserializeBinaryFromReader);
      msg.setOffence(value);
      break;
    case 3:
      var value = new proto.public.clanevent.GetEventTurn.Battle.Defence;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.Battle.Defence.deserializeBinaryFromReader);
      msg.setDefence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Battle.SummaryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRound();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOffence();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.clanevent.GetEventTurn.Battle.Offence.serializeBinaryToWriter
    );
  }
  f = message.getDefence();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.public.clanevent.GetEventTurn.Battle.Defence.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 round = 1;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.getRound = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.setRound = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Offence offence = 2;
 * @return {?proto.public.clanevent.GetEventTurn.Battle.Offence}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.getOffence = function() {
  return /** @type{?proto.public.clanevent.GetEventTurn.Battle.Offence} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetEventTurn.Battle.Offence, 2));
};


/**
 * @param {?proto.public.clanevent.GetEventTurn.Battle.Offence|undefined} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem} returns this
*/
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.setOffence = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.clearOffence = function() {
  return this.setOffence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.hasOffence = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Defence defence = 3;
 * @return {?proto.public.clanevent.GetEventTurn.Battle.Defence}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.getDefence = function() {
  return /** @type{?proto.public.clanevent.GetEventTurn.Battle.Defence} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetEventTurn.Battle.Defence, 3));
};


/**
 * @param {?proto.public.clanevent.GetEventTurn.Battle.Defence|undefined} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem} returns this
*/
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.setDefence = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.SummaryItem} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.clearDefence = function() {
  return this.setDefence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetEventTurn.Battle.SummaryItem.prototype.hasDefence = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Battle.Offence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.toObject = function(includeInstance, msg) {
  var f, obj = {
    citiesList: jspb.Message.toObjectList(msg.getCitiesList(),
    proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Battle.Offence;
  return proto.public.clanevent.GetEventTurn.Battle.Offence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.deserializeBinaryFromReader);
      msg.addCities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Battle.Offence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    cityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    myNukes: (f = msg.getMyNukes()) && proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.toObject(includeInstance, f),
    nukes: (f = msg.getNukes()) && proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary;
  return proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityId(value);
      break;
    case 2:
      var value = new proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.deserializeBinaryFromReader);
      msg.setMyNukes(value);
      break;
    case 3:
      var value = new proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.deserializeBinaryFromReader);
      msg.setNukes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMyNukes();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.serializeBinaryToWriter
    );
  }
  f = message.getNukes();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.toObject = function(includeInstance, msg) {
  var f, obj = {
    successful: jspb.Message.getFieldWithDefault(msg, 1, 0),
    failed: jspb.Message.getFieldWithDefault(msg, 2, 0),
    vampirePoints: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes;
  return proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuccessful(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFailed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVampirePoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccessful();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFailed();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getVampirePoints();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 successful = 1;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.prototype.getSuccessful = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.prototype.setSuccessful = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 failed = 2;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.prototype.getFailed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.prototype.setFailed = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 vampire_points = 3;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.prototype.getVampirePoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes.prototype.setVampirePoints = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string city_id = 1;
 * @return {string}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.getCityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.setCityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Nukes my_nukes = 2;
 * @return {?proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.getMyNukes = function() {
  return /** @type{?proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes, 2));
};


/**
 * @param {?proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes|undefined} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary} returns this
*/
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.setMyNukes = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.clearMyNukes = function() {
  return this.setMyNukes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.hasMyNukes = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Nukes nukes = 3;
 * @return {?proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.getNukes = function() {
  return /** @type{?proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes, 3));
};


/**
 * @param {?proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.Nukes|undefined} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary} returns this
*/
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.setNukes = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.clearNukes = function() {
  return this.setNukes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary.prototype.hasNukes = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated CitySummary cities = 1;
 * @return {!Array<!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary>}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.prototype.getCitiesList = function() {
  return /** @type{!Array<!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary, 1));
};


/**
 * @param {!Array<!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary>} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence} returns this
*/
proto.public.clanevent.GetEventTurn.Battle.Offence.prototype.setCitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary}
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.prototype.addCities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.public.clanevent.GetEventTurn.Battle.Offence.CitySummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Offence} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Offence.prototype.clearCitiesList = function() {
  return this.setCitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Battle.Defence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Defence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.toObject = function(includeInstance, msg) {
  var f, obj = {
    citiesList: jspb.Message.toObjectList(msg.getCitiesList(),
    proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Battle.Defence;
  return proto.public.clanevent.GetEventTurn.Battle.Defence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Defence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary;
      reader.readMessage(value,proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.deserializeBinaryFromReader);
      msg.addCities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Battle.Defence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Defence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    cityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    damagePoints: jspb.Message.getFieldWithDefault(msg, 2, 0),
    successfulNukes: jspb.Message.getFieldWithDefault(msg, 3, 0),
    failedNukes: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary;
  return proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDamagePoints(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuccessfulNukes(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFailedNukes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDamagePoints();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSuccessfulNukes();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFailedNukes();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string city_id = 1;
 * @return {string}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.getCityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.setCityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 damage_points = 2;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.getDamagePoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.setDamagePoints = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 successful_nukes = 3;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.getSuccessfulNukes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.setSuccessfulNukes = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 failed_nukes = 4;
 * @return {number}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.getFailedNukes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary.prototype.setFailedNukes = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated CitySummary cities = 1;
 * @return {!Array<!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary>}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.prototype.getCitiesList = function() {
  return /** @type{!Array<!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary, 1));
};


/**
 * @param {!Array<!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary>} value
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence} returns this
*/
proto.public.clanevent.GetEventTurn.Battle.Defence.prototype.setCitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary}
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.prototype.addCities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.public.clanevent.GetEventTurn.Battle.Defence.CitySummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetEventTurn.Battle.Defence} returns this
 */
proto.public.clanevent.GetEventTurn.Battle.Defence.prototype.clearCitiesList = function() {
  return this.setCitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.Turn.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.Turn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.Turn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.Turn.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.Turn}
 */
proto.public.clanevent.Turn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.Turn;
  return proto.public.clanevent.Turn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.Turn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.Turn}
 */
proto.public.clanevent.Turn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.Turn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.Turn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.Turn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.Turn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.public.clanevent.Turn.Status = {
  UNKNOWN: 0,
  ACTIVE: 1,
  PROCESSING: 2,
  COMPLETED: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.Turn.Info.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.Turn.Info.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.Turn.Info} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.Turn.Info.toObject = function(includeInstance, msg) {
  var f, obj = {
    turnId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    endsAt: (f = msg.getEndsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.Turn.Info}
 */
proto.public.clanevent.Turn.Info.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.Turn.Info;
  return proto.public.clanevent.Turn.Info.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.Turn.Info} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.Turn.Info}
 */
proto.public.clanevent.Turn.Info.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTurnId(value);
      break;
    case 2:
      var value = /** @type {!proto.public.clanevent.Turn.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndsAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.Turn.Info.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.Turn.Info.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.Turn.Info} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.Turn.Info.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTurnId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEndsAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string turn_id = 1;
 * @return {string}
 */
proto.public.clanevent.Turn.Info.prototype.getTurnId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.Turn.Info} returns this
 */
proto.public.clanevent.Turn.Info.prototype.setTurnId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Status status = 2;
 * @return {!proto.public.clanevent.Turn.Status}
 */
proto.public.clanevent.Turn.Info.prototype.getStatus = function() {
  return /** @type {!proto.public.clanevent.Turn.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.public.clanevent.Turn.Status} value
 * @return {!proto.public.clanevent.Turn.Info} returns this
 */
proto.public.clanevent.Turn.Info.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp ends_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.public.clanevent.Turn.Info.prototype.getEndsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.public.clanevent.Turn.Info} returns this
*/
proto.public.clanevent.Turn.Info.prototype.setEndsAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.Turn.Info} returns this
 */
proto.public.clanevent.Turn.Info.prototype.clearEndsAt = function() {
  return this.setEndsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.Turn.Info.prototype.hasEndsAt = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AddToRoundQueue.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AddToRoundQueue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AddToRoundQueue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AddToRoundQueue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AddToRoundQueue}
 */
proto.public.clanevent.AddToRoundQueue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AddToRoundQueue;
  return proto.public.clanevent.AddToRoundQueue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AddToRoundQueue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AddToRoundQueue}
 */
proto.public.clanevent.AddToRoundQueue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AddToRoundQueue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AddToRoundQueue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AddToRoundQueue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AddToRoundQueue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AddToRoundQueue.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AddToRoundQueue.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AddToRoundQueue.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    turnId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    itemData: (f = msg.getItemData()) && shared_shared_pb.RoundQueue.ItemData.toObject(includeInstance, f),
    currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    itemDataCount: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AddToRoundQueue.Request}
 */
proto.public.clanevent.AddToRoundQueue.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AddToRoundQueue.Request;
  return proto.public.clanevent.AddToRoundQueue.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AddToRoundQueue.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AddToRoundQueue.Request}
 */
proto.public.clanevent.AddToRoundQueue.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTurnId(value);
      break;
    case 3:
      var value = new shared_shared_pb.RoundQueue.ItemData;
      reader.readMessage(value,shared_shared_pb.RoundQueue.ItemData.deserializeBinaryFromReader);
      msg.setItemData(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemDataCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AddToRoundQueue.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AddToRoundQueue.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AddToRoundQueue.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTurnId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItemData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_shared_pb.RoundQueue.ItemData.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getItemDataCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.AddToRoundQueue.Request} returns this
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string turn_id = 2;
 * @return {string}
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.getTurnId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.AddToRoundQueue.Request} returns this
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.setTurnId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional shared.clanevent.RoundQueue.ItemData item_data = 3;
 * @return {?proto.shared.clanevent.RoundQueue.ItemData}
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.getItemData = function() {
  return /** @type{?proto.shared.clanevent.RoundQueue.ItemData} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.RoundQueue.ItemData, 3));
};


/**
 * @param {?proto.shared.clanevent.RoundQueue.ItemData|undefined} value
 * @return {!proto.public.clanevent.AddToRoundQueue.Request} returns this
*/
proto.public.clanevent.AddToRoundQueue.Request.prototype.setItemData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.AddToRoundQueue.Request} returns this
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.clearItemData = function() {
  return this.setItemData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.hasItemData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.AddToRoundQueue.Request} returns this
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 item_data_count = 5;
 * @return {number}
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.getItemDataCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.AddToRoundQueue.Request} returns this
 */
proto.public.clanevent.AddToRoundQueue.Request.prototype.setItemDataCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.AddToRoundQueue.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.AddToRoundQueue.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.AddToRoundQueue.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AddToRoundQueue.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.AddToRoundQueue.Response}
 */
proto.public.clanevent.AddToRoundQueue.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.AddToRoundQueue.Response;
  return proto.public.clanevent.AddToRoundQueue.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.AddToRoundQueue.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.AddToRoundQueue.Response}
 */
proto.public.clanevent.AddToRoundQueue.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.AddToRoundQueue.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.AddToRoundQueue.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.AddToRoundQueue.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.AddToRoundQueue.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.RemoveFromRoundQueue.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.RemoveFromRoundQueue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.RemoveFromRoundQueue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.RemoveFromRoundQueue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.RemoveFromRoundQueue}
 */
proto.public.clanevent.RemoveFromRoundQueue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.RemoveFromRoundQueue;
  return proto.public.clanevent.RemoveFromRoundQueue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.RemoveFromRoundQueue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.RemoveFromRoundQueue}
 */
proto.public.clanevent.RemoveFromRoundQueue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.RemoveFromRoundQueue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.RemoveFromRoundQueue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.RemoveFromRoundQueue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.RemoveFromRoundQueue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.RemoveFromRoundQueue.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.RemoveFromRoundQueue.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    turnId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    itemIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Request}
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.RemoveFromRoundQueue.Request;
  return proto.public.clanevent.RemoveFromRoundQueue.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.RemoveFromRoundQueue.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Request}
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTurnId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addItemIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.RemoveFromRoundQueue.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.RemoveFromRoundQueue.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTurnId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 3;
 * @return {string}
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Request} returns this
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string turn_id = 1;
 * @return {string}
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.getTurnId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Request} returns this
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.setTurnId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string item_ids = 2;
 * @return {!Array<string>}
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.getItemIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Request} returns this
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.setItemIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Request} returns this
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.addItemIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Request} returns this
 */
proto.public.clanevent.RemoveFromRoundQueue.Request.prototype.clearItemIdsList = function() {
  return this.setItemIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.RemoveFromRoundQueue.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.RemoveFromRoundQueue.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.RemoveFromRoundQueue.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.RemoveFromRoundQueue.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Response}
 */
proto.public.clanevent.RemoveFromRoundQueue.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.RemoveFromRoundQueue.Response;
  return proto.public.clanevent.RemoveFromRoundQueue.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.RemoveFromRoundQueue.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.RemoveFromRoundQueue.Response}
 */
proto.public.clanevent.RemoveFromRoundQueue.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.RemoveFromRoundQueue.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.RemoveFromRoundQueue.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.RemoveFromRoundQueue.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.RemoveFromRoundQueue.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetRoundQueue.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetRoundQueue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetRoundQueue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRoundQueue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetRoundQueue}
 */
proto.public.clanevent.GetRoundQueue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetRoundQueue;
  return proto.public.clanevent.GetRoundQueue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetRoundQueue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetRoundQueue}
 */
proto.public.clanevent.GetRoundQueue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetRoundQueue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetRoundQueue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetRoundQueue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRoundQueue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetRoundQueue.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetRoundQueue.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetRoundQueue.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRoundQueue.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetRoundQueue.Request}
 */
proto.public.clanevent.GetRoundQueue.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetRoundQueue.Request;
  return proto.public.clanevent.GetRoundQueue.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetRoundQueue.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetRoundQueue.Request}
 */
proto.public.clanevent.GetRoundQueue.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetRoundQueue.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetRoundQueue.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetRoundQueue.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRoundQueue.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetRoundQueue.Response.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetRoundQueue.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetRoundQueue.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetRoundQueue.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRoundQueue.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    shared_shared_pb.RoundQueue.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetRoundQueue.Response}
 */
proto.public.clanevent.GetRoundQueue.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetRoundQueue.Response;
  return proto.public.clanevent.GetRoundQueue.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetRoundQueue.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetRoundQueue.Response}
 */
proto.public.clanevent.GetRoundQueue.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new shared_shared_pb.RoundQueue.Item;
      reader.readMessage(value,shared_shared_pb.RoundQueue.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetRoundQueue.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetRoundQueue.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetRoundQueue.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRoundQueue.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      shared_shared_pb.RoundQueue.Item.serializeBinaryToWriter
    );
  }
};


/**
 * repeated shared.clanevent.RoundQueue.Item items = 2;
 * @return {!Array<!proto.shared.clanevent.RoundQueue.Item>}
 */
proto.public.clanevent.GetRoundQueue.Response.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.RoundQueue.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.RoundQueue.Item, 2));
};


/**
 * @param {!Array<!proto.shared.clanevent.RoundQueue.Item>} value
 * @return {!proto.public.clanevent.GetRoundQueue.Response} returns this
*/
proto.public.clanevent.GetRoundQueue.Response.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.shared.clanevent.RoundQueue.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.RoundQueue.Item}
 */
proto.public.clanevent.GetRoundQueue.Response.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.shared.clanevent.RoundQueue.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetRoundQueue.Response} returns this
 */
proto.public.clanevent.GetRoundQueue.Response.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanAssets.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanAssets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanAssets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanAssets.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanAssets}
 */
proto.public.clanevent.GetClanAssets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanAssets;
  return proto.public.clanevent.GetClanAssets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanAssets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanAssets}
 */
proto.public.clanevent.GetClanAssets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanAssets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanAssets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanAssets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanAssets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanAssets.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanAssets.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanAssets.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanAssets.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanAssets.Request}
 */
proto.public.clanevent.GetClanAssets.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanAssets.Request;
  return proto.public.clanevent.GetClanAssets.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanAssets.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanAssets.Request}
 */
proto.public.clanevent.GetClanAssets.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanAssets.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanAssets.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanAssets.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanAssets.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.public.clanevent.GetClanAssets.Request.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetClanAssets.Request} returns this
 */
proto.public.clanevent.GetClanAssets.Request.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetClanAssets.Response.repeatedFields_ = [1,2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetClanAssets.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetClanAssets.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanAssets.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    nukesList: jspb.Message.toObjectList(msg.getNukesList(),
    shared_shared_pb.Assets.Item.toObject, includeInstance),
    cityShieldsList: jspb.Message.toObjectList(msg.getCityShieldsList(),
    shared_shared_pb.Assets.CityShield.toObject, includeInstance),
    oilRigsList: jspb.Message.toObjectList(msg.getOilRigsList(),
    shared_shared_pb.Assets.Item.toObject, includeInstance),
    missileSilosList: jspb.Message.toObjectList(msg.getMissileSilosList(),
    shared_shared_pb.Assets.Item.toObject, includeInstance),
    ironDomesList: jspb.Message.toObjectList(msg.getIronDomesList(),
    shared_shared_pb.Assets.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetClanAssets.Response}
 */
proto.public.clanevent.GetClanAssets.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetClanAssets.Response;
  return proto.public.clanevent.GetClanAssets.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetClanAssets.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetClanAssets.Response}
 */
proto.public.clanevent.GetClanAssets.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_shared_pb.Assets.Item;
      reader.readMessage(value,shared_shared_pb.Assets.Item.deserializeBinaryFromReader);
      msg.addNukes(value);
      break;
    case 2:
      var value = new shared_shared_pb.Assets.CityShield;
      reader.readMessage(value,shared_shared_pb.Assets.CityShield.deserializeBinaryFromReader);
      msg.addCityShields(value);
      break;
    case 3:
      var value = new shared_shared_pb.Assets.Item;
      reader.readMessage(value,shared_shared_pb.Assets.Item.deserializeBinaryFromReader);
      msg.addOilRigs(value);
      break;
    case 4:
      var value = new shared_shared_pb.Assets.Item;
      reader.readMessage(value,shared_shared_pb.Assets.Item.deserializeBinaryFromReader);
      msg.addMissileSilos(value);
      break;
    case 5:
      var value = new shared_shared_pb.Assets.Item;
      reader.readMessage(value,shared_shared_pb.Assets.Item.deserializeBinaryFromReader);
      msg.addIronDomes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetClanAssets.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetClanAssets.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetClanAssets.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNukesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      shared_shared_pb.Assets.Item.serializeBinaryToWriter
    );
  }
  f = message.getCityShieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      shared_shared_pb.Assets.CityShield.serializeBinaryToWriter
    );
  }
  f = message.getOilRigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      shared_shared_pb.Assets.Item.serializeBinaryToWriter
    );
  }
  f = message.getMissileSilosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      shared_shared_pb.Assets.Item.serializeBinaryToWriter
    );
  }
  f = message.getIronDomesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      shared_shared_pb.Assets.Item.serializeBinaryToWriter
    );
  }
};


/**
 * repeated shared.clanevent.Assets.Item nukes = 1;
 * @return {!Array<!proto.shared.clanevent.Assets.Item>}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.getNukesList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Assets.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.Assets.Item, 1));
};


/**
 * @param {!Array<!proto.shared.clanevent.Assets.Item>} value
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
*/
proto.public.clanevent.GetClanAssets.Response.prototype.setNukesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.shared.clanevent.Assets.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Assets.Item}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.addNukes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.shared.clanevent.Assets.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
 */
proto.public.clanevent.GetClanAssets.Response.prototype.clearNukesList = function() {
  return this.setNukesList([]);
};


/**
 * repeated shared.clanevent.Assets.CityShield city_shields = 2;
 * @return {!Array<!proto.shared.clanevent.Assets.CityShield>}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.getCityShieldsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Assets.CityShield>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.Assets.CityShield, 2));
};


/**
 * @param {!Array<!proto.shared.clanevent.Assets.CityShield>} value
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
*/
proto.public.clanevent.GetClanAssets.Response.prototype.setCityShieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.shared.clanevent.Assets.CityShield=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Assets.CityShield}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.addCityShields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.shared.clanevent.Assets.CityShield, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
 */
proto.public.clanevent.GetClanAssets.Response.prototype.clearCityShieldsList = function() {
  return this.setCityShieldsList([]);
};


/**
 * repeated shared.clanevent.Assets.Item oil_rigs = 3;
 * @return {!Array<!proto.shared.clanevent.Assets.Item>}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.getOilRigsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Assets.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.Assets.Item, 3));
};


/**
 * @param {!Array<!proto.shared.clanevent.Assets.Item>} value
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
*/
proto.public.clanevent.GetClanAssets.Response.prototype.setOilRigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.shared.clanevent.Assets.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Assets.Item}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.addOilRigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.shared.clanevent.Assets.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
 */
proto.public.clanevent.GetClanAssets.Response.prototype.clearOilRigsList = function() {
  return this.setOilRigsList([]);
};


/**
 * repeated shared.clanevent.Assets.Item missile_silos = 4;
 * @return {!Array<!proto.shared.clanevent.Assets.Item>}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.getMissileSilosList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Assets.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.Assets.Item, 4));
};


/**
 * @param {!Array<!proto.shared.clanevent.Assets.Item>} value
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
*/
proto.public.clanevent.GetClanAssets.Response.prototype.setMissileSilosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.shared.clanevent.Assets.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Assets.Item}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.addMissileSilos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.shared.clanevent.Assets.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
 */
proto.public.clanevent.GetClanAssets.Response.prototype.clearMissileSilosList = function() {
  return this.setMissileSilosList([]);
};


/**
 * repeated shared.clanevent.Assets.Item iron_domes = 5;
 * @return {!Array<!proto.shared.clanevent.Assets.Item>}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.getIronDomesList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Assets.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_shared_pb.Assets.Item, 5));
};


/**
 * @param {!Array<!proto.shared.clanevent.Assets.Item>} value
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
*/
proto.public.clanevent.GetClanAssets.Response.prototype.setIronDomesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.shared.clanevent.Assets.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Assets.Item}
 */
proto.public.clanevent.GetClanAssets.Response.prototype.addIronDomes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.shared.clanevent.Assets.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetClanAssets.Response} returns this
 */
proto.public.clanevent.GetClanAssets.Response.prototype.clearIronDomesList = function() {
  return this.setIronDomesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.QueueRestrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.QueueRestrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.QueueRestrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.QueueRestrictions.toObject = function(includeInstance, msg) {
  var f, obj = {
    buildpoints: (f = msg.getBuildpoints()) && proto.public.clanevent.QueueRestrictions.FundLimits.toObject(includeInstance, f),
    butter: (f = msg.getButter()) && proto.public.clanevent.QueueRestrictions.FundLimits.toObject(includeInstance, f),
    uranium: (f = msg.getUranium()) && proto.public.clanevent.QueueRestrictions.FundLimits.toObject(includeInstance, f),
    canAttack: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.QueueRestrictions}
 */
proto.public.clanevent.QueueRestrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.QueueRestrictions;
  return proto.public.clanevent.QueueRestrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.QueueRestrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.QueueRestrictions}
 */
proto.public.clanevent.QueueRestrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.QueueRestrictions.FundLimits;
      reader.readMessage(value,proto.public.clanevent.QueueRestrictions.FundLimits.deserializeBinaryFromReader);
      msg.setBuildpoints(value);
      break;
    case 2:
      var value = new proto.public.clanevent.QueueRestrictions.FundLimits;
      reader.readMessage(value,proto.public.clanevent.QueueRestrictions.FundLimits.deserializeBinaryFromReader);
      msg.setButter(value);
      break;
    case 3:
      var value = new proto.public.clanevent.QueueRestrictions.FundLimits;
      reader.readMessage(value,proto.public.clanevent.QueueRestrictions.FundLimits.deserializeBinaryFromReader);
      msg.setUranium(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanAttack(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.QueueRestrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.QueueRestrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.QueueRestrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.QueueRestrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBuildpoints();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.QueueRestrictions.FundLimits.serializeBinaryToWriter
    );
  }
  f = message.getButter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.clanevent.QueueRestrictions.FundLimits.serializeBinaryToWriter
    );
  }
  f = message.getUranium();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.public.clanevent.QueueRestrictions.FundLimits.serializeBinaryToWriter
    );
  }
  f = message.getCanAttack();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.QueueRestrictions.FundLimits.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.QueueRestrictions.FundLimits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.QueueRestrictions.FundLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.QueueRestrictions.FundLimits.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
    unlimited: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.QueueRestrictions.FundLimits}
 */
proto.public.clanevent.QueueRestrictions.FundLimits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.QueueRestrictions.FundLimits;
  return proto.public.clanevent.QueueRestrictions.FundLimits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.QueueRestrictions.FundLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.QueueRestrictions.FundLimits}
 */
proto.public.clanevent.QueueRestrictions.FundLimits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnlimited(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.QueueRestrictions.FundLimits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.QueueRestrictions.FundLimits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.QueueRestrictions.FundLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.QueueRestrictions.FundLimits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUnlimited();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional int64 limit = 1;
 * @return {number}
 */
proto.public.clanevent.QueueRestrictions.FundLimits.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.QueueRestrictions.FundLimits} returns this
 */
proto.public.clanevent.QueueRestrictions.FundLimits.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool unlimited = 2;
 * @return {boolean}
 */
proto.public.clanevent.QueueRestrictions.FundLimits.prototype.getUnlimited = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clanevent.QueueRestrictions.FundLimits} returns this
 */
proto.public.clanevent.QueueRestrictions.FundLimits.prototype.setUnlimited = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional FundLimits buildpoints = 1;
 * @return {?proto.public.clanevent.QueueRestrictions.FundLimits}
 */
proto.public.clanevent.QueueRestrictions.prototype.getBuildpoints = function() {
  return /** @type{?proto.public.clanevent.QueueRestrictions.FundLimits} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.QueueRestrictions.FundLimits, 1));
};


/**
 * @param {?proto.public.clanevent.QueueRestrictions.FundLimits|undefined} value
 * @return {!proto.public.clanevent.QueueRestrictions} returns this
*/
proto.public.clanevent.QueueRestrictions.prototype.setBuildpoints = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.QueueRestrictions} returns this
 */
proto.public.clanevent.QueueRestrictions.prototype.clearBuildpoints = function() {
  return this.setBuildpoints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.QueueRestrictions.prototype.hasBuildpoints = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FundLimits butter = 2;
 * @return {?proto.public.clanevent.QueueRestrictions.FundLimits}
 */
proto.public.clanevent.QueueRestrictions.prototype.getButter = function() {
  return /** @type{?proto.public.clanevent.QueueRestrictions.FundLimits} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.QueueRestrictions.FundLimits, 2));
};


/**
 * @param {?proto.public.clanevent.QueueRestrictions.FundLimits|undefined} value
 * @return {!proto.public.clanevent.QueueRestrictions} returns this
*/
proto.public.clanevent.QueueRestrictions.prototype.setButter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.QueueRestrictions} returns this
 */
proto.public.clanevent.QueueRestrictions.prototype.clearButter = function() {
  return this.setButter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.QueueRestrictions.prototype.hasButter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FundLimits uranium = 3;
 * @return {?proto.public.clanevent.QueueRestrictions.FundLimits}
 */
proto.public.clanevent.QueueRestrictions.prototype.getUranium = function() {
  return /** @type{?proto.public.clanevent.QueueRestrictions.FundLimits} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.QueueRestrictions.FundLimits, 3));
};


/**
 * @param {?proto.public.clanevent.QueueRestrictions.FundLimits|undefined} value
 * @return {!proto.public.clanevent.QueueRestrictions} returns this
*/
proto.public.clanevent.QueueRestrictions.prototype.setUranium = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.QueueRestrictions} returns this
 */
proto.public.clanevent.QueueRestrictions.prototype.clearUranium = function() {
  return this.setUranium(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.QueueRestrictions.prototype.hasUranium = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool can_attack = 4;
 * @return {boolean}
 */
proto.public.clanevent.QueueRestrictions.prototype.getCanAttack = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clanevent.QueueRestrictions} returns this
 */
proto.public.clanevent.QueueRestrictions.prototype.setCanAttack = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.SetRestrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.SetRestrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.SetRestrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.SetRestrictions.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.SetRestrictions}
 */
proto.public.clanevent.SetRestrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.SetRestrictions;
  return proto.public.clanevent.SetRestrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.SetRestrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.SetRestrictions}
 */
proto.public.clanevent.SetRestrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.SetRestrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.SetRestrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.SetRestrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.SetRestrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.SetRestrictions.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.SetRestrictions.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.SetRestrictions.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.SetRestrictions.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    role: jspb.Message.getFieldWithDefault(msg, 1, ""),
    queueRestrictions: (f = msg.getQueueRestrictions()) && proto.public.clanevent.QueueRestrictions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.SetRestrictions.Request}
 */
proto.public.clanevent.SetRestrictions.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.SetRestrictions.Request;
  return proto.public.clanevent.SetRestrictions.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.SetRestrictions.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.SetRestrictions.Request}
 */
proto.public.clanevent.SetRestrictions.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 2:
      var value = new proto.public.clanevent.QueueRestrictions;
      reader.readMessage(value,proto.public.clanevent.QueueRestrictions.deserializeBinaryFromReader);
      msg.setQueueRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.SetRestrictions.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.SetRestrictions.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.SetRestrictions.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.SetRestrictions.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQueueRestrictions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.public.clanevent.QueueRestrictions.serializeBinaryToWriter
    );
  }
};


/**
 * optional string role = 1;
 * @return {string}
 */
proto.public.clanevent.SetRestrictions.Request.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.SetRestrictions.Request} returns this
 */
proto.public.clanevent.SetRestrictions.Request.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional QueueRestrictions queue_restrictions = 2;
 * @return {?proto.public.clanevent.QueueRestrictions}
 */
proto.public.clanevent.SetRestrictions.Request.prototype.getQueueRestrictions = function() {
  return /** @type{?proto.public.clanevent.QueueRestrictions} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.QueueRestrictions, 2));
};


/**
 * @param {?proto.public.clanevent.QueueRestrictions|undefined} value
 * @return {!proto.public.clanevent.SetRestrictions.Request} returns this
*/
proto.public.clanevent.SetRestrictions.Request.prototype.setQueueRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.SetRestrictions.Request} returns this
 */
proto.public.clanevent.SetRestrictions.Request.prototype.clearQueueRestrictions = function() {
  return this.setQueueRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.SetRestrictions.Request.prototype.hasQueueRestrictions = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.SetRestrictions.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.SetRestrictions.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.SetRestrictions.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.SetRestrictions.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.SetRestrictions.Response}
 */
proto.public.clanevent.SetRestrictions.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.SetRestrictions.Response;
  return proto.public.clanevent.SetRestrictions.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.SetRestrictions.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.SetRestrictions.Response}
 */
proto.public.clanevent.SetRestrictions.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.SetRestrictions.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.SetRestrictions.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.SetRestrictions.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.SetRestrictions.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetRestrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetRestrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetRestrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRestrictions.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetRestrictions}
 */
proto.public.clanevent.GetRestrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetRestrictions;
  return proto.public.clanevent.GetRestrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetRestrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetRestrictions}
 */
proto.public.clanevent.GetRestrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetRestrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetRestrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetRestrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRestrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetRestrictions.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetRestrictions.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetRestrictions.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRestrictions.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    role: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetRestrictions.Request}
 */
proto.public.clanevent.GetRestrictions.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetRestrictions.Request;
  return proto.public.clanevent.GetRestrictions.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetRestrictions.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetRestrictions.Request}
 */
proto.public.clanevent.GetRestrictions.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetRestrictions.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetRestrictions.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetRestrictions.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRestrictions.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string role = 1;
 * @return {string}
 */
proto.public.clanevent.GetRestrictions.Request.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetRestrictions.Request} returns this
 */
proto.public.clanevent.GetRestrictions.Request.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetRestrictions.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetRestrictions.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetRestrictions.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRestrictions.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    queueRestrictions: (f = msg.getQueueRestrictions()) && proto.public.clanevent.QueueRestrictions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetRestrictions.Response}
 */
proto.public.clanevent.GetRestrictions.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetRestrictions.Response;
  return proto.public.clanevent.GetRestrictions.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetRestrictions.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetRestrictions.Response}
 */
proto.public.clanevent.GetRestrictions.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.QueueRestrictions;
      reader.readMessage(value,proto.public.clanevent.QueueRestrictions.deserializeBinaryFromReader);
      msg.setQueueRestrictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetRestrictions.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetRestrictions.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetRestrictions.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetRestrictions.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQueueRestrictions();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.QueueRestrictions.serializeBinaryToWriter
    );
  }
};


/**
 * optional QueueRestrictions queue_restrictions = 1;
 * @return {?proto.public.clanevent.QueueRestrictions}
 */
proto.public.clanevent.GetRestrictions.Response.prototype.getQueueRestrictions = function() {
  return /** @type{?proto.public.clanevent.QueueRestrictions} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.QueueRestrictions, 1));
};


/**
 * @param {?proto.public.clanevent.QueueRestrictions|undefined} value
 * @return {!proto.public.clanevent.GetRestrictions.Response} returns this
*/
proto.public.clanevent.GetRestrictions.Response.prototype.setQueueRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetRestrictions.Response} returns this
 */
proto.public.clanevent.GetRestrictions.Response.prototype.clearQueueRestrictions = function() {
  return this.setQueueRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetRestrictions.Response.prototype.hasQueueRestrictions = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetUserRestrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetUserRestrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetUserRestrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetUserRestrictions.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetUserRestrictions}
 */
proto.public.clanevent.GetUserRestrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetUserRestrictions;
  return proto.public.clanevent.GetUserRestrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetUserRestrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetUserRestrictions}
 */
proto.public.clanevent.GetUserRestrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetUserRestrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetUserRestrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetUserRestrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetUserRestrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetUserRestrictions.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetUserRestrictions.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetUserRestrictions.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetUserRestrictions.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetUserRestrictions.Request}
 */
proto.public.clanevent.GetUserRestrictions.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetUserRestrictions.Request;
  return proto.public.clanevent.GetUserRestrictions.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetUserRestrictions.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetUserRestrictions.Request}
 */
proto.public.clanevent.GetUserRestrictions.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetUserRestrictions.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetUserRestrictions.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetUserRestrictions.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetUserRestrictions.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetUserRestrictions.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetUserRestrictions.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetUserRestrictions.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetUserRestrictions.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    queueRestrictions: (f = msg.getQueueRestrictions()) && proto.public.clanevent.QueueRestrictions.toObject(includeInstance, f),
    canCurrentUserSet: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetUserRestrictions.Response}
 */
proto.public.clanevent.GetUserRestrictions.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetUserRestrictions.Response;
  return proto.public.clanevent.GetUserRestrictions.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetUserRestrictions.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetUserRestrictions.Response}
 */
proto.public.clanevent.GetUserRestrictions.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clanevent.QueueRestrictions;
      reader.readMessage(value,proto.public.clanevent.QueueRestrictions.deserializeBinaryFromReader);
      msg.setQueueRestrictions(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanCurrentUserSet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetUserRestrictions.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetUserRestrictions.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetUserRestrictions.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetUserRestrictions.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQueueRestrictions();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clanevent.QueueRestrictions.serializeBinaryToWriter
    );
  }
  f = message.getCanCurrentUserSet();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional QueueRestrictions queue_restrictions = 1;
 * @return {?proto.public.clanevent.QueueRestrictions}
 */
proto.public.clanevent.GetUserRestrictions.Response.prototype.getQueueRestrictions = function() {
  return /** @type{?proto.public.clanevent.QueueRestrictions} */ (
    jspb.Message.getWrapperField(this, proto.public.clanevent.QueueRestrictions, 1));
};


/**
 * @param {?proto.public.clanevent.QueueRestrictions|undefined} value
 * @return {!proto.public.clanevent.GetUserRestrictions.Response} returns this
*/
proto.public.clanevent.GetUserRestrictions.Response.prototype.setQueueRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetUserRestrictions.Response} returns this
 */
proto.public.clanevent.GetUserRestrictions.Response.prototype.clearQueueRestrictions = function() {
  return this.setQueueRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetUserRestrictions.Response.prototype.hasQueueRestrictions = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool can_current_user_set = 2;
 * @return {boolean}
 */
proto.public.clanevent.GetUserRestrictions.Response.prototype.getCanCurrentUserSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clanevent.GetUserRestrictions.Response} returns this
 */
proto.public.clanevent.GetUserRestrictions.Response.prototype.setCanCurrentUserSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetProductPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetProductPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetProductPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetProductPrice.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetProductPrice}
 */
proto.public.clanevent.GetProductPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetProductPrice;
  return proto.public.clanevent.GetProductPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetProductPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetProductPrice}
 */
proto.public.clanevent.GetProductPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetProductPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetProductPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetProductPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetProductPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetProductPrice.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetProductPrice.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetProductPrice.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetProductPrice.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    turnId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    itemData: (f = msg.getItemData()) && shared_shared_pb.RoundQueue.ItemData.toObject(includeInstance, f),
    currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    itemDataAmount: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetProductPrice.Request}
 */
proto.public.clanevent.GetProductPrice.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetProductPrice.Request;
  return proto.public.clanevent.GetProductPrice.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetProductPrice.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetProductPrice.Request}
 */
proto.public.clanevent.GetProductPrice.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTurnId(value);
      break;
    case 3:
      var value = new shared_shared_pb.RoundQueue.ItemData;
      reader.readMessage(value,shared_shared_pb.RoundQueue.ItemData.deserializeBinaryFromReader);
      msg.setItemData(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemDataAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetProductPrice.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetProductPrice.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetProductPrice.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetProductPrice.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTurnId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItemData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_shared_pb.RoundQueue.ItemData.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getItemDataAmount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.public.clanevent.GetProductPrice.Request.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetProductPrice.Request} returns this
 */
proto.public.clanevent.GetProductPrice.Request.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string turn_id = 2;
 * @return {string}
 */
proto.public.clanevent.GetProductPrice.Request.prototype.getTurnId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetProductPrice.Request} returns this
 */
proto.public.clanevent.GetProductPrice.Request.prototype.setTurnId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional shared.clanevent.RoundQueue.ItemData item_data = 3;
 * @return {?proto.shared.clanevent.RoundQueue.ItemData}
 */
proto.public.clanevent.GetProductPrice.Request.prototype.getItemData = function() {
  return /** @type{?proto.shared.clanevent.RoundQueue.ItemData} */ (
    jspb.Message.getWrapperField(this, shared_shared_pb.RoundQueue.ItemData, 3));
};


/**
 * @param {?proto.shared.clanevent.RoundQueue.ItemData|undefined} value
 * @return {!proto.public.clanevent.GetProductPrice.Request} returns this
*/
proto.public.clanevent.GetProductPrice.Request.prototype.setItemData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clanevent.GetProductPrice.Request} returns this
 */
proto.public.clanevent.GetProductPrice.Request.prototype.clearItemData = function() {
  return this.setItemData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clanevent.GetProductPrice.Request.prototype.hasItemData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.public.clanevent.GetProductPrice.Request.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clanevent.GetProductPrice.Request} returns this
 */
proto.public.clanevent.GetProductPrice.Request.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 item_data_amount = 5;
 * @return {number}
 */
proto.public.clanevent.GetProductPrice.Request.prototype.getItemDataAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetProductPrice.Request} returns this
 */
proto.public.clanevent.GetProductPrice.Request.prototype.setItemDataAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clanevent.GetProductPrice.Response.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clanevent.GetProductPrice.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clanevent.GetProductPrice.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clanevent.GetProductPrice.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetProductPrice.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalPrice: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pricePerItemList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clanevent.GetProductPrice.Response}
 */
proto.public.clanevent.GetProductPrice.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clanevent.GetProductPrice.Response;
  return proto.public.clanevent.GetProductPrice.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clanevent.GetProductPrice.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clanevent.GetProductPrice.Response}
 */
proto.public.clanevent.GetProductPrice.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalPrice(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPricePerItem(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clanevent.GetProductPrice.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clanevent.GetProductPrice.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clanevent.GetProductPrice.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clanevent.GetProductPrice.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalPrice();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPricePerItemList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 total_price = 1;
 * @return {number}
 */
proto.public.clanevent.GetProductPrice.Response.prototype.getTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clanevent.GetProductPrice.Response} returns this
 */
proto.public.clanevent.GetProductPrice.Response.prototype.setTotalPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int64 price_per_item = 2;
 * @return {!Array<number>}
 */
proto.public.clanevent.GetProductPrice.Response.prototype.getPricePerItemList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.public.clanevent.GetProductPrice.Response} returns this
 */
proto.public.clanevent.GetProductPrice.Response.prototype.setPricePerItemList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.public.clanevent.GetProductPrice.Response} returns this
 */
proto.public.clanevent.GetProductPrice.Response.prototype.addPricePerItem = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clanevent.GetProductPrice.Response} returns this
 */
proto.public.clanevent.GetProductPrice.Response.prototype.clearPricePerItemList = function() {
  return this.setPricePerItemList([]);
};


goog.object.extend(exports, proto.public.clanevent);

},{"../shared/shared_pb.js":18,"../validate/validate_pb.js":19,"google-protobuf":3,"google-protobuf/google/protobuf/timestamp_pb.js":6}],18:[function(require,module,exports){
// source: shared/shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.shared.clanevent.Assets', null, global);
goog.exportSymbol('proto.shared.clanevent.Assets.CityShield', null, global);
goog.exportSymbol('proto.shared.clanevent.Assets.Item', null, global);
goog.exportSymbol('proto.shared.clanevent.Bonus', null, global);
goog.exportSymbol('proto.shared.clanevent.ClanTreasury', null, global);
goog.exportSymbol('proto.shared.clanevent.ClanTreasury.OperationType', null, global);
goog.exportSymbol('proto.shared.clanevent.Currency', null, global);
goog.exportSymbol('proto.shared.clanevent.Currency.ID', null, global);
goog.exportSymbol('proto.shared.clanevent.DifficultyConfig', null, global);
goog.exportSymbol('proto.shared.clanevent.DifficultyValue', null, global);
goog.exportSymbol('proto.shared.clanevent.Empty', null, global);
goog.exportSymbol('proto.shared.clanevent.Event', null, global);
goog.exportSymbol('proto.shared.clanevent.Event.RewardTier', null, global);
goog.exportSymbol('proto.shared.clanevent.Event.RewardTier.Reward', null, global);
goog.exportSymbol('proto.shared.clanevent.Event.RewardTier.Reward.RewardCase', null, global);
goog.exportSymbol('proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory', null, global);
goog.exportSymbol('proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney', null, global);
goog.exportSymbol('proto.shared.clanevent.Event.RewardTier.Reward.RewardToken', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension.WorldDomination', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension.WorldDomination.Config', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks', null, global);
goog.exportSymbol('proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke', null, global);
goog.exportSymbol('proto.shared.clanevent.Market', null, global);
goog.exportSymbol('proto.shared.clanevent.Market.ProductPrices', null, global);
goog.exportSymbol('proto.shared.clanevent.Money', null, global);
goog.exportSymbol('proto.shared.clanevent.NotificationErrorCode', null, global);
goog.exportSymbol('proto.shared.clanevent.NotificationType', null, global);
goog.exportSymbol('proto.shared.clanevent.NotificationWDRequest', null, global);
goog.exportSymbol('proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue', null, global);
goog.exportSymbol('proto.shared.clanevent.NotificationWDRequest.Error', null, global);
goog.exportSymbol('proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue', null, global);
goog.exportSymbol('proto.shared.clanevent.NotificationWDRequest.ResultCase', null, global);
goog.exportSymbol('proto.shared.clanevent.Product', null, global);
goog.exportSymbol('proto.shared.clanevent.Product.ID', null, global);
goog.exportSymbol('proto.shared.clanevent.Raid', null, global);
goog.exportSymbol('proto.shared.clanevent.Raid.Level', null, global);
goog.exportSymbol('proto.shared.clanevent.Raid.MissionProgressBoosts', null, global);
goog.exportSymbol('proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts', null, global);
goog.exportSymbol('proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec', null, global);
goog.exportSymbol('proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute', null, global);
goog.exportSymbol('proto.shared.clanevent.RoundQueue', null, global);
goog.exportSymbol('proto.shared.clanevent.RoundQueue.AttackCityByNuke', null, global);
goog.exportSymbol('proto.shared.clanevent.RoundQueue.BuildCityShield', null, global);
goog.exportSymbol('proto.shared.clanevent.RoundQueue.Item', null, global);
goog.exportSymbol('proto.shared.clanevent.RoundQueue.ItemData', null, global);
goog.exportSymbol('proto.shared.clanevent.RoundQueue.ItemData.DataCase', null, global);
goog.exportSymbol('proto.shared.clanevent.WorldDominationBoard', null, global);
goog.exportSymbol('proto.shared.clanevent.WorldDominationBoard.ClanSlot', null, global);
goog.exportSymbol('proto.shared.clanevent.WorldDominationBoard.ClanSlot.Kind', null, global);
goog.exportSymbol('proto.shared.clanevent.WorldDominationBoard.ClanSlot.Status', null, global);
goog.exportSymbol('proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Empty.displayName = 'proto.shared.clanevent.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.DifficultyConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.DifficultyConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.DifficultyConfig.displayName = 'proto.shared.clanevent.DifficultyConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Bonus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Bonus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Bonus.displayName = 'proto.shared.clanevent.Bonus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.displayName = 'proto.shared.clanevent.EventExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension.WorldDomination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension.WorldDomination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.WorldDomination.displayName = 'proto.shared.clanevent.EventExtension.WorldDomination';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension.WorldDomination.Config, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.WorldDomination.Config.displayName = 'proto.shared.clanevent.EventExtension.WorldDomination.Config';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.displayName = 'proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.displayName = 'proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.displayName = 'proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.displayName = 'proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.displayName = 'proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.displayName = 'proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Raid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Raid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Raid.displayName = 'proto.shared.clanevent.Raid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Raid.MissionProgressBoosts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Raid.MissionProgressBoosts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Raid.MissionProgressBoosts.displayName = 'proto.shared.clanevent.Raid.MissionProgressBoosts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.repeatedFields_, null);
};
goog.inherits(proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.displayName = 'proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.displayName = 'proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.displayName = 'proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Raid.Level = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shared.clanevent.Raid.Level.repeatedFields_, null);
};
goog.inherits(proto.shared.clanevent.Raid.Level, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Raid.Level.displayName = 'proto.shared.clanevent.Raid.Level';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Event.displayName = 'proto.shared.clanevent.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Event.RewardTier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shared.clanevent.Event.RewardTier.repeatedFields_, null);
};
goog.inherits(proto.shared.clanevent.Event.RewardTier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Event.RewardTier.displayName = 'proto.shared.clanevent.Event.RewardTier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Event.RewardTier.Reward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_);
};
goog.inherits(proto.shared.clanevent.Event.RewardTier.Reward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Event.RewardTier.Reward.displayName = 'proto.shared.clanevent.Event.RewardTier.Reward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.displayName = 'proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.displayName = 'proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Event.RewardTier.Reward.RewardToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.displayName = 'proto.shared.clanevent.Event.RewardTier.Reward.RewardToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.ClanTreasury = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.ClanTreasury, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.ClanTreasury.displayName = 'proto.shared.clanevent.ClanTreasury';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Product.displayName = 'proto.shared.clanevent.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Currency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Currency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Currency.displayName = 'proto.shared.clanevent.Currency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.RoundQueue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.RoundQueue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.RoundQueue.displayName = 'proto.shared.clanevent.RoundQueue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.RoundQueue.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.RoundQueue.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.RoundQueue.Item.displayName = 'proto.shared.clanevent.RoundQueue.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.RoundQueue.ItemData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_);
};
goog.inherits(proto.shared.clanevent.RoundQueue.ItemData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.RoundQueue.ItemData.displayName = 'proto.shared.clanevent.RoundQueue.ItemData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.RoundQueue.BuildCityShield = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.RoundQueue.BuildCityShield, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.RoundQueue.BuildCityShield.displayName = 'proto.shared.clanevent.RoundQueue.BuildCityShield';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shared.clanevent.RoundQueue.AttackCityByNuke.repeatedFields_, null);
};
goog.inherits(proto.shared.clanevent.RoundQueue.AttackCityByNuke, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.RoundQueue.AttackCityByNuke.displayName = 'proto.shared.clanevent.RoundQueue.AttackCityByNuke';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Assets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Assets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Assets.displayName = 'proto.shared.clanevent.Assets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Assets.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Assets.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Assets.Item.displayName = 'proto.shared.clanevent.Assets.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Assets.CityShield = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Assets.CityShield, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Assets.CityShield.displayName = 'proto.shared.clanevent.Assets.CityShield';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Money = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Money, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Money.displayName = 'proto.shared.clanevent.Money';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Market = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.Market, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Market.displayName = 'proto.shared.clanevent.Market';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.Market.ProductPrices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shared.clanevent.Market.ProductPrices.repeatedFields_, null);
};
goog.inherits(proto.shared.clanevent.Market.ProductPrices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.Market.ProductPrices.displayName = 'proto.shared.clanevent.Market.ProductPrices';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.WorldDominationBoard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.WorldDominationBoard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.WorldDominationBoard.displayName = 'proto.shared.clanevent.WorldDominationBoard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.repeatedFields_, null);
};
goog.inherits(proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.displayName = 'proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.WorldDominationBoard.ClanSlot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.WorldDominationBoard.ClanSlot.displayName = 'proto.shared.clanevent.WorldDominationBoard.ClanSlot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.NotificationWDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.shared.clanevent.NotificationWDRequest.oneofGroups_);
};
goog.inherits(proto.shared.clanevent.NotificationWDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.NotificationWDRequest.displayName = 'proto.shared.clanevent.NotificationWDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.NotificationWDRequest.Error = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.NotificationWDRequest.Error, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.NotificationWDRequest.Error.displayName = 'proto.shared.clanevent.NotificationWDRequest.Error';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.displayName = 'proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.displayName = 'proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Empty}
 */
proto.shared.clanevent.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Empty;
  return proto.shared.clanevent.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Empty}
 */
proto.shared.clanevent.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.DifficultyConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.DifficultyConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.DifficultyConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.DifficultyConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    questId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rewardPoints: jspb.Message.getFieldWithDefault(msg, 2, 0),
    difficultyValue: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.DifficultyConfig}
 */
proto.shared.clanevent.DifficultyConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.DifficultyConfig;
  return proto.shared.clanevent.DifficultyConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.DifficultyConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.DifficultyConfig}
 */
proto.shared.clanevent.DifficultyConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRewardPoints(value);
      break;
    case 3:
      var value = /** @type {!proto.shared.clanevent.DifficultyValue} */ (reader.readEnum());
      msg.setDifficultyValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.DifficultyConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.DifficultyConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.DifficultyConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.DifficultyConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRewardPoints();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDifficultyValue();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string quest_id = 1;
 * @return {string}
 */
proto.shared.clanevent.DifficultyConfig.prototype.getQuestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.DifficultyConfig} returns this
 */
proto.shared.clanevent.DifficultyConfig.prototype.setQuestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 reward_points = 2;
 * @return {number}
 */
proto.shared.clanevent.DifficultyConfig.prototype.getRewardPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.DifficultyConfig} returns this
 */
proto.shared.clanevent.DifficultyConfig.prototype.setRewardPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional DifficultyValue difficulty_value = 3;
 * @return {!proto.shared.clanevent.DifficultyValue}
 */
proto.shared.clanevent.DifficultyConfig.prototype.getDifficultyValue = function() {
  return /** @type {!proto.shared.clanevent.DifficultyValue} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.shared.clanevent.DifficultyValue} value
 * @return {!proto.shared.clanevent.DifficultyConfig} returns this
 */
proto.shared.clanevent.DifficultyConfig.prototype.setDifficultyValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Bonus.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Bonus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Bonus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Bonus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Bonus}
 */
proto.shared.clanevent.Bonus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Bonus;
  return proto.shared.clanevent.Bonus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Bonus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Bonus}
 */
proto.shared.clanevent.Bonus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Bonus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Bonus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Bonus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Bonus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.toObject = function(includeInstance, msg) {
  var f, obj = {
    worldDomination: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    worldDominationConfig: (f = msg.getWorldDominationConfig()) && proto.shared.clanevent.EventExtension.WorldDomination.Config.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension}
 */
proto.shared.clanevent.EventExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension;
  return proto.shared.clanevent.EventExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension}
 */
proto.shared.clanevent.EventExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWorldDomination(value);
      break;
    case 2:
      var value = new proto.shared.clanevent.EventExtension.WorldDomination.Config;
      reader.readMessage(value,proto.shared.clanevent.EventExtension.WorldDomination.Config.deserializeBinaryFromReader);
      msg.setWorldDominationConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorldDomination();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getWorldDominationConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.shared.clanevent.EventExtension.WorldDomination.Config.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.WorldDomination.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.WorldDomination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination}
 */
proto.shared.clanevent.EventExtension.WorldDomination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension.WorldDomination;
  return proto.shared.clanevent.EventExtension.WorldDomination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination}
 */
proto.shared.clanevent.EventExtension.WorldDomination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.WorldDomination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.WorldDomination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.toObject = function(includeInstance, msg) {
  var f, obj = {
    assets: (f = msg.getAssets()) && proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.toObject(includeInstance, f),
    attacks: (f = msg.getAttacks()) && proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension.WorldDomination.Config;
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets;
      reader.readMessage(value,proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.deserializeBinaryFromReader);
      msg.setAssets(value);
      break;
    case 2:
      var value = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks;
      reader.readMessage(value,proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.deserializeBinaryFromReader);
      msg.setAttacks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.WorldDomination.Config.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssets();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.serializeBinaryToWriter
    );
  }
  f = message.getAttacks();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.toObject = function(includeInstance, msg) {
  var f, obj = {
    attackCityByNuke: (f = msg.getAttackCityByNuke()) && proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks;
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke;
      reader.readMessage(value,proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.deserializeBinaryFromReader);
      msg.setAttackCityByNuke(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttackCityByNuke();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.toObject = function(includeInstance, msg) {
  var f, obj = {
    nukeDestructionPercent: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nukeVampirePercent: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ironDomeProtectionPercent: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke;
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNukeDestructionPercent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNukeVampirePercent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIronDomeProtectionPercent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNukeDestructionPercent();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNukeVampirePercent();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getIronDomeProtectionPercent();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 nuke_destruction_percent = 1;
 * @return {number}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.prototype.getNukeDestructionPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.prototype.setNukeDestructionPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 nuke_vampire_percent = 2;
 * @return {number}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.prototype.getNukeVampirePercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.prototype.setNukeVampirePercent = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 iron_dome_protection_percent = 3;
 * @return {number}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.prototype.getIronDomeProtectionPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke.prototype.setIronDomeProtectionPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional AttackCityByNuke attack_city_by_nuke = 1;
 * @return {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.prototype.getAttackCityByNuke = function() {
  return /** @type{?proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke, 1));
};


/**
 * @param {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.AttackCityByNuke|undefined} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks} returns this
*/
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.prototype.setAttackCityByNuke = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.prototype.clearAttackCityByNuke = function() {
  return this.setAttackCityByNuke(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks.prototype.hasAttackCityByNuke = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.toObject = function(includeInstance, msg) {
  var f, obj = {
    buildingLimits: (f = msg.getBuildingLimits()) && proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.toObject(includeInstance, f),
    oilRig: (f = msg.getOilRig()) && proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.toObject(includeInstance, f),
    missileSilo: (f = msg.getMissileSilo()) && proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets;
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits;
      reader.readMessage(value,proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.deserializeBinaryFromReader);
      msg.setBuildingLimits(value);
      break;
    case 2:
      var value = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig;
      reader.readMessage(value,proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.deserializeBinaryFromReader);
      msg.setOilRig(value);
      break;
    case 3:
      var value = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo;
      reader.readMessage(value,proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.deserializeBinaryFromReader);
      msg.setMissileSilo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBuildingLimits();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.serializeBinaryToWriter
    );
  }
  f = message.getOilRig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.serializeBinaryToWriter
    );
  }
  f = message.getMissileSilo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.toObject = function(includeInstance, msg) {
  var f, obj = {
    ironDomeCount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits;
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIronDomeCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIronDomeCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 iron_dome_count = 1;
 * @return {number}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.prototype.getIronDomeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits.prototype.setIronDomeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.toObject = function(includeInstance, msg) {
  var f, obj = {
    passiveBonusPoints: jspb.Message.getFieldWithDefault(msg, 1, 0),
    activeBonusPercent: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig;
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPassiveBonusPoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActiveBonusPercent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassiveBonusPoints();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getActiveBonusPercent();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 passive_bonus_points = 1;
 * @return {number}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.prototype.getPassiveBonusPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.prototype.setPassiveBonusPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 active_bonus_percent = 2;
 * @return {number}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.prototype.getActiveBonusPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig.prototype.setActiveBonusPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.toObject = function(includeInstance, msg) {
  var f, obj = {
    nukeCapacity: jspb.Message.getFieldWithDefault(msg, 1, 0),
    freeNukesCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo;
  return proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNukeCapacity(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFreeNukesCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNukeCapacity();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFreeNukesCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 nuke_capacity = 1;
 * @return {number}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.prototype.getNukeCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.prototype.setNukeCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 free_nukes_count = 2;
 * @return {number}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.prototype.getFreeNukesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo.prototype.setFreeNukesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional BuildingLimits building_limits = 1;
 * @return {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.getBuildingLimits = function() {
  return /** @type{?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits, 1));
};


/**
 * @param {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.BuildingLimits|undefined} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} returns this
*/
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.setBuildingLimits = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.clearBuildingLimits = function() {
  return this.setBuildingLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.hasBuildingLimits = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OilRig oil_rig = 2;
 * @return {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.getOilRig = function() {
  return /** @type{?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig, 2));
};


/**
 * @param {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.OilRig|undefined} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} returns this
*/
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.setOilRig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.clearOilRig = function() {
  return this.setOilRig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.hasOilRig = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MissileSilo missile_silo = 3;
 * @return {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.getMissileSilo = function() {
  return /** @type{?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo, 3));
};


/**
 * @param {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.MissileSilo|undefined} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} returns this
*/
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.setMissileSilo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.clearMissileSilo = function() {
  return this.setMissileSilo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets.prototype.hasMissileSilo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Assets assets = 1;
 * @return {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.getAssets = function() {
  return /** @type{?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets, 1));
};


/**
 * @param {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Assets|undefined} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config} returns this
*/
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.setAssets = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.clearAssets = function() {
  return this.setAssets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.hasAssets = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Attacks attacks = 2;
 * @return {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.getAttacks = function() {
  return /** @type{?proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks, 2));
};


/**
 * @param {?proto.shared.clanevent.EventExtension.WorldDomination.Config.Attacks|undefined} value
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config} returns this
*/
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.setAttacks = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.EventExtension.WorldDomination.Config} returns this
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.clearAttacks = function() {
  return this.setAttacks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.EventExtension.WorldDomination.Config.prototype.hasAttacks = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool world_domination = 1;
 * @return {boolean}
 */
proto.shared.clanevent.EventExtension.prototype.getWorldDomination = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.shared.clanevent.EventExtension} returns this
 */
proto.shared.clanevent.EventExtension.prototype.setWorldDomination = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional WorldDomination.Config world_domination_config = 2;
 * @return {?proto.shared.clanevent.EventExtension.WorldDomination.Config}
 */
proto.shared.clanevent.EventExtension.prototype.getWorldDominationConfig = function() {
  return /** @type{?proto.shared.clanevent.EventExtension.WorldDomination.Config} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.EventExtension.WorldDomination.Config, 2));
};


/**
 * @param {?proto.shared.clanevent.EventExtension.WorldDomination.Config|undefined} value
 * @return {!proto.shared.clanevent.EventExtension} returns this
*/
proto.shared.clanevent.EventExtension.prototype.setWorldDominationConfig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.EventExtension} returns this
 */
proto.shared.clanevent.EventExtension.prototype.clearWorldDominationConfig = function() {
  return this.setWorldDominationConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.EventExtension.prototype.hasWorldDominationConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Raid.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Raid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Raid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Raid}
 */
proto.shared.clanevent.Raid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Raid;
  return proto.shared.clanevent.Raid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Raid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Raid}
 */
proto.shared.clanevent.Raid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Raid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Raid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Raid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Raid.MissionProgressBoosts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.toObject = function(includeInstance, msg) {
  var f, obj = {
    nftAttributes: (f = msg.getNftAttributes()) && proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Raid.MissionProgressBoosts;
  return proto.shared.clanevent.Raid.MissionProgressBoosts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts;
      reader.readMessage(value,proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.deserializeBinaryFromReader);
      msg.setNftAttributes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Raid.MissionProgressBoosts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNftAttributes();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    specsList: jspb.Message.toObjectList(msg.getSpecsList(),
    proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts;
  return proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = new proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec;
      reader.readMessage(value,proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.deserializeBinaryFromReader);
      msg.addSpecs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSpecsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    percent: jspb.Message.getFieldWithDefault(msg, 3, 0),
    attribute: (f = msg.getAttribute()) && proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec;
  return proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPercent(value);
      break;
    case 4:
      var value = new proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute;
      reader.readMessage(value,proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.deserializeBinaryFromReader);
      msg.setAttribute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPercent();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAttribute();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute;
  return proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 percent = 3;
 * @return {number}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.getPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.setPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Attribute attribute = 4;
 * @return {?proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.getAttribute = function() {
  return /** @type{?proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute, 4));
};


/**
 * @param {?proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.Attribute|undefined} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec} returns this
*/
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.setAttribute = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.clearAttribute = function() {
  return this.setAttribute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec.prototype.hasAttribute = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Spec specs = 3;
 * @return {!Array<!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec>}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.getSpecsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec, 3));
};


/**
 * @param {!Array<!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec>} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts} returns this
*/
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.setSpecsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.addSpecs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.Spec, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts.prototype.clearSpecsList = function() {
  return this.setSpecsList([]);
};


/**
 * optional NFTAttributesBoosts nft_attributes = 1;
 * @return {?proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.prototype.getNftAttributes = function() {
  return /** @type{?proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts, 1));
};


/**
 * @param {?proto.shared.clanevent.Raid.MissionProgressBoosts.NFTAttributesBoosts|undefined} value
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts} returns this
*/
proto.shared.clanevent.Raid.MissionProgressBoosts.prototype.setNftAttributes = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.Raid.MissionProgressBoosts} returns this
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.prototype.clearNftAttributes = function() {
  return this.setNftAttributes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.Raid.MissionProgressBoosts.prototype.hasNftAttributes = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shared.clanevent.Raid.Level.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Raid.Level.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Raid.Level.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Raid.Level} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.Level.toObject = function(includeInstance, msg) {
  var f, obj = {
    price: jspb.Message.getFieldWithDefault(msg, 1, 0),
    difficultiesList: jspb.Message.toObjectList(msg.getDifficultiesList(),
    proto.shared.clanevent.DifficultyConfig.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Raid.Level}
 */
proto.shared.clanevent.Raid.Level.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Raid.Level;
  return proto.shared.clanevent.Raid.Level.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Raid.Level} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Raid.Level}
 */
proto.shared.clanevent.Raid.Level.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrice(value);
      break;
    case 2:
      var value = new proto.shared.clanevent.DifficultyConfig;
      reader.readMessage(value,proto.shared.clanevent.DifficultyConfig.deserializeBinaryFromReader);
      msg.addDifficulties(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Raid.Level.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Raid.Level.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Raid.Level} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Raid.Level.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDifficultiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.shared.clanevent.DifficultyConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 price = 1;
 * @return {number}
 */
proto.shared.clanevent.Raid.Level.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Raid.Level} returns this
 */
proto.shared.clanevent.Raid.Level.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated DifficultyConfig difficulties = 2;
 * @return {!Array<!proto.shared.clanevent.DifficultyConfig>}
 */
proto.shared.clanevent.Raid.Level.prototype.getDifficultiesList = function() {
  return /** @type{!Array<!proto.shared.clanevent.DifficultyConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.shared.clanevent.DifficultyConfig, 2));
};


/**
 * @param {!Array<!proto.shared.clanevent.DifficultyConfig>} value
 * @return {!proto.shared.clanevent.Raid.Level} returns this
*/
proto.shared.clanevent.Raid.Level.prototype.setDifficultiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.shared.clanevent.DifficultyConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.DifficultyConfig}
 */
proto.shared.clanevent.Raid.Level.prototype.addDifficulties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.shared.clanevent.DifficultyConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shared.clanevent.Raid.Level} returns this
 */
proto.shared.clanevent.Raid.Level.prototype.clearDifficultiesList = function() {
  return this.setDifficultiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Event}
 */
proto.shared.clanevent.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Event;
  return proto.shared.clanevent.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Event}
 */
proto.shared.clanevent.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shared.clanevent.Event.RewardTier.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Event.RewardTier.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Event.RewardTier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Event.RewardTier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.toObject = function(includeInstance, msg) {
  var f, obj = {
    tier: jspb.Message.getFieldWithDefault(msg, 1, 0),
    placeFromInclusive: jspb.Message.getFieldWithDefault(msg, 2, 0),
    placeToExclusive: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rewardsList: jspb.Message.toObjectList(msg.getRewardsList(),
    proto.shared.clanevent.Event.RewardTier.Reward.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Event.RewardTier}
 */
proto.shared.clanevent.Event.RewardTier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Event.RewardTier;
  return proto.shared.clanevent.Event.RewardTier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Event.RewardTier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Event.RewardTier}
 */
proto.shared.clanevent.Event.RewardTier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTier(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlaceFromInclusive(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlaceToExclusive(value);
      break;
    case 4:
      var value = new proto.shared.clanevent.Event.RewardTier.Reward;
      reader.readMessage(value,proto.shared.clanevent.Event.RewardTier.Reward.deserializeBinaryFromReader);
      msg.addRewards(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Event.RewardTier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Event.RewardTier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Event.RewardTier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTier();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPlaceFromInclusive();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPlaceToExclusive();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRewardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.shared.clanevent.Event.RewardTier.Reward.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_ = [[1,2,3,4,5,6]];

/**
 * @enum {number}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardCase = {
  REWARD_NOT_SET: 0,
  ORBS: 1,
  ENRICHED_ORBS: 2,
  BUTTER: 3,
  BATTLE_PASS_POINTS: 4,
  INVENTORY: 5,
  TOKEN: 6
};

/**
 * @return {proto.shared.clanevent.Event.RewardTier.Reward.RewardCase}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.getRewardCase = function() {
  return /** @type {proto.shared.clanevent.Event.RewardTier.Reward.RewardCase} */(jspb.Message.computeOneofCase(this, proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Event.RewardTier.Reward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.Reward.toObject = function(includeInstance, msg) {
  var f, obj = {
    orbs: (f = msg.getOrbs()) && proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.toObject(includeInstance, f),
    enrichedOrbs: (f = msg.getEnrichedOrbs()) && proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.toObject(includeInstance, f),
    butter: (f = msg.getButter()) && proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.toObject(includeInstance, f),
    battlePassPoints: (f = msg.getBattlePassPoints()) && proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.toObject(includeInstance, f),
    inventory: (f = msg.getInventory()) && proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.toObject(includeInstance, f),
    token: (f = msg.getToken()) && proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward}
 */
proto.shared.clanevent.Event.RewardTier.Reward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Event.RewardTier.Reward;
  return proto.shared.clanevent.Event.RewardTier.Reward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward}
 */
proto.shared.clanevent.Event.RewardTier.Reward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney;
      reader.readMessage(value,proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.deserializeBinaryFromReader);
      msg.setOrbs(value);
      break;
    case 2:
      var value = new proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney;
      reader.readMessage(value,proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.deserializeBinaryFromReader);
      msg.setEnrichedOrbs(value);
      break;
    case 3:
      var value = new proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney;
      reader.readMessage(value,proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.deserializeBinaryFromReader);
      msg.setButter(value);
      break;
    case 4:
      var value = new proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney;
      reader.readMessage(value,proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.deserializeBinaryFromReader);
      msg.setBattlePassPoints(value);
      break;
    case 5:
      var value = new proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory;
      reader.readMessage(value,proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.deserializeBinaryFromReader);
      msg.setInventory(value);
      break;
    case 6:
      var value = new proto.shared.clanevent.Event.RewardTier.Reward.RewardToken;
      reader.readMessage(value,proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Event.RewardTier.Reward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.Reward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrbs();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.serializeBinaryToWriter
    );
  }
  f = message.getEnrichedOrbs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.serializeBinaryToWriter
    );
  }
  f = message.getButter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.serializeBinaryToWriter
    );
  }
  f = message.getBattlePassPoints();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.serializeBinaryToWriter
    );
  }
  f = message.getInventory();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.serializeBinaryToWriter
    );
  }
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney;
  return proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 amount = 1;
 * @return {number}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory;
  return proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.toObject = function(includeInstance, msg) {
  var f, obj = {
    configId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    level: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardToken}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Event.RewardTier.Reward.RewardToken;
  return proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardToken}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward.RewardToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardToken} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardToken} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 level = 3;
 * @return {number}
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward.RewardToken} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.RewardToken.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional RewardMoney orbs = 1;
 * @return {?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.getOrbs = function() {
  return /** @type{?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney, 1));
};


/**
 * @param {?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney|undefined} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
*/
proto.shared.clanevent.Event.RewardTier.Reward.prototype.setOrbs = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.clearOrbs = function() {
  return this.setOrbs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.hasOrbs = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RewardMoney enriched_orbs = 2;
 * @return {?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.getEnrichedOrbs = function() {
  return /** @type{?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney, 2));
};


/**
 * @param {?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney|undefined} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
*/
proto.shared.clanevent.Event.RewardTier.Reward.prototype.setEnrichedOrbs = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.clearEnrichedOrbs = function() {
  return this.setEnrichedOrbs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.hasEnrichedOrbs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RewardMoney butter = 3;
 * @return {?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.getButter = function() {
  return /** @type{?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney, 3));
};


/**
 * @param {?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney|undefined} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
*/
proto.shared.clanevent.Event.RewardTier.Reward.prototype.setButter = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.clearButter = function() {
  return this.setButter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.hasButter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RewardMoney battle_pass_points = 4;
 * @return {?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.getBattlePassPoints = function() {
  return /** @type{?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney, 4));
};


/**
 * @param {?proto.shared.clanevent.Event.RewardTier.Reward.RewardMoney|undefined} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
*/
proto.shared.clanevent.Event.RewardTier.Reward.prototype.setBattlePassPoints = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.clearBattlePassPoints = function() {
  return this.setBattlePassPoints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.hasBattlePassPoints = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RewardInventory inventory = 5;
 * @return {?proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.getInventory = function() {
  return /** @type{?proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory, 5));
};


/**
 * @param {?proto.shared.clanevent.Event.RewardTier.Reward.RewardInventory|undefined} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
*/
proto.shared.clanevent.Event.RewardTier.Reward.prototype.setInventory = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.clearInventory = function() {
  return this.setInventory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.hasInventory = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RewardToken token = 6;
 * @return {?proto.shared.clanevent.Event.RewardTier.Reward.RewardToken}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.getToken = function() {
  return /** @type{?proto.shared.clanevent.Event.RewardTier.Reward.RewardToken} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Event.RewardTier.Reward.RewardToken, 6));
};


/**
 * @param {?proto.shared.clanevent.Event.RewardTier.Reward.RewardToken|undefined} value
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
*/
proto.shared.clanevent.Event.RewardTier.Reward.prototype.setToken = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.shared.clanevent.Event.RewardTier.Reward.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward} returns this
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.Event.RewardTier.Reward.prototype.hasToken = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 tier = 1;
 * @return {number}
 */
proto.shared.clanevent.Event.RewardTier.prototype.getTier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Event.RewardTier} returns this
 */
proto.shared.clanevent.Event.RewardTier.prototype.setTier = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 place_from_inclusive = 2;
 * @return {number}
 */
proto.shared.clanevent.Event.RewardTier.prototype.getPlaceFromInclusive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Event.RewardTier} returns this
 */
proto.shared.clanevent.Event.RewardTier.prototype.setPlaceFromInclusive = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 place_to_exclusive = 3;
 * @return {number}
 */
proto.shared.clanevent.Event.RewardTier.prototype.getPlaceToExclusive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Event.RewardTier} returns this
 */
proto.shared.clanevent.Event.RewardTier.prototype.setPlaceToExclusive = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated Reward rewards = 4;
 * @return {!Array<!proto.shared.clanevent.Event.RewardTier.Reward>}
 */
proto.shared.clanevent.Event.RewardTier.prototype.getRewardsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Event.RewardTier.Reward>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.shared.clanevent.Event.RewardTier.Reward, 4));
};


/**
 * @param {!Array<!proto.shared.clanevent.Event.RewardTier.Reward>} value
 * @return {!proto.shared.clanevent.Event.RewardTier} returns this
*/
proto.shared.clanevent.Event.RewardTier.prototype.setRewardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.shared.clanevent.Event.RewardTier.Reward=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Event.RewardTier.Reward}
 */
proto.shared.clanevent.Event.RewardTier.prototype.addRewards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.shared.clanevent.Event.RewardTier.Reward, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shared.clanevent.Event.RewardTier} returns this
 */
proto.shared.clanevent.Event.RewardTier.prototype.clearRewardsList = function() {
  return this.setRewardsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.ClanTreasury.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.ClanTreasury.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.ClanTreasury} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.ClanTreasury.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.ClanTreasury}
 */
proto.shared.clanevent.ClanTreasury.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.ClanTreasury;
  return proto.shared.clanevent.ClanTreasury.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.ClanTreasury} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.ClanTreasury}
 */
proto.shared.clanevent.ClanTreasury.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.ClanTreasury.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.ClanTreasury.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.ClanTreasury} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.ClanTreasury.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.shared.clanevent.ClanTreasury.OperationType = {
  UNKNOWN: 0,
  CLAN_EVENT_START_RAID: 1,
  CLAN_EVENT_TIER_REWARD: 2,
  CLAN_EVENT_WORLD_DOMINATION_PURCHASE: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Product.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Product}
 */
proto.shared.clanevent.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Product;
  return proto.shared.clanevent.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Product}
 */
proto.shared.clanevent.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.shared.clanevent.Product.ID = {
  UNKNOWN: 0,
  BUILD_NUKE: 1,
  BUILD_OIL_RIG: 2,
  BUILD_MISSILE_SILO: 3,
  BUILD_IRON_DOME: 4,
  ATTACK_CITY_BY_NUKE: 5,
  BUILD_CITY_SHIELD: 6,
  BUY_URANIUM: 7
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Currency.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Currency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Currency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Currency.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Currency}
 */
proto.shared.clanevent.Currency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Currency;
  return proto.shared.clanevent.Currency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Currency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Currency}
 */
proto.shared.clanevent.Currency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Currency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Currency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Currency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Currency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.shared.clanevent.Currency.ID = {
  UNKNOWN: 0,
  URANIUM: 1,
  BUTTER: 2,
  BUILD_POINT: 3,
  SQUIRREL: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.RoundQueue.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.RoundQueue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.RoundQueue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.RoundQueue}
 */
proto.shared.clanevent.RoundQueue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.RoundQueue;
  return proto.shared.clanevent.RoundQueue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.RoundQueue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.RoundQueue}
 */
proto.shared.clanevent.RoundQueue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.RoundQueue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.RoundQueue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.RoundQueue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.RoundQueue.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.RoundQueue.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.RoundQueue.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    data: (f = msg.getData()) && proto.shared.clanevent.RoundQueue.ItemData.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && proto.shared.clanevent.Money.toObject(includeInstance, f),
    dataCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.RoundQueue.Item}
 */
proto.shared.clanevent.RoundQueue.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.RoundQueue.Item;
  return proto.shared.clanevent.RoundQueue.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.RoundQueue.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.RoundQueue.Item}
 */
proto.shared.clanevent.RoundQueue.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.shared.clanevent.RoundQueue.ItemData;
      reader.readMessage(value,proto.shared.clanevent.RoundQueue.ItemData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 3:
      var value = new proto.shared.clanevent.Money;
      reader.readMessage(value,proto.shared.clanevent.Money.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDataCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.RoundQueue.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.RoundQueue.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.RoundQueue.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.shared.clanevent.RoundQueue.ItemData.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.shared.clanevent.Money.serializeBinaryToWriter
    );
  }
  f = message.getDataCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.shared.clanevent.RoundQueue.Item.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.RoundQueue.Item} returns this
 */
proto.shared.clanevent.RoundQueue.Item.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ItemData data = 2;
 * @return {?proto.shared.clanevent.RoundQueue.ItemData}
 */
proto.shared.clanevent.RoundQueue.Item.prototype.getData = function() {
  return /** @type{?proto.shared.clanevent.RoundQueue.ItemData} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.RoundQueue.ItemData, 2));
};


/**
 * @param {?proto.shared.clanevent.RoundQueue.ItemData|undefined} value
 * @return {!proto.shared.clanevent.RoundQueue.Item} returns this
*/
proto.shared.clanevent.RoundQueue.Item.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.Item} returns this
 */
proto.shared.clanevent.RoundQueue.Item.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.Item.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Money price = 3;
 * @return {?proto.shared.clanevent.Money}
 */
proto.shared.clanevent.RoundQueue.Item.prototype.getPrice = function() {
  return /** @type{?proto.shared.clanevent.Money} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.Money, 3));
};


/**
 * @param {?proto.shared.clanevent.Money|undefined} value
 * @return {!proto.shared.clanevent.RoundQueue.Item} returns this
*/
proto.shared.clanevent.RoundQueue.Item.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.Item} returns this
 */
proto.shared.clanevent.RoundQueue.Item.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.Item.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 data_count = 4;
 * @return {number}
 */
proto.shared.clanevent.RoundQueue.Item.prototype.getDataCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.RoundQueue.Item} returns this
 */
proto.shared.clanevent.RoundQueue.Item.prototype.setDataCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_ = [[1,2,3,4,5,6,7]];

/**
 * @enum {number}
 */
proto.shared.clanevent.RoundQueue.ItemData.DataCase = {
  DATA_NOT_SET: 0,
  BUILD_NUKE: 1,
  BUILD_OIL_RIG: 2,
  BUILD_MISSILE_SILO: 3,
  BUILD_IRON_DOME: 4,
  ATTACK_CITY_BY_NUKE: 5,
  BUILD_CITY_SHIELD: 6,
  BUY_URANIUM: 7
};

/**
 * @return {proto.shared.clanevent.RoundQueue.ItemData.DataCase}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.getDataCase = function() {
  return /** @type {proto.shared.clanevent.RoundQueue.ItemData.DataCase} */(jspb.Message.computeOneofCase(this, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.RoundQueue.ItemData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.RoundQueue.ItemData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.ItemData.toObject = function(includeInstance, msg) {
  var f, obj = {
    buildNuke: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    buildOilRig: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    buildMissileSilo: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    buildIronDome: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    attackCityByNuke: (f = msg.getAttackCityByNuke()) && proto.shared.clanevent.RoundQueue.AttackCityByNuke.toObject(includeInstance, f),
    buildCityShield: (f = msg.getBuildCityShield()) && proto.shared.clanevent.RoundQueue.BuildCityShield.toObject(includeInstance, f),
    buyUranium: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData}
 */
proto.shared.clanevent.RoundQueue.ItemData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.RoundQueue.ItemData;
  return proto.shared.clanevent.RoundQueue.ItemData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.RoundQueue.ItemData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData}
 */
proto.shared.clanevent.RoundQueue.ItemData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBuildNuke(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBuildOilRig(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBuildMissileSilo(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBuildIronDome(value);
      break;
    case 5:
      var value = new proto.shared.clanevent.RoundQueue.AttackCityByNuke;
      reader.readMessage(value,proto.shared.clanevent.RoundQueue.AttackCityByNuke.deserializeBinaryFromReader);
      msg.setAttackCityByNuke(value);
      break;
    case 6:
      var value = new proto.shared.clanevent.RoundQueue.BuildCityShield;
      reader.readMessage(value,proto.shared.clanevent.RoundQueue.BuildCityShield.deserializeBinaryFromReader);
      msg.setBuildCityShield(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBuyUranium(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.RoundQueue.ItemData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.RoundQueue.ItemData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.ItemData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAttackCityByNuke();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.shared.clanevent.RoundQueue.AttackCityByNuke.serializeBinaryToWriter
    );
  }
  f = message.getBuildCityShield();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.shared.clanevent.RoundQueue.BuildCityShield.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional bool build_nuke = 1;
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.getBuildNuke = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.setBuildNuke = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.clearBuildNuke = function() {
  return jspb.Message.setOneofField(this, 1, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.hasBuildNuke = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool build_oil_rig = 2;
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.getBuildOilRig = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.setBuildOilRig = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.clearBuildOilRig = function() {
  return jspb.Message.setOneofField(this, 2, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.hasBuildOilRig = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool build_missile_silo = 3;
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.getBuildMissileSilo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.setBuildMissileSilo = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.clearBuildMissileSilo = function() {
  return jspb.Message.setOneofField(this, 3, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.hasBuildMissileSilo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool build_iron_dome = 4;
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.getBuildIronDome = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.setBuildIronDome = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.clearBuildIronDome = function() {
  return jspb.Message.setOneofField(this, 4, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.hasBuildIronDome = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AttackCityByNuke attack_city_by_nuke = 5;
 * @return {?proto.shared.clanevent.RoundQueue.AttackCityByNuke}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.getAttackCityByNuke = function() {
  return /** @type{?proto.shared.clanevent.RoundQueue.AttackCityByNuke} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.RoundQueue.AttackCityByNuke, 5));
};


/**
 * @param {?proto.shared.clanevent.RoundQueue.AttackCityByNuke|undefined} value
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
*/
proto.shared.clanevent.RoundQueue.ItemData.prototype.setAttackCityByNuke = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.clearAttackCityByNuke = function() {
  return this.setAttackCityByNuke(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.hasAttackCityByNuke = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional BuildCityShield build_city_shield = 6;
 * @return {?proto.shared.clanevent.RoundQueue.BuildCityShield}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.getBuildCityShield = function() {
  return /** @type{?proto.shared.clanevent.RoundQueue.BuildCityShield} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.RoundQueue.BuildCityShield, 6));
};


/**
 * @param {?proto.shared.clanevent.RoundQueue.BuildCityShield|undefined} value
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
*/
proto.shared.clanevent.RoundQueue.ItemData.prototype.setBuildCityShield = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.clearBuildCityShield = function() {
  return this.setBuildCityShield(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.hasBuildCityShield = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool buy_uranium = 7;
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.getBuyUranium = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.setBuyUranium = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.shared.clanevent.RoundQueue.ItemData} returns this
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.clearBuyUranium = function() {
  return jspb.Message.setOneofField(this, 7, proto.shared.clanevent.RoundQueue.ItemData.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.RoundQueue.ItemData.prototype.hasBuyUranium = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.RoundQueue.BuildCityShield.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.RoundQueue.BuildCityShield.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.RoundQueue.BuildCityShield} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.BuildCityShield.toObject = function(includeInstance, msg) {
  var f, obj = {
    cityId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.RoundQueue.BuildCityShield}
 */
proto.shared.clanevent.RoundQueue.BuildCityShield.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.RoundQueue.BuildCityShield;
  return proto.shared.clanevent.RoundQueue.BuildCityShield.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.RoundQueue.BuildCityShield} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.RoundQueue.BuildCityShield}
 */
proto.shared.clanevent.RoundQueue.BuildCityShield.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.RoundQueue.BuildCityShield.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.RoundQueue.BuildCityShield.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.RoundQueue.BuildCityShield} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.BuildCityShield.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string city_id = 1;
 * @return {string}
 */
proto.shared.clanevent.RoundQueue.BuildCityShield.prototype.getCityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.RoundQueue.BuildCityShield} returns this
 */
proto.shared.clanevent.RoundQueue.BuildCityShield.prototype.setCityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.RoundQueue.AttackCityByNuke.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.RoundQueue.AttackCityByNuke} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.toObject = function(includeInstance, msg) {
  var f, obj = {
    nukeIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    cityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clanId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.RoundQueue.AttackCityByNuke}
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.RoundQueue.AttackCityByNuke;
  return proto.shared.clanevent.RoundQueue.AttackCityByNuke.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.RoundQueue.AttackCityByNuke} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.RoundQueue.AttackCityByNuke}
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addNukeIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.RoundQueue.AttackCityByNuke.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.RoundQueue.AttackCityByNuke} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNukeIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClanId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated string nuke_ids = 1;
 * @return {!Array<string>}
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.getNukeIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.shared.clanevent.RoundQueue.AttackCityByNuke} returns this
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.setNukeIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.RoundQueue.AttackCityByNuke} returns this
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.addNukeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shared.clanevent.RoundQueue.AttackCityByNuke} returns this
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.clearNukeIdsList = function() {
  return this.setNukeIdsList([]);
};


/**
 * optional string city_id = 2;
 * @return {string}
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.getCityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.RoundQueue.AttackCityByNuke} returns this
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.setCityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string clan_id = 3;
 * @return {string}
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.getClanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.RoundQueue.AttackCityByNuke} returns this
 */
proto.shared.clanevent.RoundQueue.AttackCityByNuke.prototype.setClanId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Assets.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Assets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Assets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Assets.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Assets}
 */
proto.shared.clanevent.Assets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Assets;
  return proto.shared.clanevent.Assets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Assets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Assets}
 */
proto.shared.clanevent.Assets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Assets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Assets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Assets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Assets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Assets.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Assets.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Assets.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Assets.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Assets.Item}
 */
proto.shared.clanevent.Assets.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Assets.Item;
  return proto.shared.clanevent.Assets.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Assets.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Assets.Item}
 */
proto.shared.clanevent.Assets.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Assets.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Assets.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Assets.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Assets.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.shared.clanevent.Assets.Item.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Assets.Item} returns this
 */
proto.shared.clanevent.Assets.Item.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Assets.CityShield.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Assets.CityShield.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Assets.CityShield} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Assets.CityShield.toObject = function(includeInstance, msg) {
  var f, obj = {
    cityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Assets.CityShield}
 */
proto.shared.clanevent.Assets.CityShield.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Assets.CityShield;
  return proto.shared.clanevent.Assets.CityShield.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Assets.CityShield} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Assets.CityShield}
 */
proto.shared.clanevent.Assets.CityShield.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Assets.CityShield.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Assets.CityShield.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Assets.CityShield} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Assets.CityShield.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string city_id = 1;
 * @return {string}
 */
proto.shared.clanevent.Assets.CityShield.prototype.getCityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Assets.CityShield} returns this
 */
proto.shared.clanevent.Assets.CityShield.prototype.setCityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.shared.clanevent.Assets.CityShield.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Assets.CityShield} returns this
 */
proto.shared.clanevent.Assets.CityShield.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Money.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Money.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Money} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Money.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    diffInPercentage: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Money}
 */
proto.shared.clanevent.Money.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Money;
  return proto.shared.clanevent.Money.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Money} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Money}
 */
proto.shared.clanevent.Money.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiffInPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Money.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Money.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Money} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Money.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDiffInPercentage();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.shared.clanevent.Money.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Money} returns this
 */
proto.shared.clanevent.Money.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.shared.clanevent.Money.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Money} returns this
 */
proto.shared.clanevent.Money.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 diff_in_percentage = 3;
 * @return {number}
 */
proto.shared.clanevent.Money.prototype.getDiffInPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.Money} returns this
 */
proto.shared.clanevent.Money.prototype.setDiffInPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Market.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Market.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Market} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Market.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Market}
 */
proto.shared.clanevent.Market.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Market;
  return proto.shared.clanevent.Market.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Market} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Market}
 */
proto.shared.clanevent.Market.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Market.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Market.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Market} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Market.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shared.clanevent.Market.ProductPrices.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.Market.ProductPrices.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.Market.ProductPrices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.Market.ProductPrices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Market.ProductPrices.toObject = function(includeInstance, msg) {
  var f, obj = {
    productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pricesList: jspb.Message.toObjectList(msg.getPricesList(),
    proto.shared.clanevent.Money.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.Market.ProductPrices}
 */
proto.shared.clanevent.Market.ProductPrices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.Market.ProductPrices;
  return proto.shared.clanevent.Market.ProductPrices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.Market.ProductPrices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.Market.ProductPrices}
 */
proto.shared.clanevent.Market.ProductPrices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 2:
      var value = new proto.shared.clanevent.Money;
      reader.readMessage(value,proto.shared.clanevent.Money.deserializeBinaryFromReader);
      msg.addPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.Market.ProductPrices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.Market.ProductPrices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.Market.ProductPrices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.Market.ProductPrices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.shared.clanevent.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.shared.clanevent.Market.ProductPrices.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.Market.ProductPrices} returns this
 */
proto.shared.clanevent.Market.ProductPrices.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Money prices = 2;
 * @return {!Array<!proto.shared.clanevent.Money>}
 */
proto.shared.clanevent.Market.ProductPrices.prototype.getPricesList = function() {
  return /** @type{!Array<!proto.shared.clanevent.Money>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.shared.clanevent.Money, 2));
};


/**
 * @param {!Array<!proto.shared.clanevent.Money>} value
 * @return {!proto.shared.clanevent.Market.ProductPrices} returns this
*/
proto.shared.clanevent.Market.ProductPrices.prototype.setPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.shared.clanevent.Money=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.Money}
 */
proto.shared.clanevent.Market.ProductPrices.prototype.addPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.shared.clanevent.Money, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shared.clanevent.Market.ProductPrices} returns this
 */
proto.shared.clanevent.Market.ProductPrices.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.WorldDominationBoard.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.WorldDominationBoard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.WorldDominationBoard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.WorldDominationBoard.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.WorldDominationBoard}
 */
proto.shared.clanevent.WorldDominationBoard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.WorldDominationBoard;
  return proto.shared.clanevent.WorldDominationBoard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.WorldDominationBoard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.WorldDominationBoard}
 */
proto.shared.clanevent.WorldDominationBoard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.WorldDominationBoard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.WorldDominationBoard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.WorldDominationBoard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.WorldDominationBoard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.toObject = function(includeInstance, msg) {
  var f, obj = {
    slotsList: jspb.Message.toObjectList(msg.getSlotsList(),
    proto.shared.clanevent.WorldDominationBoard.ClanSlot.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension}
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension;
  return proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension}
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.shared.clanevent.WorldDominationBoard.ClanSlot;
      reader.readMessage(value,proto.shared.clanevent.WorldDominationBoard.ClanSlot.deserializeBinaryFromReader);
      msg.addSlots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.shared.clanevent.WorldDominationBoard.ClanSlot.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClanSlot slots = 1;
 * @return {!Array<!proto.shared.clanevent.WorldDominationBoard.ClanSlot>}
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.prototype.getSlotsList = function() {
  return /** @type{!Array<!proto.shared.clanevent.WorldDominationBoard.ClanSlot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.shared.clanevent.WorldDominationBoard.ClanSlot, 1));
};


/**
 * @param {!Array<!proto.shared.clanevent.WorldDominationBoard.ClanSlot>} value
 * @return {!proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension} returns this
*/
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.prototype.setSlotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.shared.clanevent.WorldDominationBoard.ClanSlot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot}
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.prototype.addSlots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.shared.clanevent.WorldDominationBoard.ClanSlot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension} returns this
 */
proto.shared.clanevent.WorldDominationBoard.LeaderboardExtension.prototype.clearSlotsList = function() {
  return this.setSlotsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.WorldDominationBoard.ClanSlot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.WorldDominationBoard.ClanSlot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    kind: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    points: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.WorldDominationBoard.ClanSlot;
  return proto.shared.clanevent.WorldDominationBoard.ClanSlot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.WorldDominationBoard.ClanSlot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.shared.clanevent.WorldDominationBoard.ClanSlot.Kind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPoints(value);
      break;
    case 5:
      var value = /** @type {!proto.shared.clanevent.WorldDominationBoard.ClanSlot.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.WorldDominationBoard.ClanSlot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.WorldDominationBoard.ClanSlot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPoints();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.Kind = {
  KIND_UNKNOWN: 0,
  VAULT: 1,
  CITY: 2
};

/**
 * @enum {number}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.Status = {
  STATUS_UNKNOWN: 0,
  ACTIVE: 1,
  INACTIVE: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot} returns this
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Kind kind = 2;
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot.Kind}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.getKind = function() {
  return /** @type {!proto.shared.clanevent.WorldDominationBoard.ClanSlot.Kind} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.shared.clanevent.WorldDominationBoard.ClanSlot.Kind} value
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot} returns this
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot} returns this
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 points = 4;
 * @return {number}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.getPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot} returns this
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.setPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional Status status = 5;
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot.Status}
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.getStatus = function() {
  return /** @type {!proto.shared.clanevent.WorldDominationBoard.ClanSlot.Status} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.shared.clanevent.WorldDominationBoard.ClanSlot.Status} value
 * @return {!proto.shared.clanevent.WorldDominationBoard.ClanSlot} returns this
 */
proto.shared.clanevent.WorldDominationBoard.ClanSlot.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.shared.clanevent.NotificationWDRequest.oneofGroups_ = [[100,101,102]];

/**
 * @enum {number}
 */
proto.shared.clanevent.NotificationWDRequest.ResultCase = {
  RESULT_NOT_SET: 0,
  ERROR: 100,
  ADD_TO_ROUND_QUEUE: 101,
  REMOVE_FROM_ROUND_QUEUE: 102
};

/**
 * @return {proto.shared.clanevent.NotificationWDRequest.ResultCase}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.getResultCase = function() {
  return /** @type {proto.shared.clanevent.NotificationWDRequest.ResultCase} */(jspb.Message.computeOneofCase(this, proto.shared.clanevent.NotificationWDRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.NotificationWDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.NotificationWDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.NotificationWDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: (f = msg.getError()) && proto.shared.clanevent.NotificationWDRequest.Error.toObject(includeInstance, f),
    addToRoundQueue: (f = msg.getAddToRoundQueue()) && proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.toObject(includeInstance, f),
    removeFromRoundQueue: (f = msg.getRemoveFromRoundQueue()) && proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.NotificationWDRequest}
 */
proto.shared.clanevent.NotificationWDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.NotificationWDRequest;
  return proto.shared.clanevent.NotificationWDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.NotificationWDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.NotificationWDRequest}
 */
proto.shared.clanevent.NotificationWDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 100:
      var value = new proto.shared.clanevent.NotificationWDRequest.Error;
      reader.readMessage(value,proto.shared.clanevent.NotificationWDRequest.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 101:
      var value = new proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue;
      reader.readMessage(value,proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.deserializeBinaryFromReader);
      msg.setAddToRoundQueue(value);
      break;
    case 102:
      var value = new proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue;
      reader.readMessage(value,proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.deserializeBinaryFromReader);
      msg.setRemoveFromRoundQueue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.NotificationWDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.NotificationWDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.NotificationWDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.shared.clanevent.NotificationWDRequest.Error.serializeBinaryToWriter
    );
  }
  f = message.getAddToRoundQueue();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.serializeBinaryToWriter
    );
  }
  f = message.getRemoveFromRoundQueue();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.NotificationWDRequest.Error.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.NotificationWDRequest.Error.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.NotificationWDRequest.Error} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.NotificationWDRequest.Error.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.NotificationWDRequest.Error}
 */
proto.shared.clanevent.NotificationWDRequest.Error.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.NotificationWDRequest.Error;
  return proto.shared.clanevent.NotificationWDRequest.Error.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.NotificationWDRequest.Error} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.NotificationWDRequest.Error}
 */
proto.shared.clanevent.NotificationWDRequest.Error.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.shared.clanevent.NotificationErrorCode} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.NotificationWDRequest.Error.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.NotificationWDRequest.Error.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.NotificationWDRequest.Error} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.NotificationWDRequest.Error.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional NotificationErrorCode code = 1;
 * @return {!proto.shared.clanevent.NotificationErrorCode}
 */
proto.shared.clanevent.NotificationWDRequest.Error.prototype.getCode = function() {
  return /** @type {!proto.shared.clanevent.NotificationErrorCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.shared.clanevent.NotificationErrorCode} value
 * @return {!proto.shared.clanevent.NotificationWDRequest.Error} returns this
 */
proto.shared.clanevent.NotificationWDRequest.Error.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.shared.clanevent.NotificationWDRequest.Error.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.NotificationWDRequest.Error} returns this
 */
proto.shared.clanevent.NotificationWDRequest.Error.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue}
 */
proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue;
  return proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue}
 */
proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.prototype.toObject = function(opt_includeInstance) {
  return proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue}
 */
proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue;
  return proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue}
 */
proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shared.clanevent.NotificationWDRequest} returns this
 */
proto.shared.clanevent.NotificationWDRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Error error = 100;
 * @return {?proto.shared.clanevent.NotificationWDRequest.Error}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.getError = function() {
  return /** @type{?proto.shared.clanevent.NotificationWDRequest.Error} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.NotificationWDRequest.Error, 100));
};


/**
 * @param {?proto.shared.clanevent.NotificationWDRequest.Error|undefined} value
 * @return {!proto.shared.clanevent.NotificationWDRequest} returns this
*/
proto.shared.clanevent.NotificationWDRequest.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 100, proto.shared.clanevent.NotificationWDRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.NotificationWDRequest} returns this
 */
proto.shared.clanevent.NotificationWDRequest.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.hasError = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional AddToRoundQueue add_to_round_queue = 101;
 * @return {?proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.getAddToRoundQueue = function() {
  return /** @type{?proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue, 101));
};


/**
 * @param {?proto.shared.clanevent.NotificationWDRequest.AddToRoundQueue|undefined} value
 * @return {!proto.shared.clanevent.NotificationWDRequest} returns this
*/
proto.shared.clanevent.NotificationWDRequest.prototype.setAddToRoundQueue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 101, proto.shared.clanevent.NotificationWDRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.NotificationWDRequest} returns this
 */
proto.shared.clanevent.NotificationWDRequest.prototype.clearAddToRoundQueue = function() {
  return this.setAddToRoundQueue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.hasAddToRoundQueue = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional RemoveFromRoundQueue remove_from_round_queue = 102;
 * @return {?proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.getRemoveFromRoundQueue = function() {
  return /** @type{?proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue} */ (
    jspb.Message.getWrapperField(this, proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue, 102));
};


/**
 * @param {?proto.shared.clanevent.NotificationWDRequest.RemoveFromRoundQueue|undefined} value
 * @return {!proto.shared.clanevent.NotificationWDRequest} returns this
*/
proto.shared.clanevent.NotificationWDRequest.prototype.setRemoveFromRoundQueue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 102, proto.shared.clanevent.NotificationWDRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shared.clanevent.NotificationWDRequest} returns this
 */
proto.shared.clanevent.NotificationWDRequest.prototype.clearRemoveFromRoundQueue = function() {
  return this.setRemoveFromRoundQueue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shared.clanevent.NotificationWDRequest.prototype.hasRemoveFromRoundQueue = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * @enum {number}
 */
proto.shared.clanevent.DifficultyValue = {
  UNKNOWN_DIFFICULTY: 0,
  EASY: 1,
  MEDIUM: 2,
  HARD: 3
};

/**
 * @enum {number}
 */
proto.shared.clanevent.NotificationType = {
  NOTIFICATION_TYPE_UNKNOWN: 0,
  NOTIFICATION_TYPE_WD_REQUEST_FINISHED: 1
};

/**
 * @enum {number}
 */
proto.shared.clanevent.NotificationErrorCode = {
  NOTIFICATION_ERROR_CODE_UNKNOWN: 0,
  NOTIFICATION_ERROR_CODE_INTERNAL: 1,
  NOTIFICATION_ERROR_CODE_NOT_FOUND: 2,
  NOTIFICATION_ERROR_CODE_INSUFFICIENT_FUNDS: 3,
  NOTIFICATION_ERROR_CODE_INVALID_ARGUMENT: 4,
  NOTIFICATION_ERROR_CODE_CANNOT_ALLOCATE_DATA: 5,
  NOTIFICATION_ERROR_CODE_LIMIT_EXCEEDED: 6
};

goog.object.extend(exports, proto.shared.clanevent);

},{"../validate/validate_pb.js":19,"google-protobuf":3}],19:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],20:[function(require,module,exports){
// source: clans.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.clans.Clan', null, global);
goog.exportSymbol('proto.clans.ClanMember', null, global);
goog.exportSymbol('proto.clans.ClanMember.Role', null, global);
goog.exportSymbol('proto.clans.ClanRow', null, global);
goog.exportSymbol('proto.clans.Discord', null, global);
goog.exportSymbol('proto.clans.Empty', null, global);
goog.exportSymbol('proto.clans.Experience', null, global);
goog.exportSymbol('proto.clans.JoinType', null, global);
goog.exportSymbol('proto.clans.Links', null, global);
goog.exportSymbol('proto.clans.Log', null, global);
goog.exportSymbol('proto.clans.LogActionType', null, global);
goog.exportSymbol('proto.clans.PendingMember', null, global);
goog.exportSymbol('proto.clans.UUID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.UUID.displayName = 'proto.clans.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.Clan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.Clan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.Clan.displayName = 'proto.clans.Clan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.ClanMember = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.ClanMember, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.ClanMember.displayName = 'proto.clans.ClanMember';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.PendingMember = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.PendingMember, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.PendingMember.displayName = 'proto.clans.PendingMember';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.Experience = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.Experience, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.Experience.displayName = 'proto.clans.Experience';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.ClanRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.ClanRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.ClanRow.displayName = 'proto.clans.ClanRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.Empty.displayName = 'proto.clans.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.Links = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.Links, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.Links.displayName = 'proto.clans.Links';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.Log = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.Log, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.Log.displayName = 'proto.clans.Log';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.Discord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.Discord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.Discord.displayName = 'proto.clans.Discord';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.UUID}
 */
proto.clans.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.UUID;
  return proto.clans.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.UUID}
 */
proto.clans.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.clans.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.UUID} returns this
 */
proto.clans.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.Clan.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.Clan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.Clan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Clan.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.clans.UUID.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    slug: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    size: jspb.Message.getFieldWithDefault(msg, 5, 0),
    capacity: jspb.Message.getFieldWithDefault(msg, 6, 0),
    legacyId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    joinType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    links: (f = msg.getLinks()) && proto.clans.Links.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.Clan}
 */
proto.clans.Clan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.Clan;
  return proto.clans.Clan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.Clan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.Clan}
 */
proto.clans.Clan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clans.UUID;
      reader.readMessage(value,proto.clans.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSize(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCapacity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLegacyId(value);
      break;
    case 8:
      var value = /** @type {!proto.clans.JoinType} */ (reader.readEnum());
      msg.setJoinType(value);
      break;
    case 9:
      var value = new proto.clans.Links;
      reader.readMessage(value,proto.clans.Links.deserializeBinaryFromReader);
      msg.setLinks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.Clan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.Clan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.Clan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Clan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clans.UUID.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getCapacity();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getLegacyId();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getJoinType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getLinks();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.clans.Links.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.Clan.prototype.getId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, proto.clans.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.Clan} returns this
*/
proto.clans.Clan.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.Clan.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.clans.Clan.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slug = 3;
 * @return {string}
 */
proto.clans.Clan.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.clans.Clan.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 size = 5;
 * @return {number}
 */
proto.clans.Clan.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 capacity = 6;
 * @return {number}
 */
proto.clans.Clan.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 legacy_id = 7;
 * @return {number}
 */
proto.clans.Clan.prototype.getLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.setLegacyId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional JoinType join_type = 8;
 * @return {!proto.clans.JoinType}
 */
proto.clans.Clan.prototype.getJoinType = function() {
  return /** @type {!proto.clans.JoinType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.clans.JoinType} value
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.setJoinType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional Links links = 9;
 * @return {?proto.clans.Links}
 */
proto.clans.Clan.prototype.getLinks = function() {
  return /** @type{?proto.clans.Links} */ (
    jspb.Message.getWrapperField(this, proto.clans.Links, 9));
};


/**
 * @param {?proto.clans.Links|undefined} value
 * @return {!proto.clans.Clan} returns this
*/
proto.clans.Clan.prototype.setLinks = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.Clan} returns this
 */
proto.clans.Clan.prototype.clearLinks = function() {
  return this.setLinks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.Clan.prototype.hasLinks = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.ClanMember.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.ClanMember.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.ClanMember} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.ClanMember.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: (f = msg.getPlayerId()) && proto.clans.UUID.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    level: jspb.Message.getFieldWithDefault(msg, 3, 0),
    role: jspb.Message.getFieldWithDefault(msg, 4, 0),
    xp: (f = msg.getXp()) && proto.clans.Experience.toObject(includeInstance, f),
    joinedAt: jspb.Message.getFieldWithDefault(msg, 6, ""),
    kickable: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    lastMatchAt: jspb.Message.getFieldWithDefault(msg, 8, ""),
    discord: (f = msg.getDiscord()) && proto.clans.Discord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.ClanMember}
 */
proto.clans.ClanMember.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.ClanMember;
  return proto.clans.ClanMember.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.ClanMember} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.ClanMember}
 */
proto.clans.ClanMember.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clans.UUID;
      reader.readMessage(value,proto.clans.UUID.deserializeBinaryFromReader);
      msg.setPlayerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {!proto.clans.ClanMember.Role} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 5:
      var value = new proto.clans.Experience;
      reader.readMessage(value,proto.clans.Experience.deserializeBinaryFromReader);
      msg.setXp(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setJoinedAt(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setKickable(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastMatchAt(value);
      break;
    case 9:
      var value = new proto.clans.Discord;
      reader.readMessage(value,proto.clans.Discord.deserializeBinaryFromReader);
      msg.setDiscord(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.ClanMember.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.ClanMember.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.ClanMember} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.ClanMember.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clans.UUID.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getXp();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.clans.Experience.serializeBinaryToWriter
    );
  }
  f = message.getJoinedAt();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getKickable();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getLastMatchAt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDiscord();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.clans.Discord.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.clans.ClanMember.Role = {
  NONE: 0,
  MEMBER: 1,
  LEADER: 2,
  OFFICER: 3
};

/**
 * optional UUID player_id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.ClanMember.prototype.getPlayerId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, proto.clans.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.ClanMember} returns this
*/
proto.clans.ClanMember.prototype.setPlayerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.clearPlayerId = function() {
  return this.setPlayerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.ClanMember.prototype.hasPlayerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.clans.ClanMember.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 level = 3;
 * @return {number}
 */
proto.clans.ClanMember.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Role role = 4;
 * @return {!proto.clans.ClanMember.Role}
 */
proto.clans.ClanMember.prototype.getRole = function() {
  return /** @type {!proto.clans.ClanMember.Role} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.clans.ClanMember.Role} value
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Experience xp = 5;
 * @return {?proto.clans.Experience}
 */
proto.clans.ClanMember.prototype.getXp = function() {
  return /** @type{?proto.clans.Experience} */ (
    jspb.Message.getWrapperField(this, proto.clans.Experience, 5));
};


/**
 * @param {?proto.clans.Experience|undefined} value
 * @return {!proto.clans.ClanMember} returns this
*/
proto.clans.ClanMember.prototype.setXp = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.clearXp = function() {
  return this.setXp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.ClanMember.prototype.hasXp = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string joined_at = 6;
 * @return {string}
 */
proto.clans.ClanMember.prototype.getJoinedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.setJoinedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool kickable = 7;
 * @return {boolean}
 */
proto.clans.ClanMember.prototype.getKickable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.setKickable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string last_match_at = 8;
 * @return {string}
 */
proto.clans.ClanMember.prototype.getLastMatchAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.setLastMatchAt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional Discord discord = 9;
 * @return {?proto.clans.Discord}
 */
proto.clans.ClanMember.prototype.getDiscord = function() {
  return /** @type{?proto.clans.Discord} */ (
    jspb.Message.getWrapperField(this, proto.clans.Discord, 9));
};


/**
 * @param {?proto.clans.Discord|undefined} value
 * @return {!proto.clans.ClanMember} returns this
*/
proto.clans.ClanMember.prototype.setDiscord = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.ClanMember} returns this
 */
proto.clans.ClanMember.prototype.clearDiscord = function() {
  return this.setDiscord(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.ClanMember.prototype.hasDiscord = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.PendingMember.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.PendingMember.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.PendingMember} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.PendingMember.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: (f = msg.getPlayerId()) && proto.clans.UUID.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    level: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestedAt: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.PendingMember}
 */
proto.clans.PendingMember.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.PendingMember;
  return proto.clans.PendingMember.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.PendingMember} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.PendingMember}
 */
proto.clans.PendingMember.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clans.UUID;
      reader.readMessage(value,proto.clans.UUID.deserializeBinaryFromReader);
      msg.setPlayerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.PendingMember.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.PendingMember.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.PendingMember} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.PendingMember.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clans.UUID.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRequestedAt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional UUID player_id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.PendingMember.prototype.getPlayerId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, proto.clans.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.PendingMember} returns this
*/
proto.clans.PendingMember.prototype.setPlayerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.PendingMember} returns this
 */
proto.clans.PendingMember.prototype.clearPlayerId = function() {
  return this.setPlayerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.PendingMember.prototype.hasPlayerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.clans.PendingMember.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.PendingMember} returns this
 */
proto.clans.PendingMember.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 level = 3;
 * @return {number}
 */
proto.clans.PendingMember.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.PendingMember} returns this
 */
proto.clans.PendingMember.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string requested_at = 4;
 * @return {string}
 */
proto.clans.PendingMember.prototype.getRequestedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.PendingMember} returns this
 */
proto.clans.PendingMember.prototype.setRequestedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.Experience.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.Experience.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.Experience} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Experience.toObject = function(includeInstance, msg) {
  var f, obj = {
    seasonal: jspb.Message.getFieldWithDefault(msg, 1, 0),
    daily: jspb.Message.getFieldWithDefault(msg, 2, 0),
    weekly: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.Experience}
 */
proto.clans.Experience.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.Experience;
  return proto.clans.Experience.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.Experience} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.Experience}
 */
proto.clans.Experience.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSeasonal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDaily(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setWeekly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.Experience.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.Experience.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.Experience} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Experience.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeasonal();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getDaily();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getWeekly();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional uint64 seasonal = 1;
 * @return {number}
 */
proto.clans.Experience.prototype.getSeasonal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.Experience} returns this
 */
proto.clans.Experience.prototype.setSeasonal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 daily = 2;
 * @return {number}
 */
proto.clans.Experience.prototype.getDaily = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.Experience} returns this
 */
proto.clans.Experience.prototype.setDaily = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 weekly = 3;
 * @return {number}
 */
proto.clans.Experience.prototype.getWeekly = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.Experience} returns this
 */
proto.clans.Experience.prototype.setWeekly = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.ClanRow.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.ClanRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.ClanRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.ClanRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.clans.UUID.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    slug: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    size: jspb.Message.getFieldWithDefault(msg, 5, 0),
    capacity: jspb.Message.getFieldWithDefault(msg, 6, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 7, 0),
    xp: (f = msg.getXp()) && proto.clans.Experience.toObject(includeInstance, f),
    leader: jspb.Message.getFieldWithDefault(msg, 9, ""),
    joinType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    links: (f = msg.getLinks()) && proto.clans.Links.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.ClanRow}
 */
proto.clans.ClanRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.ClanRow;
  return proto.clans.ClanRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.ClanRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.ClanRow}
 */
proto.clans.ClanRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clans.UUID;
      reader.readMessage(value,proto.clans.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSize(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCapacity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRank(value);
      break;
    case 8:
      var value = new proto.clans.Experience;
      reader.readMessage(value,proto.clans.Experience.deserializeBinaryFromReader);
      msg.setXp(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeader(value);
      break;
    case 10:
      var value = /** @type {!proto.clans.JoinType} */ (reader.readEnum());
      msg.setJoinType(value);
      break;
    case 11:
      var value = new proto.clans.Links;
      reader.readMessage(value,proto.clans.Links.deserializeBinaryFromReader);
      msg.setLinks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.ClanRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.ClanRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.ClanRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.ClanRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clans.UUID.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getCapacity();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getXp();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.clans.Experience.serializeBinaryToWriter
    );
  }
  f = message.getLeader();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getJoinType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getLinks();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.clans.Links.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.ClanRow.prototype.getId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, proto.clans.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.ClanRow} returns this
*/
proto.clans.ClanRow.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.ClanRow.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.clans.ClanRow.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slug = 3;
 * @return {string}
 */
proto.clans.ClanRow.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.clans.ClanRow.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 size = 5;
 * @return {number}
 */
proto.clans.ClanRow.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 capacity = 6;
 * @return {number}
 */
proto.clans.ClanRow.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.setCapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 rank = 7;
 * @return {number}
 */
proto.clans.ClanRow.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional Experience xp = 8;
 * @return {?proto.clans.Experience}
 */
proto.clans.ClanRow.prototype.getXp = function() {
  return /** @type{?proto.clans.Experience} */ (
    jspb.Message.getWrapperField(this, proto.clans.Experience, 8));
};


/**
 * @param {?proto.clans.Experience|undefined} value
 * @return {!proto.clans.ClanRow} returns this
*/
proto.clans.ClanRow.prototype.setXp = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.clearXp = function() {
  return this.setXp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.ClanRow.prototype.hasXp = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string leader = 9;
 * @return {string}
 */
proto.clans.ClanRow.prototype.getLeader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.setLeader = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional JoinType join_type = 10;
 * @return {!proto.clans.JoinType}
 */
proto.clans.ClanRow.prototype.getJoinType = function() {
  return /** @type {!proto.clans.JoinType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.clans.JoinType} value
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.setJoinType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional Links links = 11;
 * @return {?proto.clans.Links}
 */
proto.clans.ClanRow.prototype.getLinks = function() {
  return /** @type{?proto.clans.Links} */ (
    jspb.Message.getWrapperField(this, proto.clans.Links, 11));
};


/**
 * @param {?proto.clans.Links|undefined} value
 * @return {!proto.clans.ClanRow} returns this
*/
proto.clans.ClanRow.prototype.setLinks = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.ClanRow} returns this
 */
proto.clans.ClanRow.prototype.clearLinks = function() {
  return this.setLinks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.ClanRow.prototype.hasLinks = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.Empty}
 */
proto.clans.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.Empty;
  return proto.clans.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.Empty}
 */
proto.clans.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.Links.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.Links.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.Links} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Links.toObject = function(includeInstance, msg) {
  var f, obj = {
    discord: jspb.Message.getFieldWithDefault(msg, 1, ""),
    twitter: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.Links}
 */
proto.clans.Links.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.Links;
  return proto.clans.Links.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.Links} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.Links}
 */
proto.clans.Links.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscord(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTwitter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.Links.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.Links.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.Links} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Links.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscord();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTwitter();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string discord = 1;
 * @return {string}
 */
proto.clans.Links.prototype.getDiscord = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Links} returns this
 */
proto.clans.Links.prototype.setDiscord = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string twitter = 2;
 * @return {string}
 */
proto.clans.Links.prototype.getTwitter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Links} returns this
 */
proto.clans.Links.prototype.setTwitter = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.Log.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.Log.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.Log} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Log.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    clanId: (f = msg.getClanId()) && proto.clans.UUID.toObject(includeInstance, f),
    actionType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    isSystem: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    authorId: (f = msg.getAuthorId()) && proto.clans.UUID.toObject(includeInstance, f),
    before: jspb.Message.getFieldWithDefault(msg, 6, ""),
    after: jspb.Message.getFieldWithDefault(msg, 7, ""),
    userId: (f = msg.getUserId()) && proto.clans.UUID.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.Log}
 */
proto.clans.Log.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.Log;
  return proto.clans.Log.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.Log} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.Log}
 */
proto.clans.Log.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.clans.UUID;
      reader.readMessage(value,proto.clans.UUID.deserializeBinaryFromReader);
      msg.setClanId(value);
      break;
    case 3:
      var value = /** @type {!proto.clans.LogActionType} */ (reader.readEnum());
      msg.setActionType(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSystem(value);
      break;
    case 5:
      var value = new proto.clans.UUID;
      reader.readMessage(value,proto.clans.UUID.deserializeBinaryFromReader);
      msg.setAuthorId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBefore(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfter(value);
      break;
    case 8:
      var value = new proto.clans.UUID;
      reader.readMessage(value,proto.clans.UUID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.Log.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.Log.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.Log} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Log.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getClanId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.clans.UUID.serializeBinaryToWriter
    );
  }
  f = message.getActionType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getIsSystem();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAuthorId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.clans.UUID.serializeBinaryToWriter
    );
  }
  f = message.getBefore();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAfter();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.clans.UUID.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.clans.Log.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional UUID clan_id = 2;
 * @return {?proto.clans.UUID}
 */
proto.clans.Log.prototype.getClanId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, proto.clans.UUID, 2));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.Log} returns this
*/
proto.clans.Log.prototype.setClanId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.clearClanId = function() {
  return this.setClanId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.Log.prototype.hasClanId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LogActionType action_type = 3;
 * @return {!proto.clans.LogActionType}
 */
proto.clans.Log.prototype.getActionType = function() {
  return /** @type {!proto.clans.LogActionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.clans.LogActionType} value
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.setActionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool is_system = 4;
 * @return {boolean}
 */
proto.clans.Log.prototype.getIsSystem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.setIsSystem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional UUID author_id = 5;
 * @return {?proto.clans.UUID}
 */
proto.clans.Log.prototype.getAuthorId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, proto.clans.UUID, 5));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.Log} returns this
*/
proto.clans.Log.prototype.setAuthorId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.clearAuthorId = function() {
  return this.setAuthorId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.Log.prototype.hasAuthorId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string before = 6;
 * @return {string}
 */
proto.clans.Log.prototype.getBefore = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.setBefore = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string after = 7;
 * @return {string}
 */
proto.clans.Log.prototype.getAfter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.setAfter = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional UUID user_id = 8;
 * @return {?proto.clans.UUID}
 */
proto.clans.Log.prototype.getUserId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, proto.clans.UUID, 8));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.Log} returns this
*/
proto.clans.Log.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.Log.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.clans.Log.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.clans.Log} returns this
*/
proto.clans.Log.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.Log} returns this
 */
proto.clans.Log.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.Log.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.Discord.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.Discord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.Discord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Discord.toObject = function(includeInstance, msg) {
  var f, obj = {
    discordId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userhash: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.Discord}
 */
proto.clans.Discord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.Discord;
  return proto.clans.Discord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.Discord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.Discord}
 */
proto.clans.Discord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscordId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserhash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.Discord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.Discord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.Discord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.Discord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscordId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserhash();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string discord_id = 1;
 * @return {string}
 */
proto.clans.Discord.prototype.getDiscordId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Discord} returns this
 */
proto.clans.Discord.prototype.setDiscordId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.clans.Discord.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Discord} returns this
 */
proto.clans.Discord.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string userhash = 3;
 * @return {string}
 */
proto.clans.Discord.prototype.getUserhash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.Discord} returns this
 */
proto.clans.Discord.prototype.setUserhash = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.clans.JoinType = {
  NONE: 0,
  INVITE_ONLY: 1,
  OPEN: 2
};

/**
 * @enum {number}
 */
proto.clans.LogActionType = {
  LOG_NONE: 0,
  CLAN_NAME_EDITED: 1,
  CLAN_SLUG_EDITED: 2,
  CLAN_DESCRIPTION_EDITED: 3,
  CLAN_LINKS_EDITED: 4,
  CLAN_JOIN_TYPE_CHANGED: 5,
  CLAN_JOIN_APPROVED: 6,
  CLAN_JOIN_DECLINED: 7,
  CLAN_MEMBER_KICKED: 8,
  CLAN_MEMBER_CHANGED_ROLE: 9,
  CLAN_LEADER_CHANGED: 10,
  CLAN_DELETED: 11
};

goog.object.extend(exports, proto.clans);

},{"./validate/validate_pb.js":21,"google-protobuf":3,"google-protobuf/google/protobuf/timestamp_pb.js":6}],21:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],22:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for clans.web
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var clans_shared_pb = require('../clans.shared_pb.js')
const proto = {};
proto.clans = {};
proto.clans.web = require('./clans_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.clans.web.ClansClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.clans.web.ClansPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.Approve.Request,
 *   !proto.clans.Empty>}
 */
const methodDescriptor_Clans_Approve = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Approve',
  grpc.web.MethodType.UNARY,
  proto.clans.web.Approve.Request,
  clans_shared_pb.Empty,
  /**
   * @param {!proto.clans.web.Approve.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  clans_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.clans.web.Approve.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.approve =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Approve',
      request,
      metadata || {},
      methodDescriptor_Clans_Approve,
      callback);
};


/**
 * @param {!proto.clans.web.Approve.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.Empty>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.approve =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Approve',
      request,
      metadata || {},
      methodDescriptor_Clans_Approve);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.ChangeRole.Request,
 *   !proto.clans.Empty>}
 */
const methodDescriptor_Clans_ChangeRole = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/ChangeRole',
  grpc.web.MethodType.UNARY,
  proto.clans.web.ChangeRole.Request,
  clans_shared_pb.Empty,
  /**
   * @param {!proto.clans.web.ChangeRole.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  clans_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.clans.web.ChangeRole.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.changeRole =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/ChangeRole',
      request,
      metadata || {},
      methodDescriptor_Clans_ChangeRole,
      callback);
};


/**
 * @param {!proto.clans.web.ChangeRole.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.Empty>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.changeRole =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/ChangeRole',
      request,
      metadata || {},
      methodDescriptor_Clans_ChangeRole);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.Create.Request,
 *   !proto.clans.Empty>}
 */
const methodDescriptor_Clans_Create = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Create',
  grpc.web.MethodType.UNARY,
  proto.clans.web.Create.Request,
  clans_shared_pb.Empty,
  /**
   * @param {!proto.clans.web.Create.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  clans_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.clans.web.Create.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Create',
      request,
      metadata || {},
      methodDescriptor_Clans_Create,
      callback);
};


/**
 * @param {!proto.clans.web.Create.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.Empty>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Create',
      request,
      metadata || {},
      methodDescriptor_Clans_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.Decline.Request,
 *   !proto.clans.Empty>}
 */
const methodDescriptor_Clans_Decline = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Decline',
  grpc.web.MethodType.UNARY,
  proto.clans.web.Decline.Request,
  clans_shared_pb.Empty,
  /**
   * @param {!proto.clans.web.Decline.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  clans_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.clans.web.Decline.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.decline =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Decline',
      request,
      metadata || {},
      methodDescriptor_Clans_Decline,
      callback);
};


/**
 * @param {!proto.clans.web.Decline.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.Empty>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.decline =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Decline',
      request,
      metadata || {},
      methodDescriptor_Clans_Decline);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.Empty,
 *   !proto.clans.web.GetMates.Response>}
 */
const methodDescriptor_Clans_GetMates = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/GetMates',
  grpc.web.MethodType.UNARY,
  clans_shared_pb.Empty,
  proto.clans.web.GetMates.Response,
  /**
   * @param {!proto.clans.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clans.web.GetMates.Response.deserializeBinary
);


/**
 * @param {!proto.clans.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.web.GetMates.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.web.GetMates.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.getMates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/GetMates',
      request,
      metadata || {},
      methodDescriptor_Clans_GetMates,
      callback);
};


/**
 * @param {!proto.clans.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.web.GetMates.Response>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.getMates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/GetMates',
      request,
      metadata || {},
      methodDescriptor_Clans_GetMates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.GetMembership.Request,
 *   !proto.clans.web.GetMembership.Response>}
 */
const methodDescriptor_Clans_GetMembership = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/GetMembership',
  grpc.web.MethodType.UNARY,
  proto.clans.web.GetMembership.Request,
  proto.clans.web.GetMembership.Response,
  /**
   * @param {!proto.clans.web.GetMembership.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clans.web.GetMembership.Response.deserializeBinary
);


/**
 * @param {!proto.clans.web.GetMembership.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.web.GetMembership.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.web.GetMembership.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.getMembership =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/GetMembership',
      request,
      metadata || {},
      methodDescriptor_Clans_GetMembership,
      callback);
};


/**
 * @param {!proto.clans.web.GetMembership.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.web.GetMembership.Response>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.getMembership =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/GetMembership',
      request,
      metadata || {},
      methodDescriptor_Clans_GetMembership);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.Empty,
 *   !proto.clans.web.Info.Response>}
 */
const methodDescriptor_Clans_Info = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Info',
  grpc.web.MethodType.UNARY,
  clans_shared_pb.Empty,
  proto.clans.web.Info.Response,
  /**
   * @param {!proto.clans.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clans.web.Info.Response.deserializeBinary
);


/**
 * @param {!proto.clans.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.web.Info.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.web.Info.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.info =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Info',
      request,
      metadata || {},
      methodDescriptor_Clans_Info,
      callback);
};


/**
 * @param {!proto.clans.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.web.Info.Response>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.info =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Info',
      request,
      metadata || {},
      methodDescriptor_Clans_Info);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.Join.Request,
 *   !proto.clans.Empty>}
 */
const methodDescriptor_Clans_Join = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Join',
  grpc.web.MethodType.UNARY,
  proto.clans.web.Join.Request,
  clans_shared_pb.Empty,
  /**
   * @param {!proto.clans.web.Join.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  clans_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.clans.web.Join.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.join =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Join',
      request,
      metadata || {},
      methodDescriptor_Clans_Join,
      callback);
};


/**
 * @param {!proto.clans.web.Join.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.Empty>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.join =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Join',
      request,
      metadata || {},
      methodDescriptor_Clans_Join);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.Kick.Request,
 *   !proto.clans.Empty>}
 */
const methodDescriptor_Clans_Kick = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Kick',
  grpc.web.MethodType.UNARY,
  proto.clans.web.Kick.Request,
  clans_shared_pb.Empty,
  /**
   * @param {!proto.clans.web.Kick.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  clans_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.clans.web.Kick.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.kick =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Kick',
      request,
      metadata || {},
      methodDescriptor_Clans_Kick,
      callback);
};


/**
 * @param {!proto.clans.web.Kick.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.Empty>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.kick =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Kick',
      request,
      metadata || {},
      methodDescriptor_Clans_Kick);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.Empty,
 *   !proto.clans.Empty>}
 */
const methodDescriptor_Clans_Leave = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Leave',
  grpc.web.MethodType.UNARY,
  clans_shared_pb.Empty,
  clans_shared_pb.Empty,
  /**
   * @param {!proto.clans.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  clans_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.clans.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.leave =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Leave',
      request,
      metadata || {},
      methodDescriptor_Clans_Leave,
      callback);
};


/**
 * @param {!proto.clans.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.Empty>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.leave =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Leave',
      request,
      metadata || {},
      methodDescriptor_Clans_Leave);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.Empty,
 *   !proto.clans.web.PendingList.Response>}
 */
const methodDescriptor_Clans_PendingList = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/PendingList',
  grpc.web.MethodType.UNARY,
  clans_shared_pb.Empty,
  proto.clans.web.PendingList.Response,
  /**
   * @param {!proto.clans.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clans.web.PendingList.Response.deserializeBinary
);


/**
 * @param {!proto.clans.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.web.PendingList.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.web.PendingList.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.pendingList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/PendingList',
      request,
      metadata || {},
      methodDescriptor_Clans_PendingList,
      callback);
};


/**
 * @param {!proto.clans.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.web.PendingList.Response>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.pendingList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/PendingList',
      request,
      metadata || {},
      methodDescriptor_Clans_PendingList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.Search.Request,
 *   !proto.clans.web.Search.Response>}
 */
const methodDescriptor_Clans_Search = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Search',
  grpc.web.MethodType.UNARY,
  proto.clans.web.Search.Request,
  proto.clans.web.Search.Response,
  /**
   * @param {!proto.clans.web.Search.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.clans.web.Search.Response.deserializeBinary
);


/**
 * @param {!proto.clans.web.Search.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.web.Search.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.web.Search.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.search =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Search',
      request,
      metadata || {},
      methodDescriptor_Clans_Search,
      callback);
};


/**
 * @param {!proto.clans.web.Search.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.web.Search.Response>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.search =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Search',
      request,
      metadata || {},
      methodDescriptor_Clans_Search);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.clans.web.Update.Request,
 *   !proto.clans.Empty>}
 */
const methodDescriptor_Clans_Update = new grpc.web.MethodDescriptor(
  '/clans.web.Clans/Update',
  grpc.web.MethodType.UNARY,
  proto.clans.web.Update.Request,
  clans_shared_pb.Empty,
  /**
   * @param {!proto.clans.web.Update.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  clans_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.clans.web.Update.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.clans.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.clans.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.clans.web.ClansClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/clans.web.Clans/Update',
      request,
      metadata || {},
      methodDescriptor_Clans_Update,
      callback);
};


/**
 * @param {!proto.clans.web.Update.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.clans.Empty>}
 *     Promise that resolves to the response
 */
proto.clans.web.ClansPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/clans.web.Clans/Update',
      request,
      metadata || {},
      methodDescriptor_Clans_Update);
};


module.exports = proto.clans.web;


},{"../clans.shared_pb.js":20,"../validate/validate_pb.js":21,"./clans_pb.js":23,"grpc-web":7}],23:[function(require,module,exports){
// source: web/clans.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var clans_shared_pb = require('../clans.shared_pb.js');
goog.object.extend(proto, clans_shared_pb);
goog.exportSymbol('proto.clans.web.Approve', null, global);
goog.exportSymbol('proto.clans.web.Approve.Request', null, global);
goog.exportSymbol('proto.clans.web.ChangeRole', null, global);
goog.exportSymbol('proto.clans.web.ChangeRole.Request', null, global);
goog.exportSymbol('proto.clans.web.Create', null, global);
goog.exportSymbol('proto.clans.web.Create.Request', null, global);
goog.exportSymbol('proto.clans.web.Decline', null, global);
goog.exportSymbol('proto.clans.web.Decline.Request', null, global);
goog.exportSymbol('proto.clans.web.GetMates', null, global);
goog.exportSymbol('proto.clans.web.GetMates.Response', null, global);
goog.exportSymbol('proto.clans.web.GetMembership', null, global);
goog.exportSymbol('proto.clans.web.GetMembership.JoinCode', null, global);
goog.exportSymbol('proto.clans.web.GetMembership.Request', null, global);
goog.exportSymbol('proto.clans.web.GetMembership.Request.ClanIdCase', null, global);
goog.exportSymbol('proto.clans.web.GetMembership.Response', null, global);
goog.exportSymbol('proto.clans.web.Info', null, global);
goog.exportSymbol('proto.clans.web.Info.Response', null, global);
goog.exportSymbol('proto.clans.web.Join', null, global);
goog.exportSymbol('proto.clans.web.Join.Request', null, global);
goog.exportSymbol('proto.clans.web.Kick', null, global);
goog.exportSymbol('proto.clans.web.Kick.Request', null, global);
goog.exportSymbol('proto.clans.web.PendingList', null, global);
goog.exportSymbol('proto.clans.web.PendingList.Response', null, global);
goog.exportSymbol('proto.clans.web.Search', null, global);
goog.exportSymbol('proto.clans.web.Search.Request', null, global);
goog.exportSymbol('proto.clans.web.Search.Response', null, global);
goog.exportSymbol('proto.clans.web.Update', null, global);
goog.exportSymbol('proto.clans.web.Update.Request', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Approve = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Approve, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Approve.displayName = 'proto.clans.web.Approve';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Approve.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Approve.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Approve.Request.displayName = 'proto.clans.web.Approve.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.ChangeRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.ChangeRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.ChangeRole.displayName = 'proto.clans.web.ChangeRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.ChangeRole.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.ChangeRole.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.ChangeRole.Request.displayName = 'proto.clans.web.ChangeRole.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Create = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Create, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Create.displayName = 'proto.clans.web.Create';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Create.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Create.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Create.Request.displayName = 'proto.clans.web.Create.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Decline = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Decline, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Decline.displayName = 'proto.clans.web.Decline';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Decline.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Decline.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Decline.Request.displayName = 'proto.clans.web.Decline.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.GetMates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.GetMates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.GetMates.displayName = 'proto.clans.web.GetMates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.GetMates.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.clans.web.GetMates.Response.repeatedFields_, null);
};
goog.inherits(proto.clans.web.GetMates.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.GetMates.Response.displayName = 'proto.clans.web.GetMates.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.GetMembership = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.GetMembership, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.GetMembership.displayName = 'proto.clans.web.GetMembership';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.GetMembership.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.clans.web.GetMembership.Request.oneofGroups_);
};
goog.inherits(proto.clans.web.GetMembership.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.GetMembership.Request.displayName = 'proto.clans.web.GetMembership.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.GetMembership.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.GetMembership.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.GetMembership.Response.displayName = 'proto.clans.web.GetMembership.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Info = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Info, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Info.displayName = 'proto.clans.web.Info';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Info.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Info.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Info.Response.displayName = 'proto.clans.web.Info.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Join = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Join, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Join.displayName = 'proto.clans.web.Join';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Join.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Join.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Join.Request.displayName = 'proto.clans.web.Join.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Kick = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Kick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Kick.displayName = 'proto.clans.web.Kick';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Kick.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Kick.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Kick.Request.displayName = 'proto.clans.web.Kick.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.PendingList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.PendingList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.PendingList.displayName = 'proto.clans.web.PendingList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.PendingList.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.clans.web.PendingList.Response.repeatedFields_, null);
};
goog.inherits(proto.clans.web.PendingList.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.PendingList.Response.displayName = 'proto.clans.web.PendingList.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Search = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Search, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Search.displayName = 'proto.clans.web.Search';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Search.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Search.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Search.Request.displayName = 'proto.clans.web.Search.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Search.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.clans.web.Search.Response.repeatedFields_, null);
};
goog.inherits(proto.clans.web.Search.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Search.Response.displayName = 'proto.clans.web.Search.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Update = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Update, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Update.displayName = 'proto.clans.web.Update';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clans.web.Update.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clans.web.Update.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clans.web.Update.Request.displayName = 'proto.clans.web.Update.Request';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Approve.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Approve.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Approve} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Approve.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Approve}
 */
proto.clans.web.Approve.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Approve;
  return proto.clans.web.Approve.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Approve} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Approve}
 */
proto.clans.web.Approve.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Approve.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Approve.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Approve} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Approve.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Approve.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Approve.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Approve.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Approve.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: (f = msg.getPlayerId()) && clans_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Approve.Request}
 */
proto.clans.web.Approve.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Approve.Request;
  return proto.clans.web.Approve.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Approve.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Approve.Request}
 */
proto.clans.web.Approve.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.UUID;
      reader.readMessage(value,clans_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setPlayerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Approve.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Approve.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Approve.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Approve.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional clans.UUID player_id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.web.Approve.Request.prototype.getPlayerId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.web.Approve.Request} returns this
*/
proto.clans.web.Approve.Request.prototype.setPlayerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.Approve.Request} returns this
 */
proto.clans.web.Approve.Request.prototype.clearPlayerId = function() {
  return this.setPlayerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.Approve.Request.prototype.hasPlayerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.ChangeRole.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.ChangeRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.ChangeRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.ChangeRole.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.ChangeRole}
 */
proto.clans.web.ChangeRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.ChangeRole;
  return proto.clans.web.ChangeRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.ChangeRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.ChangeRole}
 */
proto.clans.web.ChangeRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.ChangeRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.ChangeRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.ChangeRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.ChangeRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.ChangeRole.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.ChangeRole.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.ChangeRole.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.ChangeRole.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: (f = msg.getPlayerId()) && clans_shared_pb.UUID.toObject(includeInstance, f),
    role: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.ChangeRole.Request}
 */
proto.clans.web.ChangeRole.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.ChangeRole.Request;
  return proto.clans.web.ChangeRole.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.ChangeRole.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.ChangeRole.Request}
 */
proto.clans.web.ChangeRole.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.UUID;
      reader.readMessage(value,clans_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setPlayerId(value);
      break;
    case 2:
      var value = /** @type {!proto.clans.ClanMember.Role} */ (reader.readEnum());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.ChangeRole.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.ChangeRole.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.ChangeRole.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.ChangeRole.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.UUID.serializeBinaryToWriter
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional clans.UUID player_id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.web.ChangeRole.Request.prototype.getPlayerId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.web.ChangeRole.Request} returns this
*/
proto.clans.web.ChangeRole.Request.prototype.setPlayerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.ChangeRole.Request} returns this
 */
proto.clans.web.ChangeRole.Request.prototype.clearPlayerId = function() {
  return this.setPlayerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.ChangeRole.Request.prototype.hasPlayerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional clans.ClanMember.Role role = 2;
 * @return {!proto.clans.ClanMember.Role}
 */
proto.clans.web.ChangeRole.Request.prototype.getRole = function() {
  return /** @type {!proto.clans.ClanMember.Role} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.clans.ClanMember.Role} value
 * @return {!proto.clans.web.ChangeRole.Request} returns this
 */
proto.clans.web.ChangeRole.Request.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Create.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Create.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Create} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Create.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Create}
 */
proto.clans.web.Create.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Create;
  return proto.clans.web.Create.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Create} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Create}
 */
proto.clans.web.Create.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Create.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Create.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Create} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Create.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Create.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Create.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Create.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Create.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    clan: (f = msg.getClan()) && clans_shared_pb.Clan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Create.Request}
 */
proto.clans.web.Create.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Create.Request;
  return proto.clans.web.Create.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Create.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Create.Request}
 */
proto.clans.web.Create.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.Clan;
      reader.readMessage(value,clans_shared_pb.Clan.deserializeBinaryFromReader);
      msg.setClan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Create.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Create.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Create.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Create.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.Clan.serializeBinaryToWriter
    );
  }
};


/**
 * optional clans.Clan clan = 1;
 * @return {?proto.clans.Clan}
 */
proto.clans.web.Create.Request.prototype.getClan = function() {
  return /** @type{?proto.clans.Clan} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.Clan, 1));
};


/**
 * @param {?proto.clans.Clan|undefined} value
 * @return {!proto.clans.web.Create.Request} returns this
*/
proto.clans.web.Create.Request.prototype.setClan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.Create.Request} returns this
 */
proto.clans.web.Create.Request.prototype.clearClan = function() {
  return this.setClan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.Create.Request.prototype.hasClan = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Decline.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Decline.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Decline} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Decline.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Decline}
 */
proto.clans.web.Decline.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Decline;
  return proto.clans.web.Decline.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Decline} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Decline}
 */
proto.clans.web.Decline.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Decline.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Decline.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Decline} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Decline.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Decline.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Decline.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Decline.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Decline.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: (f = msg.getPlayerId()) && clans_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Decline.Request}
 */
proto.clans.web.Decline.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Decline.Request;
  return proto.clans.web.Decline.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Decline.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Decline.Request}
 */
proto.clans.web.Decline.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.UUID;
      reader.readMessage(value,clans_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setPlayerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Decline.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Decline.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Decline.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Decline.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional clans.UUID player_id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.web.Decline.Request.prototype.getPlayerId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.web.Decline.Request} returns this
*/
proto.clans.web.Decline.Request.prototype.setPlayerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.Decline.Request} returns this
 */
proto.clans.web.Decline.Request.prototype.clearPlayerId = function() {
  return this.setPlayerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.Decline.Request.prototype.hasPlayerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.GetMates.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.GetMates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.GetMates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMates.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.GetMates}
 */
proto.clans.web.GetMates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.GetMates;
  return proto.clans.web.GetMates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.GetMates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.GetMates}
 */
proto.clans.web.GetMates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.GetMates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.GetMates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.GetMates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.clans.web.GetMates.Response.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.GetMates.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.GetMates.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.GetMates.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMates.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    clan: (f = msg.getClan()) && clans_shared_pb.ClanRow.toObject(includeInstance, f),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    clans_shared_pb.ClanMember.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.GetMates.Response}
 */
proto.clans.web.GetMates.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.GetMates.Response;
  return proto.clans.web.GetMates.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.GetMates.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.GetMates.Response}
 */
proto.clans.web.GetMates.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.ClanRow;
      reader.readMessage(value,clans_shared_pb.ClanRow.deserializeBinaryFromReader);
      msg.setClan(value);
      break;
    case 2:
      var value = new clans_shared_pb.ClanMember;
      reader.readMessage(value,clans_shared_pb.ClanMember.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.GetMates.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.GetMates.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.GetMates.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMates.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.ClanRow.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      clans_shared_pb.ClanMember.serializeBinaryToWriter
    );
  }
};


/**
 * optional clans.ClanRow clan = 1;
 * @return {?proto.clans.ClanRow}
 */
proto.clans.web.GetMates.Response.prototype.getClan = function() {
  return /** @type{?proto.clans.ClanRow} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.ClanRow, 1));
};


/**
 * @param {?proto.clans.ClanRow|undefined} value
 * @return {!proto.clans.web.GetMates.Response} returns this
*/
proto.clans.web.GetMates.Response.prototype.setClan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.GetMates.Response} returns this
 */
proto.clans.web.GetMates.Response.prototype.clearClan = function() {
  return this.setClan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.GetMates.Response.prototype.hasClan = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated clans.ClanMember members = 2;
 * @return {!Array<!proto.clans.ClanMember>}
 */
proto.clans.web.GetMates.Response.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.clans.ClanMember>} */ (
    jspb.Message.getRepeatedWrapperField(this, clans_shared_pb.ClanMember, 2));
};


/**
 * @param {!Array<!proto.clans.ClanMember>} value
 * @return {!proto.clans.web.GetMates.Response} returns this
*/
proto.clans.web.GetMates.Response.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.clans.ClanMember=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clans.ClanMember}
 */
proto.clans.web.GetMates.Response.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.clans.ClanMember, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.clans.web.GetMates.Response} returns this
 */
proto.clans.web.GetMates.Response.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.GetMembership.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.GetMembership.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.GetMembership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMembership.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.GetMembership}
 */
proto.clans.web.GetMembership.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.GetMembership;
  return proto.clans.web.GetMembership.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.GetMembership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.GetMembership}
 */
proto.clans.web.GetMembership.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.GetMembership.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.GetMembership.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.GetMembership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMembership.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.clans.web.GetMembership.JoinCode = {
  OK: 0,
  DECLINE_GUEST: 1,
  CLAN_FULL: 2,
  HAS_PENDING: 3,
  ALREADY_MEMBER: 4,
  PLAYER_LOW_LEVEL: 5
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.clans.web.GetMembership.Request.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.clans.web.GetMembership.Request.ClanIdCase = {
  CLAN_ID_NOT_SET: 0,
  ID: 1,
  LEGACY_ID: 2
};

/**
 * @return {proto.clans.web.GetMembership.Request.ClanIdCase}
 */
proto.clans.web.GetMembership.Request.prototype.getClanIdCase = function() {
  return /** @type {proto.clans.web.GetMembership.Request.ClanIdCase} */(jspb.Message.computeOneofCase(this, proto.clans.web.GetMembership.Request.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.GetMembership.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.GetMembership.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.GetMembership.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMembership.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && clans_shared_pb.UUID.toObject(includeInstance, f),
    legacyId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.GetMembership.Request}
 */
proto.clans.web.GetMembership.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.GetMembership.Request;
  return proto.clans.web.GetMembership.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.GetMembership.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.GetMembership.Request}
 */
proto.clans.web.GetMembership.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.UUID;
      reader.readMessage(value,clans_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLegacyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.GetMembership.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.GetMembership.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.GetMembership.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMembership.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.UUID.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional clans.UUID id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.web.GetMembership.Request.prototype.getId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.web.GetMembership.Request} returns this
*/
proto.clans.web.GetMembership.Request.prototype.setId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.clans.web.GetMembership.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.GetMembership.Request} returns this
 */
proto.clans.web.GetMembership.Request.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.GetMembership.Request.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 legacy_id = 2;
 * @return {number}
 */
proto.clans.web.GetMembership.Request.prototype.getLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.clans.web.GetMembership.Request} returns this
 */
proto.clans.web.GetMembership.Request.prototype.setLegacyId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.clans.web.GetMembership.Request.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.clans.web.GetMembership.Request} returns this
 */
proto.clans.web.GetMembership.Request.prototype.clearLegacyId = function() {
  return jspb.Message.setOneofField(this, 2, proto.clans.web.GetMembership.Request.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.GetMembership.Request.prototype.hasLegacyId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.GetMembership.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.GetMembership.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.GetMembership.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMembership.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    clan: (f = msg.getClan()) && clans_shared_pb.ClanRow.toObject(includeInstance, f),
    joinCode: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.GetMembership.Response}
 */
proto.clans.web.GetMembership.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.GetMembership.Response;
  return proto.clans.web.GetMembership.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.GetMembership.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.GetMembership.Response}
 */
proto.clans.web.GetMembership.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.ClanRow;
      reader.readMessage(value,clans_shared_pb.ClanRow.deserializeBinaryFromReader);
      msg.setClan(value);
      break;
    case 2:
      var value = /** @type {!proto.clans.web.GetMembership.JoinCode} */ (reader.readEnum());
      msg.setJoinCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.GetMembership.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.GetMembership.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.GetMembership.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.GetMembership.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.ClanRow.serializeBinaryToWriter
    );
  }
  f = message.getJoinCode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional clans.ClanRow clan = 1;
 * @return {?proto.clans.ClanRow}
 */
proto.clans.web.GetMembership.Response.prototype.getClan = function() {
  return /** @type{?proto.clans.ClanRow} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.ClanRow, 1));
};


/**
 * @param {?proto.clans.ClanRow|undefined} value
 * @return {!proto.clans.web.GetMembership.Response} returns this
*/
proto.clans.web.GetMembership.Response.prototype.setClan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.GetMembership.Response} returns this
 */
proto.clans.web.GetMembership.Response.prototype.clearClan = function() {
  return this.setClan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.GetMembership.Response.prototype.hasClan = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional JoinCode join_code = 2;
 * @return {!proto.clans.web.GetMembership.JoinCode}
 */
proto.clans.web.GetMembership.Response.prototype.getJoinCode = function() {
  return /** @type {!proto.clans.web.GetMembership.JoinCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.clans.web.GetMembership.JoinCode} value
 * @return {!proto.clans.web.GetMembership.Response} returns this
 */
proto.clans.web.GetMembership.Response.prototype.setJoinCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Info.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Info.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Info} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Info.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Info}
 */
proto.clans.web.Info.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Info;
  return proto.clans.web.Info.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Info} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Info}
 */
proto.clans.web.Info.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Info.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Info.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Info} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Info.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Info.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Info.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Info.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Info.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    clan: (f = msg.getClan()) && clans_shared_pb.Clan.toObject(includeInstance, f),
    role: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Info.Response}
 */
proto.clans.web.Info.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Info.Response;
  return proto.clans.web.Info.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Info.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Info.Response}
 */
proto.clans.web.Info.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.Clan;
      reader.readMessage(value,clans_shared_pb.Clan.deserializeBinaryFromReader);
      msg.setClan(value);
      break;
    case 2:
      var value = /** @type {!proto.clans.ClanMember.Role} */ (reader.readEnum());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Info.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Info.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Info.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Info.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.Clan.serializeBinaryToWriter
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional clans.Clan clan = 1;
 * @return {?proto.clans.Clan}
 */
proto.clans.web.Info.Response.prototype.getClan = function() {
  return /** @type{?proto.clans.Clan} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.Clan, 1));
};


/**
 * @param {?proto.clans.Clan|undefined} value
 * @return {!proto.clans.web.Info.Response} returns this
*/
proto.clans.web.Info.Response.prototype.setClan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.Info.Response} returns this
 */
proto.clans.web.Info.Response.prototype.clearClan = function() {
  return this.setClan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.Info.Response.prototype.hasClan = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional clans.ClanMember.Role role = 2;
 * @return {!proto.clans.ClanMember.Role}
 */
proto.clans.web.Info.Response.prototype.getRole = function() {
  return /** @type {!proto.clans.ClanMember.Role} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.clans.ClanMember.Role} value
 * @return {!proto.clans.web.Info.Response} returns this
 */
proto.clans.web.Info.Response.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Join.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Join.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Join} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Join.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Join}
 */
proto.clans.web.Join.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Join;
  return proto.clans.web.Join.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Join} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Join}
 */
proto.clans.web.Join.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Join.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Join.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Join} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Join.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Join.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Join.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Join.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Join.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    clanId: (f = msg.getClanId()) && clans_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Join.Request}
 */
proto.clans.web.Join.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Join.Request;
  return proto.clans.web.Join.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Join.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Join.Request}
 */
proto.clans.web.Join.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.UUID;
      reader.readMessage(value,clans_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setClanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Join.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Join.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Join.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Join.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClanId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional clans.UUID clan_id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.web.Join.Request.prototype.getClanId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.web.Join.Request} returns this
*/
proto.clans.web.Join.Request.prototype.setClanId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.Join.Request} returns this
 */
proto.clans.web.Join.Request.prototype.clearClanId = function() {
  return this.setClanId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.Join.Request.prototype.hasClanId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Kick.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Kick.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Kick} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Kick.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Kick}
 */
proto.clans.web.Kick.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Kick;
  return proto.clans.web.Kick.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Kick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Kick}
 */
proto.clans.web.Kick.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Kick.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Kick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Kick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Kick.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Kick.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Kick.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Kick.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Kick.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: (f = msg.getPlayerId()) && clans_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Kick.Request}
 */
proto.clans.web.Kick.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Kick.Request;
  return proto.clans.web.Kick.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Kick.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Kick.Request}
 */
proto.clans.web.Kick.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.UUID;
      reader.readMessage(value,clans_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setPlayerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Kick.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Kick.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Kick.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Kick.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional clans.UUID player_id = 1;
 * @return {?proto.clans.UUID}
 */
proto.clans.web.Kick.Request.prototype.getPlayerId = function() {
  return /** @type{?proto.clans.UUID} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.UUID, 1));
};


/**
 * @param {?proto.clans.UUID|undefined} value
 * @return {!proto.clans.web.Kick.Request} returns this
*/
proto.clans.web.Kick.Request.prototype.setPlayerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.Kick.Request} returns this
 */
proto.clans.web.Kick.Request.prototype.clearPlayerId = function() {
  return this.setPlayerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.Kick.Request.prototype.hasPlayerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.PendingList.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.PendingList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.PendingList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.PendingList.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.PendingList}
 */
proto.clans.web.PendingList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.PendingList;
  return proto.clans.web.PendingList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.PendingList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.PendingList}
 */
proto.clans.web.PendingList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.PendingList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.PendingList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.PendingList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.PendingList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.clans.web.PendingList.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.PendingList.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.PendingList.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.PendingList.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.PendingList.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    clans_shared_pb.PendingMember.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.PendingList.Response}
 */
proto.clans.web.PendingList.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.PendingList.Response;
  return proto.clans.web.PendingList.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.PendingList.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.PendingList.Response}
 */
proto.clans.web.PendingList.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.PendingMember;
      reader.readMessage(value,clans_shared_pb.PendingMember.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.PendingList.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.PendingList.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.PendingList.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.PendingList.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      clans_shared_pb.PendingMember.serializeBinaryToWriter
    );
  }
};


/**
 * repeated clans.PendingMember members = 1;
 * @return {!Array<!proto.clans.PendingMember>}
 */
proto.clans.web.PendingList.Response.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.clans.PendingMember>} */ (
    jspb.Message.getRepeatedWrapperField(this, clans_shared_pb.PendingMember, 1));
};


/**
 * @param {!Array<!proto.clans.PendingMember>} value
 * @return {!proto.clans.web.PendingList.Response} returns this
*/
proto.clans.web.PendingList.Response.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.clans.PendingMember=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clans.PendingMember}
 */
proto.clans.web.PendingList.Response.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.clans.PendingMember, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.clans.web.PendingList.Response} returns this
 */
proto.clans.web.PendingList.Response.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Search.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Search.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Search} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Search.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Search}
 */
proto.clans.web.Search.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Search;
  return proto.clans.web.Search.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Search} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Search}
 */
proto.clans.web.Search.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Search.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Search.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Search} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Search.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Search.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Search.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Search.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Search.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    keyword: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Search.Request}
 */
proto.clans.web.Search.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Search.Request;
  return proto.clans.web.Search.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Search.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Search.Request}
 */
proto.clans.web.Search.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Search.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Search.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Search.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Search.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string keyword = 1;
 * @return {string}
 */
proto.clans.web.Search.Request.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clans.web.Search.Request} returns this
 */
proto.clans.web.Search.Request.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.clans.web.Search.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Search.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Search.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Search.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Search.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    clansList: jspb.Message.toObjectList(msg.getClansList(),
    clans_shared_pb.ClanRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Search.Response}
 */
proto.clans.web.Search.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Search.Response;
  return proto.clans.web.Search.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Search.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Search.Response}
 */
proto.clans.web.Search.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.ClanRow;
      reader.readMessage(value,clans_shared_pb.ClanRow.deserializeBinaryFromReader);
      msg.addClans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Search.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Search.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Search.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Search.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      clans_shared_pb.ClanRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated clans.ClanRow clans = 1;
 * @return {!Array<!proto.clans.ClanRow>}
 */
proto.clans.web.Search.Response.prototype.getClansList = function() {
  return /** @type{!Array<!proto.clans.ClanRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, clans_shared_pb.ClanRow, 1));
};


/**
 * @param {!Array<!proto.clans.ClanRow>} value
 * @return {!proto.clans.web.Search.Response} returns this
*/
proto.clans.web.Search.Response.prototype.setClansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.clans.ClanRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clans.ClanRow}
 */
proto.clans.web.Search.Response.prototype.addClans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.clans.ClanRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.clans.web.Search.Response} returns this
 */
proto.clans.web.Search.Response.prototype.clearClansList = function() {
  return this.setClansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Update.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Update.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Update} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Update.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Update}
 */
proto.clans.web.Update.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Update;
  return proto.clans.web.Update.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Update} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Update}
 */
proto.clans.web.Update.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Update.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Update.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Update} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Update.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clans.web.Update.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.clans.web.Update.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clans.web.Update.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Update.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    clan: (f = msg.getClan()) && clans_shared_pb.Clan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clans.web.Update.Request}
 */
proto.clans.web.Update.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clans.web.Update.Request;
  return proto.clans.web.Update.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clans.web.Update.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clans.web.Update.Request}
 */
proto.clans.web.Update.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clans_shared_pb.Clan;
      reader.readMessage(value,clans_shared_pb.Clan.deserializeBinaryFromReader);
      msg.setClan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clans.web.Update.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clans.web.Update.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clans.web.Update.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clans.web.Update.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clans_shared_pb.Clan.serializeBinaryToWriter
    );
  }
};


/**
 * optional clans.Clan clan = 1;
 * @return {?proto.clans.Clan}
 */
proto.clans.web.Update.Request.prototype.getClan = function() {
  return /** @type{?proto.clans.Clan} */ (
    jspb.Message.getWrapperField(this, clans_shared_pb.Clan, 1));
};


/**
 * @param {?proto.clans.Clan|undefined} value
 * @return {!proto.clans.web.Update.Request} returns this
*/
proto.clans.web.Update.Request.prototype.setClan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clans.web.Update.Request} returns this
 */
proto.clans.web.Update.Request.prototype.clearClan = function() {
  return this.setClan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clans.web.Update.Request.prototype.hasClan = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.clans.web);

},{"../clans.shared_pb.js":20,"../validate/validate_pb.js":21,"google-protobuf":3}],24:[function(require,module,exports){
// source: clantreasury.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
goog.exportSymbol('proto.clantreasury.Balance', null, global);
goog.exportSymbol('proto.clantreasury.Balance.Butter', null, global);
goog.exportSymbol('proto.clantreasury.Balance.EnrichedOrbs', null, global);
goog.exportSymbol('proto.clantreasury.Balance.GamedataItem', null, global);
goog.exportSymbol('proto.clantreasury.Balance.MintableToken', null, global);
goog.exportSymbol('proto.clantreasury.GamedataItem', null, global);
goog.exportSymbol('proto.clantreasury.History', null, global);
goog.exportSymbol('proto.clantreasury.History.Author', null, global);
goog.exportSymbol('proto.clantreasury.History.Operation', null, global);
goog.exportSymbol('proto.clantreasury.History.Recipient', null, global);
goog.exportSymbol('proto.clantreasury.Item', null, global);
goog.exportSymbol('proto.clantreasury.Item.Info', null, global);
goog.exportSymbol('proto.clantreasury.Item.Info.ValueCase', null, global);
goog.exportSymbol('proto.clantreasury.MintableToken', null, global);
goog.exportSymbol('proto.clantreasury.Operations', null, global);
goog.exportSymbol('proto.clantreasury.Operations.Failure', null, global);
goog.exportSymbol('proto.clantreasury.Operations.Failure.Code', null, global);
goog.exportSymbol('proto.clantreasury.Operations.MetaInfo', null, global);
goog.exportSymbol('proto.clantreasury.Operations.Restrictions', null, global);
goog.exportSymbol('proto.clantreasury.Operations.Restrictions.Donates', null, global);
goog.exportSymbol('proto.clantreasury.Operations.Restrictions.Transfers', null, global);
goog.exportSymbol('proto.clantreasury.Operations.Type', null, global);
goog.exportSymbol('proto.clantreasury.Operations.UserInfo', null, global);
goog.exportSymbol('proto.clantreasury.Operations.UserInfo.Account', null, global);
goog.exportSymbol('proto.clantreasury.Operations.UserInfo.ClanMembership', null, global);
goog.exportSymbol('proto.clantreasury.Operations.UserInfo.Ident', null, global);
goog.exportSymbol('proto.clantreasury.PageParams', null, global);
goog.exportSymbol('proto.clantreasury.Reason', null, global);
goog.exportSymbol('proto.clantreasury.TimeRange', null, global);
goog.exportSymbol('proto.clantreasury.TransferItem', null, global);
goog.exportSymbol('proto.clantreasury.TransferItem.Info', null, global);
goog.exportSymbol('proto.clantreasury.TransferItem.Info.ValueCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Item.displayName = 'proto.clantreasury.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Item.Info = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.clantreasury.Item.Info.oneofGroups_);
};
goog.inherits(proto.clantreasury.Item.Info, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Item.Info.displayName = 'proto.clantreasury.Item.Info';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.TransferItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.TransferItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.TransferItem.displayName = 'proto.clantreasury.TransferItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.TransferItem.Info = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.clantreasury.TransferItem.Info.oneofGroups_);
};
goog.inherits(proto.clantreasury.TransferItem.Info, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.TransferItem.Info.displayName = 'proto.clantreasury.TransferItem.Info';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Balance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Balance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Balance.displayName = 'proto.clantreasury.Balance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Balance.Butter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Balance.Butter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Balance.Butter.displayName = 'proto.clantreasury.Balance.Butter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Balance.EnrichedOrbs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Balance.EnrichedOrbs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Balance.EnrichedOrbs.displayName = 'proto.clantreasury.Balance.EnrichedOrbs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Balance.MintableToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Balance.MintableToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Balance.MintableToken.displayName = 'proto.clantreasury.Balance.MintableToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Balance.GamedataItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Balance.GamedataItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Balance.GamedataItem.displayName = 'proto.clantreasury.Balance.GamedataItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.History = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.History, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.History.displayName = 'proto.clantreasury.History';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.History.Operation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.History.Operation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.History.Operation.displayName = 'proto.clantreasury.History.Operation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.History.Author = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.History.Author, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.History.Author.displayName = 'proto.clantreasury.History.Author';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.History.Recipient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.History.Recipient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.History.Recipient.displayName = 'proto.clantreasury.History.Recipient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.GamedataItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.GamedataItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.GamedataItem.displayName = 'proto.clantreasury.GamedataItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.MintableToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.MintableToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.MintableToken.displayName = 'proto.clantreasury.MintableToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Reason = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Reason, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Reason.displayName = 'proto.clantreasury.Reason';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.displayName = 'proto.clantreasury.Operations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.Failure = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.Failure, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.Failure.displayName = 'proto.clantreasury.Operations.Failure';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.Restrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.Restrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.Restrictions.displayName = 'proto.clantreasury.Operations.Restrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.Restrictions.Donates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.Restrictions.Donates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.Restrictions.Donates.displayName = 'proto.clantreasury.Operations.Restrictions.Donates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.Restrictions.Transfers = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.Restrictions.Transfers, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.Restrictions.Transfers.displayName = 'proto.clantreasury.Operations.Restrictions.Transfers';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.UserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.UserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.UserInfo.displayName = 'proto.clantreasury.Operations.UserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.UserInfo.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.UserInfo.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.UserInfo.Account.displayName = 'proto.clantreasury.Operations.UserInfo.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.UserInfo.Ident = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.UserInfo.Ident, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.UserInfo.Ident.displayName = 'proto.clantreasury.Operations.UserInfo.Ident';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.UserInfo.ClanMembership = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.UserInfo.ClanMembership, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.UserInfo.ClanMembership.displayName = 'proto.clantreasury.Operations.UserInfo.ClanMembership';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.Operations.MetaInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.Operations.MetaInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.Operations.MetaInfo.displayName = 'proto.clantreasury.Operations.MetaInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.TimeRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.TimeRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.TimeRange.displayName = 'proto.clantreasury.TimeRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.clantreasury.PageParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.clantreasury.PageParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.clantreasury.PageParams.displayName = 'proto.clantreasury.PageParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: (f = msg.getInfo()) && proto.clantreasury.Item.Info.toObject(includeInstance, f),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Item}
 */
proto.clantreasury.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Item;
  return proto.clantreasury.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Item}
 */
proto.clantreasury.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clantreasury.Item.Info;
      reader.readMessage(value,proto.clantreasury.Item.Info.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clantreasury.Item.Info.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.clantreasury.Item.Info.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.clantreasury.Item.Info.ValueCase = {
  VALUE_NOT_SET: 0,
  BUTTER: 1,
  ENRICHED_ORB: 2,
  GAMEDATA_ITEM: 3,
  MINTABLE_TOKEN: 4,
  CHEDDAR: 5
};

/**
 * @return {proto.clantreasury.Item.Info.ValueCase}
 */
proto.clantreasury.Item.Info.prototype.getValueCase = function() {
  return /** @type {proto.clantreasury.Item.Info.ValueCase} */(jspb.Message.computeOneofCase(this, proto.clantreasury.Item.Info.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Item.Info.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Item.Info.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Item.Info} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Item.Info.toObject = function(includeInstance, msg) {
  var f, obj = {
    butter: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    enrichedOrb: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    gamedataItem: (f = msg.getGamedataItem()) && proto.clantreasury.GamedataItem.toObject(includeInstance, f),
    mintableToken: (f = msg.getMintableToken()) && proto.clantreasury.MintableToken.toObject(includeInstance, f),
    cheddar: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Item.Info}
 */
proto.clantreasury.Item.Info.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Item.Info;
  return proto.clantreasury.Item.Info.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Item.Info} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Item.Info}
 */
proto.clantreasury.Item.Info.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setButter(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnrichedOrb(value);
      break;
    case 3:
      var value = new proto.clantreasury.GamedataItem;
      reader.readMessage(value,proto.clantreasury.GamedataItem.deserializeBinaryFromReader);
      msg.setGamedataItem(value);
      break;
    case 4:
      var value = new proto.clantreasury.MintableToken;
      reader.readMessage(value,proto.clantreasury.MintableToken.deserializeBinaryFromReader);
      msg.setMintableToken(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCheddar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Item.Info.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Item.Info.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Item.Info} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Item.Info.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getGamedataItem();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.clantreasury.GamedataItem.serializeBinaryToWriter
    );
  }
  f = message.getMintableToken();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.clantreasury.MintableToken.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional bool butter = 1;
 * @return {boolean}
 */
proto.clantreasury.Item.Info.prototype.getButter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.clantreasury.Item.Info} returns this
 */
proto.clantreasury.Item.Info.prototype.setButter = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.clantreasury.Item.Info.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.clantreasury.Item.Info} returns this
 */
proto.clantreasury.Item.Info.prototype.clearButter = function() {
  return jspb.Message.setOneofField(this, 1, proto.clantreasury.Item.Info.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Item.Info.prototype.hasButter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool enriched_orb = 2;
 * @return {boolean}
 */
proto.clantreasury.Item.Info.prototype.getEnrichedOrb = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.clantreasury.Item.Info} returns this
 */
proto.clantreasury.Item.Info.prototype.setEnrichedOrb = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.clantreasury.Item.Info.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.clantreasury.Item.Info} returns this
 */
proto.clantreasury.Item.Info.prototype.clearEnrichedOrb = function() {
  return jspb.Message.setOneofField(this, 2, proto.clantreasury.Item.Info.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Item.Info.prototype.hasEnrichedOrb = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional GamedataItem gamedata_item = 3;
 * @return {?proto.clantreasury.GamedataItem}
 */
proto.clantreasury.Item.Info.prototype.getGamedataItem = function() {
  return /** @type{?proto.clantreasury.GamedataItem} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.GamedataItem, 3));
};


/**
 * @param {?proto.clantreasury.GamedataItem|undefined} value
 * @return {!proto.clantreasury.Item.Info} returns this
*/
proto.clantreasury.Item.Info.prototype.setGamedataItem = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.clantreasury.Item.Info.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Item.Info} returns this
 */
proto.clantreasury.Item.Info.prototype.clearGamedataItem = function() {
  return this.setGamedataItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Item.Info.prototype.hasGamedataItem = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MintableToken mintable_token = 4;
 * @return {?proto.clantreasury.MintableToken}
 */
proto.clantreasury.Item.Info.prototype.getMintableToken = function() {
  return /** @type{?proto.clantreasury.MintableToken} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.MintableToken, 4));
};


/**
 * @param {?proto.clantreasury.MintableToken|undefined} value
 * @return {!proto.clantreasury.Item.Info} returns this
*/
proto.clantreasury.Item.Info.prototype.setMintableToken = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.clantreasury.Item.Info.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Item.Info} returns this
 */
proto.clantreasury.Item.Info.prototype.clearMintableToken = function() {
  return this.setMintableToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Item.Info.prototype.hasMintableToken = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool cheddar = 5;
 * @return {boolean}
 */
proto.clantreasury.Item.Info.prototype.getCheddar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.clantreasury.Item.Info} returns this
 */
proto.clantreasury.Item.Info.prototype.setCheddar = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.clantreasury.Item.Info.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.clantreasury.Item.Info} returns this
 */
proto.clantreasury.Item.Info.prototype.clearCheddar = function() {
  return jspb.Message.setOneofField(this, 5, proto.clantreasury.Item.Info.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Item.Info.prototype.hasCheddar = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Info info = 1;
 * @return {?proto.clantreasury.Item.Info}
 */
proto.clantreasury.Item.prototype.getInfo = function() {
  return /** @type{?proto.clantreasury.Item.Info} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Item.Info, 1));
};


/**
 * @param {?proto.clantreasury.Item.Info|undefined} value
 * @return {!proto.clantreasury.Item} returns this
*/
proto.clantreasury.Item.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Item} returns this
 */
proto.clantreasury.Item.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Item.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.clantreasury.Item.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.Item} returns this
 */
proto.clantreasury.Item.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.TransferItem.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.TransferItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.TransferItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.TransferItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: (f = msg.getInfo()) && proto.clantreasury.TransferItem.Info.toObject(includeInstance, f),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.TransferItem}
 */
proto.clantreasury.TransferItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.TransferItem;
  return proto.clantreasury.TransferItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.TransferItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.TransferItem}
 */
proto.clantreasury.TransferItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clantreasury.TransferItem.Info;
      reader.readMessage(value,proto.clantreasury.TransferItem.Info.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.TransferItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.TransferItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.TransferItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.TransferItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clantreasury.TransferItem.Info.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.clantreasury.TransferItem.Info.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.clantreasury.TransferItem.Info.ValueCase = {
  VALUE_NOT_SET: 0,
  BUTTER: 1,
  GAMEDATA_ITEM: 2,
  MINTABLE_TOKEN: 3
};

/**
 * @return {proto.clantreasury.TransferItem.Info.ValueCase}
 */
proto.clantreasury.TransferItem.Info.prototype.getValueCase = function() {
  return /** @type {proto.clantreasury.TransferItem.Info.ValueCase} */(jspb.Message.computeOneofCase(this, proto.clantreasury.TransferItem.Info.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.TransferItem.Info.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.TransferItem.Info.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.TransferItem.Info} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.TransferItem.Info.toObject = function(includeInstance, msg) {
  var f, obj = {
    butter: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    gamedataItem: (f = msg.getGamedataItem()) && proto.clantreasury.GamedataItem.toObject(includeInstance, f),
    mintableToken: (f = msg.getMintableToken()) && proto.clantreasury.MintableToken.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.TransferItem.Info}
 */
proto.clantreasury.TransferItem.Info.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.TransferItem.Info;
  return proto.clantreasury.TransferItem.Info.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.TransferItem.Info} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.TransferItem.Info}
 */
proto.clantreasury.TransferItem.Info.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setButter(value);
      break;
    case 2:
      var value = new proto.clantreasury.GamedataItem;
      reader.readMessage(value,proto.clantreasury.GamedataItem.deserializeBinaryFromReader);
      msg.setGamedataItem(value);
      break;
    case 3:
      var value = new proto.clantreasury.MintableToken;
      reader.readMessage(value,proto.clantreasury.MintableToken.deserializeBinaryFromReader);
      msg.setMintableToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.TransferItem.Info.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.TransferItem.Info.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.TransferItem.Info} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.TransferItem.Info.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getGamedataItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.clantreasury.GamedataItem.serializeBinaryToWriter
    );
  }
  f = message.getMintableToken();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.clantreasury.MintableToken.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool butter = 1;
 * @return {boolean}
 */
proto.clantreasury.TransferItem.Info.prototype.getButter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.clantreasury.TransferItem.Info} returns this
 */
proto.clantreasury.TransferItem.Info.prototype.setButter = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.clantreasury.TransferItem.Info.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.clantreasury.TransferItem.Info} returns this
 */
proto.clantreasury.TransferItem.Info.prototype.clearButter = function() {
  return jspb.Message.setOneofField(this, 1, proto.clantreasury.TransferItem.Info.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.TransferItem.Info.prototype.hasButter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional GamedataItem gamedata_item = 2;
 * @return {?proto.clantreasury.GamedataItem}
 */
proto.clantreasury.TransferItem.Info.prototype.getGamedataItem = function() {
  return /** @type{?proto.clantreasury.GamedataItem} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.GamedataItem, 2));
};


/**
 * @param {?proto.clantreasury.GamedataItem|undefined} value
 * @return {!proto.clantreasury.TransferItem.Info} returns this
*/
proto.clantreasury.TransferItem.Info.prototype.setGamedataItem = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.clantreasury.TransferItem.Info.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.TransferItem.Info} returns this
 */
proto.clantreasury.TransferItem.Info.prototype.clearGamedataItem = function() {
  return this.setGamedataItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.TransferItem.Info.prototype.hasGamedataItem = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MintableToken mintable_token = 3;
 * @return {?proto.clantreasury.MintableToken}
 */
proto.clantreasury.TransferItem.Info.prototype.getMintableToken = function() {
  return /** @type{?proto.clantreasury.MintableToken} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.MintableToken, 3));
};


/**
 * @param {?proto.clantreasury.MintableToken|undefined} value
 * @return {!proto.clantreasury.TransferItem.Info} returns this
*/
proto.clantreasury.TransferItem.Info.prototype.setMintableToken = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.clantreasury.TransferItem.Info.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.TransferItem.Info} returns this
 */
proto.clantreasury.TransferItem.Info.prototype.clearMintableToken = function() {
  return this.setMintableToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.TransferItem.Info.prototype.hasMintableToken = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Info info = 1;
 * @return {?proto.clantreasury.TransferItem.Info}
 */
proto.clantreasury.TransferItem.prototype.getInfo = function() {
  return /** @type{?proto.clantreasury.TransferItem.Info} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.TransferItem.Info, 1));
};


/**
 * @param {?proto.clantreasury.TransferItem.Info|undefined} value
 * @return {!proto.clantreasury.TransferItem} returns this
*/
proto.clantreasury.TransferItem.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.TransferItem} returns this
 */
proto.clantreasury.TransferItem.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.TransferItem.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.clantreasury.TransferItem.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.TransferItem} returns this
 */
proto.clantreasury.TransferItem.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Balance.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Balance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Balance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Balance}
 */
proto.clantreasury.Balance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Balance;
  return proto.clantreasury.Balance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Balance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Balance}
 */
proto.clantreasury.Balance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Balance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Balance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Balance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Balance.Butter.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Balance.Butter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Balance.Butter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.Butter.toObject = function(includeInstance, msg) {
  var f, obj = {
    total: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Balance.Butter}
 */
proto.clantreasury.Balance.Butter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Balance.Butter;
  return proto.clantreasury.Balance.Butter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Balance.Butter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Balance.Butter}
 */
proto.clantreasury.Balance.Butter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Balance.Butter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Balance.Butter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Balance.Butter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.Butter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 total = 1;
 * @return {number}
 */
proto.clantreasury.Balance.Butter.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.Balance.Butter} returns this
 */
proto.clantreasury.Balance.Butter.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Balance.EnrichedOrbs.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Balance.EnrichedOrbs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Balance.EnrichedOrbs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.EnrichedOrbs.toObject = function(includeInstance, msg) {
  var f, obj = {
    total: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Balance.EnrichedOrbs}
 */
proto.clantreasury.Balance.EnrichedOrbs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Balance.EnrichedOrbs;
  return proto.clantreasury.Balance.EnrichedOrbs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Balance.EnrichedOrbs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Balance.EnrichedOrbs}
 */
proto.clantreasury.Balance.EnrichedOrbs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Balance.EnrichedOrbs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Balance.EnrichedOrbs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Balance.EnrichedOrbs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.EnrichedOrbs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 total = 1;
 * @return {number}
 */
proto.clantreasury.Balance.EnrichedOrbs.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.Balance.EnrichedOrbs} returns this
 */
proto.clantreasury.Balance.EnrichedOrbs.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Balance.MintableToken.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Balance.MintableToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Balance.MintableToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.MintableToken.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: (f = msg.getToken()) && proto.clantreasury.MintableToken.toObject(includeInstance, f),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Balance.MintableToken}
 */
proto.clantreasury.Balance.MintableToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Balance.MintableToken;
  return proto.clantreasury.Balance.MintableToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Balance.MintableToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Balance.MintableToken}
 */
proto.clantreasury.Balance.MintableToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clantreasury.MintableToken;
      reader.readMessage(value,proto.clantreasury.MintableToken.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Balance.MintableToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Balance.MintableToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Balance.MintableToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.MintableToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clantreasury.MintableToken.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional MintableToken token = 1;
 * @return {?proto.clantreasury.MintableToken}
 */
proto.clantreasury.Balance.MintableToken.prototype.getToken = function() {
  return /** @type{?proto.clantreasury.MintableToken} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.MintableToken, 1));
};


/**
 * @param {?proto.clantreasury.MintableToken|undefined} value
 * @return {!proto.clantreasury.Balance.MintableToken} returns this
*/
proto.clantreasury.Balance.MintableToken.prototype.setToken = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Balance.MintableToken} returns this
 */
proto.clantreasury.Balance.MintableToken.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Balance.MintableToken.prototype.hasToken = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.clantreasury.Balance.MintableToken.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.Balance.MintableToken} returns this
 */
proto.clantreasury.Balance.MintableToken.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Balance.GamedataItem.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Balance.GamedataItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Balance.GamedataItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.GamedataItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && proto.clantreasury.GamedataItem.toObject(includeInstance, f),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Balance.GamedataItem}
 */
proto.clantreasury.Balance.GamedataItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Balance.GamedataItem;
  return proto.clantreasury.Balance.GamedataItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Balance.GamedataItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Balance.GamedataItem}
 */
proto.clantreasury.Balance.GamedataItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clantreasury.GamedataItem;
      reader.readMessage(value,proto.clantreasury.GamedataItem.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Balance.GamedataItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Balance.GamedataItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Balance.GamedataItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Balance.GamedataItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clantreasury.GamedataItem.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional GamedataItem item = 1;
 * @return {?proto.clantreasury.GamedataItem}
 */
proto.clantreasury.Balance.GamedataItem.prototype.getItem = function() {
  return /** @type{?proto.clantreasury.GamedataItem} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.GamedataItem, 1));
};


/**
 * @param {?proto.clantreasury.GamedataItem|undefined} value
 * @return {!proto.clantreasury.Balance.GamedataItem} returns this
*/
proto.clantreasury.Balance.GamedataItem.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Balance.GamedataItem} returns this
 */
proto.clantreasury.Balance.GamedataItem.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Balance.GamedataItem.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.clantreasury.Balance.GamedataItem.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.Balance.GamedataItem} returns this
 */
proto.clantreasury.Balance.GamedataItem.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.History.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.History.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.History} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.History.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.History}
 */
proto.clantreasury.History.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.History;
  return proto.clantreasury.History.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.History} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.History}
 */
proto.clantreasury.History.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.History.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.History.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.History} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.History.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.History.Operation.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.History.Operation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.History.Operation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.History.Operation.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && proto.clantreasury.Item.toObject(includeInstance, f),
    processedAt: (f = msg.getProcessedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    by: (f = msg.getBy()) && proto.clantreasury.History.Author.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    recipient: (f = msg.getRecipient()) && proto.clantreasury.History.Recipient.toObject(includeInstance, f),
    failure: (f = msg.getFailure()) && proto.clantreasury.Operations.Failure.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 7, ""),
    metaInfo: (f = msg.getMetaInfo()) && proto.clantreasury.Operations.MetaInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.History.Operation}
 */
proto.clantreasury.History.Operation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.History.Operation;
  return proto.clantreasury.History.Operation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.History.Operation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.History.Operation}
 */
proto.clantreasury.History.Operation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clantreasury.Item;
      reader.readMessage(value,proto.clantreasury.Item.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setProcessedAt(value);
      break;
    case 3:
      var value = new proto.clantreasury.History.Author;
      reader.readMessage(value,proto.clantreasury.History.Author.deserializeBinaryFromReader);
      msg.setBy(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = new proto.clantreasury.History.Recipient;
      reader.readMessage(value,proto.clantreasury.History.Recipient.deserializeBinaryFromReader);
      msg.setRecipient(value);
      break;
    case 6:
      var value = new proto.clantreasury.Operations.Failure;
      reader.readMessage(value,proto.clantreasury.Operations.Failure.deserializeBinaryFromReader);
      msg.setFailure(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 8:
      var value = new proto.clantreasury.Operations.MetaInfo;
      reader.readMessage(value,proto.clantreasury.Operations.MetaInfo.deserializeBinaryFromReader);
      msg.setMetaInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.History.Operation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.History.Operation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.History.Operation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.History.Operation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clantreasury.Item.serializeBinaryToWriter
    );
  }
  f = message.getProcessedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBy();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.clantreasury.History.Author.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRecipient();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.clantreasury.History.Recipient.serializeBinaryToWriter
    );
  }
  f = message.getFailure();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.clantreasury.Operations.Failure.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMetaInfo();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.clantreasury.Operations.MetaInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional Item item = 1;
 * @return {?proto.clantreasury.Item}
 */
proto.clantreasury.History.Operation.prototype.getItem = function() {
  return /** @type{?proto.clantreasury.Item} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Item, 1));
};


/**
 * @param {?proto.clantreasury.Item|undefined} value
 * @return {!proto.clantreasury.History.Operation} returns this
*/
proto.clantreasury.History.Operation.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.History.Operation} returns this
 */
proto.clantreasury.History.Operation.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.History.Operation.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp processed_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.clantreasury.History.Operation.prototype.getProcessedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.clantreasury.History.Operation} returns this
*/
proto.clantreasury.History.Operation.prototype.setProcessedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.History.Operation} returns this
 */
proto.clantreasury.History.Operation.prototype.clearProcessedAt = function() {
  return this.setProcessedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.History.Operation.prototype.hasProcessedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Author by = 3;
 * @return {?proto.clantreasury.History.Author}
 */
proto.clantreasury.History.Operation.prototype.getBy = function() {
  return /** @type{?proto.clantreasury.History.Author} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.History.Author, 3));
};


/**
 * @param {?proto.clantreasury.History.Author|undefined} value
 * @return {!proto.clantreasury.History.Operation} returns this
*/
proto.clantreasury.History.Operation.prototype.setBy = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.History.Operation} returns this
 */
proto.clantreasury.History.Operation.prototype.clearBy = function() {
  return this.setBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.History.Operation.prototype.hasBy = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.clantreasury.History.Operation.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.clantreasury.History.Operation} returns this
*/
proto.clantreasury.History.Operation.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.History.Operation} returns this
 */
proto.clantreasury.History.Operation.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.History.Operation.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Recipient recipient = 5;
 * @return {?proto.clantreasury.History.Recipient}
 */
proto.clantreasury.History.Operation.prototype.getRecipient = function() {
  return /** @type{?proto.clantreasury.History.Recipient} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.History.Recipient, 5));
};


/**
 * @param {?proto.clantreasury.History.Recipient|undefined} value
 * @return {!proto.clantreasury.History.Operation} returns this
*/
proto.clantreasury.History.Operation.prototype.setRecipient = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.History.Operation} returns this
 */
proto.clantreasury.History.Operation.prototype.clearRecipient = function() {
  return this.setRecipient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.History.Operation.prototype.hasRecipient = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Operations.Failure failure = 6;
 * @return {?proto.clantreasury.Operations.Failure}
 */
proto.clantreasury.History.Operation.prototype.getFailure = function() {
  return /** @type{?proto.clantreasury.Operations.Failure} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Operations.Failure, 6));
};


/**
 * @param {?proto.clantreasury.Operations.Failure|undefined} value
 * @return {!proto.clantreasury.History.Operation} returns this
*/
proto.clantreasury.History.Operation.prototype.setFailure = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.History.Operation} returns this
 */
proto.clantreasury.History.Operation.prototype.clearFailure = function() {
  return this.setFailure(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.History.Operation.prototype.hasFailure = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string type = 7;
 * @return {string}
 */
proto.clantreasury.History.Operation.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.History.Operation} returns this
 */
proto.clantreasury.History.Operation.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Operations.MetaInfo meta_info = 8;
 * @return {?proto.clantreasury.Operations.MetaInfo}
 */
proto.clantreasury.History.Operation.prototype.getMetaInfo = function() {
  return /** @type{?proto.clantreasury.Operations.MetaInfo} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Operations.MetaInfo, 8));
};


/**
 * @param {?proto.clantreasury.Operations.MetaInfo|undefined} value
 * @return {!proto.clantreasury.History.Operation} returns this
*/
proto.clantreasury.History.Operation.prototype.setMetaInfo = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.History.Operation} returns this
 */
proto.clantreasury.History.Operation.prototype.clearMetaInfo = function() {
  return this.setMetaInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.History.Operation.prototype.hasMetaInfo = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.History.Author.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.History.Author.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.History.Author} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.History.Author.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.History.Author}
 */
proto.clantreasury.History.Author.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.History.Author;
  return proto.clantreasury.History.Author.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.History.Author} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.History.Author}
 */
proto.clantreasury.History.Author.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.History.Author.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.History.Author.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.History.Author} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.History.Author.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.clantreasury.History.Author.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.History.Author} returns this
 */
proto.clantreasury.History.Author.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.History.Recipient.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.History.Recipient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.History.Recipient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.History.Recipient.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.History.Recipient}
 */
proto.clantreasury.History.Recipient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.History.Recipient;
  return proto.clantreasury.History.Recipient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.History.Recipient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.History.Recipient}
 */
proto.clantreasury.History.Recipient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.History.Recipient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.History.Recipient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.History.Recipient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.History.Recipient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.clantreasury.History.Recipient.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.History.Recipient} returns this
 */
proto.clantreasury.History.Recipient.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.GamedataItem.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.GamedataItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.GamedataItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.GamedataItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.GamedataItem}
 */
proto.clantreasury.GamedataItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.GamedataItem;
  return proto.clantreasury.GamedataItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.GamedataItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.GamedataItem}
 */
proto.clantreasury.GamedataItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.GamedataItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.GamedataItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.GamedataItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.GamedataItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.clantreasury.GamedataItem.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.GamedataItem} returns this
 */
proto.clantreasury.GamedataItem.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.MintableToken.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.MintableToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.MintableToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.MintableToken.toObject = function(includeInstance, msg) {
  var f, obj = {
    configId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    level: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.MintableToken}
 */
proto.clantreasury.MintableToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.MintableToken;
  return proto.clantreasury.MintableToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.MintableToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.MintableToken}
 */
proto.clantreasury.MintableToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.MintableToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.MintableToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.MintableToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.MintableToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.clantreasury.MintableToken.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.MintableToken} returns this
 */
proto.clantreasury.MintableToken.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 level = 2;
 * @return {number}
 */
proto.clantreasury.MintableToken.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.MintableToken} returns this
 */
proto.clantreasury.MintableToken.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Reason.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Reason.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Reason} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Reason.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    operationType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Reason}
 */
proto.clantreasury.Reason.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Reason;
  return proto.clantreasury.Reason.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Reason} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Reason}
 */
proto.clantreasury.Reason.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperationType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Reason.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Reason.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Reason} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Reason.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOperationType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.clantreasury.Reason.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.Reason} returns this
 */
proto.clantreasury.Reason.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.clantreasury.Reason.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.Reason} returns this
 */
proto.clantreasury.Reason.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string operation_type = 3;
 * @return {string}
 */
proto.clantreasury.Reason.prototype.getOperationType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.Reason} returns this
 */
proto.clantreasury.Reason.prototype.setOperationType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations}
 */
proto.clantreasury.Operations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations;
  return proto.clantreasury.Operations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations}
 */
proto.clantreasury.Operations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.clantreasury.Operations.Type = {
  TYPE_UNKNOWN: 0,
  TREASURY_DONATE: 1,
  TREASURY_TRANSFER: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.Failure.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.Failure.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.Failure} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.Failure.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.Failure}
 */
proto.clantreasury.Operations.Failure.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.Failure;
  return proto.clantreasury.Operations.Failure.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.Failure} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.Failure}
 */
proto.clantreasury.Operations.Failure.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.clantreasury.Operations.Failure.Code} */ (reader.readEnum());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.Failure.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.Failure.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.Failure} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.Failure.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.clantreasury.Operations.Failure.Code = {
  UNKNOWN: 0,
  INSUFFICIENT_BALANCE: 1,
  UNKNOWN_RECIPIENT: 2
};

/**
 * optional Code code = 1;
 * @return {!proto.clantreasury.Operations.Failure.Code}
 */
proto.clantreasury.Operations.Failure.prototype.getCode = function() {
  return /** @type {!proto.clantreasury.Operations.Failure.Code} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.clantreasury.Operations.Failure.Code} value
 * @return {!proto.clantreasury.Operations.Failure} returns this
 */
proto.clantreasury.Operations.Failure.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.Restrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.Restrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.Restrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.Restrictions.toObject = function(includeInstance, msg) {
  var f, obj = {
    donates: (f = msg.getDonates()) && proto.clantreasury.Operations.Restrictions.Donates.toObject(includeInstance, f),
    transfers: (f = msg.getTransfers()) && proto.clantreasury.Operations.Restrictions.Transfers.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.Restrictions}
 */
proto.clantreasury.Operations.Restrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.Restrictions;
  return proto.clantreasury.Operations.Restrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.Restrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.Restrictions}
 */
proto.clantreasury.Operations.Restrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.clantreasury.Operations.Restrictions.Donates;
      reader.readMessage(value,proto.clantreasury.Operations.Restrictions.Donates.deserializeBinaryFromReader);
      msg.setDonates(value);
      break;
    case 2:
      var value = new proto.clantreasury.Operations.Restrictions.Transfers;
      reader.readMessage(value,proto.clantreasury.Operations.Restrictions.Transfers.deserializeBinaryFromReader);
      msg.setTransfers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.Restrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.Restrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.Restrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.Restrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDonates();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.clantreasury.Operations.Restrictions.Donates.serializeBinaryToWriter
    );
  }
  f = message.getTransfers();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.clantreasury.Operations.Restrictions.Transfers.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.Restrictions.Donates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.Restrictions.Donates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.Restrictions.Donates.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowed: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    notAllowedDur: (f = msg.getNotAllowedDur()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    allowedMemberAge: (f = msg.getAllowedMemberAge()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.Restrictions.Donates}
 */
proto.clantreasury.Operations.Restrictions.Donates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.Restrictions.Donates;
  return proto.clantreasury.Operations.Restrictions.Donates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.Restrictions.Donates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.Restrictions.Donates}
 */
proto.clantreasury.Operations.Restrictions.Donates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowed(value);
      break;
    case 2:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setNotAllowedDur(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setAllowedMemberAge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.Restrictions.Donates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.Restrictions.Donates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.Restrictions.Donates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowed();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getNotAllowedDur();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getAllowedMemberAge();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool allowed = 1;
 * @return {boolean}
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.getAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.clantreasury.Operations.Restrictions.Donates} returns this
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.setAllowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.Duration not_allowed_dur = 2;
 * @return {?proto.google.protobuf.Duration}
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.getNotAllowedDur = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 2));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.clantreasury.Operations.Restrictions.Donates} returns this
*/
proto.clantreasury.Operations.Restrictions.Donates.prototype.setNotAllowedDur = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Operations.Restrictions.Donates} returns this
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.clearNotAllowedDur = function() {
  return this.setNotAllowedDur(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.hasNotAllowedDur = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Duration allowed_member_age = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.getAllowedMemberAge = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.clantreasury.Operations.Restrictions.Donates} returns this
*/
proto.clantreasury.Operations.Restrictions.Donates.prototype.setAllowedMemberAge = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Operations.Restrictions.Donates} returns this
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.clearAllowedMemberAge = function() {
  return this.setAllowedMemberAge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Operations.Restrictions.Donates.prototype.hasAllowedMemberAge = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.Restrictions.Transfers.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.Restrictions.Transfers.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.Restrictions.Transfers} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.Restrictions.Transfers.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowed: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.Restrictions.Transfers}
 */
proto.clantreasury.Operations.Restrictions.Transfers.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.Restrictions.Transfers;
  return proto.clantreasury.Operations.Restrictions.Transfers.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.Restrictions.Transfers} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.Restrictions.Transfers}
 */
proto.clantreasury.Operations.Restrictions.Transfers.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.Restrictions.Transfers.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.Restrictions.Transfers.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.Restrictions.Transfers} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.Restrictions.Transfers.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowed();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool allowed = 1;
 * @return {boolean}
 */
proto.clantreasury.Operations.Restrictions.Transfers.prototype.getAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.clantreasury.Operations.Restrictions.Transfers} returns this
 */
proto.clantreasury.Operations.Restrictions.Transfers.prototype.setAllowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Donates donates = 1;
 * @return {?proto.clantreasury.Operations.Restrictions.Donates}
 */
proto.clantreasury.Operations.Restrictions.prototype.getDonates = function() {
  return /** @type{?proto.clantreasury.Operations.Restrictions.Donates} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Operations.Restrictions.Donates, 1));
};


/**
 * @param {?proto.clantreasury.Operations.Restrictions.Donates|undefined} value
 * @return {!proto.clantreasury.Operations.Restrictions} returns this
*/
proto.clantreasury.Operations.Restrictions.prototype.setDonates = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Operations.Restrictions} returns this
 */
proto.clantreasury.Operations.Restrictions.prototype.clearDonates = function() {
  return this.setDonates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Operations.Restrictions.prototype.hasDonates = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Transfers transfers = 2;
 * @return {?proto.clantreasury.Operations.Restrictions.Transfers}
 */
proto.clantreasury.Operations.Restrictions.prototype.getTransfers = function() {
  return /** @type{?proto.clantreasury.Operations.Restrictions.Transfers} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Operations.Restrictions.Transfers, 2));
};


/**
 * @param {?proto.clantreasury.Operations.Restrictions.Transfers|undefined} value
 * @return {!proto.clantreasury.Operations.Restrictions} returns this
*/
proto.clantreasury.Operations.Restrictions.prototype.setTransfers = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Operations.Restrictions} returns this
 */
proto.clantreasury.Operations.Restrictions.prototype.clearTransfers = function() {
  return this.setTransfers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Operations.Restrictions.prototype.hasTransfers = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.UserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.UserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.UserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.UserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    account: (f = msg.getAccount()) && proto.clantreasury.Operations.UserInfo.Account.toObject(includeInstance, f),
    ident: (f = msg.getIdent()) && proto.clantreasury.Operations.UserInfo.Ident.toObject(includeInstance, f),
    clanMembership: (f = msg.getClanMembership()) && proto.clantreasury.Operations.UserInfo.ClanMembership.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.UserInfo}
 */
proto.clantreasury.Operations.UserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.UserInfo;
  return proto.clantreasury.Operations.UserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.UserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.UserInfo}
 */
proto.clantreasury.Operations.UserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.clantreasury.Operations.UserInfo.Account;
      reader.readMessage(value,proto.clantreasury.Operations.UserInfo.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 3:
      var value = new proto.clantreasury.Operations.UserInfo.Ident;
      reader.readMessage(value,proto.clantreasury.Operations.UserInfo.Ident.deserializeBinaryFromReader);
      msg.setIdent(value);
      break;
    case 4:
      var value = new proto.clantreasury.Operations.UserInfo.ClanMembership;
      reader.readMessage(value,proto.clantreasury.Operations.UserInfo.ClanMembership.deserializeBinaryFromReader);
      msg.setClanMembership(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.UserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.UserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.UserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.UserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.clantreasury.Operations.UserInfo.Account.serializeBinaryToWriter
    );
  }
  f = message.getIdent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.clantreasury.Operations.UserInfo.Ident.serializeBinaryToWriter
    );
  }
  f = message.getClanMembership();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.clantreasury.Operations.UserInfo.ClanMembership.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.UserInfo.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.UserInfo.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.UserInfo.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.UserInfo.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.UserInfo.Account}
 */
proto.clantreasury.Operations.UserInfo.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.UserInfo.Account;
  return proto.clantreasury.Operations.UserInfo.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.UserInfo.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.UserInfo.Account}
 */
proto.clantreasury.Operations.UserInfo.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.UserInfo.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.UserInfo.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.UserInfo.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.UserInfo.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 level = 1;
 * @return {number}
 */
proto.clantreasury.Operations.UserInfo.Account.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.Operations.UserInfo.Account} returns this
 */
proto.clantreasury.Operations.UserInfo.Account.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.UserInfo.Ident.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.UserInfo.Ident.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.UserInfo.Ident} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.UserInfo.Ident.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    suffix: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.UserInfo.Ident}
 */
proto.clantreasury.Operations.UserInfo.Ident.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.UserInfo.Ident;
  return proto.clantreasury.Operations.UserInfo.Ident.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.UserInfo.Ident} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.UserInfo.Ident}
 */
proto.clantreasury.Operations.UserInfo.Ident.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.UserInfo.Ident.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.UserInfo.Ident.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.UserInfo.Ident} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.UserInfo.Ident.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuffix();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.clantreasury.Operations.UserInfo.Ident.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.Operations.UserInfo.Ident} returns this
 */
proto.clantreasury.Operations.UserInfo.Ident.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string suffix = 2;
 * @return {string}
 */
proto.clantreasury.Operations.UserInfo.Ident.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.Operations.UserInfo.Ident} returns this
 */
proto.clantreasury.Operations.UserInfo.Ident.prototype.setSuffix = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.UserInfo.ClanMembership.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.UserInfo.ClanMembership.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.UserInfo.ClanMembership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.UserInfo.ClanMembership.toObject = function(includeInstance, msg) {
  var f, obj = {
    role: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.UserInfo.ClanMembership}
 */
proto.clantreasury.Operations.UserInfo.ClanMembership.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.UserInfo.ClanMembership;
  return proto.clantreasury.Operations.UserInfo.ClanMembership.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.UserInfo.ClanMembership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.UserInfo.ClanMembership}
 */
proto.clantreasury.Operations.UserInfo.ClanMembership.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.UserInfo.ClanMembership.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.UserInfo.ClanMembership.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.UserInfo.ClanMembership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.UserInfo.ClanMembership.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string role = 1;
 * @return {string}
 */
proto.clantreasury.Operations.UserInfo.ClanMembership.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.Operations.UserInfo.ClanMembership} returns this
 */
proto.clantreasury.Operations.UserInfo.ClanMembership.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.clantreasury.Operations.UserInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.Operations.UserInfo} returns this
 */
proto.clantreasury.Operations.UserInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Account account = 2;
 * @return {?proto.clantreasury.Operations.UserInfo.Account}
 */
proto.clantreasury.Operations.UserInfo.prototype.getAccount = function() {
  return /** @type{?proto.clantreasury.Operations.UserInfo.Account} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Operations.UserInfo.Account, 2));
};


/**
 * @param {?proto.clantreasury.Operations.UserInfo.Account|undefined} value
 * @return {!proto.clantreasury.Operations.UserInfo} returns this
*/
proto.clantreasury.Operations.UserInfo.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Operations.UserInfo} returns this
 */
proto.clantreasury.Operations.UserInfo.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Operations.UserInfo.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Ident ident = 3;
 * @return {?proto.clantreasury.Operations.UserInfo.Ident}
 */
proto.clantreasury.Operations.UserInfo.prototype.getIdent = function() {
  return /** @type{?proto.clantreasury.Operations.UserInfo.Ident} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Operations.UserInfo.Ident, 3));
};


/**
 * @param {?proto.clantreasury.Operations.UserInfo.Ident|undefined} value
 * @return {!proto.clantreasury.Operations.UserInfo} returns this
*/
proto.clantreasury.Operations.UserInfo.prototype.setIdent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Operations.UserInfo} returns this
 */
proto.clantreasury.Operations.UserInfo.prototype.clearIdent = function() {
  return this.setIdent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Operations.UserInfo.prototype.hasIdent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ClanMembership clan_membership = 4;
 * @return {?proto.clantreasury.Operations.UserInfo.ClanMembership}
 */
proto.clantreasury.Operations.UserInfo.prototype.getClanMembership = function() {
  return /** @type{?proto.clantreasury.Operations.UserInfo.ClanMembership} */ (
    jspb.Message.getWrapperField(this, proto.clantreasury.Operations.UserInfo.ClanMembership, 4));
};


/**
 * @param {?proto.clantreasury.Operations.UserInfo.ClanMembership|undefined} value
 * @return {!proto.clantreasury.Operations.UserInfo} returns this
*/
proto.clantreasury.Operations.UserInfo.prototype.setClanMembership = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.Operations.UserInfo} returns this
 */
proto.clantreasury.Operations.UserInfo.prototype.clearClanMembership = function() {
  return this.setClanMembership(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.Operations.UserInfo.prototype.hasClanMembership = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.Operations.MetaInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.Operations.MetaInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.Operations.MetaInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.MetaInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    externalUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.Operations.MetaInfo}
 */
proto.clantreasury.Operations.MetaInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.Operations.MetaInfo;
  return proto.clantreasury.Operations.MetaInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.Operations.MetaInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.Operations.MetaInfo}
 */
proto.clantreasury.Operations.MetaInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.Operations.MetaInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.Operations.MetaInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.Operations.MetaInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.Operations.MetaInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExternalUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string external_url = 1;
 * @return {string}
 */
proto.clantreasury.Operations.MetaInfo.prototype.getExternalUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.Operations.MetaInfo} returns this
 */
proto.clantreasury.Operations.MetaInfo.prototype.setExternalUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.TimeRange.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.TimeRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.TimeRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.TimeRange.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: (f = msg.getStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    end: (f = msg.getEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.TimeRange}
 */
proto.clantreasury.TimeRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.TimeRange;
  return proto.clantreasury.TimeRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.TimeRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.TimeRange}
 */
proto.clantreasury.TimeRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.TimeRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.TimeRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.TimeRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.TimeRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.clantreasury.TimeRange.prototype.getStart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.clantreasury.TimeRange} returns this
*/
proto.clantreasury.TimeRange.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.TimeRange} returns this
 */
proto.clantreasury.TimeRange.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.TimeRange.prototype.hasStart = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.clantreasury.TimeRange.prototype.getEnd = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.clantreasury.TimeRange} returns this
*/
proto.clantreasury.TimeRange.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.clantreasury.TimeRange} returns this
 */
proto.clantreasury.TimeRange.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.clantreasury.TimeRange.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.clantreasury.PageParams.prototype.toObject = function(opt_includeInstance) {
  return proto.clantreasury.PageParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.clantreasury.PageParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.PageParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cursor: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.clantreasury.PageParams}
 */
proto.clantreasury.PageParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.clantreasury.PageParams;
  return proto.clantreasury.PageParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.clantreasury.PageParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.clantreasury.PageParams}
 */
proto.clantreasury.PageParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.clantreasury.PageParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.clantreasury.PageParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.clantreasury.PageParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.clantreasury.PageParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 limit = 1;
 * @return {number}
 */
proto.clantreasury.PageParams.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.clantreasury.PageParams} returns this
 */
proto.clantreasury.PageParams.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string cursor = 2;
 * @return {string}
 */
proto.clantreasury.PageParams.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.clantreasury.PageParams} returns this
 */
proto.clantreasury.PageParams.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.clantreasury);

},{"./validate/validate_pb.js":27,"google-protobuf":3,"google-protobuf/google/protobuf/duration_pb.js":4,"google-protobuf/google/protobuf/timestamp_pb.js":6}],25:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for public.clantreasury
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var clantreasury_pb = require('../clantreasury_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js')
const proto = {};
proto.public = {};
proto.public.clantreasury = require('./service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.clantreasury.OperationsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.clantreasury.OperationsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clantreasury.SubmitTransfer.Request,
 *   !proto.public.clantreasury.SubmitTransfer.Response>}
 */
const methodDescriptor_Operations_SubmitTransfer = new grpc.web.MethodDescriptor(
  '/public.clantreasury.Operations/SubmitTransfer',
  grpc.web.MethodType.UNARY,
  proto.public.clantreasury.SubmitTransfer.Request,
  proto.public.clantreasury.SubmitTransfer.Response,
  /**
   * @param {!proto.public.clantreasury.SubmitTransfer.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clantreasury.SubmitTransfer.Response.deserializeBinary
);


/**
 * @param {!proto.public.clantreasury.SubmitTransfer.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clantreasury.SubmitTransfer.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clantreasury.SubmitTransfer.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clantreasury.OperationsClient.prototype.submitTransfer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clantreasury.Operations/SubmitTransfer',
      request,
      metadata || {},
      methodDescriptor_Operations_SubmitTransfer,
      callback);
};


/**
 * @param {!proto.public.clantreasury.SubmitTransfer.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clantreasury.SubmitTransfer.Response>}
 *     Promise that resolves to the response
 */
proto.public.clantreasury.OperationsPromiseClient.prototype.submitTransfer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clantreasury.Operations/SubmitTransfer',
      request,
      metadata || {},
      methodDescriptor_Operations_SubmitTransfer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clantreasury.OperationsHistory.Request,
 *   !proto.public.clantreasury.OperationsHistory.Response>}
 */
const methodDescriptor_Operations_History = new grpc.web.MethodDescriptor(
  '/public.clantreasury.Operations/History',
  grpc.web.MethodType.UNARY,
  proto.public.clantreasury.OperationsHistory.Request,
  proto.public.clantreasury.OperationsHistory.Response,
  /**
   * @param {!proto.public.clantreasury.OperationsHistory.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clantreasury.OperationsHistory.Response.deserializeBinary
);


/**
 * @param {!proto.public.clantreasury.OperationsHistory.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clantreasury.OperationsHistory.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clantreasury.OperationsHistory.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clantreasury.OperationsClient.prototype.history =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clantreasury.Operations/History',
      request,
      metadata || {},
      methodDescriptor_Operations_History,
      callback);
};


/**
 * @param {!proto.public.clantreasury.OperationsHistory.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clantreasury.OperationsHistory.Response>}
 *     Promise that resolves to the response
 */
proto.public.clantreasury.OperationsPromiseClient.prototype.history =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clantreasury.Operations/History',
      request,
      metadata || {},
      methodDescriptor_Operations_History);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clantreasury.Donate.Request,
 *   !proto.public.clantreasury.Donate.Response>}
 */
const methodDescriptor_Operations_Donate = new grpc.web.MethodDescriptor(
  '/public.clantreasury.Operations/Donate',
  grpc.web.MethodType.UNARY,
  proto.public.clantreasury.Donate.Request,
  proto.public.clantreasury.Donate.Response,
  /**
   * @param {!proto.public.clantreasury.Donate.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clantreasury.Donate.Response.deserializeBinary
);


/**
 * @param {!proto.public.clantreasury.Donate.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clantreasury.Donate.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clantreasury.Donate.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clantreasury.OperationsClient.prototype.donate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clantreasury.Operations/Donate',
      request,
      metadata || {},
      methodDescriptor_Operations_Donate,
      callback);
};


/**
 * @param {!proto.public.clantreasury.Donate.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clantreasury.Donate.Response>}
 *     Promise that resolves to the response
 */
proto.public.clantreasury.OperationsPromiseClient.prototype.donate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clantreasury.Operations/Donate',
      request,
      metadata || {},
      methodDescriptor_Operations_Donate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clantreasury.DonateHistory.Request,
 *   !proto.public.clantreasury.DonateHistory.Response>}
 */
const methodDescriptor_Operations_DonateHistory = new grpc.web.MethodDescriptor(
  '/public.clantreasury.Operations/DonateHistory',
  grpc.web.MethodType.UNARY,
  proto.public.clantreasury.DonateHistory.Request,
  proto.public.clantreasury.DonateHistory.Response,
  /**
   * @param {!proto.public.clantreasury.DonateHistory.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clantreasury.DonateHistory.Response.deserializeBinary
);


/**
 * @param {!proto.public.clantreasury.DonateHistory.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clantreasury.DonateHistory.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clantreasury.DonateHistory.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clantreasury.OperationsClient.prototype.donateHistory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clantreasury.Operations/DonateHistory',
      request,
      metadata || {},
      methodDescriptor_Operations_DonateHistory,
      callback);
};


/**
 * @param {!proto.public.clantreasury.DonateHistory.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clantreasury.DonateHistory.Response>}
 *     Promise that resolves to the response
 */
proto.public.clantreasury.OperationsPromiseClient.prototype.donateHistory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clantreasury.Operations/DonateHistory',
      request,
      metadata || {},
      methodDescriptor_Operations_DonateHistory);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.clantreasury.OverviewClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.clantreasury.OverviewPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.clantreasury.GetBalances.Request,
 *   !proto.public.clantreasury.GetBalances.Response>}
 */
const methodDescriptor_Overview_GetBalances = new grpc.web.MethodDescriptor(
  '/public.clantreasury.Overview/GetBalances',
  grpc.web.MethodType.UNARY,
  proto.public.clantreasury.GetBalances.Request,
  proto.public.clantreasury.GetBalances.Response,
  /**
   * @param {!proto.public.clantreasury.GetBalances.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.clantreasury.GetBalances.Response.deserializeBinary
);


/**
 * @param {!proto.public.clantreasury.GetBalances.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.clantreasury.GetBalances.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.clantreasury.GetBalances.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.clantreasury.OverviewClient.prototype.getBalances =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.clantreasury.Overview/GetBalances',
      request,
      metadata || {},
      methodDescriptor_Overview_GetBalances,
      callback);
};


/**
 * @param {!proto.public.clantreasury.GetBalances.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.clantreasury.GetBalances.Response>}
 *     Promise that resolves to the response
 */
proto.public.clantreasury.OverviewPromiseClient.prototype.getBalances =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.clantreasury.Overview/GetBalances',
      request,
      metadata || {},
      methodDescriptor_Overview_GetBalances);
};


module.exports = proto.public.clantreasury;


},{"../clantreasury_pb.js":24,"../validate/validate_pb.js":27,"./service_pb.js":26,"google-protobuf/google/protobuf/duration_pb.js":4,"google-protobuf/google/protobuf/timestamp_pb.js":6,"grpc-web":7}],26:[function(require,module,exports){
// source: public/service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var clantreasury_pb = require('../clantreasury_pb.js');
goog.object.extend(proto, clantreasury_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
goog.exportSymbol('proto.public.clantreasury.Donate', null, global);
goog.exportSymbol('proto.public.clantreasury.Donate.Request', null, global);
goog.exportSymbol('proto.public.clantreasury.Donate.Response', null, global);
goog.exportSymbol('proto.public.clantreasury.DonateHistory', null, global);
goog.exportSymbol('proto.public.clantreasury.DonateHistory.Request', null, global);
goog.exportSymbol('proto.public.clantreasury.DonateHistory.Response', null, global);
goog.exportSymbol('proto.public.clantreasury.GetBalances', null, global);
goog.exportSymbol('proto.public.clantreasury.GetBalances.Filter', null, global);
goog.exportSymbol('proto.public.clantreasury.GetBalances.Request', null, global);
goog.exportSymbol('proto.public.clantreasury.GetBalances.Response', null, global);
goog.exportSymbol('proto.public.clantreasury.GetBalances.UserBalances', null, global);
goog.exportSymbol('proto.public.clantreasury.OperationsHistory', null, global);
goog.exportSymbol('proto.public.clantreasury.OperationsHistory.Request', null, global);
goog.exportSymbol('proto.public.clantreasury.OperationsHistory.Response', null, global);
goog.exportSymbol('proto.public.clantreasury.SubmitTransfer', null, global);
goog.exportSymbol('proto.public.clantreasury.SubmitTransfer.Request', null, global);
goog.exportSymbol('proto.public.clantreasury.SubmitTransfer.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.SubmitTransfer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.SubmitTransfer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.SubmitTransfer.displayName = 'proto.public.clantreasury.SubmitTransfer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.SubmitTransfer.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.SubmitTransfer.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.SubmitTransfer.Request.displayName = 'proto.public.clantreasury.SubmitTransfer.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.SubmitTransfer.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.SubmitTransfer.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.SubmitTransfer.Response.displayName = 'proto.public.clantreasury.SubmitTransfer.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.OperationsHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.OperationsHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.OperationsHistory.displayName = 'proto.public.clantreasury.OperationsHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.OperationsHistory.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.OperationsHistory.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.OperationsHistory.Request.displayName = 'proto.public.clantreasury.OperationsHistory.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.OperationsHistory.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clantreasury.OperationsHistory.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clantreasury.OperationsHistory.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.OperationsHistory.Response.displayName = 'proto.public.clantreasury.OperationsHistory.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.Donate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.Donate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.Donate.displayName = 'proto.public.clantreasury.Donate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.Donate.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.Donate.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.Donate.Request.displayName = 'proto.public.clantreasury.Donate.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.Donate.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.Donate.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.Donate.Response.displayName = 'proto.public.clantreasury.Donate.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.DonateHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.DonateHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.DonateHistory.displayName = 'proto.public.clantreasury.DonateHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.DonateHistory.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.DonateHistory.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.DonateHistory.Request.displayName = 'proto.public.clantreasury.DonateHistory.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.DonateHistory.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clantreasury.DonateHistory.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clantreasury.DonateHistory.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.DonateHistory.Response.displayName = 'proto.public.clantreasury.DonateHistory.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.GetBalances = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.GetBalances, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.GetBalances.displayName = 'proto.public.clantreasury.GetBalances';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.GetBalances.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.GetBalances.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.GetBalances.Request.displayName = 'proto.public.clantreasury.GetBalances.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.GetBalances.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.clantreasury.GetBalances.Response.repeatedFields_, null);
};
goog.inherits(proto.public.clantreasury.GetBalances.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.GetBalances.Response.displayName = 'proto.public.clantreasury.GetBalances.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.GetBalances.UserBalances = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.GetBalances.UserBalances, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.GetBalances.UserBalances.displayName = 'proto.public.clantreasury.GetBalances.UserBalances';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.clantreasury.GetBalances.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.clantreasury.GetBalances.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.clantreasury.GetBalances.Filter.displayName = 'proto.public.clantreasury.GetBalances.Filter';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.SubmitTransfer.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.SubmitTransfer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.SubmitTransfer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.SubmitTransfer.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.SubmitTransfer}
 */
proto.public.clantreasury.SubmitTransfer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.SubmitTransfer;
  return proto.public.clantreasury.SubmitTransfer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.SubmitTransfer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.SubmitTransfer}
 */
proto.public.clantreasury.SubmitTransfer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.SubmitTransfer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.SubmitTransfer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.SubmitTransfer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.SubmitTransfer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.SubmitTransfer.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.SubmitTransfer.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.SubmitTransfer.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    reasonId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    recipientUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    item: (f = msg.getItem()) && clantreasury_pb.TransferItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.SubmitTransfer.Request}
 */
proto.public.clantreasury.SubmitTransfer.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.SubmitTransfer.Request;
  return proto.public.clantreasury.SubmitTransfer.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.SubmitTransfer.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.SubmitTransfer.Request}
 */
proto.public.clantreasury.SubmitTransfer.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasonId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipientUserId(value);
      break;
    case 4:
      var value = new clantreasury_pb.TransferItem;
      reader.readMessage(value,clantreasury_pb.TransferItem.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.SubmitTransfer.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.SubmitTransfer.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.SubmitTransfer.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReasonId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecipientUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      clantreasury_pb.TransferItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string reason_id = 1;
 * @return {string}
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.getReasonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clantreasury.SubmitTransfer.Request} returns this
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.setReasonId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string recipient_user_id = 2;
 * @return {string}
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.getRecipientUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clantreasury.SubmitTransfer.Request} returns this
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.setRecipientUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional clantreasury.TransferItem item = 4;
 * @return {?proto.clantreasury.TransferItem}
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.getItem = function() {
  return /** @type{?proto.clantreasury.TransferItem} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.TransferItem, 4));
};


/**
 * @param {?proto.clantreasury.TransferItem|undefined} value
 * @return {!proto.public.clantreasury.SubmitTransfer.Request} returns this
*/
proto.public.clantreasury.SubmitTransfer.Request.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.SubmitTransfer.Request} returns this
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.SubmitTransfer.Request.prototype.hasItem = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.SubmitTransfer.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.SubmitTransfer.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.SubmitTransfer.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.SubmitTransfer.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.SubmitTransfer.Response}
 */
proto.public.clantreasury.SubmitTransfer.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.SubmitTransfer.Response;
  return proto.public.clantreasury.SubmitTransfer.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.SubmitTransfer.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.SubmitTransfer.Response}
 */
proto.public.clantreasury.SubmitTransfer.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.SubmitTransfer.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.SubmitTransfer.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.SubmitTransfer.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.SubmitTransfer.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.OperationsHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.OperationsHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.OperationsHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.OperationsHistory.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.OperationsHistory}
 */
proto.public.clantreasury.OperationsHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.OperationsHistory;
  return proto.public.clantreasury.OperationsHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.OperationsHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.OperationsHistory}
 */
proto.public.clantreasury.OperationsHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.OperationsHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.OperationsHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.OperationsHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.OperationsHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.OperationsHistory.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.OperationsHistory.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.OperationsHistory.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.OperationsHistory.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageCursor: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.OperationsHistory.Request}
 */
proto.public.clantreasury.OperationsHistory.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.OperationsHistory.Request;
  return proto.public.clantreasury.OperationsHistory.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.OperationsHistory.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.OperationsHistory.Request}
 */
proto.public.clantreasury.OperationsHistory.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.OperationsHistory.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.OperationsHistory.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.OperationsHistory.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.OperationsHistory.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 limit = 1;
 * @return {number}
 */
proto.public.clantreasury.OperationsHistory.Request.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clantreasury.OperationsHistory.Request} returns this
 */
proto.public.clantreasury.OperationsHistory.Request.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string page_cursor = 2;
 * @return {string}
 */
proto.public.clantreasury.OperationsHistory.Request.prototype.getPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clantreasury.OperationsHistory.Request} returns this
 */
proto.public.clantreasury.OperationsHistory.Request.prototype.setPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clantreasury.OperationsHistory.Response.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.OperationsHistory.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.OperationsHistory.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.OperationsHistory.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    operationsList: jspb.Message.toObjectList(msg.getOperationsList(),
    clantreasury_pb.History.Operation.toObject, includeInstance),
    nextPage: jspb.Message.getFieldWithDefault(msg, 2, ""),
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    clantreasury_pb.Operations.UserInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.OperationsHistory.Response}
 */
proto.public.clantreasury.OperationsHistory.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.OperationsHistory.Response;
  return proto.public.clantreasury.OperationsHistory.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.OperationsHistory.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.OperationsHistory.Response}
 */
proto.public.clantreasury.OperationsHistory.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clantreasury_pb.History.Operation;
      reader.readMessage(value,clantreasury_pb.History.Operation.deserializeBinaryFromReader);
      msg.addOperations(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPage(value);
      break;
    case 3:
      var value = new clantreasury_pb.Operations.UserInfo;
      reader.readMessage(value,clantreasury_pb.Operations.UserInfo.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.OperationsHistory.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.OperationsHistory.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.OperationsHistory.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      clantreasury_pb.History.Operation.serializeBinaryToWriter
    );
  }
  f = message.getNextPage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      clantreasury_pb.Operations.UserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated clantreasury.History.Operation operations = 1;
 * @return {!Array<!proto.clantreasury.History.Operation>}
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.getOperationsList = function() {
  return /** @type{!Array<!proto.clantreasury.History.Operation>} */ (
    jspb.Message.getRepeatedWrapperField(this, clantreasury_pb.History.Operation, 1));
};


/**
 * @param {!Array<!proto.clantreasury.History.Operation>} value
 * @return {!proto.public.clantreasury.OperationsHistory.Response} returns this
*/
proto.public.clantreasury.OperationsHistory.Response.prototype.setOperationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.clantreasury.History.Operation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clantreasury.History.Operation}
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.addOperations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.clantreasury.History.Operation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clantreasury.OperationsHistory.Response} returns this
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.clearOperationsList = function() {
  return this.setOperationsList([]);
};


/**
 * optional string next_page = 2;
 * @return {string}
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.getNextPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clantreasury.OperationsHistory.Response} returns this
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.setNextPage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated clantreasury.Operations.UserInfo users = 3;
 * @return {!Array<!proto.clantreasury.Operations.UserInfo>}
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.clantreasury.Operations.UserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, clantreasury_pb.Operations.UserInfo, 3));
};


/**
 * @param {!Array<!proto.clantreasury.Operations.UserInfo>} value
 * @return {!proto.public.clantreasury.OperationsHistory.Response} returns this
*/
proto.public.clantreasury.OperationsHistory.Response.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.clantreasury.Operations.UserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clantreasury.Operations.UserInfo}
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.clantreasury.Operations.UserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clantreasury.OperationsHistory.Response} returns this
 */
proto.public.clantreasury.OperationsHistory.Response.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.Donate.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.Donate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.Donate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.Donate.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.Donate}
 */
proto.public.clantreasury.Donate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.Donate;
  return proto.public.clantreasury.Donate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.Donate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.Donate}
 */
proto.public.clantreasury.Donate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.Donate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.Donate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.Donate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.Donate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.Donate.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.Donate.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.Donate.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.Donate.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    reasonId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    enrichedOrbs: jspb.Message.getFieldWithDefault(msg, 2, 0),
    item: (f = msg.getItem()) && clantreasury_pb.Item.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.Donate.Request}
 */
proto.public.clantreasury.Donate.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.Donate.Request;
  return proto.public.clantreasury.Donate.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.Donate.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.Donate.Request}
 */
proto.public.clantreasury.Donate.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasonId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnrichedOrbs(value);
      break;
    case 3:
      var value = new clantreasury_pb.Item;
      reader.readMessage(value,clantreasury_pb.Item.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.Donate.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.Donate.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.Donate.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.Donate.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReasonId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnrichedOrbs();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      clantreasury_pb.Item.serializeBinaryToWriter
    );
  }
};


/**
 * optional string reason_id = 1;
 * @return {string}
 */
proto.public.clantreasury.Donate.Request.prototype.getReasonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clantreasury.Donate.Request} returns this
 */
proto.public.clantreasury.Donate.Request.prototype.setReasonId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 enriched_orbs = 2;
 * @return {number}
 */
proto.public.clantreasury.Donate.Request.prototype.getEnrichedOrbs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.clantreasury.Donate.Request} returns this
 */
proto.public.clantreasury.Donate.Request.prototype.setEnrichedOrbs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional clantreasury.Item item = 3;
 * @return {?proto.clantreasury.Item}
 */
proto.public.clantreasury.Donate.Request.prototype.getItem = function() {
  return /** @type{?proto.clantreasury.Item} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.Item, 3));
};


/**
 * @param {?proto.clantreasury.Item|undefined} value
 * @return {!proto.public.clantreasury.Donate.Request} returns this
*/
proto.public.clantreasury.Donate.Request.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.Donate.Request} returns this
 */
proto.public.clantreasury.Donate.Request.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.Donate.Request.prototype.hasItem = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.Donate.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.Donate.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.Donate.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.Donate.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.Donate.Response}
 */
proto.public.clantreasury.Donate.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.Donate.Response;
  return proto.public.clantreasury.Donate.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.Donate.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.Donate.Response}
 */
proto.public.clantreasury.Donate.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.Donate.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.Donate.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.Donate.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.Donate.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.DonateHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.DonateHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.DonateHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.DonateHistory.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.DonateHistory}
 */
proto.public.clantreasury.DonateHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.DonateHistory;
  return proto.public.clantreasury.DonateHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.DonateHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.DonateHistory}
 */
proto.public.clantreasury.DonateHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.DonateHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.DonateHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.DonateHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.DonateHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.DonateHistory.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.DonateHistory.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.DonateHistory.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.DonateHistory.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: (f = msg.getPage()) && clantreasury_pb.PageParams.toObject(includeInstance, f),
    timerange: (f = msg.getTimerange()) && clantreasury_pb.TimeRange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.DonateHistory.Request}
 */
proto.public.clantreasury.DonateHistory.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.DonateHistory.Request;
  return proto.public.clantreasury.DonateHistory.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.DonateHistory.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.DonateHistory.Request}
 */
proto.public.clantreasury.DonateHistory.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clantreasury_pb.PageParams;
      reader.readMessage(value,clantreasury_pb.PageParams.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 2:
      var value = new clantreasury_pb.TimeRange;
      reader.readMessage(value,clantreasury_pb.TimeRange.deserializeBinaryFromReader);
      msg.setTimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.DonateHistory.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.DonateHistory.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.DonateHistory.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.DonateHistory.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clantreasury_pb.PageParams.serializeBinaryToWriter
    );
  }
  f = message.getTimerange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      clantreasury_pb.TimeRange.serializeBinaryToWriter
    );
  }
};


/**
 * optional clantreasury.PageParams page = 1;
 * @return {?proto.clantreasury.PageParams}
 */
proto.public.clantreasury.DonateHistory.Request.prototype.getPage = function() {
  return /** @type{?proto.clantreasury.PageParams} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.PageParams, 1));
};


/**
 * @param {?proto.clantreasury.PageParams|undefined} value
 * @return {!proto.public.clantreasury.DonateHistory.Request} returns this
*/
proto.public.clantreasury.DonateHistory.Request.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.DonateHistory.Request} returns this
 */
proto.public.clantreasury.DonateHistory.Request.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.DonateHistory.Request.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional clantreasury.TimeRange timerange = 2;
 * @return {?proto.clantreasury.TimeRange}
 */
proto.public.clantreasury.DonateHistory.Request.prototype.getTimerange = function() {
  return /** @type{?proto.clantreasury.TimeRange} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.TimeRange, 2));
};


/**
 * @param {?proto.clantreasury.TimeRange|undefined} value
 * @return {!proto.public.clantreasury.DonateHistory.Request} returns this
*/
proto.public.clantreasury.DonateHistory.Request.prototype.setTimerange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.DonateHistory.Request} returns this
 */
proto.public.clantreasury.DonateHistory.Request.prototype.clearTimerange = function() {
  return this.setTimerange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.DonateHistory.Request.prototype.hasTimerange = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clantreasury.DonateHistory.Response.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.DonateHistory.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.DonateHistory.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.DonateHistory.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.DonateHistory.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    operationsList: jspb.Message.toObjectList(msg.getOperationsList(),
    clantreasury_pb.History.Operation.toObject, includeInstance),
    nextPage: jspb.Message.getFieldWithDefault(msg, 2, ""),
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    clantreasury_pb.Operations.UserInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.DonateHistory.Response}
 */
proto.public.clantreasury.DonateHistory.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.DonateHistory.Response;
  return proto.public.clantreasury.DonateHistory.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.DonateHistory.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.DonateHistory.Response}
 */
proto.public.clantreasury.DonateHistory.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clantreasury_pb.History.Operation;
      reader.readMessage(value,clantreasury_pb.History.Operation.deserializeBinaryFromReader);
      msg.addOperations(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPage(value);
      break;
    case 3:
      var value = new clantreasury_pb.Operations.UserInfo;
      reader.readMessage(value,clantreasury_pb.Operations.UserInfo.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.DonateHistory.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.DonateHistory.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.DonateHistory.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.DonateHistory.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      clantreasury_pb.History.Operation.serializeBinaryToWriter
    );
  }
  f = message.getNextPage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      clantreasury_pb.Operations.UserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated clantreasury.History.Operation operations = 1;
 * @return {!Array<!proto.clantreasury.History.Operation>}
 */
proto.public.clantreasury.DonateHistory.Response.prototype.getOperationsList = function() {
  return /** @type{!Array<!proto.clantreasury.History.Operation>} */ (
    jspb.Message.getRepeatedWrapperField(this, clantreasury_pb.History.Operation, 1));
};


/**
 * @param {!Array<!proto.clantreasury.History.Operation>} value
 * @return {!proto.public.clantreasury.DonateHistory.Response} returns this
*/
proto.public.clantreasury.DonateHistory.Response.prototype.setOperationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.clantreasury.History.Operation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clantreasury.History.Operation}
 */
proto.public.clantreasury.DonateHistory.Response.prototype.addOperations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.clantreasury.History.Operation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clantreasury.DonateHistory.Response} returns this
 */
proto.public.clantreasury.DonateHistory.Response.prototype.clearOperationsList = function() {
  return this.setOperationsList([]);
};


/**
 * optional string next_page = 2;
 * @return {string}
 */
proto.public.clantreasury.DonateHistory.Response.prototype.getNextPage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.clantreasury.DonateHistory.Response} returns this
 */
proto.public.clantreasury.DonateHistory.Response.prototype.setNextPage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated clantreasury.Operations.UserInfo users = 3;
 * @return {!Array<!proto.clantreasury.Operations.UserInfo>}
 */
proto.public.clantreasury.DonateHistory.Response.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.clantreasury.Operations.UserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, clantreasury_pb.Operations.UserInfo, 3));
};


/**
 * @param {!Array<!proto.clantreasury.Operations.UserInfo>} value
 * @return {!proto.public.clantreasury.DonateHistory.Response} returns this
*/
proto.public.clantreasury.DonateHistory.Response.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.clantreasury.Operations.UserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clantreasury.Operations.UserInfo}
 */
proto.public.clantreasury.DonateHistory.Response.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.clantreasury.Operations.UserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clantreasury.DonateHistory.Response} returns this
 */
proto.public.clantreasury.DonateHistory.Response.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.GetBalances.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.GetBalances.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.GetBalances} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.GetBalances}
 */
proto.public.clantreasury.GetBalances.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.GetBalances;
  return proto.public.clantreasury.GetBalances.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.GetBalances} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.GetBalances}
 */
proto.public.clantreasury.GetBalances.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.GetBalances.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.GetBalances.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.GetBalances} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.GetBalances.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.GetBalances.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.GetBalances.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: (f = msg.getFilter()) && proto.public.clantreasury.GetBalances.Filter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.GetBalances.Request}
 */
proto.public.clantreasury.GetBalances.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.GetBalances.Request;
  return proto.public.clantreasury.GetBalances.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.GetBalances.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.GetBalances.Request}
 */
proto.public.clantreasury.GetBalances.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.clantreasury.GetBalances.Filter;
      reader.readMessage(value,proto.public.clantreasury.GetBalances.Filter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.GetBalances.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.GetBalances.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.GetBalances.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.clantreasury.GetBalances.Filter.serializeBinaryToWriter
    );
  }
};


/**
 * optional Filter filter = 1;
 * @return {?proto.public.clantreasury.GetBalances.Filter}
 */
proto.public.clantreasury.GetBalances.Request.prototype.getFilter = function() {
  return /** @type{?proto.public.clantreasury.GetBalances.Filter} */ (
    jspb.Message.getWrapperField(this, proto.public.clantreasury.GetBalances.Filter, 1));
};


/**
 * @param {?proto.public.clantreasury.GetBalances.Filter|undefined} value
 * @return {!proto.public.clantreasury.GetBalances.Request} returns this
*/
proto.public.clantreasury.GetBalances.Request.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.GetBalances.Request} returns this
 */
proto.public.clantreasury.GetBalances.Request.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Request.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.clantreasury.GetBalances.Response.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.GetBalances.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.GetBalances.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.GetBalances.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    butter: (f = msg.getButter()) && clantreasury_pb.Balance.Butter.toObject(includeInstance, f),
    enrichedOrbs: (f = msg.getEnrichedOrbs()) && clantreasury_pb.Balance.EnrichedOrbs.toObject(includeInstance, f),
    gamedataItemsList: jspb.Message.toObjectList(msg.getGamedataItemsList(),
    clantreasury_pb.Balance.GamedataItem.toObject, includeInstance),
    mintableTokensList: jspb.Message.toObjectList(msg.getMintableTokensList(),
    clantreasury_pb.Balance.MintableToken.toObject, includeInstance),
    restrictions: (f = msg.getRestrictions()) && clantreasury_pb.Operations.Restrictions.toObject(includeInstance, f),
    userBalances: (f = msg.getUserBalances()) && proto.public.clantreasury.GetBalances.UserBalances.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.GetBalances.Response}
 */
proto.public.clantreasury.GetBalances.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.GetBalances.Response;
  return proto.public.clantreasury.GetBalances.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.GetBalances.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.GetBalances.Response}
 */
proto.public.clantreasury.GetBalances.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clantreasury_pb.Balance.Butter;
      reader.readMessage(value,clantreasury_pb.Balance.Butter.deserializeBinaryFromReader);
      msg.setButter(value);
      break;
    case 2:
      var value = new clantreasury_pb.Balance.EnrichedOrbs;
      reader.readMessage(value,clantreasury_pb.Balance.EnrichedOrbs.deserializeBinaryFromReader);
      msg.setEnrichedOrbs(value);
      break;
    case 3:
      var value = new clantreasury_pb.Balance.GamedataItem;
      reader.readMessage(value,clantreasury_pb.Balance.GamedataItem.deserializeBinaryFromReader);
      msg.addGamedataItems(value);
      break;
    case 4:
      var value = new clantreasury_pb.Balance.MintableToken;
      reader.readMessage(value,clantreasury_pb.Balance.MintableToken.deserializeBinaryFromReader);
      msg.addMintableTokens(value);
      break;
    case 5:
      var value = new clantreasury_pb.Operations.Restrictions;
      reader.readMessage(value,clantreasury_pb.Operations.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    case 6:
      var value = new proto.public.clantreasury.GetBalances.UserBalances;
      reader.readMessage(value,proto.public.clantreasury.GetBalances.UserBalances.deserializeBinaryFromReader);
      msg.setUserBalances(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.GetBalances.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.GetBalances.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.GetBalances.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getButter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clantreasury_pb.Balance.Butter.serializeBinaryToWriter
    );
  }
  f = message.getEnrichedOrbs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      clantreasury_pb.Balance.EnrichedOrbs.serializeBinaryToWriter
    );
  }
  f = message.getGamedataItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      clantreasury_pb.Balance.GamedataItem.serializeBinaryToWriter
    );
  }
  f = message.getMintableTokensList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      clantreasury_pb.Balance.MintableToken.serializeBinaryToWriter
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      clantreasury_pb.Operations.Restrictions.serializeBinaryToWriter
    );
  }
  f = message.getUserBalances();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.public.clantreasury.GetBalances.UserBalances.serializeBinaryToWriter
    );
  }
};


/**
 * optional clantreasury.Balance.Butter butter = 1;
 * @return {?proto.clantreasury.Balance.Butter}
 */
proto.public.clantreasury.GetBalances.Response.prototype.getButter = function() {
  return /** @type{?proto.clantreasury.Balance.Butter} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.Balance.Butter, 1));
};


/**
 * @param {?proto.clantreasury.Balance.Butter|undefined} value
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
*/
proto.public.clantreasury.GetBalances.Response.prototype.setButter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
 */
proto.public.clantreasury.GetBalances.Response.prototype.clearButter = function() {
  return this.setButter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Response.prototype.hasButter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional clantreasury.Balance.EnrichedOrbs enriched_orbs = 2;
 * @return {?proto.clantreasury.Balance.EnrichedOrbs}
 */
proto.public.clantreasury.GetBalances.Response.prototype.getEnrichedOrbs = function() {
  return /** @type{?proto.clantreasury.Balance.EnrichedOrbs} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.Balance.EnrichedOrbs, 2));
};


/**
 * @param {?proto.clantreasury.Balance.EnrichedOrbs|undefined} value
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
*/
proto.public.clantreasury.GetBalances.Response.prototype.setEnrichedOrbs = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
 */
proto.public.clantreasury.GetBalances.Response.prototype.clearEnrichedOrbs = function() {
  return this.setEnrichedOrbs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Response.prototype.hasEnrichedOrbs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated clantreasury.Balance.GamedataItem gamedata_items = 3;
 * @return {!Array<!proto.clantreasury.Balance.GamedataItem>}
 */
proto.public.clantreasury.GetBalances.Response.prototype.getGamedataItemsList = function() {
  return /** @type{!Array<!proto.clantreasury.Balance.GamedataItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, clantreasury_pb.Balance.GamedataItem, 3));
};


/**
 * @param {!Array<!proto.clantreasury.Balance.GamedataItem>} value
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
*/
proto.public.clantreasury.GetBalances.Response.prototype.setGamedataItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.clantreasury.Balance.GamedataItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clantreasury.Balance.GamedataItem}
 */
proto.public.clantreasury.GetBalances.Response.prototype.addGamedataItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.clantreasury.Balance.GamedataItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
 */
proto.public.clantreasury.GetBalances.Response.prototype.clearGamedataItemsList = function() {
  return this.setGamedataItemsList([]);
};


/**
 * repeated clantreasury.Balance.MintableToken mintable_tokens = 4;
 * @return {!Array<!proto.clantreasury.Balance.MintableToken>}
 */
proto.public.clantreasury.GetBalances.Response.prototype.getMintableTokensList = function() {
  return /** @type{!Array<!proto.clantreasury.Balance.MintableToken>} */ (
    jspb.Message.getRepeatedWrapperField(this, clantreasury_pb.Balance.MintableToken, 4));
};


/**
 * @param {!Array<!proto.clantreasury.Balance.MintableToken>} value
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
*/
proto.public.clantreasury.GetBalances.Response.prototype.setMintableTokensList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.clantreasury.Balance.MintableToken=} opt_value
 * @param {number=} opt_index
 * @return {!proto.clantreasury.Balance.MintableToken}
 */
proto.public.clantreasury.GetBalances.Response.prototype.addMintableTokens = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.clantreasury.Balance.MintableToken, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
 */
proto.public.clantreasury.GetBalances.Response.prototype.clearMintableTokensList = function() {
  return this.setMintableTokensList([]);
};


/**
 * optional clantreasury.Operations.Restrictions restrictions = 5;
 * @return {?proto.clantreasury.Operations.Restrictions}
 */
proto.public.clantreasury.GetBalances.Response.prototype.getRestrictions = function() {
  return /** @type{?proto.clantreasury.Operations.Restrictions} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.Operations.Restrictions, 5));
};


/**
 * @param {?proto.clantreasury.Operations.Restrictions|undefined} value
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
*/
proto.public.clantreasury.GetBalances.Response.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
 */
proto.public.clantreasury.GetBalances.Response.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Response.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional UserBalances user_balances = 6;
 * @return {?proto.public.clantreasury.GetBalances.UserBalances}
 */
proto.public.clantreasury.GetBalances.Response.prototype.getUserBalances = function() {
  return /** @type{?proto.public.clantreasury.GetBalances.UserBalances} */ (
    jspb.Message.getWrapperField(this, proto.public.clantreasury.GetBalances.UserBalances, 6));
};


/**
 * @param {?proto.public.clantreasury.GetBalances.UserBalances|undefined} value
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
*/
proto.public.clantreasury.GetBalances.Response.prototype.setUserBalances = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.GetBalances.Response} returns this
 */
proto.public.clantreasury.GetBalances.Response.prototype.clearUserBalances = function() {
  return this.setUserBalances(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Response.prototype.hasUserBalances = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.GetBalances.UserBalances.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.GetBalances.UserBalances.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.GetBalances.UserBalances} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.UserBalances.toObject = function(includeInstance, msg) {
  var f, obj = {
    enrichedOrbs: (f = msg.getEnrichedOrbs()) && clantreasury_pb.Balance.EnrichedOrbs.toObject(includeInstance, f),
    butter: (f = msg.getButter()) && clantreasury_pb.Balance.Butter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.GetBalances.UserBalances}
 */
proto.public.clantreasury.GetBalances.UserBalances.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.GetBalances.UserBalances;
  return proto.public.clantreasury.GetBalances.UserBalances.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.GetBalances.UserBalances} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.GetBalances.UserBalances}
 */
proto.public.clantreasury.GetBalances.UserBalances.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new clantreasury_pb.Balance.EnrichedOrbs;
      reader.readMessage(value,clantreasury_pb.Balance.EnrichedOrbs.deserializeBinaryFromReader);
      msg.setEnrichedOrbs(value);
      break;
    case 2:
      var value = new clantreasury_pb.Balance.Butter;
      reader.readMessage(value,clantreasury_pb.Balance.Butter.deserializeBinaryFromReader);
      msg.setButter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.GetBalances.UserBalances.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.GetBalances.UserBalances.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.GetBalances.UserBalances} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.UserBalances.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnrichedOrbs();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      clantreasury_pb.Balance.EnrichedOrbs.serializeBinaryToWriter
    );
  }
  f = message.getButter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      clantreasury_pb.Balance.Butter.serializeBinaryToWriter
    );
  }
};


/**
 * optional clantreasury.Balance.EnrichedOrbs enriched_orbs = 1;
 * @return {?proto.clantreasury.Balance.EnrichedOrbs}
 */
proto.public.clantreasury.GetBalances.UserBalances.prototype.getEnrichedOrbs = function() {
  return /** @type{?proto.clantreasury.Balance.EnrichedOrbs} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.Balance.EnrichedOrbs, 1));
};


/**
 * @param {?proto.clantreasury.Balance.EnrichedOrbs|undefined} value
 * @return {!proto.public.clantreasury.GetBalances.UserBalances} returns this
*/
proto.public.clantreasury.GetBalances.UserBalances.prototype.setEnrichedOrbs = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.GetBalances.UserBalances} returns this
 */
proto.public.clantreasury.GetBalances.UserBalances.prototype.clearEnrichedOrbs = function() {
  return this.setEnrichedOrbs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.UserBalances.prototype.hasEnrichedOrbs = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional clantreasury.Balance.Butter butter = 2;
 * @return {?proto.clantreasury.Balance.Butter}
 */
proto.public.clantreasury.GetBalances.UserBalances.prototype.getButter = function() {
  return /** @type{?proto.clantreasury.Balance.Butter} */ (
    jspb.Message.getWrapperField(this, clantreasury_pb.Balance.Butter, 2));
};


/**
 * @param {?proto.clantreasury.Balance.Butter|undefined} value
 * @return {!proto.public.clantreasury.GetBalances.UserBalances} returns this
*/
proto.public.clantreasury.GetBalances.UserBalances.prototype.setButter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.clantreasury.GetBalances.UserBalances} returns this
 */
proto.public.clantreasury.GetBalances.UserBalances.prototype.clearButter = function() {
  return this.setButter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.UserBalances.prototype.hasButter = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.public.clantreasury.GetBalances.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.clantreasury.GetBalances.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    butter: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    enrichedOrbs: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    gamedataItems: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    mintableTokens: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    currency: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    inventory: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    userEnrichedOrbs: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    userButter: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.clantreasury.GetBalances.Filter}
 */
proto.public.clantreasury.GetBalances.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.clantreasury.GetBalances.Filter;
  return proto.public.clantreasury.GetBalances.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.clantreasury.GetBalances.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.clantreasury.GetBalances.Filter}
 */
proto.public.clantreasury.GetBalances.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setButter(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnrichedOrbs(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGamedataItems(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMintableTokens(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInventory(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserEnrichedOrbs(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserButter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.clantreasury.GetBalances.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.clantreasury.GetBalances.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.clantreasury.GetBalances.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getButter();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getEnrichedOrbs();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getGamedataItems();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMintableTokens();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCurrency();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getInventory();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getUserEnrichedOrbs();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getUserButter();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional bool butter = 1;
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.getButter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clantreasury.GetBalances.Filter} returns this
 */
proto.public.clantreasury.GetBalances.Filter.prototype.setButter = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool enriched_orbs = 2;
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.getEnrichedOrbs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clantreasury.GetBalances.Filter} returns this
 */
proto.public.clantreasury.GetBalances.Filter.prototype.setEnrichedOrbs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool gamedata_items = 3;
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.getGamedataItems = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clantreasury.GetBalances.Filter} returns this
 */
proto.public.clantreasury.GetBalances.Filter.prototype.setGamedataItems = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool mintable_tokens = 4;
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.getMintableTokens = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clantreasury.GetBalances.Filter} returns this
 */
proto.public.clantreasury.GetBalances.Filter.prototype.setMintableTokens = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool currency = 5;
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.getCurrency = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clantreasury.GetBalances.Filter} returns this
 */
proto.public.clantreasury.GetBalances.Filter.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool inventory = 6;
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.getInventory = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clantreasury.GetBalances.Filter} returns this
 */
proto.public.clantreasury.GetBalances.Filter.prototype.setInventory = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool user_enriched_orbs = 7;
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.getUserEnrichedOrbs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clantreasury.GetBalances.Filter} returns this
 */
proto.public.clantreasury.GetBalances.Filter.prototype.setUserEnrichedOrbs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool user_butter = 8;
 * @return {boolean}
 */
proto.public.clantreasury.GetBalances.Filter.prototype.getUserButter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.clantreasury.GetBalances.Filter} returns this
 */
proto.public.clantreasury.GetBalances.Filter.prototype.setUserButter = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


goog.object.extend(exports, proto.public.clantreasury);

},{"../clantreasury_pb.js":24,"../validate/validate_pb.js":27,"google-protobuf":3,"google-protobuf/google/protobuf/duration_pb.js":4,"google-protobuf/google/protobuf/timestamp_pb.js":6}],27:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],28:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for discord
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('./validate/validate_pb.js')

var shared_pb = require('./shared_pb.js')
const proto = {};
proto.discord = require('./public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.discord.PublicClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.discord.PublicPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.discord.GetAccount.Request,
 *   !proto.discord.GetAccount.Response>}
 */
const methodDescriptor_Public_GetAccount = new grpc.web.MethodDescriptor(
  '/discord.Public/GetAccount',
  grpc.web.MethodType.UNARY,
  proto.discord.GetAccount.Request,
  proto.discord.GetAccount.Response,
  /**
   * @param {!proto.discord.GetAccount.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.discord.GetAccount.Response.deserializeBinary
);


/**
 * @param {!proto.discord.GetAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.discord.GetAccount.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.discord.GetAccount.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.discord.PublicClient.prototype.getAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/discord.Public/GetAccount',
      request,
      metadata || {},
      methodDescriptor_Public_GetAccount,
      callback);
};


/**
 * @param {!proto.discord.GetAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.discord.GetAccount.Response>}
 *     Promise that resolves to the response
 */
proto.discord.PublicPromiseClient.prototype.getAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/discord.Public/GetAccount',
      request,
      metadata || {},
      methodDescriptor_Public_GetAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.discord.Link.Request,
 *   !proto.discord.Link.Response>}
 */
const methodDescriptor_Public_Link = new grpc.web.MethodDescriptor(
  '/discord.Public/Link',
  grpc.web.MethodType.UNARY,
  proto.discord.Link.Request,
  proto.discord.Link.Response,
  /**
   * @param {!proto.discord.Link.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.discord.Link.Response.deserializeBinary
);


/**
 * @param {!proto.discord.Link.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.discord.Link.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.discord.Link.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.discord.PublicClient.prototype.link =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/discord.Public/Link',
      request,
      metadata || {},
      methodDescriptor_Public_Link,
      callback);
};


/**
 * @param {!proto.discord.Link.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.discord.Link.Response>}
 *     Promise that resolves to the response
 */
proto.discord.PublicPromiseClient.prototype.link =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/discord.Public/Link',
      request,
      metadata || {},
      methodDescriptor_Public_Link);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.discord.Unlink.Request,
 *   !proto.discord.Unlink.Response>}
 */
const methodDescriptor_Public_Unlink = new grpc.web.MethodDescriptor(
  '/discord.Public/Unlink',
  grpc.web.MethodType.UNARY,
  proto.discord.Unlink.Request,
  proto.discord.Unlink.Response,
  /**
   * @param {!proto.discord.Unlink.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.discord.Unlink.Response.deserializeBinary
);


/**
 * @param {!proto.discord.Unlink.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.discord.Unlink.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.discord.Unlink.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.discord.PublicClient.prototype.unlink =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/discord.Public/Unlink',
      request,
      metadata || {},
      methodDescriptor_Public_Unlink,
      callback);
};


/**
 * @param {!proto.discord.Unlink.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.discord.Unlink.Response>}
 *     Promise that resolves to the response
 */
proto.discord.PublicPromiseClient.prototype.unlink =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/discord.Public/Unlink',
      request,
      metadata || {},
      methodDescriptor_Public_Unlink);
};


module.exports = proto.discord;


},{"./public_pb.js":29,"./shared_pb.js":30,"./validate/validate_pb.js":31,"grpc-web":7}],29:[function(require,module,exports){
// source: public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var shared_pb = require('./shared_pb.js');
goog.object.extend(proto, shared_pb);
goog.exportSymbol('proto.discord.GetAccount', null, global);
goog.exportSymbol('proto.discord.GetAccount.Request', null, global);
goog.exportSymbol('proto.discord.GetAccount.Response', null, global);
goog.exportSymbol('proto.discord.Link', null, global);
goog.exportSymbol('proto.discord.Link.Request', null, global);
goog.exportSymbol('proto.discord.Link.Response', null, global);
goog.exportSymbol('proto.discord.Unlink', null, global);
goog.exportSymbol('proto.discord.Unlink.Request', null, global);
goog.exportSymbol('proto.discord.Unlink.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.GetAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.GetAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.GetAccount.displayName = 'proto.discord.GetAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.GetAccount.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.GetAccount.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.GetAccount.Request.displayName = 'proto.discord.GetAccount.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.GetAccount.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.GetAccount.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.GetAccount.Response.displayName = 'proto.discord.GetAccount.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.Link = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.Link, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.Link.displayName = 'proto.discord.Link';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.Link.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.Link.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.Link.Request.displayName = 'proto.discord.Link.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.Link.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.Link.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.Link.Response.displayName = 'proto.discord.Link.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.Unlink = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.Unlink, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.Unlink.displayName = 'proto.discord.Unlink';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.Unlink.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.Unlink.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.Unlink.Request.displayName = 'proto.discord.Unlink.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.Unlink.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.Unlink.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.Unlink.Response.displayName = 'proto.discord.Unlink.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.GetAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.GetAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.GetAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.GetAccount.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.GetAccount}
 */
proto.discord.GetAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.GetAccount;
  return proto.discord.GetAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.GetAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.GetAccount}
 */
proto.discord.GetAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.GetAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.GetAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.GetAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.GetAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.GetAccount.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.GetAccount.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.GetAccount.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.GetAccount.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.GetAccount.Request}
 */
proto.discord.GetAccount.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.GetAccount.Request;
  return proto.discord.GetAccount.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.GetAccount.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.GetAccount.Request}
 */
proto.discord.GetAccount.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.GetAccount.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.GetAccount.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.GetAccount.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.GetAccount.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.GetAccount.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.GetAccount.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.GetAccount.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.GetAccount.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && shared_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.GetAccount.Response}
 */
proto.discord.GetAccount.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.GetAccount.Response;
  return proto.discord.GetAccount.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.GetAccount.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.GetAccount.Response}
 */
proto.discord.GetAccount.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_pb.User;
      reader.readMessage(value,shared_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.GetAccount.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.GetAccount.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.GetAccount.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.GetAccount.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional User user = 1;
 * @return {?proto.discord.User}
 */
proto.discord.GetAccount.Response.prototype.getUser = function() {
  return /** @type{?proto.discord.User} */ (
    jspb.Message.getWrapperField(this, shared_pb.User, 1));
};


/**
 * @param {?proto.discord.User|undefined} value
 * @return {!proto.discord.GetAccount.Response} returns this
*/
proto.discord.GetAccount.Response.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.discord.GetAccount.Response} returns this
 */
proto.discord.GetAccount.Response.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.discord.GetAccount.Response.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.Link.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.Link.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.Link} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Link.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.Link}
 */
proto.discord.Link.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.Link;
  return proto.discord.Link.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.Link} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.Link}
 */
proto.discord.Link.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.Link.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.Link.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.Link} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Link.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.Link.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.Link.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.Link.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Link.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    authCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.Link.Request}
 */
proto.discord.Link.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.Link.Request;
  return proto.discord.Link.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.Link.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.Link.Request}
 */
proto.discord.Link.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.Link.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.Link.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.Link.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Link.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string auth_code = 1;
 * @return {string}
 */
proto.discord.Link.Request.prototype.getAuthCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.discord.Link.Request} returns this
 */
proto.discord.Link.Request.prototype.setAuthCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.Link.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.Link.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.Link.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Link.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && shared_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.Link.Response}
 */
proto.discord.Link.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.Link.Response;
  return proto.discord.Link.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.Link.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.Link.Response}
 */
proto.discord.Link.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_pb.User;
      reader.readMessage(value,shared_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.Link.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.Link.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.Link.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Link.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional User user = 1;
 * @return {?proto.discord.User}
 */
proto.discord.Link.Response.prototype.getUser = function() {
  return /** @type{?proto.discord.User} */ (
    jspb.Message.getWrapperField(this, shared_pb.User, 1));
};


/**
 * @param {?proto.discord.User|undefined} value
 * @return {!proto.discord.Link.Response} returns this
*/
proto.discord.Link.Response.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.discord.Link.Response} returns this
 */
proto.discord.Link.Response.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.discord.Link.Response.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.Unlink.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.Unlink.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.Unlink} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Unlink.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.Unlink}
 */
proto.discord.Unlink.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.Unlink;
  return proto.discord.Unlink.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.Unlink} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.Unlink}
 */
proto.discord.Unlink.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.Unlink.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.Unlink.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.Unlink} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Unlink.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.Unlink.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.Unlink.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.Unlink.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Unlink.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.Unlink.Request}
 */
proto.discord.Unlink.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.Unlink.Request;
  return proto.discord.Unlink.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.Unlink.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.Unlink.Request}
 */
proto.discord.Unlink.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.Unlink.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.Unlink.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.Unlink.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Unlink.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.Unlink.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.Unlink.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.Unlink.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Unlink.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.Unlink.Response}
 */
proto.discord.Unlink.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.Unlink.Response;
  return proto.discord.Unlink.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.Unlink.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.Unlink.Response}
 */
proto.discord.Unlink.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.Unlink.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.Unlink.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.Unlink.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.Unlink.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.discord);

},{"./shared_pb.js":30,"./validate/validate_pb.js":31,"google-protobuf":3}],30:[function(require,module,exports){
// source: shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.discord.User', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.discord.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.discord.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.discord.User.displayName = 'proto.discord.User';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.discord.User.prototype.toObject = function(opt_includeInstance) {
  return proto.discord.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.discord.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 2, ""),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 3, ""),
    discordId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    userhash: jspb.Message.getFieldWithDefault(msg, 6, ""),
    locale: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.discord.User}
 */
proto.discord.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.discord.User;
  return proto.discord.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.discord.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.discord.User}
 */
proto.discord.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscordId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserhash(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.discord.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.discord.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.discord.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.discord.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDiscordId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserhash();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.discord.User.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.discord.User} returns this
 */
proto.discord.User.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string created_at = 2;
 * @return {string}
 */
proto.discord.User.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.discord.User} returns this
 */
proto.discord.User.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string updated_at = 3;
 * @return {string}
 */
proto.discord.User.prototype.getUpdatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.discord.User} returns this
 */
proto.discord.User.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string discord_id = 4;
 * @return {string}
 */
proto.discord.User.prototype.getDiscordId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.discord.User} returns this
 */
proto.discord.User.prototype.setDiscordId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string username = 5;
 * @return {string}
 */
proto.discord.User.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.discord.User} returns this
 */
proto.discord.User.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string userhash = 6;
 * @return {string}
 */
proto.discord.User.prototype.getUserhash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.discord.User} returns this
 */
proto.discord.User.prototype.setUserhash = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string locale = 7;
 * @return {string}
 */
proto.discord.User.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.discord.User} returns this
 */
proto.discord.User.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


goog.object.extend(exports, proto.discord);

},{"google-protobuf":3}],31:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],32:[function(require,module,exports){
// source: economy.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.economy.UUID', null, global);
goog.exportSymbol('proto.economy.Variable', null, global);
goog.exportSymbol('proto.economy.Variable.Spec', null, global);
goog.exportSymbol('proto.economy.Variable.Type', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.economy.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.economy.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.economy.UUID.displayName = 'proto.economy.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.economy.Variable = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.economy.Variable, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.economy.Variable.displayName = 'proto.economy.Variable';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.economy.Variable.Spec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.economy.Variable.Spec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.economy.Variable.Spec.displayName = 'proto.economy.Variable.Spec';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.economy.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.economy.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.economy.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.economy.UUID}
 */
proto.economy.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.economy.UUID;
  return proto.economy.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.economy.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.economy.UUID}
 */
proto.economy.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.economy.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.economy.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.economy.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.economy.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.economy.UUID} returns this
 */
proto.economy.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.economy.Variable.prototype.toObject = function(opt_includeInstance) {
  return proto.economy.Variable.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.economy.Variable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.Variable.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.economy.UUID.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    spec: (f = msg.getSpec()) && proto.economy.Variable.Spec.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.economy.Variable}
 */
proto.economy.Variable.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.economy.Variable;
  return proto.economy.Variable.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.economy.Variable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.economy.Variable}
 */
proto.economy.Variable.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.economy.UUID;
      reader.readMessage(value,proto.economy.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.economy.Variable.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 5:
      var value = new proto.economy.Variable.Spec;
      reader.readMessage(value,proto.economy.Variable.Spec.deserializeBinaryFromReader);
      msg.setSpec(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.economy.Variable.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.economy.Variable.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.economy.Variable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.Variable.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.economy.UUID.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getSpec();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.economy.Variable.Spec.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.economy.Variable.Type = {
  UNDEFINED: 0,
  BATTLE_PASS_POINTS_FACTOR: 1
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.economy.Variable.Spec.prototype.toObject = function(opt_includeInstance) {
  return proto.economy.Variable.Spec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.economy.Variable.Spec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.Variable.Spec.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    desc: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.economy.Variable.Spec}
 */
proto.economy.Variable.Spec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.economy.Variable.Spec;
  return proto.economy.Variable.Spec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.economy.Variable.Spec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.economy.Variable.Spec}
 */
proto.economy.Variable.Spec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.economy.Variable.Spec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.economy.Variable.Spec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.economy.Variable.Spec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.Variable.Spec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDesc();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.economy.Variable.Spec.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.economy.Variable.Spec} returns this
 */
proto.economy.Variable.Spec.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string desc = 2;
 * @return {string}
 */
proto.economy.Variable.Spec.prototype.getDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.economy.Variable.Spec} returns this
 */
proto.economy.Variable.Spec.prototype.setDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional UUID id = 1;
 * @return {?proto.economy.UUID}
 */
proto.economy.Variable.prototype.getId = function() {
  return /** @type{?proto.economy.UUID} */ (
    jspb.Message.getWrapperField(this, proto.economy.UUID, 1));
};


/**
 * @param {?proto.economy.UUID|undefined} value
 * @return {!proto.economy.Variable} returns this
*/
proto.economy.Variable.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.economy.Variable} returns this
 */
proto.economy.Variable.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.economy.Variable.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Type type = 2;
 * @return {!proto.economy.Variable.Type}
 */
proto.economy.Variable.prototype.getType = function() {
  return /** @type {!proto.economy.Variable.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.economy.Variable.Type} value
 * @return {!proto.economy.Variable} returns this
 */
proto.economy.Variable.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.economy.Variable.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.economy.Variable} returns this
 */
proto.economy.Variable.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double value = 4;
 * @return {number}
 */
proto.economy.Variable.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.economy.Variable} returns this
 */
proto.economy.Variable.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional Spec spec = 5;
 * @return {?proto.economy.Variable.Spec}
 */
proto.economy.Variable.prototype.getSpec = function() {
  return /** @type{?proto.economy.Variable.Spec} */ (
    jspb.Message.getWrapperField(this, proto.economy.Variable.Spec, 5));
};


/**
 * @param {?proto.economy.Variable.Spec|undefined} value
 * @return {!proto.economy.Variable} returns this
*/
proto.economy.Variable.prototype.setSpec = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.economy.Variable} returns this
 */
proto.economy.Variable.prototype.clearSpec = function() {
  return this.setSpec(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.economy.Variable.prototype.hasSpec = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.economy);

},{"./validate/validate_pb.js":33,"google-protobuf":3}],33:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],34:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for economy.web
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var economy_shared_pb = require('../economy.shared_pb.js')
const proto = {};
proto.economy = {};
proto.economy.web = require('./economy_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.economy.web.UserClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.economy.web.UserPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.economy.web.GetVariables.Request,
 *   !proto.economy.web.GetVariables.Response>}
 */
const methodDescriptor_User_GetVariables = new grpc.web.MethodDescriptor(
  '/economy.web.User/GetVariables',
  grpc.web.MethodType.UNARY,
  proto.economy.web.GetVariables.Request,
  proto.economy.web.GetVariables.Response,
  /**
   * @param {!proto.economy.web.GetVariables.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.economy.web.GetVariables.Response.deserializeBinary
);


/**
 * @param {!proto.economy.web.GetVariables.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.economy.web.GetVariables.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.economy.web.GetVariables.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.economy.web.UserClient.prototype.getVariables =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/economy.web.User/GetVariables',
      request,
      metadata || {},
      methodDescriptor_User_GetVariables,
      callback);
};


/**
 * @param {!proto.economy.web.GetVariables.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.economy.web.GetVariables.Response>}
 *     Promise that resolves to the response
 */
proto.economy.web.UserPromiseClient.prototype.getVariables =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/economy.web.User/GetVariables',
      request,
      metadata || {},
      methodDescriptor_User_GetVariables);
};


module.exports = proto.economy.web;


},{"../economy.shared_pb.js":32,"./economy_pb.js":35,"grpc-web":7}],35:[function(require,module,exports){
// source: web/economy.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var economy_shared_pb = require('../economy.shared_pb.js');
goog.object.extend(proto, economy_shared_pb);
goog.exportSymbol('proto.economy.web.GetVariables', null, global);
goog.exportSymbol('proto.economy.web.GetVariables.Request', null, global);
goog.exportSymbol('proto.economy.web.GetVariables.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.economy.web.GetVariables = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.economy.web.GetVariables, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.economy.web.GetVariables.displayName = 'proto.economy.web.GetVariables';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.economy.web.GetVariables.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.economy.web.GetVariables.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.economy.web.GetVariables.Request.displayName = 'proto.economy.web.GetVariables.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.economy.web.GetVariables.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.economy.web.GetVariables.Response.repeatedFields_, null);
};
goog.inherits(proto.economy.web.GetVariables.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.economy.web.GetVariables.Response.displayName = 'proto.economy.web.GetVariables.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.economy.web.GetVariables.prototype.toObject = function(opt_includeInstance) {
  return proto.economy.web.GetVariables.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.economy.web.GetVariables} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.web.GetVariables.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.economy.web.GetVariables}
 */
proto.economy.web.GetVariables.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.economy.web.GetVariables;
  return proto.economy.web.GetVariables.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.economy.web.GetVariables} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.economy.web.GetVariables}
 */
proto.economy.web.GetVariables.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.economy.web.GetVariables.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.economy.web.GetVariables.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.economy.web.GetVariables} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.web.GetVariables.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.economy.web.GetVariables.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.economy.web.GetVariables.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.economy.web.GetVariables.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.web.GetVariables.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.economy.web.GetVariables.Request}
 */
proto.economy.web.GetVariables.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.economy.web.GetVariables.Request;
  return proto.economy.web.GetVariables.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.economy.web.GetVariables.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.economy.web.GetVariables.Request}
 */
proto.economy.web.GetVariables.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.economy.web.GetVariables.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.economy.web.GetVariables.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.economy.web.GetVariables.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.web.GetVariables.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.economy.web.GetVariables.Response.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.economy.web.GetVariables.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.economy.web.GetVariables.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.economy.web.GetVariables.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.web.GetVariables.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    varsList: jspb.Message.toObjectList(msg.getVarsList(),
    economy_shared_pb.Variable.toObject, includeInstance),
    enabledList: jspb.Message.toObjectList(msg.getEnabledList(),
    economy_shared_pb.UUID.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.economy.web.GetVariables.Response}
 */
proto.economy.web.GetVariables.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.economy.web.GetVariables.Response;
  return proto.economy.web.GetVariables.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.economy.web.GetVariables.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.economy.web.GetVariables.Response}
 */
proto.economy.web.GetVariables.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new economy_shared_pb.Variable;
      reader.readMessage(value,economy_shared_pb.Variable.deserializeBinaryFromReader);
      msg.addVars(value);
      break;
    case 2:
      var value = new economy_shared_pb.UUID;
      reader.readMessage(value,economy_shared_pb.UUID.deserializeBinaryFromReader);
      msg.addEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.economy.web.GetVariables.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.economy.web.GetVariables.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.economy.web.GetVariables.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.economy.web.GetVariables.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVarsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      economy_shared_pb.Variable.serializeBinaryToWriter
    );
  }
  f = message.getEnabledList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      economy_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * repeated economy.Variable vars = 1;
 * @return {!Array<!proto.economy.Variable>}
 */
proto.economy.web.GetVariables.Response.prototype.getVarsList = function() {
  return /** @type{!Array<!proto.economy.Variable>} */ (
    jspb.Message.getRepeatedWrapperField(this, economy_shared_pb.Variable, 1));
};


/**
 * @param {!Array<!proto.economy.Variable>} value
 * @return {!proto.economy.web.GetVariables.Response} returns this
*/
proto.economy.web.GetVariables.Response.prototype.setVarsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.economy.Variable=} opt_value
 * @param {number=} opt_index
 * @return {!proto.economy.Variable}
 */
proto.economy.web.GetVariables.Response.prototype.addVars = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.economy.Variable, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.economy.web.GetVariables.Response} returns this
 */
proto.economy.web.GetVariables.Response.prototype.clearVarsList = function() {
  return this.setVarsList([]);
};


/**
 * repeated economy.UUID enabled = 2;
 * @return {!Array<!proto.economy.UUID>}
 */
proto.economy.web.GetVariables.Response.prototype.getEnabledList = function() {
  return /** @type{!Array<!proto.economy.UUID>} */ (
    jspb.Message.getRepeatedWrapperField(this, economy_shared_pb.UUID, 2));
};


/**
 * @param {!Array<!proto.economy.UUID>} value
 * @return {!proto.economy.web.GetVariables.Response} returns this
*/
proto.economy.web.GetVariables.Response.prototype.setEnabledList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.economy.UUID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.economy.UUID}
 */
proto.economy.web.GetVariables.Response.prototype.addEnabled = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.economy.UUID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.economy.web.GetVariables.Response} returns this
 */
proto.economy.web.GetVariables.Response.prototype.clearEnabledList = function() {
  return this.setEnabledList([]);
};


goog.object.extend(exports, proto.economy.web);

},{"../economy.shared_pb.js":32,"google-protobuf":3}],36:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for fflags.public
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.fflags = {};
proto.fflags.public = require('./feature-flags_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fflags.public.FeatureFlagsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fflags.public.FeatureFlagsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fflags.public.Empty,
 *   !proto.fflags.public.GetUserFeatures.Response>}
 */
const methodDescriptor_FeatureFlags_GetUserFeatures = new grpc.web.MethodDescriptor(
  '/fflags.public.FeatureFlags/GetUserFeatures',
  grpc.web.MethodType.UNARY,
  proto.fflags.public.Empty,
  proto.fflags.public.GetUserFeatures.Response,
  /**
   * @param {!proto.fflags.public.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fflags.public.GetUserFeatures.Response.deserializeBinary
);


/**
 * @param {!proto.fflags.public.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fflags.public.GetUserFeatures.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fflags.public.GetUserFeatures.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fflags.public.FeatureFlagsClient.prototype.getUserFeatures =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fflags.public.FeatureFlags/GetUserFeatures',
      request,
      metadata || {},
      methodDescriptor_FeatureFlags_GetUserFeatures,
      callback);
};


/**
 * @param {!proto.fflags.public.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fflags.public.GetUserFeatures.Response>}
 *     Promise that resolves to the response
 */
proto.fflags.public.FeatureFlagsPromiseClient.prototype.getUserFeatures =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fflags.public.FeatureFlags/GetUserFeatures',
      request,
      metadata || {},
      methodDescriptor_FeatureFlags_GetUserFeatures);
};


module.exports = proto.fflags.public;


},{"./feature-flags_pb.js":37,"grpc-web":7}],37:[function(require,module,exports){
// source: public/feature-flags.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.fflags.public.Empty', null, global);
goog.exportSymbol('proto.fflags.public.Feature', null, global);
goog.exportSymbol('proto.fflags.public.GetUserFeatures', null, global);
goog.exportSymbol('proto.fflags.public.GetUserFeatures.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fflags.public.GetUserFeatures = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fflags.public.GetUserFeatures, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fflags.public.GetUserFeatures.displayName = 'proto.fflags.public.GetUserFeatures';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fflags.public.GetUserFeatures.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fflags.public.GetUserFeatures.Response.repeatedFields_, null);
};
goog.inherits(proto.fflags.public.GetUserFeatures.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fflags.public.GetUserFeatures.Response.displayName = 'proto.fflags.public.GetUserFeatures.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fflags.public.Feature = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fflags.public.Feature, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fflags.public.Feature.displayName = 'proto.fflags.public.Feature';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fflags.public.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fflags.public.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fflags.public.Empty.displayName = 'proto.fflags.public.Empty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fflags.public.GetUserFeatures.prototype.toObject = function(opt_includeInstance) {
  return proto.fflags.public.GetUserFeatures.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fflags.public.GetUserFeatures} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fflags.public.GetUserFeatures.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fflags.public.GetUserFeatures}
 */
proto.fflags.public.GetUserFeatures.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fflags.public.GetUserFeatures;
  return proto.fflags.public.GetUserFeatures.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fflags.public.GetUserFeatures} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fflags.public.GetUserFeatures}
 */
proto.fflags.public.GetUserFeatures.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fflags.public.GetUserFeatures.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fflags.public.GetUserFeatures.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fflags.public.GetUserFeatures} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fflags.public.GetUserFeatures.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fflags.public.GetUserFeatures.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fflags.public.GetUserFeatures.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fflags.public.GetUserFeatures.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fflags.public.GetUserFeatures.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fflags.public.GetUserFeatures.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    featuresList: jspb.Message.toObjectList(msg.getFeaturesList(),
    proto.fflags.public.Feature.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fflags.public.GetUserFeatures.Response}
 */
proto.fflags.public.GetUserFeatures.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fflags.public.GetUserFeatures.Response;
  return proto.fflags.public.GetUserFeatures.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fflags.public.GetUserFeatures.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fflags.public.GetUserFeatures.Response}
 */
proto.fflags.public.GetUserFeatures.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fflags.public.Feature;
      reader.readMessage(value,proto.fflags.public.Feature.deserializeBinaryFromReader);
      msg.addFeatures(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fflags.public.GetUserFeatures.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fflags.public.GetUserFeatures.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fflags.public.GetUserFeatures.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fflags.public.GetUserFeatures.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fflags.public.Feature.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Feature features = 1;
 * @return {!Array<!proto.fflags.public.Feature>}
 */
proto.fflags.public.GetUserFeatures.Response.prototype.getFeaturesList = function() {
  return /** @type{!Array<!proto.fflags.public.Feature>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fflags.public.Feature, 1));
};


/**
 * @param {!Array<!proto.fflags.public.Feature>} value
 * @return {!proto.fflags.public.GetUserFeatures.Response} returns this
*/
proto.fflags.public.GetUserFeatures.Response.prototype.setFeaturesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fflags.public.Feature=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fflags.public.Feature}
 */
proto.fflags.public.GetUserFeatures.Response.prototype.addFeatures = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fflags.public.Feature, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fflags.public.GetUserFeatures.Response} returns this
 */
proto.fflags.public.GetUserFeatures.Response.prototype.clearFeaturesList = function() {
  return this.setFeaturesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fflags.public.Feature.prototype.toObject = function(opt_includeInstance) {
  return proto.fflags.public.Feature.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fflags.public.Feature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fflags.public.Feature.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paramsMap: (f = msg.getParamsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fflags.public.Feature}
 */
proto.fflags.public.Feature.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fflags.public.Feature;
  return proto.fflags.public.Feature.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fflags.public.Feature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fflags.public.Feature}
 */
proto.fflags.public.Feature.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = msg.getParamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fflags.public.Feature.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fflags.public.Feature.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fflags.public.Feature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fflags.public.Feature.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.fflags.public.Feature.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fflags.public.Feature} returns this
 */
proto.fflags.public.Feature.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, string> params = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.fflags.public.Feature.prototype.getParamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.fflags.public.Feature} returns this
 */
proto.fflags.public.Feature.prototype.clearParamsMap = function() {
  this.getParamsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fflags.public.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.fflags.public.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fflags.public.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fflags.public.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fflags.public.Empty}
 */
proto.fflags.public.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fflags.public.Empty;
  return proto.fflags.public.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fflags.public.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fflags.public.Empty}
 */
proto.fflags.public.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fflags.public.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fflags.public.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fflags.public.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fflags.public.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.fflags.public);

},{"google-protobuf":3}],38:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for public.friends
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')
const proto = {};
proto.public = {};
proto.public.friends = require('./service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.friends.ConnectionsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.friends.ConnectionsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.friends.GetOverview.Request,
 *   !proto.public.friends.GetOverview.Response>}
 */
const methodDescriptor_Connections_GetOverview = new grpc.web.MethodDescriptor(
  '/public.friends.Connections/GetOverview',
  grpc.web.MethodType.UNARY,
  proto.public.friends.GetOverview.Request,
  proto.public.friends.GetOverview.Response,
  /**
   * @param {!proto.public.friends.GetOverview.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.friends.GetOverview.Response.deserializeBinary
);


/**
 * @param {!proto.public.friends.GetOverview.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.friends.GetOverview.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.friends.GetOverview.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.friends.ConnectionsClient.prototype.getOverview =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.friends.Connections/GetOverview',
      request,
      metadata || {},
      methodDescriptor_Connections_GetOverview,
      callback);
};


/**
 * @param {!proto.public.friends.GetOverview.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.friends.GetOverview.Response>}
 *     Promise that resolves to the response
 */
proto.public.friends.ConnectionsPromiseClient.prototype.getOverview =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.friends.Connections/GetOverview',
      request,
      metadata || {},
      methodDescriptor_Connections_GetOverview);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.friends.ListConnections.Request,
 *   !proto.public.friends.ListConnections.Response>}
 */
const methodDescriptor_Connections_List = new grpc.web.MethodDescriptor(
  '/public.friends.Connections/List',
  grpc.web.MethodType.UNARY,
  proto.public.friends.ListConnections.Request,
  proto.public.friends.ListConnections.Response,
  /**
   * @param {!proto.public.friends.ListConnections.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.friends.ListConnections.Response.deserializeBinary
);


/**
 * @param {!proto.public.friends.ListConnections.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.friends.ListConnections.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.friends.ListConnections.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.friends.ConnectionsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.friends.Connections/List',
      request,
      metadata || {},
      methodDescriptor_Connections_List,
      callback);
};


/**
 * @param {!proto.public.friends.ListConnections.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.friends.ListConnections.Response>}
 *     Promise that resolves to the response
 */
proto.public.friends.ConnectionsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.friends.Connections/List',
      request,
      metadata || {},
      methodDescriptor_Connections_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.friends.AddConnection.Request,
 *   !proto.public.friends.AddConnection.Response>}
 */
const methodDescriptor_Connections_Add = new grpc.web.MethodDescriptor(
  '/public.friends.Connections/Add',
  grpc.web.MethodType.UNARY,
  proto.public.friends.AddConnection.Request,
  proto.public.friends.AddConnection.Response,
  /**
   * @param {!proto.public.friends.AddConnection.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.friends.AddConnection.Response.deserializeBinary
);


/**
 * @param {!proto.public.friends.AddConnection.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.friends.AddConnection.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.friends.AddConnection.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.friends.ConnectionsClient.prototype.add =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.friends.Connections/Add',
      request,
      metadata || {},
      methodDescriptor_Connections_Add,
      callback);
};


/**
 * @param {!proto.public.friends.AddConnection.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.friends.AddConnection.Response>}
 *     Promise that resolves to the response
 */
proto.public.friends.ConnectionsPromiseClient.prototype.add =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.friends.Connections/Add',
      request,
      metadata || {},
      methodDescriptor_Connections_Add);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.friends.RemoveConnection.Request,
 *   !proto.public.friends.RemoveConnection.Response>}
 */
const methodDescriptor_Connections_Remove = new grpc.web.MethodDescriptor(
  '/public.friends.Connections/Remove',
  grpc.web.MethodType.UNARY,
  proto.public.friends.RemoveConnection.Request,
  proto.public.friends.RemoveConnection.Response,
  /**
   * @param {!proto.public.friends.RemoveConnection.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.friends.RemoveConnection.Response.deserializeBinary
);


/**
 * @param {!proto.public.friends.RemoveConnection.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.friends.RemoveConnection.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.friends.RemoveConnection.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.friends.ConnectionsClient.prototype.remove =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.friends.Connections/Remove',
      request,
      metadata || {},
      methodDescriptor_Connections_Remove,
      callback);
};


/**
 * @param {!proto.public.friends.RemoveConnection.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.friends.RemoveConnection.Response>}
 *     Promise that resolves to the response
 */
proto.public.friends.ConnectionsPromiseClient.prototype.remove =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.friends.Connections/Remove',
      request,
      metadata || {},
      methodDescriptor_Connections_Remove);
};


module.exports = proto.public.friends;


},{"../validate/validate_pb.js":40,"./service_pb.js":39,"grpc-web":7}],39:[function(require,module,exports){
// source: public/service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.public.friends.AddConnection', null, global);
goog.exportSymbol('proto.public.friends.AddConnection.Request', null, global);
goog.exportSymbol('proto.public.friends.AddConnection.Request.ByCase', null, global);
goog.exportSymbol('proto.public.friends.AddConnection.Response', null, global);
goog.exportSymbol('proto.public.friends.FollowingStatus', null, global);
goog.exportSymbol('proto.public.friends.GetOverview', null, global);
goog.exportSymbol('proto.public.friends.GetOverview.Request', null, global);
goog.exportSymbol('proto.public.friends.GetOverview.Response', null, global);
goog.exportSymbol('proto.public.friends.IDP', null, global);
goog.exportSymbol('proto.public.friends.IDP.Ident', null, global);
goog.exportSymbol('proto.public.friends.ListConnections', null, global);
goog.exportSymbol('proto.public.friends.ListConnections.Item', null, global);
goog.exportSymbol('proto.public.friends.ListConnections.Request', null, global);
goog.exportSymbol('proto.public.friends.ListConnections.Response', null, global);
goog.exportSymbol('proto.public.friends.RemoveConnection', null, global);
goog.exportSymbol('proto.public.friends.RemoveConnection.Request', null, global);
goog.exportSymbol('proto.public.friends.RemoveConnection.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.GetOverview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.GetOverview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.GetOverview.displayName = 'proto.public.friends.GetOverview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.GetOverview.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.GetOverview.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.GetOverview.Request.displayName = 'proto.public.friends.GetOverview.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.GetOverview.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.GetOverview.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.GetOverview.Response.displayName = 'proto.public.friends.GetOverview.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.ListConnections = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.ListConnections, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.ListConnections.displayName = 'proto.public.friends.ListConnections';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.ListConnections.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.ListConnections.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.ListConnections.Request.displayName = 'proto.public.friends.ListConnections.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.ListConnections.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.friends.ListConnections.Response.repeatedFields_, null);
};
goog.inherits(proto.public.friends.ListConnections.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.ListConnections.Response.displayName = 'proto.public.friends.ListConnections.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.ListConnections.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.ListConnections.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.ListConnections.Item.displayName = 'proto.public.friends.ListConnections.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.AddConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.AddConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.AddConnection.displayName = 'proto.public.friends.AddConnection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.AddConnection.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.public.friends.AddConnection.Request.oneofGroups_);
};
goog.inherits(proto.public.friends.AddConnection.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.AddConnection.Request.displayName = 'proto.public.friends.AddConnection.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.AddConnection.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.AddConnection.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.AddConnection.Response.displayName = 'proto.public.friends.AddConnection.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.RemoveConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.RemoveConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.RemoveConnection.displayName = 'proto.public.friends.RemoveConnection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.RemoveConnection.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.RemoveConnection.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.RemoveConnection.Request.displayName = 'proto.public.friends.RemoveConnection.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.RemoveConnection.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.RemoveConnection.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.RemoveConnection.Response.displayName = 'proto.public.friends.RemoveConnection.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.IDP = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.IDP, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.IDP.displayName = 'proto.public.friends.IDP';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.friends.IDP.Ident = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.friends.IDP.Ident, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.friends.IDP.Ident.displayName = 'proto.public.friends.IDP.Ident';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.GetOverview.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.GetOverview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.GetOverview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.GetOverview.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.GetOverview}
 */
proto.public.friends.GetOverview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.GetOverview;
  return proto.public.friends.GetOverview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.GetOverview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.GetOverview}
 */
proto.public.friends.GetOverview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.GetOverview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.GetOverview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.GetOverview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.GetOverview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.GetOverview.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.GetOverview.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.GetOverview.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.GetOverview.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.GetOverview.Request}
 */
proto.public.friends.GetOverview.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.GetOverview.Request;
  return proto.public.friends.GetOverview.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.GetOverview.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.GetOverview.Request}
 */
proto.public.friends.GetOverview.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.GetOverview.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.GetOverview.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.GetOverview.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.GetOverview.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.public.friends.GetOverview.Request.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.friends.GetOverview.Request} returns this
 */
proto.public.friends.GetOverview.Request.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.GetOverview.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.GetOverview.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.GetOverview.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.GetOverview.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    followingCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    followersCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    followingStatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.GetOverview.Response}
 */
proto.public.friends.GetOverview.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.GetOverview.Response;
  return proto.public.friends.GetOverview.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.GetOverview.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.GetOverview.Response}
 */
proto.public.friends.GetOverview.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFollowingCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFollowersCount(value);
      break;
    case 3:
      var value = /** @type {!proto.public.friends.FollowingStatus} */ (reader.readEnum());
      msg.setFollowingStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.GetOverview.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.GetOverview.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.GetOverview.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.GetOverview.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFollowingCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getFollowersCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFollowingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 following_count = 1;
 * @return {number}
 */
proto.public.friends.GetOverview.Response.prototype.getFollowingCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.friends.GetOverview.Response} returns this
 */
proto.public.friends.GetOverview.Response.prototype.setFollowingCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 followers_count = 2;
 * @return {number}
 */
proto.public.friends.GetOverview.Response.prototype.getFollowersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.friends.GetOverview.Response} returns this
 */
proto.public.friends.GetOverview.Response.prototype.setFollowersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional FollowingStatus following_status = 3;
 * @return {!proto.public.friends.FollowingStatus}
 */
proto.public.friends.GetOverview.Response.prototype.getFollowingStatus = function() {
  return /** @type {!proto.public.friends.FollowingStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.public.friends.FollowingStatus} value
 * @return {!proto.public.friends.GetOverview.Response} returns this
 */
proto.public.friends.GetOverview.Response.prototype.setFollowingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.ListConnections.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.ListConnections.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.ListConnections} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.ListConnections.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.ListConnections}
 */
proto.public.friends.ListConnections.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.ListConnections;
  return proto.public.friends.ListConnections.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.ListConnections} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.ListConnections}
 */
proto.public.friends.ListConnections.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.ListConnections.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.ListConnections.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.ListConnections} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.ListConnections.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.ListConnections.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.ListConnections.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.ListConnections.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.ListConnections.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    withFollowers: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.ListConnections.Request}
 */
proto.public.friends.ListConnections.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.ListConnections.Request;
  return proto.public.friends.ListConnections.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.ListConnections.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.ListConnections.Request}
 */
proto.public.friends.ListConnections.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithFollowers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.ListConnections.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.ListConnections.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.ListConnections.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.ListConnections.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWithFollowers();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool with_followers = 1;
 * @return {boolean}
 */
proto.public.friends.ListConnections.Request.prototype.getWithFollowers = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.friends.ListConnections.Request} returns this
 */
proto.public.friends.ListConnections.Request.prototype.setWithFollowers = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.friends.ListConnections.Response.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.ListConnections.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.ListConnections.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.ListConnections.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.ListConnections.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    followingsList: jspb.Message.toObjectList(msg.getFollowingsList(),
    proto.public.friends.ListConnections.Item.toObject, includeInstance),
    followersList: jspb.Message.toObjectList(msg.getFollowersList(),
    proto.public.friends.ListConnections.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.ListConnections.Response}
 */
proto.public.friends.ListConnections.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.ListConnections.Response;
  return proto.public.friends.ListConnections.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.ListConnections.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.ListConnections.Response}
 */
proto.public.friends.ListConnections.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.friends.ListConnections.Item;
      reader.readMessage(value,proto.public.friends.ListConnections.Item.deserializeBinaryFromReader);
      msg.addFollowings(value);
      break;
    case 2:
      var value = new proto.public.friends.ListConnections.Item;
      reader.readMessage(value,proto.public.friends.ListConnections.Item.deserializeBinaryFromReader);
      msg.addFollowers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.ListConnections.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.ListConnections.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.ListConnections.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.ListConnections.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFollowingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.public.friends.ListConnections.Item.serializeBinaryToWriter
    );
  }
  f = message.getFollowersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.public.friends.ListConnections.Item.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Item followings = 1;
 * @return {!Array<!proto.public.friends.ListConnections.Item>}
 */
proto.public.friends.ListConnections.Response.prototype.getFollowingsList = function() {
  return /** @type{!Array<!proto.public.friends.ListConnections.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.friends.ListConnections.Item, 1));
};


/**
 * @param {!Array<!proto.public.friends.ListConnections.Item>} value
 * @return {!proto.public.friends.ListConnections.Response} returns this
*/
proto.public.friends.ListConnections.Response.prototype.setFollowingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.public.friends.ListConnections.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.friends.ListConnections.Item}
 */
proto.public.friends.ListConnections.Response.prototype.addFollowings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.public.friends.ListConnections.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.friends.ListConnections.Response} returns this
 */
proto.public.friends.ListConnections.Response.prototype.clearFollowingsList = function() {
  return this.setFollowingsList([]);
};


/**
 * repeated Item followers = 2;
 * @return {!Array<!proto.public.friends.ListConnections.Item>}
 */
proto.public.friends.ListConnections.Response.prototype.getFollowersList = function() {
  return /** @type{!Array<!proto.public.friends.ListConnections.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.friends.ListConnections.Item, 2));
};


/**
 * @param {!Array<!proto.public.friends.ListConnections.Item>} value
 * @return {!proto.public.friends.ListConnections.Response} returns this
*/
proto.public.friends.ListConnections.Response.prototype.setFollowersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.public.friends.ListConnections.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.friends.ListConnections.Item}
 */
proto.public.friends.ListConnections.Response.prototype.addFollowers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.public.friends.ListConnections.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.friends.ListConnections.Response} returns this
 */
proto.public.friends.ListConnections.Response.prototype.clearFollowersList = function() {
  return this.setFollowersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.ListConnections.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.ListConnections.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.ListConnections.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.ListConnections.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    followingStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ident: (f = msg.getIdent()) && proto.public.friends.IDP.Ident.toObject(includeInstance, f),
    activeSkin: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lastGameStart: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.ListConnections.Item}
 */
proto.public.friends.ListConnections.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.ListConnections.Item;
  return proto.public.friends.ListConnections.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.ListConnections.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.ListConnections.Item}
 */
proto.public.friends.ListConnections.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.public.friends.FollowingStatus} */ (reader.readEnum());
      msg.setFollowingStatus(value);
      break;
    case 3:
      var value = new proto.public.friends.IDP.Ident;
      reader.readMessage(value,proto.public.friends.IDP.Ident.deserializeBinaryFromReader);
      msg.setIdent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActiveSkin(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastGameStart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.ListConnections.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.ListConnections.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.ListConnections.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.ListConnections.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFollowingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIdent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.public.friends.IDP.Ident.serializeBinaryToWriter
    );
  }
  f = message.getActiveSkin();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLastGameStart();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.public.friends.ListConnections.Item.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.friends.ListConnections.Item} returns this
 */
proto.public.friends.ListConnections.Item.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FollowingStatus following_status = 2;
 * @return {!proto.public.friends.FollowingStatus}
 */
proto.public.friends.ListConnections.Item.prototype.getFollowingStatus = function() {
  return /** @type {!proto.public.friends.FollowingStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.public.friends.FollowingStatus} value
 * @return {!proto.public.friends.ListConnections.Item} returns this
 */
proto.public.friends.ListConnections.Item.prototype.setFollowingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional IDP.Ident ident = 3;
 * @return {?proto.public.friends.IDP.Ident}
 */
proto.public.friends.ListConnections.Item.prototype.getIdent = function() {
  return /** @type{?proto.public.friends.IDP.Ident} */ (
    jspb.Message.getWrapperField(this, proto.public.friends.IDP.Ident, 3));
};


/**
 * @param {?proto.public.friends.IDP.Ident|undefined} value
 * @return {!proto.public.friends.ListConnections.Item} returns this
*/
proto.public.friends.ListConnections.Item.prototype.setIdent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.friends.ListConnections.Item} returns this
 */
proto.public.friends.ListConnections.Item.prototype.clearIdent = function() {
  return this.setIdent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.friends.ListConnections.Item.prototype.hasIdent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string active_skin = 4;
 * @return {string}
 */
proto.public.friends.ListConnections.Item.prototype.getActiveSkin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.friends.ListConnections.Item} returns this
 */
proto.public.friends.ListConnections.Item.prototype.setActiveSkin = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 last_game_start = 5;
 * @return {number}
 */
proto.public.friends.ListConnections.Item.prototype.getLastGameStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.friends.ListConnections.Item} returns this
 */
proto.public.friends.ListConnections.Item.prototype.setLastGameStart = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.AddConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.AddConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.AddConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.AddConnection.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.AddConnection}
 */
proto.public.friends.AddConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.AddConnection;
  return proto.public.friends.AddConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.AddConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.AddConnection}
 */
proto.public.friends.AddConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.AddConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.AddConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.AddConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.AddConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.public.friends.AddConnection.Request.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.public.friends.AddConnection.Request.ByCase = {
  BY_NOT_SET: 0,
  IDENT: 1,
  USER_ID: 2
};

/**
 * @return {proto.public.friends.AddConnection.Request.ByCase}
 */
proto.public.friends.AddConnection.Request.prototype.getByCase = function() {
  return /** @type {proto.public.friends.AddConnection.Request.ByCase} */(jspb.Message.computeOneofCase(this, proto.public.friends.AddConnection.Request.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.AddConnection.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.AddConnection.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.AddConnection.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.AddConnection.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    ident: (f = msg.getIdent()) && proto.public.friends.IDP.Ident.toObject(includeInstance, f),
    userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.AddConnection.Request}
 */
proto.public.friends.AddConnection.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.AddConnection.Request;
  return proto.public.friends.AddConnection.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.AddConnection.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.AddConnection.Request}
 */
proto.public.friends.AddConnection.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.friends.IDP.Ident;
      reader.readMessage(value,proto.public.friends.IDP.Ident.deserializeBinaryFromReader);
      msg.setIdent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.AddConnection.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.AddConnection.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.AddConnection.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.AddConnection.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.friends.IDP.Ident.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional IDP.Ident ident = 1;
 * @return {?proto.public.friends.IDP.Ident}
 */
proto.public.friends.AddConnection.Request.prototype.getIdent = function() {
  return /** @type{?proto.public.friends.IDP.Ident} */ (
    jspb.Message.getWrapperField(this, proto.public.friends.IDP.Ident, 1));
};


/**
 * @param {?proto.public.friends.IDP.Ident|undefined} value
 * @return {!proto.public.friends.AddConnection.Request} returns this
*/
proto.public.friends.AddConnection.Request.prototype.setIdent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.public.friends.AddConnection.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.friends.AddConnection.Request} returns this
 */
proto.public.friends.AddConnection.Request.prototype.clearIdent = function() {
  return this.setIdent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.friends.AddConnection.Request.prototype.hasIdent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.public.friends.AddConnection.Request.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.friends.AddConnection.Request} returns this
 */
proto.public.friends.AddConnection.Request.prototype.setUserId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.public.friends.AddConnection.Request.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.public.friends.AddConnection.Request} returns this
 */
proto.public.friends.AddConnection.Request.prototype.clearUserId = function() {
  return jspb.Message.setOneofField(this, 2, proto.public.friends.AddConnection.Request.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.friends.AddConnection.Request.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.AddConnection.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.AddConnection.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.AddConnection.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.AddConnection.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.AddConnection.Response}
 */
proto.public.friends.AddConnection.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.AddConnection.Response;
  return proto.public.friends.AddConnection.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.AddConnection.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.AddConnection.Response}
 */
proto.public.friends.AddConnection.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.AddConnection.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.AddConnection.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.AddConnection.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.AddConnection.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.public.friends.AddConnection.Response.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.friends.AddConnection.Response} returns this
 */
proto.public.friends.AddConnection.Response.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.RemoveConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.RemoveConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.RemoveConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.RemoveConnection.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.RemoveConnection}
 */
proto.public.friends.RemoveConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.RemoveConnection;
  return proto.public.friends.RemoveConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.RemoveConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.RemoveConnection}
 */
proto.public.friends.RemoveConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.RemoveConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.RemoveConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.RemoveConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.RemoveConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.RemoveConnection.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.RemoveConnection.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.RemoveConnection.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.RemoveConnection.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.RemoveConnection.Request}
 */
proto.public.friends.RemoveConnection.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.RemoveConnection.Request;
  return proto.public.friends.RemoveConnection.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.RemoveConnection.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.RemoveConnection.Request}
 */
proto.public.friends.RemoveConnection.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.RemoveConnection.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.RemoveConnection.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.RemoveConnection.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.RemoveConnection.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.public.friends.RemoveConnection.Request.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.friends.RemoveConnection.Request} returns this
 */
proto.public.friends.RemoveConnection.Request.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.RemoveConnection.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.RemoveConnection.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.RemoveConnection.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.RemoveConnection.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.RemoveConnection.Response}
 */
proto.public.friends.RemoveConnection.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.RemoveConnection.Response;
  return proto.public.friends.RemoveConnection.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.RemoveConnection.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.RemoveConnection.Response}
 */
proto.public.friends.RemoveConnection.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.RemoveConnection.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.RemoveConnection.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.RemoveConnection.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.RemoveConnection.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.IDP.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.IDP.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.IDP} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.IDP.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.IDP}
 */
proto.public.friends.IDP.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.IDP;
  return proto.public.friends.IDP.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.IDP} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.IDP}
 */
proto.public.friends.IDP.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.IDP.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.IDP.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.IDP} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.IDP.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.friends.IDP.Ident.prototype.toObject = function(opt_includeInstance) {
  return proto.public.friends.IDP.Ident.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.friends.IDP.Ident} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.IDP.Ident.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    suffix: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.friends.IDP.Ident}
 */
proto.public.friends.IDP.Ident.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.friends.IDP.Ident;
  return proto.public.friends.IDP.Ident.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.friends.IDP.Ident} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.friends.IDP.Ident}
 */
proto.public.friends.IDP.Ident.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.friends.IDP.Ident.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.friends.IDP.Ident.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.friends.IDP.Ident} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.friends.IDP.Ident.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuffix();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.public.friends.IDP.Ident.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.friends.IDP.Ident} returns this
 */
proto.public.friends.IDP.Ident.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string suffix = 2;
 * @return {string}
 */
proto.public.friends.IDP.Ident.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.friends.IDP.Ident} returns this
 */
proto.public.friends.IDP.Ident.prototype.setSuffix = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.public.friends.FollowingStatus = {
  FOLLOWING_STATUS_UNKNOWN: 0,
  FOLLOWING: 1,
  UNFOLLOWED: 2
};

goog.object.extend(exports, proto.public.friends);

},{"../validate/validate_pb.js":40,"google-protobuf":3}],40:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],41:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for fusion.public
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.fusion = {};
proto.fusion.public = require('./fusion_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fusion.public.FusionClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fusion.public.FusionPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fusion.public.GetRecipes.Request,
 *   !proto.fusion.public.GetRecipes.Response>}
 */
const methodDescriptor_Fusion_GetRecipes = new grpc.web.MethodDescriptor(
  '/fusion.public.Fusion/GetRecipes',
  grpc.web.MethodType.UNARY,
  proto.fusion.public.GetRecipes.Request,
  proto.fusion.public.GetRecipes.Response,
  /**
   * @param {!proto.fusion.public.GetRecipes.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fusion.public.GetRecipes.Response.deserializeBinary
);


/**
 * @param {!proto.fusion.public.GetRecipes.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fusion.public.GetRecipes.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fusion.public.GetRecipes.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fusion.public.FusionClient.prototype.getRecipes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fusion.public.Fusion/GetRecipes',
      request,
      metadata || {},
      methodDescriptor_Fusion_GetRecipes,
      callback);
};


/**
 * @param {!proto.fusion.public.GetRecipes.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fusion.public.GetRecipes.Response>}
 *     Promise that resolves to the response
 */
proto.fusion.public.FusionPromiseClient.prototype.getRecipes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fusion.public.Fusion/GetRecipes',
      request,
      metadata || {},
      methodDescriptor_Fusion_GetRecipes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fusion.public.AddIngredient.Request,
 *   !proto.fusion.public.AddIngredient.Response>}
 */
const methodDescriptor_Fusion_AddIngredient = new grpc.web.MethodDescriptor(
  '/fusion.public.Fusion/AddIngredient',
  grpc.web.MethodType.UNARY,
  proto.fusion.public.AddIngredient.Request,
  proto.fusion.public.AddIngredient.Response,
  /**
   * @param {!proto.fusion.public.AddIngredient.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fusion.public.AddIngredient.Response.deserializeBinary
);


/**
 * @param {!proto.fusion.public.AddIngredient.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fusion.public.AddIngredient.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fusion.public.AddIngredient.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fusion.public.FusionClient.prototype.addIngredient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fusion.public.Fusion/AddIngredient',
      request,
      metadata || {},
      methodDescriptor_Fusion_AddIngredient,
      callback);
};


/**
 * @param {!proto.fusion.public.AddIngredient.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fusion.public.AddIngredient.Response>}
 *     Promise that resolves to the response
 */
proto.fusion.public.FusionPromiseClient.prototype.addIngredient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fusion.public.Fusion/AddIngredient',
      request,
      metadata || {},
      methodDescriptor_Fusion_AddIngredient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fusion.public.Fuse.Request,
 *   !proto.fusion.public.Fuse.Response>}
 */
const methodDescriptor_Fusion_Fuse = new grpc.web.MethodDescriptor(
  '/fusion.public.Fusion/Fuse',
  grpc.web.MethodType.UNARY,
  proto.fusion.public.Fuse.Request,
  proto.fusion.public.Fuse.Response,
  /**
   * @param {!proto.fusion.public.Fuse.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fusion.public.Fuse.Response.deserializeBinary
);


/**
 * @param {!proto.fusion.public.Fuse.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fusion.public.Fuse.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fusion.public.Fuse.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fusion.public.FusionClient.prototype.fuse =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fusion.public.Fusion/Fuse',
      request,
      metadata || {},
      methodDescriptor_Fusion_Fuse,
      callback);
};


/**
 * @param {!proto.fusion.public.Fuse.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fusion.public.Fuse.Response>}
 *     Promise that resolves to the response
 */
proto.fusion.public.FusionPromiseClient.prototype.fuse =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fusion.public.Fusion/Fuse',
      request,
      metadata || {},
      methodDescriptor_Fusion_Fuse);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fusion.public.UpdateRecipeStatus.Request,
 *   !proto.fusion.public.UpdateRecipeStatus.Response>}
 */
const methodDescriptor_Fusion_UpdateRecipeStatus = new grpc.web.MethodDescriptor(
  '/fusion.public.Fusion/UpdateRecipeStatus',
  grpc.web.MethodType.UNARY,
  proto.fusion.public.UpdateRecipeStatus.Request,
  proto.fusion.public.UpdateRecipeStatus.Response,
  /**
   * @param {!proto.fusion.public.UpdateRecipeStatus.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fusion.public.UpdateRecipeStatus.Response.deserializeBinary
);


/**
 * @param {!proto.fusion.public.UpdateRecipeStatus.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fusion.public.UpdateRecipeStatus.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fusion.public.UpdateRecipeStatus.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fusion.public.FusionClient.prototype.updateRecipeStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fusion.public.Fusion/UpdateRecipeStatus',
      request,
      metadata || {},
      methodDescriptor_Fusion_UpdateRecipeStatus,
      callback);
};


/**
 * @param {!proto.fusion.public.UpdateRecipeStatus.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fusion.public.UpdateRecipeStatus.Response>}
 *     Promise that resolves to the response
 */
proto.fusion.public.FusionPromiseClient.prototype.updateRecipeStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fusion.public.Fusion/UpdateRecipeStatus',
      request,
      metadata || {},
      methodDescriptor_Fusion_UpdateRecipeStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fusion.public.GetMatchingItems.Request,
 *   !proto.fusion.public.GetMatchingItems.Response>}
 */
const methodDescriptor_Fusion_GetMatchingItems = new grpc.web.MethodDescriptor(
  '/fusion.public.Fusion/GetMatchingItems',
  grpc.web.MethodType.UNARY,
  proto.fusion.public.GetMatchingItems.Request,
  proto.fusion.public.GetMatchingItems.Response,
  /**
   * @param {!proto.fusion.public.GetMatchingItems.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fusion.public.GetMatchingItems.Response.deserializeBinary
);


/**
 * @param {!proto.fusion.public.GetMatchingItems.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fusion.public.GetMatchingItems.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fusion.public.GetMatchingItems.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fusion.public.FusionClient.prototype.getMatchingItems =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fusion.public.Fusion/GetMatchingItems',
      request,
      metadata || {},
      methodDescriptor_Fusion_GetMatchingItems,
      callback);
};


/**
 * @param {!proto.fusion.public.GetMatchingItems.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fusion.public.GetMatchingItems.Response>}
 *     Promise that resolves to the response
 */
proto.fusion.public.FusionPromiseClient.prototype.getMatchingItems =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fusion.public.Fusion/GetMatchingItems',
      request,
      metadata || {},
      methodDescriptor_Fusion_GetMatchingItems);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fusion.public.Take.Request,
 *   !proto.fusion.public.Take.Response>}
 */
const methodDescriptor_Fusion_Take = new grpc.web.MethodDescriptor(
  '/fusion.public.Fusion/Take',
  grpc.web.MethodType.UNARY,
  proto.fusion.public.Take.Request,
  proto.fusion.public.Take.Response,
  /**
   * @param {!proto.fusion.public.Take.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fusion.public.Take.Response.deserializeBinary
);


/**
 * @param {!proto.fusion.public.Take.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fusion.public.Take.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fusion.public.Take.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fusion.public.FusionClient.prototype.take =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fusion.public.Fusion/Take',
      request,
      metadata || {},
      methodDescriptor_Fusion_Take,
      callback);
};


/**
 * @param {!proto.fusion.public.Take.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fusion.public.Take.Response>}
 *     Promise that resolves to the response
 */
proto.fusion.public.FusionPromiseClient.prototype.take =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fusion.public.Fusion/Take',
      request,
      metadata || {},
      methodDescriptor_Fusion_Take);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fusion.public.RemoveIngredient.Request,
 *   !proto.fusion.public.RemoveIngredient.Response>}
 */
const methodDescriptor_Fusion_RemoveIngredient = new grpc.web.MethodDescriptor(
  '/fusion.public.Fusion/RemoveIngredient',
  grpc.web.MethodType.UNARY,
  proto.fusion.public.RemoveIngredient.Request,
  proto.fusion.public.RemoveIngredient.Response,
  /**
   * @param {!proto.fusion.public.RemoveIngredient.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fusion.public.RemoveIngredient.Response.deserializeBinary
);


/**
 * @param {!proto.fusion.public.RemoveIngredient.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fusion.public.RemoveIngredient.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fusion.public.RemoveIngredient.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fusion.public.FusionClient.prototype.removeIngredient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fusion.public.Fusion/RemoveIngredient',
      request,
      metadata || {},
      methodDescriptor_Fusion_RemoveIngredient,
      callback);
};


/**
 * @param {!proto.fusion.public.RemoveIngredient.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fusion.public.RemoveIngredient.Response>}
 *     Promise that resolves to the response
 */
proto.fusion.public.FusionPromiseClient.prototype.removeIngredient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fusion.public.Fusion/RemoveIngredient',
      request,
      metadata || {},
      methodDescriptor_Fusion_RemoveIngredient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fusion.public.GetIngredients.Request,
 *   !proto.fusion.public.GetIngredients.Response>}
 */
const methodDescriptor_Fusion_GetIngredients = new grpc.web.MethodDescriptor(
  '/fusion.public.Fusion/GetIngredients',
  grpc.web.MethodType.UNARY,
  proto.fusion.public.GetIngredients.Request,
  proto.fusion.public.GetIngredients.Response,
  /**
   * @param {!proto.fusion.public.GetIngredients.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fusion.public.GetIngredients.Response.deserializeBinary
);


/**
 * @param {!proto.fusion.public.GetIngredients.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fusion.public.GetIngredients.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fusion.public.GetIngredients.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fusion.public.FusionClient.prototype.getIngredients =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fusion.public.Fusion/GetIngredients',
      request,
      metadata || {},
      methodDescriptor_Fusion_GetIngredients,
      callback);
};


/**
 * @param {!proto.fusion.public.GetIngredients.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fusion.public.GetIngredients.Response>}
 *     Promise that resolves to the response
 */
proto.fusion.public.FusionPromiseClient.prototype.getIngredients =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fusion.public.Fusion/GetIngredients',
      request,
      metadata || {},
      methodDescriptor_Fusion_GetIngredients);
};


module.exports = proto.fusion.public;


},{"../validate/validate_pb.js":43,"./fusion_pb.js":42,"google-protobuf/google/protobuf/timestamp_pb.js":6,"grpc-web":7}],42:[function(require,module,exports){
// source: public/fusion.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.fusion.public.AddIngredient', null, global);
goog.exportSymbol('proto.fusion.public.AddIngredient.Request', null, global);
goog.exportSymbol('proto.fusion.public.AddIngredient.Response', null, global);
goog.exportSymbol('proto.fusion.public.Fuse', null, global);
goog.exportSymbol('proto.fusion.public.Fuse.Request', null, global);
goog.exportSymbol('proto.fusion.public.Fuse.Response', null, global);
goog.exportSymbol('proto.fusion.public.Fuse.TransactionDetails', null, global);
goog.exportSymbol('proto.fusion.public.GetIngredients', null, global);
goog.exportSymbol('proto.fusion.public.GetIngredients.Request', null, global);
goog.exportSymbol('proto.fusion.public.GetIngredients.Response', null, global);
goog.exportSymbol('proto.fusion.public.GetMatchingItems', null, global);
goog.exportSymbol('proto.fusion.public.GetMatchingItems.Request', null, global);
goog.exportSymbol('proto.fusion.public.GetMatchingItems.Response', null, global);
goog.exportSymbol('proto.fusion.public.GetRecipes', null, global);
goog.exportSymbol('proto.fusion.public.GetRecipes.Request', null, global);
goog.exportSymbol('proto.fusion.public.GetRecipes.Response', null, global);
goog.exportSymbol('proto.fusion.public.MatchingItemsUpdate', null, global);
goog.exportSymbol('proto.fusion.public.MatchingItemsUpdate.Recipe', null, global);
goog.exportSymbol('proto.fusion.public.MatchingItemsUpdate.Slot', null, global);
goog.exportSymbol('proto.fusion.public.Recipe', null, global);
goog.exportSymbol('proto.fusion.public.Recipe.CalendarDetails', null, global);
goog.exportSymbol('proto.fusion.public.Recipe.ItemType', null, global);
goog.exportSymbol('proto.fusion.public.Recipe.PaymentDetails', null, global);
goog.exportSymbol('proto.fusion.public.Recipe.Status', null, global);
goog.exportSymbol('proto.fusion.public.RemoveIngredient', null, global);
goog.exportSymbol('proto.fusion.public.RemoveIngredient.Request', null, global);
goog.exportSymbol('proto.fusion.public.RemoveIngredient.Response', null, global);
goog.exportSymbol('proto.fusion.public.Slot', null, global);
goog.exportSymbol('proto.fusion.public.Take', null, global);
goog.exportSymbol('proto.fusion.public.Take.Request', null, global);
goog.exportSymbol('proto.fusion.public.Take.Response', null, global);
goog.exportSymbol('proto.fusion.public.UpdateRecipeStatus', null, global);
goog.exportSymbol('proto.fusion.public.UpdateRecipeStatus.Request', null, global);
goog.exportSymbol('proto.fusion.public.UpdateRecipeStatus.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetRecipes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.GetRecipes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetRecipes.displayName = 'proto.fusion.public.GetRecipes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetRecipes.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.GetRecipes.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetRecipes.Request.displayName = 'proto.fusion.public.GetRecipes.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetRecipes.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fusion.public.GetRecipes.Response.repeatedFields_, null);
};
goog.inherits(proto.fusion.public.GetRecipes.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetRecipes.Response.displayName = 'proto.fusion.public.GetRecipes.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Recipe = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fusion.public.Recipe.repeatedFields_, null);
};
goog.inherits(proto.fusion.public.Recipe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Recipe.displayName = 'proto.fusion.public.Recipe';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Recipe.PaymentDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Recipe.PaymentDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Recipe.PaymentDetails.displayName = 'proto.fusion.public.Recipe.PaymentDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Recipe.CalendarDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Recipe.CalendarDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Recipe.CalendarDetails.displayName = 'proto.fusion.public.Recipe.CalendarDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Slot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Slot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Slot.displayName = 'proto.fusion.public.Slot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.AddIngredient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.AddIngredient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.AddIngredient.displayName = 'proto.fusion.public.AddIngredient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.AddIngredient.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.AddIngredient.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.AddIngredient.Request.displayName = 'proto.fusion.public.AddIngredient.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.AddIngredient.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.AddIngredient.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.AddIngredient.Response.displayName = 'proto.fusion.public.AddIngredient.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Fuse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Fuse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Fuse.displayName = 'proto.fusion.public.Fuse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Fuse.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Fuse.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Fuse.Request.displayName = 'proto.fusion.public.Fuse.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Fuse.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Fuse.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Fuse.Response.displayName = 'proto.fusion.public.Fuse.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Fuse.TransactionDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Fuse.TransactionDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Fuse.TransactionDetails.displayName = 'proto.fusion.public.Fuse.TransactionDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetMatchingItems = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.GetMatchingItems, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetMatchingItems.displayName = 'proto.fusion.public.GetMatchingItems';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetMatchingItems.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.GetMatchingItems.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetMatchingItems.Request.displayName = 'proto.fusion.public.GetMatchingItems.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetMatchingItems.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fusion.public.GetMatchingItems.Response.repeatedFields_, null);
};
goog.inherits(proto.fusion.public.GetMatchingItems.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetMatchingItems.Response.displayName = 'proto.fusion.public.GetMatchingItems.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Take = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Take, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Take.displayName = 'proto.fusion.public.Take';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Take.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Take.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Take.Request.displayName = 'proto.fusion.public.Take.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.Take.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.Take.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.Take.Response.displayName = 'proto.fusion.public.Take.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.RemoveIngredient = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.RemoveIngredient, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.RemoveIngredient.displayName = 'proto.fusion.public.RemoveIngredient';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.RemoveIngredient.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.RemoveIngredient.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.RemoveIngredient.Request.displayName = 'proto.fusion.public.RemoveIngredient.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.RemoveIngredient.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.RemoveIngredient.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.RemoveIngredient.Response.displayName = 'proto.fusion.public.RemoveIngredient.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.MatchingItemsUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fusion.public.MatchingItemsUpdate.repeatedFields_, null);
};
goog.inherits(proto.fusion.public.MatchingItemsUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.MatchingItemsUpdate.displayName = 'proto.fusion.public.MatchingItemsUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.MatchingItemsUpdate.Recipe = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fusion.public.MatchingItemsUpdate.Recipe.repeatedFields_, null);
};
goog.inherits(proto.fusion.public.MatchingItemsUpdate.Recipe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.MatchingItemsUpdate.Recipe.displayName = 'proto.fusion.public.MatchingItemsUpdate.Recipe';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.MatchingItemsUpdate.Slot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.MatchingItemsUpdate.Slot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.MatchingItemsUpdate.Slot.displayName = 'proto.fusion.public.MatchingItemsUpdate.Slot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.UpdateRecipeStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.UpdateRecipeStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.UpdateRecipeStatus.displayName = 'proto.fusion.public.UpdateRecipeStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.UpdateRecipeStatus.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.UpdateRecipeStatus.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.UpdateRecipeStatus.Request.displayName = 'proto.fusion.public.UpdateRecipeStatus.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.UpdateRecipeStatus.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.UpdateRecipeStatus.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.UpdateRecipeStatus.Response.displayName = 'proto.fusion.public.UpdateRecipeStatus.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetIngredients = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.GetIngredients, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetIngredients.displayName = 'proto.fusion.public.GetIngredients';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetIngredients.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fusion.public.GetIngredients.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetIngredients.Request.displayName = 'proto.fusion.public.GetIngredients.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fusion.public.GetIngredients.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fusion.public.GetIngredients.Response.repeatedFields_, null);
};
goog.inherits(proto.fusion.public.GetIngredients.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fusion.public.GetIngredients.Response.displayName = 'proto.fusion.public.GetIngredients.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetRecipes.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetRecipes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetRecipes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetRecipes.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetRecipes}
 */
proto.fusion.public.GetRecipes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetRecipes;
  return proto.fusion.public.GetRecipes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetRecipes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetRecipes}
 */
proto.fusion.public.GetRecipes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetRecipes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetRecipes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetRecipes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetRecipes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetRecipes.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetRecipes.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetRecipes.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetRecipes.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetRecipes.Request}
 */
proto.fusion.public.GetRecipes.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetRecipes.Request;
  return proto.fusion.public.GetRecipes.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetRecipes.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetRecipes.Request}
 */
proto.fusion.public.GetRecipes.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetRecipes.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetRecipes.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetRecipes.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetRecipes.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fusion.public.GetRecipes.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetRecipes.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetRecipes.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetRecipes.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetRecipes.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipesList: jspb.Message.toObjectList(msg.getRecipesList(),
    proto.fusion.public.Recipe.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetRecipes.Response}
 */
proto.fusion.public.GetRecipes.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetRecipes.Response;
  return proto.fusion.public.GetRecipes.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetRecipes.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetRecipes.Response}
 */
proto.fusion.public.GetRecipes.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fusion.public.Recipe;
      reader.readMessage(value,proto.fusion.public.Recipe.deserializeBinaryFromReader);
      msg.addRecipes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetRecipes.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetRecipes.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetRecipes.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetRecipes.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fusion.public.Recipe.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Recipe recipes = 1;
 * @return {!Array<!proto.fusion.public.Recipe>}
 */
proto.fusion.public.GetRecipes.Response.prototype.getRecipesList = function() {
  return /** @type{!Array<!proto.fusion.public.Recipe>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fusion.public.Recipe, 1));
};


/**
 * @param {!Array<!proto.fusion.public.Recipe>} value
 * @return {!proto.fusion.public.GetRecipes.Response} returns this
*/
proto.fusion.public.GetRecipes.Response.prototype.setRecipesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fusion.public.Recipe=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fusion.public.Recipe}
 */
proto.fusion.public.GetRecipes.Response.prototype.addRecipes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fusion.public.Recipe, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fusion.public.GetRecipes.Response} returns this
 */
proto.fusion.public.GetRecipes.Response.prototype.clearRecipesList = function() {
  return this.setRecipesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fusion.public.Recipe.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Recipe.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Recipe.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Recipe} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Recipe.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fusedCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    fusionDurationSeconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    initialLevel: jspb.Message.getFieldWithDefault(msg, 4, 0),
    paymentDetails: (f = msg.getPaymentDetails()) && proto.fusion.public.Recipe.PaymentDetails.toObject(includeInstance, f),
    calendarDetails: (f = msg.getCalendarDetails()) && proto.fusion.public.Recipe.CalendarDetails.toObject(includeInstance, f),
    slotsList: jspb.Message.toObjectList(msg.getSlotsList(),
    proto.fusion.public.Slot.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 10, 0),
    fusionEndsInSeconds: jspb.Message.getFieldWithDefault(msg, 11, 0),
    name: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Recipe}
 */
proto.fusion.public.Recipe.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Recipe;
  return proto.fusion.public.Recipe.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Recipe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Recipe}
 */
proto.fusion.public.Recipe.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFusedCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFusionDurationSeconds(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setInitialLevel(value);
      break;
    case 7:
      var value = new proto.fusion.public.Recipe.PaymentDetails;
      reader.readMessage(value,proto.fusion.public.Recipe.PaymentDetails.deserializeBinaryFromReader);
      msg.setPaymentDetails(value);
      break;
    case 8:
      var value = new proto.fusion.public.Recipe.CalendarDetails;
      reader.readMessage(value,proto.fusion.public.Recipe.CalendarDetails.deserializeBinaryFromReader);
      msg.setCalendarDetails(value);
      break;
    case 9:
      var value = new proto.fusion.public.Slot;
      reader.readMessage(value,proto.fusion.public.Slot.deserializeBinaryFromReader);
      msg.addSlots(value);
      break;
    case 10:
      var value = /** @type {!proto.fusion.public.Recipe.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFusionEndsInSeconds(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Recipe.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Recipe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Recipe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Recipe.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFusedCount();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getFusionDurationSeconds();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getInitialLevel();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getPaymentDetails();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.fusion.public.Recipe.PaymentDetails.serializeBinaryToWriter
    );
  }
  f = message.getCalendarDetails();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.fusion.public.Recipe.CalendarDetails.serializeBinaryToWriter
    );
  }
  f = message.getSlotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.fusion.public.Slot.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getFusionEndsInSeconds();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.fusion.public.Recipe.Status = {
  UNKNOWN_RECIPE_STATUS: 0,
  FORMING: 1,
  FUSING: 2,
  CONFIRMED: 3,
  COLLECT: 4
};

/**
 * @enum {number}
 */
proto.fusion.public.Recipe.ItemType = {
  UNKNOWN_ITEM_TYPE: 0,
  WEAPON: 1,
  CHARACTER: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Recipe.PaymentDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Recipe.PaymentDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Recipe.PaymentDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Recipe.PaymentDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Recipe.PaymentDetails}
 */
proto.fusion.public.Recipe.PaymentDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Recipe.PaymentDetails;
  return proto.fusion.public.Recipe.PaymentDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Recipe.PaymentDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Recipe.PaymentDetails}
 */
proto.fusion.public.Recipe.PaymentDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Recipe.PaymentDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Recipe.PaymentDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Recipe.PaymentDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Recipe.PaymentDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 amount = 1;
 * @return {number}
 */
proto.fusion.public.Recipe.PaymentDetails.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.Recipe.PaymentDetails} returns this
 */
proto.fusion.public.Recipe.PaymentDetails.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.fusion.public.Recipe.PaymentDetails.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.Recipe.PaymentDetails} returns this
 */
proto.fusion.public.Recipe.PaymentDetails.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Recipe.CalendarDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Recipe.CalendarDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Recipe.CalendarDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    startsAt: (f = msg.getStartsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endsAt: (f = msg.getEndsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endsInSeconds: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Recipe.CalendarDetails}
 */
proto.fusion.public.Recipe.CalendarDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Recipe.CalendarDetails;
  return proto.fusion.public.Recipe.CalendarDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Recipe.CalendarDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Recipe.CalendarDetails}
 */
proto.fusion.public.Recipe.CalendarDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartsAt(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndsAt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndsInSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Recipe.CalendarDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Recipe.CalendarDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Recipe.CalendarDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartsAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndsAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndsInSeconds();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp starts_at = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.getStartsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fusion.public.Recipe.CalendarDetails} returns this
*/
proto.fusion.public.Recipe.CalendarDetails.prototype.setStartsAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fusion.public.Recipe.CalendarDetails} returns this
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.clearStartsAt = function() {
  return this.setStartsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.hasStartsAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp ends_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.getEndsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fusion.public.Recipe.CalendarDetails} returns this
*/
proto.fusion.public.Recipe.CalendarDetails.prototype.setEndsAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fusion.public.Recipe.CalendarDetails} returns this
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.clearEndsAt = function() {
  return this.setEndsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.hasEndsAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 ends_in_seconds = 3;
 * @return {number}
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.getEndsInSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.Recipe.CalendarDetails} returns this
 */
proto.fusion.public.Recipe.CalendarDetails.prototype.setEndsInSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fusion.public.Recipe.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 fused_count = 2;
 * @return {number}
 */
proto.fusion.public.Recipe.prototype.getFusedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.setFusedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 fusion_duration_seconds = 3;
 * @return {number}
 */
proto.fusion.public.Recipe.prototype.getFusionDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.setFusionDurationSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 initial_level = 4;
 * @return {number}
 */
proto.fusion.public.Recipe.prototype.getInitialLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.setInitialLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional PaymentDetails payment_details = 7;
 * @return {?proto.fusion.public.Recipe.PaymentDetails}
 */
proto.fusion.public.Recipe.prototype.getPaymentDetails = function() {
  return /** @type{?proto.fusion.public.Recipe.PaymentDetails} */ (
    jspb.Message.getWrapperField(this, proto.fusion.public.Recipe.PaymentDetails, 7));
};


/**
 * @param {?proto.fusion.public.Recipe.PaymentDetails|undefined} value
 * @return {!proto.fusion.public.Recipe} returns this
*/
proto.fusion.public.Recipe.prototype.setPaymentDetails = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.clearPaymentDetails = function() {
  return this.setPaymentDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fusion.public.Recipe.prototype.hasPaymentDetails = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional CalendarDetails calendar_details = 8;
 * @return {?proto.fusion.public.Recipe.CalendarDetails}
 */
proto.fusion.public.Recipe.prototype.getCalendarDetails = function() {
  return /** @type{?proto.fusion.public.Recipe.CalendarDetails} */ (
    jspb.Message.getWrapperField(this, proto.fusion.public.Recipe.CalendarDetails, 8));
};


/**
 * @param {?proto.fusion.public.Recipe.CalendarDetails|undefined} value
 * @return {!proto.fusion.public.Recipe} returns this
*/
proto.fusion.public.Recipe.prototype.setCalendarDetails = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.clearCalendarDetails = function() {
  return this.setCalendarDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fusion.public.Recipe.prototype.hasCalendarDetails = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated Slot slots = 9;
 * @return {!Array<!proto.fusion.public.Slot>}
 */
proto.fusion.public.Recipe.prototype.getSlotsList = function() {
  return /** @type{!Array<!proto.fusion.public.Slot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fusion.public.Slot, 9));
};


/**
 * @param {!Array<!proto.fusion.public.Slot>} value
 * @return {!proto.fusion.public.Recipe} returns this
*/
proto.fusion.public.Recipe.prototype.setSlotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.fusion.public.Slot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fusion.public.Slot}
 */
proto.fusion.public.Recipe.prototype.addSlots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.fusion.public.Slot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.clearSlotsList = function() {
  return this.setSlotsList([]);
};


/**
 * optional Status status = 10;
 * @return {!proto.fusion.public.Recipe.Status}
 */
proto.fusion.public.Recipe.prototype.getStatus = function() {
  return /** @type {!proto.fusion.public.Recipe.Status} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.fusion.public.Recipe.Status} value
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional int64 fusion_ends_in_seconds = 11;
 * @return {number}
 */
proto.fusion.public.Recipe.prototype.getFusionEndsInSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.setFusionEndsInSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string name = 12;
 * @return {string}
 */
proto.fusion.public.Recipe.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.Recipe} returns this
 */
proto.fusion.public.Recipe.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Slot.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Slot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Slot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Slot.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hasMatchingItem: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    rulesMap: (f = msg.getRulesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Slot}
 */
proto.fusion.public.Slot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Slot;
  return proto.fusion.public.Slot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Slot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Slot}
 */
proto.fusion.public.Slot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasMatchingItem(value);
      break;
    case 3:
      var value = msg.getRulesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Slot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Slot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Slot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Slot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHasMatchingItem();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRulesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.fusion.public.Slot.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.Slot} returns this
 */
proto.fusion.public.Slot.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool has_matching_item = 2;
 * @return {boolean}
 */
proto.fusion.public.Slot.prototype.getHasMatchingItem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fusion.public.Slot} returns this
 */
proto.fusion.public.Slot.prototype.setHasMatchingItem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * map<string, string> rules = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.fusion.public.Slot.prototype.getRulesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.fusion.public.Slot} returns this
 */
proto.fusion.public.Slot.prototype.clearRulesMap = function() {
  this.getRulesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.AddIngredient.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.AddIngredient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.AddIngredient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.AddIngredient.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.AddIngredient}
 */
proto.fusion.public.AddIngredient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.AddIngredient;
  return proto.fusion.public.AddIngredient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.AddIngredient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.AddIngredient}
 */
proto.fusion.public.AddIngredient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.AddIngredient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.AddIngredient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.AddIngredient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.AddIngredient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.AddIngredient.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.AddIngredient.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.AddIngredient.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.AddIngredient.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    recipeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    slotNumber: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.AddIngredient.Request}
 */
proto.fusion.public.AddIngredient.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.AddIngredient.Request;
  return proto.fusion.public.AddIngredient.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.AddIngredient.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.AddIngredient.Request}
 */
proto.fusion.public.AddIngredient.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipeId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSlotNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.AddIngredient.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.AddIngredient.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.AddIngredient.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.AddIngredient.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecipeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlotNumber();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.fusion.public.AddIngredient.Request.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.AddIngredient.Request} returns this
 */
proto.fusion.public.AddIngredient.Request.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string recipe_id = 2;
 * @return {string}
 */
proto.fusion.public.AddIngredient.Request.prototype.getRecipeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.AddIngredient.Request} returns this
 */
proto.fusion.public.AddIngredient.Request.prototype.setRecipeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 slot_number = 3;
 * @return {number}
 */
proto.fusion.public.AddIngredient.Request.prototype.getSlotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.AddIngredient.Request} returns this
 */
proto.fusion.public.AddIngredient.Request.prototype.setSlotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.AddIngredient.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.AddIngredient.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.AddIngredient.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.AddIngredient.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    update: (f = msg.getUpdate()) && proto.fusion.public.MatchingItemsUpdate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.AddIngredient.Response}
 */
proto.fusion.public.AddIngredient.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.AddIngredient.Response;
  return proto.fusion.public.AddIngredient.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.AddIngredient.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.AddIngredient.Response}
 */
proto.fusion.public.AddIngredient.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fusion.public.MatchingItemsUpdate;
      reader.readMessage(value,proto.fusion.public.MatchingItemsUpdate.deserializeBinaryFromReader);
      msg.setUpdate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.AddIngredient.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.AddIngredient.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.AddIngredient.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.AddIngredient.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fusion.public.MatchingItemsUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * optional MatchingItemsUpdate update = 1;
 * @return {?proto.fusion.public.MatchingItemsUpdate}
 */
proto.fusion.public.AddIngredient.Response.prototype.getUpdate = function() {
  return /** @type{?proto.fusion.public.MatchingItemsUpdate} */ (
    jspb.Message.getWrapperField(this, proto.fusion.public.MatchingItemsUpdate, 1));
};


/**
 * @param {?proto.fusion.public.MatchingItemsUpdate|undefined} value
 * @return {!proto.fusion.public.AddIngredient.Response} returns this
*/
proto.fusion.public.AddIngredient.Response.prototype.setUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fusion.public.AddIngredient.Response} returns this
 */
proto.fusion.public.AddIngredient.Response.prototype.clearUpdate = function() {
  return this.setUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fusion.public.AddIngredient.Response.prototype.hasUpdate = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Fuse.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Fuse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Fuse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Fuse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Fuse}
 */
proto.fusion.public.Fuse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Fuse;
  return proto.fusion.public.Fuse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Fuse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Fuse}
 */
proto.fusion.public.Fuse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Fuse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Fuse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Fuse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Fuse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Fuse.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Fuse.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Fuse.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Fuse.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Fuse.Request}
 */
proto.fusion.public.Fuse.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Fuse.Request;
  return proto.fusion.public.Fuse.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Fuse.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Fuse.Request}
 */
proto.fusion.public.Fuse.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Fuse.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Fuse.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Fuse.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Fuse.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string recipe_id = 1;
 * @return {string}
 */
proto.fusion.public.Fuse.Request.prototype.getRecipeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.Fuse.Request} returns this
 */
proto.fusion.public.Fuse.Request.prototype.setRecipeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Fuse.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Fuse.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Fuse.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Fuse.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionDetails: (f = msg.getTransactionDetails()) && proto.fusion.public.Fuse.TransactionDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Fuse.Response}
 */
proto.fusion.public.Fuse.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Fuse.Response;
  return proto.fusion.public.Fuse.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Fuse.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Fuse.Response}
 */
proto.fusion.public.Fuse.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fusion.public.Fuse.TransactionDetails;
      reader.readMessage(value,proto.fusion.public.Fuse.TransactionDetails.deserializeBinaryFromReader);
      msg.setTransactionDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Fuse.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Fuse.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Fuse.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Fuse.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fusion.public.Fuse.TransactionDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional TransactionDetails transaction_details = 1;
 * @return {?proto.fusion.public.Fuse.TransactionDetails}
 */
proto.fusion.public.Fuse.Response.prototype.getTransactionDetails = function() {
  return /** @type{?proto.fusion.public.Fuse.TransactionDetails} */ (
    jspb.Message.getWrapperField(this, proto.fusion.public.Fuse.TransactionDetails, 1));
};


/**
 * @param {?proto.fusion.public.Fuse.TransactionDetails|undefined} value
 * @return {!proto.fusion.public.Fuse.Response} returns this
*/
proto.fusion.public.Fuse.Response.prototype.setTransactionDetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fusion.public.Fuse.Response} returns this
 */
proto.fusion.public.Fuse.Response.prototype.clearTransactionDetails = function() {
  return this.setTransactionDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fusion.public.Fuse.Response.prototype.hasTransactionDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Fuse.TransactionDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Fuse.TransactionDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Fuse.TransactionDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Fuse.TransactionDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    tx: msg.getTx_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Fuse.TransactionDetails}
 */
proto.fusion.public.Fuse.TransactionDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Fuse.TransactionDetails;
  return proto.fusion.public.Fuse.TransactionDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Fuse.TransactionDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Fuse.TransactionDetails}
 */
proto.fusion.public.Fuse.TransactionDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setTx(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Fuse.TransactionDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Fuse.TransactionDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Fuse.TransactionDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Fuse.TransactionDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTx_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes tx = 1;
 * @return {string}
 */
proto.fusion.public.Fuse.TransactionDetails.prototype.getTx = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes tx = 1;
 * This is a type-conversion wrapper around `getTx()`
 * @return {string}
 */
proto.fusion.public.Fuse.TransactionDetails.prototype.getTx_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getTx()));
};


/**
 * optional bytes tx = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTx()`
 * @return {!Uint8Array}
 */
proto.fusion.public.Fuse.TransactionDetails.prototype.getTx_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getTx()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fusion.public.Fuse.TransactionDetails} returns this
 */
proto.fusion.public.Fuse.TransactionDetails.prototype.setTx = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetMatchingItems.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetMatchingItems.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetMatchingItems} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetMatchingItems.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetMatchingItems}
 */
proto.fusion.public.GetMatchingItems.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetMatchingItems;
  return proto.fusion.public.GetMatchingItems.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetMatchingItems} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetMatchingItems}
 */
proto.fusion.public.GetMatchingItems.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetMatchingItems.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetMatchingItems.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetMatchingItems} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetMatchingItems.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetMatchingItems.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetMatchingItems.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetMatchingItems.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetMatchingItems.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotNumber: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetMatchingItems.Request}
 */
proto.fusion.public.GetMatchingItems.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetMatchingItems.Request;
  return proto.fusion.public.GetMatchingItems.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetMatchingItems.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetMatchingItems.Request}
 */
proto.fusion.public.GetMatchingItems.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSlotNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetMatchingItems.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetMatchingItems.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetMatchingItems.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetMatchingItems.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotNumber();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional string recipe_id = 1;
 * @return {string}
 */
proto.fusion.public.GetMatchingItems.Request.prototype.getRecipeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.GetMatchingItems.Request} returns this
 */
proto.fusion.public.GetMatchingItems.Request.prototype.setRecipeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 slot_number = 2;
 * @return {number}
 */
proto.fusion.public.GetMatchingItems.Request.prototype.getSlotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.GetMatchingItems.Request} returns this
 */
proto.fusion.public.GetMatchingItems.Request.prototype.setSlotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fusion.public.GetMatchingItems.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetMatchingItems.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetMatchingItems.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetMatchingItems.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetMatchingItems.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetMatchingItems.Response}
 */
proto.fusion.public.GetMatchingItems.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetMatchingItems.Response;
  return proto.fusion.public.GetMatchingItems.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetMatchingItems.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetMatchingItems.Response}
 */
proto.fusion.public.GetMatchingItems.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetMatchingItems.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetMatchingItems.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetMatchingItems.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetMatchingItems.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string items = 1;
 * @return {!Array<string>}
 */
proto.fusion.public.GetMatchingItems.Response.prototype.getItemsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fusion.public.GetMatchingItems.Response} returns this
 */
proto.fusion.public.GetMatchingItems.Response.prototype.setItemsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fusion.public.GetMatchingItems.Response} returns this
 */
proto.fusion.public.GetMatchingItems.Response.prototype.addItems = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fusion.public.GetMatchingItems.Response} returns this
 */
proto.fusion.public.GetMatchingItems.Response.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Take.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Take.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Take} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Take.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Take}
 */
proto.fusion.public.Take.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Take;
  return proto.fusion.public.Take.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Take} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Take}
 */
proto.fusion.public.Take.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Take.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Take.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Take} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Take.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Take.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Take.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Take.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Take.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Take.Request}
 */
proto.fusion.public.Take.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Take.Request;
  return proto.fusion.public.Take.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Take.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Take.Request}
 */
proto.fusion.public.Take.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Take.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Take.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Take.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Take.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string recipe_id = 1;
 * @return {string}
 */
proto.fusion.public.Take.Request.prototype.getRecipeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.Take.Request} returns this
 */
proto.fusion.public.Take.Request.prototype.setRecipeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.Take.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.Take.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.Take.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Take.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.Take.Response}
 */
proto.fusion.public.Take.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.Take.Response;
  return proto.fusion.public.Take.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.Take.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.Take.Response}
 */
proto.fusion.public.Take.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.Take.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.Take.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.Take.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.Take.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.fusion.public.Take.Response.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.Take.Response} returns this
 */
proto.fusion.public.Take.Response.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.RemoveIngredient.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.RemoveIngredient.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.RemoveIngredient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.RemoveIngredient.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.RemoveIngredient}
 */
proto.fusion.public.RemoveIngredient.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.RemoveIngredient;
  return proto.fusion.public.RemoveIngredient.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.RemoveIngredient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.RemoveIngredient}
 */
proto.fusion.public.RemoveIngredient.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.RemoveIngredient.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.RemoveIngredient.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.RemoveIngredient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.RemoveIngredient.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.RemoveIngredient.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.RemoveIngredient.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.RemoveIngredient.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.RemoveIngredient.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotNumber: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.RemoveIngredient.Request}
 */
proto.fusion.public.RemoveIngredient.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.RemoveIngredient.Request;
  return proto.fusion.public.RemoveIngredient.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.RemoveIngredient.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.RemoveIngredient.Request}
 */
proto.fusion.public.RemoveIngredient.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSlotNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.RemoveIngredient.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.RemoveIngredient.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.RemoveIngredient.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.RemoveIngredient.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotNumber();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional string recipe_id = 1;
 * @return {string}
 */
proto.fusion.public.RemoveIngredient.Request.prototype.getRecipeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.RemoveIngredient.Request} returns this
 */
proto.fusion.public.RemoveIngredient.Request.prototype.setRecipeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 slot_number = 2;
 * @return {number}
 */
proto.fusion.public.RemoveIngredient.Request.prototype.getSlotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.RemoveIngredient.Request} returns this
 */
proto.fusion.public.RemoveIngredient.Request.prototype.setSlotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.RemoveIngredient.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.RemoveIngredient.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.RemoveIngredient.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.RemoveIngredient.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    update: (f = msg.getUpdate()) && proto.fusion.public.MatchingItemsUpdate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.RemoveIngredient.Response}
 */
proto.fusion.public.RemoveIngredient.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.RemoveIngredient.Response;
  return proto.fusion.public.RemoveIngredient.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.RemoveIngredient.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.RemoveIngredient.Response}
 */
proto.fusion.public.RemoveIngredient.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fusion.public.MatchingItemsUpdate;
      reader.readMessage(value,proto.fusion.public.MatchingItemsUpdate.deserializeBinaryFromReader);
      msg.setUpdate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.RemoveIngredient.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.RemoveIngredient.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.RemoveIngredient.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.RemoveIngredient.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fusion.public.MatchingItemsUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * optional MatchingItemsUpdate update = 1;
 * @return {?proto.fusion.public.MatchingItemsUpdate}
 */
proto.fusion.public.RemoveIngredient.Response.prototype.getUpdate = function() {
  return /** @type{?proto.fusion.public.MatchingItemsUpdate} */ (
    jspb.Message.getWrapperField(this, proto.fusion.public.MatchingItemsUpdate, 1));
};


/**
 * @param {?proto.fusion.public.MatchingItemsUpdate|undefined} value
 * @return {!proto.fusion.public.RemoveIngredient.Response} returns this
*/
proto.fusion.public.RemoveIngredient.Response.prototype.setUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fusion.public.RemoveIngredient.Response} returns this
 */
proto.fusion.public.RemoveIngredient.Response.prototype.clearUpdate = function() {
  return this.setUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fusion.public.RemoveIngredient.Response.prototype.hasUpdate = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fusion.public.MatchingItemsUpdate.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.MatchingItemsUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.MatchingItemsUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.MatchingItemsUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.MatchingItemsUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipesList: jspb.Message.toObjectList(msg.getRecipesList(),
    proto.fusion.public.MatchingItemsUpdate.Recipe.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.MatchingItemsUpdate}
 */
proto.fusion.public.MatchingItemsUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.MatchingItemsUpdate;
  return proto.fusion.public.MatchingItemsUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.MatchingItemsUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.MatchingItemsUpdate}
 */
proto.fusion.public.MatchingItemsUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fusion.public.MatchingItemsUpdate.Recipe;
      reader.readMessage(value,proto.fusion.public.MatchingItemsUpdate.Recipe.deserializeBinaryFromReader);
      msg.addRecipes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.MatchingItemsUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.MatchingItemsUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.MatchingItemsUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.MatchingItemsUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fusion.public.MatchingItemsUpdate.Recipe.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.MatchingItemsUpdate.Recipe.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.MatchingItemsUpdate.Recipe} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotsList: jspb.Message.toObjectList(msg.getSlotsList(),
    proto.fusion.public.MatchingItemsUpdate.Slot.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.MatchingItemsUpdate.Recipe}
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.MatchingItemsUpdate.Recipe;
  return proto.fusion.public.MatchingItemsUpdate.Recipe.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.MatchingItemsUpdate.Recipe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.MatchingItemsUpdate.Recipe}
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.fusion.public.MatchingItemsUpdate.Slot;
      reader.readMessage(value,proto.fusion.public.MatchingItemsUpdate.Slot.deserializeBinaryFromReader);
      msg.addSlots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.MatchingItemsUpdate.Recipe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.MatchingItemsUpdate.Recipe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fusion.public.MatchingItemsUpdate.Slot.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.MatchingItemsUpdate.Recipe} returns this
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Slot slots = 2;
 * @return {!Array<!proto.fusion.public.MatchingItemsUpdate.Slot>}
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.prototype.getSlotsList = function() {
  return /** @type{!Array<!proto.fusion.public.MatchingItemsUpdate.Slot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fusion.public.MatchingItemsUpdate.Slot, 2));
};


/**
 * @param {!Array<!proto.fusion.public.MatchingItemsUpdate.Slot>} value
 * @return {!proto.fusion.public.MatchingItemsUpdate.Recipe} returns this
*/
proto.fusion.public.MatchingItemsUpdate.Recipe.prototype.setSlotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fusion.public.MatchingItemsUpdate.Slot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fusion.public.MatchingItemsUpdate.Slot}
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.prototype.addSlots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fusion.public.MatchingItemsUpdate.Slot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fusion.public.MatchingItemsUpdate.Recipe} returns this
 */
proto.fusion.public.MatchingItemsUpdate.Recipe.prototype.clearSlotsList = function() {
  return this.setSlotsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.MatchingItemsUpdate.Slot.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.MatchingItemsUpdate.Slot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.MatchingItemsUpdate.Slot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.MatchingItemsUpdate.Slot.toObject = function(includeInstance, msg) {
  var f, obj = {
    number: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hasMatchingItem: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.MatchingItemsUpdate.Slot}
 */
proto.fusion.public.MatchingItemsUpdate.Slot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.MatchingItemsUpdate.Slot;
  return proto.fusion.public.MatchingItemsUpdate.Slot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.MatchingItemsUpdate.Slot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.MatchingItemsUpdate.Slot}
 */
proto.fusion.public.MatchingItemsUpdate.Slot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumber(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasMatchingItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.MatchingItemsUpdate.Slot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.MatchingItemsUpdate.Slot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.MatchingItemsUpdate.Slot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.MatchingItemsUpdate.Slot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumber();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getHasMatchingItem();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional uint32 number = 1;
 * @return {number}
 */
proto.fusion.public.MatchingItemsUpdate.Slot.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fusion.public.MatchingItemsUpdate.Slot} returns this
 */
proto.fusion.public.MatchingItemsUpdate.Slot.prototype.setNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool has_matching_item = 2;
 * @return {boolean}
 */
proto.fusion.public.MatchingItemsUpdate.Slot.prototype.getHasMatchingItem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fusion.public.MatchingItemsUpdate.Slot} returns this
 */
proto.fusion.public.MatchingItemsUpdate.Slot.prototype.setHasMatchingItem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Recipe recipes = 1;
 * @return {!Array<!proto.fusion.public.MatchingItemsUpdate.Recipe>}
 */
proto.fusion.public.MatchingItemsUpdate.prototype.getRecipesList = function() {
  return /** @type{!Array<!proto.fusion.public.MatchingItemsUpdate.Recipe>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fusion.public.MatchingItemsUpdate.Recipe, 1));
};


/**
 * @param {!Array<!proto.fusion.public.MatchingItemsUpdate.Recipe>} value
 * @return {!proto.fusion.public.MatchingItemsUpdate} returns this
*/
proto.fusion.public.MatchingItemsUpdate.prototype.setRecipesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fusion.public.MatchingItemsUpdate.Recipe=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fusion.public.MatchingItemsUpdate.Recipe}
 */
proto.fusion.public.MatchingItemsUpdate.prototype.addRecipes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fusion.public.MatchingItemsUpdate.Recipe, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fusion.public.MatchingItemsUpdate} returns this
 */
proto.fusion.public.MatchingItemsUpdate.prototype.clearRecipesList = function() {
  return this.setRecipesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.UpdateRecipeStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.UpdateRecipeStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.UpdateRecipeStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.UpdateRecipeStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.UpdateRecipeStatus}
 */
proto.fusion.public.UpdateRecipeStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.UpdateRecipeStatus;
  return proto.fusion.public.UpdateRecipeStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.UpdateRecipeStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.UpdateRecipeStatus}
 */
proto.fusion.public.UpdateRecipeStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.UpdateRecipeStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.UpdateRecipeStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.UpdateRecipeStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.UpdateRecipeStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.UpdateRecipeStatus.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.UpdateRecipeStatus.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.UpdateRecipeStatus.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.UpdateRecipeStatus.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.UpdateRecipeStatus.Request}
 */
proto.fusion.public.UpdateRecipeStatus.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.UpdateRecipeStatus.Request;
  return proto.fusion.public.UpdateRecipeStatus.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.UpdateRecipeStatus.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.UpdateRecipeStatus.Request}
 */
proto.fusion.public.UpdateRecipeStatus.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.UpdateRecipeStatus.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.UpdateRecipeStatus.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.UpdateRecipeStatus.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.UpdateRecipeStatus.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string recipe_id = 1;
 * @return {string}
 */
proto.fusion.public.UpdateRecipeStatus.Request.prototype.getRecipeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fusion.public.UpdateRecipeStatus.Request} returns this
 */
proto.fusion.public.UpdateRecipeStatus.Request.prototype.setRecipeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.UpdateRecipeStatus.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.UpdateRecipeStatus.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.UpdateRecipeStatus.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.UpdateRecipeStatus.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.UpdateRecipeStatus.Response}
 */
proto.fusion.public.UpdateRecipeStatus.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.UpdateRecipeStatus.Response;
  return proto.fusion.public.UpdateRecipeStatus.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.UpdateRecipeStatus.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.UpdateRecipeStatus.Response}
 */
proto.fusion.public.UpdateRecipeStatus.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.UpdateRecipeStatus.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.UpdateRecipeStatus.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.UpdateRecipeStatus.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.UpdateRecipeStatus.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetIngredients.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetIngredients.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetIngredients} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetIngredients.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetIngredients}
 */
proto.fusion.public.GetIngredients.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetIngredients;
  return proto.fusion.public.GetIngredients.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetIngredients} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetIngredients}
 */
proto.fusion.public.GetIngredients.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetIngredients.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetIngredients.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetIngredients} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetIngredients.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetIngredients.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetIngredients.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetIngredients.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetIngredients.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetIngredients.Request}
 */
proto.fusion.public.GetIngredients.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetIngredients.Request;
  return proto.fusion.public.GetIngredients.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetIngredients.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetIngredients.Request}
 */
proto.fusion.public.GetIngredients.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetIngredients.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetIngredients.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetIngredients.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetIngredients.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fusion.public.GetIngredients.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fusion.public.GetIngredients.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fusion.public.GetIngredients.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fusion.public.GetIngredients.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetIngredients.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    ingredientsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fusion.public.GetIngredients.Response}
 */
proto.fusion.public.GetIngredients.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fusion.public.GetIngredients.Response;
  return proto.fusion.public.GetIngredients.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fusion.public.GetIngredients.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fusion.public.GetIngredients.Response}
 */
proto.fusion.public.GetIngredients.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIngredients(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fusion.public.GetIngredients.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fusion.public.GetIngredients.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fusion.public.GetIngredients.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fusion.public.GetIngredients.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIngredientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ingredients = 1;
 * @return {!Array<string>}
 */
proto.fusion.public.GetIngredients.Response.prototype.getIngredientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fusion.public.GetIngredients.Response} returns this
 */
proto.fusion.public.GetIngredients.Response.prototype.setIngredientsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fusion.public.GetIngredients.Response} returns this
 */
proto.fusion.public.GetIngredients.Response.prototype.addIngredients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fusion.public.GetIngredients.Response} returns this
 */
proto.fusion.public.GetIngredients.Response.prototype.clearIngredientsList = function() {
  return this.setIngredientsList([]);
};


goog.object.extend(exports, proto.fusion.public);

},{"../validate/validate_pb.js":43,"google-protobuf":3,"google-protobuf/google/protobuf/timestamp_pb.js":6}],43:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],44:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for gacha
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var shared_types_pb = require('../shared/types_pb.js')
const proto = {};
proto.gacha = require('./gacha.public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gacha.SlotsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gacha.SlotsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.gacha.GetShootingRange.Request,
 *   !proto.gacha.GetShootingRange.Response>}
 */
const methodDescriptor_Slots_GetShootingRange = new grpc.web.MethodDescriptor(
  '/gacha.Slots/GetShootingRange',
  grpc.web.MethodType.UNARY,
  proto.gacha.GetShootingRange.Request,
  proto.gacha.GetShootingRange.Response,
  /**
   * @param {!proto.gacha.GetShootingRange.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.gacha.GetShootingRange.Response.deserializeBinary
);


/**
 * @param {!proto.gacha.GetShootingRange.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.gacha.GetShootingRange.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.gacha.GetShootingRange.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.gacha.SlotsClient.prototype.getShootingRange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/gacha.Slots/GetShootingRange',
      request,
      metadata || {},
      methodDescriptor_Slots_GetShootingRange,
      callback);
};


/**
 * @param {!proto.gacha.GetShootingRange.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.gacha.GetShootingRange.Response>}
 *     Promise that resolves to the response
 */
proto.gacha.SlotsPromiseClient.prototype.getShootingRange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/gacha.Slots/GetShootingRange',
      request,
      metadata || {},
      methodDescriptor_Slots_GetShootingRange);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gacha.DicesClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gacha.DicesPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.gacha.RollShootingRangeDice.Request,
 *   !proto.gacha.RollShootingRangeDice.Response>}
 */
const methodDescriptor_Dices_RollShootingRange = new grpc.web.MethodDescriptor(
  '/gacha.Dices/RollShootingRange',
  grpc.web.MethodType.UNARY,
  proto.gacha.RollShootingRangeDice.Request,
  proto.gacha.RollShootingRangeDice.Response,
  /**
   * @param {!proto.gacha.RollShootingRangeDice.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.gacha.RollShootingRangeDice.Response.deserializeBinary
);


/**
 * @param {!proto.gacha.RollShootingRangeDice.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.gacha.RollShootingRangeDice.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.gacha.RollShootingRangeDice.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.gacha.DicesClient.prototype.rollShootingRange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/gacha.Dices/RollShootingRange',
      request,
      metadata || {},
      methodDescriptor_Dices_RollShootingRange,
      callback);
};


/**
 * @param {!proto.gacha.RollShootingRangeDice.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.gacha.RollShootingRangeDice.Response>}
 *     Promise that resolves to the response
 */
proto.gacha.DicesPromiseClient.prototype.rollShootingRange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/gacha.Dices/RollShootingRange',
      request,
      metadata || {},
      methodDescriptor_Dices_RollShootingRange);
};


module.exports = proto.gacha;


},{"../shared/types_pb.js":46,"../validate/validate_pb.js":47,"./gacha.public_pb.js":45,"grpc-web":7}],45:[function(require,module,exports){
// source: public/gacha.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var shared_types_pb = require('../shared/types_pb.js');
goog.object.extend(proto, shared_types_pb);
goog.exportSymbol('proto.gacha.GetShootingRange', null, global);
goog.exportSymbol('proto.gacha.GetShootingRange.MatchStreak', null, global);
goog.exportSymbol('proto.gacha.GetShootingRange.Request', null, global);
goog.exportSymbol('proto.gacha.GetShootingRange.Response', null, global);
goog.exportSymbol('proto.gacha.Reward', null, global);
goog.exportSymbol('proto.gacha.Reward.BPPoints', null, global);
goog.exportSymbol('proto.gacha.Reward.Currency', null, global);
goog.exportSymbol('proto.gacha.Reward.Gamedata', null, global);
goog.exportSymbol('proto.gacha.Reward.Item', null, global);
goog.exportSymbol('proto.gacha.Reward.Item.ContentCase', null, global);
goog.exportSymbol('proto.gacha.Reward.Mintable', null, global);
goog.exportSymbol('proto.gacha.Reward.Mintable.Item', null, global);
goog.exportSymbol('proto.gacha.RollShootingRangeDice', null, global);
goog.exportSymbol('proto.gacha.RollShootingRangeDice.Request', null, global);
goog.exportSymbol('proto.gacha.RollShootingRangeDice.Response', null, global);
goog.exportSymbol('proto.gacha.State', null, global);
goog.exportSymbol('proto.gacha.State.RewardsList', null, global);
goog.exportSymbol('proto.gacha.State.RewardsList.Item', null, global);
goog.exportSymbol('proto.gacha.State.Roll', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.GetShootingRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.GetShootingRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.GetShootingRange.displayName = 'proto.gacha.GetShootingRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.GetShootingRange.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.GetShootingRange.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.GetShootingRange.Request.displayName = 'proto.gacha.GetShootingRange.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.GetShootingRange.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.GetShootingRange.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.GetShootingRange.Response.displayName = 'proto.gacha.GetShootingRange.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.GetShootingRange.MatchStreak = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.GetShootingRange.MatchStreak, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.GetShootingRange.MatchStreak.displayName = 'proto.gacha.GetShootingRange.MatchStreak';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.State = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.State, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.State.displayName = 'proto.gacha.State';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.State.Roll = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.State.Roll, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.State.Roll.displayName = 'proto.gacha.State.Roll';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.State.RewardsList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gacha.State.RewardsList.repeatedFields_, null);
};
goog.inherits(proto.gacha.State.RewardsList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.State.RewardsList.displayName = 'proto.gacha.State.RewardsList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.State.RewardsList.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.State.RewardsList.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.State.RewardsList.Item.displayName = 'proto.gacha.State.RewardsList.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.RollShootingRangeDice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.RollShootingRangeDice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.RollShootingRangeDice.displayName = 'proto.gacha.RollShootingRangeDice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.RollShootingRangeDice.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.RollShootingRangeDice.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.RollShootingRangeDice.Request.displayName = 'proto.gacha.RollShootingRangeDice.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.RollShootingRangeDice.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.RollShootingRangeDice.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.RollShootingRangeDice.Response.displayName = 'proto.gacha.RollShootingRangeDice.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.Reward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gacha.Reward.repeatedFields_, null);
};
goog.inherits(proto.gacha.Reward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.Reward.displayName = 'proto.gacha.Reward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.Reward.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.gacha.Reward.Item.oneofGroups_);
};
goog.inherits(proto.gacha.Reward.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.Reward.Item.displayName = 'proto.gacha.Reward.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.Reward.Gamedata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gacha.Reward.Gamedata.repeatedFields_, null);
};
goog.inherits(proto.gacha.Reward.Gamedata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.Reward.Gamedata.displayName = 'proto.gacha.Reward.Gamedata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.Reward.Mintable = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gacha.Reward.Mintable.repeatedFields_, null);
};
goog.inherits(proto.gacha.Reward.Mintable, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.Reward.Mintable.displayName = 'proto.gacha.Reward.Mintable';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.Reward.Mintable.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.Reward.Mintable.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.Reward.Mintable.Item.displayName = 'proto.gacha.Reward.Mintable.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.Reward.Currency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.Reward.Currency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.Reward.Currency.displayName = 'proto.gacha.Reward.Currency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.Reward.BPPoints = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.Reward.BPPoints, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.Reward.BPPoints.displayName = 'proto.gacha.Reward.BPPoints';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.GetShootingRange.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.GetShootingRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.GetShootingRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.GetShootingRange.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.GetShootingRange}
 */
proto.gacha.GetShootingRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.GetShootingRange;
  return proto.gacha.GetShootingRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.GetShootingRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.GetShootingRange}
 */
proto.gacha.GetShootingRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.GetShootingRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.GetShootingRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.GetShootingRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.GetShootingRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.GetShootingRange.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.GetShootingRange.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.GetShootingRange.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.GetShootingRange.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.GetShootingRange.Request}
 */
proto.gacha.GetShootingRange.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.GetShootingRange.Request;
  return proto.gacha.GetShootingRange.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.GetShootingRange.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.GetShootingRange.Request}
 */
proto.gacha.GetShootingRange.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.GetShootingRange.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.GetShootingRange.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.GetShootingRange.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.GetShootingRange.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.GetShootingRange.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.GetShootingRange.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.GetShootingRange.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.GetShootingRange.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: (f = msg.getState()) && proto.gacha.State.toObject(includeInstance, f),
    streak: (f = msg.getStreak()) && proto.gacha.GetShootingRange.MatchStreak.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.GetShootingRange.Response}
 */
proto.gacha.GetShootingRange.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.GetShootingRange.Response;
  return proto.gacha.GetShootingRange.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.GetShootingRange.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.GetShootingRange.Response}
 */
proto.gacha.GetShootingRange.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gacha.State;
      reader.readMessage(value,proto.gacha.State.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 2:
      var value = new proto.gacha.GetShootingRange.MatchStreak;
      reader.readMessage(value,proto.gacha.GetShootingRange.MatchStreak.deserializeBinaryFromReader);
      msg.setStreak(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.GetShootingRange.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.GetShootingRange.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.GetShootingRange.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.GetShootingRange.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gacha.State.serializeBinaryToWriter
    );
  }
  f = message.getStreak();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gacha.GetShootingRange.MatchStreak.serializeBinaryToWriter
    );
  }
};


/**
 * optional State state = 1;
 * @return {?proto.gacha.State}
 */
proto.gacha.GetShootingRange.Response.prototype.getState = function() {
  return /** @type{?proto.gacha.State} */ (
    jspb.Message.getWrapperField(this, proto.gacha.State, 1));
};


/**
 * @param {?proto.gacha.State|undefined} value
 * @return {!proto.gacha.GetShootingRange.Response} returns this
*/
proto.gacha.GetShootingRange.Response.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.GetShootingRange.Response} returns this
 */
proto.gacha.GetShootingRange.Response.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.GetShootingRange.Response.prototype.hasState = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MatchStreak streak = 2;
 * @return {?proto.gacha.GetShootingRange.MatchStreak}
 */
proto.gacha.GetShootingRange.Response.prototype.getStreak = function() {
  return /** @type{?proto.gacha.GetShootingRange.MatchStreak} */ (
    jspb.Message.getWrapperField(this, proto.gacha.GetShootingRange.MatchStreak, 2));
};


/**
 * @param {?proto.gacha.GetShootingRange.MatchStreak|undefined} value
 * @return {!proto.gacha.GetShootingRange.Response} returns this
*/
proto.gacha.GetShootingRange.Response.prototype.setStreak = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.GetShootingRange.Response} returns this
 */
proto.gacha.GetShootingRange.Response.prototype.clearStreak = function() {
  return this.setStreak(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.GetShootingRange.Response.prototype.hasStreak = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.GetShootingRange.MatchStreak.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.GetShootingRange.MatchStreak.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.GetShootingRange.MatchStreak} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.GetShootingRange.MatchStreak.toObject = function(includeInstance, msg) {
  var f, obj = {
    goal: jspb.Message.getFieldWithDefault(msg, 1, 0),
    current: jspb.Message.getFieldWithDefault(msg, 2, 0),
    breakDuration: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.GetShootingRange.MatchStreak}
 */
proto.gacha.GetShootingRange.MatchStreak.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.GetShootingRange.MatchStreak;
  return proto.gacha.GetShootingRange.MatchStreak.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.GetShootingRange.MatchStreak} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.GetShootingRange.MatchStreak}
 */
proto.gacha.GetShootingRange.MatchStreak.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGoal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBreakDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.GetShootingRange.MatchStreak.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.GetShootingRange.MatchStreak.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.GetShootingRange.MatchStreak} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.GetShootingRange.MatchStreak.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGoal();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCurrent();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBreakDuration();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 goal = 1;
 * @return {number}
 */
proto.gacha.GetShootingRange.MatchStreak.prototype.getGoal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gacha.GetShootingRange.MatchStreak} returns this
 */
proto.gacha.GetShootingRange.MatchStreak.prototype.setGoal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 current = 2;
 * @return {number}
 */
proto.gacha.GetShootingRange.MatchStreak.prototype.getCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.gacha.GetShootingRange.MatchStreak} returns this
 */
proto.gacha.GetShootingRange.MatchStreak.prototype.setCurrent = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 break_duration = 3;
 * @return {number}
 */
proto.gacha.GetShootingRange.MatchStreak.prototype.getBreakDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.gacha.GetShootingRange.MatchStreak} returns this
 */
proto.gacha.GetShootingRange.MatchStreak.prototype.setBreakDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.State.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.State.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.State} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.State.toObject = function(includeInstance, msg) {
  var f, obj = {
    roll: (f = msg.getRoll()) && proto.gacha.State.Roll.toObject(includeInstance, f),
    rewardsList: (f = msg.getRewardsList()) && proto.gacha.State.RewardsList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.State}
 */
proto.gacha.State.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.State;
  return proto.gacha.State.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.State} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.State}
 */
proto.gacha.State.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gacha.State.Roll;
      reader.readMessage(value,proto.gacha.State.Roll.deserializeBinaryFromReader);
      msg.setRoll(value);
      break;
    case 2:
      var value = new proto.gacha.State.RewardsList;
      reader.readMessage(value,proto.gacha.State.RewardsList.deserializeBinaryFromReader);
      msg.setRewardsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.State.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.State.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.State} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.State.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoll();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gacha.State.Roll.serializeBinaryToWriter
    );
  }
  f = message.getRewardsList();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gacha.State.RewardsList.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.State.Roll.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.State.Roll.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.State.Roll} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.State.Roll.toObject = function(includeInstance, msg) {
  var f, obj = {
    isAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.State.Roll}
 */
proto.gacha.State.Roll.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.State.Roll;
  return proto.gacha.State.Roll.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.State.Roll} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.State.Roll}
 */
proto.gacha.State.Roll.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAvailable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.State.Roll.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.State.Roll.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.State.Roll} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.State.Roll.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsAvailable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_available = 1;
 * @return {boolean}
 */
proto.gacha.State.Roll.prototype.getIsAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.gacha.State.Roll} returns this
 */
proto.gacha.State.Roll.prototype.setIsAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gacha.State.RewardsList.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.State.RewardsList.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.State.RewardsList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.State.RewardsList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.State.RewardsList.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && shared_types_pb.UUID.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.gacha.State.RewardsList.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.State.RewardsList}
 */
proto.gacha.State.RewardsList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.State.RewardsList;
  return proto.gacha.State.RewardsList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.State.RewardsList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.State.RewardsList}
 */
proto.gacha.State.RewardsList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_pb.UUID;
      reader.readMessage(value,shared_types_pb.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new proto.gacha.State.RewardsList.Item;
      reader.readMessage(value,proto.gacha.State.RewardsList.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.State.RewardsList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.State.RewardsList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.State.RewardsList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.State.RewardsList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_types_pb.UUID.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.gacha.State.RewardsList.Item.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.State.RewardsList.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.State.RewardsList.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.State.RewardsList.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.State.RewardsList.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    reward: (f = msg.getReward()) && proto.gacha.Reward.toObject(includeInstance, f),
    chance: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isGeneral: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.State.RewardsList.Item}
 */
proto.gacha.State.RewardsList.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.State.RewardsList.Item;
  return proto.gacha.State.RewardsList.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.State.RewardsList.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.State.RewardsList.Item}
 */
proto.gacha.State.RewardsList.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gacha.Reward;
      reader.readMessage(value,proto.gacha.Reward.deserializeBinaryFromReader);
      msg.setReward(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChance(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGeneral(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.State.RewardsList.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.State.RewardsList.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.State.RewardsList.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.State.RewardsList.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReward();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gacha.Reward.serializeBinaryToWriter
    );
  }
  f = message.getChance();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsGeneral();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional Reward reward = 1;
 * @return {?proto.gacha.Reward}
 */
proto.gacha.State.RewardsList.Item.prototype.getReward = function() {
  return /** @type{?proto.gacha.Reward} */ (
    jspb.Message.getWrapperField(this, proto.gacha.Reward, 1));
};


/**
 * @param {?proto.gacha.Reward|undefined} value
 * @return {!proto.gacha.State.RewardsList.Item} returns this
*/
proto.gacha.State.RewardsList.Item.prototype.setReward = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.State.RewardsList.Item} returns this
 */
proto.gacha.State.RewardsList.Item.prototype.clearReward = function() {
  return this.setReward(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.State.RewardsList.Item.prototype.hasReward = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string chance = 2;
 * @return {string}
 */
proto.gacha.State.RewardsList.Item.prototype.getChance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.gacha.State.RewardsList.Item} returns this
 */
proto.gacha.State.RewardsList.Item.prototype.setChance = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_general = 3;
 * @return {boolean}
 */
proto.gacha.State.RewardsList.Item.prototype.getIsGeneral = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.gacha.State.RewardsList.Item} returns this
 */
proto.gacha.State.RewardsList.Item.prototype.setIsGeneral = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional UUID id = 1;
 * @return {?proto.gacha.UUID}
 */
proto.gacha.State.RewardsList.prototype.getId = function() {
  return /** @type{?proto.gacha.UUID} */ (
    jspb.Message.getWrapperField(this, shared_types_pb.UUID, 1));
};


/**
 * @param {?proto.gacha.UUID|undefined} value
 * @return {!proto.gacha.State.RewardsList} returns this
*/
proto.gacha.State.RewardsList.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.State.RewardsList} returns this
 */
proto.gacha.State.RewardsList.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.State.RewardsList.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Item items = 2;
 * @return {!Array<!proto.gacha.State.RewardsList.Item>}
 */
proto.gacha.State.RewardsList.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.gacha.State.RewardsList.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gacha.State.RewardsList.Item, 2));
};


/**
 * @param {!Array<!proto.gacha.State.RewardsList.Item>} value
 * @return {!proto.gacha.State.RewardsList} returns this
*/
proto.gacha.State.RewardsList.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.gacha.State.RewardsList.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gacha.State.RewardsList.Item}
 */
proto.gacha.State.RewardsList.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.gacha.State.RewardsList.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gacha.State.RewardsList} returns this
 */
proto.gacha.State.RewardsList.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional Roll roll = 1;
 * @return {?proto.gacha.State.Roll}
 */
proto.gacha.State.prototype.getRoll = function() {
  return /** @type{?proto.gacha.State.Roll} */ (
    jspb.Message.getWrapperField(this, proto.gacha.State.Roll, 1));
};


/**
 * @param {?proto.gacha.State.Roll|undefined} value
 * @return {!proto.gacha.State} returns this
*/
proto.gacha.State.prototype.setRoll = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.State} returns this
 */
proto.gacha.State.prototype.clearRoll = function() {
  return this.setRoll(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.State.prototype.hasRoll = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RewardsList rewards_list = 2;
 * @return {?proto.gacha.State.RewardsList}
 */
proto.gacha.State.prototype.getRewardsList = function() {
  return /** @type{?proto.gacha.State.RewardsList} */ (
    jspb.Message.getWrapperField(this, proto.gacha.State.RewardsList, 2));
};


/**
 * @param {?proto.gacha.State.RewardsList|undefined} value
 * @return {!proto.gacha.State} returns this
*/
proto.gacha.State.prototype.setRewardsList = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.State} returns this
 */
proto.gacha.State.prototype.clearRewardsList = function() {
  return this.setRewardsList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.State.prototype.hasRewardsList = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.RollShootingRangeDice.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.RollShootingRangeDice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.RollShootingRangeDice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.RollShootingRangeDice.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.RollShootingRangeDice}
 */
proto.gacha.RollShootingRangeDice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.RollShootingRangeDice;
  return proto.gacha.RollShootingRangeDice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.RollShootingRangeDice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.RollShootingRangeDice}
 */
proto.gacha.RollShootingRangeDice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.RollShootingRangeDice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.RollShootingRangeDice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.RollShootingRangeDice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.RollShootingRangeDice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.RollShootingRangeDice.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.RollShootingRangeDice.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.RollShootingRangeDice.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.RollShootingRangeDice.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    rewardsListId: (f = msg.getRewardsListId()) && shared_types_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.RollShootingRangeDice.Request}
 */
proto.gacha.RollShootingRangeDice.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.RollShootingRangeDice.Request;
  return proto.gacha.RollShootingRangeDice.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.RollShootingRangeDice.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.RollShootingRangeDice.Request}
 */
proto.gacha.RollShootingRangeDice.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_pb.UUID;
      reader.readMessage(value,shared_types_pb.UUID.deserializeBinaryFromReader);
      msg.setRewardsListId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.RollShootingRangeDice.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.RollShootingRangeDice.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.RollShootingRangeDice.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.RollShootingRangeDice.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRewardsListId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_types_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID rewards_list_id = 1;
 * @return {?proto.gacha.UUID}
 */
proto.gacha.RollShootingRangeDice.Request.prototype.getRewardsListId = function() {
  return /** @type{?proto.gacha.UUID} */ (
    jspb.Message.getWrapperField(this, shared_types_pb.UUID, 1));
};


/**
 * @param {?proto.gacha.UUID|undefined} value
 * @return {!proto.gacha.RollShootingRangeDice.Request} returns this
*/
proto.gacha.RollShootingRangeDice.Request.prototype.setRewardsListId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.RollShootingRangeDice.Request} returns this
 */
proto.gacha.RollShootingRangeDice.Request.prototype.clearRewardsListId = function() {
  return this.setRewardsListId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.RollShootingRangeDice.Request.prototype.hasRewardsListId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.RollShootingRangeDice.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.RollShootingRangeDice.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.RollShootingRangeDice.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.RollShootingRangeDice.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    reward: (f = msg.getReward()) && proto.gacha.Reward.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.RollShootingRangeDice.Response}
 */
proto.gacha.RollShootingRangeDice.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.RollShootingRangeDice.Response;
  return proto.gacha.RollShootingRangeDice.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.RollShootingRangeDice.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.RollShootingRangeDice.Response}
 */
proto.gacha.RollShootingRangeDice.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gacha.Reward;
      reader.readMessage(value,proto.gacha.Reward.deserializeBinaryFromReader);
      msg.setReward(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.RollShootingRangeDice.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.RollShootingRangeDice.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.RollShootingRangeDice.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.RollShootingRangeDice.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReward();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gacha.Reward.serializeBinaryToWriter
    );
  }
};


/**
 * optional Reward reward = 1;
 * @return {?proto.gacha.Reward}
 */
proto.gacha.RollShootingRangeDice.Response.prototype.getReward = function() {
  return /** @type{?proto.gacha.Reward} */ (
    jspb.Message.getWrapperField(this, proto.gacha.Reward, 1));
};


/**
 * @param {?proto.gacha.Reward|undefined} value
 * @return {!proto.gacha.RollShootingRangeDice.Response} returns this
*/
proto.gacha.RollShootingRangeDice.Response.prototype.setReward = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.RollShootingRangeDice.Response} returns this
 */
proto.gacha.RollShootingRangeDice.Response.prototype.clearReward = function() {
  return this.setReward(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.RollShootingRangeDice.Response.prototype.hasReward = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gacha.Reward.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.Reward.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.Reward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.Reward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && shared_types_pb.UUID.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.gacha.Reward.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.Reward}
 */
proto.gacha.Reward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.Reward;
  return proto.gacha.Reward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.Reward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.Reward}
 */
proto.gacha.Reward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_pb.UUID;
      reader.readMessage(value,shared_types_pb.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new proto.gacha.Reward.Item;
      reader.readMessage(value,proto.gacha.Reward.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.Reward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.Reward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.Reward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      shared_types_pb.UUID.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.gacha.Reward.Item.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.gacha.Reward.Item.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.gacha.Reward.Item.ContentCase = {
  CONTENT_NOT_SET: 0,
  GAMEDATA: 1,
  MINTABLE: 2,
  CURRENCY: 3,
  BP_POINTS: 4
};

/**
 * @return {proto.gacha.Reward.Item.ContentCase}
 */
proto.gacha.Reward.Item.prototype.getContentCase = function() {
  return /** @type {proto.gacha.Reward.Item.ContentCase} */(jspb.Message.computeOneofCase(this, proto.gacha.Reward.Item.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.Reward.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.Reward.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.Reward.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    gamedata: (f = msg.getGamedata()) && proto.gacha.Reward.Gamedata.toObject(includeInstance, f),
    mintable: (f = msg.getMintable()) && proto.gacha.Reward.Mintable.toObject(includeInstance, f),
    currency: (f = msg.getCurrency()) && proto.gacha.Reward.Currency.toObject(includeInstance, f),
    bpPoints: (f = msg.getBpPoints()) && proto.gacha.Reward.BPPoints.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.Reward.Item}
 */
proto.gacha.Reward.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.Reward.Item;
  return proto.gacha.Reward.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.Reward.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.Reward.Item}
 */
proto.gacha.Reward.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gacha.Reward.Gamedata;
      reader.readMessage(value,proto.gacha.Reward.Gamedata.deserializeBinaryFromReader);
      msg.setGamedata(value);
      break;
    case 2:
      var value = new proto.gacha.Reward.Mintable;
      reader.readMessage(value,proto.gacha.Reward.Mintable.deserializeBinaryFromReader);
      msg.setMintable(value);
      break;
    case 3:
      var value = new proto.gacha.Reward.Currency;
      reader.readMessage(value,proto.gacha.Reward.Currency.deserializeBinaryFromReader);
      msg.setCurrency(value);
      break;
    case 4:
      var value = new proto.gacha.Reward.BPPoints;
      reader.readMessage(value,proto.gacha.Reward.BPPoints.deserializeBinaryFromReader);
      msg.setBpPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.Reward.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.Reward.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.Reward.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGamedata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gacha.Reward.Gamedata.serializeBinaryToWriter
    );
  }
  f = message.getMintable();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gacha.Reward.Mintable.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.gacha.Reward.Currency.serializeBinaryToWriter
    );
  }
  f = message.getBpPoints();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.gacha.Reward.BPPoints.serializeBinaryToWriter
    );
  }
};


/**
 * optional Gamedata gamedata = 1;
 * @return {?proto.gacha.Reward.Gamedata}
 */
proto.gacha.Reward.Item.prototype.getGamedata = function() {
  return /** @type{?proto.gacha.Reward.Gamedata} */ (
    jspb.Message.getWrapperField(this, proto.gacha.Reward.Gamedata, 1));
};


/**
 * @param {?proto.gacha.Reward.Gamedata|undefined} value
 * @return {!proto.gacha.Reward.Item} returns this
*/
proto.gacha.Reward.Item.prototype.setGamedata = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.gacha.Reward.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.Reward.Item} returns this
 */
proto.gacha.Reward.Item.prototype.clearGamedata = function() {
  return this.setGamedata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.Reward.Item.prototype.hasGamedata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Mintable mintable = 2;
 * @return {?proto.gacha.Reward.Mintable}
 */
proto.gacha.Reward.Item.prototype.getMintable = function() {
  return /** @type{?proto.gacha.Reward.Mintable} */ (
    jspb.Message.getWrapperField(this, proto.gacha.Reward.Mintable, 2));
};


/**
 * @param {?proto.gacha.Reward.Mintable|undefined} value
 * @return {!proto.gacha.Reward.Item} returns this
*/
proto.gacha.Reward.Item.prototype.setMintable = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.gacha.Reward.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.Reward.Item} returns this
 */
proto.gacha.Reward.Item.prototype.clearMintable = function() {
  return this.setMintable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.Reward.Item.prototype.hasMintable = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Currency currency = 3;
 * @return {?proto.gacha.Reward.Currency}
 */
proto.gacha.Reward.Item.prototype.getCurrency = function() {
  return /** @type{?proto.gacha.Reward.Currency} */ (
    jspb.Message.getWrapperField(this, proto.gacha.Reward.Currency, 3));
};


/**
 * @param {?proto.gacha.Reward.Currency|undefined} value
 * @return {!proto.gacha.Reward.Item} returns this
*/
proto.gacha.Reward.Item.prototype.setCurrency = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.gacha.Reward.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.Reward.Item} returns this
 */
proto.gacha.Reward.Item.prototype.clearCurrency = function() {
  return this.setCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.Reward.Item.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional BPPoints bp_points = 4;
 * @return {?proto.gacha.Reward.BPPoints}
 */
proto.gacha.Reward.Item.prototype.getBpPoints = function() {
  return /** @type{?proto.gacha.Reward.BPPoints} */ (
    jspb.Message.getWrapperField(this, proto.gacha.Reward.BPPoints, 4));
};


/**
 * @param {?proto.gacha.Reward.BPPoints|undefined} value
 * @return {!proto.gacha.Reward.Item} returns this
*/
proto.gacha.Reward.Item.prototype.setBpPoints = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.gacha.Reward.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.Reward.Item} returns this
 */
proto.gacha.Reward.Item.prototype.clearBpPoints = function() {
  return this.setBpPoints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.Reward.Item.prototype.hasBpPoints = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gacha.Reward.Gamedata.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.Reward.Gamedata.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.Reward.Gamedata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.Reward.Gamedata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Gamedata.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    shared_types_pb.UUID.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.Reward.Gamedata}
 */
proto.gacha.Reward.Gamedata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.Reward.Gamedata;
  return proto.gacha.Reward.Gamedata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.Reward.Gamedata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.Reward.Gamedata}
 */
proto.gacha.Reward.Gamedata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_pb.UUID;
      reader.readMessage(value,shared_types_pb.UUID.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.Reward.Gamedata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.Reward.Gamedata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.Reward.Gamedata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Gamedata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      shared_types_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UUID items = 1;
 * @return {!Array<!proto.gacha.UUID>}
 */
proto.gacha.Reward.Gamedata.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.gacha.UUID>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_types_pb.UUID, 1));
};


/**
 * @param {!Array<!proto.gacha.UUID>} value
 * @return {!proto.gacha.Reward.Gamedata} returns this
*/
proto.gacha.Reward.Gamedata.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.gacha.UUID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gacha.UUID}
 */
proto.gacha.Reward.Gamedata.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.gacha.UUID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gacha.Reward.Gamedata} returns this
 */
proto.gacha.Reward.Gamedata.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gacha.Reward.Mintable.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.Reward.Mintable.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.Reward.Mintable.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.Reward.Mintable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Mintable.toObject = function(includeInstance, msg) {
  var f, obj = {
    tokensList: jspb.Message.toObjectList(msg.getTokensList(),
    shared_types_pb.UUID.toObject, includeInstance),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.gacha.Reward.Mintable.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.Reward.Mintable}
 */
proto.gacha.Reward.Mintable.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.Reward.Mintable;
  return proto.gacha.Reward.Mintable.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.Reward.Mintable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.Reward.Mintable}
 */
proto.gacha.Reward.Mintable.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_pb.UUID;
      reader.readMessage(value,shared_types_pb.UUID.deserializeBinaryFromReader);
      msg.addTokens(value);
      break;
    case 2:
      var value = new proto.gacha.Reward.Mintable.Item;
      reader.readMessage(value,proto.gacha.Reward.Mintable.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.Reward.Mintable.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.Reward.Mintable.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.Reward.Mintable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Mintable.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTokensList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      shared_types_pb.UUID.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.gacha.Reward.Mintable.Item.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.Reward.Mintable.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.Reward.Mintable.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.Reward.Mintable.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Mintable.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    configId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.Reward.Mintable.Item}
 */
proto.gacha.Reward.Mintable.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.Reward.Mintable.Item;
  return proto.gacha.Reward.Mintable.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.Reward.Mintable.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.Reward.Mintable.Item}
 */
proto.gacha.Reward.Mintable.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.Reward.Mintable.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.Reward.Mintable.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.Reward.Mintable.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Mintable.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.gacha.Reward.Mintable.Item.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gacha.Reward.Mintable.Item} returns this
 */
proto.gacha.Reward.Mintable.Item.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated UUID tokens = 1;
 * @return {!Array<!proto.gacha.UUID>}
 */
proto.gacha.Reward.Mintable.prototype.getTokensList = function() {
  return /** @type{!Array<!proto.gacha.UUID>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_types_pb.UUID, 1));
};


/**
 * @param {!Array<!proto.gacha.UUID>} value
 * @return {!proto.gacha.Reward.Mintable} returns this
*/
proto.gacha.Reward.Mintable.prototype.setTokensList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.gacha.UUID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gacha.UUID}
 */
proto.gacha.Reward.Mintable.prototype.addTokens = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.gacha.UUID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gacha.Reward.Mintable} returns this
 */
proto.gacha.Reward.Mintable.prototype.clearTokensList = function() {
  return this.setTokensList([]);
};


/**
 * repeated Item items = 2;
 * @return {!Array<!proto.gacha.Reward.Mintable.Item>}
 */
proto.gacha.Reward.Mintable.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.gacha.Reward.Mintable.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gacha.Reward.Mintable.Item, 2));
};


/**
 * @param {!Array<!proto.gacha.Reward.Mintable.Item>} value
 * @return {!proto.gacha.Reward.Mintable} returns this
*/
proto.gacha.Reward.Mintable.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.gacha.Reward.Mintable.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gacha.Reward.Mintable.Item}
 */
proto.gacha.Reward.Mintable.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.gacha.Reward.Mintable.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gacha.Reward.Mintable} returns this
 */
proto.gacha.Reward.Mintable.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.Reward.Currency.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.Reward.Currency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.Reward.Currency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Currency.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.Reward.Currency}
 */
proto.gacha.Reward.Currency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.Reward.Currency;
  return proto.gacha.Reward.Currency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.Reward.Currency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.Reward.Currency}
 */
proto.gacha.Reward.Currency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.Reward.Currency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.Reward.Currency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.Reward.Currency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.Currency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 amount = 1;
 * @return {number}
 */
proto.gacha.Reward.Currency.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gacha.Reward.Currency} returns this
 */
proto.gacha.Reward.Currency.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.Reward.BPPoints.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.Reward.BPPoints.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.Reward.BPPoints} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.BPPoints.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.Reward.BPPoints}
 */
proto.gacha.Reward.BPPoints.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.Reward.BPPoints;
  return proto.gacha.Reward.BPPoints.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.Reward.BPPoints} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.Reward.BPPoints}
 */
proto.gacha.Reward.BPPoints.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.Reward.BPPoints.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.Reward.BPPoints.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.Reward.BPPoints} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.Reward.BPPoints.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 amount = 1;
 * @return {number}
 */
proto.gacha.Reward.BPPoints.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gacha.Reward.BPPoints} returns this
 */
proto.gacha.Reward.BPPoints.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional UUID id = 1;
 * @return {?proto.gacha.UUID}
 */
proto.gacha.Reward.prototype.getId = function() {
  return /** @type{?proto.gacha.UUID} */ (
    jspb.Message.getWrapperField(this, shared_types_pb.UUID, 1));
};


/**
 * @param {?proto.gacha.UUID|undefined} value
 * @return {!proto.gacha.Reward} returns this
*/
proto.gacha.Reward.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gacha.Reward} returns this
 */
proto.gacha.Reward.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gacha.Reward.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Item items = 2;
 * @return {!Array<!proto.gacha.Reward.Item>}
 */
proto.gacha.Reward.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.gacha.Reward.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gacha.Reward.Item, 2));
};


/**
 * @param {!Array<!proto.gacha.Reward.Item>} value
 * @return {!proto.gacha.Reward} returns this
*/
proto.gacha.Reward.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.gacha.Reward.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gacha.Reward.Item}
 */
proto.gacha.Reward.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.gacha.Reward.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gacha.Reward} returns this
 */
proto.gacha.Reward.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


goog.object.extend(exports, proto.gacha);

},{"../shared/types_pb.js":46,"../validate/validate_pb.js":47,"google-protobuf":3}],46:[function(require,module,exports){
// source: shared/types.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.gacha.UUID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gacha.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gacha.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gacha.UUID.displayName = 'proto.gacha.UUID';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gacha.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.gacha.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gacha.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gacha.UUID}
 */
proto.gacha.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gacha.UUID;
  return proto.gacha.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gacha.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gacha.UUID}
 */
proto.gacha.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gacha.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gacha.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gacha.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gacha.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.gacha.UUID.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gacha.UUID} returns this
 */
proto.gacha.UUID.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.gacha);

},{"../validate/validate_pb.js":47,"google-protobuf":3}],47:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],48:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for gameaccount
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')
const proto = {};
proto.gameaccount = require('./gameaccount.public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gameaccount.OverviewClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gameaccount.OverviewPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.gameaccount.GetAccount.Request,
 *   !proto.gameaccount.GetAccount.Response>}
 */
const methodDescriptor_Overview_GetAccount = new grpc.web.MethodDescriptor(
  '/gameaccount.Overview/GetAccount',
  grpc.web.MethodType.UNARY,
  proto.gameaccount.GetAccount.Request,
  proto.gameaccount.GetAccount.Response,
  /**
   * @param {!proto.gameaccount.GetAccount.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.gameaccount.GetAccount.Response.deserializeBinary
);


/**
 * @param {!proto.gameaccount.GetAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.gameaccount.GetAccount.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.gameaccount.GetAccount.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.gameaccount.OverviewClient.prototype.getAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/gameaccount.Overview/GetAccount',
      request,
      metadata || {},
      methodDescriptor_Overview_GetAccount,
      callback);
};


/**
 * @param {!proto.gameaccount.GetAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.gameaccount.GetAccount.Response>}
 *     Promise that resolves to the response
 */
proto.gameaccount.OverviewPromiseClient.prototype.getAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/gameaccount.Overview/GetAccount',
      request,
      metadata || {},
      methodDescriptor_Overview_GetAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.gameaccount.GetAccountDetails.Request,
 *   !proto.gameaccount.GetAccountDetails.Response>}
 */
const methodDescriptor_Overview_GetAccountDetails = new grpc.web.MethodDescriptor(
  '/gameaccount.Overview/GetAccountDetails',
  grpc.web.MethodType.UNARY,
  proto.gameaccount.GetAccountDetails.Request,
  proto.gameaccount.GetAccountDetails.Response,
  /**
   * @param {!proto.gameaccount.GetAccountDetails.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.gameaccount.GetAccountDetails.Response.deserializeBinary
);


/**
 * @param {!proto.gameaccount.GetAccountDetails.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.gameaccount.GetAccountDetails.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.gameaccount.GetAccountDetails.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.gameaccount.OverviewClient.prototype.getAccountDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/gameaccount.Overview/GetAccountDetails',
      request,
      metadata || {},
      methodDescriptor_Overview_GetAccountDetails,
      callback);
};


/**
 * @param {!proto.gameaccount.GetAccountDetails.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.gameaccount.GetAccountDetails.Response>}
 *     Promise that resolves to the response
 */
proto.gameaccount.OverviewPromiseClient.prototype.getAccountDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/gameaccount.Overview/GetAccountDetails',
      request,
      metadata || {},
      methodDescriptor_Overview_GetAccountDetails);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gameaccount.RegistryClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gameaccount.RegistryPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.gameaccount.ListRegistryLevels.Request,
 *   !proto.gameaccount.ListRegistryLevels.Response>}
 */
const methodDescriptor_Registry_ListLevels = new grpc.web.MethodDescriptor(
  '/gameaccount.Registry/ListLevels',
  grpc.web.MethodType.UNARY,
  proto.gameaccount.ListRegistryLevels.Request,
  proto.gameaccount.ListRegistryLevels.Response,
  /**
   * @param {!proto.gameaccount.ListRegistryLevels.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.gameaccount.ListRegistryLevels.Response.deserializeBinary
);


/**
 * @param {!proto.gameaccount.ListRegistryLevels.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.gameaccount.ListRegistryLevels.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.gameaccount.ListRegistryLevels.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.gameaccount.RegistryClient.prototype.listLevels =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/gameaccount.Registry/ListLevels',
      request,
      metadata || {},
      methodDescriptor_Registry_ListLevels,
      callback);
};


/**
 * @param {!proto.gameaccount.ListRegistryLevels.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.gameaccount.ListRegistryLevels.Response>}
 *     Promise that resolves to the response
 */
proto.gameaccount.RegistryPromiseClient.prototype.listLevels =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/gameaccount.Registry/ListLevels',
      request,
      metadata || {},
      methodDescriptor_Registry_ListLevels);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gameaccount.LevelRewardsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.gameaccount.LevelRewardsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.gameaccount.ClaimLevelReward.Request,
 *   !proto.gameaccount.ClaimLevelReward.Response>}
 */
const methodDescriptor_LevelRewards_Claim = new grpc.web.MethodDescriptor(
  '/gameaccount.LevelRewards/Claim',
  grpc.web.MethodType.UNARY,
  proto.gameaccount.ClaimLevelReward.Request,
  proto.gameaccount.ClaimLevelReward.Response,
  /**
   * @param {!proto.gameaccount.ClaimLevelReward.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.gameaccount.ClaimLevelReward.Response.deserializeBinary
);


/**
 * @param {!proto.gameaccount.ClaimLevelReward.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.gameaccount.ClaimLevelReward.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.gameaccount.ClaimLevelReward.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.gameaccount.LevelRewardsClient.prototype.claim =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/gameaccount.LevelRewards/Claim',
      request,
      metadata || {},
      methodDescriptor_LevelRewards_Claim,
      callback);
};


/**
 * @param {!proto.gameaccount.ClaimLevelReward.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.gameaccount.ClaimLevelReward.Response>}
 *     Promise that resolves to the response
 */
proto.gameaccount.LevelRewardsPromiseClient.prototype.claim =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/gameaccount.LevelRewards/Claim',
      request,
      metadata || {},
      methodDescriptor_LevelRewards_Claim);
};


module.exports = proto.gameaccount;


},{"../validate/validate_pb.js":50,"./gameaccount.public_pb.js":49,"grpc-web":7}],49:[function(require,module,exports){
// source: public/gameaccount.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.gameaccount.Account', null, global);
goog.exportSymbol('proto.gameaccount.Account.Level', null, global);
goog.exportSymbol('proto.gameaccount.Account.Level.Experience', null, global);
goog.exportSymbol('proto.gameaccount.ClaimLevelReward', null, global);
goog.exportSymbol('proto.gameaccount.ClaimLevelReward.Request', null, global);
goog.exportSymbol('proto.gameaccount.ClaimLevelReward.Response', null, global);
goog.exportSymbol('proto.gameaccount.GetAccount', null, global);
goog.exportSymbol('proto.gameaccount.GetAccount.RegistryItemsParams', null, global);
goog.exportSymbol('proto.gameaccount.GetAccount.Request', null, global);
goog.exportSymbol('proto.gameaccount.GetAccount.Response', null, global);
goog.exportSymbol('proto.gameaccount.GetAccountDetails', null, global);
goog.exportSymbol('proto.gameaccount.GetAccountDetails.Clan', null, global);
goog.exportSymbol('proto.gameaccount.GetAccountDetails.Details', null, global);
goog.exportSymbol('proto.gameaccount.GetAccountDetails.LastMatch', null, global);
goog.exportSymbol('proto.gameaccount.GetAccountDetails.Request', null, global);
goog.exportSymbol('proto.gameaccount.GetAccountDetails.Response', null, global);
goog.exportSymbol('proto.gameaccount.ListRegistryLevels', null, global);
goog.exportSymbol('proto.gameaccount.ListRegistryLevels.Request', null, global);
goog.exportSymbol('proto.gameaccount.ListRegistryLevels.Response', null, global);
goog.exportSymbol('proto.gameaccount.RegistryItem', null, global);
goog.exportSymbol('proto.gameaccount.RegistryItem.Level', null, global);
goog.exportSymbol('proto.gameaccount.RegistryItem.Level.RewardInfo', null, global);
goog.exportSymbol('proto.gameaccount.RegistryItem.LevelContentUnlock', null, global);
goog.exportSymbol('proto.gameaccount.RegistryItem.LevelContentUnlock.Target', null, global);
goog.exportSymbol('proto.gameaccount.RegistryItem.Reward', null, global);
goog.exportSymbol('proto.gameaccount.RegistryItems', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.Account.displayName = 'proto.gameaccount.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.Account.Level = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.Account.Level, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.Account.Level.displayName = 'proto.gameaccount.Account.Level';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.Account.Level.Experience = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.Account.Level.Experience, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.Account.Level.Experience.displayName = 'proto.gameaccount.Account.Level.Experience';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.RegistryItems = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gameaccount.RegistryItems.repeatedFields_, null);
};
goog.inherits(proto.gameaccount.RegistryItems, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.RegistryItems.displayName = 'proto.gameaccount.RegistryItems';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.RegistryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.RegistryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.RegistryItem.displayName = 'proto.gameaccount.RegistryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.RegistryItem.Level = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.RegistryItem.Level, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.RegistryItem.Level.displayName = 'proto.gameaccount.RegistryItem.Level';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.RegistryItem.Level.RewardInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.RegistryItem.Level.RewardInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.RegistryItem.Level.RewardInfo.displayName = 'proto.gameaccount.RegistryItem.Level.RewardInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.RegistryItem.Reward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gameaccount.RegistryItem.Reward.repeatedFields_, null);
};
goog.inherits(proto.gameaccount.RegistryItem.Reward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.RegistryItem.Reward.displayName = 'proto.gameaccount.RegistryItem.Reward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.RegistryItem.LevelContentUnlock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.RegistryItem.LevelContentUnlock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.RegistryItem.LevelContentUnlock.displayName = 'proto.gameaccount.RegistryItem.LevelContentUnlock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccount.displayName = 'proto.gameaccount.GetAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccount.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccount.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccount.Request.displayName = 'proto.gameaccount.GetAccount.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccount.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccount.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccount.Response.displayName = 'proto.gameaccount.GetAccount.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccount.RegistryItemsParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccount.RegistryItemsParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccount.RegistryItemsParams.displayName = 'proto.gameaccount.GetAccount.RegistryItemsParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccountDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccountDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccountDetails.displayName = 'proto.gameaccount.GetAccountDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccountDetails.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccountDetails.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccountDetails.Request.displayName = 'proto.gameaccount.GetAccountDetails.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccountDetails.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccountDetails.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccountDetails.Response.displayName = 'proto.gameaccount.GetAccountDetails.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccountDetails.Details = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccountDetails.Details, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccountDetails.Details.displayName = 'proto.gameaccount.GetAccountDetails.Details';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccountDetails.Clan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccountDetails.Clan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccountDetails.Clan.displayName = 'proto.gameaccount.GetAccountDetails.Clan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.GetAccountDetails.LastMatch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.GetAccountDetails.LastMatch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.GetAccountDetails.LastMatch.displayName = 'proto.gameaccount.GetAccountDetails.LastMatch';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.ListRegistryLevels = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.ListRegistryLevels, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.ListRegistryLevels.displayName = 'proto.gameaccount.ListRegistryLevels';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.ListRegistryLevels.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.ListRegistryLevels.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.ListRegistryLevels.Request.displayName = 'proto.gameaccount.ListRegistryLevels.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.ListRegistryLevels.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.gameaccount.ListRegistryLevels.Response.repeatedFields_, null);
};
goog.inherits(proto.gameaccount.ListRegistryLevels.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.ListRegistryLevels.Response.displayName = 'proto.gameaccount.ListRegistryLevels.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.ClaimLevelReward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.ClaimLevelReward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.ClaimLevelReward.displayName = 'proto.gameaccount.ClaimLevelReward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.ClaimLevelReward.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.ClaimLevelReward.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.ClaimLevelReward.Request.displayName = 'proto.gameaccount.ClaimLevelReward.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.gameaccount.ClaimLevelReward.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.gameaccount.ClaimLevelReward.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.gameaccount.ClaimLevelReward.Response.displayName = 'proto.gameaccount.ClaimLevelReward.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: (f = msg.getLevel()) && proto.gameaccount.Account.Level.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.Account}
 */
proto.gameaccount.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.Account;
  return proto.gameaccount.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.Account}
 */
proto.gameaccount.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameaccount.Account.Level;
      reader.readMessage(value,proto.gameaccount.Account.Level.deserializeBinaryFromReader);
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gameaccount.Account.Level.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.Account.Level.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.Account.Level.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.Account.Level} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.Account.Level.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0),
    exp: (f = msg.getExp()) && proto.gameaccount.Account.Level.Experience.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.Account.Level}
 */
proto.gameaccount.Account.Level.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.Account.Level;
  return proto.gameaccount.Account.Level.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.Account.Level} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.Account.Level}
 */
proto.gameaccount.Account.Level.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    case 2:
      var value = new proto.gameaccount.Account.Level.Experience;
      reader.readMessage(value,proto.gameaccount.Account.Level.Experience.deserializeBinaryFromReader);
      msg.setExp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.Account.Level.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.Account.Level.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.Account.Level} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.Account.Level.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getExp();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gameaccount.Account.Level.Experience.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.Account.Level.Experience.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.Account.Level.Experience.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.Account.Level.Experience} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.Account.Level.Experience.toObject = function(includeInstance, msg) {
  var f, obj = {
    current: jspb.Message.getFieldWithDefault(msg, 1, 0),
    goal: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.Account.Level.Experience}
 */
proto.gameaccount.Account.Level.Experience.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.Account.Level.Experience;
  return proto.gameaccount.Account.Level.Experience.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.Account.Level.Experience} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.Account.Level.Experience}
 */
proto.gameaccount.Account.Level.Experience.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGoal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.Account.Level.Experience.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.Account.Level.Experience.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.Account.Level.Experience} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.Account.Level.Experience.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrent();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getGoal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 current = 1;
 * @return {number}
 */
proto.gameaccount.Account.Level.Experience.prototype.getCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.Account.Level.Experience} returns this
 */
proto.gameaccount.Account.Level.Experience.prototype.setCurrent = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 goal = 2;
 * @return {number}
 */
proto.gameaccount.Account.Level.Experience.prototype.getGoal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.Account.Level.Experience} returns this
 */
proto.gameaccount.Account.Level.Experience.prototype.setGoal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 level = 1;
 * @return {number}
 */
proto.gameaccount.Account.Level.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.Account.Level} returns this
 */
proto.gameaccount.Account.Level.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Experience exp = 2;
 * @return {?proto.gameaccount.Account.Level.Experience}
 */
proto.gameaccount.Account.Level.prototype.getExp = function() {
  return /** @type{?proto.gameaccount.Account.Level.Experience} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.Account.Level.Experience, 2));
};


/**
 * @param {?proto.gameaccount.Account.Level.Experience|undefined} value
 * @return {!proto.gameaccount.Account.Level} returns this
*/
proto.gameaccount.Account.Level.prototype.setExp = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.Account.Level} returns this
 */
proto.gameaccount.Account.Level.prototype.clearExp = function() {
  return this.setExp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.Account.Level.prototype.hasExp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Level level = 1;
 * @return {?proto.gameaccount.Account.Level}
 */
proto.gameaccount.Account.prototype.getLevel = function() {
  return /** @type{?proto.gameaccount.Account.Level} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.Account.Level, 1));
};


/**
 * @param {?proto.gameaccount.Account.Level|undefined} value
 * @return {!proto.gameaccount.Account} returns this
*/
proto.gameaccount.Account.prototype.setLevel = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.Account} returns this
 */
proto.gameaccount.Account.prototype.clearLevel = function() {
  return this.setLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.Account.prototype.hasLevel = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gameaccount.RegistryItems.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.RegistryItems.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.RegistryItems.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.RegistryItems} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItems.toObject = function(includeInstance, msg) {
  var f, obj = {
    levelsList: jspb.Message.toObjectList(msg.getLevelsList(),
    proto.gameaccount.RegistryItem.Level.toObject, includeInstance),
    levelContentUnlocksList: jspb.Message.toObjectList(msg.getLevelContentUnlocksList(),
    proto.gameaccount.RegistryItem.LevelContentUnlock.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.RegistryItems}
 */
proto.gameaccount.RegistryItems.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.RegistryItems;
  return proto.gameaccount.RegistryItems.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.RegistryItems} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.RegistryItems}
 */
proto.gameaccount.RegistryItems.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameaccount.RegistryItem.Level;
      reader.readMessage(value,proto.gameaccount.RegistryItem.Level.deserializeBinaryFromReader);
      msg.addLevels(value);
      break;
    case 2:
      var value = new proto.gameaccount.RegistryItem.LevelContentUnlock;
      reader.readMessage(value,proto.gameaccount.RegistryItem.LevelContentUnlock.deserializeBinaryFromReader);
      msg.addLevelContentUnlocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.RegistryItems.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.RegistryItems.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.RegistryItems} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItems.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.gameaccount.RegistryItem.Level.serializeBinaryToWriter
    );
  }
  f = message.getLevelContentUnlocksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.gameaccount.RegistryItem.LevelContentUnlock.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RegistryItem.Level levels = 1;
 * @return {!Array<!proto.gameaccount.RegistryItem.Level>}
 */
proto.gameaccount.RegistryItems.prototype.getLevelsList = function() {
  return /** @type{!Array<!proto.gameaccount.RegistryItem.Level>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gameaccount.RegistryItem.Level, 1));
};


/**
 * @param {!Array<!proto.gameaccount.RegistryItem.Level>} value
 * @return {!proto.gameaccount.RegistryItems} returns this
*/
proto.gameaccount.RegistryItems.prototype.setLevelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.gameaccount.RegistryItem.Level=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gameaccount.RegistryItem.Level}
 */
proto.gameaccount.RegistryItems.prototype.addLevels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.gameaccount.RegistryItem.Level, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameaccount.RegistryItems} returns this
 */
proto.gameaccount.RegistryItems.prototype.clearLevelsList = function() {
  return this.setLevelsList([]);
};


/**
 * repeated RegistryItem.LevelContentUnlock level_content_unlocks = 2;
 * @return {!Array<!proto.gameaccount.RegistryItem.LevelContentUnlock>}
 */
proto.gameaccount.RegistryItems.prototype.getLevelContentUnlocksList = function() {
  return /** @type{!Array<!proto.gameaccount.RegistryItem.LevelContentUnlock>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gameaccount.RegistryItem.LevelContentUnlock, 2));
};


/**
 * @param {!Array<!proto.gameaccount.RegistryItem.LevelContentUnlock>} value
 * @return {!proto.gameaccount.RegistryItems} returns this
*/
proto.gameaccount.RegistryItems.prototype.setLevelContentUnlocksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.gameaccount.RegistryItem.LevelContentUnlock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gameaccount.RegistryItem.LevelContentUnlock}
 */
proto.gameaccount.RegistryItems.prototype.addLevelContentUnlocks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.gameaccount.RegistryItem.LevelContentUnlock, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameaccount.RegistryItems} returns this
 */
proto.gameaccount.RegistryItems.prototype.clearLevelContentUnlocksList = function() {
  return this.setLevelContentUnlocksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.RegistryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.RegistryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.RegistryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.RegistryItem}
 */
proto.gameaccount.RegistryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.RegistryItem;
  return proto.gameaccount.RegistryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.RegistryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.RegistryItem}
 */
proto.gameaccount.RegistryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.RegistryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.RegistryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.RegistryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.RegistryItem.Level.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.RegistryItem.Level.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.RegistryItem.Level} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.Level.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reward: (f = msg.getReward()) && proto.gameaccount.RegistryItem.Level.RewardInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.RegistryItem.Level}
 */
proto.gameaccount.RegistryItem.Level.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.RegistryItem.Level;
  return proto.gameaccount.RegistryItem.Level.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.RegistryItem.Level} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.RegistryItem.Level}
 */
proto.gameaccount.RegistryItem.Level.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    case 2:
      var value = new proto.gameaccount.RegistryItem.Level.RewardInfo;
      reader.readMessage(value,proto.gameaccount.RegistryItem.Level.RewardInfo.deserializeBinaryFromReader);
      msg.setReward(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.RegistryItem.Level.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.RegistryItem.Level.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.RegistryItem.Level} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.Level.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getReward();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gameaccount.RegistryItem.Level.RewardInfo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.RegistryItem.Level.RewardInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.RegistryItem.Level.RewardInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    claimed: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    data: (f = msg.getData()) && proto.gameaccount.RegistryItem.Reward.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.RegistryItem.Level.RewardInfo}
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.RegistryItem.Level.RewardInfo;
  return proto.gameaccount.RegistryItem.Level.RewardInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.RegistryItem.Level.RewardInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.RegistryItem.Level.RewardInfo}
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClaimed(value);
      break;
    case 2:
      var value = new proto.gameaccount.RegistryItem.Reward;
      reader.readMessage(value,proto.gameaccount.RegistryItem.Reward.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.RegistryItem.Level.RewardInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.RegistryItem.Level.RewardInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimed();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gameaccount.RegistryItem.Reward.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool claimed = 1;
 * @return {boolean}
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.prototype.getClaimed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.gameaccount.RegistryItem.Level.RewardInfo} returns this
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.prototype.setClaimed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Reward data = 2;
 * @return {?proto.gameaccount.RegistryItem.Reward}
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.prototype.getData = function() {
  return /** @type{?proto.gameaccount.RegistryItem.Reward} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.RegistryItem.Reward, 2));
};


/**
 * @param {?proto.gameaccount.RegistryItem.Reward|undefined} value
 * @return {!proto.gameaccount.RegistryItem.Level.RewardInfo} returns this
*/
proto.gameaccount.RegistryItem.Level.RewardInfo.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.RegistryItem.Level.RewardInfo} returns this
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.RegistryItem.Level.RewardInfo.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 level = 1;
 * @return {number}
 */
proto.gameaccount.RegistryItem.Level.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.RegistryItem.Level} returns this
 */
proto.gameaccount.RegistryItem.Level.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional RewardInfo reward = 2;
 * @return {?proto.gameaccount.RegistryItem.Level.RewardInfo}
 */
proto.gameaccount.RegistryItem.Level.prototype.getReward = function() {
  return /** @type{?proto.gameaccount.RegistryItem.Level.RewardInfo} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.RegistryItem.Level.RewardInfo, 2));
};


/**
 * @param {?proto.gameaccount.RegistryItem.Level.RewardInfo|undefined} value
 * @return {!proto.gameaccount.RegistryItem.Level} returns this
*/
proto.gameaccount.RegistryItem.Level.prototype.setReward = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.RegistryItem.Level} returns this
 */
proto.gameaccount.RegistryItem.Level.prototype.clearReward = function() {
  return this.setReward(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.RegistryItem.Level.prototype.hasReward = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gameaccount.RegistryItem.Reward.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.RegistryItem.Reward.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.RegistryItem.Reward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.RegistryItem.Reward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.Reward.toObject = function(includeInstance, msg) {
  var f, obj = {
    gamedataItemsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    currencyItems: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.RegistryItem.Reward}
 */
proto.gameaccount.RegistryItem.Reward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.RegistryItem.Reward;
  return proto.gameaccount.RegistryItem.Reward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.RegistryItem.Reward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.RegistryItem.Reward}
 */
proto.gameaccount.RegistryItem.Reward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addGamedataItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrencyItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.RegistryItem.Reward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.RegistryItem.Reward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.RegistryItem.Reward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.Reward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGamedataItemsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCurrencyItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated string gamedata_items = 1;
 * @return {!Array<string>}
 */
proto.gameaccount.RegistryItem.Reward.prototype.getGamedataItemsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.gameaccount.RegistryItem.Reward} returns this
 */
proto.gameaccount.RegistryItem.Reward.prototype.setGamedataItemsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.gameaccount.RegistryItem.Reward} returns this
 */
proto.gameaccount.RegistryItem.Reward.prototype.addGamedataItems = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameaccount.RegistryItem.Reward} returns this
 */
proto.gameaccount.RegistryItem.Reward.prototype.clearGamedataItemsList = function() {
  return this.setGamedataItemsList([]);
};


/**
 * optional int64 currency_items = 2;
 * @return {number}
 */
proto.gameaccount.RegistryItem.Reward.prototype.getCurrencyItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.RegistryItem.Reward} returns this
 */
proto.gameaccount.RegistryItem.Reward.prototype.setCurrencyItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.RegistryItem.LevelContentUnlock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.RegistryItem.LevelContentUnlock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0),
    target: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.RegistryItem.LevelContentUnlock}
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.RegistryItem.LevelContentUnlock;
  return proto.gameaccount.RegistryItem.LevelContentUnlock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.RegistryItem.LevelContentUnlock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.RegistryItem.LevelContentUnlock}
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    case 2:
      var value = /** @type {!proto.gameaccount.RegistryItem.LevelContentUnlock.Target} */ (reader.readEnum());
      msg.setTarget(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.RegistryItem.LevelContentUnlock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.RegistryItem.LevelContentUnlock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTarget();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.Target = {
  UNKNOWN: 0,
  DAILY_QUESTS: 1,
  SEASON_QUESTS: 2,
  JOIN_CLANS: 3,
  CREATE_CLANS: 4,
  LIMITED_QUESTS: 5,
  SPECIAL_QUESTS: 6
};

/**
 * optional int64 level = 1;
 * @return {number}
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.RegistryItem.LevelContentUnlock} returns this
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Target target = 2;
 * @return {!proto.gameaccount.RegistryItem.LevelContentUnlock.Target}
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.prototype.getTarget = function() {
  return /** @type {!proto.gameaccount.RegistryItem.LevelContentUnlock.Target} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.gameaccount.RegistryItem.LevelContentUnlock.Target} value
 * @return {!proto.gameaccount.RegistryItem.LevelContentUnlock} returns this
 */
proto.gameaccount.RegistryItem.LevelContentUnlock.prototype.setTarget = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccount.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccount}
 */
proto.gameaccount.GetAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccount;
  return proto.gameaccount.GetAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccount}
 */
proto.gameaccount.GetAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccount.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccount.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccount.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccount.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    registryItems: (f = msg.getRegistryItems()) && proto.gameaccount.GetAccount.RegistryItemsParams.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccount.Request}
 */
proto.gameaccount.GetAccount.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccount.Request;
  return proto.gameaccount.GetAccount.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccount.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccount.Request}
 */
proto.gameaccount.GetAccount.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameaccount.GetAccount.RegistryItemsParams;
      reader.readMessage(value,proto.gameaccount.GetAccount.RegistryItemsParams.deserializeBinaryFromReader);
      msg.setRegistryItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccount.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccount.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccount.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccount.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegistryItems();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gameaccount.GetAccount.RegistryItemsParams.serializeBinaryToWriter
    );
  }
};


/**
 * optional RegistryItemsParams registry_items = 1;
 * @return {?proto.gameaccount.GetAccount.RegistryItemsParams}
 */
proto.gameaccount.GetAccount.Request.prototype.getRegistryItems = function() {
  return /** @type{?proto.gameaccount.GetAccount.RegistryItemsParams} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.GetAccount.RegistryItemsParams, 1));
};


/**
 * @param {?proto.gameaccount.GetAccount.RegistryItemsParams|undefined} value
 * @return {!proto.gameaccount.GetAccount.Request} returns this
*/
proto.gameaccount.GetAccount.Request.prototype.setRegistryItems = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.GetAccount.Request} returns this
 */
proto.gameaccount.GetAccount.Request.prototype.clearRegistryItems = function() {
  return this.setRegistryItems(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.GetAccount.Request.prototype.hasRegistryItems = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccount.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccount.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccount.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccount.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.gameaccount.Account.toObject(includeInstance, f),
    registry: (f = msg.getRegistry()) && proto.gameaccount.RegistryItems.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccount.Response}
 */
proto.gameaccount.GetAccount.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccount.Response;
  return proto.gameaccount.GetAccount.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccount.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccount.Response}
 */
proto.gameaccount.GetAccount.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameaccount.Account;
      reader.readMessage(value,proto.gameaccount.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 2:
      var value = new proto.gameaccount.RegistryItems;
      reader.readMessage(value,proto.gameaccount.RegistryItems.deserializeBinaryFromReader);
      msg.setRegistry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccount.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccount.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccount.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccount.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gameaccount.Account.serializeBinaryToWriter
    );
  }
  f = message.getRegistry();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.gameaccount.RegistryItems.serializeBinaryToWriter
    );
  }
};


/**
 * optional Account account = 1;
 * @return {?proto.gameaccount.Account}
 */
proto.gameaccount.GetAccount.Response.prototype.getAccount = function() {
  return /** @type{?proto.gameaccount.Account} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.Account, 1));
};


/**
 * @param {?proto.gameaccount.Account|undefined} value
 * @return {!proto.gameaccount.GetAccount.Response} returns this
*/
proto.gameaccount.GetAccount.Response.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.GetAccount.Response} returns this
 */
proto.gameaccount.GetAccount.Response.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.GetAccount.Response.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RegistryItems registry = 2;
 * @return {?proto.gameaccount.RegistryItems}
 */
proto.gameaccount.GetAccount.Response.prototype.getRegistry = function() {
  return /** @type{?proto.gameaccount.RegistryItems} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.RegistryItems, 2));
};


/**
 * @param {?proto.gameaccount.RegistryItems|undefined} value
 * @return {!proto.gameaccount.GetAccount.Response} returns this
*/
proto.gameaccount.GetAccount.Response.prototype.setRegistry = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.GetAccount.Response} returns this
 */
proto.gameaccount.GetAccount.Response.prototype.clearRegistry = function() {
  return this.setRegistry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.GetAccount.Response.prototype.hasRegistry = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccount.RegistryItemsParams.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccount.RegistryItemsParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccount.RegistryItemsParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccount.RegistryItemsParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    extraLevels: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccount.RegistryItemsParams}
 */
proto.gameaccount.GetAccount.RegistryItemsParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccount.RegistryItemsParams;
  return proto.gameaccount.GetAccount.RegistryItemsParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccount.RegistryItemsParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccount.RegistryItemsParams}
 */
proto.gameaccount.GetAccount.RegistryItemsParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtraLevels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccount.RegistryItemsParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccount.RegistryItemsParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccount.RegistryItemsParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccount.RegistryItemsParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtraLevels();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 extra_levels = 1;
 * @return {number}
 */
proto.gameaccount.GetAccount.RegistryItemsParams.prototype.getExtraLevels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccount.RegistryItemsParams} returns this
 */
proto.gameaccount.GetAccount.RegistryItemsParams.prototype.setExtraLevels = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccountDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccountDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccountDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccountDetails}
 */
proto.gameaccount.GetAccountDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccountDetails;
  return proto.gameaccount.GetAccountDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccountDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccountDetails}
 */
proto.gameaccount.GetAccountDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccountDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccountDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccountDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccountDetails.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccountDetails.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccountDetails.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccountDetails.Request}
 */
proto.gameaccount.GetAccountDetails.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccountDetails.Request;
  return proto.gameaccount.GetAccountDetails.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccountDetails.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccountDetails.Request}
 */
proto.gameaccount.GetAccountDetails.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccountDetails.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccountDetails.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccountDetails.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Request.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Request} returns this
 */
proto.gameaccount.GetAccountDetails.Request.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccountDetails.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccountDetails.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccountDetails.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    details: (f = msg.getDetails()) && proto.gameaccount.GetAccountDetails.Details.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccountDetails.Response}
 */
proto.gameaccount.GetAccountDetails.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccountDetails.Response;
  return proto.gameaccount.GetAccountDetails.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccountDetails.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccountDetails.Response}
 */
proto.gameaccount.GetAccountDetails.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameaccount.GetAccountDetails.Details;
      reader.readMessage(value,proto.gameaccount.GetAccountDetails.Details.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccountDetails.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccountDetails.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccountDetails.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gameaccount.GetAccountDetails.Details.serializeBinaryToWriter
    );
  }
};


/**
 * optional Details details = 1;
 * @return {?proto.gameaccount.GetAccountDetails.Details}
 */
proto.gameaccount.GetAccountDetails.Response.prototype.getDetails = function() {
  return /** @type{?proto.gameaccount.GetAccountDetails.Details} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.GetAccountDetails.Details, 1));
};


/**
 * @param {?proto.gameaccount.GetAccountDetails.Details|undefined} value
 * @return {!proto.gameaccount.GetAccountDetails.Response} returns this
*/
proto.gameaccount.GetAccountDetails.Response.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.GetAccountDetails.Response} returns this
 */
proto.gameaccount.GetAccountDetails.Response.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.GetAccountDetails.Response.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccountDetails.Details.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccountDetails.Details} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.Details.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    verified: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    clan: (f = msg.getClan()) && proto.gameaccount.GetAccountDetails.Clan.toObject(includeInstance, f),
    level: (f = msg.getLevel()) && proto.gameaccount.Account.Level.toObject(includeInstance, f),
    currencyItems: jspb.Message.getFieldWithDefault(msg, 6, 0),
    kills: jspb.Message.getFieldWithDefault(msg, 9, 0),
    deaths: jspb.Message.getFieldWithDefault(msg, 10, 0),
    assists: jspb.Message.getFieldWithDefault(msg, 11, 0),
    headshots: jspb.Message.getFieldWithDefault(msg, 12, 0),
    kdr: jspb.Message.getFieldWithDefault(msg, 13, ""),
    currentRank: jspb.Message.getFieldWithDefault(msg, 14, 0),
    totalGamesWon: jspb.Message.getFieldWithDefault(msg, 15, 0),
    totalGamesPlayed: jspb.Message.getFieldWithDefault(msg, 16, 0),
    totalGameTime: jspb.Message.getFieldWithDefault(msg, 17, 0),
    lastMatch: (f = msg.getLastMatch()) && proto.gameaccount.GetAccountDetails.LastMatch.toObject(includeInstance, f),
    activeHat: jspb.Message.getFieldWithDefault(msg, 19, ""),
    activeSkin: jspb.Message.getFieldWithDefault(msg, 20, ""),
    suffix: jspb.Message.getFieldWithDefault(msg, 21, ""),
    experience: jspb.Message.getFieldWithDefault(msg, 22, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccountDetails.Details}
 */
proto.gameaccount.GetAccountDetails.Details.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccountDetails.Details;
  return proto.gameaccount.GetAccountDetails.Details.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccountDetails.Details} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccountDetails.Details}
 */
proto.gameaccount.GetAccountDetails.Details.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 4:
      var value = new proto.gameaccount.GetAccountDetails.Clan;
      reader.readMessage(value,proto.gameaccount.GetAccountDetails.Clan.deserializeBinaryFromReader);
      msg.setClan(value);
      break;
    case 5:
      var value = new proto.gameaccount.Account.Level;
      reader.readMessage(value,proto.gameaccount.Account.Level.deserializeBinaryFromReader);
      msg.setLevel(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrencyItems(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setKills(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeaths(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssists(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHeadshots(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setKdr(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentRank(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalGamesWon(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalGamesPlayed(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalGameTime(value);
      break;
    case 18:
      var value = new proto.gameaccount.GetAccountDetails.LastMatch;
      reader.readMessage(value,proto.gameaccount.GetAccountDetails.LastMatch.deserializeBinaryFromReader);
      msg.setLastMatch(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setActiveHat(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setActiveSkin(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExperience(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccountDetails.Details.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccountDetails.Details} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.Details.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getClan();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.gameaccount.GetAccountDetails.Clan.serializeBinaryToWriter
    );
  }
  f = message.getLevel();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.gameaccount.Account.Level.serializeBinaryToWriter
    );
  }
  f = message.getCurrencyItems();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getKills();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getDeaths();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAssists();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getHeadshots();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getKdr();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCurrentRank();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getTotalGamesWon();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getTotalGamesPlayed();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getTotalGameTime();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getLastMatch();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.gameaccount.GetAccountDetails.LastMatch.serializeBinaryToWriter
    );
  }
  f = message.getActiveHat();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getActiveSkin();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getSuffix();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getExperience();
  if (f !== 0) {
    writer.writeUint64(
      22,
      f
    );
  }
};


/**
 * optional string hash = 1;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool verified = 3;
 * @return {boolean}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Clan clan = 4;
 * @return {?proto.gameaccount.GetAccountDetails.Clan}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getClan = function() {
  return /** @type{?proto.gameaccount.GetAccountDetails.Clan} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.GetAccountDetails.Clan, 4));
};


/**
 * @param {?proto.gameaccount.GetAccountDetails.Clan|undefined} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
*/
proto.gameaccount.GetAccountDetails.Details.prototype.setClan = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.clearClan = function() {
  return this.setClan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.hasClan = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Account.Level level = 5;
 * @return {?proto.gameaccount.Account.Level}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getLevel = function() {
  return /** @type{?proto.gameaccount.Account.Level} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.Account.Level, 5));
};


/**
 * @param {?proto.gameaccount.Account.Level|undefined} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
*/
proto.gameaccount.GetAccountDetails.Details.prototype.setLevel = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.clearLevel = function() {
  return this.setLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.hasLevel = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 currency_items = 6;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getCurrencyItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setCurrencyItems = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 kills = 9;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getKills = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setKills = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 deaths = 10;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getDeaths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setDeaths = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 assists = 11;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getAssists = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setAssists = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 headshots = 12;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getHeadshots = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setHeadshots = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string kdr = 13;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getKdr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setKdr = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 current_rank = 14;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getCurrentRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setCurrentRank = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 total_games_won = 15;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getTotalGamesWon = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setTotalGamesWon = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 total_games_played = 16;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getTotalGamesPlayed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setTotalGamesPlayed = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 total_game_time = 17;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getTotalGameTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setTotalGameTime = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional LastMatch last_match = 18;
 * @return {?proto.gameaccount.GetAccountDetails.LastMatch}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getLastMatch = function() {
  return /** @type{?proto.gameaccount.GetAccountDetails.LastMatch} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.GetAccountDetails.LastMatch, 18));
};


/**
 * @param {?proto.gameaccount.GetAccountDetails.LastMatch|undefined} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
*/
proto.gameaccount.GetAccountDetails.Details.prototype.setLastMatch = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.clearLastMatch = function() {
  return this.setLastMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.hasLastMatch = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string active_hat = 19;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getActiveHat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setActiveHat = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string active_skin = 20;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getActiveSkin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setActiveSkin = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string suffix = 21;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setSuffix = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional uint64 experience = 22;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.Details.prototype.getExperience = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.Details} returns this
 */
proto.gameaccount.GetAccountDetails.Details.prototype.setExperience = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccountDetails.Clan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccountDetails.Clan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.Clan.toObject = function(includeInstance, msg) {
  var f, obj = {
    slug: jspb.Message.getFieldWithDefault(msg, 1, ""),
    socialLink: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isOwner: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    name: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccountDetails.Clan}
 */
proto.gameaccount.GetAccountDetails.Clan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccountDetails.Clan;
  return proto.gameaccount.GetAccountDetails.Clan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccountDetails.Clan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccountDetails.Clan}
 */
proto.gameaccount.GetAccountDetails.Clan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSocialLink(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOwner(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccountDetails.Clan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccountDetails.Clan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.Clan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSocialLink();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsOwner();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string slug = 1;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Clan} returns this
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string social_link = 2;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.getSocialLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Clan} returns this
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.setSocialLink = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_owner = 3;
 * @return {boolean}
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.getIsOwner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.gameaccount.GetAccountDetails.Clan} returns this
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.setIsOwner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.gameaccount.GetAccountDetails.Clan} returns this
 */
proto.gameaccount.GetAccountDetails.Clan.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.GetAccountDetails.LastMatch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.GetAccountDetails.LastMatch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.LastMatch.toObject = function(includeInstance, msg) {
  var f, obj = {
    kills: jspb.Message.getFieldWithDefault(msg, 1, 0),
    headshots: jspb.Message.getFieldWithDefault(msg, 2, 0),
    time: jspb.Message.getFieldWithDefault(msg, 3, 0),
    position: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.GetAccountDetails.LastMatch}
 */
proto.gameaccount.GetAccountDetails.LastMatch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.GetAccountDetails.LastMatch;
  return proto.gameaccount.GetAccountDetails.LastMatch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.GetAccountDetails.LastMatch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.GetAccountDetails.LastMatch}
 */
proto.gameaccount.GetAccountDetails.LastMatch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setKills(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHeadshots(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.GetAccountDetails.LastMatch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.GetAccountDetails.LastMatch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.GetAccountDetails.LastMatch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKills();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getHeadshots();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 kills = 1;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.getKills = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.LastMatch} returns this
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.setKills = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 headshots = 2;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.getHeadshots = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.LastMatch} returns this
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.setHeadshots = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 time = 3;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.LastMatch} returns this
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 position = 4;
 * @return {number}
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.GetAccountDetails.LastMatch} returns this
 */
proto.gameaccount.GetAccountDetails.LastMatch.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.ListRegistryLevels.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.ListRegistryLevels.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.ListRegistryLevels} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ListRegistryLevels.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.ListRegistryLevels}
 */
proto.gameaccount.ListRegistryLevels.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.ListRegistryLevels;
  return proto.gameaccount.ListRegistryLevels.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.ListRegistryLevels} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.ListRegistryLevels}
 */
proto.gameaccount.ListRegistryLevels.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.ListRegistryLevels.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.ListRegistryLevels.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.ListRegistryLevels} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ListRegistryLevels.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.ListRegistryLevels.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.ListRegistryLevels.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.ListRegistryLevels.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ListRegistryLevels.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reverse: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.ListRegistryLevels.Request}
 */
proto.gameaccount.ListRegistryLevels.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.ListRegistryLevels.Request;
  return proto.gameaccount.ListRegistryLevels.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.ListRegistryLevels.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.ListRegistryLevels.Request}
 */
proto.gameaccount.ListRegistryLevels.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReverse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.ListRegistryLevels.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.ListRegistryLevels.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.ListRegistryLevels.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ListRegistryLevels.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getReverse();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int64 level = 1;
 * @return {number}
 */
proto.gameaccount.ListRegistryLevels.Request.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.ListRegistryLevels.Request} returns this
 */
proto.gameaccount.ListRegistryLevels.Request.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 limit = 2;
 * @return {number}
 */
proto.gameaccount.ListRegistryLevels.Request.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.ListRegistryLevels.Request} returns this
 */
proto.gameaccount.ListRegistryLevels.Request.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool reverse = 3;
 * @return {boolean}
 */
proto.gameaccount.ListRegistryLevels.Request.prototype.getReverse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.gameaccount.ListRegistryLevels.Request} returns this
 */
proto.gameaccount.ListRegistryLevels.Request.prototype.setReverse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.gameaccount.ListRegistryLevels.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.ListRegistryLevels.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.ListRegistryLevels.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.ListRegistryLevels.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ListRegistryLevels.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    levelsList: jspb.Message.toObjectList(msg.getLevelsList(),
    proto.gameaccount.RegistryItem.Level.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.ListRegistryLevels.Response}
 */
proto.gameaccount.ListRegistryLevels.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.ListRegistryLevels.Response;
  return proto.gameaccount.ListRegistryLevels.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.ListRegistryLevels.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.ListRegistryLevels.Response}
 */
proto.gameaccount.ListRegistryLevels.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameaccount.RegistryItem.Level;
      reader.readMessage(value,proto.gameaccount.RegistryItem.Level.deserializeBinaryFromReader);
      msg.addLevels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.ListRegistryLevels.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.ListRegistryLevels.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.ListRegistryLevels.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ListRegistryLevels.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.gameaccount.RegistryItem.Level.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RegistryItem.Level levels = 1;
 * @return {!Array<!proto.gameaccount.RegistryItem.Level>}
 */
proto.gameaccount.ListRegistryLevels.Response.prototype.getLevelsList = function() {
  return /** @type{!Array<!proto.gameaccount.RegistryItem.Level>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.gameaccount.RegistryItem.Level, 1));
};


/**
 * @param {!Array<!proto.gameaccount.RegistryItem.Level>} value
 * @return {!proto.gameaccount.ListRegistryLevels.Response} returns this
*/
proto.gameaccount.ListRegistryLevels.Response.prototype.setLevelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.gameaccount.RegistryItem.Level=} opt_value
 * @param {number=} opt_index
 * @return {!proto.gameaccount.RegistryItem.Level}
 */
proto.gameaccount.ListRegistryLevels.Response.prototype.addLevels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.gameaccount.RegistryItem.Level, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.gameaccount.ListRegistryLevels.Response} returns this
 */
proto.gameaccount.ListRegistryLevels.Response.prototype.clearLevelsList = function() {
  return this.setLevelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.ClaimLevelReward.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.ClaimLevelReward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.ClaimLevelReward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ClaimLevelReward.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.ClaimLevelReward}
 */
proto.gameaccount.ClaimLevelReward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.ClaimLevelReward;
  return proto.gameaccount.ClaimLevelReward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.ClaimLevelReward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.ClaimLevelReward}
 */
proto.gameaccount.ClaimLevelReward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.ClaimLevelReward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.ClaimLevelReward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.ClaimLevelReward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ClaimLevelReward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.ClaimLevelReward.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.ClaimLevelReward.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.ClaimLevelReward.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ClaimLevelReward.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.ClaimLevelReward.Request}
 */
proto.gameaccount.ClaimLevelReward.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.ClaimLevelReward.Request;
  return proto.gameaccount.ClaimLevelReward.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.ClaimLevelReward.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.ClaimLevelReward.Request}
 */
proto.gameaccount.ClaimLevelReward.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.ClaimLevelReward.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.ClaimLevelReward.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.ClaimLevelReward.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ClaimLevelReward.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 level = 1;
 * @return {number}
 */
proto.gameaccount.ClaimLevelReward.Request.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.gameaccount.ClaimLevelReward.Request} returns this
 */
proto.gameaccount.ClaimLevelReward.Request.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.gameaccount.ClaimLevelReward.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.gameaccount.ClaimLevelReward.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.gameaccount.ClaimLevelReward.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ClaimLevelReward.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    claimed: (f = msg.getClaimed()) && proto.gameaccount.RegistryItem.Reward.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.gameaccount.ClaimLevelReward.Response}
 */
proto.gameaccount.ClaimLevelReward.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.gameaccount.ClaimLevelReward.Response;
  return proto.gameaccount.ClaimLevelReward.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.gameaccount.ClaimLevelReward.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.gameaccount.ClaimLevelReward.Response}
 */
proto.gameaccount.ClaimLevelReward.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.gameaccount.RegistryItem.Reward;
      reader.readMessage(value,proto.gameaccount.RegistryItem.Reward.deserializeBinaryFromReader);
      msg.setClaimed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.gameaccount.ClaimLevelReward.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.gameaccount.ClaimLevelReward.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.gameaccount.ClaimLevelReward.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.gameaccount.ClaimLevelReward.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimed();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.gameaccount.RegistryItem.Reward.serializeBinaryToWriter
    );
  }
};


/**
 * optional RegistryItem.Reward claimed = 1;
 * @return {?proto.gameaccount.RegistryItem.Reward}
 */
proto.gameaccount.ClaimLevelReward.Response.prototype.getClaimed = function() {
  return /** @type{?proto.gameaccount.RegistryItem.Reward} */ (
    jspb.Message.getWrapperField(this, proto.gameaccount.RegistryItem.Reward, 1));
};


/**
 * @param {?proto.gameaccount.RegistryItem.Reward|undefined} value
 * @return {!proto.gameaccount.ClaimLevelReward.Response} returns this
*/
proto.gameaccount.ClaimLevelReward.Response.prototype.setClaimed = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.gameaccount.ClaimLevelReward.Response} returns this
 */
proto.gameaccount.ClaimLevelReward.Response.prototype.clearClaimed = function() {
  return this.setClaimed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.gameaccount.ClaimLevelReward.Response.prototype.hasClaimed = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.gameaccount);

},{"../validate/validate_pb.js":50,"google-protobuf":3}],50:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],51:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for public.gwdealer
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.public = {};
proto.public.gwdealer = require('./gwdealer_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.gwdealer.GwDealerClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.gwdealer.GwDealerPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.gwdealer.GetSwapTransaction.Request,
 *   !proto.public.gwdealer.GetSwapTransaction.Response>}
 */
const methodDescriptor_GwDealer_GetSwapTransaction = new grpc.web.MethodDescriptor(
  '/public.gwdealer.GwDealer/GetSwapTransaction',
  grpc.web.MethodType.UNARY,
  proto.public.gwdealer.GetSwapTransaction.Request,
  proto.public.gwdealer.GetSwapTransaction.Response,
  /**
   * @param {!proto.public.gwdealer.GetSwapTransaction.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.gwdealer.GetSwapTransaction.Response.deserializeBinary
);


/**
 * @param {!proto.public.gwdealer.GetSwapTransaction.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.gwdealer.GetSwapTransaction.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.gwdealer.GetSwapTransaction.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.gwdealer.GwDealerClient.prototype.getSwapTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.gwdealer.GwDealer/GetSwapTransaction',
      request,
      metadata || {},
      methodDescriptor_GwDealer_GetSwapTransaction,
      callback);
};


/**
 * @param {!proto.public.gwdealer.GetSwapTransaction.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.gwdealer.GetSwapTransaction.Response>}
 *     Promise that resolves to the response
 */
proto.public.gwdealer.GwDealerPromiseClient.prototype.getSwapTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.gwdealer.GwDealer/GetSwapTransaction',
      request,
      metadata || {},
      methodDescriptor_GwDealer_GetSwapTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.gwdealer.GetEmpty.Request,
 *   !proto.public.gwdealer.GetEmpty.Response>}
 */
const methodDescriptor_GwDealer_GetEmpty = new grpc.web.MethodDescriptor(
  '/public.gwdealer.GwDealer/GetEmpty',
  grpc.web.MethodType.UNARY,
  proto.public.gwdealer.GetEmpty.Request,
  proto.public.gwdealer.GetEmpty.Response,
  /**
   * @param {!proto.public.gwdealer.GetEmpty.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.public.gwdealer.GetEmpty.Response.deserializeBinary
);


/**
 * @param {!proto.public.gwdealer.GetEmpty.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.public.gwdealer.GetEmpty.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.public.gwdealer.GetEmpty.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.public.gwdealer.GwDealerClient.prototype.getEmpty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/public.gwdealer.GwDealer/GetEmpty',
      request,
      metadata || {},
      methodDescriptor_GwDealer_GetEmpty,
      callback);
};


/**
 * @param {!proto.public.gwdealer.GetEmpty.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.public.gwdealer.GetEmpty.Response>}
 *     Promise that resolves to the response
 */
proto.public.gwdealer.GwDealerPromiseClient.prototype.getEmpty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/public.gwdealer.GwDealer/GetEmpty',
      request,
      metadata || {},
      methodDescriptor_GwDealer_GetEmpty);
};


module.exports = proto.public.gwdealer;


},{"./gwdealer_pb.js":52,"grpc-web":7}],52:[function(require,module,exports){
// source: public/gwdealer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.public.gwdealer.GetEmpty', null, global);
goog.exportSymbol('proto.public.gwdealer.GetEmpty.Request', null, global);
goog.exportSymbol('proto.public.gwdealer.GetEmpty.Response', null, global);
goog.exportSymbol('proto.public.gwdealer.GetSwapTransaction', null, global);
goog.exportSymbol('proto.public.gwdealer.GetSwapTransaction.Request', null, global);
goog.exportSymbol('proto.public.gwdealer.GetSwapTransaction.Response', null, global);
goog.exportSymbol('proto.public.gwdealer.Token', null, global);
goog.exportSymbol('proto.public.gwdealer.TransactionDetails', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.gwdealer.TransactionDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.gwdealer.TransactionDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.gwdealer.TransactionDetails.displayName = 'proto.public.gwdealer.TransactionDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.gwdealer.Token = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.gwdealer.Token, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.gwdealer.Token.displayName = 'proto.public.gwdealer.Token';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.gwdealer.GetSwapTransaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.gwdealer.GetSwapTransaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.gwdealer.GetSwapTransaction.displayName = 'proto.public.gwdealer.GetSwapTransaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.gwdealer.GetSwapTransaction.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.public.gwdealer.GetSwapTransaction.Request.repeatedFields_, null);
};
goog.inherits(proto.public.gwdealer.GetSwapTransaction.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.gwdealer.GetSwapTransaction.Request.displayName = 'proto.public.gwdealer.GetSwapTransaction.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.gwdealer.GetSwapTransaction.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.gwdealer.GetSwapTransaction.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.gwdealer.GetSwapTransaction.Response.displayName = 'proto.public.gwdealer.GetSwapTransaction.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.gwdealer.GetEmpty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.gwdealer.GetEmpty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.gwdealer.GetEmpty.displayName = 'proto.public.gwdealer.GetEmpty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.gwdealer.GetEmpty.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.gwdealer.GetEmpty.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.gwdealer.GetEmpty.Request.displayName = 'proto.public.gwdealer.GetEmpty.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.gwdealer.GetEmpty.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.gwdealer.GetEmpty.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.gwdealer.GetEmpty.Response.displayName = 'proto.public.gwdealer.GetEmpty.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.gwdealer.TransactionDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.public.gwdealer.TransactionDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.gwdealer.TransactionDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.TransactionDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    signature: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.gwdealer.TransactionDetails}
 */
proto.public.gwdealer.TransactionDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.gwdealer.TransactionDetails;
  return proto.public.gwdealer.TransactionDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.gwdealer.TransactionDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.gwdealer.TransactionDetails}
 */
proto.public.gwdealer.TransactionDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignature(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.gwdealer.TransactionDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.gwdealer.TransactionDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.gwdealer.TransactionDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.TransactionDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignature();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string signature = 1;
 * @return {string}
 */
proto.public.gwdealer.TransactionDetails.prototype.getSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.gwdealer.TransactionDetails} returns this
 */
proto.public.gwdealer.TransactionDetails.prototype.setSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.public.gwdealer.TransactionDetails.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.gwdealer.TransactionDetails} returns this
 */
proto.public.gwdealer.TransactionDetails.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.gwdealer.Token.prototype.toObject = function(opt_includeInstance) {
  return proto.public.gwdealer.Token.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.gwdealer.Token} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.Token.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    onchain: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    tokenType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.gwdealer.Token}
 */
proto.public.gwdealer.Token.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.gwdealer.Token;
  return proto.public.gwdealer.Token.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.gwdealer.Token} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.gwdealer.Token}
 */
proto.public.gwdealer.Token.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnchain(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.gwdealer.Token.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.gwdealer.Token.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.gwdealer.Token} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.Token.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOnchain();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTokenType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.public.gwdealer.Token.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.gwdealer.Token} returns this
 */
proto.public.gwdealer.Token.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool onchain = 2;
 * @return {boolean}
 */
proto.public.gwdealer.Token.prototype.getOnchain = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.public.gwdealer.Token} returns this
 */
proto.public.gwdealer.Token.prototype.setOnchain = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string token_type = 3;
 * @return {string}
 */
proto.public.gwdealer.Token.prototype.getTokenType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.gwdealer.Token} returns this
 */
proto.public.gwdealer.Token.prototype.setTokenType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 amount = 4;
 * @return {number}
 */
proto.public.gwdealer.Token.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.public.gwdealer.Token} returns this
 */
proto.public.gwdealer.Token.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.gwdealer.GetSwapTransaction.prototype.toObject = function(opt_includeInstance) {
  return proto.public.gwdealer.GetSwapTransaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.gwdealer.GetSwapTransaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetSwapTransaction.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.gwdealer.GetSwapTransaction}
 */
proto.public.gwdealer.GetSwapTransaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.gwdealer.GetSwapTransaction;
  return proto.public.gwdealer.GetSwapTransaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.gwdealer.GetSwapTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.gwdealer.GetSwapTransaction}
 */
proto.public.gwdealer.GetSwapTransaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.gwdealer.GetSwapTransaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.gwdealer.GetSwapTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.gwdealer.GetSwapTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetSwapTransaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.public.gwdealer.GetSwapTransaction.Request.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.gwdealer.GetSwapTransaction.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.gwdealer.GetSwapTransaction.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetSwapTransaction.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userTokensList: jspb.Message.toObjectList(msg.getUserTokensList(),
    proto.public.gwdealer.Token.toObject, includeInstance),
    dealerTokensList: jspb.Message.toObjectList(msg.getDealerTokensList(),
    proto.public.gwdealer.Token.toObject, includeInstance),
    srcAddr: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.gwdealer.GetSwapTransaction.Request}
 */
proto.public.gwdealer.GetSwapTransaction.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.gwdealer.GetSwapTransaction.Request;
  return proto.public.gwdealer.GetSwapTransaction.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.gwdealer.GetSwapTransaction.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.gwdealer.GetSwapTransaction.Request}
 */
proto.public.gwdealer.GetSwapTransaction.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.gwdealer.Token;
      reader.readMessage(value,proto.public.gwdealer.Token.deserializeBinaryFromReader);
      msg.addUserTokens(value);
      break;
    case 2:
      var value = new proto.public.gwdealer.Token;
      reader.readMessage(value,proto.public.gwdealer.Token.deserializeBinaryFromReader);
      msg.addDealerTokens(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcAddr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.gwdealer.GetSwapTransaction.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.gwdealer.GetSwapTransaction.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetSwapTransaction.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserTokensList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.public.gwdealer.Token.serializeBinaryToWriter
    );
  }
  f = message.getDealerTokensList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.public.gwdealer.Token.serializeBinaryToWriter
    );
  }
  f = message.getSrcAddr();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated Token user_tokens = 1;
 * @return {!Array<!proto.public.gwdealer.Token>}
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.getUserTokensList = function() {
  return /** @type{!Array<!proto.public.gwdealer.Token>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.gwdealer.Token, 1));
};


/**
 * @param {!Array<!proto.public.gwdealer.Token>} value
 * @return {!proto.public.gwdealer.GetSwapTransaction.Request} returns this
*/
proto.public.gwdealer.GetSwapTransaction.Request.prototype.setUserTokensList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.public.gwdealer.Token=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.gwdealer.Token}
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.addUserTokens = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.public.gwdealer.Token, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.gwdealer.GetSwapTransaction.Request} returns this
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.clearUserTokensList = function() {
  return this.setUserTokensList([]);
};


/**
 * repeated Token dealer_tokens = 2;
 * @return {!Array<!proto.public.gwdealer.Token>}
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.getDealerTokensList = function() {
  return /** @type{!Array<!proto.public.gwdealer.Token>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.public.gwdealer.Token, 2));
};


/**
 * @param {!Array<!proto.public.gwdealer.Token>} value
 * @return {!proto.public.gwdealer.GetSwapTransaction.Request} returns this
*/
proto.public.gwdealer.GetSwapTransaction.Request.prototype.setDealerTokensList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.public.gwdealer.Token=} opt_value
 * @param {number=} opt_index
 * @return {!proto.public.gwdealer.Token}
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.addDealerTokens = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.public.gwdealer.Token, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.public.gwdealer.GetSwapTransaction.Request} returns this
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.clearDealerTokensList = function() {
  return this.setDealerTokensList([]);
};


/**
 * optional string src_addr = 3;
 * @return {string}
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.getSrcAddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.gwdealer.GetSwapTransaction.Request} returns this
 */
proto.public.gwdealer.GetSwapTransaction.Request.prototype.setSrcAddr = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.gwdealer.GetSwapTransaction.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.gwdealer.GetSwapTransaction.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.gwdealer.GetSwapTransaction.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetSwapTransaction.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    transaction: (f = msg.getTransaction()) && proto.public.gwdealer.TransactionDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.gwdealer.GetSwapTransaction.Response}
 */
proto.public.gwdealer.GetSwapTransaction.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.gwdealer.GetSwapTransaction.Response;
  return proto.public.gwdealer.GetSwapTransaction.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.gwdealer.GetSwapTransaction.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.gwdealer.GetSwapTransaction.Response}
 */
proto.public.gwdealer.GetSwapTransaction.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.public.gwdealer.TransactionDetails;
      reader.readMessage(value,proto.public.gwdealer.TransactionDetails.deserializeBinaryFromReader);
      msg.setTransaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.gwdealer.GetSwapTransaction.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.gwdealer.GetSwapTransaction.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.gwdealer.GetSwapTransaction.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetSwapTransaction.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransaction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.public.gwdealer.TransactionDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional TransactionDetails transaction = 1;
 * @return {?proto.public.gwdealer.TransactionDetails}
 */
proto.public.gwdealer.GetSwapTransaction.Response.prototype.getTransaction = function() {
  return /** @type{?proto.public.gwdealer.TransactionDetails} */ (
    jspb.Message.getWrapperField(this, proto.public.gwdealer.TransactionDetails, 1));
};


/**
 * @param {?proto.public.gwdealer.TransactionDetails|undefined} value
 * @return {!proto.public.gwdealer.GetSwapTransaction.Response} returns this
*/
proto.public.gwdealer.GetSwapTransaction.Response.prototype.setTransaction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.public.gwdealer.GetSwapTransaction.Response} returns this
 */
proto.public.gwdealer.GetSwapTransaction.Response.prototype.clearTransaction = function() {
  return this.setTransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.public.gwdealer.GetSwapTransaction.Response.prototype.hasTransaction = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.gwdealer.GetEmpty.prototype.toObject = function(opt_includeInstance) {
  return proto.public.gwdealer.GetEmpty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.gwdealer.GetEmpty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetEmpty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.gwdealer.GetEmpty}
 */
proto.public.gwdealer.GetEmpty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.gwdealer.GetEmpty;
  return proto.public.gwdealer.GetEmpty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.gwdealer.GetEmpty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.gwdealer.GetEmpty}
 */
proto.public.gwdealer.GetEmpty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.gwdealer.GetEmpty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.gwdealer.GetEmpty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.gwdealer.GetEmpty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetEmpty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.gwdealer.GetEmpty.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.gwdealer.GetEmpty.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.gwdealer.GetEmpty.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetEmpty.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.gwdealer.GetEmpty.Request}
 */
proto.public.gwdealer.GetEmpty.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.gwdealer.GetEmpty.Request;
  return proto.public.gwdealer.GetEmpty.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.gwdealer.GetEmpty.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.gwdealer.GetEmpty.Request}
 */
proto.public.gwdealer.GetEmpty.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.gwdealer.GetEmpty.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.gwdealer.GetEmpty.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.gwdealer.GetEmpty.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetEmpty.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.gwdealer.GetEmpty.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.public.gwdealer.GetEmpty.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.gwdealer.GetEmpty.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetEmpty.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.gwdealer.GetEmpty.Response}
 */
proto.public.gwdealer.GetEmpty.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.gwdealer.GetEmpty.Response;
  return proto.public.gwdealer.GetEmpty.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.gwdealer.GetEmpty.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.gwdealer.GetEmpty.Response}
 */
proto.public.gwdealer.GetEmpty.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.gwdealer.GetEmpty.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.gwdealer.GetEmpty.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.gwdealer.GetEmpty.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.gwdealer.GetEmpty.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.public.gwdealer);

},{"google-protobuf":3}],53:[function(require,module,exports){
// source: idp.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.idp.Ident', null, global);
goog.exportSymbol('proto.idp.JWT', null, global);
goog.exportSymbol('proto.idp.LegacyUser', null, global);
goog.exportSymbol('proto.idp.Referral', null, global);
goog.exportSymbol('proto.idp.Referral.Attributes', null, global);
goog.exportSymbol('proto.idp.Referral.Attributes.Twitch', null, global);
goog.exportSymbol('proto.idp.UUID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.UUID.displayName = 'proto.idp.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.JWT = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.JWT, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.JWT.displayName = 'proto.idp.JWT';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Ident = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Ident, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Ident.displayName = 'proto.idp.Ident';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.LegacyUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.LegacyUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.LegacyUser.displayName = 'proto.idp.LegacyUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Referral = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Referral, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Referral.displayName = 'proto.idp.Referral';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Referral.Attributes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Referral.Attributes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Referral.Attributes.displayName = 'proto.idp.Referral.Attributes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Referral.Attributes.Twitch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Referral.Attributes.Twitch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Referral.Attributes.Twitch.displayName = 'proto.idp.Referral.Attributes.Twitch';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.UUID}
 */
proto.idp.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.UUID;
  return proto.idp.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.UUID}
 */
proto.idp.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.idp.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.UUID} returns this
 */
proto.idp.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.JWT.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.JWT.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.JWT} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.JWT.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.JWT}
 */
proto.idp.JWT.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.JWT;
  return proto.idp.JWT.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.JWT} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.JWT}
 */
proto.idp.JWT.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.JWT.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.JWT.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.JWT} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.JWT.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.idp.JWT.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.JWT} returns this
 */
proto.idp.JWT.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Ident.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Ident.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Ident} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Ident.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    suffix: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Ident}
 */
proto.idp.Ident.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Ident;
  return proto.idp.Ident.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Ident} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Ident}
 */
proto.idp.Ident.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Ident.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Ident.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Ident} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Ident.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSuffix();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.idp.Ident.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Ident} returns this
 */
proto.idp.Ident.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string suffix = 2;
 * @return {string}
 */
proto.idp.Ident.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Ident} returns this
 */
proto.idp.Ident.prototype.setSuffix = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.LegacyUser.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.LegacyUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.LegacyUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.LegacyUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hash: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.LegacyUser}
 */
proto.idp.LegacyUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.LegacyUser;
  return proto.idp.LegacyUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.LegacyUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.LegacyUser}
 */
proto.idp.LegacyUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.LegacyUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.LegacyUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.LegacyUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.LegacyUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.idp.LegacyUser.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.idp.LegacyUser} returns this
 */
proto.idp.LegacyUser.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string hash = 2;
 * @return {string}
 */
proto.idp.LegacyUser.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.LegacyUser} returns this
 */
proto.idp.LegacyUser.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Referral.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Referral.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Referral} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Referral.toObject = function(includeInstance, msg) {
  var f, obj = {
    referralId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    attributes: (f = msg.getAttributes()) && proto.idp.Referral.Attributes.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Referral}
 */
proto.idp.Referral.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Referral;
  return proto.idp.Referral.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Referral} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Referral}
 */
proto.idp.Referral.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferralId(value);
      break;
    case 2:
      var value = new proto.idp.Referral.Attributes;
      reader.readMessage(value,proto.idp.Referral.Attributes.deserializeBinaryFromReader);
      msg.setAttributes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Referral.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Referral.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Referral} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Referral.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReferralId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAttributes();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.idp.Referral.Attributes.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Referral.Attributes.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Referral.Attributes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Referral.Attributes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Referral.Attributes.toObject = function(includeInstance, msg) {
  var f, obj = {
    twitch: (f = msg.getTwitch()) && proto.idp.Referral.Attributes.Twitch.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Referral.Attributes}
 */
proto.idp.Referral.Attributes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Referral.Attributes;
  return proto.idp.Referral.Attributes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Referral.Attributes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Referral.Attributes}
 */
proto.idp.Referral.Attributes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.idp.Referral.Attributes.Twitch;
      reader.readMessage(value,proto.idp.Referral.Attributes.Twitch.deserializeBinaryFromReader);
      msg.setTwitch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Referral.Attributes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Referral.Attributes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Referral.Attributes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Referral.Attributes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTwitch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.idp.Referral.Attributes.Twitch.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Referral.Attributes.Twitch.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Referral.Attributes.Twitch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Referral.Attributes.Twitch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Referral.Attributes.Twitch.toObject = function(includeInstance, msg) {
  var f, obj = {
    createdAt: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    viewerLogin: jspb.Message.getFieldWithDefault(msg, 4, ""),
    streamerLogin: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Referral.Attributes.Twitch}
 */
proto.idp.Referral.Attributes.Twitch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Referral.Attributes.Twitch;
  return proto.idp.Referral.Attributes.Twitch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Referral.Attributes.Twitch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Referral.Attributes.Twitch}
 */
proto.idp.Referral.Attributes.Twitch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setViewerLogin(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamerLogin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Referral.Attributes.Twitch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Referral.Attributes.Twitch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Referral.Attributes.Twitch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Referral.Attributes.Twitch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getViewerLogin();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStreamerLogin();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string created_at = 1;
 * @return {string}
 */
proto.idp.Referral.Attributes.Twitch.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Referral.Attributes.Twitch} returns this
 */
proto.idp.Referral.Attributes.Twitch.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.idp.Referral.Attributes.Twitch.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Referral.Attributes.Twitch} returns this
 */
proto.idp.Referral.Attributes.Twitch.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 id = 3;
 * @return {number}
 */
proto.idp.Referral.Attributes.Twitch.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.idp.Referral.Attributes.Twitch} returns this
 */
proto.idp.Referral.Attributes.Twitch.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string viewer_login = 4;
 * @return {string}
 */
proto.idp.Referral.Attributes.Twitch.prototype.getViewerLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Referral.Attributes.Twitch} returns this
 */
proto.idp.Referral.Attributes.Twitch.prototype.setViewerLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string streamer_login = 5;
 * @return {string}
 */
proto.idp.Referral.Attributes.Twitch.prototype.getStreamerLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Referral.Attributes.Twitch} returns this
 */
proto.idp.Referral.Attributes.Twitch.prototype.setStreamerLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Twitch twitch = 1;
 * @return {?proto.idp.Referral.Attributes.Twitch}
 */
proto.idp.Referral.Attributes.prototype.getTwitch = function() {
  return /** @type{?proto.idp.Referral.Attributes.Twitch} */ (
    jspb.Message.getWrapperField(this, proto.idp.Referral.Attributes.Twitch, 1));
};


/**
 * @param {?proto.idp.Referral.Attributes.Twitch|undefined} value
 * @return {!proto.idp.Referral.Attributes} returns this
*/
proto.idp.Referral.Attributes.prototype.setTwitch = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.Referral.Attributes} returns this
 */
proto.idp.Referral.Attributes.prototype.clearTwitch = function() {
  return this.setTwitch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.Referral.Attributes.prototype.hasTwitch = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string referral_id = 1;
 * @return {string}
 */
proto.idp.Referral.prototype.getReferralId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Referral} returns this
 */
proto.idp.Referral.prototype.setReferralId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Attributes attributes = 2;
 * @return {?proto.idp.Referral.Attributes}
 */
proto.idp.Referral.prototype.getAttributes = function() {
  return /** @type{?proto.idp.Referral.Attributes} */ (
    jspb.Message.getWrapperField(this, proto.idp.Referral.Attributes, 2));
};


/**
 * @param {?proto.idp.Referral.Attributes|undefined} value
 * @return {!proto.idp.Referral} returns this
*/
proto.idp.Referral.prototype.setAttributes = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.Referral} returns this
 */
proto.idp.Referral.prototype.clearAttributes = function() {
  return this.setAttributes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.Referral.prototype.hasAttributes = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.idp);

},{"./validate/validate_pb.js":56,"google-protobuf":3}],54:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for idp
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('./validate/validate_pb.js')

var idp_shared_pb = require('./idp.shared_pb.js')
const proto = {};
proto.idp = require('./idp_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.idp.AccountsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.idp.AccountsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.CreateAccount.Request,
 *   !proto.idp.CreateAccount.Response>}
 */
const methodDescriptor_Accounts_CreateAccount = new grpc.web.MethodDescriptor(
  '/idp.Accounts/CreateAccount',
  grpc.web.MethodType.UNARY,
  proto.idp.CreateAccount.Request,
  proto.idp.CreateAccount.Response,
  /**
   * @param {!proto.idp.CreateAccount.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.CreateAccount.Response.deserializeBinary
);


/**
 * @param {!proto.idp.CreateAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.CreateAccount.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.CreateAccount.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.AccountsClient.prototype.createAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Accounts/CreateAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_CreateAccount,
      callback);
};


/**
 * @param {!proto.idp.CreateAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.CreateAccount.Response>}
 *     Promise that resolves to the response
 */
proto.idp.AccountsPromiseClient.prototype.createAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Accounts/CreateAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_CreateAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.UpdateAccount.Request,
 *   !proto.idp.UpdateAccount.Response>}
 */
const methodDescriptor_Accounts_UpdateAccount = new grpc.web.MethodDescriptor(
  '/idp.Accounts/UpdateAccount',
  grpc.web.MethodType.UNARY,
  proto.idp.UpdateAccount.Request,
  proto.idp.UpdateAccount.Response,
  /**
   * @param {!proto.idp.UpdateAccount.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.UpdateAccount.Response.deserializeBinary
);


/**
 * @param {!proto.idp.UpdateAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.UpdateAccount.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.UpdateAccount.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.AccountsClient.prototype.updateAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Accounts/UpdateAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_UpdateAccount,
      callback);
};


/**
 * @param {!proto.idp.UpdateAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.UpdateAccount.Response>}
 *     Promise that resolves to the response
 */
proto.idp.AccountsPromiseClient.prototype.updateAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Accounts/UpdateAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_UpdateAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.GetAccount.Request,
 *   !proto.idp.GetAccount.Response>}
 */
const methodDescriptor_Accounts_GetAccount = new grpc.web.MethodDescriptor(
  '/idp.Accounts/GetAccount',
  grpc.web.MethodType.UNARY,
  proto.idp.GetAccount.Request,
  proto.idp.GetAccount.Response,
  /**
   * @param {!proto.idp.GetAccount.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.GetAccount.Response.deserializeBinary
);


/**
 * @param {!proto.idp.GetAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.GetAccount.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.GetAccount.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.AccountsClient.prototype.getAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Accounts/GetAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_GetAccount,
      callback);
};


/**
 * @param {!proto.idp.GetAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.GetAccount.Response>}
 *     Promise that resolves to the response
 */
proto.idp.AccountsPromiseClient.prototype.getAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Accounts/GetAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_GetAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.VerifyAccount.Request,
 *   !proto.idp.VerifyAccount.Response>}
 */
const methodDescriptor_Accounts_VerifyAccount = new grpc.web.MethodDescriptor(
  '/idp.Accounts/VerifyAccount',
  grpc.web.MethodType.UNARY,
  proto.idp.VerifyAccount.Request,
  proto.idp.VerifyAccount.Response,
  /**
   * @param {!proto.idp.VerifyAccount.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.VerifyAccount.Response.deserializeBinary
);


/**
 * @param {!proto.idp.VerifyAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.VerifyAccount.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.VerifyAccount.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.AccountsClient.prototype.verifyAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Accounts/VerifyAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_VerifyAccount,
      callback);
};


/**
 * @param {!proto.idp.VerifyAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.VerifyAccount.Response>}
 *     Promise that resolves to the response
 */
proto.idp.AccountsPromiseClient.prototype.verifyAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Accounts/VerifyAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_VerifyAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.AssertAccount.Request,
 *   !proto.idp.AssertAccount.Response>}
 */
const methodDescriptor_Accounts_AssertAccount = new grpc.web.MethodDescriptor(
  '/idp.Accounts/AssertAccount',
  grpc.web.MethodType.UNARY,
  proto.idp.AssertAccount.Request,
  proto.idp.AssertAccount.Response,
  /**
   * @param {!proto.idp.AssertAccount.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.AssertAccount.Response.deserializeBinary
);


/**
 * @param {!proto.idp.AssertAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.AssertAccount.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.AssertAccount.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.AccountsClient.prototype.assertAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Accounts/AssertAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_AssertAccount,
      callback);
};


/**
 * @param {!proto.idp.AssertAccount.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.AssertAccount.Response>}
 *     Promise that resolves to the response
 */
proto.idp.AccountsPromiseClient.prototype.assertAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Accounts/AssertAccount',
      request,
      metadata || {},
      methodDescriptor_Accounts_AssertAccount);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.idp.ConnectClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.idp.ConnectPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.Authenticate.Request,
 *   !proto.idp.Authenticate.Response>}
 */
const methodDescriptor_Connect_Authenticate = new grpc.web.MethodDescriptor(
  '/idp.Connect/Authenticate',
  grpc.web.MethodType.UNARY,
  proto.idp.Authenticate.Request,
  proto.idp.Authenticate.Response,
  /**
   * @param {!proto.idp.Authenticate.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.Authenticate.Response.deserializeBinary
);


/**
 * @param {!proto.idp.Authenticate.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.Authenticate.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.Authenticate.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.ConnectClient.prototype.authenticate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Connect/Authenticate',
      request,
      metadata || {},
      methodDescriptor_Connect_Authenticate,
      callback);
};


/**
 * @param {!proto.idp.Authenticate.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.Authenticate.Response>}
 *     Promise that resolves to the response
 */
proto.idp.ConnectPromiseClient.prototype.authenticate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Connect/Authenticate',
      request,
      metadata || {},
      methodDescriptor_Connect_Authenticate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.Logout.Request,
 *   !proto.idp.Logout.Response>}
 */
const methodDescriptor_Connect_Logout = new grpc.web.MethodDescriptor(
  '/idp.Connect/Logout',
  grpc.web.MethodType.UNARY,
  proto.idp.Logout.Request,
  proto.idp.Logout.Response,
  /**
   * @param {!proto.idp.Logout.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.Logout.Response.deserializeBinary
);


/**
 * @param {!proto.idp.Logout.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.Logout.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.Logout.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.ConnectClient.prototype.logout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Connect/Logout',
      request,
      metadata || {},
      methodDescriptor_Connect_Logout,
      callback);
};


/**
 * @param {!proto.idp.Logout.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.Logout.Response>}
 *     Promise that resolves to the response
 */
proto.idp.ConnectPromiseClient.prototype.logout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Connect/Logout',
      request,
      metadata || {},
      methodDescriptor_Connect_Logout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.Rescue.Request,
 *   !proto.idp.Rescue.Response>}
 */
const methodDescriptor_Connect_Rescue = new grpc.web.MethodDescriptor(
  '/idp.Connect/Rescue',
  grpc.web.MethodType.UNARY,
  proto.idp.Rescue.Request,
  proto.idp.Rescue.Response,
  /**
   * @param {!proto.idp.Rescue.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.Rescue.Response.deserializeBinary
);


/**
 * @param {!proto.idp.Rescue.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.Rescue.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.Rescue.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.ConnectClient.prototype.rescue =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Connect/Rescue',
      request,
      metadata || {},
      methodDescriptor_Connect_Rescue,
      callback);
};


/**
 * @param {!proto.idp.Rescue.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.Rescue.Response>}
 *     Promise that resolves to the response
 */
proto.idp.ConnectPromiseClient.prototype.rescue =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Connect/Rescue',
      request,
      metadata || {},
      methodDescriptor_Connect_Rescue);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.idp.ValidatorClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.idp.ValidatorPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.idp.ValidateToken.Request,
 *   !proto.idp.ValidateToken.Response>}
 */
const methodDescriptor_Validator_ValidateToken = new grpc.web.MethodDescriptor(
  '/idp.Validator/ValidateToken',
  grpc.web.MethodType.UNARY,
  proto.idp.ValidateToken.Request,
  proto.idp.ValidateToken.Response,
  /**
   * @param {!proto.idp.ValidateToken.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.idp.ValidateToken.Response.deserializeBinary
);


/**
 * @param {!proto.idp.ValidateToken.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.idp.ValidateToken.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.idp.ValidateToken.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.idp.ValidatorClient.prototype.validateToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/idp.Validator/ValidateToken',
      request,
      metadata || {},
      methodDescriptor_Validator_ValidateToken,
      callback);
};


/**
 * @param {!proto.idp.ValidateToken.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.idp.ValidateToken.Response>}
 *     Promise that resolves to the response
 */
proto.idp.ValidatorPromiseClient.prototype.validateToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/idp.Validator/ValidateToken',
      request,
      metadata || {},
      methodDescriptor_Validator_ValidateToken);
};


module.exports = proto.idp;


},{"./idp.shared_pb.js":53,"./idp_pb.js":55,"./validate/validate_pb.js":56,"grpc-web":7}],55:[function(require,module,exports){
// source: idp.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var idp_shared_pb = require('./idp.shared_pb.js');
goog.object.extend(proto, idp_shared_pb);
goog.exportSymbol('proto.idp.AssertAccount', null, global);
goog.exportSymbol('proto.idp.AssertAccount.Request', null, global);
goog.exportSymbol('proto.idp.AssertAccount.Response', null, global);
goog.exportSymbol('proto.idp.Authenticate', null, global);
goog.exportSymbol('proto.idp.Authenticate.Request', null, global);
goog.exportSymbol('proto.idp.Authenticate.Request.Remember', null, global);
goog.exportSymbol('proto.idp.Authenticate.Response', null, global);
goog.exportSymbol('proto.idp.CreateAccount', null, global);
goog.exportSymbol('proto.idp.CreateAccount.Request', null, global);
goog.exportSymbol('proto.idp.CreateAccount.Response', null, global);
goog.exportSymbol('proto.idp.GetAccount', null, global);
goog.exportSymbol('proto.idp.GetAccount.Request', null, global);
goog.exportSymbol('proto.idp.GetAccount.Response', null, global);
goog.exportSymbol('proto.idp.Logout', null, global);
goog.exportSymbol('proto.idp.Logout.Request', null, global);
goog.exportSymbol('proto.idp.Logout.Response', null, global);
goog.exportSymbol('proto.idp.Rescue', null, global);
goog.exportSymbol('proto.idp.Rescue.Request', null, global);
goog.exportSymbol('proto.idp.Rescue.Response', null, global);
goog.exportSymbol('proto.idp.UpdateAccount', null, global);
goog.exportSymbol('proto.idp.UpdateAccount.Request', null, global);
goog.exportSymbol('proto.idp.UpdateAccount.Response', null, global);
goog.exportSymbol('proto.idp.ValidateToken', null, global);
goog.exportSymbol('proto.idp.ValidateToken.Request', null, global);
goog.exportSymbol('proto.idp.ValidateToken.Response', null, global);
goog.exportSymbol('proto.idp.VerifyAccount', null, global);
goog.exportSymbol('proto.idp.VerifyAccount.Request', null, global);
goog.exportSymbol('proto.idp.VerifyAccount.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.CreateAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.CreateAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.CreateAccount.displayName = 'proto.idp.CreateAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.CreateAccount.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.CreateAccount.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.CreateAccount.Request.displayName = 'proto.idp.CreateAccount.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.CreateAccount.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.CreateAccount.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.CreateAccount.Response.displayName = 'proto.idp.CreateAccount.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.UpdateAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.UpdateAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.UpdateAccount.displayName = 'proto.idp.UpdateAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.UpdateAccount.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.UpdateAccount.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.UpdateAccount.Request.displayName = 'proto.idp.UpdateAccount.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.UpdateAccount.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.UpdateAccount.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.UpdateAccount.Response.displayName = 'proto.idp.UpdateAccount.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.GetAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.GetAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.GetAccount.displayName = 'proto.idp.GetAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.GetAccount.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.GetAccount.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.GetAccount.Request.displayName = 'proto.idp.GetAccount.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.GetAccount.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.GetAccount.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.GetAccount.Response.displayName = 'proto.idp.GetAccount.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.VerifyAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.VerifyAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.VerifyAccount.displayName = 'proto.idp.VerifyAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.VerifyAccount.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.VerifyAccount.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.VerifyAccount.Request.displayName = 'proto.idp.VerifyAccount.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.VerifyAccount.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.VerifyAccount.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.VerifyAccount.Response.displayName = 'proto.idp.VerifyAccount.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.AssertAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.AssertAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.AssertAccount.displayName = 'proto.idp.AssertAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.AssertAccount.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.AssertAccount.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.AssertAccount.Request.displayName = 'proto.idp.AssertAccount.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.AssertAccount.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.AssertAccount.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.AssertAccount.Response.displayName = 'proto.idp.AssertAccount.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Authenticate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Authenticate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Authenticate.displayName = 'proto.idp.Authenticate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Authenticate.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Authenticate.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Authenticate.Request.displayName = 'proto.idp.Authenticate.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Authenticate.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Authenticate.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Authenticate.Response.displayName = 'proto.idp.Authenticate.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Logout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Logout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Logout.displayName = 'proto.idp.Logout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Logout.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Logout.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Logout.Request.displayName = 'proto.idp.Logout.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Logout.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Logout.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Logout.Response.displayName = 'proto.idp.Logout.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Rescue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Rescue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Rescue.displayName = 'proto.idp.Rescue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Rescue.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Rescue.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Rescue.Request.displayName = 'proto.idp.Rescue.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.Rescue.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.Rescue.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.Rescue.Response.displayName = 'proto.idp.Rescue.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.ValidateToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.ValidateToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.ValidateToken.displayName = 'proto.idp.ValidateToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.ValidateToken.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.ValidateToken.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.ValidateToken.Request.displayName = 'proto.idp.ValidateToken.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.idp.ValidateToken.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.idp.ValidateToken.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.idp.ValidateToken.Response.displayName = 'proto.idp.ValidateToken.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.CreateAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.CreateAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.CreateAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.CreateAccount.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.CreateAccount}
 */
proto.idp.CreateAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.CreateAccount;
  return proto.idp.CreateAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.CreateAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.CreateAccount}
 */
proto.idp.CreateAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.CreateAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.CreateAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.CreateAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.CreateAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.CreateAccount.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.CreateAccount.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.CreateAccount.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.CreateAccount.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    password: jspb.Message.getFieldWithDefault(msg, 3, ""),
    referral: (f = msg.getReferral()) && idp_shared_pb.Referral.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.CreateAccount.Request}
 */
proto.idp.CreateAccount.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.CreateAccount.Request;
  return proto.idp.CreateAccount.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.CreateAccount.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.CreateAccount.Request}
 */
proto.idp.CreateAccount.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 4:
      var value = new idp_shared_pb.Referral;
      reader.readMessage(value,idp_shared_pb.Referral.deserializeBinaryFromReader);
      msg.setReferral(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.CreateAccount.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.CreateAccount.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.CreateAccount.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.CreateAccount.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReferral();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      idp_shared_pb.Referral.serializeBinaryToWriter
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.idp.CreateAccount.Request.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.CreateAccount.Request} returns this
 */
proto.idp.CreateAccount.Request.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.idp.CreateAccount.Request.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.CreateAccount.Request} returns this
 */
proto.idp.CreateAccount.Request.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string password = 3;
 * @return {string}
 */
proto.idp.CreateAccount.Request.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.CreateAccount.Request} returns this
 */
proto.idp.CreateAccount.Request.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Referral referral = 4;
 * @return {?proto.idp.Referral}
 */
proto.idp.CreateAccount.Request.prototype.getReferral = function() {
  return /** @type{?proto.idp.Referral} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.Referral, 4));
};


/**
 * @param {?proto.idp.Referral|undefined} value
 * @return {!proto.idp.CreateAccount.Request} returns this
*/
proto.idp.CreateAccount.Request.prototype.setReferral = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.CreateAccount.Request} returns this
 */
proto.idp.CreateAccount.Request.prototype.clearReferral = function() {
  return this.setReferral(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.CreateAccount.Request.prototype.hasReferral = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.CreateAccount.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.CreateAccount.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.CreateAccount.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.CreateAccount.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    ident: (f = msg.getIdent()) && idp_shared_pb.Ident.toObject(includeInstance, f),
    userId: (f = msg.getUserId()) && idp_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.CreateAccount.Response}
 */
proto.idp.CreateAccount.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.CreateAccount.Response;
  return proto.idp.CreateAccount.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.CreateAccount.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.CreateAccount.Response}
 */
proto.idp.CreateAccount.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new idp_shared_pb.Ident;
      reader.readMessage(value,idp_shared_pb.Ident.deserializeBinaryFromReader);
      msg.setIdent(value);
      break;
    case 2:
      var value = new idp_shared_pb.UUID;
      reader.readMessage(value,idp_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.CreateAccount.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.CreateAccount.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.CreateAccount.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.CreateAccount.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      idp_shared_pb.Ident.serializeBinaryToWriter
    );
  }
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      idp_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional Ident ident = 1;
 * @return {?proto.idp.Ident}
 */
proto.idp.CreateAccount.Response.prototype.getIdent = function() {
  return /** @type{?proto.idp.Ident} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.Ident, 1));
};


/**
 * @param {?proto.idp.Ident|undefined} value
 * @return {!proto.idp.CreateAccount.Response} returns this
*/
proto.idp.CreateAccount.Response.prototype.setIdent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.CreateAccount.Response} returns this
 */
proto.idp.CreateAccount.Response.prototype.clearIdent = function() {
  return this.setIdent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.CreateAccount.Response.prototype.hasIdent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UUID user_id = 2;
 * @return {?proto.idp.UUID}
 */
proto.idp.CreateAccount.Response.prototype.getUserId = function() {
  return /** @type{?proto.idp.UUID} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.UUID, 2));
};


/**
 * @param {?proto.idp.UUID|undefined} value
 * @return {!proto.idp.CreateAccount.Response} returns this
*/
proto.idp.CreateAccount.Response.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.CreateAccount.Response} returns this
 */
proto.idp.CreateAccount.Response.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.CreateAccount.Response.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.UpdateAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.UpdateAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.UpdateAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.UpdateAccount.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.UpdateAccount}
 */
proto.idp.UpdateAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.UpdateAccount;
  return proto.idp.UpdateAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.UpdateAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.UpdateAccount}
 */
proto.idp.UpdateAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.UpdateAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.UpdateAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.UpdateAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.UpdateAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.UpdateAccount.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.UpdateAccount.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.UpdateAccount.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.UpdateAccount.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    newPassword: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.UpdateAccount.Request}
 */
proto.idp.UpdateAccount.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.UpdateAccount.Request;
  return proto.idp.UpdateAccount.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.UpdateAccount.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.UpdateAccount.Request}
 */
proto.idp.UpdateAccount.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.UpdateAccount.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.UpdateAccount.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.UpdateAccount.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.UpdateAccount.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.idp.UpdateAccount.Request.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.UpdateAccount.Request} returns this
 */
proto.idp.UpdateAccount.Request.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.idp.UpdateAccount.Request.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.UpdateAccount.Request} returns this
 */
proto.idp.UpdateAccount.Request.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string new_password = 3;
 * @return {string}
 */
proto.idp.UpdateAccount.Request.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.UpdateAccount.Request} returns this
 */
proto.idp.UpdateAccount.Request.prototype.setNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.UpdateAccount.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.UpdateAccount.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.UpdateAccount.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.UpdateAccount.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    ident: (f = msg.getIdent()) && idp_shared_pb.Ident.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.UpdateAccount.Response}
 */
proto.idp.UpdateAccount.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.UpdateAccount.Response;
  return proto.idp.UpdateAccount.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.UpdateAccount.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.UpdateAccount.Response}
 */
proto.idp.UpdateAccount.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new idp_shared_pb.Ident;
      reader.readMessage(value,idp_shared_pb.Ident.deserializeBinaryFromReader);
      msg.setIdent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.UpdateAccount.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.UpdateAccount.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.UpdateAccount.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.UpdateAccount.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      idp_shared_pb.Ident.serializeBinaryToWriter
    );
  }
};


/**
 * optional Ident ident = 1;
 * @return {?proto.idp.Ident}
 */
proto.idp.UpdateAccount.Response.prototype.getIdent = function() {
  return /** @type{?proto.idp.Ident} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.Ident, 1));
};


/**
 * @param {?proto.idp.Ident|undefined} value
 * @return {!proto.idp.UpdateAccount.Response} returns this
*/
proto.idp.UpdateAccount.Response.prototype.setIdent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.UpdateAccount.Response} returns this
 */
proto.idp.UpdateAccount.Response.prototype.clearIdent = function() {
  return this.setIdent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.UpdateAccount.Response.prototype.hasIdent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.GetAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.GetAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.GetAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.GetAccount.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.GetAccount}
 */
proto.idp.GetAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.GetAccount;
  return proto.idp.GetAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.GetAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.GetAccount}
 */
proto.idp.GetAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.GetAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.GetAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.GetAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.GetAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.GetAccount.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.GetAccount.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.GetAccount.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.GetAccount.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.GetAccount.Request}
 */
proto.idp.GetAccount.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.GetAccount.Request;
  return proto.idp.GetAccount.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.GetAccount.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.GetAccount.Request}
 */
proto.idp.GetAccount.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.GetAccount.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.GetAccount.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.GetAccount.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.GetAccount.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.GetAccount.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.GetAccount.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.GetAccount.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.GetAccount.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ident: (f = msg.getIdent()) && idp_shared_pb.Ident.toObject(includeInstance, f),
    verified: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    userId: (f = msg.getUserId()) && idp_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.GetAccount.Response}
 */
proto.idp.GetAccount.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.GetAccount.Response;
  return proto.idp.GetAccount.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.GetAccount.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.GetAccount.Response}
 */
proto.idp.GetAccount.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = new idp_shared_pb.Ident;
      reader.readMessage(value,idp_shared_pb.Ident.deserializeBinaryFromReader);
      msg.setIdent(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerified(value);
      break;
    case 4:
      var value = new idp_shared_pb.UUID;
      reader.readMessage(value,idp_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.GetAccount.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.GetAccount.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.GetAccount.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.GetAccount.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      idp_shared_pb.Ident.serializeBinaryToWriter
    );
  }
  f = message.getVerified();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      idp_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.idp.GetAccount.Response.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.GetAccount.Response} returns this
 */
proto.idp.GetAccount.Response.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Ident ident = 2;
 * @return {?proto.idp.Ident}
 */
proto.idp.GetAccount.Response.prototype.getIdent = function() {
  return /** @type{?proto.idp.Ident} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.Ident, 2));
};


/**
 * @param {?proto.idp.Ident|undefined} value
 * @return {!proto.idp.GetAccount.Response} returns this
*/
proto.idp.GetAccount.Response.prototype.setIdent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.GetAccount.Response} returns this
 */
proto.idp.GetAccount.Response.prototype.clearIdent = function() {
  return this.setIdent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.GetAccount.Response.prototype.hasIdent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool verified = 3;
 * @return {boolean}
 */
proto.idp.GetAccount.Response.prototype.getVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.idp.GetAccount.Response} returns this
 */
proto.idp.GetAccount.Response.prototype.setVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional UUID user_id = 4;
 * @return {?proto.idp.UUID}
 */
proto.idp.GetAccount.Response.prototype.getUserId = function() {
  return /** @type{?proto.idp.UUID} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.UUID, 4));
};


/**
 * @param {?proto.idp.UUID|undefined} value
 * @return {!proto.idp.GetAccount.Response} returns this
*/
proto.idp.GetAccount.Response.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.GetAccount.Response} returns this
 */
proto.idp.GetAccount.Response.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.GetAccount.Response.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.VerifyAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.VerifyAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.VerifyAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.VerifyAccount.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.VerifyAccount}
 */
proto.idp.VerifyAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.VerifyAccount;
  return proto.idp.VerifyAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.VerifyAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.VerifyAccount}
 */
proto.idp.VerifyAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.VerifyAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.VerifyAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.VerifyAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.VerifyAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.VerifyAccount.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.VerifyAccount.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.VerifyAccount.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.VerifyAccount.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: (f = msg.getToken()) && idp_shared_pb.JWT.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.VerifyAccount.Request}
 */
proto.idp.VerifyAccount.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.VerifyAccount.Request;
  return proto.idp.VerifyAccount.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.VerifyAccount.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.VerifyAccount.Request}
 */
proto.idp.VerifyAccount.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new idp_shared_pb.JWT;
      reader.readMessage(value,idp_shared_pb.JWT.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.VerifyAccount.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.VerifyAccount.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.VerifyAccount.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.VerifyAccount.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      idp_shared_pb.JWT.serializeBinaryToWriter
    );
  }
};


/**
 * optional JWT token = 1;
 * @return {?proto.idp.JWT}
 */
proto.idp.VerifyAccount.Request.prototype.getToken = function() {
  return /** @type{?proto.idp.JWT} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.JWT, 1));
};


/**
 * @param {?proto.idp.JWT|undefined} value
 * @return {!proto.idp.VerifyAccount.Request} returns this
*/
proto.idp.VerifyAccount.Request.prototype.setToken = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.VerifyAccount.Request} returns this
 */
proto.idp.VerifyAccount.Request.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.VerifyAccount.Request.prototype.hasToken = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.VerifyAccount.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.VerifyAccount.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.VerifyAccount.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.VerifyAccount.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.VerifyAccount.Response}
 */
proto.idp.VerifyAccount.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.VerifyAccount.Response;
  return proto.idp.VerifyAccount.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.VerifyAccount.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.VerifyAccount.Response}
 */
proto.idp.VerifyAccount.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.VerifyAccount.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.VerifyAccount.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.VerifyAccount.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.VerifyAccount.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.AssertAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.AssertAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.AssertAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.AssertAccount.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.AssertAccount}
 */
proto.idp.AssertAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.AssertAccount;
  return proto.idp.AssertAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.AssertAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.AssertAccount}
 */
proto.idp.AssertAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.AssertAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.AssertAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.AssertAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.AssertAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.AssertAccount.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.AssertAccount.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.AssertAccount.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.AssertAccount.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.AssertAccount.Request}
 */
proto.idp.AssertAccount.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.AssertAccount.Request;
  return proto.idp.AssertAccount.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.AssertAccount.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.AssertAccount.Request}
 */
proto.idp.AssertAccount.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.AssertAccount.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.AssertAccount.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.AssertAccount.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.AssertAccount.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.AssertAccount.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.AssertAccount.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.AssertAccount.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.AssertAccount.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.AssertAccount.Response}
 */
proto.idp.AssertAccount.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.AssertAccount.Response;
  return proto.idp.AssertAccount.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.AssertAccount.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.AssertAccount.Response}
 */
proto.idp.AssertAccount.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.AssertAccount.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.AssertAccount.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.AssertAccount.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.AssertAccount.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Authenticate.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Authenticate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Authenticate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Authenticate.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Authenticate}
 */
proto.idp.Authenticate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Authenticate;
  return proto.idp.Authenticate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Authenticate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Authenticate}
 */
proto.idp.Authenticate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Authenticate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Authenticate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Authenticate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Authenticate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Authenticate.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Authenticate.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Authenticate.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Authenticate.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    password: jspb.Message.getFieldWithDefault(msg, 2, ""),
    remember: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Authenticate.Request}
 */
proto.idp.Authenticate.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Authenticate.Request;
  return proto.idp.Authenticate.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Authenticate.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Authenticate.Request}
 */
proto.idp.Authenticate.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 3:
      var value = /** @type {!proto.idp.Authenticate.Request.Remember} */ (reader.readEnum());
      msg.setRemember(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Authenticate.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Authenticate.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Authenticate.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Authenticate.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRemember();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.idp.Authenticate.Request.Remember = {
  NEVER: 0,
  ALWAYS: 1
};

/**
 * optional string email = 1;
 * @return {string}
 */
proto.idp.Authenticate.Request.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Authenticate.Request} returns this
 */
proto.idp.Authenticate.Request.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.idp.Authenticate.Request.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Authenticate.Request} returns this
 */
proto.idp.Authenticate.Request.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Remember remember = 3;
 * @return {!proto.idp.Authenticate.Request.Remember}
 */
proto.idp.Authenticate.Request.prototype.getRemember = function() {
  return /** @type {!proto.idp.Authenticate.Request.Remember} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.idp.Authenticate.Request.Remember} value
 * @return {!proto.idp.Authenticate.Request} returns this
 */
proto.idp.Authenticate.Request.prototype.setRemember = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Authenticate.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Authenticate.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Authenticate.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Authenticate.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Authenticate.Response}
 */
proto.idp.Authenticate.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Authenticate.Response;
  return proto.idp.Authenticate.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Authenticate.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Authenticate.Response}
 */
proto.idp.Authenticate.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Authenticate.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Authenticate.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Authenticate.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Authenticate.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Logout.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Logout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Logout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Logout.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Logout}
 */
proto.idp.Logout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Logout;
  return proto.idp.Logout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Logout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Logout}
 */
proto.idp.Logout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Logout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Logout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Logout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Logout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Logout.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Logout.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Logout.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Logout.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Logout.Request}
 */
proto.idp.Logout.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Logout.Request;
  return proto.idp.Logout.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Logout.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Logout.Request}
 */
proto.idp.Logout.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Logout.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Logout.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Logout.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Logout.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Logout.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Logout.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Logout.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Logout.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Logout.Response}
 */
proto.idp.Logout.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Logout.Response;
  return proto.idp.Logout.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Logout.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Logout.Response}
 */
proto.idp.Logout.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Logout.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Logout.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Logout.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Logout.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Rescue.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Rescue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Rescue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Rescue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Rescue}
 */
proto.idp.Rescue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Rescue;
  return proto.idp.Rescue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Rescue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Rescue}
 */
proto.idp.Rescue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Rescue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Rescue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Rescue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Rescue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Rescue.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Rescue.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Rescue.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Rescue.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Rescue.Request}
 */
proto.idp.Rescue.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Rescue.Request;
  return proto.idp.Rescue.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Rescue.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Rescue.Request}
 */
proto.idp.Rescue.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Rescue.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Rescue.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Rescue.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Rescue.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.idp.Rescue.Request.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.idp.Rescue.Request} returns this
 */
proto.idp.Rescue.Request.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.Rescue.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.Rescue.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.Rescue.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Rescue.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.Rescue.Response}
 */
proto.idp.Rescue.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.Rescue.Response;
  return proto.idp.Rescue.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.Rescue.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.Rescue.Response}
 */
proto.idp.Rescue.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.Rescue.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.Rescue.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.Rescue.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.Rescue.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.ValidateToken.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.ValidateToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.ValidateToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.ValidateToken.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.ValidateToken}
 */
proto.idp.ValidateToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.ValidateToken;
  return proto.idp.ValidateToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.ValidateToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.ValidateToken}
 */
proto.idp.ValidateToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.ValidateToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.ValidateToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.ValidateToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.ValidateToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.ValidateToken.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.ValidateToken.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.ValidateToken.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.ValidateToken.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: (f = msg.getToken()) && idp_shared_pb.JWT.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.ValidateToken.Request}
 */
proto.idp.ValidateToken.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.ValidateToken.Request;
  return proto.idp.ValidateToken.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.ValidateToken.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.ValidateToken.Request}
 */
proto.idp.ValidateToken.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new idp_shared_pb.JWT;
      reader.readMessage(value,idp_shared_pb.JWT.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.ValidateToken.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.ValidateToken.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.ValidateToken.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.ValidateToken.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      idp_shared_pb.JWT.serializeBinaryToWriter
    );
  }
};


/**
 * optional JWT token = 1;
 * @return {?proto.idp.JWT}
 */
proto.idp.ValidateToken.Request.prototype.getToken = function() {
  return /** @type{?proto.idp.JWT} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.JWT, 1));
};


/**
 * @param {?proto.idp.JWT|undefined} value
 * @return {!proto.idp.ValidateToken.Request} returns this
*/
proto.idp.ValidateToken.Request.prototype.setToken = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.ValidateToken.Request} returns this
 */
proto.idp.ValidateToken.Request.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.ValidateToken.Request.prototype.hasToken = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.idp.ValidateToken.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.idp.ValidateToken.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.idp.ValidateToken.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.ValidateToken.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && idp_shared_pb.UUID.toObject(includeInstance, f),
    tokenId: (f = msg.getTokenId()) && idp_shared_pb.UUID.toObject(includeInstance, f),
    legacyUser: (f = msg.getLegacyUser()) && idp_shared_pb.LegacyUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.idp.ValidateToken.Response}
 */
proto.idp.ValidateToken.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.idp.ValidateToken.Response;
  return proto.idp.ValidateToken.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.idp.ValidateToken.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.idp.ValidateToken.Response}
 */
proto.idp.ValidateToken.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new idp_shared_pb.UUID;
      reader.readMessage(value,idp_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    case 2:
      var value = new idp_shared_pb.UUID;
      reader.readMessage(value,idp_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setTokenId(value);
      break;
    case 3:
      var value = new idp_shared_pb.LegacyUser;
      reader.readMessage(value,idp_shared_pb.LegacyUser.deserializeBinaryFromReader);
      msg.setLegacyUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.idp.ValidateToken.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.idp.ValidateToken.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.idp.ValidateToken.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.idp.ValidateToken.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      idp_shared_pb.UUID.serializeBinaryToWriter
    );
  }
  f = message.getTokenId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      idp_shared_pb.UUID.serializeBinaryToWriter
    );
  }
  f = message.getLegacyUser();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      idp_shared_pb.LegacyUser.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID user_id = 1;
 * @return {?proto.idp.UUID}
 */
proto.idp.ValidateToken.Response.prototype.getUserId = function() {
  return /** @type{?proto.idp.UUID} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.UUID, 1));
};


/**
 * @param {?proto.idp.UUID|undefined} value
 * @return {!proto.idp.ValidateToken.Response} returns this
*/
proto.idp.ValidateToken.Response.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.ValidateToken.Response} returns this
 */
proto.idp.ValidateToken.Response.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.ValidateToken.Response.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UUID token_id = 2;
 * @return {?proto.idp.UUID}
 */
proto.idp.ValidateToken.Response.prototype.getTokenId = function() {
  return /** @type{?proto.idp.UUID} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.UUID, 2));
};


/**
 * @param {?proto.idp.UUID|undefined} value
 * @return {!proto.idp.ValidateToken.Response} returns this
*/
proto.idp.ValidateToken.Response.prototype.setTokenId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.ValidateToken.Response} returns this
 */
proto.idp.ValidateToken.Response.prototype.clearTokenId = function() {
  return this.setTokenId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.ValidateToken.Response.prototype.hasTokenId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LegacyUser legacy_user = 3;
 * @return {?proto.idp.LegacyUser}
 */
proto.idp.ValidateToken.Response.prototype.getLegacyUser = function() {
  return /** @type{?proto.idp.LegacyUser} */ (
    jspb.Message.getWrapperField(this, idp_shared_pb.LegacyUser, 3));
};


/**
 * @param {?proto.idp.LegacyUser|undefined} value
 * @return {!proto.idp.ValidateToken.Response} returns this
*/
proto.idp.ValidateToken.Response.prototype.setLegacyUser = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.idp.ValidateToken.Response} returns this
 */
proto.idp.ValidateToken.Response.prototype.clearLegacyUser = function() {
  return this.setLegacyUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.idp.ValidateToken.Response.prototype.hasLegacyUser = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.idp);

},{"./idp.shared_pb.js":53,"./validate/validate_pb.js":56,"google-protobuf":3}],56:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],57:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for images
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var images_shared_pb = require('./images.shared_pb.js')
const proto = {};
proto.images = require('./images.public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.images.PublicClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.images.PublicPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.images.GetActualImages.Request,
 *   !proto.images.GetActualImages.Response>}
 */
const methodDescriptor_Public_GetActualImages = new grpc.web.MethodDescriptor(
  '/images.Public/GetActualImages',
  grpc.web.MethodType.UNARY,
  proto.images.GetActualImages.Request,
  proto.images.GetActualImages.Response,
  /**
   * @param {!proto.images.GetActualImages.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.images.GetActualImages.Response.deserializeBinary
);


/**
 * @param {!proto.images.GetActualImages.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.images.GetActualImages.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.images.GetActualImages.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.images.PublicClient.prototype.getActualImages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/images.Public/GetActualImages',
      request,
      metadata || {},
      methodDescriptor_Public_GetActualImages,
      callback);
};


/**
 * @param {!proto.images.GetActualImages.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.images.GetActualImages.Response>}
 *     Promise that resolves to the response
 */
proto.images.PublicPromiseClient.prototype.getActualImages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/images.Public/GetActualImages',
      request,
      metadata || {},
      methodDescriptor_Public_GetActualImages);
};


module.exports = proto.images;


},{"./images.public_pb.js":58,"./images.shared_pb.js":59,"grpc-web":7}],58:[function(require,module,exports){
// source: images.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var images_shared_pb = require('./images.shared_pb.js');
goog.object.extend(proto, images_shared_pb);
goog.exportSymbol('proto.images.GetActualImages', null, global);
goog.exportSymbol('proto.images.GetActualImages.Request', null, global);
goog.exportSymbol('proto.images.GetActualImages.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.images.GetActualImages = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.images.GetActualImages, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.images.GetActualImages.displayName = 'proto.images.GetActualImages';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.images.GetActualImages.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.images.GetActualImages.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.images.GetActualImages.Request.displayName = 'proto.images.GetActualImages.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.images.GetActualImages.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.images.GetActualImages.Response.repeatedFields_, null);
};
goog.inherits(proto.images.GetActualImages.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.images.GetActualImages.Response.displayName = 'proto.images.GetActualImages.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.images.GetActualImages.prototype.toObject = function(opt_includeInstance) {
  return proto.images.GetActualImages.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.images.GetActualImages} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.GetActualImages.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.images.GetActualImages}
 */
proto.images.GetActualImages.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.images.GetActualImages;
  return proto.images.GetActualImages.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.images.GetActualImages} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.images.GetActualImages}
 */
proto.images.GetActualImages.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.images.GetActualImages.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.images.GetActualImages.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.images.GetActualImages} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.GetActualImages.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.images.GetActualImages.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.images.GetActualImages.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.images.GetActualImages.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.GetActualImages.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.images.GetActualImages.Request}
 */
proto.images.GetActualImages.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.images.GetActualImages.Request;
  return proto.images.GetActualImages.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.images.GetActualImages.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.images.GetActualImages.Request}
 */
proto.images.GetActualImages.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.images.GetActualImages.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.images.GetActualImages.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.images.GetActualImages.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.GetActualImages.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.images.GetActualImages.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.images.GetActualImages.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.images.GetActualImages.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.images.GetActualImages.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.GetActualImages.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    imagesList: jspb.Message.toObjectList(msg.getImagesList(),
    images_shared_pb.ActualImage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.images.GetActualImages.Response}
 */
proto.images.GetActualImages.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.images.GetActualImages.Response;
  return proto.images.GetActualImages.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.images.GetActualImages.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.images.GetActualImages.Response}
 */
proto.images.GetActualImages.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new images_shared_pb.ActualImage;
      reader.readMessage(value,images_shared_pb.ActualImage.deserializeBinaryFromReader);
      msg.addImages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.images.GetActualImages.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.images.GetActualImages.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.images.GetActualImages.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.GetActualImages.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      images_shared_pb.ActualImage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActualImage images = 1;
 * @return {!Array<!proto.images.ActualImage>}
 */
proto.images.GetActualImages.Response.prototype.getImagesList = function() {
  return /** @type{!Array<!proto.images.ActualImage>} */ (
    jspb.Message.getRepeatedWrapperField(this, images_shared_pb.ActualImage, 1));
};


/**
 * @param {!Array<!proto.images.ActualImage>} value
 * @return {!proto.images.GetActualImages.Response} returns this
*/
proto.images.GetActualImages.Response.prototype.setImagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.images.ActualImage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.images.ActualImage}
 */
proto.images.GetActualImages.Response.prototype.addImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.images.ActualImage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.images.GetActualImages.Response} returns this
 */
proto.images.GetActualImages.Response.prototype.clearImagesList = function() {
  return this.setImagesList([]);
};


goog.object.extend(exports, proto.images);

},{"./images.shared_pb.js":59,"google-protobuf":3}],59:[function(require,module,exports){
// source: images.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.images.ActualImage', null, global);
goog.exportSymbol('proto.images.Collection', null, global);
goog.exportSymbol('proto.images.Image', null, global);
goog.exportSymbol('proto.images.Timestamp', null, global);
goog.exportSymbol('proto.images.UUID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.images.Collection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.images.Collection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.images.Collection.displayName = 'proto.images.Collection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.images.Image = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.images.Image, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.images.Image.displayName = 'proto.images.Image';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.images.ActualImage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.images.ActualImage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.images.ActualImage.displayName = 'proto.images.ActualImage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.images.Timestamp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.images.Timestamp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.images.Timestamp.displayName = 'proto.images.Timestamp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.images.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.images.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.images.UUID.displayName = 'proto.images.UUID';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.images.Collection.prototype.toObject = function(opt_includeInstance) {
  return proto.images.Collection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.images.Collection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.Collection.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.images.UUID.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && proto.images.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && proto.images.Timestamp.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.images.Collection}
 */
proto.images.Collection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.images.Collection;
  return proto.images.Collection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.images.Collection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.images.Collection}
 */
proto.images.Collection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.images.UUID;
      reader.readMessage(value,proto.images.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new proto.images.Timestamp;
      reader.readMessage(value,proto.images.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new proto.images.Timestamp;
      reader.readMessage(value,proto.images.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.images.Collection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.images.Collection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.images.Collection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.Collection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.images.UUID.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.images.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.images.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional UUID id = 1;
 * @return {?proto.images.UUID}
 */
proto.images.Collection.prototype.getId = function() {
  return /** @type{?proto.images.UUID} */ (
    jspb.Message.getWrapperField(this, proto.images.UUID, 1));
};


/**
 * @param {?proto.images.UUID|undefined} value
 * @return {!proto.images.Collection} returns this
*/
proto.images.Collection.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.images.Collection} returns this
 */
proto.images.Collection.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.images.Collection.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Timestamp created_at = 2;
 * @return {?proto.images.Timestamp}
 */
proto.images.Collection.prototype.getCreatedAt = function() {
  return /** @type{?proto.images.Timestamp} */ (
    jspb.Message.getWrapperField(this, proto.images.Timestamp, 2));
};


/**
 * @param {?proto.images.Timestamp|undefined} value
 * @return {!proto.images.Collection} returns this
*/
proto.images.Collection.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.images.Collection} returns this
 */
proto.images.Collection.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.images.Collection.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Timestamp updated_at = 3;
 * @return {?proto.images.Timestamp}
 */
proto.images.Collection.prototype.getUpdatedAt = function() {
  return /** @type{?proto.images.Timestamp} */ (
    jspb.Message.getWrapperField(this, proto.images.Timestamp, 3));
};


/**
 * @param {?proto.images.Timestamp|undefined} value
 * @return {!proto.images.Collection} returns this
*/
proto.images.Collection.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.images.Collection} returns this
 */
proto.images.Collection.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.images.Collection.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.images.Collection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.images.Collection} returns this
 */
proto.images.Collection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.images.Collection.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.images.Collection} returns this
 */
proto.images.Collection.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.images.Image.prototype.toObject = function(opt_includeInstance) {
  return proto.images.Image.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.images.Image} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.Image.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.images.UUID.toObject(includeInstance, f),
    collectionId: (f = msg.getCollectionId()) && proto.images.UUID.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && proto.images.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && proto.images.Timestamp.toObject(includeInstance, f),
    startDate: (f = msg.getStartDate()) && proto.images.Timestamp.toObject(includeInstance, f),
    isBuiltin: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    image: jspb.Message.getFieldWithDefault(msg, 7, ""),
    redirectUrl: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.images.Image}
 */
proto.images.Image.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.images.Image;
  return proto.images.Image.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.images.Image} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.images.Image}
 */
proto.images.Image.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.images.UUID;
      reader.readMessage(value,proto.images.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new proto.images.UUID;
      reader.readMessage(value,proto.images.UUID.deserializeBinaryFromReader);
      msg.setCollectionId(value);
      break;
    case 3:
      var value = new proto.images.Timestamp;
      reader.readMessage(value,proto.images.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = new proto.images.Timestamp;
      reader.readMessage(value,proto.images.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 5:
      var value = new proto.images.Timestamp;
      reader.readMessage(value,proto.images.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBuiltin(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setImage(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.images.Image.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.images.Image.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.images.Image} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.Image.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.images.UUID.serializeBinaryToWriter
    );
  }
  f = message.getCollectionId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.images.UUID.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.images.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.images.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.images.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsBuiltin();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getImage();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional UUID id = 1;
 * @return {?proto.images.UUID}
 */
proto.images.Image.prototype.getId = function() {
  return /** @type{?proto.images.UUID} */ (
    jspb.Message.getWrapperField(this, proto.images.UUID, 1));
};


/**
 * @param {?proto.images.UUID|undefined} value
 * @return {!proto.images.Image} returns this
*/
proto.images.Image.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.images.Image} returns this
 */
proto.images.Image.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.images.Image.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UUID collection_id = 2;
 * @return {?proto.images.UUID}
 */
proto.images.Image.prototype.getCollectionId = function() {
  return /** @type{?proto.images.UUID} */ (
    jspb.Message.getWrapperField(this, proto.images.UUID, 2));
};


/**
 * @param {?proto.images.UUID|undefined} value
 * @return {!proto.images.Image} returns this
*/
proto.images.Image.prototype.setCollectionId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.images.Image} returns this
 */
proto.images.Image.prototype.clearCollectionId = function() {
  return this.setCollectionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.images.Image.prototype.hasCollectionId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Timestamp created_at = 3;
 * @return {?proto.images.Timestamp}
 */
proto.images.Image.prototype.getCreatedAt = function() {
  return /** @type{?proto.images.Timestamp} */ (
    jspb.Message.getWrapperField(this, proto.images.Timestamp, 3));
};


/**
 * @param {?proto.images.Timestamp|undefined} value
 * @return {!proto.images.Image} returns this
*/
proto.images.Image.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.images.Image} returns this
 */
proto.images.Image.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.images.Image.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Timestamp updated_at = 4;
 * @return {?proto.images.Timestamp}
 */
proto.images.Image.prototype.getUpdatedAt = function() {
  return /** @type{?proto.images.Timestamp} */ (
    jspb.Message.getWrapperField(this, proto.images.Timestamp, 4));
};


/**
 * @param {?proto.images.Timestamp|undefined} value
 * @return {!proto.images.Image} returns this
*/
proto.images.Image.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.images.Image} returns this
 */
proto.images.Image.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.images.Image.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Timestamp start_date = 5;
 * @return {?proto.images.Timestamp}
 */
proto.images.Image.prototype.getStartDate = function() {
  return /** @type{?proto.images.Timestamp} */ (
    jspb.Message.getWrapperField(this, proto.images.Timestamp, 5));
};


/**
 * @param {?proto.images.Timestamp|undefined} value
 * @return {!proto.images.Image} returns this
*/
proto.images.Image.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.images.Image} returns this
 */
proto.images.Image.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.images.Image.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool is_builtin = 6;
 * @return {boolean}
 */
proto.images.Image.prototype.getIsBuiltin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.images.Image} returns this
 */
proto.images.Image.prototype.setIsBuiltin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string image = 7;
 * @return {string}
 */
proto.images.Image.prototype.getImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.images.Image} returns this
 */
proto.images.Image.prototype.setImage = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string redirect_url = 8;
 * @return {string}
 */
proto.images.Image.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.images.Image} returns this
 */
proto.images.Image.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.images.ActualImage.prototype.toObject = function(opt_includeInstance) {
  return proto.images.ActualImage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.images.ActualImage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.ActualImage.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isBuiltin: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    image: jspb.Message.getFieldWithDefault(msg, 3, ""),
    redirectUrl: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.images.ActualImage}
 */
proto.images.ActualImage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.images.ActualImage;
  return proto.images.ActualImage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.images.ActualImage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.images.ActualImage}
 */
proto.images.ActualImage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBuiltin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setImage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirectUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.images.ActualImage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.images.ActualImage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.images.ActualImage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.ActualImage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsBuiltin();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getImage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRedirectUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.images.ActualImage.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.images.ActualImage} returns this
 */
proto.images.ActualImage.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_builtin = 2;
 * @return {boolean}
 */
proto.images.ActualImage.prototype.getIsBuiltin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.images.ActualImage} returns this
 */
proto.images.ActualImage.prototype.setIsBuiltin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string image = 3;
 * @return {string}
 */
proto.images.ActualImage.prototype.getImage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.images.ActualImage} returns this
 */
proto.images.ActualImage.prototype.setImage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string redirect_url = 4;
 * @return {string}
 */
proto.images.ActualImage.prototype.getRedirectUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.images.ActualImage} returns this
 */
proto.images.ActualImage.prototype.setRedirectUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.images.Timestamp.prototype.toObject = function(opt_includeInstance) {
  return proto.images.Timestamp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.images.Timestamp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.Timestamp.toObject = function(includeInstance, msg) {
  var f, obj = {
    seconds: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nanos: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.images.Timestamp}
 */
proto.images.Timestamp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.images.Timestamp;
  return proto.images.Timestamp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.images.Timestamp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.images.Timestamp}
 */
proto.images.Timestamp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSeconds(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNanos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.images.Timestamp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.images.Timestamp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.images.Timestamp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.Timestamp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeconds();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNanos();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 seconds = 1;
 * @return {number}
 */
proto.images.Timestamp.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.images.Timestamp} returns this
 */
proto.images.Timestamp.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 nanos = 2;
 * @return {number}
 */
proto.images.Timestamp.prototype.getNanos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.images.Timestamp} returns this
 */
proto.images.Timestamp.prototype.setNanos = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.images.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.images.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.images.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.images.UUID}
 */
proto.images.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.images.UUID;
  return proto.images.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.images.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.images.UUID}
 */
proto.images.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.images.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.images.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.images.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.images.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.images.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.images.UUID} returns this
 */
proto.images.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.images);

},{"./validate/validate_pb.js":60,"google-protobuf":3}],60:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],61:[function(require,module,exports){
// DO NOT EDIT THIS FILE!
var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);
goog.exportSymbol('proto', null, global);


// Version: v0.0.16
module.exports.attendance = {
	...require('./attendance/attendance_grpc_web_pb.js'),
	...require('./attendance/attendance_pb.js'),
};


// Version: v0.4.29
module.exports.cgs = {
	...require('./cgs/public/cgs_grpc_web_pb.js'),
	...require('./cgs/public/cgs_pb.js'),
	...require('./cgs/validate/validate_pb.js'),
};


// Version: v0.2.2
module.exports.clanevents = {
	...require('./clanevents/public/clanevent.public_grpc_web_pb.js'),
	...require('./clanevents/public/clanevent.public_pb.js'),
	...require('./clanevents/public/world_domination.public_grpc_web_pb.js'),
	...require('./clanevents/public/world_domination.public_pb.js'),
	...require('./clanevents/shared/shared_pb.js'),
	...require('./clanevents/validate/validate_pb.js'),
};


// Version: v1.5.4
module.exports.clans = {
	...require('./clans/clans.shared_pb.js'),
	...require('./clans/validate/validate_pb.js'),
	...require('./clans/web/clans_grpc_web_pb.js'),
	...require('./clans/web/clans_pb.js'),
};


// Version: v0.1.15
module.exports.clantreasury = {
	...require('./clantreasury/clantreasury_pb.js'),
	...require('./clantreasury/public/service_grpc_web_pb.js'),
	...require('./clantreasury/public/service_pb.js'),
	...require('./clantreasury/validate/validate_pb.js'),
};


// Version: v1.0.2
module.exports.discord = {
	...require('./discord/public_grpc_web_pb.js'),
	...require('./discord/public_pb.js'),
	...require('./discord/shared_pb.js'),
	...require('./discord/validate/validate_pb.js'),
};


// Version: v0.0.8
module.exports.economy = {
	...require('./economy/economy.shared_pb.js'),
	...require('./economy/validate/validate_pb.js'),
	...require('./economy/web/economy_grpc_web_pb.js'),
	...require('./economy/web/economy_pb.js'),
};


// Version: v0.1.2
module.exports.fflags = {
	...require('./fflags/public/feature-flags_grpc_web_pb.js'),
	...require('./fflags/public/feature-flags_pb.js'),
};


// Version: v0.1.3
module.exports.friends = {
	...require('./friends/public/service_grpc_web_pb.js'),
	...require('./friends/public/service_pb.js'),
	...require('./friends/validate/validate_pb.js'),
};


// Version: v0.1.15
module.exports.fusion = {
	...require('./fusion/public/fusion_grpc_web_pb.js'),
	...require('./fusion/public/fusion_pb.js'),
	...require('./fusion/validate/validate_pb.js'),
};


// Version: v0.1.13
module.exports.gacha = {
	...require('./gacha/public/gacha.public_grpc_web_pb.js'),
	...require('./gacha/public/gacha.public_pb.js'),
	...require('./gacha/shared/types_pb.js'),
	...require('./gacha/validate/validate_pb.js'),
};


// Version: v0.1.22
module.exports.gameaccount = {
	...require('./gameaccount/public/gameaccount.public_grpc_web_pb.js'),
	...require('./gameaccount/public/gameaccount.public_pb.js'),
	...require('./gameaccount/validate/validate_pb.js'),
};


// Version: v2.0.0
module.exports.gwdealer = {
	...require('./gwdealer/public/gwdealer_grpc_web_pb.js'),
	...require('./gwdealer/public/gwdealer_pb.js'),
};


// Version: 7e161c051e9c3228e161b04cd86117d270da7cf3
module.exports.idp = {
	...require('./idp/idp.shared_pb.js'),
	...require('./idp/idp_grpc_web_pb.js'),
	...require('./idp/idp_pb.js'),
	...require('./idp/validate/validate_pb.js'),
};


// Version: v1.3.5
module.exports.images = {
	...require('./images/images.public_grpc_web_pb.js'),
	...require('./images/images.public_pb.js'),
	...require('./images/images.shared_pb.js'),
	...require('./images/validate/validate_pb.js'),
};


// Version: v0.1.20
module.exports.inventory = {
	...require('./inventory/client_inventory_grpc_web_pb.js'),
	...require('./inventory/client_inventory_pb.js'),
};


// Version: v0.0.17
module.exports.leaderboards = {
	...require('./leaderboards/leaderboards.shared_pb.js'),
	...require('./leaderboards/validate/validate_pb.js'),
	...require('./leaderboards/web/leaderboards_grpc_web_pb.js'),
	...require('./leaderboards/web/leaderboards_pb.js'),
};


// Version: v0.1.6
module.exports.offchain_wallets = {
	...require('./offchain_wallets/public/public_grpc_web_pb.js'),
	...require('./offchain_wallets/public/public_pb.js'),
	...require('./offchain_wallets/validate/validate_pb.js'),
};


// Version: v0.1.17
module.exports.onchain_inventory = {
	...require('./onchain_inventory/public/public_grpc_web_pb.js'),
	...require('./onchain_inventory/public/public_pb.js'),
};


// Version: v0.2.4
module.exports.party = {
	...require('./party/party.shared_pb.js'),
	...require('./party/web/party.public_grpc_web_pb.js'),
	...require('./party/web/party.public_pb.js'),
};


// Version: v1.0.6
module.exports.pb = {
	...require('./pb/faraway_rpc_grpc_web_pb.js'),
	...require('./pb/faraway_rpc_pb.js'),
	...require('./pb/friends_pb.js'),
	...require('./pb/mm_facade_pb.js'),
	...require('./pb/player_pb.js'),
	...require('./pb/util_pb.js'),
};


// Version: v0.9.11
module.exports.quests = {
	...require('./quests/public/progress_grpc_web_pb.js'),
	...require('./quests/public/progress_pb.js'),
	...require('./quests/public/quests.public_grpc_web_pb.js'),
	...require('./quests/public/quests.public_pb.js'),
	...require('./quests/public/quests.shared_pb.js'),
	...require('./quests/validate/validate_pb.js'),
};


// Version: d0cbaae698c7b4e0ff9ce540d6283aeec28d3f59
module.exports.referral = {
	...require('./referral/referral.shared_pb.js'),
	...require('./referral/referral_grpc_web_pb.js'),
	...require('./referral/referral_pb.js'),
	...require('./referral/validate/validate_pb.js'),
};


// Version: v0.1.5
module.exports.refinery = {
	...require('./refinery/refinery_grpc_web_pb.js'),
	...require('./refinery/refinery_pb.js'),
	...require('./refinery/validate/validate_pb.js'),
};


// Version: v0.0.5
module.exports.relay = {
	...require('./relay/relay.shared_pb.js'),
	...require('./relay/validate/validate_pb.js'),
	...require('./relay/web/relay_grpc_web_pb.js'),
	...require('./relay/web/relay_pb.js'),
};


// Version: v1.6.1
module.exports.room = {
	...require('./room/constants_pb.js'),
	...require('./room/player_pb.js'),
	...require('./room/room_grpc_web_pb.js'),
	...require('./room/room_pb.js'),
	...require('./room/state_pb.js'),
	...require('./room/util_pb.js'),
};


// Version: v0.1.1
module.exports.shards = {
	...require('./shards/public/shards_grpc_web_pb.js'),
	...require('./shards/public/shards_pb.js'),
	...require('./shards/validate/validate_pb.js'),
};


// Version: v0.1.9
module.exports.staking = {
	...require('./staking/public/public_grpc_web_pb.js'),
	...require('./staking/public/public_pb.js'),
	...require('./staking/validate/validate_pb.js'),
};


// Version: v0.1.4
module.exports.stream = {
	...require('./stream/entities/party_pb.js'),
	...require('./stream/entities/party_player_pb.js'),
	...require('./stream/entities/player_match_pb.js'),
	...require('./stream/entities/player_pb.js'),
	...require('./stream/public/event_pb.js'),
	...require('./stream/public/events/party_pb.js'),
	...require('./stream/public/events/party_player_pb.js'),
	...require('./stream/public/events/player_pb.js'),
	...require('./stream/public/events/quests_progress_pb.js'),
	...require('./stream/public/stream.public_grpc_web_pb.js'),
	...require('./stream/public/stream.public_pb.js'),
	...require('./stream/validate/validate_pb.js'),
};


// Version: v1.2.0
module.exports.twitch = {
	...require('./twitch/twitch_grpc_web_pb.js'),
	...require('./twitch/twitch_pb.js'),
	...require('./twitch/validate/validate_pb.js'),
};


// Version: v0.1.7
module.exports.wallets = {
	...require('./wallets/v1/wallets_grpc_web_pb.js'),
	...require('./wallets/v1/wallets_pb.js'),
	...require('./wallets/validate/validate_pb.js'),
};


// Version: v0.1.7
module.exports.wallets_v2 = {
	...require('./wallets_v2/v2/wallets_grpc_web_pb.js'),
	...require('./wallets_v2/v2/wallets_pb.js'),
	...require('./wallets_v2/validate/validate_pb.js'),
};

},{"./attendance/attendance_grpc_web_pb.js":9,"./attendance/attendance_pb.js":10,"./cgs/public/cgs_grpc_web_pb.js":11,"./cgs/public/cgs_pb.js":12,"./cgs/validate/validate_pb.js":13,"./clanevents/public/clanevent.public_grpc_web_pb.js":14,"./clanevents/public/clanevent.public_pb.js":15,"./clanevents/public/world_domination.public_grpc_web_pb.js":16,"./clanevents/public/world_domination.public_pb.js":17,"./clanevents/shared/shared_pb.js":18,"./clanevents/validate/validate_pb.js":19,"./clans/clans.shared_pb.js":20,"./clans/validate/validate_pb.js":21,"./clans/web/clans_grpc_web_pb.js":22,"./clans/web/clans_pb.js":23,"./clantreasury/clantreasury_pb.js":24,"./clantreasury/public/service_grpc_web_pb.js":25,"./clantreasury/public/service_pb.js":26,"./clantreasury/validate/validate_pb.js":27,"./discord/public_grpc_web_pb.js":28,"./discord/public_pb.js":29,"./discord/shared_pb.js":30,"./discord/validate/validate_pb.js":31,"./economy/economy.shared_pb.js":32,"./economy/validate/validate_pb.js":33,"./economy/web/economy_grpc_web_pb.js":34,"./economy/web/economy_pb.js":35,"./fflags/public/feature-flags_grpc_web_pb.js":36,"./fflags/public/feature-flags_pb.js":37,"./friends/public/service_grpc_web_pb.js":38,"./friends/public/service_pb.js":39,"./friends/validate/validate_pb.js":40,"./fusion/public/fusion_grpc_web_pb.js":41,"./fusion/public/fusion_pb.js":42,"./fusion/validate/validate_pb.js":43,"./gacha/public/gacha.public_grpc_web_pb.js":44,"./gacha/public/gacha.public_pb.js":45,"./gacha/shared/types_pb.js":46,"./gacha/validate/validate_pb.js":47,"./gameaccount/public/gameaccount.public_grpc_web_pb.js":48,"./gameaccount/public/gameaccount.public_pb.js":49,"./gameaccount/validate/validate_pb.js":50,"./gwdealer/public/gwdealer_grpc_web_pb.js":51,"./gwdealer/public/gwdealer_pb.js":52,"./idp/idp.shared_pb.js":53,"./idp/idp_grpc_web_pb.js":54,"./idp/idp_pb.js":55,"./idp/validate/validate_pb.js":56,"./images/images.public_grpc_web_pb.js":57,"./images/images.public_pb.js":58,"./images/images.shared_pb.js":59,"./images/validate/validate_pb.js":60,"./inventory/client_inventory_grpc_web_pb.js":62,"./inventory/client_inventory_pb.js":63,"./leaderboards/leaderboards.shared_pb.js":64,"./leaderboards/validate/validate_pb.js":65,"./leaderboards/web/leaderboards_grpc_web_pb.js":66,"./leaderboards/web/leaderboards_pb.js":67,"./offchain_wallets/public/public_grpc_web_pb.js":68,"./offchain_wallets/public/public_pb.js":69,"./offchain_wallets/validate/validate_pb.js":70,"./onchain_inventory/public/public_grpc_web_pb.js":71,"./onchain_inventory/public/public_pb.js":72,"./party/party.shared_pb.js":73,"./party/web/party.public_grpc_web_pb.js":74,"./party/web/party.public_pb.js":75,"./pb/faraway_rpc_grpc_web_pb.js":76,"./pb/faraway_rpc_pb.js":77,"./pb/friends_pb.js":78,"./pb/mm_facade_pb.js":79,"./pb/player_pb.js":80,"./pb/util_pb.js":81,"./quests/public/progress_grpc_web_pb.js":82,"./quests/public/progress_pb.js":83,"./quests/public/quests.public_grpc_web_pb.js":84,"./quests/public/quests.public_pb.js":85,"./quests/public/quests.shared_pb.js":86,"./quests/validate/validate_pb.js":87,"./referral/referral.shared_pb.js":88,"./referral/referral_grpc_web_pb.js":89,"./referral/referral_pb.js":90,"./referral/validate/validate_pb.js":91,"./refinery/refinery_grpc_web_pb.js":92,"./refinery/refinery_pb.js":93,"./refinery/validate/validate_pb.js":94,"./relay/relay.shared_pb.js":95,"./relay/validate/validate_pb.js":96,"./relay/web/relay_grpc_web_pb.js":97,"./relay/web/relay_pb.js":98,"./room/constants_pb.js":99,"./room/player_pb.js":100,"./room/room_grpc_web_pb.js":101,"./room/room_pb.js":102,"./room/state_pb.js":103,"./room/util_pb.js":104,"./shards/public/shards_grpc_web_pb.js":105,"./shards/public/shards_pb.js":106,"./shards/validate/validate_pb.js":107,"./staking/public/public_grpc_web_pb.js":108,"./staking/public/public_pb.js":109,"./staking/validate/validate_pb.js":110,"./stream/entities/party_pb.js":111,"./stream/entities/party_player_pb.js":112,"./stream/entities/player_match_pb.js":113,"./stream/entities/player_pb.js":114,"./stream/public/event_pb.js":115,"./stream/public/events/party_pb.js":116,"./stream/public/events/party_player_pb.js":117,"./stream/public/events/player_pb.js":118,"./stream/public/events/quests_progress_pb.js":119,"./stream/public/stream.public_grpc_web_pb.js":120,"./stream/public/stream.public_pb.js":121,"./stream/validate/validate_pb.js":122,"./twitch/twitch_grpc_web_pb.js":123,"./twitch/twitch_pb.js":124,"./twitch/validate/validate_pb.js":125,"./wallets/v1/wallets_grpc_web_pb.js":126,"./wallets/v1/wallets_pb.js":127,"./wallets/validate/validate_pb.js":128,"./wallets_v2/v2/wallets_grpc_web_pb.js":129,"./wallets_v2/v2/wallets_pb.js":130,"./wallets_v2/validate/validate_pb.js":131,"google-protobuf":3}],62:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for client_inventory
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.client_inventory = require('./client_inventory_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.client_inventory.InventoryClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.client_inventory.InventoryPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.client_inventory.GetItemRequest,
 *   !proto.client_inventory.GetItemResponse>}
 */
const methodDescriptor_Inventory_GetItem = new grpc.web.MethodDescriptor(
  '/client_inventory.Inventory/GetItem',
  grpc.web.MethodType.UNARY,
  proto.client_inventory.GetItemRequest,
  proto.client_inventory.GetItemResponse,
  /**
   * @param {!proto.client_inventory.GetItemRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.client_inventory.GetItemResponse.deserializeBinary
);


/**
 * @param {!proto.client_inventory.GetItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.client_inventory.GetItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.client_inventory.GetItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.client_inventory.InventoryClient.prototype.getItem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/client_inventory.Inventory/GetItem',
      request,
      metadata || {},
      methodDescriptor_Inventory_GetItem,
      callback);
};


/**
 * @param {!proto.client_inventory.GetItemRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.client_inventory.GetItemResponse>}
 *     Promise that resolves to the response
 */
proto.client_inventory.InventoryPromiseClient.prototype.getItem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/client_inventory.Inventory/GetItem',
      request,
      metadata || {},
      methodDescriptor_Inventory_GetItem);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.client_inventory.Empty,
 *   !proto.client_inventory.GetItemsResponse>}
 */
const methodDescriptor_Inventory_GetItems = new grpc.web.MethodDescriptor(
  '/client_inventory.Inventory/GetItems',
  grpc.web.MethodType.UNARY,
  proto.client_inventory.Empty,
  proto.client_inventory.GetItemsResponse,
  /**
   * @param {!proto.client_inventory.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.client_inventory.GetItemsResponse.deserializeBinary
);


/**
 * @param {!proto.client_inventory.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.client_inventory.GetItemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.client_inventory.GetItemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.client_inventory.InventoryClient.prototype.getItems =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/client_inventory.Inventory/GetItems',
      request,
      metadata || {},
      methodDescriptor_Inventory_GetItems,
      callback);
};


/**
 * @param {!proto.client_inventory.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.client_inventory.GetItemsResponse>}
 *     Promise that resolves to the response
 */
proto.client_inventory.InventoryPromiseClient.prototype.getItems =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/client_inventory.Inventory/GetItems',
      request,
      metadata || {},
      methodDescriptor_Inventory_GetItems);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.client_inventory.Empty,
 *   !proto.client_inventory.GetLoadoutsResponse>}
 */
const methodDescriptor_Inventory_GetLoadouts = new grpc.web.MethodDescriptor(
  '/client_inventory.Inventory/GetLoadouts',
  grpc.web.MethodType.UNARY,
  proto.client_inventory.Empty,
  proto.client_inventory.GetLoadoutsResponse,
  /**
   * @param {!proto.client_inventory.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.client_inventory.GetLoadoutsResponse.deserializeBinary
);


/**
 * @param {!proto.client_inventory.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.client_inventory.GetLoadoutsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.client_inventory.GetLoadoutsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.client_inventory.InventoryClient.prototype.getLoadouts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/client_inventory.Inventory/GetLoadouts',
      request,
      metadata || {},
      methodDescriptor_Inventory_GetLoadouts,
      callback);
};


/**
 * @param {!proto.client_inventory.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.client_inventory.GetLoadoutsResponse>}
 *     Promise that resolves to the response
 */
proto.client_inventory.InventoryPromiseClient.prototype.getLoadouts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/client_inventory.Inventory/GetLoadouts',
      request,
      metadata || {},
      methodDescriptor_Inventory_GetLoadouts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.client_inventory.SetLoadoutRequest,
 *   !proto.client_inventory.Empty>}
 */
const methodDescriptor_Inventory_SetLoadout = new grpc.web.MethodDescriptor(
  '/client_inventory.Inventory/SetLoadout',
  grpc.web.MethodType.UNARY,
  proto.client_inventory.SetLoadoutRequest,
  proto.client_inventory.Empty,
  /**
   * @param {!proto.client_inventory.SetLoadoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.client_inventory.Empty.deserializeBinary
);


/**
 * @param {!proto.client_inventory.SetLoadoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.client_inventory.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.client_inventory.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.client_inventory.InventoryClient.prototype.setLoadout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/client_inventory.Inventory/SetLoadout',
      request,
      metadata || {},
      methodDescriptor_Inventory_SetLoadout,
      callback);
};


/**
 * @param {!proto.client_inventory.SetLoadoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.client_inventory.Empty>}
 *     Promise that resolves to the response
 */
proto.client_inventory.InventoryPromiseClient.prototype.setLoadout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/client_inventory.Inventory/SetLoadout',
      request,
      metadata || {},
      methodDescriptor_Inventory_SetLoadout);
};


module.exports = proto.client_inventory;


},{"./client_inventory_pb.js":63,"grpc-web":7}],63:[function(require,module,exports){
// source: client_inventory.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.client_inventory.Asset', null, global);
goog.exportSymbol('proto.client_inventory.Category', null, global);
goog.exportSymbol('proto.client_inventory.Empty', null, global);
goog.exportSymbol('proto.client_inventory.GeneratedItem', null, global);
goog.exportSymbol('proto.client_inventory.GeneratedItem.DropType', null, global);
goog.exportSymbol('proto.client_inventory.GeneratedItem.MintStatus', null, global);
goog.exportSymbol('proto.client_inventory.GetItemRequest', null, global);
goog.exportSymbol('proto.client_inventory.GetItemResponse', null, global);
goog.exportSymbol('proto.client_inventory.GetItemsResponse', null, global);
goog.exportSymbol('proto.client_inventory.GetLoadoutsResponse', null, global);
goog.exportSymbol('proto.client_inventory.Item', null, global);
goog.exportSymbol('proto.client_inventory.Item.ContentCase', null, global);
goog.exportSymbol('proto.client_inventory.Item.Rarity', null, global);
goog.exportSymbol('proto.client_inventory.Item.Type', null, global);
goog.exportSymbol('proto.client_inventory.Loadout', null, global);
goog.exportSymbol('proto.client_inventory.MatchMode', null, global);
goog.exportSymbol('proto.client_inventory.Material', null, global);
goog.exportSymbol('proto.client_inventory.Parameter', null, global);
goog.exportSymbol('proto.client_inventory.Perk', null, global);
goog.exportSymbol('proto.client_inventory.Progress', null, global);
goog.exportSymbol('proto.client_inventory.SetLoadoutRequest', null, global);
goog.exportSymbol('proto.client_inventory.Slot', null, global);
goog.exportSymbol('proto.client_inventory.Slot.Type', null, global);
goog.exportSymbol('proto.client_inventory.StandardItem', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Empty.displayName = 'proto.client_inventory.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.GetItemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.client_inventory.GetItemsResponse.repeatedFields_, null);
};
goog.inherits(proto.client_inventory.GetItemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.GetItemsResponse.displayName = 'proto.client_inventory.GetItemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.GetLoadoutsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.client_inventory.GetLoadoutsResponse.repeatedFields_, null);
};
goog.inherits(proto.client_inventory.GetLoadoutsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.GetLoadoutsResponse.displayName = 'proto.client_inventory.GetLoadoutsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.SetLoadoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.SetLoadoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.SetLoadoutRequest.displayName = 'proto.client_inventory.SetLoadoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Slot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.client_inventory.Slot.repeatedFields_, null);
};
goog.inherits(proto.client_inventory.Slot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Slot.displayName = 'proto.client_inventory.Slot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Loadout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.client_inventory.Loadout.repeatedFields_, null);
};
goog.inherits(proto.client_inventory.Loadout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Loadout.displayName = 'proto.client_inventory.Loadout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Material = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.Material, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Material.displayName = 'proto.client_inventory.Material';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.client_inventory.Item.oneofGroups_);
};
goog.inherits(proto.client_inventory.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Item.displayName = 'proto.client_inventory.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Progress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.Progress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Progress.displayName = 'proto.client_inventory.Progress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.StandardItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.StandardItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.StandardItem.displayName = 'proto.client_inventory.StandardItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.GeneratedItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.GeneratedItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.GeneratedItem.displayName = 'proto.client_inventory.GeneratedItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Asset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.client_inventory.Asset.repeatedFields_, null);
};
goog.inherits(proto.client_inventory.Asset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Asset.displayName = 'proto.client_inventory.Asset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Perk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.client_inventory.Perk.repeatedFields_, null);
};
goog.inherits(proto.client_inventory.Perk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Perk.displayName = 'proto.client_inventory.Perk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.Parameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.Parameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.Parameter.displayName = 'proto.client_inventory.Parameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.GetItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.GetItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.GetItemRequest.displayName = 'proto.client_inventory.GetItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.client_inventory.GetItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.client_inventory.GetItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.client_inventory.GetItemResponse.displayName = 'proto.client_inventory.GetItemResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Empty}
 */
proto.client_inventory.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Empty;
  return proto.client_inventory.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Empty}
 */
proto.client_inventory.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.client_inventory.GetItemsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.GetItemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.GetItemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.GetItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GetItemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.client_inventory.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.GetItemsResponse}
 */
proto.client_inventory.GetItemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.GetItemsResponse;
  return proto.client_inventory.GetItemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.GetItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.GetItemsResponse}
 */
proto.client_inventory.GetItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.client_inventory.Item;
      reader.readMessage(value,proto.client_inventory.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.GetItemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.GetItemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.GetItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GetItemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.client_inventory.Item.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Item items = 1;
 * @return {!Array<!proto.client_inventory.Item>}
 */
proto.client_inventory.GetItemsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.client_inventory.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.client_inventory.Item, 1));
};


/**
 * @param {!Array<!proto.client_inventory.Item>} value
 * @return {!proto.client_inventory.GetItemsResponse} returns this
*/
proto.client_inventory.GetItemsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.client_inventory.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.client_inventory.Item}
 */
proto.client_inventory.GetItemsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.client_inventory.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.client_inventory.GetItemsResponse} returns this
 */
proto.client_inventory.GetItemsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.client_inventory.GetLoadoutsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.GetLoadoutsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.GetLoadoutsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.GetLoadoutsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GetLoadoutsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    loadoutsList: jspb.Message.toObjectList(msg.getLoadoutsList(),
    proto.client_inventory.Loadout.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.GetLoadoutsResponse}
 */
proto.client_inventory.GetLoadoutsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.GetLoadoutsResponse;
  return proto.client_inventory.GetLoadoutsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.GetLoadoutsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.GetLoadoutsResponse}
 */
proto.client_inventory.GetLoadoutsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.client_inventory.Loadout;
      reader.readMessage(value,proto.client_inventory.Loadout.deserializeBinaryFromReader);
      msg.addLoadouts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.GetLoadoutsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.GetLoadoutsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.GetLoadoutsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GetLoadoutsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoadoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.client_inventory.Loadout.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Loadout Loadouts = 1;
 * @return {!Array<!proto.client_inventory.Loadout>}
 */
proto.client_inventory.GetLoadoutsResponse.prototype.getLoadoutsList = function() {
  return /** @type{!Array<!proto.client_inventory.Loadout>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.client_inventory.Loadout, 1));
};


/**
 * @param {!Array<!proto.client_inventory.Loadout>} value
 * @return {!proto.client_inventory.GetLoadoutsResponse} returns this
*/
proto.client_inventory.GetLoadoutsResponse.prototype.setLoadoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.client_inventory.Loadout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.client_inventory.Loadout}
 */
proto.client_inventory.GetLoadoutsResponse.prototype.addLoadouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.client_inventory.Loadout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.client_inventory.GetLoadoutsResponse} returns this
 */
proto.client_inventory.GetLoadoutsResponse.prototype.clearLoadoutsList = function() {
  return this.setLoadoutsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.SetLoadoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.SetLoadoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.SetLoadoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.SetLoadoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    loadout: (f = msg.getLoadout()) && proto.client_inventory.Loadout.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.SetLoadoutRequest}
 */
proto.client_inventory.SetLoadoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.SetLoadoutRequest;
  return proto.client_inventory.SetLoadoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.SetLoadoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.SetLoadoutRequest}
 */
proto.client_inventory.SetLoadoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.client_inventory.Loadout;
      reader.readMessage(value,proto.client_inventory.Loadout.deserializeBinaryFromReader);
      msg.setLoadout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.SetLoadoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.SetLoadoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.SetLoadoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.SetLoadoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoadout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.client_inventory.Loadout.serializeBinaryToWriter
    );
  }
};


/**
 * optional Loadout loadout = 1;
 * @return {?proto.client_inventory.Loadout}
 */
proto.client_inventory.SetLoadoutRequest.prototype.getLoadout = function() {
  return /** @type{?proto.client_inventory.Loadout} */ (
    jspb.Message.getWrapperField(this, proto.client_inventory.Loadout, 1));
};


/**
 * @param {?proto.client_inventory.Loadout|undefined} value
 * @return {!proto.client_inventory.SetLoadoutRequest} returns this
*/
proto.client_inventory.SetLoadoutRequest.prototype.setLoadout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.client_inventory.SetLoadoutRequest} returns this
 */
proto.client_inventory.SetLoadoutRequest.prototype.clearLoadout = function() {
  return this.setLoadout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.client_inventory.SetLoadoutRequest.prototype.hasLoadout = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.client_inventory.Slot.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Slot.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Slot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Slot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Slot.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.client_inventory.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Slot}
 */
proto.client_inventory.Slot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Slot;
  return proto.client_inventory.Slot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Slot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Slot}
 */
proto.client_inventory.Slot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.client_inventory.Slot.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.client_inventory.Item;
      reader.readMessage(value,proto.client_inventory.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Slot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Slot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Slot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Slot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.client_inventory.Item.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.client_inventory.Slot.Type = {
  UNKNOWN: 0,
  OUTFIT: 1,
  HEADGEAR: 2,
  PRIMARY: 3,
  SECONDARY: 4,
  GRENADE: 5,
  PARACHUTE: 6
};

/**
 * optional Type type = 1;
 * @return {!proto.client_inventory.Slot.Type}
 */
proto.client_inventory.Slot.prototype.getType = function() {
  return /** @type {!proto.client_inventory.Slot.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.client_inventory.Slot.Type} value
 * @return {!proto.client_inventory.Slot} returns this
 */
proto.client_inventory.Slot.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated Item items = 2;
 * @return {!Array<!proto.client_inventory.Item>}
 */
proto.client_inventory.Slot.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.client_inventory.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.client_inventory.Item, 2));
};


/**
 * @param {!Array<!proto.client_inventory.Item>} value
 * @return {!proto.client_inventory.Slot} returns this
*/
proto.client_inventory.Slot.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.client_inventory.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.client_inventory.Item}
 */
proto.client_inventory.Slot.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.client_inventory.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.client_inventory.Slot} returns this
 */
proto.client_inventory.Slot.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.client_inventory.Loadout.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Loadout.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Loadout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Loadout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Loadout.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    slotsList: jspb.Message.toObjectList(msg.getSlotsList(),
    proto.client_inventory.Slot.toObject, includeInstance),
    selected: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Loadout}
 */
proto.client_inventory.Loadout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Loadout;
  return proto.client_inventory.Loadout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Loadout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Loadout}
 */
proto.client_inventory.Loadout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.client_inventory.MatchMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 3:
      var value = new proto.client_inventory.Slot;
      reader.readMessage(value,proto.client_inventory.Slot.deserializeBinaryFromReader);
      msg.addSlots(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Loadout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Loadout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Loadout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Loadout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSlotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.client_inventory.Slot.serializeBinaryToWriter
    );
  }
  f = message.getSelected();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.client_inventory.Loadout.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Loadout} returns this
 */
proto.client_inventory.Loadout.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MatchMode mode = 2;
 * @return {!proto.client_inventory.MatchMode}
 */
proto.client_inventory.Loadout.prototype.getMode = function() {
  return /** @type {!proto.client_inventory.MatchMode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.client_inventory.MatchMode} value
 * @return {!proto.client_inventory.Loadout} returns this
 */
proto.client_inventory.Loadout.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated Slot slots = 3;
 * @return {!Array<!proto.client_inventory.Slot>}
 */
proto.client_inventory.Loadout.prototype.getSlotsList = function() {
  return /** @type{!Array<!proto.client_inventory.Slot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.client_inventory.Slot, 3));
};


/**
 * @param {!Array<!proto.client_inventory.Slot>} value
 * @return {!proto.client_inventory.Loadout} returns this
*/
proto.client_inventory.Loadout.prototype.setSlotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.client_inventory.Slot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.client_inventory.Slot}
 */
proto.client_inventory.Loadout.prototype.addSlots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.client_inventory.Slot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.client_inventory.Loadout} returns this
 */
proto.client_inventory.Loadout.prototype.clearSlotsList = function() {
  return this.setSlotsList([]);
};


/**
 * optional bool selected = 4;
 * @return {boolean}
 */
proto.client_inventory.Loadout.prototype.getSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.client_inventory.Loadout} returns this
 */
proto.client_inventory.Loadout.prototype.setSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Material.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Material.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Material} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Material.toObject = function(includeInstance, msg) {
  var f, obj = {
    baseColor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    normalMap: jspb.Message.getFieldWithDefault(msg, 2, ""),
    emissionMap: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ambientOcclusion: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Material}
 */
proto.client_inventory.Material.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Material;
  return proto.client_inventory.Material.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Material} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Material}
 */
proto.client_inventory.Material.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseColor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNormalMap(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmissionMap(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmbientOcclusion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Material.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Material.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Material} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Material.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBaseColor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNormalMap();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmissionMap();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmbientOcclusion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string base_color = 1;
 * @return {string}
 */
proto.client_inventory.Material.prototype.getBaseColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Material} returns this
 */
proto.client_inventory.Material.prototype.setBaseColor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string normal_map = 2;
 * @return {string}
 */
proto.client_inventory.Material.prototype.getNormalMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Material} returns this
 */
proto.client_inventory.Material.prototype.setNormalMap = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string emission_map = 3;
 * @return {string}
 */
proto.client_inventory.Material.prototype.getEmissionMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Material} returns this
 */
proto.client_inventory.Material.prototype.setEmissionMap = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ambient_occlusion = 4;
 * @return {string}
 */
proto.client_inventory.Material.prototype.getAmbientOcclusion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Material} returns this
 */
proto.client_inventory.Material.prototype.setAmbientOcclusion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.client_inventory.Item.oneofGroups_ = [[101,102]];

/**
 * @enum {number}
 */
proto.client_inventory.Item.ContentCase = {
  CONTENT_NOT_SET: 0,
  STANDARD: 101,
  GENERATED: 102
};

/**
 * @return {proto.client_inventory.Item.ContentCase}
 */
proto.client_inventory.Item.prototype.getContentCase = function() {
  return /** @type {proto.client_inventory.Item.ContentCase} */(jspb.Message.computeOneofCase(this, proto.client_inventory.Item.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    category: jspb.Message.getFieldWithDefault(msg, 4, 0),
    rarity: jspb.Message.getFieldWithDefault(msg, 5, 0),
    prototype: jspb.Message.getFieldWithDefault(msg, 6, ""),
    progress: (f = msg.getProgress()) && proto.client_inventory.Progress.toObject(includeInstance, f),
    standard: (f = msg.getStandard()) && proto.client_inventory.StandardItem.toObject(includeInstance, f),
    generated: (f = msg.getGenerated()) && proto.client_inventory.GeneratedItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Item}
 */
proto.client_inventory.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Item;
  return proto.client_inventory.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Item}
 */
proto.client_inventory.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.client_inventory.Item.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {!proto.client_inventory.Category} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {!proto.client_inventory.Item.Rarity} */ (reader.readEnum());
      msg.setRarity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrototype(value);
      break;
    case 7:
      var value = new proto.client_inventory.Progress;
      reader.readMessage(value,proto.client_inventory.Progress.deserializeBinaryFromReader);
      msg.setProgress(value);
      break;
    case 101:
      var value = new proto.client_inventory.StandardItem;
      reader.readMessage(value,proto.client_inventory.StandardItem.deserializeBinaryFromReader);
      msg.setStandard(value);
      break;
    case 102:
      var value = new proto.client_inventory.GeneratedItem;
      reader.readMessage(value,proto.client_inventory.GeneratedItem.deserializeBinaryFromReader);
      msg.setGenerated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getRarity();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getPrototype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProgress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.client_inventory.Progress.serializeBinaryToWriter
    );
  }
  f = message.getStandard();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.client_inventory.StandardItem.serializeBinaryToWriter
    );
  }
  f = message.getGenerated();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      proto.client_inventory.GeneratedItem.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.client_inventory.Item.Type = {
  UNKNOWN_TYPE: 0,
  OUTFIT: 1,
  HAT: 2,
  CURRENCY: 3,
  PARACHUTE: 4,
  MAIN_WEAPON: 5,
  SECONDARY_WEAPON: 6,
  GRENADE: 7
};

/**
 * @enum {number}
 */
proto.client_inventory.Item.Rarity = {
  UNKNOWN_RARITY: 0,
  COMMON: 1,
  UNCOMMON: 2,
  RARE: 3,
  EPIC: 4,
  LEGENDARY: 5
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.client_inventory.Item.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.client_inventory.Item.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Type type = 3;
 * @return {!proto.client_inventory.Item.Type}
 */
proto.client_inventory.Item.prototype.getType = function() {
  return /** @type {!proto.client_inventory.Item.Type} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.client_inventory.Item.Type} value
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Category category = 4;
 * @return {!proto.client_inventory.Category}
 */
proto.client_inventory.Item.prototype.getCategory = function() {
  return /** @type {!proto.client_inventory.Category} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.client_inventory.Category} value
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Rarity rarity = 5;
 * @return {!proto.client_inventory.Item.Rarity}
 */
proto.client_inventory.Item.prototype.getRarity = function() {
  return /** @type {!proto.client_inventory.Item.Rarity} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.client_inventory.Item.Rarity} value
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.setRarity = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string prototype = 6;
 * @return {string}
 */
proto.client_inventory.Item.prototype.getPrototype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.setPrototype = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Progress progress = 7;
 * @return {?proto.client_inventory.Progress}
 */
proto.client_inventory.Item.prototype.getProgress = function() {
  return /** @type{?proto.client_inventory.Progress} */ (
    jspb.Message.getWrapperField(this, proto.client_inventory.Progress, 7));
};


/**
 * @param {?proto.client_inventory.Progress|undefined} value
 * @return {!proto.client_inventory.Item} returns this
*/
proto.client_inventory.Item.prototype.setProgress = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.clearProgress = function() {
  return this.setProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.client_inventory.Item.prototype.hasProgress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional StandardItem standard = 101;
 * @return {?proto.client_inventory.StandardItem}
 */
proto.client_inventory.Item.prototype.getStandard = function() {
  return /** @type{?proto.client_inventory.StandardItem} */ (
    jspb.Message.getWrapperField(this, proto.client_inventory.StandardItem, 101));
};


/**
 * @param {?proto.client_inventory.StandardItem|undefined} value
 * @return {!proto.client_inventory.Item} returns this
*/
proto.client_inventory.Item.prototype.setStandard = function(value) {
  return jspb.Message.setOneofWrapperField(this, 101, proto.client_inventory.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.clearStandard = function() {
  return this.setStandard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.client_inventory.Item.prototype.hasStandard = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional GeneratedItem generated = 102;
 * @return {?proto.client_inventory.GeneratedItem}
 */
proto.client_inventory.Item.prototype.getGenerated = function() {
  return /** @type{?proto.client_inventory.GeneratedItem} */ (
    jspb.Message.getWrapperField(this, proto.client_inventory.GeneratedItem, 102));
};


/**
 * @param {?proto.client_inventory.GeneratedItem|undefined} value
 * @return {!proto.client_inventory.Item} returns this
*/
proto.client_inventory.Item.prototype.setGenerated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 102, proto.client_inventory.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.client_inventory.Item} returns this
 */
proto.client_inventory.Item.prototype.clearGenerated = function() {
  return this.setGenerated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.client_inventory.Item.prototype.hasGenerated = function() {
  return jspb.Message.getField(this, 102) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Progress.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Progress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Progress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Progress.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0),
    points: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nextLevelPoints: jspb.Message.getFieldWithDefault(msg, 3, 0),
    currLevelPoints: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Progress}
 */
proto.client_inventory.Progress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Progress;
  return proto.client_inventory.Progress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Progress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Progress}
 */
proto.client_inventory.Progress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLevel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPoints(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNextLevelPoints(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCurrLevelPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Progress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Progress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Progress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Progress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getPoints();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getNextLevelPoints();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getCurrLevelPoints();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional uint64 level = 1;
 * @return {number}
 */
proto.client_inventory.Progress.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.client_inventory.Progress} returns this
 */
proto.client_inventory.Progress.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 points = 2;
 * @return {number}
 */
proto.client_inventory.Progress.prototype.getPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.client_inventory.Progress} returns this
 */
proto.client_inventory.Progress.prototype.setPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 next_level_points = 3;
 * @return {number}
 */
proto.client_inventory.Progress.prototype.getNextLevelPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.client_inventory.Progress} returns this
 */
proto.client_inventory.Progress.prototype.setNextLevelPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 curr_level_points = 4;
 * @return {number}
 */
proto.client_inventory.Progress.prototype.getCurrLevelPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.client_inventory.Progress} returns this
 */
proto.client_inventory.Progress.prototype.setCurrLevelPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.StandardItem.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.StandardItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.StandardItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.StandardItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    asset: (f = msg.getAsset()) && proto.client_inventory.Asset.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.StandardItem}
 */
proto.client_inventory.StandardItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.StandardItem;
  return proto.client_inventory.StandardItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.StandardItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.StandardItem}
 */
proto.client_inventory.StandardItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.client_inventory.Asset;
      reader.readMessage(value,proto.client_inventory.Asset.deserializeBinaryFromReader);
      msg.setAsset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.StandardItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.StandardItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.StandardItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.StandardItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAsset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.client_inventory.Asset.serializeBinaryToWriter
    );
  }
};


/**
 * optional Asset asset = 1;
 * @return {?proto.client_inventory.Asset}
 */
proto.client_inventory.StandardItem.prototype.getAsset = function() {
  return /** @type{?proto.client_inventory.Asset} */ (
    jspb.Message.getWrapperField(this, proto.client_inventory.Asset, 1));
};


/**
 * @param {?proto.client_inventory.Asset|undefined} value
 * @return {!proto.client_inventory.StandardItem} returns this
*/
proto.client_inventory.StandardItem.prototype.setAsset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.client_inventory.StandardItem} returns this
 */
proto.client_inventory.StandardItem.prototype.clearAsset = function() {
  return this.setAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.client_inventory.StandardItem.prototype.hasAsset = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.GeneratedItem.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.GeneratedItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.GeneratedItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GeneratedItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    asset: (f = msg.getAsset()) && proto.client_inventory.Asset.toObject(includeInstance, f),
    mintStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    dropType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    season: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tokenAddress: jspb.Message.getFieldWithDefault(msg, 5, ""),
    tokenMint: jspb.Message.getFieldWithDefault(msg, 6, ""),
    locked: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.GeneratedItem}
 */
proto.client_inventory.GeneratedItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.GeneratedItem;
  return proto.client_inventory.GeneratedItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.GeneratedItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.GeneratedItem}
 */
proto.client_inventory.GeneratedItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.client_inventory.Asset;
      reader.readMessage(value,proto.client_inventory.Asset.deserializeBinaryFromReader);
      msg.setAsset(value);
      break;
    case 2:
      var value = /** @type {!proto.client_inventory.GeneratedItem.MintStatus} */ (reader.readEnum());
      msg.setMintStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.client_inventory.GeneratedItem.DropType} */ (reader.readEnum());
      msg.setDropType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeason(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenAddress(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenMint(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLocked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.GeneratedItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.GeneratedItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.GeneratedItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GeneratedItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAsset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.client_inventory.Asset.serializeBinaryToWriter
    );
  }
  f = message.getMintStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDropType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSeason();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTokenAddress();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTokenMint();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLocked();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.client_inventory.GeneratedItem.MintStatus = {
  UNKNOWN: 0,
  MINTABLE: 1,
  MINTED: 2,
  MINTING: 3
};

/**
 * @enum {number}
 */
proto.client_inventory.GeneratedItem.DropType = {
  DROP_TYPE_UNKNOWN: 0,
  DROP_TYPE_LOOT_COLLECTION: 1,
  DROP_TYPE_PREMIUM: 2
};

/**
 * optional Asset asset = 1;
 * @return {?proto.client_inventory.Asset}
 */
proto.client_inventory.GeneratedItem.prototype.getAsset = function() {
  return /** @type{?proto.client_inventory.Asset} */ (
    jspb.Message.getWrapperField(this, proto.client_inventory.Asset, 1));
};


/**
 * @param {?proto.client_inventory.Asset|undefined} value
 * @return {!proto.client_inventory.GeneratedItem} returns this
*/
proto.client_inventory.GeneratedItem.prototype.setAsset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.client_inventory.GeneratedItem} returns this
 */
proto.client_inventory.GeneratedItem.prototype.clearAsset = function() {
  return this.setAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.client_inventory.GeneratedItem.prototype.hasAsset = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MintStatus mint_status = 2;
 * @return {!proto.client_inventory.GeneratedItem.MintStatus}
 */
proto.client_inventory.GeneratedItem.prototype.getMintStatus = function() {
  return /** @type {!proto.client_inventory.GeneratedItem.MintStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.client_inventory.GeneratedItem.MintStatus} value
 * @return {!proto.client_inventory.GeneratedItem} returns this
 */
proto.client_inventory.GeneratedItem.prototype.setMintStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional DropType drop_type = 3;
 * @return {!proto.client_inventory.GeneratedItem.DropType}
 */
proto.client_inventory.GeneratedItem.prototype.getDropType = function() {
  return /** @type {!proto.client_inventory.GeneratedItem.DropType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.client_inventory.GeneratedItem.DropType} value
 * @return {!proto.client_inventory.GeneratedItem} returns this
 */
proto.client_inventory.GeneratedItem.prototype.setDropType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string season = 4;
 * @return {string}
 */
proto.client_inventory.GeneratedItem.prototype.getSeason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.GeneratedItem} returns this
 */
proto.client_inventory.GeneratedItem.prototype.setSeason = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string token_address = 5;
 * @return {string}
 */
proto.client_inventory.GeneratedItem.prototype.getTokenAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.GeneratedItem} returns this
 */
proto.client_inventory.GeneratedItem.prototype.setTokenAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string token_mint = 6;
 * @return {string}
 */
proto.client_inventory.GeneratedItem.prototype.getTokenMint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.GeneratedItem} returns this
 */
proto.client_inventory.GeneratedItem.prototype.setTokenMint = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool locked = 7;
 * @return {boolean}
 */
proto.client_inventory.GeneratedItem.prototype.getLocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.client_inventory.GeneratedItem} returns this
 */
proto.client_inventory.GeneratedItem.prototype.setLocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.client_inventory.Asset.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Asset.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Asset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Asset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Asset.toObject = function(includeInstance, msg) {
  var f, obj = {
    icon: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mesh: jspb.Message.getFieldWithDefault(msg, 2, ""),
    texture: jspb.Message.getFieldWithDefault(msg, 3, ""),
    materialsMap: (f = msg.getMaterialsMap()) ? f.toObject(includeInstance, proto.client_inventory.Material.toObject) : [],
    perksList: jspb.Message.toObjectList(msg.getPerksList(),
    proto.client_inventory.Perk.toObject, includeInstance),
    skeleton: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Asset}
 */
proto.client_inventory.Asset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Asset;
  return proto.client_inventory.Asset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Asset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Asset}
 */
proto.client_inventory.Asset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMesh(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTexture(value);
      break;
    case 4:
      var value = msg.getMaterialsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.client_inventory.Material.deserializeBinaryFromReader, "", new proto.client_inventory.Material());
         });
      break;
    case 6:
      var value = new proto.client_inventory.Perk;
      reader.readMessage(value,proto.client_inventory.Perk.deserializeBinaryFromReader);
      msg.addPerks(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSkeleton(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Asset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Asset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Asset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Asset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMesh();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTexture();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMaterialsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.client_inventory.Material.serializeBinaryToWriter);
  }
  f = message.getPerksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.client_inventory.Perk.serializeBinaryToWriter
    );
  }
  f = message.getSkeleton();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string icon = 1;
 * @return {string}
 */
proto.client_inventory.Asset.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Asset} returns this
 */
proto.client_inventory.Asset.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string mesh = 2;
 * @return {string}
 */
proto.client_inventory.Asset.prototype.getMesh = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Asset} returns this
 */
proto.client_inventory.Asset.prototype.setMesh = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string texture = 3;
 * @return {string}
 */
proto.client_inventory.Asset.prototype.getTexture = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Asset} returns this
 */
proto.client_inventory.Asset.prototype.setTexture = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, Material> materials = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.client_inventory.Material>}
 */
proto.client_inventory.Asset.prototype.getMaterialsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.client_inventory.Material>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.client_inventory.Material));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.client_inventory.Asset} returns this
 */
proto.client_inventory.Asset.prototype.clearMaterialsMap = function() {
  this.getMaterialsMap().clear();
  return this;};


/**
 * repeated Perk perks = 6;
 * @return {!Array<!proto.client_inventory.Perk>}
 */
proto.client_inventory.Asset.prototype.getPerksList = function() {
  return /** @type{!Array<!proto.client_inventory.Perk>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.client_inventory.Perk, 6));
};


/**
 * @param {!Array<!proto.client_inventory.Perk>} value
 * @return {!proto.client_inventory.Asset} returns this
*/
proto.client_inventory.Asset.prototype.setPerksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.client_inventory.Perk=} opt_value
 * @param {number=} opt_index
 * @return {!proto.client_inventory.Perk}
 */
proto.client_inventory.Asset.prototype.addPerks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.client_inventory.Perk, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.client_inventory.Asset} returns this
 */
proto.client_inventory.Asset.prototype.clearPerksList = function() {
  return this.setPerksList([]);
};


/**
 * optional string skeleton = 8;
 * @return {string}
 */
proto.client_inventory.Asset.prototype.getSkeleton = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Asset} returns this
 */
proto.client_inventory.Asset.prototype.setSkeleton = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.client_inventory.Perk.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Perk.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Perk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Perk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Perk.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parametersList: jspb.Message.toObjectList(msg.getParametersList(),
    proto.client_inventory.Parameter.toObject, includeInstance),
    description: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Perk}
 */
proto.client_inventory.Perk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Perk;
  return proto.client_inventory.Perk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Perk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Perk}
 */
proto.client_inventory.Perk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.client_inventory.Parameter;
      reader.readMessage(value,proto.client_inventory.Parameter.deserializeBinaryFromReader);
      msg.addParameters(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Perk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Perk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Perk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Perk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParametersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.client_inventory.Parameter.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.client_inventory.Perk.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Perk} returns this
 */
proto.client_inventory.Perk.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.client_inventory.Perk.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Perk} returns this
 */
proto.client_inventory.Perk.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Parameter parameters = 3;
 * @return {!Array<!proto.client_inventory.Parameter>}
 */
proto.client_inventory.Perk.prototype.getParametersList = function() {
  return /** @type{!Array<!proto.client_inventory.Parameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.client_inventory.Parameter, 3));
};


/**
 * @param {!Array<!proto.client_inventory.Parameter>} value
 * @return {!proto.client_inventory.Perk} returns this
*/
proto.client_inventory.Perk.prototype.setParametersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.client_inventory.Parameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.client_inventory.Parameter}
 */
proto.client_inventory.Perk.prototype.addParameters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.client_inventory.Parameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.client_inventory.Perk} returns this
 */
proto.client_inventory.Perk.prototype.clearParametersList = function() {
  return this.setParametersList([]);
};


/**
 * optional string Description = 4;
 * @return {string}
 */
proto.client_inventory.Perk.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Perk} returns this
 */
proto.client_inventory.Perk.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.Parameter.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.Parameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.Parameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Parameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.Parameter}
 */
proto.client_inventory.Parameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.Parameter;
  return proto.client_inventory.Parameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.Parameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.Parameter}
 */
proto.client_inventory.Parameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.Parameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.Parameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.Parameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.Parameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.client_inventory.Parameter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.Parameter} returns this
 */
proto.client_inventory.Parameter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional float value = 2;
 * @return {number}
 */
proto.client_inventory.Parameter.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.client_inventory.Parameter} returns this
 */
proto.client_inventory.Parameter.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.GetItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.GetItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.GetItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GetItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.GetItemRequest}
 */
proto.client_inventory.GetItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.GetItemRequest;
  return proto.client_inventory.GetItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.GetItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.GetItemRequest}
 */
proto.client_inventory.GetItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.GetItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.GetItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.GetItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GetItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.client_inventory.GetItemRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.client_inventory.GetItemRequest} returns this
 */
proto.client_inventory.GetItemRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.client_inventory.GetItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.client_inventory.GetItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.client_inventory.GetItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GetItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && proto.client_inventory.Item.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.client_inventory.GetItemResponse}
 */
proto.client_inventory.GetItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.client_inventory.GetItemResponse;
  return proto.client_inventory.GetItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.client_inventory.GetItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.client_inventory.GetItemResponse}
 */
proto.client_inventory.GetItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.client_inventory.Item;
      reader.readMessage(value,proto.client_inventory.Item.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.client_inventory.GetItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.client_inventory.GetItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.client_inventory.GetItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.client_inventory.GetItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.client_inventory.Item.serializeBinaryToWriter
    );
  }
};


/**
 * optional Item item = 1;
 * @return {?proto.client_inventory.Item}
 */
proto.client_inventory.GetItemResponse.prototype.getItem = function() {
  return /** @type{?proto.client_inventory.Item} */ (
    jspb.Message.getWrapperField(this, proto.client_inventory.Item, 1));
};


/**
 * @param {?proto.client_inventory.Item|undefined} value
 * @return {!proto.client_inventory.GetItemResponse} returns this
*/
proto.client_inventory.GetItemResponse.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.client_inventory.GetItemResponse} returns this
 */
proto.client_inventory.GetItemResponse.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.client_inventory.GetItemResponse.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.client_inventory.Category = {
  UNKNOWN_CATEGORY: 0,
  BODY: 1,
  ASSAULT_RIFLE: 2,
  HANDGUN: 3,
  HAT: 4,
  MELEE_WEAPONS: 5,
  PARACHUTE: 6,
  SHOTGUN: 7,
  SNIPER_RIFLE: 8,
  SOFT: 9,
  SUBMACHINE_GUN: 10,
  GRENADE: 11
};

/**
 * @enum {number}
 */
proto.client_inventory.MatchMode = {
  UNKNOWN_MATCH_MODE: 0,
  BATTLE_ROYALE: 1,
  ARENA: 2
};

goog.object.extend(exports, proto.client_inventory);

},{"google-protobuf":3}],64:[function(require,module,exports){
// source: leaderboards.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.leaderboards.Match', null, global);
goog.exportSymbol('proto.leaderboards.Match.Status', null, global);
goog.exportSymbol('proto.leaderboards.MatchMode', null, global);
goog.exportSymbol('proto.leaderboards.Period', null, global);
goog.exportSymbol('proto.leaderboards.PlayerStat', null, global);
goog.exportSymbol('proto.leaderboards.Timestamp', null, global);
goog.exportSymbol('proto.leaderboards.UUID', null, global);
goog.exportSymbol('proto.leaderboards.User', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.User.displayName = 'proto.leaderboards.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.UUID.displayName = 'proto.leaderboards.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.PlayerStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.PlayerStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.PlayerStat.displayName = 'proto.leaderboards.PlayerStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.Match = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.Match, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.Match.displayName = 'proto.leaderboards.Match';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.Timestamp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.Timestamp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.Timestamp.displayName = 'proto.leaderboards.Timestamp';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.User.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.leaderboards.UUID.toObject(includeInstance, f),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    suffix: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.User}
 */
proto.leaderboards.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.User;
  return proto.leaderboards.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.User}
 */
proto.leaderboards.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.leaderboards.UUID;
      reader.readMessage(value,proto.leaderboards.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.leaderboards.UUID.serializeBinaryToWriter
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSuffix();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional UUID id = 1;
 * @return {?proto.leaderboards.UUID}
 */
proto.leaderboards.User.prototype.getId = function() {
  return /** @type{?proto.leaderboards.UUID} */ (
    jspb.Message.getWrapperField(this, proto.leaderboards.UUID, 1));
};


/**
 * @param {?proto.leaderboards.UUID|undefined} value
 * @return {!proto.leaderboards.User} returns this
*/
proto.leaderboards.User.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.User} returns this
 */
proto.leaderboards.User.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.User.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.leaderboards.User.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.leaderboards.User} returns this
 */
proto.leaderboards.User.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string suffix = 3;
 * @return {string}
 */
proto.leaderboards.User.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.leaderboards.User} returns this
 */
proto.leaderboards.User.prototype.setSuffix = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.UUID}
 */
proto.leaderboards.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.UUID;
  return proto.leaderboards.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.UUID}
 */
proto.leaderboards.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.leaderboards.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.leaderboards.UUID} returns this
 */
proto.leaderboards.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.PlayerStat.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.PlayerStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.PlayerStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.PlayerStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    kills: jspb.Message.getFieldWithDefault(msg, 1, 0),
    deaths: jspb.Message.getFieldWithDefault(msg, 2, 0),
    experience: jspb.Message.getFieldWithDefault(msg, 3, 0),
    headshots: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.PlayerStat}
 */
proto.leaderboards.PlayerStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.PlayerStat;
  return proto.leaderboards.PlayerStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.PlayerStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.PlayerStat}
 */
proto.leaderboards.PlayerStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKills(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDeaths(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExperience(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeadshots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.PlayerStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.PlayerStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.PlayerStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.PlayerStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKills();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getDeaths();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getExperience();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getHeadshots();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional uint32 kills = 1;
 * @return {number}
 */
proto.leaderboards.PlayerStat.prototype.getKills = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.PlayerStat} returns this
 */
proto.leaderboards.PlayerStat.prototype.setKills = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 deaths = 2;
 * @return {number}
 */
proto.leaderboards.PlayerStat.prototype.getDeaths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.PlayerStat} returns this
 */
proto.leaderboards.PlayerStat.prototype.setDeaths = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 experience = 3;
 * @return {number}
 */
proto.leaderboards.PlayerStat.prototype.getExperience = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.PlayerStat} returns this
 */
proto.leaderboards.PlayerStat.prototype.setExperience = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 headshots = 4;
 * @return {number}
 */
proto.leaderboards.PlayerStat.prototype.getHeadshots = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.PlayerStat} returns this
 */
proto.leaderboards.PlayerStat.prototype.setHeadshots = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.Match.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.Match.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.Match} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.Match.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    startedAt: (f = msg.getStartedAt()) && proto.leaderboards.Timestamp.toObject(includeInstance, f),
    map: jspb.Message.getFieldWithDefault(msg, 3, ""),
    rank: jspb.Message.getFieldWithDefault(msg, 4, 0),
    stat: (f = msg.getStat()) && proto.leaderboards.PlayerStat.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.Match}
 */
proto.leaderboards.Match.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.Match;
  return proto.leaderboards.Match.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.Match} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.Match}
 */
proto.leaderboards.Match.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.leaderboards.MatchMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = new proto.leaderboards.Timestamp;
      reader.readMessage(value,proto.leaderboards.Timestamp.deserializeBinaryFromReader);
      msg.setStartedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMap(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRank(value);
      break;
    case 5:
      var value = new proto.leaderboards.PlayerStat;
      reader.readMessage(value,proto.leaderboards.PlayerStat.deserializeBinaryFromReader);
      msg.setStat(value);
      break;
    case 6:
      var value = /** @type {!proto.leaderboards.Match.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.Match.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.Match.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.Match} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.Match.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStartedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.leaderboards.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMap();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getStat();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.leaderboards.PlayerStat.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.leaderboards.Match.Status = {
  UNKNOWN: 0,
  DEFEAT: 1,
  VICTORY: 2
};

/**
 * optional MatchMode mode = 1;
 * @return {!proto.leaderboards.MatchMode}
 */
proto.leaderboards.Match.prototype.getMode = function() {
  return /** @type {!proto.leaderboards.MatchMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.leaderboards.MatchMode} value
 * @return {!proto.leaderboards.Match} returns this
 */
proto.leaderboards.Match.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Timestamp started_at = 2;
 * @return {?proto.leaderboards.Timestamp}
 */
proto.leaderboards.Match.prototype.getStartedAt = function() {
  return /** @type{?proto.leaderboards.Timestamp} */ (
    jspb.Message.getWrapperField(this, proto.leaderboards.Timestamp, 2));
};


/**
 * @param {?proto.leaderboards.Timestamp|undefined} value
 * @return {!proto.leaderboards.Match} returns this
*/
proto.leaderboards.Match.prototype.setStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.Match} returns this
 */
proto.leaderboards.Match.prototype.clearStartedAt = function() {
  return this.setStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.Match.prototype.hasStartedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string map = 3;
 * @return {string}
 */
proto.leaderboards.Match.prototype.getMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.leaderboards.Match} returns this
 */
proto.leaderboards.Match.prototype.setMap = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 rank = 4;
 * @return {number}
 */
proto.leaderboards.Match.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.Match} returns this
 */
proto.leaderboards.Match.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional PlayerStat stat = 5;
 * @return {?proto.leaderboards.PlayerStat}
 */
proto.leaderboards.Match.prototype.getStat = function() {
  return /** @type{?proto.leaderboards.PlayerStat} */ (
    jspb.Message.getWrapperField(this, proto.leaderboards.PlayerStat, 5));
};


/**
 * @param {?proto.leaderboards.PlayerStat|undefined} value
 * @return {!proto.leaderboards.Match} returns this
*/
proto.leaderboards.Match.prototype.setStat = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.Match} returns this
 */
proto.leaderboards.Match.prototype.clearStat = function() {
  return this.setStat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.Match.prototype.hasStat = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Status status = 6;
 * @return {!proto.leaderboards.Match.Status}
 */
proto.leaderboards.Match.prototype.getStatus = function() {
  return /** @type {!proto.leaderboards.Match.Status} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.leaderboards.Match.Status} value
 * @return {!proto.leaderboards.Match} returns this
 */
proto.leaderboards.Match.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.Timestamp.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.Timestamp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.Timestamp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.Timestamp.toObject = function(includeInstance, msg) {
  var f, obj = {
    unixMilli: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.Timestamp}
 */
proto.leaderboards.Timestamp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.Timestamp;
  return proto.leaderboards.Timestamp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.Timestamp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.Timestamp}
 */
proto.leaderboards.Timestamp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUnixMilli(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.Timestamp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.Timestamp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.Timestamp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.Timestamp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnixMilli();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 unix_milli = 1;
 * @return {number}
 */
proto.leaderboards.Timestamp.prototype.getUnixMilli = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.Timestamp} returns this
 */
proto.leaderboards.Timestamp.prototype.setUnixMilli = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.leaderboards.MatchMode = {
  UNKNOWN: 0,
  CAPTURE_THE_FLAG: 1,
  TEAM_DEATH_MATCH: 2,
  BATTLE_ROYALE: 3,
  FREE_FOR_ALL: 4
};

/**
 * @enum {number}
 */
proto.leaderboards.Period = {
  ALL: 0,
  DAILY: 1,
  SEASONAL: 2
};

goog.object.extend(exports, proto.leaderboards);

},{"./validate/validate_pb.js":65,"google-protobuf":3}],65:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],66:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for leaderboards.web
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var leaderboards_shared_pb = require('../leaderboards.shared_pb.js')
const proto = {};
proto.leaderboards = {};
proto.leaderboards.web = require('./leaderboards_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.leaderboards.web.FeedClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.leaderboards.web.FeedPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.leaderboards.web.Scores.Request,
 *   !proto.leaderboards.web.Scores.Response>}
 */
const methodDescriptor_Feed_Scores = new grpc.web.MethodDescriptor(
  '/leaderboards.web.Feed/Scores',
  grpc.web.MethodType.UNARY,
  proto.leaderboards.web.Scores.Request,
  proto.leaderboards.web.Scores.Response,
  /**
   * @param {!proto.leaderboards.web.Scores.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.leaderboards.web.Scores.Response.deserializeBinary
);


/**
 * @param {!proto.leaderboards.web.Scores.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.leaderboards.web.Scores.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.leaderboards.web.Scores.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.leaderboards.web.FeedClient.prototype.scores =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/leaderboards.web.Feed/Scores',
      request,
      metadata || {},
      methodDescriptor_Feed_Scores,
      callback);
};


/**
 * @param {!proto.leaderboards.web.Scores.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.leaderboards.web.Scores.Response>}
 *     Promise that resolves to the response
 */
proto.leaderboards.web.FeedPromiseClient.prototype.scores =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/leaderboards.web.Feed/Scores',
      request,
      metadata || {},
      methodDescriptor_Feed_Scores);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.leaderboards.web.Clans.Request,
 *   !proto.leaderboards.web.Clans.Response>}
 */
const methodDescriptor_Feed_Clans = new grpc.web.MethodDescriptor(
  '/leaderboards.web.Feed/Clans',
  grpc.web.MethodType.UNARY,
  proto.leaderboards.web.Clans.Request,
  proto.leaderboards.web.Clans.Response,
  /**
   * @param {!proto.leaderboards.web.Clans.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.leaderboards.web.Clans.Response.deserializeBinary
);


/**
 * @param {!proto.leaderboards.web.Clans.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.leaderboards.web.Clans.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.leaderboards.web.Clans.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.leaderboards.web.FeedClient.prototype.clans =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/leaderboards.web.Feed/Clans',
      request,
      metadata || {},
      methodDescriptor_Feed_Clans,
      callback);
};


/**
 * @param {!proto.leaderboards.web.Clans.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.leaderboards.web.Clans.Response>}
 *     Promise that resolves to the response
 */
proto.leaderboards.web.FeedPromiseClient.prototype.clans =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/leaderboards.web.Feed/Clans',
      request,
      metadata || {},
      methodDescriptor_Feed_Clans);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.leaderboards.web.Profile.Request,
 *   !proto.leaderboards.web.Profile.Response>}
 */
const methodDescriptor_Feed_Profile = new grpc.web.MethodDescriptor(
  '/leaderboards.web.Feed/Profile',
  grpc.web.MethodType.UNARY,
  proto.leaderboards.web.Profile.Request,
  proto.leaderboards.web.Profile.Response,
  /**
   * @param {!proto.leaderboards.web.Profile.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.leaderboards.web.Profile.Response.deserializeBinary
);


/**
 * @param {!proto.leaderboards.web.Profile.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.leaderboards.web.Profile.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.leaderboards.web.Profile.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.leaderboards.web.FeedClient.prototype.profile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/leaderboards.web.Feed/Profile',
      request,
      metadata || {},
      methodDescriptor_Feed_Profile,
      callback);
};


/**
 * @param {!proto.leaderboards.web.Profile.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.leaderboards.web.Profile.Response>}
 *     Promise that resolves to the response
 */
proto.leaderboards.web.FeedPromiseClient.prototype.profile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/leaderboards.web.Feed/Profile',
      request,
      metadata || {},
      methodDescriptor_Feed_Profile);
};


module.exports = proto.leaderboards.web;


},{"../leaderboards.shared_pb.js":64,"../validate/validate_pb.js":65,"./leaderboards_pb.js":67,"grpc-web":7}],67:[function(require,module,exports){
// source: web/leaderboards.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var leaderboards_shared_pb = require('../leaderboards.shared_pb.js');
goog.object.extend(proto, leaderboards_shared_pb);
goog.exportSymbol('proto.leaderboards.web.Clans', null, global);
goog.exportSymbol('proto.leaderboards.web.Clans.Clan', null, global);
goog.exportSymbol('proto.leaderboards.web.Clans.Request', null, global);
goog.exportSymbol('proto.leaderboards.web.Clans.Response', null, global);
goog.exportSymbol('proto.leaderboards.web.Filter', null, global);
goog.exportSymbol('proto.leaderboards.web.Profile', null, global);
goog.exportSymbol('proto.leaderboards.web.Profile.Request', null, global);
goog.exportSymbol('proto.leaderboards.web.Profile.Response', null, global);
goog.exportSymbol('proto.leaderboards.web.Scores', null, global);
goog.exportSymbol('proto.leaderboards.web.Scores.Player', null, global);
goog.exportSymbol('proto.leaderboards.web.Scores.Request', null, global);
goog.exportSymbol('proto.leaderboards.web.Scores.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.leaderboards.web.Filter.repeatedFields_, null);
};
goog.inherits(proto.leaderboards.web.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Filter.displayName = 'proto.leaderboards.web.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Scores = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.web.Scores, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Scores.displayName = 'proto.leaderboards.web.Scores';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Scores.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.web.Scores.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Scores.Player.displayName = 'proto.leaderboards.web.Scores.Player';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Scores.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.web.Scores.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Scores.Request.displayName = 'proto.leaderboards.web.Scores.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Scores.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.leaderboards.web.Scores.Response.repeatedFields_, null);
};
goog.inherits(proto.leaderboards.web.Scores.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Scores.Response.displayName = 'proto.leaderboards.web.Scores.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Clans = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.web.Clans, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Clans.displayName = 'proto.leaderboards.web.Clans';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Clans.Clan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.web.Clans.Clan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Clans.Clan.displayName = 'proto.leaderboards.web.Clans.Clan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Clans.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.web.Clans.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Clans.Request.displayName = 'proto.leaderboards.web.Clans.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Clans.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.leaderboards.web.Clans.Response.repeatedFields_, null);
};
goog.inherits(proto.leaderboards.web.Clans.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Clans.Response.displayName = 'proto.leaderboards.web.Clans.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Profile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.web.Profile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Profile.displayName = 'proto.leaderboards.web.Profile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Profile.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.leaderboards.web.Profile.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Profile.Request.displayName = 'proto.leaderboards.web.Profile.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.leaderboards.web.Profile.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.leaderboards.web.Profile.Response.repeatedFields_, null);
};
goog.inherits(proto.leaderboards.web.Profile.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.leaderboards.web.Profile.Response.displayName = 'proto.leaderboards.web.Profile.Response';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.leaderboards.web.Filter.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchModeList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    matchMapList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Filter}
 */
proto.leaderboards.web.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Filter;
  return proto.leaderboards.web.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Filter}
 */
proto.leaderboards.web.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.leaderboards.MatchMode>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMatchMode(values[i]);
      }
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addMatchMap(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchModeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getMatchMapList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated leaderboards.MatchMode match_mode = 1;
 * @return {!Array<!proto.leaderboards.MatchMode>}
 */
proto.leaderboards.web.Filter.prototype.getMatchModeList = function() {
  return /** @type {!Array<!proto.leaderboards.MatchMode>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.leaderboards.MatchMode>} value
 * @return {!proto.leaderboards.web.Filter} returns this
 */
proto.leaderboards.web.Filter.prototype.setMatchModeList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.leaderboards.MatchMode} value
 * @param {number=} opt_index
 * @return {!proto.leaderboards.web.Filter} returns this
 */
proto.leaderboards.web.Filter.prototype.addMatchMode = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.leaderboards.web.Filter} returns this
 */
proto.leaderboards.web.Filter.prototype.clearMatchModeList = function() {
  return this.setMatchModeList([]);
};


/**
 * repeated string match_map = 2;
 * @return {!Array<string>}
 */
proto.leaderboards.web.Filter.prototype.getMatchMapList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.leaderboards.web.Filter} returns this
 */
proto.leaderboards.web.Filter.prototype.setMatchMapList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.leaderboards.web.Filter} returns this
 */
proto.leaderboards.web.Filter.prototype.addMatchMap = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.leaderboards.web.Filter} returns this
 */
proto.leaderboards.web.Filter.prototype.clearMatchMapList = function() {
  return this.setMatchMapList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Scores.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Scores.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Scores} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Scores.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Scores}
 */
proto.leaderboards.web.Scores.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Scores;
  return proto.leaderboards.web.Scores.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Scores} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Scores}
 */
proto.leaderboards.web.Scores.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Scores.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Scores.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Scores} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Scores.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Scores.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Scores.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Scores.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Scores.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && leaderboards_shared_pb.User.toObject(includeInstance, f),
    stat: (f = msg.getStat()) && leaderboards_shared_pb.PlayerStat.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Scores.Player}
 */
proto.leaderboards.web.Scores.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Scores.Player;
  return proto.leaderboards.web.Scores.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Scores.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Scores.Player}
 */
proto.leaderboards.web.Scores.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new leaderboards_shared_pb.User;
      reader.readMessage(value,leaderboards_shared_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = new leaderboards_shared_pb.PlayerStat;
      reader.readMessage(value,leaderboards_shared_pb.PlayerStat.deserializeBinaryFromReader);
      msg.setStat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Scores.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Scores.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Scores.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Scores.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      leaderboards_shared_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getStat();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      leaderboards_shared_pb.PlayerStat.serializeBinaryToWriter
    );
  }
};


/**
 * optional leaderboards.User user = 1;
 * @return {?proto.leaderboards.User}
 */
proto.leaderboards.web.Scores.Player.prototype.getUser = function() {
  return /** @type{?proto.leaderboards.User} */ (
    jspb.Message.getWrapperField(this, leaderboards_shared_pb.User, 1));
};


/**
 * @param {?proto.leaderboards.User|undefined} value
 * @return {!proto.leaderboards.web.Scores.Player} returns this
*/
proto.leaderboards.web.Scores.Player.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.web.Scores.Player} returns this
 */
proto.leaderboards.web.Scores.Player.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.web.Scores.Player.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional leaderboards.PlayerStat stat = 2;
 * @return {?proto.leaderboards.PlayerStat}
 */
proto.leaderboards.web.Scores.Player.prototype.getStat = function() {
  return /** @type{?proto.leaderboards.PlayerStat} */ (
    jspb.Message.getWrapperField(this, leaderboards_shared_pb.PlayerStat, 2));
};


/**
 * @param {?proto.leaderboards.PlayerStat|undefined} value
 * @return {!proto.leaderboards.web.Scores.Player} returns this
*/
proto.leaderboards.web.Scores.Player.prototype.setStat = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.web.Scores.Player} returns this
 */
proto.leaderboards.web.Scores.Player.prototype.clearStat = function() {
  return this.setStat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.web.Scores.Player.prototype.hasStat = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Scores.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Scores.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Scores.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Scores.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: (f = msg.getFilter()) && proto.leaderboards.web.Filter.toObject(includeInstance, f),
    period: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Scores.Request}
 */
proto.leaderboards.web.Scores.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Scores.Request;
  return proto.leaderboards.web.Scores.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Scores.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Scores.Request}
 */
proto.leaderboards.web.Scores.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.leaderboards.web.Filter;
      reader.readMessage(value,proto.leaderboards.web.Filter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    case 2:
      var value = /** @type {!proto.leaderboards.Period} */ (reader.readEnum());
      msg.setPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Scores.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Scores.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Scores.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Scores.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.leaderboards.web.Filter.serializeBinaryToWriter
    );
  }
  f = message.getPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Filter filter = 1;
 * @return {?proto.leaderboards.web.Filter}
 */
proto.leaderboards.web.Scores.Request.prototype.getFilter = function() {
  return /** @type{?proto.leaderboards.web.Filter} */ (
    jspb.Message.getWrapperField(this, proto.leaderboards.web.Filter, 1));
};


/**
 * @param {?proto.leaderboards.web.Filter|undefined} value
 * @return {!proto.leaderboards.web.Scores.Request} returns this
*/
proto.leaderboards.web.Scores.Request.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.web.Scores.Request} returns this
 */
proto.leaderboards.web.Scores.Request.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.web.Scores.Request.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional leaderboards.Period period = 2;
 * @return {!proto.leaderboards.Period}
 */
proto.leaderboards.web.Scores.Request.prototype.getPeriod = function() {
  return /** @type {!proto.leaderboards.Period} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.leaderboards.Period} value
 * @return {!proto.leaderboards.web.Scores.Request} returns this
 */
proto.leaderboards.web.Scores.Request.prototype.setPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.leaderboards.web.Scores.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Scores.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Scores.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Scores.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Scores.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    playersList: jspb.Message.toObjectList(msg.getPlayersList(),
    proto.leaderboards.web.Scores.Player.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Scores.Response}
 */
proto.leaderboards.web.Scores.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Scores.Response;
  return proto.leaderboards.web.Scores.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Scores.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Scores.Response}
 */
proto.leaderboards.web.Scores.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.leaderboards.web.Scores.Player;
      reader.readMessage(value,proto.leaderboards.web.Scores.Player.deserializeBinaryFromReader);
      msg.addPlayers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Scores.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Scores.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Scores.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Scores.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.leaderboards.web.Scores.Player.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Player players = 1;
 * @return {!Array<!proto.leaderboards.web.Scores.Player>}
 */
proto.leaderboards.web.Scores.Response.prototype.getPlayersList = function() {
  return /** @type{!Array<!proto.leaderboards.web.Scores.Player>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.leaderboards.web.Scores.Player, 1));
};


/**
 * @param {!Array<!proto.leaderboards.web.Scores.Player>} value
 * @return {!proto.leaderboards.web.Scores.Response} returns this
*/
proto.leaderboards.web.Scores.Response.prototype.setPlayersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.leaderboards.web.Scores.Player=} opt_value
 * @param {number=} opt_index
 * @return {!proto.leaderboards.web.Scores.Player}
 */
proto.leaderboards.web.Scores.Response.prototype.addPlayers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.leaderboards.web.Scores.Player, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.leaderboards.web.Scores.Response} returns this
 */
proto.leaderboards.web.Scores.Response.prototype.clearPlayersList = function() {
  return this.setPlayersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Clans.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Clans.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Clans} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Clans.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Clans}
 */
proto.leaderboards.web.Clans.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Clans;
  return proto.leaderboards.web.Clans.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Clans} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Clans}
 */
proto.leaderboards.web.Clans.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Clans.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Clans.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Clans} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Clans.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Clans.Clan.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Clans.Clan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Clans.Clan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Clans.Clan.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slug: jspb.Message.getFieldWithDefault(msg, 2, ""),
    experience: jspb.Message.getFieldWithDefault(msg, 3, 0),
    membersNum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    owner: (f = msg.getOwner()) && leaderboards_shared_pb.User.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Clans.Clan}
 */
proto.leaderboards.web.Clans.Clan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Clans.Clan;
  return proto.leaderboards.web.Clans.Clan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Clans.Clan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Clans.Clan}
 */
proto.leaderboards.web.Clans.Clan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExperience(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMembersNum(value);
      break;
    case 5:
      var value = new leaderboards_shared_pb.User;
      reader.readMessage(value,leaderboards_shared_pb.User.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Clans.Clan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Clans.Clan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Clans.Clan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Clans.Clan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExperience();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getMembersNum();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      leaderboards_shared_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.leaderboards.web.Clans.Clan.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.leaderboards.web.Clans.Clan} returns this
 */
proto.leaderboards.web.Clans.Clan.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slug = 2;
 * @return {string}
 */
proto.leaderboards.web.Clans.Clan.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.leaderboards.web.Clans.Clan} returns this
 */
proto.leaderboards.web.Clans.Clan.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 experience = 3;
 * @return {number}
 */
proto.leaderboards.web.Clans.Clan.prototype.getExperience = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.web.Clans.Clan} returns this
 */
proto.leaderboards.web.Clans.Clan.prototype.setExperience = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 members_num = 4;
 * @return {number}
 */
proto.leaderboards.web.Clans.Clan.prototype.getMembersNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.web.Clans.Clan} returns this
 */
proto.leaderboards.web.Clans.Clan.prototype.setMembersNum = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional leaderboards.User owner = 5;
 * @return {?proto.leaderboards.User}
 */
proto.leaderboards.web.Clans.Clan.prototype.getOwner = function() {
  return /** @type{?proto.leaderboards.User} */ (
    jspb.Message.getWrapperField(this, leaderboards_shared_pb.User, 5));
};


/**
 * @param {?proto.leaderboards.User|undefined} value
 * @return {!proto.leaderboards.web.Clans.Clan} returns this
*/
proto.leaderboards.web.Clans.Clan.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.web.Clans.Clan} returns this
 */
proto.leaderboards.web.Clans.Clan.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.web.Clans.Clan.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint64 id = 6;
 * @return {number}
 */
proto.leaderboards.web.Clans.Clan.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.web.Clans.Clan} returns this
 */
proto.leaderboards.web.Clans.Clan.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Clans.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Clans.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Clans.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Clans.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: (f = msg.getFilter()) && proto.leaderboards.web.Filter.toObject(includeInstance, f),
    period: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Clans.Request}
 */
proto.leaderboards.web.Clans.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Clans.Request;
  return proto.leaderboards.web.Clans.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Clans.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Clans.Request}
 */
proto.leaderboards.web.Clans.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.leaderboards.web.Filter;
      reader.readMessage(value,proto.leaderboards.web.Filter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    case 2:
      var value = /** @type {!proto.leaderboards.Period} */ (reader.readEnum());
      msg.setPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Clans.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Clans.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Clans.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Clans.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.leaderboards.web.Filter.serializeBinaryToWriter
    );
  }
  f = message.getPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Filter filter = 1;
 * @return {?proto.leaderboards.web.Filter}
 */
proto.leaderboards.web.Clans.Request.prototype.getFilter = function() {
  return /** @type{?proto.leaderboards.web.Filter} */ (
    jspb.Message.getWrapperField(this, proto.leaderboards.web.Filter, 1));
};


/**
 * @param {?proto.leaderboards.web.Filter|undefined} value
 * @return {!proto.leaderboards.web.Clans.Request} returns this
*/
proto.leaderboards.web.Clans.Request.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.web.Clans.Request} returns this
 */
proto.leaderboards.web.Clans.Request.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.web.Clans.Request.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional leaderboards.Period period = 2;
 * @return {!proto.leaderboards.Period}
 */
proto.leaderboards.web.Clans.Request.prototype.getPeriod = function() {
  return /** @type {!proto.leaderboards.Period} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.leaderboards.Period} value
 * @return {!proto.leaderboards.web.Clans.Request} returns this
 */
proto.leaderboards.web.Clans.Request.prototype.setPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.leaderboards.web.Clans.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Clans.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Clans.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Clans.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Clans.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    clansList: jspb.Message.toObjectList(msg.getClansList(),
    proto.leaderboards.web.Clans.Clan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Clans.Response}
 */
proto.leaderboards.web.Clans.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Clans.Response;
  return proto.leaderboards.web.Clans.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Clans.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Clans.Response}
 */
proto.leaderboards.web.Clans.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.leaderboards.web.Clans.Clan;
      reader.readMessage(value,proto.leaderboards.web.Clans.Clan.deserializeBinaryFromReader);
      msg.addClans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Clans.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Clans.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Clans.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Clans.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.leaderboards.web.Clans.Clan.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Clan clans = 1;
 * @return {!Array<!proto.leaderboards.web.Clans.Clan>}
 */
proto.leaderboards.web.Clans.Response.prototype.getClansList = function() {
  return /** @type{!Array<!proto.leaderboards.web.Clans.Clan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.leaderboards.web.Clans.Clan, 1));
};


/**
 * @param {!Array<!proto.leaderboards.web.Clans.Clan>} value
 * @return {!proto.leaderboards.web.Clans.Response} returns this
*/
proto.leaderboards.web.Clans.Response.prototype.setClansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.leaderboards.web.Clans.Clan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.leaderboards.web.Clans.Clan}
 */
proto.leaderboards.web.Clans.Response.prototype.addClans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.leaderboards.web.Clans.Clan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.leaderboards.web.Clans.Response} returns this
 */
proto.leaderboards.web.Clans.Response.prototype.clearClansList = function() {
  return this.setClansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Profile.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Profile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Profile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Profile.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Profile}
 */
proto.leaderboards.web.Profile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Profile;
  return proto.leaderboards.web.Profile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Profile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Profile}
 */
proto.leaderboards.web.Profile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Profile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Profile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Profile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Profile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Profile.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Profile.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Profile.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Profile.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && leaderboards_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Profile.Request}
 */
proto.leaderboards.web.Profile.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Profile.Request;
  return proto.leaderboards.web.Profile.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Profile.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Profile.Request}
 */
proto.leaderboards.web.Profile.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new leaderboards_shared_pb.UUID;
      reader.readMessage(value,leaderboards_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Profile.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Profile.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Profile.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Profile.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      leaderboards_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional leaderboards.UUID user_id = 1;
 * @return {?proto.leaderboards.UUID}
 */
proto.leaderboards.web.Profile.Request.prototype.getUserId = function() {
  return /** @type{?proto.leaderboards.UUID} */ (
    jspb.Message.getWrapperField(this, leaderboards_shared_pb.UUID, 1));
};


/**
 * @param {?proto.leaderboards.UUID|undefined} value
 * @return {!proto.leaderboards.web.Profile.Request} returns this
*/
proto.leaderboards.web.Profile.Request.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.leaderboards.web.Profile.Request} returns this
 */
proto.leaderboards.web.Profile.Request.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.leaderboards.web.Profile.Request.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.leaderboards.web.Profile.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.leaderboards.web.Profile.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.leaderboards.web.Profile.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.leaderboards.web.Profile.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Profile.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchHistoryList: jspb.Message.toObjectList(msg.getMatchHistoryList(),
    leaderboards_shared_pb.Match.toObject, includeInstance),
    dailyRank: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.leaderboards.web.Profile.Response}
 */
proto.leaderboards.web.Profile.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.leaderboards.web.Profile.Response;
  return proto.leaderboards.web.Profile.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.leaderboards.web.Profile.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.leaderboards.web.Profile.Response}
 */
proto.leaderboards.web.Profile.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new leaderboards_shared_pb.Match;
      reader.readMessage(value,leaderboards_shared_pb.Match.deserializeBinaryFromReader);
      msg.addMatchHistory(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDailyRank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.leaderboards.web.Profile.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.leaderboards.web.Profile.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.leaderboards.web.Profile.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.leaderboards.web.Profile.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchHistoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      leaderboards_shared_pb.Match.serializeBinaryToWriter
    );
  }
  f = message.getDailyRank();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * repeated leaderboards.Match match_history = 1;
 * @return {!Array<!proto.leaderboards.Match>}
 */
proto.leaderboards.web.Profile.Response.prototype.getMatchHistoryList = function() {
  return /** @type{!Array<!proto.leaderboards.Match>} */ (
    jspb.Message.getRepeatedWrapperField(this, leaderboards_shared_pb.Match, 1));
};


/**
 * @param {!Array<!proto.leaderboards.Match>} value
 * @return {!proto.leaderboards.web.Profile.Response} returns this
*/
proto.leaderboards.web.Profile.Response.prototype.setMatchHistoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.leaderboards.Match=} opt_value
 * @param {number=} opt_index
 * @return {!proto.leaderboards.Match}
 */
proto.leaderboards.web.Profile.Response.prototype.addMatchHistory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.leaderboards.Match, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.leaderboards.web.Profile.Response} returns this
 */
proto.leaderboards.web.Profile.Response.prototype.clearMatchHistoryList = function() {
  return this.setMatchHistoryList([]);
};


/**
 * optional uint32 daily_rank = 2;
 * @return {number}
 */
proto.leaderboards.web.Profile.Response.prototype.getDailyRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.leaderboards.web.Profile.Response} returns this
 */
proto.leaderboards.web.Profile.Response.prototype.setDailyRank = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.leaderboards.web);

},{"../leaderboards.shared_pb.js":64,"../validate/validate_pb.js":65,"google-protobuf":3}],68:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for offchain_wallets.public
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')
const proto = {};
proto.offchain_wallets = {};
proto.offchain_wallets.public = require('./public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.offchain_wallets.public.WalletsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.offchain_wallets.public.WalletsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.offchain_wallets.public.GetBalance.Request,
 *   !proto.offchain_wallets.public.GetBalance.Response>}
 */
const methodDescriptor_Wallets_GetBalance = new grpc.web.MethodDescriptor(
  '/offchain_wallets.public.Wallets/GetBalance',
  grpc.web.MethodType.UNARY,
  proto.offchain_wallets.public.GetBalance.Request,
  proto.offchain_wallets.public.GetBalance.Response,
  /**
   * @param {!proto.offchain_wallets.public.GetBalance.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.offchain_wallets.public.GetBalance.Response.deserializeBinary
);


/**
 * @param {!proto.offchain_wallets.public.GetBalance.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.offchain_wallets.public.GetBalance.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.offchain_wallets.public.GetBalance.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.offchain_wallets.public.WalletsClient.prototype.getBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/offchain_wallets.public.Wallets/GetBalance',
      request,
      metadata || {},
      methodDescriptor_Wallets_GetBalance,
      callback);
};


/**
 * @param {!proto.offchain_wallets.public.GetBalance.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.offchain_wallets.public.GetBalance.Response>}
 *     Promise that resolves to the response
 */
proto.offchain_wallets.public.WalletsPromiseClient.prototype.getBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/offchain_wallets.public.Wallets/GetBalance',
      request,
      metadata || {},
      methodDescriptor_Wallets_GetBalance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.offchain_wallets.public.GetBalances.Request,
 *   !proto.offchain_wallets.public.GetBalances.Response>}
 */
const methodDescriptor_Wallets_GetBalances = new grpc.web.MethodDescriptor(
  '/offchain_wallets.public.Wallets/GetBalances',
  grpc.web.MethodType.UNARY,
  proto.offchain_wallets.public.GetBalances.Request,
  proto.offchain_wallets.public.GetBalances.Response,
  /**
   * @param {!proto.offchain_wallets.public.GetBalances.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.offchain_wallets.public.GetBalances.Response.deserializeBinary
);


/**
 * @param {!proto.offchain_wallets.public.GetBalances.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.offchain_wallets.public.GetBalances.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.offchain_wallets.public.GetBalances.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.offchain_wallets.public.WalletsClient.prototype.getBalances =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/offchain_wallets.public.Wallets/GetBalances',
      request,
      metadata || {},
      methodDescriptor_Wallets_GetBalances,
      callback);
};


/**
 * @param {!proto.offchain_wallets.public.GetBalances.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.offchain_wallets.public.GetBalances.Response>}
 *     Promise that resolves to the response
 */
proto.offchain_wallets.public.WalletsPromiseClient.prototype.getBalances =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/offchain_wallets.public.Wallets/GetBalances',
      request,
      metadata || {},
      methodDescriptor_Wallets_GetBalances);
};


module.exports = proto.offchain_wallets.public;


},{"../validate/validate_pb.js":70,"./public_pb.js":69,"grpc-web":7}],69:[function(require,module,exports){
// source: public/public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.offchain_wallets.public.GetBalance', null, global);
goog.exportSymbol('proto.offchain_wallets.public.GetBalance.Request', null, global);
goog.exportSymbol('proto.offchain_wallets.public.GetBalance.Response', null, global);
goog.exportSymbol('proto.offchain_wallets.public.GetBalances', null, global);
goog.exportSymbol('proto.offchain_wallets.public.GetBalances.Balance', null, global);
goog.exportSymbol('proto.offchain_wallets.public.GetBalances.Request', null, global);
goog.exportSymbol('proto.offchain_wallets.public.GetBalances.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.offchain_wallets.public.GetBalance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.offchain_wallets.public.GetBalance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.offchain_wallets.public.GetBalance.displayName = 'proto.offchain_wallets.public.GetBalance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.offchain_wallets.public.GetBalance.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.offchain_wallets.public.GetBalance.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.offchain_wallets.public.GetBalance.Request.displayName = 'proto.offchain_wallets.public.GetBalance.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.offchain_wallets.public.GetBalance.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.offchain_wallets.public.GetBalance.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.offchain_wallets.public.GetBalance.Response.displayName = 'proto.offchain_wallets.public.GetBalance.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.offchain_wallets.public.GetBalances = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.offchain_wallets.public.GetBalances, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.offchain_wallets.public.GetBalances.displayName = 'proto.offchain_wallets.public.GetBalances';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.offchain_wallets.public.GetBalances.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.offchain_wallets.public.GetBalances.Request.repeatedFields_, null);
};
goog.inherits(proto.offchain_wallets.public.GetBalances.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.offchain_wallets.public.GetBalances.Request.displayName = 'proto.offchain_wallets.public.GetBalances.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.offchain_wallets.public.GetBalances.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.offchain_wallets.public.GetBalances.Response.repeatedFields_, null);
};
goog.inherits(proto.offchain_wallets.public.GetBalances.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.offchain_wallets.public.GetBalances.Response.displayName = 'proto.offchain_wallets.public.GetBalances.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.offchain_wallets.public.GetBalances.Balance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.offchain_wallets.public.GetBalances.Balance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.offchain_wallets.public.GetBalances.Balance.displayName = 'proto.offchain_wallets.public.GetBalances.Balance';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.offchain_wallets.public.GetBalance.prototype.toObject = function(opt_includeInstance) {
  return proto.offchain_wallets.public.GetBalance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.offchain_wallets.public.GetBalance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalance.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.offchain_wallets.public.GetBalance}
 */
proto.offchain_wallets.public.GetBalance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.offchain_wallets.public.GetBalance;
  return proto.offchain_wallets.public.GetBalance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.offchain_wallets.public.GetBalance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.offchain_wallets.public.GetBalance}
 */
proto.offchain_wallets.public.GetBalance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.offchain_wallets.public.GetBalance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.offchain_wallets.public.GetBalance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.offchain_wallets.public.GetBalance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.offchain_wallets.public.GetBalance.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.offchain_wallets.public.GetBalance.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.offchain_wallets.public.GetBalance.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalance.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.offchain_wallets.public.GetBalance.Request}
 */
proto.offchain_wallets.public.GetBalance.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.offchain_wallets.public.GetBalance.Request;
  return proto.offchain_wallets.public.GetBalance.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.offchain_wallets.public.GetBalance.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.offchain_wallets.public.GetBalance.Request}
 */
proto.offchain_wallets.public.GetBalance.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.offchain_wallets.public.GetBalance.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.offchain_wallets.public.GetBalance.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.offchain_wallets.public.GetBalance.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalance.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.offchain_wallets.public.GetBalance.Request.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.offchain_wallets.public.GetBalance.Request} returns this
 */
proto.offchain_wallets.public.GetBalance.Request.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.offchain_wallets.public.GetBalance.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.offchain_wallets.public.GetBalance.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.offchain_wallets.public.GetBalance.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalance.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.offchain_wallets.public.GetBalance.Response}
 */
proto.offchain_wallets.public.GetBalance.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.offchain_wallets.public.GetBalance.Response;
  return proto.offchain_wallets.public.GetBalance.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.offchain_wallets.public.GetBalance.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.offchain_wallets.public.GetBalance.Response}
 */
proto.offchain_wallets.public.GetBalance.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.offchain_wallets.public.GetBalance.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.offchain_wallets.public.GetBalance.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.offchain_wallets.public.GetBalance.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalance.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 amount = 4;
 * @return {number}
 */
proto.offchain_wallets.public.GetBalance.Response.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.offchain_wallets.public.GetBalance.Response} returns this
 */
proto.offchain_wallets.public.GetBalance.Response.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.offchain_wallets.public.GetBalances.prototype.toObject = function(opt_includeInstance) {
  return proto.offchain_wallets.public.GetBalances.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.offchain_wallets.public.GetBalances} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalances.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.offchain_wallets.public.GetBalances}
 */
proto.offchain_wallets.public.GetBalances.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.offchain_wallets.public.GetBalances;
  return proto.offchain_wallets.public.GetBalances.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.offchain_wallets.public.GetBalances} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.offchain_wallets.public.GetBalances}
 */
proto.offchain_wallets.public.GetBalances.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.offchain_wallets.public.GetBalances.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.offchain_wallets.public.GetBalances.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.offchain_wallets.public.GetBalances} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalances.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.offchain_wallets.public.GetBalances.Request.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.offchain_wallets.public.GetBalances.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.offchain_wallets.public.GetBalances.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.offchain_wallets.public.GetBalances.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalances.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    typesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.offchain_wallets.public.GetBalances.Request}
 */
proto.offchain_wallets.public.GetBalances.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.offchain_wallets.public.GetBalances.Request;
  return proto.offchain_wallets.public.GetBalances.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.offchain_wallets.public.GetBalances.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.offchain_wallets.public.GetBalances.Request}
 */
proto.offchain_wallets.public.GetBalances.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.offchain_wallets.public.GetBalances.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.offchain_wallets.public.GetBalances.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.offchain_wallets.public.GetBalances.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalances.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string types = 1;
 * @return {!Array<string>}
 */
proto.offchain_wallets.public.GetBalances.Request.prototype.getTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.offchain_wallets.public.GetBalances.Request} returns this
 */
proto.offchain_wallets.public.GetBalances.Request.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.offchain_wallets.public.GetBalances.Request} returns this
 */
proto.offchain_wallets.public.GetBalances.Request.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.offchain_wallets.public.GetBalances.Request} returns this
 */
proto.offchain_wallets.public.GetBalances.Request.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.offchain_wallets.public.GetBalances.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.offchain_wallets.public.GetBalances.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.offchain_wallets.public.GetBalances.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.offchain_wallets.public.GetBalances.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalances.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    balancesList: jspb.Message.toObjectList(msg.getBalancesList(),
    proto.offchain_wallets.public.GetBalances.Balance.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.offchain_wallets.public.GetBalances.Response}
 */
proto.offchain_wallets.public.GetBalances.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.offchain_wallets.public.GetBalances.Response;
  return proto.offchain_wallets.public.GetBalances.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.offchain_wallets.public.GetBalances.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.offchain_wallets.public.GetBalances.Response}
 */
proto.offchain_wallets.public.GetBalances.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.offchain_wallets.public.GetBalances.Balance;
      reader.readMessage(value,proto.offchain_wallets.public.GetBalances.Balance.deserializeBinaryFromReader);
      msg.addBalances(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.offchain_wallets.public.GetBalances.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.offchain_wallets.public.GetBalances.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.offchain_wallets.public.GetBalances.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalances.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.offchain_wallets.public.GetBalances.Balance.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Balance balances = 1;
 * @return {!Array<!proto.offchain_wallets.public.GetBalances.Balance>}
 */
proto.offchain_wallets.public.GetBalances.Response.prototype.getBalancesList = function() {
  return /** @type{!Array<!proto.offchain_wallets.public.GetBalances.Balance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.offchain_wallets.public.GetBalances.Balance, 1));
};


/**
 * @param {!Array<!proto.offchain_wallets.public.GetBalances.Balance>} value
 * @return {!proto.offchain_wallets.public.GetBalances.Response} returns this
*/
proto.offchain_wallets.public.GetBalances.Response.prototype.setBalancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.offchain_wallets.public.GetBalances.Balance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.offchain_wallets.public.GetBalances.Balance}
 */
proto.offchain_wallets.public.GetBalances.Response.prototype.addBalances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.offchain_wallets.public.GetBalances.Balance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.offchain_wallets.public.GetBalances.Response} returns this
 */
proto.offchain_wallets.public.GetBalances.Response.prototype.clearBalancesList = function() {
  return this.setBalancesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.offchain_wallets.public.GetBalances.Balance.prototype.toObject = function(opt_includeInstance) {
  return proto.offchain_wallets.public.GetBalances.Balance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.offchain_wallets.public.GetBalances.Balance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalances.Balance.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.offchain_wallets.public.GetBalances.Balance}
 */
proto.offchain_wallets.public.GetBalances.Balance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.offchain_wallets.public.GetBalances.Balance;
  return proto.offchain_wallets.public.GetBalances.Balance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.offchain_wallets.public.GetBalances.Balance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.offchain_wallets.public.GetBalances.Balance}
 */
proto.offchain_wallets.public.GetBalances.Balance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.offchain_wallets.public.GetBalances.Balance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.offchain_wallets.public.GetBalances.Balance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.offchain_wallets.public.GetBalances.Balance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.offchain_wallets.public.GetBalances.Balance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.offchain_wallets.public.GetBalances.Balance.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.offchain_wallets.public.GetBalances.Balance} returns this
 */
proto.offchain_wallets.public.GetBalances.Balance.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.offchain_wallets.public.GetBalances.Balance.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.offchain_wallets.public.GetBalances.Balance} returns this
 */
proto.offchain_wallets.public.GetBalances.Balance.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.offchain_wallets.public);

},{"../validate/validate_pb.js":70,"google-protobuf":3}],70:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],71:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for onchain_inventory
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.onchain_inventory = require('./public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.onchain_inventory.MintClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.onchain_inventory.MintPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.onchain_inventory.MintItem.Request,
 *   !proto.onchain_inventory.MintItem.Response>}
 */
const methodDescriptor_Mint_MintItem = new grpc.web.MethodDescriptor(
  '/onchain_inventory.Mint/MintItem',
  grpc.web.MethodType.UNARY,
  proto.onchain_inventory.MintItem.Request,
  proto.onchain_inventory.MintItem.Response,
  /**
   * @param {!proto.onchain_inventory.MintItem.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.onchain_inventory.MintItem.Response.deserializeBinary
);


/**
 * @param {!proto.onchain_inventory.MintItem.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.onchain_inventory.MintItem.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.onchain_inventory.MintItem.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.onchain_inventory.MintClient.prototype.mintItem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/onchain_inventory.Mint/MintItem',
      request,
      metadata || {},
      methodDescriptor_Mint_MintItem,
      callback);
};


/**
 * @param {!proto.onchain_inventory.MintItem.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.onchain_inventory.MintItem.Response>}
 *     Promise that resolves to the response
 */
proto.onchain_inventory.MintPromiseClient.prototype.mintItem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/onchain_inventory.Mint/MintItem',
      request,
      metadata || {},
      methodDescriptor_Mint_MintItem);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.onchain_inventory.LockedItemsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.onchain_inventory.LockedItemsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.onchain_inventory.Empty,
 *   !proto.onchain_inventory.GetLockedItems.Response>}
 */
const methodDescriptor_LockedItems_GetLockedItems = new grpc.web.MethodDescriptor(
  '/onchain_inventory.LockedItems/GetLockedItems',
  grpc.web.MethodType.UNARY,
  proto.onchain_inventory.Empty,
  proto.onchain_inventory.GetLockedItems.Response,
  /**
   * @param {!proto.onchain_inventory.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.onchain_inventory.GetLockedItems.Response.deserializeBinary
);


/**
 * @param {!proto.onchain_inventory.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.onchain_inventory.GetLockedItems.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.onchain_inventory.GetLockedItems.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.onchain_inventory.LockedItemsClient.prototype.getLockedItems =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/onchain_inventory.LockedItems/GetLockedItems',
      request,
      metadata || {},
      methodDescriptor_LockedItems_GetLockedItems,
      callback);
};


/**
 * @param {!proto.onchain_inventory.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.onchain_inventory.GetLockedItems.Response>}
 *     Promise that resolves to the response
 */
proto.onchain_inventory.LockedItemsPromiseClient.prototype.getLockedItems =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/onchain_inventory.LockedItems/GetLockedItems',
      request,
      metadata || {},
      methodDescriptor_LockedItems_GetLockedItems);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.onchain_inventory.GenesysGoClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.onchain_inventory.GenesysGoPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.onchain_inventory.Empty,
 *   !proto.onchain_inventory.GetToken.Response>}
 */
const methodDescriptor_GenesysGo_GetToken = new grpc.web.MethodDescriptor(
  '/onchain_inventory.GenesysGo/GetToken',
  grpc.web.MethodType.UNARY,
  proto.onchain_inventory.Empty,
  proto.onchain_inventory.GetToken.Response,
  /**
   * @param {!proto.onchain_inventory.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.onchain_inventory.GetToken.Response.deserializeBinary
);


/**
 * @param {!proto.onchain_inventory.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.onchain_inventory.GetToken.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.onchain_inventory.GetToken.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.onchain_inventory.GenesysGoClient.prototype.getToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/onchain_inventory.GenesysGo/GetToken',
      request,
      metadata || {},
      methodDescriptor_GenesysGo_GetToken,
      callback);
};


/**
 * @param {!proto.onchain_inventory.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.onchain_inventory.GetToken.Response>}
 *     Promise that resolves to the response
 */
proto.onchain_inventory.GenesysGoPromiseClient.prototype.getToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/onchain_inventory.GenesysGo/GetToken',
      request,
      metadata || {},
      methodDescriptor_GenesysGo_GetToken);
};


module.exports = proto.onchain_inventory;


},{"./public_pb.js":72,"google-protobuf/google/protobuf/timestamp_pb.js":6,"grpc-web":7}],72:[function(require,module,exports){
// source: public/public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.onchain_inventory.Empty', null, global);
goog.exportSymbol('proto.onchain_inventory.GetLockedItems', null, global);
goog.exportSymbol('proto.onchain_inventory.GetLockedItems.LockedItem', null, global);
goog.exportSymbol('proto.onchain_inventory.GetLockedItems.Request', null, global);
goog.exportSymbol('proto.onchain_inventory.GetLockedItems.Response', null, global);
goog.exportSymbol('proto.onchain_inventory.GetToken', null, global);
goog.exportSymbol('proto.onchain_inventory.GetToken.Response', null, global);
goog.exportSymbol('proto.onchain_inventory.MintItem', null, global);
goog.exportSymbol('proto.onchain_inventory.MintItem.Request', null, global);
goog.exportSymbol('proto.onchain_inventory.MintItem.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.GetLockedItems = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.GetLockedItems, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.GetLockedItems.displayName = 'proto.onchain_inventory.GetLockedItems';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.GetLockedItems.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.GetLockedItems.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.GetLockedItems.Request.displayName = 'proto.onchain_inventory.GetLockedItems.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.GetLockedItems.LockedItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.GetLockedItems.LockedItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.GetLockedItems.LockedItem.displayName = 'proto.onchain_inventory.GetLockedItems.LockedItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.GetLockedItems.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.onchain_inventory.GetLockedItems.Response.repeatedFields_, null);
};
goog.inherits(proto.onchain_inventory.GetLockedItems.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.GetLockedItems.Response.displayName = 'proto.onchain_inventory.GetLockedItems.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.GetToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.GetToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.GetToken.displayName = 'proto.onchain_inventory.GetToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.GetToken.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.GetToken.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.GetToken.Response.displayName = 'proto.onchain_inventory.GetToken.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.Empty.displayName = 'proto.onchain_inventory.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.MintItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.MintItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.MintItem.displayName = 'proto.onchain_inventory.MintItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.MintItem.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.MintItem.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.MintItem.Request.displayName = 'proto.onchain_inventory.MintItem.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.onchain_inventory.MintItem.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.onchain_inventory.MintItem.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.onchain_inventory.MintItem.Response.displayName = 'proto.onchain_inventory.MintItem.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.GetLockedItems.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.GetLockedItems.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.GetLockedItems} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetLockedItems.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.GetLockedItems}
 */
proto.onchain_inventory.GetLockedItems.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.GetLockedItems;
  return proto.onchain_inventory.GetLockedItems.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.GetLockedItems} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.GetLockedItems}
 */
proto.onchain_inventory.GetLockedItems.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.GetLockedItems.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.GetLockedItems.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.GetLockedItems} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetLockedItems.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.GetLockedItems.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.GetLockedItems.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.GetLockedItems.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetLockedItems.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.GetLockedItems.Request}
 */
proto.onchain_inventory.GetLockedItems.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.GetLockedItems.Request;
  return proto.onchain_inventory.GetLockedItems.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.GetLockedItems.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.GetLockedItems.Request}
 */
proto.onchain_inventory.GetLockedItems.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.GetLockedItems.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.GetLockedItems.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.GetLockedItems.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetLockedItems.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.GetLockedItems.LockedItem.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.GetLockedItems.LockedItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.GetLockedItems.LockedItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetLockedItems.LockedItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lockedUntil: (f = msg.getLockedUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.GetLockedItems.LockedItem}
 */
proto.onchain_inventory.GetLockedItems.LockedItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.GetLockedItems.LockedItem;
  return proto.onchain_inventory.GetLockedItems.LockedItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.GetLockedItems.LockedItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.GetLockedItems.LockedItem}
 */
proto.onchain_inventory.GetLockedItems.LockedItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLockedUntil(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.GetLockedItems.LockedItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.GetLockedItems.LockedItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.GetLockedItems.LockedItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetLockedItems.LockedItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLockedUntil();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.onchain_inventory.GetLockedItems.LockedItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.GetLockedItems.LockedItem} returns this
 */
proto.onchain_inventory.GetLockedItems.LockedItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp locked_until = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.onchain_inventory.GetLockedItems.LockedItem.prototype.getLockedUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.onchain_inventory.GetLockedItems.LockedItem} returns this
*/
proto.onchain_inventory.GetLockedItems.LockedItem.prototype.setLockedUntil = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.onchain_inventory.GetLockedItems.LockedItem} returns this
 */
proto.onchain_inventory.GetLockedItems.LockedItem.prototype.clearLockedUntil = function() {
  return this.setLockedUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.onchain_inventory.GetLockedItems.LockedItem.prototype.hasLockedUntil = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.onchain_inventory.GetLockedItems.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.GetLockedItems.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.GetLockedItems.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.GetLockedItems.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetLockedItems.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    lockedItemsList: jspb.Message.toObjectList(msg.getLockedItemsList(),
    proto.onchain_inventory.GetLockedItems.LockedItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.GetLockedItems.Response}
 */
proto.onchain_inventory.GetLockedItems.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.GetLockedItems.Response;
  return proto.onchain_inventory.GetLockedItems.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.GetLockedItems.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.GetLockedItems.Response}
 */
proto.onchain_inventory.GetLockedItems.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.onchain_inventory.GetLockedItems.LockedItem;
      reader.readMessage(value,proto.onchain_inventory.GetLockedItems.LockedItem.deserializeBinaryFromReader);
      msg.addLockedItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.GetLockedItems.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.GetLockedItems.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.GetLockedItems.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetLockedItems.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLockedItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.onchain_inventory.GetLockedItems.LockedItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LockedItem locked_items = 1;
 * @return {!Array<!proto.onchain_inventory.GetLockedItems.LockedItem>}
 */
proto.onchain_inventory.GetLockedItems.Response.prototype.getLockedItemsList = function() {
  return /** @type{!Array<!proto.onchain_inventory.GetLockedItems.LockedItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.onchain_inventory.GetLockedItems.LockedItem, 1));
};


/**
 * @param {!Array<!proto.onchain_inventory.GetLockedItems.LockedItem>} value
 * @return {!proto.onchain_inventory.GetLockedItems.Response} returns this
*/
proto.onchain_inventory.GetLockedItems.Response.prototype.setLockedItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.onchain_inventory.GetLockedItems.LockedItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.onchain_inventory.GetLockedItems.LockedItem}
 */
proto.onchain_inventory.GetLockedItems.Response.prototype.addLockedItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.onchain_inventory.GetLockedItems.LockedItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.onchain_inventory.GetLockedItems.Response} returns this
 */
proto.onchain_inventory.GetLockedItems.Response.prototype.clearLockedItemsList = function() {
  return this.setLockedItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.GetToken.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.GetToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.GetToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetToken.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.GetToken}
 */
proto.onchain_inventory.GetToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.GetToken;
  return proto.onchain_inventory.GetToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.GetToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.GetToken}
 */
proto.onchain_inventory.GetToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.GetToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.GetToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.GetToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.GetToken.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.GetToken.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.GetToken.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetToken.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expiresInSeconds: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.GetToken.Response}
 */
proto.onchain_inventory.GetToken.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.GetToken.Response;
  return proto.onchain_inventory.GetToken.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.GetToken.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.GetToken.Response}
 */
proto.onchain_inventory.GetToken.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresInSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.GetToken.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.GetToken.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.GetToken.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.GetToken.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpiresInSeconds();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.onchain_inventory.GetToken.Response.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.GetToken.Response} returns this
 */
proto.onchain_inventory.GetToken.Response.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 expires_in_seconds = 2;
 * @return {number}
 */
proto.onchain_inventory.GetToken.Response.prototype.getExpiresInSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.onchain_inventory.GetToken.Response} returns this
 */
proto.onchain_inventory.GetToken.Response.prototype.setExpiresInSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.Empty}
 */
proto.onchain_inventory.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.Empty;
  return proto.onchain_inventory.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.Empty}
 */
proto.onchain_inventory.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.MintItem.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.MintItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.MintItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.MintItem.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.MintItem}
 */
proto.onchain_inventory.MintItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.MintItem;
  return proto.onchain_inventory.MintItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.MintItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.MintItem}
 */
proto.onchain_inventory.MintItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.MintItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.MintItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.MintItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.MintItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.MintItem.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.MintItem.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.MintItem.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.MintItem.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.MintItem.Request}
 */
proto.onchain_inventory.MintItem.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.MintItem.Request;
  return proto.onchain_inventory.MintItem.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.MintItem.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.MintItem.Request}
 */
proto.onchain_inventory.MintItem.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.MintItem.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.MintItem.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.MintItem.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.MintItem.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.onchain_inventory.MintItem.Request.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.MintItem.Request} returns this
 */
proto.onchain_inventory.MintItem.Request.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.onchain_inventory.MintItem.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.onchain_inventory.MintItem.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.onchain_inventory.MintItem.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.MintItem.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    destAddr: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fee: jspb.Message.getFieldWithDefault(msg, 2, 0),
    block: jspb.Message.getFieldWithDefault(msg, 3, ""),
    nonce: jspb.Message.getFieldWithDefault(msg, 4, ""),
    signature: jspb.Message.getFieldWithDefault(msg, 5, ""),
    nonceAuth: jspb.Message.getFieldWithDefault(msg, 6, ""),
    message: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.onchain_inventory.MintItem.Response}
 */
proto.onchain_inventory.MintItem.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.onchain_inventory.MintItem.Response;
  return proto.onchain_inventory.MintItem.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.onchain_inventory.MintItem.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.onchain_inventory.MintItem.Response}
 */
proto.onchain_inventory.MintItem.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestAddr(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFee(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlock(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonce(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignature(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonceAuth(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.onchain_inventory.MintItem.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.onchain_inventory.MintItem.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.onchain_inventory.MintItem.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.onchain_inventory.MintItem.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDestAddr();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFee();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBlock();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNonce();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSignature();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNonceAuth();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string dest_addr = 1;
 * @return {string}
 */
proto.onchain_inventory.MintItem.Response.prototype.getDestAddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.MintItem.Response} returns this
 */
proto.onchain_inventory.MintItem.Response.prototype.setDestAddr = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 fee = 2;
 * @return {number}
 */
proto.onchain_inventory.MintItem.Response.prototype.getFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.onchain_inventory.MintItem.Response} returns this
 */
proto.onchain_inventory.MintItem.Response.prototype.setFee = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string block = 3;
 * @return {string}
 */
proto.onchain_inventory.MintItem.Response.prototype.getBlock = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.MintItem.Response} returns this
 */
proto.onchain_inventory.MintItem.Response.prototype.setBlock = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string nonce = 4;
 * @return {string}
 */
proto.onchain_inventory.MintItem.Response.prototype.getNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.MintItem.Response} returns this
 */
proto.onchain_inventory.MintItem.Response.prototype.setNonce = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string signature = 5;
 * @return {string}
 */
proto.onchain_inventory.MintItem.Response.prototype.getSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.MintItem.Response} returns this
 */
proto.onchain_inventory.MintItem.Response.prototype.setSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string nonce_auth = 6;
 * @return {string}
 */
proto.onchain_inventory.MintItem.Response.prototype.getNonceAuth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.MintItem.Response} returns this
 */
proto.onchain_inventory.MintItem.Response.prototype.setNonceAuth = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string message = 7;
 * @return {string}
 */
proto.onchain_inventory.MintItem.Response.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.onchain_inventory.MintItem.Response} returns this
 */
proto.onchain_inventory.MintItem.Response.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


goog.object.extend(exports, proto.onchain_inventory);

},{"google-protobuf":3,"google-protobuf/google/protobuf/timestamp_pb.js":6}],73:[function(require,module,exports){
// source: party.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.party.ClientUpdate', null, global);
goog.exportSymbol('proto.party.Empty', null, global);
goog.exportSymbol('proto.party.Player', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.party.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.Player.displayName = 'proto.party.Player';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.ClientUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.party.ClientUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.ClientUpdate.displayName = 'proto.party.ClientUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.party.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.Empty.displayName = 'proto.party.Empty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.party.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    level: jspb.Message.getFieldWithDefault(msg, 3, 0),
    hat: jspb.Message.getFieldWithDefault(msg, 4, ""),
    characterSkin: jspb.Message.getFieldWithDefault(msg, 5, ""),
    ready: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    clanName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    clanSlug: jspb.Message.getFieldWithDefault(msg, 8, ""),
    isGuest: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    nametail: jspb.Message.getFieldWithDefault(msg, 12, ""),
    clanLegacyId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    isCurrentPlayer: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    isConnected: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    clanId: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.Player}
 */
proto.party.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.Player;
  return proto.party.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.Player}
 */
proto.party.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHat(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCharacterSkin(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReady(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClanName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setClanSlug(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGuest(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setNametail(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setClanLegacyId(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCurrentPlayer(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsConnected(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setClanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHat();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCharacterSkin();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getReady();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getClanName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getClanSlug();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsGuest();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getNametail();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getClanLegacyId();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getIsCurrentPlayer();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getIsConnected();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getClanId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string player_id = 1;
 * @return {string}
 */
proto.party.Player.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.party.Player.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 level = 3;
 * @return {number}
 */
proto.party.Player.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string hat = 4;
 * @return {string}
 */
proto.party.Player.prototype.getHat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setHat = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string character_skin = 5;
 * @return {string}
 */
proto.party.Player.prototype.getCharacterSkin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setCharacterSkin = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool ready = 6;
 * @return {boolean}
 */
proto.party.Player.prototype.getReady = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setReady = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string clan_name = 7;
 * @return {string}
 */
proto.party.Player.prototype.getClanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setClanName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string clan_slug = 8;
 * @return {string}
 */
proto.party.Player.prototype.getClanSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setClanSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool is_guest = 11;
 * @return {boolean}
 */
proto.party.Player.prototype.getIsGuest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setIsGuest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string nametail = 12;
 * @return {string}
 */
proto.party.Player.prototype.getNametail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setNametail = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint64 clan_legacy_id = 13;
 * @return {number}
 */
proto.party.Player.prototype.getClanLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setClanLegacyId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional bool is_current_player = 14;
 * @return {boolean}
 */
proto.party.Player.prototype.getIsCurrentPlayer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setIsCurrentPlayer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool is_connected = 15;
 * @return {boolean}
 */
proto.party.Player.prototype.getIsConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setIsConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string clan_id = 16;
 * @return {string}
 */
proto.party.Player.prototype.getClanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.Player} returns this
 */
proto.party.Player.prototype.setClanId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.ClientUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.party.ClientUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.ClientUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.ClientUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    payload: msg.getPayload_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.ClientUpdate}
 */
proto.party.ClientUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.ClientUpdate;
  return proto.party.ClientUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.ClientUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.ClientUpdate}
 */
proto.party.ClientUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.ClientUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.ClientUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.ClientUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.ClientUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPayload_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.party.ClientUpdate.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.ClientUpdate} returns this
 */
proto.party.ClientUpdate.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes payload = 2;
 * @return {string}
 */
proto.party.ClientUpdate.prototype.getPayload = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes payload = 2;
 * This is a type-conversion wrapper around `getPayload()`
 * @return {string}
 */
proto.party.ClientUpdate.prototype.getPayload_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPayload()));
};


/**
 * optional bytes payload = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPayload()`
 * @return {!Uint8Array}
 */
proto.party.ClientUpdate.prototype.getPayload_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPayload()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.party.ClientUpdate} returns this
 */
proto.party.ClientUpdate.prototype.setPayload = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.party.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.Empty}
 */
proto.party.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.Empty;
  return proto.party.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.Empty}
 */
proto.party.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.party);

},{"google-protobuf":3}],74:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for party
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var party_shared_pb = require('../party.shared_pb.js')
const proto = {};
proto.party = require('./party.public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.party.PartyClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.party.PartyPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.party.Empty,
 *   !proto.party.PartyUpdate>}
 */
const methodDescriptor_Party_GetActiveParty = new grpc.web.MethodDescriptor(
  '/party.Party/GetActiveParty',
  grpc.web.MethodType.UNARY,
  party_shared_pb.Empty,
  proto.party.PartyUpdate,
  /**
   * @param {!proto.party.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.party.PartyUpdate.deserializeBinary
);


/**
 * @param {!proto.party.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.party.PartyUpdate)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.party.PartyUpdate>|undefined}
 *     The XHR Node Readable Stream
 */
proto.party.PartyClient.prototype.getActiveParty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/party.Party/GetActiveParty',
      request,
      metadata || {},
      methodDescriptor_Party_GetActiveParty,
      callback);
};


/**
 * @param {!proto.party.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.party.PartyUpdate>}
 *     Promise that resolves to the response
 */
proto.party.PartyPromiseClient.prototype.getActiveParty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/party.Party/GetActiveParty',
      request,
      metadata || {},
      methodDescriptor_Party_GetActiveParty);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.party.PartyInviteRequest,
 *   !proto.party.Empty>}
 */
const methodDescriptor_Party_InviteToParty = new grpc.web.MethodDescriptor(
  '/party.Party/InviteToParty',
  grpc.web.MethodType.UNARY,
  proto.party.PartyInviteRequest,
  party_shared_pb.Empty,
  /**
   * @param {!proto.party.PartyInviteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  party_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.party.PartyInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.party.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.party.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.party.PartyClient.prototype.inviteToParty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/party.Party/InviteToParty',
      request,
      metadata || {},
      methodDescriptor_Party_InviteToParty,
      callback);
};


/**
 * @param {!proto.party.PartyInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.party.Empty>}
 *     Promise that resolves to the response
 */
proto.party.PartyPromiseClient.prototype.inviteToParty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/party.Party/InviteToParty',
      request,
      metadata || {},
      methodDescriptor_Party_InviteToParty);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.party.PartyJoinRequest,
 *   !proto.party.Empty>}
 */
const methodDescriptor_Party_JoinParty = new grpc.web.MethodDescriptor(
  '/party.Party/JoinParty',
  grpc.web.MethodType.UNARY,
  proto.party.PartyJoinRequest,
  party_shared_pb.Empty,
  /**
   * @param {!proto.party.PartyJoinRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  party_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.party.PartyJoinRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.party.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.party.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.party.PartyClient.prototype.joinParty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/party.Party/JoinParty',
      request,
      metadata || {},
      methodDescriptor_Party_JoinParty,
      callback);
};


/**
 * @param {!proto.party.PartyJoinRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.party.Empty>}
 *     Promise that resolves to the response
 */
proto.party.PartyPromiseClient.prototype.joinParty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/party.Party/JoinParty',
      request,
      metadata || {},
      methodDescriptor_Party_JoinParty);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.party.Empty,
 *   !proto.party.Empty>}
 */
const methodDescriptor_Party_LeaveParty = new grpc.web.MethodDescriptor(
  '/party.Party/LeaveParty',
  grpc.web.MethodType.UNARY,
  party_shared_pb.Empty,
  party_shared_pb.Empty,
  /**
   * @param {!proto.party.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  party_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.party.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.party.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.party.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.party.PartyClient.prototype.leaveParty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/party.Party/LeaveParty',
      request,
      metadata || {},
      methodDescriptor_Party_LeaveParty,
      callback);
};


/**
 * @param {!proto.party.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.party.Empty>}
 *     Promise that resolves to the response
 */
proto.party.PartyPromiseClient.prototype.leaveParty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/party.Party/LeaveParty',
      request,
      metadata || {},
      methodDescriptor_Party_LeaveParty);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.party.KickPlayerRequest,
 *   !proto.party.Empty>}
 */
const methodDescriptor_Party_KickPlayer = new grpc.web.MethodDescriptor(
  '/party.Party/KickPlayer',
  grpc.web.MethodType.UNARY,
  proto.party.KickPlayerRequest,
  party_shared_pb.Empty,
  /**
   * @param {!proto.party.KickPlayerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  party_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.party.KickPlayerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.party.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.party.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.party.PartyClient.prototype.kickPlayer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/party.Party/KickPlayer',
      request,
      metadata || {},
      methodDescriptor_Party_KickPlayer,
      callback);
};


/**
 * @param {!proto.party.KickPlayerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.party.Empty>}
 *     Promise that resolves to the response
 */
proto.party.PartyPromiseClient.prototype.kickPlayer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/party.Party/KickPlayer',
      request,
      metadata || {},
      methodDescriptor_Party_KickPlayer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.party.UpdatePartyInfo,
 *   !proto.party.Empty>}
 */
const methodDescriptor_Party_UpdateParty = new grpc.web.MethodDescriptor(
  '/party.Party/UpdateParty',
  grpc.web.MethodType.UNARY,
  proto.party.UpdatePartyInfo,
  party_shared_pb.Empty,
  /**
   * @param {!proto.party.UpdatePartyInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  party_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.party.UpdatePartyInfo} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.party.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.party.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.party.PartyClient.prototype.updateParty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/party.Party/UpdateParty',
      request,
      metadata || {},
      methodDescriptor_Party_UpdateParty,
      callback);
};


/**
 * @param {!proto.party.UpdatePartyInfo} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.party.Empty>}
 *     Promise that resolves to the response
 */
proto.party.PartyPromiseClient.prototype.updateParty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/party.Party/UpdateParty',
      request,
      metadata || {},
      methodDescriptor_Party_UpdateParty);
};


module.exports = proto.party;


},{"../party.shared_pb.js":73,"./party.public_pb.js":75,"grpc-web":7}],75:[function(require,module,exports){
// source: web/party.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var party_shared_pb = require('../party.shared_pb.js');
goog.object.extend(proto, party_shared_pb);
goog.exportSymbol('proto.party.KickPlayerRequest', null, global);
goog.exportSymbol('proto.party.PartyInviteRequest', null, global);
goog.exportSymbol('proto.party.PartyInviteUpdate', null, global);
goog.exportSymbol('proto.party.PartyJoinRequest', null, global);
goog.exportSymbol('proto.party.PartyUpdate', null, global);
goog.exportSymbol('proto.party.UpdatePartyInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.PartyJoinRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.party.PartyJoinRequest.repeatedFields_, null);
};
goog.inherits(proto.party.PartyJoinRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.PartyJoinRequest.displayName = 'proto.party.PartyJoinRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.UpdatePartyInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.party.UpdatePartyInfo.repeatedFields_, null);
};
goog.inherits(proto.party.UpdatePartyInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.UpdatePartyInfo.displayName = 'proto.party.UpdatePartyInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.PartyUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.party.PartyUpdate.repeatedFields_, null);
};
goog.inherits(proto.party.PartyUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.PartyUpdate.displayName = 'proto.party.PartyUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.PartyInviteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.party.PartyInviteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.PartyInviteRequest.displayName = 'proto.party.PartyInviteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.PartyInviteUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.party.PartyInviteUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.PartyInviteUpdate.displayName = 'proto.party.PartyInviteUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.party.KickPlayerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.party.KickPlayerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.party.KickPlayerRequest.displayName = 'proto.party.KickPlayerRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.party.PartyJoinRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.PartyJoinRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.party.PartyJoinRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.PartyJoinRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.PartyJoinRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    partyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    region: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gameModesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    characterSkin: jspb.Message.getFieldWithDefault(msg, 5, ""),
    hat: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.PartyJoinRequest}
 */
proto.party.PartyJoinRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.PartyJoinRequest;
  return proto.party.PartyJoinRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.PartyJoinRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.PartyJoinRequest}
 */
proto.party.PartyJoinRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addGameModes(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCharacterSkin(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.PartyJoinRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.PartyJoinRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.PartyJoinRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.PartyJoinRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGameModesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getCharacterSkin();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHat();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string party_id = 1;
 * @return {string}
 */
proto.party.PartyJoinRequest.prototype.getPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyJoinRequest} returns this
 */
proto.party.PartyJoinRequest.prototype.setPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string region = 2;
 * @return {string}
 */
proto.party.PartyJoinRequest.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyJoinRequest} returns this
 */
proto.party.PartyJoinRequest.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string game_modes = 4;
 * @return {!Array<string>}
 */
proto.party.PartyJoinRequest.prototype.getGameModesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.party.PartyJoinRequest} returns this
 */
proto.party.PartyJoinRequest.prototype.setGameModesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.party.PartyJoinRequest} returns this
 */
proto.party.PartyJoinRequest.prototype.addGameModes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.party.PartyJoinRequest} returns this
 */
proto.party.PartyJoinRequest.prototype.clearGameModesList = function() {
  return this.setGameModesList([]);
};


/**
 * optional string character_skin = 5;
 * @return {string}
 */
proto.party.PartyJoinRequest.prototype.getCharacterSkin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyJoinRequest} returns this
 */
proto.party.PartyJoinRequest.prototype.setCharacterSkin = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string hat = 6;
 * @return {string}
 */
proto.party.PartyJoinRequest.prototype.getHat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyJoinRequest} returns this
 */
proto.party.PartyJoinRequest.prototype.setHat = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.party.UpdatePartyInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.UpdatePartyInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.party.UpdatePartyInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.UpdatePartyInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.UpdatePartyInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    partyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    region: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gameModesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    playerReady: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    characterSkin: jspb.Message.getFieldWithDefault(msg, 6, ""),
    hat: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.UpdatePartyInfo}
 */
proto.party.UpdatePartyInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.UpdatePartyInfo;
  return proto.party.UpdatePartyInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.UpdatePartyInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.UpdatePartyInfo}
 */
proto.party.UpdatePartyInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addGameModes(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlayerReady(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCharacterSkin(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setHat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.UpdatePartyInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.UpdatePartyInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.UpdatePartyInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.UpdatePartyInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGameModesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getPlayerReady();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCharacterSkin();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getHat();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string party_id = 1;
 * @return {string}
 */
proto.party.UpdatePartyInfo.prototype.getPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.UpdatePartyInfo} returns this
 */
proto.party.UpdatePartyInfo.prototype.setPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string region = 2;
 * @return {string}
 */
proto.party.UpdatePartyInfo.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.UpdatePartyInfo} returns this
 */
proto.party.UpdatePartyInfo.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string game_modes = 3;
 * @return {!Array<string>}
 */
proto.party.UpdatePartyInfo.prototype.getGameModesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.party.UpdatePartyInfo} returns this
 */
proto.party.UpdatePartyInfo.prototype.setGameModesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.party.UpdatePartyInfo} returns this
 */
proto.party.UpdatePartyInfo.prototype.addGameModes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.party.UpdatePartyInfo} returns this
 */
proto.party.UpdatePartyInfo.prototype.clearGameModesList = function() {
  return this.setGameModesList([]);
};


/**
 * optional bool player_ready = 5;
 * @return {boolean}
 */
proto.party.UpdatePartyInfo.prototype.getPlayerReady = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.party.UpdatePartyInfo} returns this
 */
proto.party.UpdatePartyInfo.prototype.setPlayerReady = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string character_skin = 6;
 * @return {string}
 */
proto.party.UpdatePartyInfo.prototype.getCharacterSkin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.UpdatePartyInfo} returns this
 */
proto.party.UpdatePartyInfo.prototype.setCharacterSkin = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string hat = 7;
 * @return {string}
 */
proto.party.UpdatePartyInfo.prototype.getHat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.UpdatePartyInfo} returns this
 */
proto.party.UpdatePartyInfo.prototype.setHat = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.party.PartyUpdate.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.PartyUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.party.PartyUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.PartyUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.PartyUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    partyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    leaderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    playersList: jspb.Message.toObjectList(msg.getPlayersList(),
    party_shared_pb.Player.toObject, includeInstance),
    region: jspb.Message.getFieldWithDefault(msg, 4, ""),
    gameModesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    isLeader: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.PartyUpdate}
 */
proto.party.PartyUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.PartyUpdate;
  return proto.party.PartyUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.PartyUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.PartyUpdate}
 */
proto.party.PartyUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeaderId(value);
      break;
    case 3:
      var value = new party_shared_pb.Player;
      reader.readMessage(value,party_shared_pb.Player.deserializeBinaryFromReader);
      msg.addPlayers(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addGameModes(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLeader(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.PartyUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.PartyUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.PartyUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.PartyUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLeaderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlayersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      party_shared_pb.Player.serializeBinaryToWriter
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGameModesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getIsLeader();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string party_id = 1;
 * @return {string}
 */
proto.party.PartyUpdate.prototype.getPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyUpdate} returns this
 */
proto.party.PartyUpdate.prototype.setPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string leader_id = 2;
 * @return {string}
 */
proto.party.PartyUpdate.prototype.getLeaderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyUpdate} returns this
 */
proto.party.PartyUpdate.prototype.setLeaderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Player players = 3;
 * @return {!Array<!proto.party.Player>}
 */
proto.party.PartyUpdate.prototype.getPlayersList = function() {
  return /** @type{!Array<!proto.party.Player>} */ (
    jspb.Message.getRepeatedWrapperField(this, party_shared_pb.Player, 3));
};


/**
 * @param {!Array<!proto.party.Player>} value
 * @return {!proto.party.PartyUpdate} returns this
*/
proto.party.PartyUpdate.prototype.setPlayersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.party.Player=} opt_value
 * @param {number=} opt_index
 * @return {!proto.party.Player}
 */
proto.party.PartyUpdate.prototype.addPlayers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.party.Player, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.party.PartyUpdate} returns this
 */
proto.party.PartyUpdate.prototype.clearPlayersList = function() {
  return this.setPlayersList([]);
};


/**
 * optional string region = 4;
 * @return {string}
 */
proto.party.PartyUpdate.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyUpdate} returns this
 */
proto.party.PartyUpdate.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string game_modes = 5;
 * @return {!Array<string>}
 */
proto.party.PartyUpdate.prototype.getGameModesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.party.PartyUpdate} returns this
 */
proto.party.PartyUpdate.prototype.setGameModesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.party.PartyUpdate} returns this
 */
proto.party.PartyUpdate.prototype.addGameModes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.party.PartyUpdate} returns this
 */
proto.party.PartyUpdate.prototype.clearGameModesList = function() {
  return this.setGameModesList([]);
};


/**
 * optional bool is_leader = 6;
 * @return {boolean}
 */
proto.party.PartyUpdate.prototype.getIsLeader = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.party.PartyUpdate} returns this
 */
proto.party.PartyUpdate.prototype.setIsLeader = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.PartyInviteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.party.PartyInviteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.PartyInviteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.PartyInviteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiverPlayerId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.PartyInviteRequest}
 */
proto.party.PartyInviteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.PartyInviteRequest;
  return proto.party.PartyInviteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.PartyInviteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.PartyInviteRequest}
 */
proto.party.PartyInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiverPlayerId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.PartyInviteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.PartyInviteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.PartyInviteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.PartyInviteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiverPlayerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string receiver_player_id = 2;
 * @return {string}
 */
proto.party.PartyInviteRequest.prototype.getReceiverPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyInviteRequest} returns this
 */
proto.party.PartyInviteRequest.prototype.setReceiverPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 timestamp = 4;
 * @return {number}
 */
proto.party.PartyInviteRequest.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.party.PartyInviteRequest} returns this
 */
proto.party.PartyInviteRequest.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.PartyInviteUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.party.PartyInviteUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.PartyInviteUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.PartyInviteUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    sender: (f = msg.getSender()) && party_shared_pb.Player.toObject(includeInstance, f),
    partyId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.PartyInviteUpdate}
 */
proto.party.PartyInviteUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.PartyInviteUpdate;
  return proto.party.PartyInviteUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.PartyInviteUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.PartyInviteUpdate}
 */
proto.party.PartyInviteUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new party_shared_pb.Player;
      reader.readMessage(value,party_shared_pb.Player.deserializeBinaryFromReader);
      msg.setSender(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartyId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.PartyInviteUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.PartyInviteUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.PartyInviteUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.PartyInviteUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSender();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      party_shared_pb.Player.serializeBinaryToWriter
    );
  }
  f = message.getPartyId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional Player sender = 1;
 * @return {?proto.party.Player}
 */
proto.party.PartyInviteUpdate.prototype.getSender = function() {
  return /** @type{?proto.party.Player} */ (
    jspb.Message.getWrapperField(this, party_shared_pb.Player, 1));
};


/**
 * @param {?proto.party.Player|undefined} value
 * @return {!proto.party.PartyInviteUpdate} returns this
*/
proto.party.PartyInviteUpdate.prototype.setSender = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.party.PartyInviteUpdate} returns this
 */
proto.party.PartyInviteUpdate.prototype.clearSender = function() {
  return this.setSender(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.party.PartyInviteUpdate.prototype.hasSender = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string party_id = 2;
 * @return {string}
 */
proto.party.PartyInviteUpdate.prototype.getPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.PartyInviteUpdate} returns this
 */
proto.party.PartyInviteUpdate.prototype.setPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 timestamp = 3;
 * @return {number}
 */
proto.party.PartyInviteUpdate.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.party.PartyInviteUpdate} returns this
 */
proto.party.PartyInviteUpdate.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.party.KickPlayerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.party.KickPlayerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.party.KickPlayerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.KickPlayerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.party.KickPlayerRequest}
 */
proto.party.KickPlayerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.party.KickPlayerRequest;
  return proto.party.KickPlayerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.party.KickPlayerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.party.KickPlayerRequest}
 */
proto.party.KickPlayerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.party.KickPlayerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.party.KickPlayerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.party.KickPlayerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.party.KickPlayerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string player_id = 2;
 * @return {string}
 */
proto.party.KickPlayerRequest.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.party.KickPlayerRequest} returns this
 */
proto.party.KickPlayerRequest.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.party);

},{"../party.shared_pb.js":73,"google-protobuf":3}],76:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for pb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var friends_pb = require('./friends_pb.js')

var mm_facade_pb = require('./mm_facade_pb.js')

var player_pb = require('./player_pb.js')

var util_pb = require('./util_pb.js')
const proto = {};
proto.pb = require('./faraway_rpc_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.FarawayRPCClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.FarawayRPCPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Empty,
 *   !proto.pb.ClientUpdate>}
 */
const methodDescriptor_FarawayRPC_Subscribe = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/Subscribe',
  grpc.web.MethodType.SERVER_STREAMING,
  util_pb.Empty,
  proto.pb.ClientUpdate,
  /**
   * @param {!proto.pb.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.ClientUpdate.deserializeBinary
);


/**
 * @param {!proto.pb.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.ClientUpdate>}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.FarawayRPC/Subscribe',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_Subscribe);
};


/**
 * @param {!proto.pb.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.ClientUpdate>}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCPromiseClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.FarawayRPC/Subscribe',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_Subscribe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.GetFriendsRequest,
 *   !proto.pb.GetFriendsResponse>}
 */
const methodDescriptor_FarawayRPC_GetFriends = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/GetFriends',
  grpc.web.MethodType.UNARY,
  friends_pb.GetFriendsRequest,
  friends_pb.GetFriendsResponse,
  /**
   * @param {!proto.pb.GetFriendsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  friends_pb.GetFriendsResponse.deserializeBinary
);


/**
 * @param {!proto.pb.GetFriendsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.GetFriendsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.GetFriendsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.getFriends =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/GetFriends',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_GetFriends,
      callback);
};


/**
 * @param {!proto.pb.GetFriendsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.GetFriendsResponse>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.getFriends =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/GetFriends',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_GetFriends);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.GetFriendsStatusesRequest,
 *   !proto.pb.GetFriendsStatusesResponse>}
 */
const methodDescriptor_FarawayRPC_GetFriendsStatuses = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/GetFriendsStatuses',
  grpc.web.MethodType.UNARY,
  friends_pb.GetFriendsStatusesRequest,
  friends_pb.GetFriendsStatusesResponse,
  /**
   * @param {!proto.pb.GetFriendsStatusesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  friends_pb.GetFriendsStatusesResponse.deserializeBinary
);


/**
 * @param {!proto.pb.GetFriendsStatusesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.GetFriendsStatusesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.GetFriendsStatusesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.getFriendsStatuses =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/GetFriendsStatuses',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_GetFriendsStatuses,
      callback);
};


/**
 * @param {!proto.pb.GetFriendsStatusesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.GetFriendsStatusesResponse>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.getFriendsStatuses =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/GetFriendsStatuses',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_GetFriendsStatuses);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.MatchmakerEntryInfo,
 *   !proto.pb.Empty>}
 */
const methodDescriptor_FarawayRPC_FindMatch = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/FindMatch',
  grpc.web.MethodType.UNARY,
  mm_facade_pb.MatchmakerEntryInfo,
  util_pb.Empty,
  /**
   * @param {!proto.pb.MatchmakerEntryInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pb.MatchmakerEntryInfo} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.findMatch =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/FindMatch',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_FindMatch,
      callback);
};


/**
 * @param {!proto.pb.MatchmakerEntryInfo} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Empty>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.findMatch =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/FindMatch',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_FindMatch);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.FindMatchCancelRequest,
 *   !proto.pb.Empty>}
 */
const methodDescriptor_FarawayRPC_CancelMatch = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/CancelMatch',
  grpc.web.MethodType.UNARY,
  mm_facade_pb.FindMatchCancelRequest,
  util_pb.Empty,
  /**
   * @param {!proto.pb.FindMatchCancelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pb.FindMatchCancelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.cancelMatch =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/CancelMatch',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_CancelMatch,
      callback);
};


/**
 * @param {!proto.pb.FindMatchCancelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Empty>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.cancelMatch =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/CancelMatch',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_CancelMatch);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.UpdateStatusRequest,
 *   !proto.pb.Empty>}
 */
const methodDescriptor_FarawayRPC_UpdateStatus = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/UpdateStatus',
  grpc.web.MethodType.UNARY,
  friends_pb.UpdateStatusRequest,
  util_pb.Empty,
  /**
   * @param {!proto.pb.UpdateStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pb.UpdateStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.updateStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/UpdateStatus',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_UpdateStatus,
      callback);
};


/**
 * @param {!proto.pb.UpdateStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Empty>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.updateStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/UpdateStatus',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_UpdateStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.BroadcastClientUpdateRequest,
 *   !proto.pb.Empty>}
 */
const methodDescriptor_FarawayRPC_BroadcastClientUpdate = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/BroadcastClientUpdate',
  grpc.web.MethodType.UNARY,
  proto.pb.BroadcastClientUpdateRequest,
  util_pb.Empty,
  /**
   * @param {!proto.pb.BroadcastClientUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pb.BroadcastClientUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.broadcastClientUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/BroadcastClientUpdate',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_BroadcastClientUpdate,
      callback);
};


/**
 * @param {!proto.pb.BroadcastClientUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Empty>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.broadcastClientUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/BroadcastClientUpdate',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_BroadcastClientUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.PlayerDisconnectedRequest,
 *   !proto.pb.Empty>}
 */
const methodDescriptor_FarawayRPC_PlayerDisconnected = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/PlayerDisconnected',
  grpc.web.MethodType.UNARY,
  player_pb.PlayerDisconnectedRequest,
  util_pb.Empty,
  /**
   * @param {!proto.pb.PlayerDisconnectedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pb.PlayerDisconnectedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.playerDisconnected =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/PlayerDisconnected',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_PlayerDisconnected,
      callback);
};


/**
 * @param {!proto.pb.PlayerDisconnectedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Empty>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.playerDisconnected =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/PlayerDisconnected',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_PlayerDisconnected);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.KillPlayerConnectionRequest,
 *   !proto.pb.Empty>}
 */
const methodDescriptor_FarawayRPC_KillPlayerConnection = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/KillPlayerConnection',
  grpc.web.MethodType.UNARY,
  proto.pb.KillPlayerConnectionRequest,
  util_pb.Empty,
  /**
   * @param {!proto.pb.KillPlayerConnectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pb.KillPlayerConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.killPlayerConnection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/KillPlayerConnection',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_KillPlayerConnection,
      callback);
};


/**
 * @param {!proto.pb.KillPlayerConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Empty>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.killPlayerConnection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/KillPlayerConnection',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_KillPlayerConnection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.HasPlayerConnectionRequest,
 *   !proto.pb.HasPlayerConnectionResponse>}
 */
const methodDescriptor_FarawayRPC_HasPlayerConnection = new grpc.web.MethodDescriptor(
  '/pb.FarawayRPC/HasPlayerConnection',
  grpc.web.MethodType.UNARY,
  proto.pb.HasPlayerConnectionRequest,
  proto.pb.HasPlayerConnectionResponse,
  /**
   * @param {!proto.pb.HasPlayerConnectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pb.HasPlayerConnectionResponse.deserializeBinary
);


/**
 * @param {!proto.pb.HasPlayerConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.HasPlayerConnectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.HasPlayerConnectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.FarawayRPCClient.prototype.hasPlayerConnection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.FarawayRPC/HasPlayerConnection',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_HasPlayerConnection,
      callback);
};


/**
 * @param {!proto.pb.HasPlayerConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.HasPlayerConnectionResponse>}
 *     Promise that resolves to the response
 */
proto.pb.FarawayRPCPromiseClient.prototype.hasPlayerConnection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.FarawayRPC/HasPlayerConnection',
      request,
      metadata || {},
      methodDescriptor_FarawayRPC_HasPlayerConnection);
};


module.exports = proto.pb;


},{"./faraway_rpc_pb.js":77,"./friends_pb.js":78,"./mm_facade_pb.js":79,"./player_pb.js":80,"./util_pb.js":81,"grpc-web":7}],77:[function(require,module,exports){
// source: faraway_rpc.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var friends_pb = require('./friends_pb.js');
goog.object.extend(proto, friends_pb);
var mm_facade_pb = require('./mm_facade_pb.js');
goog.object.extend(proto, mm_facade_pb);
var player_pb = require('./player_pb.js');
goog.object.extend(proto, player_pb);
var util_pb = require('./util_pb.js');
goog.object.extend(proto, util_pb);
goog.exportSymbol('proto.pb.BroadcastClientUpdateRequest', null, global);
goog.exportSymbol('proto.pb.ClientConnectionUnsubscribed', null, global);
goog.exportSymbol('proto.pb.ClientID', null, global);
goog.exportSymbol('proto.pb.ClientUpdate', null, global);
goog.exportSymbol('proto.pb.HasPlayerConnectionRequest', null, global);
goog.exportSymbol('proto.pb.HasPlayerConnectionResponse', null, global);
goog.exportSymbol('proto.pb.HeartBeat', null, global);
goog.exportSymbol('proto.pb.KillPlayerConnectionRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.ClientID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.ClientID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.ClientID.displayName = 'proto.pb.ClientID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.ClientUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.ClientUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.ClientUpdate.displayName = 'proto.pb.ClientUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.BroadcastClientUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.BroadcastClientUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.BroadcastClientUpdateRequest.displayName = 'proto.pb.BroadcastClientUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.KillPlayerConnectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.KillPlayerConnectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.KillPlayerConnectionRequest.displayName = 'proto.pb.KillPlayerConnectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.ClientConnectionUnsubscribed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.ClientConnectionUnsubscribed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.ClientConnectionUnsubscribed.displayName = 'proto.pb.ClientConnectionUnsubscribed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.HeartBeat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.HeartBeat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.HeartBeat.displayName = 'proto.pb.HeartBeat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.HasPlayerConnectionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.HasPlayerConnectionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.HasPlayerConnectionRequest.displayName = 'proto.pb.HasPlayerConnectionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.HasPlayerConnectionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.HasPlayerConnectionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.HasPlayerConnectionResponse.displayName = 'proto.pb.HasPlayerConnectionResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.ClientID.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.ClientID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.ClientID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.ClientID.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.ClientID}
 */
proto.pb.ClientID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.ClientID;
  return proto.pb.ClientID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.ClientID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.ClientID}
 */
proto.pb.ClientID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.ClientID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.ClientID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.ClientID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.ClientID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pb.ClientID.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ClientID} returns this
 */
proto.pb.ClientID.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.ClientUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.ClientUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.ClientUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.ClientUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    payload: msg.getPayload_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.ClientUpdate}
 */
proto.pb.ClientUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.ClientUpdate;
  return proto.pb.ClientUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.ClientUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.ClientUpdate}
 */
proto.pb.ClientUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.ClientUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.ClientUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.ClientUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.ClientUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPayload_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.pb.ClientUpdate.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ClientUpdate} returns this
 */
proto.pb.ClientUpdate.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes payload = 2;
 * @return {string}
 */
proto.pb.ClientUpdate.prototype.getPayload = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes payload = 2;
 * This is a type-conversion wrapper around `getPayload()`
 * @return {string}
 */
proto.pb.ClientUpdate.prototype.getPayload_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPayload()));
};


/**
 * optional bytes payload = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPayload()`
 * @return {!Uint8Array}
 */
proto.pb.ClientUpdate.prototype.getPayload_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPayload()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pb.ClientUpdate} returns this
 */
proto.pb.ClientUpdate.prototype.setPayload = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.BroadcastClientUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.BroadcastClientUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.BroadcastClientUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.BroadcastClientUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    update: (f = msg.getUpdate()) && proto.pb.ClientUpdate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.BroadcastClientUpdateRequest}
 */
proto.pb.BroadcastClientUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.BroadcastClientUpdateRequest;
  return proto.pb.BroadcastClientUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.BroadcastClientUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.BroadcastClientUpdateRequest}
 */
proto.pb.BroadcastClientUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    case 2:
      var value = new proto.pb.ClientUpdate;
      reader.readMessage(value,proto.pb.ClientUpdate.deserializeBinaryFromReader);
      msg.setUpdate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.BroadcastClientUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.BroadcastClientUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.BroadcastClientUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.BroadcastClientUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pb.ClientUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * optional string player_id = 1;
 * @return {string}
 */
proto.pb.BroadcastClientUpdateRequest.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.BroadcastClientUpdateRequest} returns this
 */
proto.pb.BroadcastClientUpdateRequest.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ClientUpdate update = 2;
 * @return {?proto.pb.ClientUpdate}
 */
proto.pb.BroadcastClientUpdateRequest.prototype.getUpdate = function() {
  return /** @type{?proto.pb.ClientUpdate} */ (
    jspb.Message.getWrapperField(this, proto.pb.ClientUpdate, 2));
};


/**
 * @param {?proto.pb.ClientUpdate|undefined} value
 * @return {!proto.pb.BroadcastClientUpdateRequest} returns this
*/
proto.pb.BroadcastClientUpdateRequest.prototype.setUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.BroadcastClientUpdateRequest} returns this
 */
proto.pb.BroadcastClientUpdateRequest.prototype.clearUpdate = function() {
  return this.setUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.BroadcastClientUpdateRequest.prototype.hasUpdate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.KillPlayerConnectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.KillPlayerConnectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.KillPlayerConnectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.KillPlayerConnectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.KillPlayerConnectionRequest}
 */
proto.pb.KillPlayerConnectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.KillPlayerConnectionRequest;
  return proto.pb.KillPlayerConnectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.KillPlayerConnectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.KillPlayerConnectionRequest}
 */
proto.pb.KillPlayerConnectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.KillPlayerConnectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.KillPlayerConnectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.KillPlayerConnectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.KillPlayerConnectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string player_id = 1;
 * @return {string}
 */
proto.pb.KillPlayerConnectionRequest.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.KillPlayerConnectionRequest} returns this
 */
proto.pb.KillPlayerConnectionRequest.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.ClientConnectionUnsubscribed.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.ClientConnectionUnsubscribed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.ClientConnectionUnsubscribed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.ClientConnectionUnsubscribed.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.ClientConnectionUnsubscribed}
 */
proto.pb.ClientConnectionUnsubscribed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.ClientConnectionUnsubscribed;
  return proto.pb.ClientConnectionUnsubscribed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.ClientConnectionUnsubscribed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.ClientConnectionUnsubscribed}
 */
proto.pb.ClientConnectionUnsubscribed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.ClientConnectionUnsubscribed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.ClientConnectionUnsubscribed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.ClientConnectionUnsubscribed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.ClientConnectionUnsubscribed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pb.ClientConnectionUnsubscribed.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ClientConnectionUnsubscribed} returns this
 */
proto.pb.ClientConnectionUnsubscribed.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.HeartBeat.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.HeartBeat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.HeartBeat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.HeartBeat.toObject = function(includeInstance, msg) {
  var f, obj = {
    interval: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.HeartBeat}
 */
proto.pb.HeartBeat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.HeartBeat;
  return proto.pb.HeartBeat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.HeartBeat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.HeartBeat}
 */
proto.pb.HeartBeat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInterval(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.HeartBeat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.HeartBeat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.HeartBeat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.HeartBeat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInterval();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 interval = 1;
 * @return {number}
 */
proto.pb.HeartBeat.prototype.getInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.HeartBeat} returns this
 */
proto.pb.HeartBeat.prototype.setInterval = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.HasPlayerConnectionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.HasPlayerConnectionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.HasPlayerConnectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.HasPlayerConnectionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.HasPlayerConnectionRequest}
 */
proto.pb.HasPlayerConnectionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.HasPlayerConnectionRequest;
  return proto.pb.HasPlayerConnectionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.HasPlayerConnectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.HasPlayerConnectionRequest}
 */
proto.pb.HasPlayerConnectionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.HasPlayerConnectionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.HasPlayerConnectionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.HasPlayerConnectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.HasPlayerConnectionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string player_id = 1;
 * @return {string}
 */
proto.pb.HasPlayerConnectionRequest.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.HasPlayerConnectionRequest} returns this
 */
proto.pb.HasPlayerConnectionRequest.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.HasPlayerConnectionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.HasPlayerConnectionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.HasPlayerConnectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.HasPlayerConnectionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hasPlayerConnection: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.HasPlayerConnectionResponse}
 */
proto.pb.HasPlayerConnectionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.HasPlayerConnectionResponse;
  return proto.pb.HasPlayerConnectionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.HasPlayerConnectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.HasPlayerConnectionResponse}
 */
proto.pb.HasPlayerConnectionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasPlayerConnection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.HasPlayerConnectionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.HasPlayerConnectionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.HasPlayerConnectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.HasPlayerConnectionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasPlayerConnection();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool has_player_connection = 1;
 * @return {boolean}
 */
proto.pb.HasPlayerConnectionResponse.prototype.getHasPlayerConnection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.HasPlayerConnectionResponse} returns this
 */
proto.pb.HasPlayerConnectionResponse.prototype.setHasPlayerConnection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


goog.object.extend(exports, proto.pb);

},{"./friends_pb.js":78,"./mm_facade_pb.js":79,"./player_pb.js":80,"./util_pb.js":81,"google-protobuf":3}],78:[function(require,module,exports){
// source: friends.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var player_pb = require('./player_pb.js');
goog.object.extend(proto, player_pb);
goog.exportSymbol('proto.pb.Friend', null, global);
goog.exportSymbol('proto.pb.FriendStatus', null, global);
goog.exportSymbol('proto.pb.FriendsUpdate', null, global);
goog.exportSymbol('proto.pb.GetFriendsRequest', null, global);
goog.exportSymbol('proto.pb.GetFriendsResponse', null, global);
goog.exportSymbol('proto.pb.GetFriendsStatusesRequest', null, global);
goog.exportSymbol('proto.pb.GetFriendsStatusesResponse', null, global);
goog.exportSymbol('proto.pb.UpdateStatusRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.GetFriendsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.GetFriendsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.GetFriendsRequest.displayName = 'proto.pb.GetFriendsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.GetFriendsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.GetFriendsResponse.repeatedFields_, null);
};
goog.inherits(proto.pb.GetFriendsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.GetFriendsResponse.displayName = 'proto.pb.GetFriendsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.Friend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.Friend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.Friend.displayName = 'proto.pb.Friend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.FriendsUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.FriendsUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.FriendsUpdate.displayName = 'proto.pb.FriendsUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.GetFriendsStatusesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.GetFriendsStatusesRequest.repeatedFields_, null);
};
goog.inherits(proto.pb.GetFriendsStatusesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.GetFriendsStatusesRequest.displayName = 'proto.pb.GetFriendsStatusesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.GetFriendsStatusesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.GetFriendsStatusesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.GetFriendsStatusesResponse.displayName = 'proto.pb.GetFriendsStatusesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.UpdateStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.UpdateStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.UpdateStatusRequest.displayName = 'proto.pb.UpdateStatusRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.GetFriendsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.GetFriendsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.GetFriendsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.GetFriendsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.GetFriendsRequest}
 */
proto.pb.GetFriendsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.GetFriendsRequest;
  return proto.pb.GetFriendsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.GetFriendsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.GetFriendsRequest}
 */
proto.pb.GetFriendsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.GetFriendsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.GetFriendsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.GetFriendsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.GetFriendsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string player_id = 1;
 * @return {string}
 */
proto.pb.GetFriendsRequest.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.GetFriendsRequest} returns this
 */
proto.pb.GetFriendsRequest.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.GetFriendsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.GetFriendsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.GetFriendsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.GetFriendsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.GetFriendsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    friendsList: jspb.Message.toObjectList(msg.getFriendsList(),
    proto.pb.Friend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.GetFriendsResponse}
 */
proto.pb.GetFriendsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.GetFriendsResponse;
  return proto.pb.GetFriendsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.GetFriendsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.GetFriendsResponse}
 */
proto.pb.GetFriendsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.Friend;
      reader.readMessage(value,proto.pb.Friend.deserializeBinaryFromReader);
      msg.addFriends(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.GetFriendsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.GetFriendsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.GetFriendsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.GetFriendsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFriendsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pb.Friend.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Friend friends = 1;
 * @return {!Array<!proto.pb.Friend>}
 */
proto.pb.GetFriendsResponse.prototype.getFriendsList = function() {
  return /** @type{!Array<!proto.pb.Friend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pb.Friend, 1));
};


/**
 * @param {!Array<!proto.pb.Friend>} value
 * @return {!proto.pb.GetFriendsResponse} returns this
*/
proto.pb.GetFriendsResponse.prototype.setFriendsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pb.Friend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pb.Friend}
 */
proto.pb.GetFriendsResponse.prototype.addFriends = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pb.Friend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.GetFriendsResponse} returns this
 */
proto.pb.GetFriendsResponse.prototype.clearFriendsList = function() {
  return this.setFriendsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.Friend.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.Friend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.Friend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Friend.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: (f = msg.getInfo()) && player_pb.Player.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.Friend}
 */
proto.pb.Friend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.Friend;
  return proto.pb.Friend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.Friend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.Friend}
 */
proto.pb.Friend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new player_pb.Player;
      reader.readMessage(value,player_pb.Player.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = /** @type {!proto.pb.FriendStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.Friend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.Friend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.Friend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Friend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      player_pb.Player.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Player info = 1;
 * @return {?proto.pb.Player}
 */
proto.pb.Friend.prototype.getInfo = function() {
  return /** @type{?proto.pb.Player} */ (
    jspb.Message.getWrapperField(this, player_pb.Player, 1));
};


/**
 * @param {?proto.pb.Player|undefined} value
 * @return {!proto.pb.Friend} returns this
*/
proto.pb.Friend.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.Friend} returns this
 */
proto.pb.Friend.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.Friend.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FriendStatus status = 2;
 * @return {!proto.pb.FriendStatus}
 */
proto.pb.Friend.prototype.getStatus = function() {
  return /** @type {!proto.pb.FriendStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pb.FriendStatus} value
 * @return {!proto.pb.Friend} returns this
 */
proto.pb.Friend.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.FriendsUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.FriendsUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.FriendsUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.FriendsUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    friend: (f = msg.getFriend()) && proto.pb.Friend.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.FriendsUpdate}
 */
proto.pb.FriendsUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.FriendsUpdate;
  return proto.pb.FriendsUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.FriendsUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.FriendsUpdate}
 */
proto.pb.FriendsUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.Friend;
      reader.readMessage(value,proto.pb.Friend.deserializeBinaryFromReader);
      msg.setFriend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.FriendsUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.FriendsUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.FriendsUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.FriendsUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFriend();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pb.Friend.serializeBinaryToWriter
    );
  }
};


/**
 * optional Friend friend = 1;
 * @return {?proto.pb.Friend}
 */
proto.pb.FriendsUpdate.prototype.getFriend = function() {
  return /** @type{?proto.pb.Friend} */ (
    jspb.Message.getWrapperField(this, proto.pb.Friend, 1));
};


/**
 * @param {?proto.pb.Friend|undefined} value
 * @return {!proto.pb.FriendsUpdate} returns this
*/
proto.pb.FriendsUpdate.prototype.setFriend = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.FriendsUpdate} returns this
 */
proto.pb.FriendsUpdate.prototype.clearFriend = function() {
  return this.setFriend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.FriendsUpdate.prototype.hasFriend = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.GetFriendsStatusesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.GetFriendsStatusesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.GetFriendsStatusesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.GetFriendsStatusesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.GetFriendsStatusesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.GetFriendsStatusesRequest}
 */
proto.pb.GetFriendsStatusesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.GetFriendsStatusesRequest;
  return proto.pb.GetFriendsStatusesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.GetFriendsStatusesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.GetFriendsStatusesRequest}
 */
proto.pb.GetFriendsStatusesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPlayerIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.GetFriendsStatusesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.GetFriendsStatusesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.GetFriendsStatusesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.GetFriendsStatusesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string player_ids = 1;
 * @return {!Array<string>}
 */
proto.pb.GetFriendsStatusesRequest.prototype.getPlayerIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.GetFriendsStatusesRequest} returns this
 */
proto.pb.GetFriendsStatusesRequest.prototype.setPlayerIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.GetFriendsStatusesRequest} returns this
 */
proto.pb.GetFriendsStatusesRequest.prototype.addPlayerIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.GetFriendsStatusesRequest} returns this
 */
proto.pb.GetFriendsStatusesRequest.prototype.clearPlayerIdsList = function() {
  return this.setPlayerIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.GetFriendsStatusesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.GetFriendsStatusesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.GetFriendsStatusesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.GetFriendsStatusesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusesMap: (f = msg.getStatusesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.GetFriendsStatusesResponse}
 */
proto.pb.GetFriendsStatusesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.GetFriendsStatusesResponse;
  return proto.pb.GetFriendsStatusesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.GetFriendsStatusesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.GetFriendsStatusesResponse}
 */
proto.pb.GetFriendsStatusesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getStatusesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readEnum, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.GetFriendsStatusesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.GetFriendsStatusesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.GetFriendsStatusesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.GetFriendsStatusesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatusesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeEnum);
  }
};


/**
 * map<string, FriendStatus> statuses = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.pb.FriendStatus>}
 */
proto.pb.GetFriendsStatusesResponse.prototype.getStatusesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.pb.FriendStatus>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pb.GetFriendsStatusesResponse} returns this
 */
proto.pb.GetFriendsStatusesResponse.prototype.clearStatusesMap = function() {
  this.getStatusesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.UpdateStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.UpdateStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.UpdateStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.UpdateStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.UpdateStatusRequest}
 */
proto.pb.UpdateStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.UpdateStatusRequest;
  return proto.pb.UpdateStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.UpdateStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.UpdateStatusRequest}
 */
proto.pb.UpdateStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    case 2:
      var value = /** @type {!proto.pb.FriendStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.UpdateStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.UpdateStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.UpdateStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.UpdateStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string player_id = 1;
 * @return {string}
 */
proto.pb.UpdateStatusRequest.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.UpdateStatusRequest} returns this
 */
proto.pb.UpdateStatusRequest.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FriendStatus status = 2;
 * @return {!proto.pb.FriendStatus}
 */
proto.pb.UpdateStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.pb.FriendStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pb.FriendStatus} value
 * @return {!proto.pb.UpdateStatusRequest} returns this
 */
proto.pb.UpdateStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.pb.FriendStatus = {
  ONLINE: 0,
  OFFLINE: 1,
  IN_GAME: 2,
  IN_PARTY: 3
};

goog.object.extend(exports, proto.pb);

},{"./player_pb.js":80,"google-protobuf":3}],79:[function(require,module,exports){
// source: mm_facade.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var player_pb = require('./player_pb.js');
goog.object.extend(proto, player_pb);
goog.exportSymbol('proto.pb.FindMatchCancelRequest', null, global);
goog.exportSymbol('proto.pb.FindMatchStatus', null, global);
goog.exportSymbol('proto.pb.MatchmakerEntryInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.MatchmakerEntryInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.MatchmakerEntryInfo.repeatedFields_, null);
};
goog.inherits(proto.pb.MatchmakerEntryInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.MatchmakerEntryInfo.displayName = 'proto.pb.MatchmakerEntryInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.FindMatchStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.FindMatchStatus.repeatedFields_, null);
};
goog.inherits(proto.pb.FindMatchStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.FindMatchStatus.displayName = 'proto.pb.FindMatchStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.FindMatchCancelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.FindMatchCancelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.FindMatchCancelRequest.displayName = 'proto.pb.FindMatchCancelRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.MatchmakerEntryInfo.repeatedFields_ = [5,6,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.MatchmakerEntryInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.MatchmakerEntryInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.MatchmakerEntryInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.MatchmakerEntryInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    partyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    partySize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    partyLevel: jspb.Message.getFieldWithDefault(msg, 3, 0),
    region: jspb.Message.getFieldWithDefault(msg, 4, ""),
    gameModesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    mapsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    repositoryBranch: jspb.Message.getFieldWithDefault(msg, 7, ""),
    playersList: jspb.Message.toObjectList(msg.getPlayersList(),
    player_pb.Player.toObject, includeInstance),
    releaseTag: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.MatchmakerEntryInfo}
 */
proto.pb.MatchmakerEntryInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.MatchmakerEntryInfo;
  return proto.pb.MatchmakerEntryInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.MatchmakerEntryInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.MatchmakerEntryInfo}
 */
proto.pb.MatchmakerEntryInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPartySize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPartyLevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addGameModes(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addMaps(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepositoryBranch(value);
      break;
    case 8:
      var value = new player_pb.Player;
      reader.readMessage(value,player_pb.Player.deserializeBinaryFromReader);
      msg.addPlayers(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.MatchmakerEntryInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.MatchmakerEntryInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.MatchmakerEntryInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.MatchmakerEntryInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPartySize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPartyLevel();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGameModesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getMapsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getRepositoryBranch();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPlayersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      player_pb.Player.serializeBinaryToWriter
    );
  }
  f = message.getReleaseTag();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string party_id = 1;
 * @return {string}
 */
proto.pb.MatchmakerEntryInfo.prototype.getPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.setPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 party_size = 2;
 * @return {number}
 */
proto.pb.MatchmakerEntryInfo.prototype.getPartySize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.setPartySize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 party_level = 3;
 * @return {number}
 */
proto.pb.MatchmakerEntryInfo.prototype.getPartyLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.setPartyLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string region = 4;
 * @return {string}
 */
proto.pb.MatchmakerEntryInfo.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string game_modes = 5;
 * @return {!Array<string>}
 */
proto.pb.MatchmakerEntryInfo.prototype.getGameModesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.setGameModesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.addGameModes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.clearGameModesList = function() {
  return this.setGameModesList([]);
};


/**
 * repeated string maps = 6;
 * @return {!Array<string>}
 */
proto.pb.MatchmakerEntryInfo.prototype.getMapsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.setMapsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.addMaps = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.clearMapsList = function() {
  return this.setMapsList([]);
};


/**
 * optional string repository_branch = 7;
 * @return {string}
 */
proto.pb.MatchmakerEntryInfo.prototype.getRepositoryBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.setRepositoryBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated Player players = 8;
 * @return {!Array<!proto.pb.Player>}
 */
proto.pb.MatchmakerEntryInfo.prototype.getPlayersList = function() {
  return /** @type{!Array<!proto.pb.Player>} */ (
    jspb.Message.getRepeatedWrapperField(this, player_pb.Player, 8));
};


/**
 * @param {!Array<!proto.pb.Player>} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
*/
proto.pb.MatchmakerEntryInfo.prototype.setPlayersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.pb.Player=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pb.Player}
 */
proto.pb.MatchmakerEntryInfo.prototype.addPlayers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.pb.Player, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.clearPlayersList = function() {
  return this.setPlayersList([]);
};


/**
 * optional string release_tag = 9;
 * @return {string}
 */
proto.pb.MatchmakerEntryInfo.prototype.getReleaseTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.MatchmakerEntryInfo} returns this
 */
proto.pb.MatchmakerEntryInfo.prototype.setReleaseTag = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.FindMatchStatus.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.FindMatchStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.FindMatchStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.FindMatchStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.FindMatchStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    error: jspb.Message.getFieldWithDefault(msg, 1, ""),
    region: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    gameserverIp: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currentPlayers: jspb.Message.getFieldWithDefault(msg, 5, 0),
    maxPlayers: jspb.Message.getFieldWithDefault(msg, 6, 0),
    mode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    map: jspb.Message.getFieldWithDefault(msg, 8, ""),
    settings: jspb.Message.getFieldWithDefault(msg, 9, ""),
    mapCandidatesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    canceled: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    userSession: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.FindMatchStatus}
 */
proto.pb.FindMatchStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.FindMatchStatus;
  return proto.pb.FindMatchStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.FindMatchStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.FindMatchStatus}
 */
proto.pb.FindMatchStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameserverIp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentPlayers(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxPlayers(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMap(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettings(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addMapCandidates(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanceled(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserSession(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.FindMatchStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.FindMatchStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.FindMatchStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.FindMatchStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGameserverIp();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrentPlayers();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMaxPlayers();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMap();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSettings();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMapCandidatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getCanceled();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getUserSession();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string error = 1;
 * @return {string}
 */
proto.pb.FindMatchStatus.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string region = 2;
 * @return {string}
 */
proto.pb.FindMatchStatus.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string room_id = 3;
 * @return {string}
 */
proto.pb.FindMatchStatus.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string gameserver_ip = 4;
 * @return {string}
 */
proto.pb.FindMatchStatus.prototype.getGameserverIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setGameserverIp = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 current_players = 5;
 * @return {number}
 */
proto.pb.FindMatchStatus.prototype.getCurrentPlayers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setCurrentPlayers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 max_players = 6;
 * @return {number}
 */
proto.pb.FindMatchStatus.prototype.getMaxPlayers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setMaxPlayers = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string mode = 7;
 * @return {string}
 */
proto.pb.FindMatchStatus.prototype.getMode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setMode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string map = 8;
 * @return {string}
 */
proto.pb.FindMatchStatus.prototype.getMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setMap = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string settings = 9;
 * @return {string}
 */
proto.pb.FindMatchStatus.prototype.getSettings = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setSettings = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated string map_candidates = 11;
 * @return {!Array<string>}
 */
proto.pb.FindMatchStatus.prototype.getMapCandidatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setMapCandidatesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.addMapCandidates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.clearMapCandidatesList = function() {
  return this.setMapCandidatesList([]);
};


/**
 * optional bool canceled = 12;
 * @return {boolean}
 */
proto.pb.FindMatchStatus.prototype.getCanceled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setCanceled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string user_session = 13;
 * @return {string}
 */
proto.pb.FindMatchStatus.prototype.getUserSession = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchStatus} returns this
 */
proto.pb.FindMatchStatus.prototype.setUserSession = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.FindMatchCancelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.FindMatchCancelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.FindMatchCancelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.FindMatchCancelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    partyId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.FindMatchCancelRequest}
 */
proto.pb.FindMatchCancelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.FindMatchCancelRequest;
  return proto.pb.FindMatchCancelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.FindMatchCancelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.FindMatchCancelRequest}
 */
proto.pb.FindMatchCancelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.FindMatchCancelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.FindMatchCancelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.FindMatchCancelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.FindMatchCancelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string party_id = 1;
 * @return {string}
 */
proto.pb.FindMatchCancelRequest.prototype.getPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.FindMatchCancelRequest} returns this
 */
proto.pb.FindMatchCancelRequest.prototype.setPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.pb);

},{"./player_pb.js":80,"google-protobuf":3}],80:[function(require,module,exports){
// source: player.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.pb.Player', null, global);
goog.exportSymbol('proto.pb.PlayerDisconnectedRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.Player.displayName = 'proto.pb.Player';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.PlayerDisconnectedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.PlayerDisconnectedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.PlayerDisconnectedRequest.displayName = 'proto.pb.PlayerDisconnectedRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    level: jspb.Message.getFieldWithDefault(msg, 3, 0),
    hat: jspb.Message.getFieldWithDefault(msg, 4, ""),
    characterSkin: jspb.Message.getFieldWithDefault(msg, 5, ""),
    ready: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    clanName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    clanSlug: jspb.Message.getFieldWithDefault(msg, 8, ""),
    userUuid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 10, ""),
    isGuest: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    nametail: jspb.Message.getFieldWithDefault(msg, 12, ""),
    clanLegacyId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    isCurrentPlayer: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    isConnected: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    clanId: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.Player}
 */
proto.pb.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.Player;
  return proto.pb.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.Player}
 */
proto.pb.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHat(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCharacterSkin(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReady(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClanName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setClanSlug(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGuest(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setNametail(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setClanLegacyId(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCurrentPlayer(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsConnected(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setClanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHat();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCharacterSkin();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getReady();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getClanName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getClanSlug();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getIsGuest();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getNametail();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getClanLegacyId();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getIsCurrentPlayer();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getIsConnected();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getClanId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string player_id = 1;
 * @return {string}
 */
proto.pb.Player.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.pb.Player.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 level = 3;
 * @return {number}
 */
proto.pb.Player.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string hat = 4;
 * @return {string}
 */
proto.pb.Player.prototype.getHat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setHat = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string character_skin = 5;
 * @return {string}
 */
proto.pb.Player.prototype.getCharacterSkin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setCharacterSkin = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool ready = 6;
 * @return {boolean}
 */
proto.pb.Player.prototype.getReady = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setReady = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string clan_name = 7;
 * @return {string}
 */
proto.pb.Player.prototype.getClanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setClanName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string clan_slug = 8;
 * @return {string}
 */
proto.pb.Player.prototype.getClanSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setClanSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string user_uuid = 9;
 * @return {string}
 */
proto.pb.Player.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string hash = 10;
 * @return {string}
 */
proto.pb.Player.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool is_guest = 11;
 * @return {boolean}
 */
proto.pb.Player.prototype.getIsGuest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setIsGuest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string nametail = 12;
 * @return {string}
 */
proto.pb.Player.prototype.getNametail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setNametail = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint64 clan_legacy_id = 13;
 * @return {number}
 */
proto.pb.Player.prototype.getClanLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setClanLegacyId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional bool is_current_player = 14;
 * @return {boolean}
 */
proto.pb.Player.prototype.getIsCurrentPlayer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setIsCurrentPlayer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool is_connected = 15;
 * @return {boolean}
 */
proto.pb.Player.prototype.getIsConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setIsConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string clan_id = 16;
 * @return {string}
 */
proto.pb.Player.prototype.getClanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Player} returns this
 */
proto.pb.Player.prototype.setClanId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.PlayerDisconnectedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.PlayerDisconnectedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.PlayerDisconnectedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.PlayerDisconnectedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.PlayerDisconnectedRequest}
 */
proto.pb.PlayerDisconnectedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.PlayerDisconnectedRequest;
  return proto.pb.PlayerDisconnectedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.PlayerDisconnectedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.PlayerDisconnectedRequest}
 */
proto.pb.PlayerDisconnectedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.PlayerDisconnectedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.PlayerDisconnectedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.PlayerDisconnectedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.PlayerDisconnectedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string player_id = 1;
 * @return {string}
 */
proto.pb.PlayerDisconnectedRequest.prototype.getPlayerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.PlayerDisconnectedRequest} returns this
 */
proto.pb.PlayerDisconnectedRequest.prototype.setPlayerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.pb);

},{"google-protobuf":3}],81:[function(require,module,exports){
// source: util.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.pb.Empty', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.Empty.displayName = 'proto.pb.Empty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.Empty}
 */
proto.pb.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.Empty;
  return proto.pb.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.Empty}
 */
proto.pb.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.pb);

},{"google-protobuf":3}],82:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for quests
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var public_quests_shared_pb = require('../public/quests.shared_pb.js')
const proto = {};
proto.quests = require('./progress_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.quests.MatchProgressClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.quests.MatchProgressPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.quests.GetProgress.Request,
 *   !proto.quests.GetProgress.Response>}
 */
const methodDescriptor_MatchProgress_GetProgress = new grpc.web.MethodDescriptor(
  '/quests.MatchProgress/GetProgress',
  grpc.web.MethodType.UNARY,
  proto.quests.GetProgress.Request,
  proto.quests.GetProgress.Response,
  /**
   * @param {!proto.quests.GetProgress.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.quests.GetProgress.Response.deserializeBinary
);


/**
 * @param {!proto.quests.GetProgress.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.quests.GetProgress.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.quests.GetProgress.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.quests.MatchProgressClient.prototype.getProgress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/quests.MatchProgress/GetProgress',
      request,
      metadata || {},
      methodDescriptor_MatchProgress_GetProgress,
      callback);
};


/**
 * @param {!proto.quests.GetProgress.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.quests.GetProgress.Response>}
 *     Promise that resolves to the response
 */
proto.quests.MatchProgressPromiseClient.prototype.getProgress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/quests.MatchProgress/GetProgress',
      request,
      metadata || {},
      methodDescriptor_MatchProgress_GetProgress);
};


module.exports = proto.quests;


},{"../public/quests.shared_pb.js":86,"../validate/validate_pb.js":87,"./progress_pb.js":83,"grpc-web":7}],83:[function(require,module,exports){
// source: public/progress.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var public_quests_shared_pb = require('../public/quests.shared_pb.js');
goog.object.extend(proto, public_quests_shared_pb);
goog.exportSymbol('proto.quests.GetProgress', null, global);
goog.exportSymbol('proto.quests.GetProgress.Request', null, global);
goog.exportSymbol('proto.quests.GetProgress.Response', null, global);
goog.exportSymbol('proto.quests.GetProgress.Response.Bucket', null, global);
goog.exportSymbol('proto.quests.GetProgress.Response.Bucket.Activity', null, global);
goog.exportSymbol('proto.quests.GetProgress.Response.Bucket.Activity.Ref', null, global);
goog.exportSymbol('proto.quests.GetProgress.Response.Bucket.Ref', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.GetProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetProgress.displayName = 'proto.quests.GetProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetProgress.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.GetProgress.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetProgress.Request.displayName = 'proto.quests.GetProgress.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetProgress.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.GetProgress.Response.repeatedFields_, null);
};
goog.inherits(proto.quests.GetProgress.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetProgress.Response.displayName = 'proto.quests.GetProgress.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetProgress.Response.Bucket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.GetProgress.Response.Bucket.repeatedFields_, null);
};
goog.inherits(proto.quests.GetProgress.Response.Bucket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetProgress.Response.Bucket.displayName = 'proto.quests.GetProgress.Response.Bucket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetProgress.Response.Bucket.Ref = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.GetProgress.Response.Bucket.Ref, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetProgress.Response.Bucket.Ref.displayName = 'proto.quests.GetProgress.Response.Bucket.Ref';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetProgress.Response.Bucket.Activity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.GetProgress.Response.Bucket.Activity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetProgress.Response.Bucket.Activity.displayName = 'proto.quests.GetProgress.Response.Bucket.Activity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.GetProgress.Response.Bucket.Activity.Ref, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetProgress.Response.Bucket.Activity.Ref.displayName = 'proto.quests.GetProgress.Response.Bucket.Activity.Ref';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetProgress}
 */
proto.quests.GetProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetProgress;
  return proto.quests.GetProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetProgress}
 */
proto.quests.GetProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetProgress.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetProgress.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetProgress.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchId: (f = msg.getMatchId()) && public_quests_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetProgress.Request}
 */
proto.quests.GetProgress.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetProgress.Request;
  return proto.quests.GetProgress.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetProgress.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetProgress.Request}
 */
proto.quests.GetProgress.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new public_quests_shared_pb.UUID;
      reader.readMessage(value,public_quests_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setMatchId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetProgress.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetProgress.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetProgress.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      public_quests_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID match_id = 1;
 * @return {?proto.quests.UUID}
 */
proto.quests.GetProgress.Request.prototype.getMatchId = function() {
  return /** @type{?proto.quests.UUID} */ (
    jspb.Message.getWrapperField(this, public_quests_shared_pb.UUID, 1));
};


/**
 * @param {?proto.quests.UUID|undefined} value
 * @return {!proto.quests.GetProgress.Request} returns this
*/
proto.quests.GetProgress.Request.prototype.setMatchId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.GetProgress.Request} returns this
 */
proto.quests.GetProgress.Request.prototype.clearMatchId = function() {
  return this.setMatchId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.GetProgress.Request.prototype.hasMatchId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.GetProgress.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetProgress.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetProgress.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetProgress.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    bucketsList: jspb.Message.toObjectList(msg.getBucketsList(),
    proto.quests.GetProgress.Response.Bucket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetProgress.Response}
 */
proto.quests.GetProgress.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetProgress.Response;
  return proto.quests.GetProgress.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetProgress.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetProgress.Response}
 */
proto.quests.GetProgress.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.GetProgress.Response.Bucket;
      reader.readMessage(value,proto.quests.GetProgress.Response.Bucket.deserializeBinaryFromReader);
      msg.addBuckets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetProgress.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetProgress.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetProgress.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.quests.GetProgress.Response.Bucket.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.GetProgress.Response.Bucket.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetProgress.Response.Bucket.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetProgress.Response.Bucket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetProgress.Response.Bucket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.Bucket.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ref: (f = msg.getRef()) && proto.quests.GetProgress.Response.Bucket.Ref.toObject(includeInstance, f),
    activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.quests.GetProgress.Response.Bucket.Activity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetProgress.Response.Bucket}
 */
proto.quests.GetProgress.Response.Bucket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetProgress.Response.Bucket;
  return proto.quests.GetProgress.Response.Bucket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetProgress.Response.Bucket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetProgress.Response.Bucket}
 */
proto.quests.GetProgress.Response.Bucket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.quests.GetProgress.Response.Bucket.Ref;
      reader.readMessage(value,proto.quests.GetProgress.Response.Bucket.Ref.deserializeBinaryFromReader);
      msg.setRef(value);
      break;
    case 3:
      var value = new proto.quests.GetProgress.Response.Bucket.Activity;
      reader.readMessage(value,proto.quests.GetProgress.Response.Bucket.Activity.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetProgress.Response.Bucket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetProgress.Response.Bucket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetProgress.Response.Bucket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.Bucket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRef();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.quests.GetProgress.Response.Bucket.Ref.serializeBinaryToWriter
    );
  }
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.quests.GetProgress.Response.Bucket.Activity.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetProgress.Response.Bucket.Ref.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetProgress.Response.Bucket.Ref.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetProgress.Response.Bucket.Ref} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.Bucket.Ref.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clanId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    raidId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetProgress.Response.Bucket.Ref}
 */
proto.quests.GetProgress.Response.Bucket.Ref.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetProgress.Response.Bucket.Ref;
  return proto.quests.GetProgress.Response.Bucket.Ref.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetProgress.Response.Bucket.Ref} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetProgress.Response.Bucket.Ref}
 */
proto.quests.GetProgress.Response.Bucket.Ref.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClanId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRaidId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetProgress.Response.Bucket.Ref.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetProgress.Response.Bucket.Ref.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetProgress.Response.Bucket.Ref} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.Bucket.Ref.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClanId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRaidId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.quests.GetProgress.Response.Bucket.Ref.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.GetProgress.Response.Bucket.Ref} returns this
 */
proto.quests.GetProgress.Response.Bucket.Ref.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string clan_id = 2;
 * @return {string}
 */
proto.quests.GetProgress.Response.Bucket.Ref.prototype.getClanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.GetProgress.Response.Bucket.Ref} returns this
 */
proto.quests.GetProgress.Response.Bucket.Ref.prototype.setClanId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string raid_id = 3;
 * @return {string}
 */
proto.quests.GetProgress.Response.Bucket.Ref.prototype.getRaidId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.GetProgress.Response.Bucket.Ref} returns this
 */
proto.quests.GetProgress.Response.Bucket.Ref.prototype.setRaidId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetProgress.Response.Bucket.Activity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetProgress.Response.Bucket.Activity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.Bucket.Activity.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ref: (f = msg.getRef()) && proto.quests.GetProgress.Response.Bucket.Activity.Ref.toObject(includeInstance, f),
    increase: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity}
 */
proto.quests.GetProgress.Response.Bucket.Activity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetProgress.Response.Bucket.Activity;
  return proto.quests.GetProgress.Response.Bucket.Activity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetProgress.Response.Bucket.Activity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity}
 */
proto.quests.GetProgress.Response.Bucket.Activity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.quests.GetProgress.Response.Bucket.Activity.Ref;
      reader.readMessage(value,proto.quests.GetProgress.Response.Bucket.Activity.Ref.deserializeBinaryFromReader);
      msg.setRef(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIncrease(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetProgress.Response.Bucket.Activity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetProgress.Response.Bucket.Activity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.Bucket.Activity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRef();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.quests.GetProgress.Response.Bucket.Activity.Ref.serializeBinaryToWriter
    );
  }
  f = message.getIncrease();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetProgress.Response.Bucket.Activity.Ref.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetProgress.Response.Bucket.Activity.Ref} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.toObject = function(includeInstance, msg) {
  var f, obj = {
    questId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taskId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity.Ref}
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetProgress.Response.Bucket.Activity.Ref;
  return proto.quests.GetProgress.Response.Bucket.Activity.Ref.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetProgress.Response.Bucket.Activity.Ref} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity.Ref}
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetProgress.Response.Bucket.Activity.Ref.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetProgress.Response.Bucket.Activity.Ref} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string quest_id = 1;
 * @return {string}
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.prototype.getQuestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity.Ref} returns this
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.prototype.setQuestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_id = 2;
 * @return {string}
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity.Ref} returns this
 */
proto.quests.GetProgress.Response.Bucket.Activity.Ref.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity} returns this
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Ref ref = 2;
 * @return {?proto.quests.GetProgress.Response.Bucket.Activity.Ref}
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.getRef = function() {
  return /** @type{?proto.quests.GetProgress.Response.Bucket.Activity.Ref} */ (
    jspb.Message.getWrapperField(this, proto.quests.GetProgress.Response.Bucket.Activity.Ref, 2));
};


/**
 * @param {?proto.quests.GetProgress.Response.Bucket.Activity.Ref|undefined} value
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity} returns this
*/
proto.quests.GetProgress.Response.Bucket.Activity.prototype.setRef = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity} returns this
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.clearRef = function() {
  return this.setRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.hasRef = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 increase = 3;
 * @return {number}
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.getIncrease = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity} returns this
 */
proto.quests.GetProgress.Response.Bucket.Activity.prototype.setIncrease = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.quests.GetProgress.Response.Bucket.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.GetProgress.Response.Bucket} returns this
 */
proto.quests.GetProgress.Response.Bucket.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Ref ref = 2;
 * @return {?proto.quests.GetProgress.Response.Bucket.Ref}
 */
proto.quests.GetProgress.Response.Bucket.prototype.getRef = function() {
  return /** @type{?proto.quests.GetProgress.Response.Bucket.Ref} */ (
    jspb.Message.getWrapperField(this, proto.quests.GetProgress.Response.Bucket.Ref, 2));
};


/**
 * @param {?proto.quests.GetProgress.Response.Bucket.Ref|undefined} value
 * @return {!proto.quests.GetProgress.Response.Bucket} returns this
*/
proto.quests.GetProgress.Response.Bucket.prototype.setRef = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.GetProgress.Response.Bucket} returns this
 */
proto.quests.GetProgress.Response.Bucket.prototype.clearRef = function() {
  return this.setRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.GetProgress.Response.Bucket.prototype.hasRef = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Activity activities = 3;
 * @return {!Array<!proto.quests.GetProgress.Response.Bucket.Activity>}
 */
proto.quests.GetProgress.Response.Bucket.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.quests.GetProgress.Response.Bucket.Activity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.GetProgress.Response.Bucket.Activity, 3));
};


/**
 * @param {!Array<!proto.quests.GetProgress.Response.Bucket.Activity>} value
 * @return {!proto.quests.GetProgress.Response.Bucket} returns this
*/
proto.quests.GetProgress.Response.Bucket.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.quests.GetProgress.Response.Bucket.Activity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.GetProgress.Response.Bucket.Activity}
 */
proto.quests.GetProgress.Response.Bucket.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.quests.GetProgress.Response.Bucket.Activity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.GetProgress.Response.Bucket} returns this
 */
proto.quests.GetProgress.Response.Bucket.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * repeated Bucket buckets = 1;
 * @return {!Array<!proto.quests.GetProgress.Response.Bucket>}
 */
proto.quests.GetProgress.Response.prototype.getBucketsList = function() {
  return /** @type{!Array<!proto.quests.GetProgress.Response.Bucket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.GetProgress.Response.Bucket, 1));
};


/**
 * @param {!Array<!proto.quests.GetProgress.Response.Bucket>} value
 * @return {!proto.quests.GetProgress.Response} returns this
*/
proto.quests.GetProgress.Response.prototype.setBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.GetProgress.Response.Bucket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.GetProgress.Response.Bucket}
 */
proto.quests.GetProgress.Response.prototype.addBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.GetProgress.Response.Bucket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.GetProgress.Response} returns this
 */
proto.quests.GetProgress.Response.prototype.clearBucketsList = function() {
  return this.setBucketsList([]);
};


goog.object.extend(exports, proto.quests);

},{"../public/quests.shared_pb.js":86,"../validate/validate_pb.js":87,"google-protobuf":3}],84:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for quests
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var public_quests_shared_pb = require('../public/quests.shared_pb.js')
const proto = {};
proto.quests = require('./quests.public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.quests.RegistryClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.quests.RegistryPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.quests.GetQuests.Request,
 *   !proto.quests.GetQuests.Response>}
 */
const methodDescriptor_Registry_GetAvailable = new grpc.web.MethodDescriptor(
  '/quests.Registry/GetAvailable',
  grpc.web.MethodType.UNARY,
  proto.quests.GetQuests.Request,
  proto.quests.GetQuests.Response,
  /**
   * @param {!proto.quests.GetQuests.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.quests.GetQuests.Response.deserializeBinary
);


/**
 * @param {!proto.quests.GetQuests.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.quests.GetQuests.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.quests.GetQuests.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.quests.RegistryClient.prototype.getAvailable =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/quests.Registry/GetAvailable',
      request,
      metadata || {},
      methodDescriptor_Registry_GetAvailable,
      callback);
};


/**
 * @param {!proto.quests.GetQuests.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.quests.GetQuests.Response>}
 *     Promise that resolves to the response
 */
proto.quests.RegistryPromiseClient.prototype.getAvailable =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/quests.Registry/GetAvailable',
      request,
      metadata || {},
      methodDescriptor_Registry_GetAvailable);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.quests.GetClanQuests.Request,
 *   !proto.quests.GetClanQuests.Response>}
 */
const methodDescriptor_Registry_GetClanQuests = new grpc.web.MethodDescriptor(
  '/quests.Registry/GetClanQuests',
  grpc.web.MethodType.UNARY,
  proto.quests.GetClanQuests.Request,
  proto.quests.GetClanQuests.Response,
  /**
   * @param {!proto.quests.GetClanQuests.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.quests.GetClanQuests.Response.deserializeBinary
);


/**
 * @param {!proto.quests.GetClanQuests.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.quests.GetClanQuests.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.quests.GetClanQuests.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.quests.RegistryClient.prototype.getClanQuests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/quests.Registry/GetClanQuests',
      request,
      metadata || {},
      methodDescriptor_Registry_GetClanQuests,
      callback);
};


/**
 * @param {!proto.quests.GetClanQuests.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.quests.GetClanQuests.Response>}
 *     Promise that resolves to the response
 */
proto.quests.RegistryPromiseClient.prototype.getClanQuests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/quests.Registry/GetClanQuests',
      request,
      metadata || {},
      methodDescriptor_Registry_GetClanQuests);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.quests.RewardsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.quests.RewardsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.quests.ClaimReward.Request,
 *   !proto.quests.ClaimReward.Response>}
 */
const methodDescriptor_Rewards_ClaimReward = new grpc.web.MethodDescriptor(
  '/quests.Rewards/ClaimReward',
  grpc.web.MethodType.UNARY,
  proto.quests.ClaimReward.Request,
  proto.quests.ClaimReward.Response,
  /**
   * @param {!proto.quests.ClaimReward.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.quests.ClaimReward.Response.deserializeBinary
);


/**
 * @param {!proto.quests.ClaimReward.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.quests.ClaimReward.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.quests.ClaimReward.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.quests.RewardsClient.prototype.claimReward =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/quests.Rewards/ClaimReward',
      request,
      metadata || {},
      methodDescriptor_Rewards_ClaimReward,
      callback);
};


/**
 * @param {!proto.quests.ClaimReward.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.quests.ClaimReward.Response>}
 *     Promise that resolves to the response
 */
proto.quests.RewardsPromiseClient.prototype.claimReward =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/quests.Rewards/ClaimReward',
      request,
      metadata || {},
      methodDescriptor_Rewards_ClaimReward);
};


module.exports = proto.quests;


},{"../public/quests.shared_pb.js":86,"../validate/validate_pb.js":87,"./quests.public_pb.js":85,"grpc-web":7}],85:[function(require,module,exports){
// source: public/quests.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var public_quests_shared_pb = require('../public/quests.shared_pb.js');
goog.object.extend(proto, public_quests_shared_pb);
goog.exportSymbol('proto.quests.ClaimReward', null, global);
goog.exportSymbol('proto.quests.ClaimReward.Request', null, global);
goog.exportSymbol('proto.quests.ClaimReward.Response', null, global);
goog.exportSymbol('proto.quests.GetClanQuests', null, global);
goog.exportSymbol('proto.quests.GetClanQuests.Request', null, global);
goog.exportSymbol('proto.quests.GetClanQuests.Response', null, global);
goog.exportSymbol('proto.quests.GetQuests', null, global);
goog.exportSymbol('proto.quests.GetQuests.Request', null, global);
goog.exportSymbol('proto.quests.GetQuests.Response', null, global);
goog.exportSymbol('proto.quests.RegistryItem', null, global);
goog.exportSymbol('proto.quests.RegistryItem.ActivityID', null, global);
goog.exportSymbol('proto.quests.RegistryItem.ActivityID.IdCase', null, global);
goog.exportSymbol('proto.quests.RegistryItem.ActivityReward', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Quest', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Quest.Info', null, global);
goog.exportSymbol('proto.quests.RegistryItem.QuestsGroup', null, global);
goog.exportSymbol('proto.quests.RegistryItem.QuestsGroup.Daily', null, global);
goog.exportSymbol('proto.quests.RegistryItem.QuestsGroup.Limited', null, global);
goog.exportSymbol('proto.quests.RegistryItem.QuestsGroup.Season', null, global);
goog.exportSymbol('proto.quests.RegistryItem.QuestsGroup.Special', null, global);
goog.exportSymbol('proto.quests.RegistryItem.QuestsGroup.Value', null, global);
goog.exportSymbol('proto.quests.RegistryItem.QuestsGroup.Value.DataCase', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Reward', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Reward.Mintable', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Reward.Mintable.Item', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Reward.Shards', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Reward.Shards.Item', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Task', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Task.Progress', null, global);
goog.exportSymbol('proto.quests.RegistryItem.Task.Status', null, global);
goog.exportSymbol('proto.quests.TimeRange', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetQuests = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.GetQuests, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetQuests.displayName = 'proto.quests.GetQuests';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetQuests.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.GetQuests.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetQuests.Request.displayName = 'proto.quests.GetQuests.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetQuests.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.GetQuests.Response.repeatedFields_, null);
};
goog.inherits(proto.quests.GetQuests.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetQuests.Response.displayName = 'proto.quests.GetQuests.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetClanQuests = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.GetClanQuests, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetClanQuests.displayName = 'proto.quests.GetClanQuests';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetClanQuests.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.GetClanQuests.Request.repeatedFields_, null);
};
goog.inherits(proto.quests.GetClanQuests.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetClanQuests.Request.displayName = 'proto.quests.GetClanQuests.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.GetClanQuests.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.GetClanQuests.Response.repeatedFields_, null);
};
goog.inherits(proto.quests.GetClanQuests.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.GetClanQuests.Response.displayName = 'proto.quests.GetClanQuests.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.displayName = 'proto.quests.RegistryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.QuestsGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem.QuestsGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.QuestsGroup.displayName = 'proto.quests.RegistryItem.QuestsGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.QuestsGroup.Value = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.quests.RegistryItem.QuestsGroup.Value.oneofGroups_);
};
goog.inherits(proto.quests.RegistryItem.QuestsGroup.Value, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.QuestsGroup.Value.displayName = 'proto.quests.RegistryItem.QuestsGroup.Value';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.QuestsGroup.Season = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.RegistryItem.QuestsGroup.Season.repeatedFields_, null);
};
goog.inherits(proto.quests.RegistryItem.QuestsGroup.Season, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.QuestsGroup.Season.displayName = 'proto.quests.RegistryItem.QuestsGroup.Season';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.QuestsGroup.Daily = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem.QuestsGroup.Daily, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.QuestsGroup.Daily.displayName = 'proto.quests.RegistryItem.QuestsGroup.Daily';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.QuestsGroup.Limited = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.RegistryItem.QuestsGroup.Limited.repeatedFields_, null);
};
goog.inherits(proto.quests.RegistryItem.QuestsGroup.Limited, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.QuestsGroup.Limited.displayName = 'proto.quests.RegistryItem.QuestsGroup.Limited';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.QuestsGroup.Special = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.RegistryItem.QuestsGroup.Special.repeatedFields_, null);
};
goog.inherits(proto.quests.RegistryItem.QuestsGroup.Special, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.QuestsGroup.Special.displayName = 'proto.quests.RegistryItem.QuestsGroup.Special';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Quest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.RegistryItem.Quest.repeatedFields_, null);
};
goog.inherits(proto.quests.RegistryItem.Quest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Quest.displayName = 'proto.quests.RegistryItem.Quest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Quest.Info = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem.Quest.Info, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Quest.Info.displayName = 'proto.quests.RegistryItem.Quest.Info';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Task = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem.Task, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Task.displayName = 'proto.quests.RegistryItem.Task';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Task.Progress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem.Task.Progress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Task.Progress.displayName = 'proto.quests.RegistryItem.Task.Progress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.ActivityID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.quests.RegistryItem.ActivityID.oneofGroups_);
};
goog.inherits(proto.quests.RegistryItem.ActivityID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.ActivityID.displayName = 'proto.quests.RegistryItem.ActivityID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.ActivityReward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem.ActivityReward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.ActivityReward.displayName = 'proto.quests.RegistryItem.ActivityReward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Reward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.RegistryItem.Reward.repeatedFields_, null);
};
goog.inherits(proto.quests.RegistryItem.Reward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Reward.displayName = 'proto.quests.RegistryItem.Reward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Reward.Mintable = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.RegistryItem.Reward.Mintable.repeatedFields_, null);
};
goog.inherits(proto.quests.RegistryItem.Reward.Mintable, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Reward.Mintable.displayName = 'proto.quests.RegistryItem.Reward.Mintable';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Reward.Mintable.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem.Reward.Mintable.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Reward.Mintable.Item.displayName = 'proto.quests.RegistryItem.Reward.Mintable.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Reward.Shards = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.RegistryItem.Reward.Shards.repeatedFields_, null);
};
goog.inherits(proto.quests.RegistryItem.Reward.Shards, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Reward.Shards.displayName = 'proto.quests.RegistryItem.Reward.Shards';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.RegistryItem.Reward.Shards.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.RegistryItem.Reward.Shards.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.RegistryItem.Reward.Shards.Item.displayName = 'proto.quests.RegistryItem.Reward.Shards.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.ClaimReward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.ClaimReward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.ClaimReward.displayName = 'proto.quests.ClaimReward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.ClaimReward.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.ClaimReward.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.ClaimReward.Request.displayName = 'proto.quests.ClaimReward.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.ClaimReward.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.ClaimReward.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.ClaimReward.Response.displayName = 'proto.quests.ClaimReward.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.TimeRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.TimeRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.TimeRange.displayName = 'proto.quests.TimeRange';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetQuests.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetQuests.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetQuests} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetQuests.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetQuests}
 */
proto.quests.GetQuests.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetQuests;
  return proto.quests.GetQuests.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetQuests} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetQuests}
 */
proto.quests.GetQuests.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetQuests.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetQuests.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetQuests} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetQuests.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetQuests.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetQuests.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetQuests.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetQuests.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetQuests.Request}
 */
proto.quests.GetQuests.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetQuests.Request;
  return proto.quests.GetQuests.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetQuests.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetQuests.Request}
 */
proto.quests.GetQuests.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetQuests.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetQuests.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetQuests.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetQuests.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.GetQuests.Response.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetQuests.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetQuests.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetQuests.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetQuests.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.quests.RegistryItem.QuestsGroup.toObject, includeInstance),
    rewardsList: jspb.Message.toObjectList(msg.getRewardsList(),
    proto.quests.RegistryItem.ActivityReward.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetQuests.Response}
 */
proto.quests.GetQuests.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetQuests.Response;
  return proto.quests.GetQuests.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetQuests.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetQuests.Response}
 */
proto.quests.GetQuests.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.QuestsGroup;
      reader.readMessage(value,proto.quests.RegistryItem.QuestsGroup.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    case 2:
      var value = new proto.quests.RegistryItem.ActivityReward;
      reader.readMessage(value,proto.quests.RegistryItem.ActivityReward.deserializeBinaryFromReader);
      msg.addRewards(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetQuests.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetQuests.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetQuests.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetQuests.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.quests.RegistryItem.QuestsGroup.serializeBinaryToWriter
    );
  }
  f = message.getRewardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.quests.RegistryItem.ActivityReward.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RegistryItem.QuestsGroup groups = 1;
 * @return {!Array<!proto.quests.RegistryItem.QuestsGroup>}
 */
proto.quests.GetQuests.Response.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.QuestsGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.QuestsGroup, 1));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.QuestsGroup>} value
 * @return {!proto.quests.GetQuests.Response} returns this
*/
proto.quests.GetQuests.Response.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.RegistryItem.QuestsGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.QuestsGroup}
 */
proto.quests.GetQuests.Response.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.RegistryItem.QuestsGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.GetQuests.Response} returns this
 */
proto.quests.GetQuests.Response.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};


/**
 * repeated RegistryItem.ActivityReward rewards = 2;
 * @return {!Array<!proto.quests.RegistryItem.ActivityReward>}
 */
proto.quests.GetQuests.Response.prototype.getRewardsList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.ActivityReward>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.ActivityReward, 2));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.ActivityReward>} value
 * @return {!proto.quests.GetQuests.Response} returns this
*/
proto.quests.GetQuests.Response.prototype.setRewardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.quests.RegistryItem.ActivityReward=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.ActivityReward}
 */
proto.quests.GetQuests.Response.prototype.addRewards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.quests.RegistryItem.ActivityReward, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.GetQuests.Response} returns this
 */
proto.quests.GetQuests.Response.prototype.clearRewardsList = function() {
  return this.setRewardsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetClanQuests.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetClanQuests.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetClanQuests} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetClanQuests.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetClanQuests}
 */
proto.quests.GetClanQuests.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetClanQuests;
  return proto.quests.GetClanQuests.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetClanQuests} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetClanQuests}
 */
proto.quests.GetClanQuests.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetClanQuests.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetClanQuests.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetClanQuests} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetClanQuests.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.GetClanQuests.Request.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetClanQuests.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetClanQuests.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetClanQuests.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetClanQuests.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    questIdsList: jspb.Message.toObjectList(msg.getQuestIdsList(),
    public_quests_shared_pb.UUID.toObject, includeInstance),
    raidId: (f = msg.getRaidId()) && public_quests_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetClanQuests.Request}
 */
proto.quests.GetClanQuests.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetClanQuests.Request;
  return proto.quests.GetClanQuests.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetClanQuests.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetClanQuests.Request}
 */
proto.quests.GetClanQuests.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new public_quests_shared_pb.UUID;
      reader.readMessage(value,public_quests_shared_pb.UUID.deserializeBinaryFromReader);
      msg.addQuestIds(value);
      break;
    case 2:
      var value = new public_quests_shared_pb.UUID;
      reader.readMessage(value,public_quests_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setRaidId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetClanQuests.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetClanQuests.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetClanQuests.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetClanQuests.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      public_quests_shared_pb.UUID.serializeBinaryToWriter
    );
  }
  f = message.getRaidId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      public_quests_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UUID quest_ids = 1;
 * @return {!Array<!proto.quests.UUID>}
 */
proto.quests.GetClanQuests.Request.prototype.getQuestIdsList = function() {
  return /** @type{!Array<!proto.quests.UUID>} */ (
    jspb.Message.getRepeatedWrapperField(this, public_quests_shared_pb.UUID, 1));
};


/**
 * @param {!Array<!proto.quests.UUID>} value
 * @return {!proto.quests.GetClanQuests.Request} returns this
*/
proto.quests.GetClanQuests.Request.prototype.setQuestIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.UUID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.UUID}
 */
proto.quests.GetClanQuests.Request.prototype.addQuestIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.UUID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.GetClanQuests.Request} returns this
 */
proto.quests.GetClanQuests.Request.prototype.clearQuestIdsList = function() {
  return this.setQuestIdsList([]);
};


/**
 * optional UUID raid_id = 2;
 * @return {?proto.quests.UUID}
 */
proto.quests.GetClanQuests.Request.prototype.getRaidId = function() {
  return /** @type{?proto.quests.UUID} */ (
    jspb.Message.getWrapperField(this, public_quests_shared_pb.UUID, 2));
};


/**
 * @param {?proto.quests.UUID|undefined} value
 * @return {!proto.quests.GetClanQuests.Request} returns this
*/
proto.quests.GetClanQuests.Request.prototype.setRaidId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.GetClanQuests.Request} returns this
 */
proto.quests.GetClanQuests.Request.prototype.clearRaidId = function() {
  return this.setRaidId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.GetClanQuests.Request.prototype.hasRaidId = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.GetClanQuests.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.GetClanQuests.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.GetClanQuests.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.GetClanQuests.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetClanQuests.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    questsList: jspb.Message.toObjectList(msg.getQuestsList(),
    proto.quests.RegistryItem.Quest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.GetClanQuests.Response}
 */
proto.quests.GetClanQuests.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.GetClanQuests.Response;
  return proto.quests.GetClanQuests.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.GetClanQuests.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.GetClanQuests.Response}
 */
proto.quests.GetClanQuests.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.Quest;
      reader.readMessage(value,proto.quests.RegistryItem.Quest.deserializeBinaryFromReader);
      msg.addQuests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.GetClanQuests.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.GetClanQuests.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.GetClanQuests.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.GetClanQuests.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.quests.RegistryItem.Quest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RegistryItem.Quest quests = 1;
 * @return {!Array<!proto.quests.RegistryItem.Quest>}
 */
proto.quests.GetClanQuests.Response.prototype.getQuestsList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.Quest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.Quest, 1));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.Quest>} value
 * @return {!proto.quests.GetClanQuests.Response} returns this
*/
proto.quests.GetClanQuests.Response.prototype.setQuestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.RegistryItem.Quest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Quest}
 */
proto.quests.GetClanQuests.Response.prototype.addQuests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.RegistryItem.Quest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.GetClanQuests.Response} returns this
 */
proto.quests.GetClanQuests.Response.prototype.clearQuestsList = function() {
  return this.setQuestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem}
 */
proto.quests.RegistryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem;
  return proto.quests.RegistryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem}
 */
proto.quests.RegistryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.QuestsGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.QuestsGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.QuestsGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    descriptionkey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: (f = msg.getValue()) && proto.quests.RegistryItem.QuestsGroup.Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.QuestsGroup}
 */
proto.quests.RegistryItem.QuestsGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.QuestsGroup;
  return proto.quests.RegistryItem.QuestsGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.QuestsGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.QuestsGroup}
 */
proto.quests.RegistryItem.QuestsGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionkey(value);
      break;
    case 3:
      var value = new proto.quests.RegistryItem.QuestsGroup.Value;
      reader.readMessage(value,proto.quests.RegistryItem.QuestsGroup.Value.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.QuestsGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.QuestsGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.QuestsGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescriptionkey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.quests.RegistryItem.QuestsGroup.Value.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.quests.RegistryItem.QuestsGroup.Value.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.quests.RegistryItem.QuestsGroup.Value.DataCase = {
  DATA_NOT_SET: 0,
  SEASON: 1,
  DAILY: 2,
  LIMITED: 3,
  SPECIAL: 4
};

/**
 * @return {proto.quests.RegistryItem.QuestsGroup.Value.DataCase}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.getDataCase = function() {
  return /** @type {proto.quests.RegistryItem.QuestsGroup.Value.DataCase} */(jspb.Message.computeOneofCase(this, proto.quests.RegistryItem.QuestsGroup.Value.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.QuestsGroup.Value.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.QuestsGroup.Value} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Value.toObject = function(includeInstance, msg) {
  var f, obj = {
    season: (f = msg.getSeason()) && proto.quests.RegistryItem.QuestsGroup.Season.toObject(includeInstance, f),
    daily: (f = msg.getDaily()) && proto.quests.RegistryItem.QuestsGroup.Daily.toObject(includeInstance, f),
    limited: (f = msg.getLimited()) && proto.quests.RegistryItem.QuestsGroup.Limited.toObject(includeInstance, f),
    special: (f = msg.getSpecial()) && proto.quests.RegistryItem.QuestsGroup.Special.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value}
 */
proto.quests.RegistryItem.QuestsGroup.Value.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.QuestsGroup.Value;
  return proto.quests.RegistryItem.QuestsGroup.Value.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Value} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value}
 */
proto.quests.RegistryItem.QuestsGroup.Value.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.QuestsGroup.Season;
      reader.readMessage(value,proto.quests.RegistryItem.QuestsGroup.Season.deserializeBinaryFromReader);
      msg.setSeason(value);
      break;
    case 2:
      var value = new proto.quests.RegistryItem.QuestsGroup.Daily;
      reader.readMessage(value,proto.quests.RegistryItem.QuestsGroup.Daily.deserializeBinaryFromReader);
      msg.setDaily(value);
      break;
    case 3:
      var value = new proto.quests.RegistryItem.QuestsGroup.Limited;
      reader.readMessage(value,proto.quests.RegistryItem.QuestsGroup.Limited.deserializeBinaryFromReader);
      msg.setLimited(value);
      break;
    case 4:
      var value = new proto.quests.RegistryItem.QuestsGroup.Special;
      reader.readMessage(value,proto.quests.RegistryItem.QuestsGroup.Special.deserializeBinaryFromReader);
      msg.setSpecial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.QuestsGroup.Value.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Value} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Value.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeason();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.quests.RegistryItem.QuestsGroup.Season.serializeBinaryToWriter
    );
  }
  f = message.getDaily();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.quests.RegistryItem.QuestsGroup.Daily.serializeBinaryToWriter
    );
  }
  f = message.getLimited();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.quests.RegistryItem.QuestsGroup.Limited.serializeBinaryToWriter
    );
  }
  f = message.getSpecial();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.quests.RegistryItem.QuestsGroup.Special.serializeBinaryToWriter
    );
  }
};


/**
 * optional Season season = 1;
 * @return {?proto.quests.RegistryItem.QuestsGroup.Season}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.getSeason = function() {
  return /** @type{?proto.quests.RegistryItem.QuestsGroup.Season} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.QuestsGroup.Season, 1));
};


/**
 * @param {?proto.quests.RegistryItem.QuestsGroup.Season|undefined} value
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value} returns this
*/
proto.quests.RegistryItem.QuestsGroup.Value.prototype.setSeason = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.quests.RegistryItem.QuestsGroup.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value} returns this
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.clearSeason = function() {
  return this.setSeason(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.hasSeason = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Daily daily = 2;
 * @return {?proto.quests.RegistryItem.QuestsGroup.Daily}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.getDaily = function() {
  return /** @type{?proto.quests.RegistryItem.QuestsGroup.Daily} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.QuestsGroup.Daily, 2));
};


/**
 * @param {?proto.quests.RegistryItem.QuestsGroup.Daily|undefined} value
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value} returns this
*/
proto.quests.RegistryItem.QuestsGroup.Value.prototype.setDaily = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.quests.RegistryItem.QuestsGroup.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value} returns this
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.clearDaily = function() {
  return this.setDaily(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.hasDaily = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Limited limited = 3;
 * @return {?proto.quests.RegistryItem.QuestsGroup.Limited}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.getLimited = function() {
  return /** @type{?proto.quests.RegistryItem.QuestsGroup.Limited} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.QuestsGroup.Limited, 3));
};


/**
 * @param {?proto.quests.RegistryItem.QuestsGroup.Limited|undefined} value
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value} returns this
*/
proto.quests.RegistryItem.QuestsGroup.Value.prototype.setLimited = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.quests.RegistryItem.QuestsGroup.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value} returns this
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.clearLimited = function() {
  return this.setLimited(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.hasLimited = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Special special = 4;
 * @return {?proto.quests.RegistryItem.QuestsGroup.Special}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.getSpecial = function() {
  return /** @type{?proto.quests.RegistryItem.QuestsGroup.Special} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.QuestsGroup.Special, 4));
};


/**
 * @param {?proto.quests.RegistryItem.QuestsGroup.Special|undefined} value
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value} returns this
*/
proto.quests.RegistryItem.QuestsGroup.Value.prototype.setSpecial = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.quests.RegistryItem.QuestsGroup.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Value} returns this
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.clearSpecial = function() {
  return this.setSpecial(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.QuestsGroup.Value.prototype.hasSpecial = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.RegistryItem.QuestsGroup.Season.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.QuestsGroup.Season.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.QuestsGroup.Season.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.QuestsGroup.Season} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Season.toObject = function(includeInstance, msg) {
  var f, obj = {
    questsList: jspb.Message.toObjectList(msg.getQuestsList(),
    proto.quests.RegistryItem.Quest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Season}
 */
proto.quests.RegistryItem.QuestsGroup.Season.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.QuestsGroup.Season;
  return proto.quests.RegistryItem.QuestsGroup.Season.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Season} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Season}
 */
proto.quests.RegistryItem.QuestsGroup.Season.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.Quest;
      reader.readMessage(value,proto.quests.RegistryItem.Quest.deserializeBinaryFromReader);
      msg.addQuests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.QuestsGroup.Season.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.QuestsGroup.Season.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Season} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Season.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.quests.RegistryItem.Quest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Quest quests = 1;
 * @return {!Array<!proto.quests.RegistryItem.Quest>}
 */
proto.quests.RegistryItem.QuestsGroup.Season.prototype.getQuestsList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.Quest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.Quest, 1));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.Quest>} value
 * @return {!proto.quests.RegistryItem.QuestsGroup.Season} returns this
*/
proto.quests.RegistryItem.QuestsGroup.Season.prototype.setQuestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.RegistryItem.Quest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Quest}
 */
proto.quests.RegistryItem.QuestsGroup.Season.prototype.addQuests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.RegistryItem.Quest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Season} returns this
 */
proto.quests.RegistryItem.QuestsGroup.Season.prototype.clearQuestsList = function() {
  return this.setQuestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.QuestsGroup.Daily.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.QuestsGroup.Daily.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.QuestsGroup.Daily} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Daily.toObject = function(includeInstance, msg) {
  var f, obj = {
    quest: (f = msg.getQuest()) && proto.quests.RegistryItem.Quest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Daily}
 */
proto.quests.RegistryItem.QuestsGroup.Daily.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.QuestsGroup.Daily;
  return proto.quests.RegistryItem.QuestsGroup.Daily.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Daily} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Daily}
 */
proto.quests.RegistryItem.QuestsGroup.Daily.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.Quest;
      reader.readMessage(value,proto.quests.RegistryItem.Quest.deserializeBinaryFromReader);
      msg.setQuest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.QuestsGroup.Daily.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.QuestsGroup.Daily.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Daily} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Daily.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.quests.RegistryItem.Quest.serializeBinaryToWriter
    );
  }
};


/**
 * optional Quest quest = 1;
 * @return {?proto.quests.RegistryItem.Quest}
 */
proto.quests.RegistryItem.QuestsGroup.Daily.prototype.getQuest = function() {
  return /** @type{?proto.quests.RegistryItem.Quest} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.Quest, 1));
};


/**
 * @param {?proto.quests.RegistryItem.Quest|undefined} value
 * @return {!proto.quests.RegistryItem.QuestsGroup.Daily} returns this
*/
proto.quests.RegistryItem.QuestsGroup.Daily.prototype.setQuest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Daily} returns this
 */
proto.quests.RegistryItem.QuestsGroup.Daily.prototype.clearQuest = function() {
  return this.setQuest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.QuestsGroup.Daily.prototype.hasQuest = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.RegistryItem.QuestsGroup.Limited.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.QuestsGroup.Limited.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.QuestsGroup.Limited.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.QuestsGroup.Limited} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Limited.toObject = function(includeInstance, msg) {
  var f, obj = {
    questsList: jspb.Message.toObjectList(msg.getQuestsList(),
    proto.quests.RegistryItem.Quest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Limited}
 */
proto.quests.RegistryItem.QuestsGroup.Limited.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.QuestsGroup.Limited;
  return proto.quests.RegistryItem.QuestsGroup.Limited.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Limited} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Limited}
 */
proto.quests.RegistryItem.QuestsGroup.Limited.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.Quest;
      reader.readMessage(value,proto.quests.RegistryItem.Quest.deserializeBinaryFromReader);
      msg.addQuests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.QuestsGroup.Limited.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.QuestsGroup.Limited.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Limited} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Limited.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.quests.RegistryItem.Quest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Quest quests = 1;
 * @return {!Array<!proto.quests.RegistryItem.Quest>}
 */
proto.quests.RegistryItem.QuestsGroup.Limited.prototype.getQuestsList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.Quest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.Quest, 1));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.Quest>} value
 * @return {!proto.quests.RegistryItem.QuestsGroup.Limited} returns this
*/
proto.quests.RegistryItem.QuestsGroup.Limited.prototype.setQuestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.RegistryItem.Quest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Quest}
 */
proto.quests.RegistryItem.QuestsGroup.Limited.prototype.addQuests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.RegistryItem.Quest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Limited} returns this
 */
proto.quests.RegistryItem.QuestsGroup.Limited.prototype.clearQuestsList = function() {
  return this.setQuestsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.RegistryItem.QuestsGroup.Special.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.QuestsGroup.Special.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.QuestsGroup.Special.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.QuestsGroup.Special} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Special.toObject = function(includeInstance, msg) {
  var f, obj = {
    questsList: jspb.Message.toObjectList(msg.getQuestsList(),
    proto.quests.RegistryItem.Quest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Special}
 */
proto.quests.RegistryItem.QuestsGroup.Special.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.QuestsGroup.Special;
  return proto.quests.RegistryItem.QuestsGroup.Special.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Special} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Special}
 */
proto.quests.RegistryItem.QuestsGroup.Special.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.Quest;
      reader.readMessage(value,proto.quests.RegistryItem.Quest.deserializeBinaryFromReader);
      msg.addQuests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.QuestsGroup.Special.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.QuestsGroup.Special.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.QuestsGroup.Special} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.QuestsGroup.Special.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.quests.RegistryItem.Quest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Quest quests = 1;
 * @return {!Array<!proto.quests.RegistryItem.Quest>}
 */
proto.quests.RegistryItem.QuestsGroup.Special.prototype.getQuestsList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.Quest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.Quest, 1));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.Quest>} value
 * @return {!proto.quests.RegistryItem.QuestsGroup.Special} returns this
*/
proto.quests.RegistryItem.QuestsGroup.Special.prototype.setQuestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.RegistryItem.Quest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Quest}
 */
proto.quests.RegistryItem.QuestsGroup.Special.prototype.addQuests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.RegistryItem.Quest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.RegistryItem.QuestsGroup.Special} returns this
 */
proto.quests.RegistryItem.QuestsGroup.Special.prototype.clearQuestsList = function() {
  return this.setQuestsList([]);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.quests.RegistryItem.QuestsGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.QuestsGroup} returns this
 */
proto.quests.RegistryItem.QuestsGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string descriptionKey = 2;
 * @return {string}
 */
proto.quests.RegistryItem.QuestsGroup.prototype.getDescriptionkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.QuestsGroup} returns this
 */
proto.quests.RegistryItem.QuestsGroup.prototype.setDescriptionkey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Value value = 3;
 * @return {?proto.quests.RegistryItem.QuestsGroup.Value}
 */
proto.quests.RegistryItem.QuestsGroup.prototype.getValue = function() {
  return /** @type{?proto.quests.RegistryItem.QuestsGroup.Value} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.QuestsGroup.Value, 3));
};


/**
 * @param {?proto.quests.RegistryItem.QuestsGroup.Value|undefined} value
 * @return {!proto.quests.RegistryItem.QuestsGroup} returns this
*/
proto.quests.RegistryItem.QuestsGroup.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.QuestsGroup} returns this
 */
proto.quests.RegistryItem.QuestsGroup.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.QuestsGroup.prototype.hasValue = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.RegistryItem.Quest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Quest.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Quest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Quest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Quest.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: (f = msg.getInfo()) && proto.quests.RegistryItem.Quest.Info.toObject(includeInstance, f),
    tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    proto.quests.RegistryItem.Task.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Quest}
 */
proto.quests.RegistryItem.Quest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Quest;
  return proto.quests.RegistryItem.Quest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Quest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Quest}
 */
proto.quests.RegistryItem.Quest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.Quest.Info;
      reader.readMessage(value,proto.quests.RegistryItem.Quest.Info.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = new proto.quests.RegistryItem.Task;
      reader.readMessage(value,proto.quests.RegistryItem.Task.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Quest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Quest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Quest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Quest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.quests.RegistryItem.Quest.Info.serializeBinaryToWriter
    );
  }
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.quests.RegistryItem.Task.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Quest.Info.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Quest.Info.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Quest.Info} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Quest.Info.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    descriptionKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    textKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timeRange: (f = msg.getTimeRange()) && proto.quests.TimeRange.toObject(includeInstance, f),
    reward: (f = msg.getReward()) && proto.quests.RegistryItem.Reward.toObject(includeInstance, f),
    tasksNoteKey: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Quest.Info}
 */
proto.quests.RegistryItem.Quest.Info.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Quest.Info;
  return proto.quests.RegistryItem.Quest.Info.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Quest.Info} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Quest.Info}
 */
proto.quests.RegistryItem.Quest.Info.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 5:
      var value = new proto.quests.TimeRange;
      reader.readMessage(value,proto.quests.TimeRange.deserializeBinaryFromReader);
      msg.setTimeRange(value);
      break;
    case 6:
      var value = new proto.quests.RegistryItem.Reward;
      reader.readMessage(value,proto.quests.RegistryItem.Reward.deserializeBinaryFromReader);
      msg.setReward(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasksNoteKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Quest.Info.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Quest.Info.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Quest.Info} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Quest.Info.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescriptionKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTextKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimeRange();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.quests.TimeRange.serializeBinaryToWriter
    );
  }
  f = message.getReward();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.quests.RegistryItem.Reward.serializeBinaryToWriter
    );
  }
  f = message.getTasksNoteKey();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.quests.RegistryItem.Quest.Info.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
 */
proto.quests.RegistryItem.Quest.Info.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description_key = 2;
 * @return {string}
 */
proto.quests.RegistryItem.Quest.Info.prototype.getDescriptionKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
 */
proto.quests.RegistryItem.Quest.Info.prototype.setDescriptionKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text_key = 3;
 * @return {string}
 */
proto.quests.RegistryItem.Quest.Info.prototype.getTextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
 */
proto.quests.RegistryItem.Quest.Info.prototype.setTextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string image_url = 4;
 * @return {string}
 */
proto.quests.RegistryItem.Quest.Info.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
 */
proto.quests.RegistryItem.Quest.Info.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional TimeRange time_range = 5;
 * @return {?proto.quests.TimeRange}
 */
proto.quests.RegistryItem.Quest.Info.prototype.getTimeRange = function() {
  return /** @type{?proto.quests.TimeRange} */ (
    jspb.Message.getWrapperField(this, proto.quests.TimeRange, 5));
};


/**
 * @param {?proto.quests.TimeRange|undefined} value
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
*/
proto.quests.RegistryItem.Quest.Info.prototype.setTimeRange = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
 */
proto.quests.RegistryItem.Quest.Info.prototype.clearTimeRange = function() {
  return this.setTimeRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.Quest.Info.prototype.hasTimeRange = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Reward reward = 6;
 * @return {?proto.quests.RegistryItem.Reward}
 */
proto.quests.RegistryItem.Quest.Info.prototype.getReward = function() {
  return /** @type{?proto.quests.RegistryItem.Reward} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.Reward, 6));
};


/**
 * @param {?proto.quests.RegistryItem.Reward|undefined} value
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
*/
proto.quests.RegistryItem.Quest.Info.prototype.setReward = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
 */
proto.quests.RegistryItem.Quest.Info.prototype.clearReward = function() {
  return this.setReward(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.Quest.Info.prototype.hasReward = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string tasks_note_key = 7;
 * @return {string}
 */
proto.quests.RegistryItem.Quest.Info.prototype.getTasksNoteKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Quest.Info} returns this
 */
proto.quests.RegistryItem.Quest.Info.prototype.setTasksNoteKey = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Info info = 1;
 * @return {?proto.quests.RegistryItem.Quest.Info}
 */
proto.quests.RegistryItem.Quest.prototype.getInfo = function() {
  return /** @type{?proto.quests.RegistryItem.Quest.Info} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.Quest.Info, 1));
};


/**
 * @param {?proto.quests.RegistryItem.Quest.Info|undefined} value
 * @return {!proto.quests.RegistryItem.Quest} returns this
*/
proto.quests.RegistryItem.Quest.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.Quest} returns this
 */
proto.quests.RegistryItem.Quest.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.Quest.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Task tasks = 2;
 * @return {!Array<!proto.quests.RegistryItem.Task>}
 */
proto.quests.RegistryItem.Quest.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.Task>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.Task, 2));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.Task>} value
 * @return {!proto.quests.RegistryItem.Quest} returns this
*/
proto.quests.RegistryItem.Quest.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.quests.RegistryItem.Task=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Task}
 */
proto.quests.RegistryItem.Quest.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.quests.RegistryItem.Task, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.RegistryItem.Quest} returns this
 */
proto.quests.RegistryItem.Quest.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Task.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Task.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Task} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Task.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    descriptionKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    reward: (f = msg.getReward()) && proto.quests.RegistryItem.Reward.toObject(includeInstance, f),
    progress: (f = msg.getProgress()) && proto.quests.RegistryItem.Task.Progress.toObject(includeInstance, f),
    expr: (f = msg.getExpr()) && public_quests_shared_pb.Triggers.Expression.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Task}
 */
proto.quests.RegistryItem.Task.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Task;
  return proto.quests.RegistryItem.Task.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Task} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Task}
 */
proto.quests.RegistryItem.Task.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionKey(value);
      break;
    case 3:
      var value = /** @type {!proto.quests.RegistryItem.Task.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.quests.RegistryItem.Reward;
      reader.readMessage(value,proto.quests.RegistryItem.Reward.deserializeBinaryFromReader);
      msg.setReward(value);
      break;
    case 5:
      var value = new proto.quests.RegistryItem.Task.Progress;
      reader.readMessage(value,proto.quests.RegistryItem.Task.Progress.deserializeBinaryFromReader);
      msg.setProgress(value);
      break;
    case 6:
      var value = new public_quests_shared_pb.Triggers.Expression;
      reader.readMessage(value,public_quests_shared_pb.Triggers.Expression.deserializeBinaryFromReader);
      msg.setExpr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Task.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Task.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Task} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Task.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescriptionKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getReward();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.quests.RegistryItem.Reward.serializeBinaryToWriter
    );
  }
  f = message.getProgress();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.quests.RegistryItem.Task.Progress.serializeBinaryToWriter
    );
  }
  f = message.getExpr();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      public_quests_shared_pb.Triggers.Expression.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.quests.RegistryItem.Task.Status = {
  LOCKED: 0,
  UNLOCKED: 1,
  COMPLETED: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Task.Progress.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Task.Progress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Task.Progress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Task.Progress.toObject = function(includeInstance, msg) {
  var f, obj = {
    target: jspb.Message.getFieldWithDefault(msg, 1, 0),
    current: jspb.Message.getFieldWithDefault(msg, 2, 0),
    step: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Task.Progress}
 */
proto.quests.RegistryItem.Task.Progress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Task.Progress;
  return proto.quests.RegistryItem.Task.Progress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Task.Progress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Task.Progress}
 */
proto.quests.RegistryItem.Task.Progress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTarget(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStep(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Task.Progress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Task.Progress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Task.Progress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Task.Progress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTarget();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCurrent();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getStep();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 target = 1;
 * @return {number}
 */
proto.quests.RegistryItem.Task.Progress.prototype.getTarget = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.RegistryItem.Task.Progress} returns this
 */
proto.quests.RegistryItem.Task.Progress.prototype.setTarget = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 current = 2;
 * @return {number}
 */
proto.quests.RegistryItem.Task.Progress.prototype.getCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.RegistryItem.Task.Progress} returns this
 */
proto.quests.RegistryItem.Task.Progress.prototype.setCurrent = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 step = 3;
 * @return {number}
 */
proto.quests.RegistryItem.Task.Progress.prototype.getStep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.RegistryItem.Task.Progress} returns this
 */
proto.quests.RegistryItem.Task.Progress.prototype.setStep = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.quests.RegistryItem.Task.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Task} returns this
 */
proto.quests.RegistryItem.Task.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description_key = 2;
 * @return {string}
 */
proto.quests.RegistryItem.Task.prototype.getDescriptionKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Task} returns this
 */
proto.quests.RegistryItem.Task.prototype.setDescriptionKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Status status = 3;
 * @return {!proto.quests.RegistryItem.Task.Status}
 */
proto.quests.RegistryItem.Task.prototype.getStatus = function() {
  return /** @type {!proto.quests.RegistryItem.Task.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.quests.RegistryItem.Task.Status} value
 * @return {!proto.quests.RegistryItem.Task} returns this
 */
proto.quests.RegistryItem.Task.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Reward reward = 4;
 * @return {?proto.quests.RegistryItem.Reward}
 */
proto.quests.RegistryItem.Task.prototype.getReward = function() {
  return /** @type{?proto.quests.RegistryItem.Reward} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.Reward, 4));
};


/**
 * @param {?proto.quests.RegistryItem.Reward|undefined} value
 * @return {!proto.quests.RegistryItem.Task} returns this
*/
proto.quests.RegistryItem.Task.prototype.setReward = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.Task} returns this
 */
proto.quests.RegistryItem.Task.prototype.clearReward = function() {
  return this.setReward(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.Task.prototype.hasReward = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Progress progress = 5;
 * @return {?proto.quests.RegistryItem.Task.Progress}
 */
proto.quests.RegistryItem.Task.prototype.getProgress = function() {
  return /** @type{?proto.quests.RegistryItem.Task.Progress} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.Task.Progress, 5));
};


/**
 * @param {?proto.quests.RegistryItem.Task.Progress|undefined} value
 * @return {!proto.quests.RegistryItem.Task} returns this
*/
proto.quests.RegistryItem.Task.prototype.setProgress = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.Task} returns this
 */
proto.quests.RegistryItem.Task.prototype.clearProgress = function() {
  return this.setProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.Task.prototype.hasProgress = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Triggers.Expression expr = 6;
 * @return {?proto.quests.Triggers.Expression}
 */
proto.quests.RegistryItem.Task.prototype.getExpr = function() {
  return /** @type{?proto.quests.Triggers.Expression} */ (
    jspb.Message.getWrapperField(this, public_quests_shared_pb.Triggers.Expression, 6));
};


/**
 * @param {?proto.quests.Triggers.Expression|undefined} value
 * @return {!proto.quests.RegistryItem.Task} returns this
*/
proto.quests.RegistryItem.Task.prototype.setExpr = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.Task} returns this
 */
proto.quests.RegistryItem.Task.prototype.clearExpr = function() {
  return this.setExpr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.Task.prototype.hasExpr = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.quests.RegistryItem.ActivityID.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.quests.RegistryItem.ActivityID.IdCase = {
  ID_NOT_SET: 0,
  QUEST_ID: 1,
  TASK_ID: 2
};

/**
 * @return {proto.quests.RegistryItem.ActivityID.IdCase}
 */
proto.quests.RegistryItem.ActivityID.prototype.getIdCase = function() {
  return /** @type {proto.quests.RegistryItem.ActivityID.IdCase} */(jspb.Message.computeOneofCase(this, proto.quests.RegistryItem.ActivityID.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.ActivityID.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.ActivityID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.ActivityID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.ActivityID.toObject = function(includeInstance, msg) {
  var f, obj = {
    questId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taskId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.ActivityID}
 */
proto.quests.RegistryItem.ActivityID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.ActivityID;
  return proto.quests.RegistryItem.ActivityID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.ActivityID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.ActivityID}
 */
proto.quests.RegistryItem.ActivityID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.ActivityID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.ActivityID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.ActivityID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.ActivityID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string quest_id = 1;
 * @return {string}
 */
proto.quests.RegistryItem.ActivityID.prototype.getQuestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.ActivityID} returns this
 */
proto.quests.RegistryItem.ActivityID.prototype.setQuestId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.quests.RegistryItem.ActivityID.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.quests.RegistryItem.ActivityID} returns this
 */
proto.quests.RegistryItem.ActivityID.prototype.clearQuestId = function() {
  return jspb.Message.setOneofField(this, 1, proto.quests.RegistryItem.ActivityID.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.ActivityID.prototype.hasQuestId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string task_id = 2;
 * @return {string}
 */
proto.quests.RegistryItem.ActivityID.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.ActivityID} returns this
 */
proto.quests.RegistryItem.ActivityID.prototype.setTaskId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.quests.RegistryItem.ActivityID.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.quests.RegistryItem.ActivityID} returns this
 */
proto.quests.RegistryItem.ActivityID.prototype.clearTaskId = function() {
  return jspb.Message.setOneofField(this, 2, proto.quests.RegistryItem.ActivityID.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.ActivityID.prototype.hasTaskId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.ActivityReward.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.ActivityReward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.ActivityReward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.ActivityReward.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    activityId: (f = msg.getActivityId()) && proto.quests.RegistryItem.ActivityID.toObject(includeInstance, f),
    claimed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.ActivityReward}
 */
proto.quests.RegistryItem.ActivityReward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.ActivityReward;
  return proto.quests.RegistryItem.ActivityReward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.ActivityReward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.ActivityReward}
 */
proto.quests.RegistryItem.ActivityReward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.quests.RegistryItem.ActivityID;
      reader.readMessage(value,proto.quests.RegistryItem.ActivityID.deserializeBinaryFromReader);
      msg.setActivityId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClaimed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.ActivityReward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.ActivityReward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.ActivityReward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.ActivityReward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActivityId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.quests.RegistryItem.ActivityID.serializeBinaryToWriter
    );
  }
  f = message.getClaimed();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.quests.RegistryItem.ActivityReward.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.ActivityReward} returns this
 */
proto.quests.RegistryItem.ActivityReward.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ActivityID activity_id = 2;
 * @return {?proto.quests.RegistryItem.ActivityID}
 */
proto.quests.RegistryItem.ActivityReward.prototype.getActivityId = function() {
  return /** @type{?proto.quests.RegistryItem.ActivityID} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.ActivityID, 2));
};


/**
 * @param {?proto.quests.RegistryItem.ActivityID|undefined} value
 * @return {!proto.quests.RegistryItem.ActivityReward} returns this
*/
proto.quests.RegistryItem.ActivityReward.prototype.setActivityId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.ActivityReward} returns this
 */
proto.quests.RegistryItem.ActivityReward.prototype.clearActivityId = function() {
  return this.setActivityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.ActivityReward.prototype.hasActivityId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool claimed = 3;
 * @return {boolean}
 */
proto.quests.RegistryItem.ActivityReward.prototype.getClaimed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.quests.RegistryItem.ActivityReward} returns this
 */
proto.quests.RegistryItem.ActivityReward.prototype.setClaimed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.RegistryItem.Reward.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Reward.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Reward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Reward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    currencyItems: jspb.Message.getFieldWithDefault(msg, 2, 0),
    bPoints: jspb.Message.getFieldWithDefault(msg, 3, 0),
    mintable: (f = msg.getMintable()) && proto.quests.RegistryItem.Reward.Mintable.toObject(includeInstance, f),
    shards: (f = msg.getShards()) && proto.quests.RegistryItem.Reward.Shards.toObject(includeInstance, f),
    enrichedOrbs: jspb.Message.getFieldWithDefault(msg, 6, 0),
    butter: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Reward}
 */
proto.quests.RegistryItem.Reward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Reward;
  return proto.quests.RegistryItem.Reward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Reward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Reward}
 */
proto.quests.RegistryItem.Reward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrencyItems(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBPoints(value);
      break;
    case 4:
      var value = new proto.quests.RegistryItem.Reward.Mintable;
      reader.readMessage(value,proto.quests.RegistryItem.Reward.Mintable.deserializeBinaryFromReader);
      msg.setMintable(value);
      break;
    case 5:
      var value = new proto.quests.RegistryItem.Reward.Shards;
      reader.readMessage(value,proto.quests.RegistryItem.Reward.Shards.deserializeBinaryFromReader);
      msg.setShards(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnrichedOrbs(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setButter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Reward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Reward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Reward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCurrencyItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBPoints();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMintable();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.quests.RegistryItem.Reward.Mintable.serializeBinaryToWriter
    );
  }
  f = message.getShards();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.quests.RegistryItem.Reward.Shards.serializeBinaryToWriter
    );
  }
  f = message.getEnrichedOrbs();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getButter();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.RegistryItem.Reward.Mintable.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Reward.Mintable.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Reward.Mintable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.Mintable.toObject = function(includeInstance, msg) {
  var f, obj = {
    tokensList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.quests.RegistryItem.Reward.Mintable.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Reward.Mintable}
 */
proto.quests.RegistryItem.Reward.Mintable.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Reward.Mintable;
  return proto.quests.RegistryItem.Reward.Mintable.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Reward.Mintable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Reward.Mintable}
 */
proto.quests.RegistryItem.Reward.Mintable.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTokens(value);
      break;
    case 2:
      var value = new proto.quests.RegistryItem.Reward.Mintable.Item;
      reader.readMessage(value,proto.quests.RegistryItem.Reward.Mintable.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Reward.Mintable.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Reward.Mintable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.Mintable.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTokensList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.quests.RegistryItem.Reward.Mintable.Item.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Reward.Mintable.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Reward.Mintable.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Reward.Mintable.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.Mintable.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    configId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Reward.Mintable.Item}
 */
proto.quests.RegistryItem.Reward.Mintable.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Reward.Mintable.Item;
  return proto.quests.RegistryItem.Reward.Mintable.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Reward.Mintable.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Reward.Mintable.Item}
 */
proto.quests.RegistryItem.Reward.Mintable.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Reward.Mintable.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Reward.Mintable.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Reward.Mintable.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.Mintable.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.quests.RegistryItem.Reward.Mintable.Item.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Reward.Mintable.Item} returns this
 */
proto.quests.RegistryItem.Reward.Mintable.Item.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string tokens = 1;
 * @return {!Array<string>}
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.getTokensList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.quests.RegistryItem.Reward.Mintable} returns this
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.setTokensList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Reward.Mintable} returns this
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.addTokens = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.RegistryItem.Reward.Mintable} returns this
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.clearTokensList = function() {
  return this.setTokensList([]);
};


/**
 * repeated Item items = 2;
 * @return {!Array<!proto.quests.RegistryItem.Reward.Mintable.Item>}
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.Reward.Mintable.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.Reward.Mintable.Item, 2));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.Reward.Mintable.Item>} value
 * @return {!proto.quests.RegistryItem.Reward.Mintable} returns this
*/
proto.quests.RegistryItem.Reward.Mintable.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.quests.RegistryItem.Reward.Mintable.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Reward.Mintable.Item}
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.quests.RegistryItem.Reward.Mintable.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.RegistryItem.Reward.Mintable} returns this
 */
proto.quests.RegistryItem.Reward.Mintable.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.RegistryItem.Reward.Shards.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Reward.Shards.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Reward.Shards.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Reward.Shards} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.Shards.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.quests.RegistryItem.Reward.Shards.Item.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Reward.Shards}
 */
proto.quests.RegistryItem.Reward.Shards.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Reward.Shards;
  return proto.quests.RegistryItem.Reward.Shards.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Reward.Shards} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Reward.Shards}
 */
proto.quests.RegistryItem.Reward.Shards.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.Reward.Shards.Item;
      reader.readMessage(value,proto.quests.RegistryItem.Reward.Shards.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Reward.Shards.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Reward.Shards.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Reward.Shards} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.Shards.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.quests.RegistryItem.Reward.Shards.Item.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.RegistryItem.Reward.Shards.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.RegistryItem.Reward.Shards.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.RegistryItem.Reward.Shards.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.Shards.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.RegistryItem.Reward.Shards.Item}
 */
proto.quests.RegistryItem.Reward.Shards.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.RegistryItem.Reward.Shards.Item;
  return proto.quests.RegistryItem.Reward.Shards.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.RegistryItem.Reward.Shards.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.RegistryItem.Reward.Shards.Item}
 */
proto.quests.RegistryItem.Reward.Shards.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.RegistryItem.Reward.Shards.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.RegistryItem.Reward.Shards.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.RegistryItem.Reward.Shards.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.RegistryItem.Reward.Shards.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.quests.RegistryItem.Reward.Shards.Item.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.RegistryItem.Reward.Shards.Item} returns this
 */
proto.quests.RegistryItem.Reward.Shards.Item.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.quests.RegistryItem.Reward.Shards.Item.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.RegistryItem.Reward.Shards.Item} returns this
 */
proto.quests.RegistryItem.Reward.Shards.Item.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Item items = 1;
 * @return {!Array<!proto.quests.RegistryItem.Reward.Shards.Item>}
 */
proto.quests.RegistryItem.Reward.Shards.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.quests.RegistryItem.Reward.Shards.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.RegistryItem.Reward.Shards.Item, 1));
};


/**
 * @param {!Array<!proto.quests.RegistryItem.Reward.Shards.Item>} value
 * @return {!proto.quests.RegistryItem.Reward.Shards} returns this
*/
proto.quests.RegistryItem.Reward.Shards.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.RegistryItem.Reward.Shards.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Reward.Shards.Item}
 */
proto.quests.RegistryItem.Reward.Shards.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.RegistryItem.Reward.Shards.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.RegistryItem.Reward.Shards} returns this
 */
proto.quests.RegistryItem.Reward.Shards.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * repeated string items = 1;
 * @return {!Array<string>}
 */
proto.quests.RegistryItem.Reward.prototype.getItemsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.setItemsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.addItems = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int64 currency_items = 2;
 * @return {number}
 */
proto.quests.RegistryItem.Reward.prototype.getCurrencyItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.setCurrencyItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 b_points = 3;
 * @return {number}
 */
proto.quests.RegistryItem.Reward.prototype.getBPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.setBPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Mintable mintable = 4;
 * @return {?proto.quests.RegistryItem.Reward.Mintable}
 */
proto.quests.RegistryItem.Reward.prototype.getMintable = function() {
  return /** @type{?proto.quests.RegistryItem.Reward.Mintable} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.Reward.Mintable, 4));
};


/**
 * @param {?proto.quests.RegistryItem.Reward.Mintable|undefined} value
 * @return {!proto.quests.RegistryItem.Reward} returns this
*/
proto.quests.RegistryItem.Reward.prototype.setMintable = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.clearMintable = function() {
  return this.setMintable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.Reward.prototype.hasMintable = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Shards shards = 5;
 * @return {?proto.quests.RegistryItem.Reward.Shards}
 */
proto.quests.RegistryItem.Reward.prototype.getShards = function() {
  return /** @type{?proto.quests.RegistryItem.Reward.Shards} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.Reward.Shards, 5));
};


/**
 * @param {?proto.quests.RegistryItem.Reward.Shards|undefined} value
 * @return {!proto.quests.RegistryItem.Reward} returns this
*/
proto.quests.RegistryItem.Reward.prototype.setShards = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.clearShards = function() {
  return this.setShards(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.RegistryItem.Reward.prototype.hasShards = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 enriched_orbs = 6;
 * @return {number}
 */
proto.quests.RegistryItem.Reward.prototype.getEnrichedOrbs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.setEnrichedOrbs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 butter = 7;
 * @return {number}
 */
proto.quests.RegistryItem.Reward.prototype.getButter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.RegistryItem.Reward} returns this
 */
proto.quests.RegistryItem.Reward.prototype.setButter = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.ClaimReward.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.ClaimReward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.ClaimReward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.ClaimReward.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.ClaimReward}
 */
proto.quests.ClaimReward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.ClaimReward;
  return proto.quests.ClaimReward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.ClaimReward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.ClaimReward}
 */
proto.quests.ClaimReward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.ClaimReward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.ClaimReward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.ClaimReward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.ClaimReward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.ClaimReward.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.ClaimReward.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.ClaimReward.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.ClaimReward.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    rewardId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.ClaimReward.Request}
 */
proto.quests.ClaimReward.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.ClaimReward.Request;
  return proto.quests.ClaimReward.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.ClaimReward.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.ClaimReward.Request}
 */
proto.quests.ClaimReward.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRewardId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.ClaimReward.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.ClaimReward.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.ClaimReward.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.ClaimReward.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRewardId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reward_id = 1;
 * @return {string}
 */
proto.quests.ClaimReward.Request.prototype.getRewardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.ClaimReward.Request} returns this
 */
proto.quests.ClaimReward.Request.prototype.setRewardId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.ClaimReward.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.ClaimReward.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.ClaimReward.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.ClaimReward.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    claimedReward: (f = msg.getClaimedReward()) && proto.quests.RegistryItem.Reward.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.ClaimReward.Response}
 */
proto.quests.ClaimReward.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.ClaimReward.Response;
  return proto.quests.ClaimReward.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.ClaimReward.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.ClaimReward.Response}
 */
proto.quests.ClaimReward.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.RegistryItem.Reward;
      reader.readMessage(value,proto.quests.RegistryItem.Reward.deserializeBinaryFromReader);
      msg.setClaimedReward(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.ClaimReward.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.ClaimReward.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.ClaimReward.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.ClaimReward.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimedReward();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.quests.RegistryItem.Reward.serializeBinaryToWriter
    );
  }
};


/**
 * optional RegistryItem.Reward claimed_reward = 1;
 * @return {?proto.quests.RegistryItem.Reward}
 */
proto.quests.ClaimReward.Response.prototype.getClaimedReward = function() {
  return /** @type{?proto.quests.RegistryItem.Reward} */ (
    jspb.Message.getWrapperField(this, proto.quests.RegistryItem.Reward, 1));
};


/**
 * @param {?proto.quests.RegistryItem.Reward|undefined} value
 * @return {!proto.quests.ClaimReward.Response} returns this
*/
proto.quests.ClaimReward.Response.prototype.setClaimedReward = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.ClaimReward.Response} returns this
 */
proto.quests.ClaimReward.Response.prototype.clearClaimedReward = function() {
  return this.setClaimedReward(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.ClaimReward.Response.prototype.hasClaimedReward = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.TimeRange.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.TimeRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.TimeRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.TimeRange.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    end: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.TimeRange}
 */
proto.quests.TimeRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.TimeRange;
  return proto.quests.TimeRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.TimeRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.TimeRange}
 */
proto.quests.TimeRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.TimeRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.TimeRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.TimeRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.TimeRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 start = 1;
 * @return {number}
 */
proto.quests.TimeRange.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.TimeRange} returns this
 */
proto.quests.TimeRange.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end = 2;
 * @return {number}
 */
proto.quests.TimeRange.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.TimeRange} returns this
 */
proto.quests.TimeRange.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.quests);

},{"../public/quests.shared_pb.js":86,"../validate/validate_pb.js":87,"google-protobuf":3}],86:[function(require,module,exports){
// source: public/quests.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.quests.Empty', null, global);
goog.exportSymbol('proto.quests.Triggers', null, global);
goog.exportSymbol('proto.quests.Triggers.Expression', null, global);
goog.exportSymbol('proto.quests.Triggers.ID', null, global);
goog.exportSymbol('proto.quests.Triggers.IDValue', null, global);
goog.exportSymbol('proto.quests.Triggers.IDValue.VCase', null, global);
goog.exportSymbol('proto.quests.Triggers.Op', null, global);
goog.exportSymbol('proto.quests.Triggers.Operator', null, global);
goog.exportSymbol('proto.quests.Triggers.TypedValue', null, global);
goog.exportSymbol('proto.quests.Triggers.TypedValue.KeyValue', null, global);
goog.exportSymbol('proto.quests.Triggers.TypedValue.VCase', null, global);
goog.exportSymbol('proto.quests.Ts', null, global);
goog.exportSymbol('proto.quests.UUID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.UUID.displayName = 'proto.quests.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.Ts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.Ts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.Ts.displayName = 'proto.quests.Ts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.Empty.displayName = 'proto.quests.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.Triggers = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.Triggers, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.Triggers.displayName = 'proto.quests.Triggers';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.Triggers.Expression = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.quests.Triggers.Expression.repeatedFields_, null);
};
goog.inherits(proto.quests.Triggers.Expression, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.Triggers.Expression.displayName = 'proto.quests.Triggers.Expression';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.Triggers.Operator = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.Triggers.Operator, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.Triggers.Operator.displayName = 'proto.quests.Triggers.Operator';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.Triggers.IDValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.quests.Triggers.IDValue.oneofGroups_);
};
goog.inherits(proto.quests.Triggers.IDValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.Triggers.IDValue.displayName = 'proto.quests.Triggers.IDValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.Triggers.TypedValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.quests.Triggers.TypedValue.oneofGroups_);
};
goog.inherits(proto.quests.Triggers.TypedValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.Triggers.TypedValue.displayName = 'proto.quests.Triggers.TypedValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.quests.Triggers.TypedValue.KeyValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.quests.Triggers.TypedValue.KeyValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.quests.Triggers.TypedValue.KeyValue.displayName = 'proto.quests.Triggers.TypedValue.KeyValue';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.UUID}
 */
proto.quests.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.UUID;
  return proto.quests.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.UUID}
 */
proto.quests.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.quests.UUID.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.UUID} returns this
 */
proto.quests.UUID.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.Ts.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.Ts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.Ts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Ts.toObject = function(includeInstance, msg) {
  var f, obj = {
    unix: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.Ts}
 */
proto.quests.Ts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.Ts;
  return proto.quests.Ts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.Ts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.Ts}
 */
proto.quests.Ts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.Ts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.Ts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.Ts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Ts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnix();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 unix = 1;
 * @return {number}
 */
proto.quests.Ts.prototype.getUnix = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.Ts} returns this
 */
proto.quests.Ts.prototype.setUnix = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.Empty}
 */
proto.quests.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.Empty;
  return proto.quests.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.Empty}
 */
proto.quests.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.Triggers.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.Triggers.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.Triggers} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.Triggers}
 */
proto.quests.Triggers.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.Triggers;
  return proto.quests.Triggers.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.Triggers} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.Triggers}
 */
proto.quests.Triggers.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.Triggers.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.Triggers.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.Triggers} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.quests.Triggers.ID = {
  ID_UNKNOWN: 0,
  MATCH_TYPE: 2,
  MATCH_RANK: 3,
  MATCH_KILLS: 4,
  MATCH_KILL_ITEM: 5,
  MATCH_KILL_HEADSHOTS: 6,
  MATCH_TEAM_WINNER: 7,
  MATCH_MAP: 101,
  MATCH_MODE: 102,
  PLAYER_RANK: 103,
  PLAYER_IN_WINNER_TEAM: 104,
  WEAPON_KILLS: 105,
  WEAPON_KILLS_HS: 106,
  LOADOUT_WEAPON_PROTO: 107,
  LOADOUT_OUTFIT_NFT_ATTR: 108,
  LOADOUT_WEAPON_NFT_ATTR: 109
};

/**
 * @enum {number}
 */
proto.quests.Triggers.Op = {
  OP_UNKNOWN: 0,
  EQUAL: 1,
  LESS_OR_EQUAL: 2,
  GREATER_OR_EQUAL: 3,
  LESS: 4,
  GREATER: 5
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.quests.Triggers.Expression.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.Triggers.Expression.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.Triggers.Expression.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.Triggers.Expression} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.Expression.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatorsList: jspb.Message.toObjectList(msg.getOperatorsList(),
    proto.quests.Triggers.Operator.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.Triggers.Expression}
 */
proto.quests.Triggers.Expression.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.Triggers.Expression;
  return proto.quests.Triggers.Expression.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.Triggers.Expression} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.Triggers.Expression}
 */
proto.quests.Triggers.Expression.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.Triggers.Operator;
      reader.readMessage(value,proto.quests.Triggers.Operator.deserializeBinaryFromReader);
      msg.addOperators(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.Triggers.Expression.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.Triggers.Expression.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.Triggers.Expression} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.Expression.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.quests.Triggers.Operator.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Operator operators = 1;
 * @return {!Array<!proto.quests.Triggers.Operator>}
 */
proto.quests.Triggers.Expression.prototype.getOperatorsList = function() {
  return /** @type{!Array<!proto.quests.Triggers.Operator>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.quests.Triggers.Operator, 1));
};


/**
 * @param {!Array<!proto.quests.Triggers.Operator>} value
 * @return {!proto.quests.Triggers.Expression} returns this
*/
proto.quests.Triggers.Expression.prototype.setOperatorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.quests.Triggers.Operator=} opt_value
 * @param {number=} opt_index
 * @return {!proto.quests.Triggers.Operator}
 */
proto.quests.Triggers.Expression.prototype.addOperators = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.quests.Triggers.Operator, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.quests.Triggers.Expression} returns this
 */
proto.quests.Triggers.Expression.prototype.clearOperatorsList = function() {
  return this.setOperatorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.Triggers.Operator.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.Triggers.Operator.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.Triggers.Operator} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.Operator.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.quests.Triggers.IDValue.toObject(includeInstance, f),
    op: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.Triggers.Operator}
 */
proto.quests.Triggers.Operator.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.Triggers.Operator;
  return proto.quests.Triggers.Operator.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.Triggers.Operator} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.Triggers.Operator}
 */
proto.quests.Triggers.Operator.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.quests.Triggers.IDValue;
      reader.readMessage(value,proto.quests.Triggers.IDValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {!proto.quests.Triggers.Op} */ (reader.readEnum());
      msg.setOp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.Triggers.Operator.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.Triggers.Operator.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.Triggers.Operator} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.Operator.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.quests.Triggers.IDValue.serializeBinaryToWriter
    );
  }
  f = message.getOp();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional IDValue value = 1;
 * @return {?proto.quests.Triggers.IDValue}
 */
proto.quests.Triggers.Operator.prototype.getValue = function() {
  return /** @type{?proto.quests.Triggers.IDValue} */ (
    jspb.Message.getWrapperField(this, proto.quests.Triggers.IDValue, 1));
};


/**
 * @param {?proto.quests.Triggers.IDValue|undefined} value
 * @return {!proto.quests.Triggers.Operator} returns this
*/
proto.quests.Triggers.Operator.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.Triggers.Operator} returns this
 */
proto.quests.Triggers.Operator.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.Triggers.Operator.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Op op = 2;
 * @return {!proto.quests.Triggers.Op}
 */
proto.quests.Triggers.Operator.prototype.getOp = function() {
  return /** @type {!proto.quests.Triggers.Op} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.quests.Triggers.Op} value
 * @return {!proto.quests.Triggers.Operator} returns this
 */
proto.quests.Triggers.Operator.prototype.setOp = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.quests.Triggers.IDValue.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.quests.Triggers.IDValue.VCase = {
  V_NOT_SET: 0,
  MATCH_MAP: 1,
  MATCH_MODE: 2
};

/**
 * @return {proto.quests.Triggers.IDValue.VCase}
 */
proto.quests.Triggers.IDValue.prototype.getVCase = function() {
  return /** @type {proto.quests.Triggers.IDValue.VCase} */(jspb.Message.computeOneofCase(this, proto.quests.Triggers.IDValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.Triggers.IDValue.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.Triggers.IDValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.Triggers.IDValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.IDValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchMap: jspb.Message.getFieldWithDefault(msg, 1, ""),
    matchMode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.Triggers.IDValue}
 */
proto.quests.Triggers.IDValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.Triggers.IDValue;
  return proto.quests.Triggers.IDValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.Triggers.IDValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.Triggers.IDValue}
 */
proto.quests.Triggers.IDValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchMap(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.Triggers.IDValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.Triggers.IDValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.Triggers.IDValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.IDValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string match_map = 1;
 * @return {string}
 */
proto.quests.Triggers.IDValue.prototype.getMatchMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.Triggers.IDValue} returns this
 */
proto.quests.Triggers.IDValue.prototype.setMatchMap = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.quests.Triggers.IDValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.quests.Triggers.IDValue} returns this
 */
proto.quests.Triggers.IDValue.prototype.clearMatchMap = function() {
  return jspb.Message.setOneofField(this, 1, proto.quests.Triggers.IDValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.Triggers.IDValue.prototype.hasMatchMap = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string match_mode = 2;
 * @return {string}
 */
proto.quests.Triggers.IDValue.prototype.getMatchMode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.Triggers.IDValue} returns this
 */
proto.quests.Triggers.IDValue.prototype.setMatchMode = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.quests.Triggers.IDValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.quests.Triggers.IDValue} returns this
 */
proto.quests.Triggers.IDValue.prototype.clearMatchMode = function() {
  return jspb.Message.setOneofField(this, 2, proto.quests.Triggers.IDValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.Triggers.IDValue.prototype.hasMatchMode = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.quests.Triggers.TypedValue.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.quests.Triggers.TypedValue.VCase = {
  V_NOT_SET: 0,
  I64: 1,
  STR: 2,
  KV: 3
};

/**
 * @return {proto.quests.Triggers.TypedValue.VCase}
 */
proto.quests.Triggers.TypedValue.prototype.getVCase = function() {
  return /** @type {proto.quests.Triggers.TypedValue.VCase} */(jspb.Message.computeOneofCase(this, proto.quests.Triggers.TypedValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.Triggers.TypedValue.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.Triggers.TypedValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.Triggers.TypedValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.TypedValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    i64: jspb.Message.getFieldWithDefault(msg, 1, 0),
    str: jspb.Message.getFieldWithDefault(msg, 2, ""),
    kv: (f = msg.getKv()) && proto.quests.Triggers.TypedValue.KeyValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.Triggers.TypedValue}
 */
proto.quests.Triggers.TypedValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.Triggers.TypedValue;
  return proto.quests.Triggers.TypedValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.Triggers.TypedValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.Triggers.TypedValue}
 */
proto.quests.Triggers.TypedValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setI64(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStr(value);
      break;
    case 3:
      var value = new proto.quests.Triggers.TypedValue.KeyValue;
      reader.readMessage(value,proto.quests.Triggers.TypedValue.KeyValue.deserializeBinaryFromReader);
      msg.setKv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.Triggers.TypedValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.Triggers.TypedValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.Triggers.TypedValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.TypedValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKv();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.quests.Triggers.TypedValue.KeyValue.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.quests.Triggers.TypedValue.KeyValue.prototype.toObject = function(opt_includeInstance) {
  return proto.quests.Triggers.TypedValue.KeyValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.quests.Triggers.TypedValue.KeyValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.TypedValue.KeyValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.quests.Triggers.TypedValue.KeyValue}
 */
proto.quests.Triggers.TypedValue.KeyValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.quests.Triggers.TypedValue.KeyValue;
  return proto.quests.Triggers.TypedValue.KeyValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.quests.Triggers.TypedValue.KeyValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.quests.Triggers.TypedValue.KeyValue}
 */
proto.quests.Triggers.TypedValue.KeyValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.quests.Triggers.TypedValue.KeyValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.quests.Triggers.TypedValue.KeyValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.quests.Triggers.TypedValue.KeyValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.quests.Triggers.TypedValue.KeyValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.quests.Triggers.TypedValue.KeyValue.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.Triggers.TypedValue.KeyValue} returns this
 */
proto.quests.Triggers.TypedValue.KeyValue.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.quests.Triggers.TypedValue.KeyValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.Triggers.TypedValue.KeyValue} returns this
 */
proto.quests.Triggers.TypedValue.KeyValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 i64 = 1;
 * @return {number}
 */
proto.quests.Triggers.TypedValue.prototype.getI64 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.quests.Triggers.TypedValue} returns this
 */
proto.quests.Triggers.TypedValue.prototype.setI64 = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.quests.Triggers.TypedValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.quests.Triggers.TypedValue} returns this
 */
proto.quests.Triggers.TypedValue.prototype.clearI64 = function() {
  return jspb.Message.setOneofField(this, 1, proto.quests.Triggers.TypedValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.Triggers.TypedValue.prototype.hasI64 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string str = 2;
 * @return {string}
 */
proto.quests.Triggers.TypedValue.prototype.getStr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.quests.Triggers.TypedValue} returns this
 */
proto.quests.Triggers.TypedValue.prototype.setStr = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.quests.Triggers.TypedValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.quests.Triggers.TypedValue} returns this
 */
proto.quests.Triggers.TypedValue.prototype.clearStr = function() {
  return jspb.Message.setOneofField(this, 2, proto.quests.Triggers.TypedValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.Triggers.TypedValue.prototype.hasStr = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional KeyValue kv = 3;
 * @return {?proto.quests.Triggers.TypedValue.KeyValue}
 */
proto.quests.Triggers.TypedValue.prototype.getKv = function() {
  return /** @type{?proto.quests.Triggers.TypedValue.KeyValue} */ (
    jspb.Message.getWrapperField(this, proto.quests.Triggers.TypedValue.KeyValue, 3));
};


/**
 * @param {?proto.quests.Triggers.TypedValue.KeyValue|undefined} value
 * @return {!proto.quests.Triggers.TypedValue} returns this
*/
proto.quests.Triggers.TypedValue.prototype.setKv = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.quests.Triggers.TypedValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.quests.Triggers.TypedValue} returns this
 */
proto.quests.Triggers.TypedValue.prototype.clearKv = function() {
  return this.setKv(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.quests.Triggers.TypedValue.prototype.hasKv = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.quests);

},{"../validate/validate_pb.js":87,"google-protobuf":3}],87:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],88:[function(require,module,exports){
// source: referral.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.referral.Referral', null, global);
goog.exportSymbol('proto.referral.Referral.Attributes', null, global);
goog.exportSymbol('proto.referral.Referral.Attributes.Twitch', null, global);
goog.exportSymbol('proto.referral.UUID', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Referral = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.Referral, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Referral.displayName = 'proto.referral.Referral';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Referral.Attributes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.Referral.Attributes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Referral.Attributes.displayName = 'proto.referral.Referral.Attributes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Referral.Attributes.Twitch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.Referral.Attributes.Twitch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Referral.Attributes.Twitch.displayName = 'proto.referral.Referral.Attributes.Twitch';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.UUID.displayName = 'proto.referral.UUID';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Referral.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Referral.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Referral} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Referral.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    attributes: (f = msg.getAttributes()) && proto.referral.Referral.Attributes.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Referral}
 */
proto.referral.Referral.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Referral;
  return proto.referral.Referral.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Referral} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Referral}
 */
proto.referral.Referral.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = new proto.referral.Referral.Attributes;
      reader.readMessage(value,proto.referral.Referral.Attributes.deserializeBinaryFromReader);
      msg.setAttributes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Referral.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Referral.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Referral} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Referral.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAttributes();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.referral.Referral.Attributes.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Referral.Attributes.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Referral.Attributes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Referral.Attributes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Referral.Attributes.toObject = function(includeInstance, msg) {
  var f, obj = {
    twitch: (f = msg.getTwitch()) && proto.referral.Referral.Attributes.Twitch.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Referral.Attributes}
 */
proto.referral.Referral.Attributes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Referral.Attributes;
  return proto.referral.Referral.Attributes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Referral.Attributes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Referral.Attributes}
 */
proto.referral.Referral.Attributes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.referral.Referral.Attributes.Twitch;
      reader.readMessage(value,proto.referral.Referral.Attributes.Twitch.deserializeBinaryFromReader);
      msg.setTwitch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Referral.Attributes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Referral.Attributes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Referral.Attributes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Referral.Attributes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTwitch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.referral.Referral.Attributes.Twitch.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Referral.Attributes.Twitch.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Referral.Attributes.Twitch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Referral.Attributes.Twitch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Referral.Attributes.Twitch.toObject = function(includeInstance, msg) {
  var f, obj = {
    createdAt: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    id: jspb.Message.getFieldWithDefault(msg, 3, 0),
    viewerLogin: jspb.Message.getFieldWithDefault(msg, 4, ""),
    streamerLogin: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Referral.Attributes.Twitch}
 */
proto.referral.Referral.Attributes.Twitch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Referral.Attributes.Twitch;
  return proto.referral.Referral.Attributes.Twitch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Referral.Attributes.Twitch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Referral.Attributes.Twitch}
 */
proto.referral.Referral.Attributes.Twitch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setViewerLogin(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamerLogin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Referral.Attributes.Twitch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Referral.Attributes.Twitch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Referral.Attributes.Twitch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Referral.Attributes.Twitch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getViewerLogin();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStreamerLogin();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string created_at = 1;
 * @return {string}
 */
proto.referral.Referral.Attributes.Twitch.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Referral.Attributes.Twitch} returns this
 */
proto.referral.Referral.Attributes.Twitch.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.referral.Referral.Attributes.Twitch.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Referral.Attributes.Twitch} returns this
 */
proto.referral.Referral.Attributes.Twitch.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 id = 3;
 * @return {number}
 */
proto.referral.Referral.Attributes.Twitch.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.referral.Referral.Attributes.Twitch} returns this
 */
proto.referral.Referral.Attributes.Twitch.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string viewer_login = 4;
 * @return {string}
 */
proto.referral.Referral.Attributes.Twitch.prototype.getViewerLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Referral.Attributes.Twitch} returns this
 */
proto.referral.Referral.Attributes.Twitch.prototype.setViewerLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string streamer_login = 5;
 * @return {string}
 */
proto.referral.Referral.Attributes.Twitch.prototype.getStreamerLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Referral.Attributes.Twitch} returns this
 */
proto.referral.Referral.Attributes.Twitch.prototype.setStreamerLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Twitch twitch = 1;
 * @return {?proto.referral.Referral.Attributes.Twitch}
 */
proto.referral.Referral.Attributes.prototype.getTwitch = function() {
  return /** @type{?proto.referral.Referral.Attributes.Twitch} */ (
    jspb.Message.getWrapperField(this, proto.referral.Referral.Attributes.Twitch, 1));
};


/**
 * @param {?proto.referral.Referral.Attributes.Twitch|undefined} value
 * @return {!proto.referral.Referral.Attributes} returns this
*/
proto.referral.Referral.Attributes.prototype.setTwitch = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.referral.Referral.Attributes} returns this
 */
proto.referral.Referral.Attributes.prototype.clearTwitch = function() {
  return this.setTwitch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Referral.Attributes.prototype.hasTwitch = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string campaign_id = 1;
 * @return {string}
 */
proto.referral.Referral.prototype.getCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Referral} returns this
 */
proto.referral.Referral.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Attributes attributes = 2;
 * @return {?proto.referral.Referral.Attributes}
 */
proto.referral.Referral.prototype.getAttributes = function() {
  return /** @type{?proto.referral.Referral.Attributes} */ (
    jspb.Message.getWrapperField(this, proto.referral.Referral.Attributes, 2));
};


/**
 * @param {?proto.referral.Referral.Attributes|undefined} value
 * @return {!proto.referral.Referral} returns this
*/
proto.referral.Referral.prototype.setAttributes = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.referral.Referral} returns this
 */
proto.referral.Referral.prototype.clearAttributes = function() {
  return this.setAttributes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Referral.prototype.hasAttributes = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.UUID}
 */
proto.referral.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.UUID;
  return proto.referral.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.UUID}
 */
proto.referral.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.referral.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.UUID} returns this
 */
proto.referral.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.referral);

},{"./validate/validate_pb.js":91,"google-protobuf":3}],89:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for referral
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('./validate/validate_pb.js')

var referral_shared_pb = require('./referral.shared_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.referral = require('./referral_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.referral.CampaignsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.referral.CampaignsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.referral.Get.Request,
 *   !proto.referral.Get.Response>}
 */
const methodDescriptor_Campaigns_Get = new grpc.web.MethodDescriptor(
  '/referral.Campaigns/Get',
  grpc.web.MethodType.UNARY,
  proto.referral.Get.Request,
  proto.referral.Get.Response,
  /**
   * @param {!proto.referral.Get.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.referral.Get.Response.deserializeBinary
);


/**
 * @param {!proto.referral.Get.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.referral.Get.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.referral.Get.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.referral.CampaignsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/referral.Campaigns/Get',
      request,
      metadata || {},
      methodDescriptor_Campaigns_Get,
      callback);
};


/**
 * @param {!proto.referral.Get.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.referral.Get.Response>}
 *     Promise that resolves to the response
 */
proto.referral.CampaignsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/referral.Campaigns/Get',
      request,
      metadata || {},
      methodDescriptor_Campaigns_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.referral.GetUsersActiveCampaigns.Request,
 *   !proto.referral.GetUsersActiveCampaigns.Response>}
 */
const methodDescriptor_Campaigns_GetUsersActiveCampaigns = new grpc.web.MethodDescriptor(
  '/referral.Campaigns/GetUsersActiveCampaigns',
  grpc.web.MethodType.UNARY,
  proto.referral.GetUsersActiveCampaigns.Request,
  proto.referral.GetUsersActiveCampaigns.Response,
  /**
   * @param {!proto.referral.GetUsersActiveCampaigns.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.referral.GetUsersActiveCampaigns.Response.deserializeBinary
);


/**
 * @param {!proto.referral.GetUsersActiveCampaigns.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.referral.GetUsersActiveCampaigns.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.referral.GetUsersActiveCampaigns.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.referral.CampaignsClient.prototype.getUsersActiveCampaigns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/referral.Campaigns/GetUsersActiveCampaigns',
      request,
      metadata || {},
      methodDescriptor_Campaigns_GetUsersActiveCampaigns,
      callback);
};


/**
 * @param {!proto.referral.GetUsersActiveCampaigns.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.referral.GetUsersActiveCampaigns.Response>}
 *     Promise that resolves to the response
 */
proto.referral.CampaignsPromiseClient.prototype.getUsersActiveCampaigns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/referral.Campaigns/GetUsersActiveCampaigns',
      request,
      metadata || {},
      methodDescriptor_Campaigns_GetUsersActiveCampaigns);
};


module.exports = proto.referral;


},{"./referral.shared_pb.js":88,"./referral_pb.js":90,"./validate/validate_pb.js":91,"google-protobuf/google/protobuf/timestamp_pb.js":6,"grpc-web":7}],90:[function(require,module,exports){
// source: referral.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var referral_shared_pb = require('./referral.shared_pb.js');
goog.object.extend(proto, referral_shared_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.referral.Currency', null, global);
goog.exportSymbol('proto.referral.Currency.ValueCase', null, global);
goog.exportSymbol('proto.referral.Get', null, global);
goog.exportSymbol('proto.referral.Get.Request', null, global);
goog.exportSymbol('proto.referral.Get.Response', null, global);
goog.exportSymbol('proto.referral.Get.Response.Reward', null, global);
goog.exportSymbol('proto.referral.GetUsersActiveCampaigns', null, global);
goog.exportSymbol('proto.referral.GetUsersActiveCampaigns.Request', null, global);
goog.exportSymbol('proto.referral.GetUsersActiveCampaigns.Response', null, global);
goog.exportSymbol('proto.referral.GetUsersActiveCampaigns.Response.Campaign', null, global);
goog.exportSymbol('proto.referral.Inventory', null, global);
goog.exportSymbol('proto.referral.Item', null, global);
goog.exportSymbol('proto.referral.Item.ValueCase', null, global);
goog.exportSymbol('proto.referral.Token', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.GetUsersActiveCampaigns = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.GetUsersActiveCampaigns, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.GetUsersActiveCampaigns.displayName = 'proto.referral.GetUsersActiveCampaigns';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.GetUsersActiveCampaigns.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.GetUsersActiveCampaigns.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.GetUsersActiveCampaigns.Request.displayName = 'proto.referral.GetUsersActiveCampaigns.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.GetUsersActiveCampaigns.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.referral.GetUsersActiveCampaigns.Response.repeatedFields_, null);
};
goog.inherits(proto.referral.GetUsersActiveCampaigns.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.GetUsersActiveCampaigns.Response.displayName = 'proto.referral.GetUsersActiveCampaigns.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.GetUsersActiveCampaigns.Response.Campaign, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.GetUsersActiveCampaigns.Response.Campaign.displayName = 'proto.referral.GetUsersActiveCampaigns.Response.Campaign';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Get = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.Get, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Get.displayName = 'proto.referral.Get';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Get.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.Get.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Get.Request.displayName = 'proto.referral.Get.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Get.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.referral.Get.Response.repeatedFields_, null);
};
goog.inherits(proto.referral.Get.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Get.Response.displayName = 'proto.referral.Get.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Get.Response.Reward = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.Get.Response.Reward, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Get.Response.Reward.displayName = 'proto.referral.Get.Response.Reward';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.referral.Item.oneofGroups_);
};
goog.inherits(proto.referral.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Item.displayName = 'proto.referral.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Currency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.referral.Currency.oneofGroups_);
};
goog.inherits(proto.referral.Currency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Currency.displayName = 'proto.referral.Currency';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Token = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.Token, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Token.displayName = 'proto.referral.Token';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.referral.Inventory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.referral.Inventory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.referral.Inventory.displayName = 'proto.referral.Inventory';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.GetUsersActiveCampaigns.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.GetUsersActiveCampaigns.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.GetUsersActiveCampaigns} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.GetUsersActiveCampaigns.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.GetUsersActiveCampaigns}
 */
proto.referral.GetUsersActiveCampaigns.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.GetUsersActiveCampaigns;
  return proto.referral.GetUsersActiveCampaigns.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.GetUsersActiveCampaigns} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.GetUsersActiveCampaigns}
 */
proto.referral.GetUsersActiveCampaigns.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.GetUsersActiveCampaigns.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.GetUsersActiveCampaigns.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.GetUsersActiveCampaigns} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.GetUsersActiveCampaigns.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.GetUsersActiveCampaigns.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.GetUsersActiveCampaigns.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.GetUsersActiveCampaigns.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.GetUsersActiveCampaigns.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.GetUsersActiveCampaigns.Request}
 */
proto.referral.GetUsersActiveCampaigns.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.GetUsersActiveCampaigns.Request;
  return proto.referral.GetUsersActiveCampaigns.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.GetUsersActiveCampaigns.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.GetUsersActiveCampaigns.Request}
 */
proto.referral.GetUsersActiveCampaigns.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.GetUsersActiveCampaigns.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.GetUsersActiveCampaigns.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.GetUsersActiveCampaigns.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.GetUsersActiveCampaigns.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.referral.GetUsersActiveCampaigns.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.GetUsersActiveCampaigns.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.GetUsersActiveCampaigns.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.GetUsersActiveCampaigns.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.GetUsersActiveCampaigns.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    activeCampaignsList: jspb.Message.toObjectList(msg.getActiveCampaignsList(),
    proto.referral.GetUsersActiveCampaigns.Response.Campaign.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.GetUsersActiveCampaigns.Response}
 */
proto.referral.GetUsersActiveCampaigns.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.GetUsersActiveCampaigns.Response;
  return proto.referral.GetUsersActiveCampaigns.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.GetUsersActiveCampaigns.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.GetUsersActiveCampaigns.Response}
 */
proto.referral.GetUsersActiveCampaigns.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.referral.GetUsersActiveCampaigns.Response.Campaign;
      reader.readMessage(value,proto.referral.GetUsersActiveCampaigns.Response.Campaign.deserializeBinaryFromReader);
      msg.addActiveCampaigns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.GetUsersActiveCampaigns.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.GetUsersActiveCampaigns.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.GetUsersActiveCampaigns.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.GetUsersActiveCampaigns.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActiveCampaignsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.referral.GetUsersActiveCampaigns.Response.Campaign.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.GetUsersActiveCampaigns.Response.Campaign.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.GetUsersActiveCampaigns.Response.Campaign} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    joinedAtUnix: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.GetUsersActiveCampaigns.Response.Campaign}
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.GetUsersActiveCampaigns.Response.Campaign;
  return proto.referral.GetUsersActiveCampaigns.Response.Campaign.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.GetUsersActiveCampaigns.Response.Campaign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.GetUsersActiveCampaigns.Response.Campaign}
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJoinedAtUnix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.GetUsersActiveCampaigns.Response.Campaign.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.GetUsersActiveCampaigns.Response.Campaign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJoinedAtUnix();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string campaign_id = 1;
 * @return {string}
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.prototype.getCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.GetUsersActiveCampaigns.Response.Campaign} returns this
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 joined_at_unix = 2;
 * @return {number}
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.prototype.getJoinedAtUnix = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.referral.GetUsersActiveCampaigns.Response.Campaign} returns this
 */
proto.referral.GetUsersActiveCampaigns.Response.Campaign.prototype.setJoinedAtUnix = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Campaign active_campaigns = 1;
 * @return {!Array<!proto.referral.GetUsersActiveCampaigns.Response.Campaign>}
 */
proto.referral.GetUsersActiveCampaigns.Response.prototype.getActiveCampaignsList = function() {
  return /** @type{!Array<!proto.referral.GetUsersActiveCampaigns.Response.Campaign>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.referral.GetUsersActiveCampaigns.Response.Campaign, 1));
};


/**
 * @param {!Array<!proto.referral.GetUsersActiveCampaigns.Response.Campaign>} value
 * @return {!proto.referral.GetUsersActiveCampaigns.Response} returns this
*/
proto.referral.GetUsersActiveCampaigns.Response.prototype.setActiveCampaignsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.referral.GetUsersActiveCampaigns.Response.Campaign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.referral.GetUsersActiveCampaigns.Response.Campaign}
 */
proto.referral.GetUsersActiveCampaigns.Response.prototype.addActiveCampaigns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.referral.GetUsersActiveCampaigns.Response.Campaign, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.referral.GetUsersActiveCampaigns.Response} returns this
 */
proto.referral.GetUsersActiveCampaigns.Response.prototype.clearActiveCampaignsList = function() {
  return this.setActiveCampaignsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Get.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Get.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Get} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Get.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Get}
 */
proto.referral.Get.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Get;
  return proto.referral.Get.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Get} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Get}
 */
proto.referral.Get.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Get.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Get.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Get} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Get.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Get.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Get.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Get.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Get.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Get.Request}
 */
proto.referral.Get.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Get.Request;
  return proto.referral.Get.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Get.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Get.Request}
 */
proto.referral.Get.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Get.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Get.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Get.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Get.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string campaign_id = 1;
 * @return {string}
 */
proto.referral.Get.Request.prototype.getCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Get.Request} returns this
 */
proto.referral.Get.Request.prototype.setCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.referral.Get.Response.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Get.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Get.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Get.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Get.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rewardsList: jspb.Message.toObjectList(msg.getRewardsList(),
    proto.referral.Get.Response.Reward.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Get.Response}
 */
proto.referral.Get.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Get.Response;
  return proto.referral.Get.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Get.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Get.Response}
 */
proto.referral.Get.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = new proto.referral.Get.Response.Reward;
      reader.readMessage(value,proto.referral.Get.Response.Reward.deserializeBinaryFromReader);
      msg.addRewards(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Get.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Get.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Get.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Get.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRewardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.referral.Get.Response.Reward.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Get.Response.Reward.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Get.Response.Reward.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Get.Response.Reward} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Get.Response.Reward.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    level: jspb.Message.getFieldWithDefault(msg, 3, 0),
    item: (f = msg.getItem()) && proto.referral.Item.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Get.Response.Reward}
 */
proto.referral.Get.Response.Reward.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Get.Response.Reward;
  return proto.referral.Get.Response.Reward.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Get.Response.Reward} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Get.Response.Reward}
 */
proto.referral.Get.Response.Reward.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 4:
      var value = new proto.referral.Item;
      reader.readMessage(value,proto.referral.Item.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Get.Response.Reward.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Get.Response.Reward.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Get.Response.Reward} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Get.Response.Reward.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.referral.Item.serializeBinaryToWriter
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.referral.Get.Response.Reward.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Get.Response.Reward} returns this
 */
proto.referral.Get.Response.Reward.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string image_url = 2;
 * @return {string}
 */
proto.referral.Get.Response.Reward.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Get.Response.Reward} returns this
 */
proto.referral.Get.Response.Reward.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 level = 3;
 * @return {number}
 */
proto.referral.Get.Response.Reward.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.referral.Get.Response.Reward} returns this
 */
proto.referral.Get.Response.Reward.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Item item = 4;
 * @return {?proto.referral.Item}
 */
proto.referral.Get.Response.Reward.prototype.getItem = function() {
  return /** @type{?proto.referral.Item} */ (
    jspb.Message.getWrapperField(this, proto.referral.Item, 4));
};


/**
 * @param {?proto.referral.Item|undefined} value
 * @return {!proto.referral.Get.Response.Reward} returns this
*/
proto.referral.Get.Response.Reward.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.referral.Get.Response.Reward} returns this
 */
proto.referral.Get.Response.Reward.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Get.Response.Reward.prototype.hasItem = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.referral.Get.Response.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Get.Response} returns this
 */
proto.referral.Get.Response.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Reward rewards = 2;
 * @return {!Array<!proto.referral.Get.Response.Reward>}
 */
proto.referral.Get.Response.prototype.getRewardsList = function() {
  return /** @type{!Array<!proto.referral.Get.Response.Reward>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.referral.Get.Response.Reward, 2));
};


/**
 * @param {!Array<!proto.referral.Get.Response.Reward>} value
 * @return {!proto.referral.Get.Response} returns this
*/
proto.referral.Get.Response.prototype.setRewardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.referral.Get.Response.Reward=} opt_value
 * @param {number=} opt_index
 * @return {!proto.referral.Get.Response.Reward}
 */
proto.referral.Get.Response.prototype.addRewards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.referral.Get.Response.Reward, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.referral.Get.Response} returns this
 */
proto.referral.Get.Response.prototype.clearRewardsList = function() {
  return this.setRewardsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.referral.Item.oneofGroups_ = [[1,2,4]];

/**
 * @enum {number}
 */
proto.referral.Item.ValueCase = {
  VALUE_NOT_SET: 0,
  CURRENCY: 1,
  INVENTORY: 2,
  TOKEN: 4
};

/**
 * @return {proto.referral.Item.ValueCase}
 */
proto.referral.Item.prototype.getValueCase = function() {
  return /** @type {proto.referral.Item.ValueCase} */(jspb.Message.computeOneofCase(this, proto.referral.Item.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: (f = msg.getCurrency()) && proto.referral.Currency.toObject(includeInstance, f),
    inventory: (f = msg.getInventory()) && proto.referral.Inventory.toObject(includeInstance, f),
    token: (f = msg.getToken()) && proto.referral.Token.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Item}
 */
proto.referral.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Item;
  return proto.referral.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Item}
 */
proto.referral.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.referral.Currency;
      reader.readMessage(value,proto.referral.Currency.deserializeBinaryFromReader);
      msg.setCurrency(value);
      break;
    case 2:
      var value = new proto.referral.Inventory;
      reader.readMessage(value,proto.referral.Inventory.deserializeBinaryFromReader);
      msg.setInventory(value);
      break;
    case 4:
      var value = new proto.referral.Token;
      reader.readMessage(value,proto.referral.Token.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.referral.Currency.serializeBinaryToWriter
    );
  }
  f = message.getInventory();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.referral.Inventory.serializeBinaryToWriter
    );
  }
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.referral.Token.serializeBinaryToWriter
    );
  }
};


/**
 * optional Currency currency = 1;
 * @return {?proto.referral.Currency}
 */
proto.referral.Item.prototype.getCurrency = function() {
  return /** @type{?proto.referral.Currency} */ (
    jspb.Message.getWrapperField(this, proto.referral.Currency, 1));
};


/**
 * @param {?proto.referral.Currency|undefined} value
 * @return {!proto.referral.Item} returns this
*/
proto.referral.Item.prototype.setCurrency = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.referral.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.referral.Item} returns this
 */
proto.referral.Item.prototype.clearCurrency = function() {
  return this.setCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Item.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Inventory inventory = 2;
 * @return {?proto.referral.Inventory}
 */
proto.referral.Item.prototype.getInventory = function() {
  return /** @type{?proto.referral.Inventory} */ (
    jspb.Message.getWrapperField(this, proto.referral.Inventory, 2));
};


/**
 * @param {?proto.referral.Inventory|undefined} value
 * @return {!proto.referral.Item} returns this
*/
proto.referral.Item.prototype.setInventory = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.referral.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.referral.Item} returns this
 */
proto.referral.Item.prototype.clearInventory = function() {
  return this.setInventory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Item.prototype.hasInventory = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Token token = 4;
 * @return {?proto.referral.Token}
 */
proto.referral.Item.prototype.getToken = function() {
  return /** @type{?proto.referral.Token} */ (
    jspb.Message.getWrapperField(this, proto.referral.Token, 4));
};


/**
 * @param {?proto.referral.Token|undefined} value
 * @return {!proto.referral.Item} returns this
*/
proto.referral.Item.prototype.setToken = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.referral.Item.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.referral.Item} returns this
 */
proto.referral.Item.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Item.prototype.hasToken = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.referral.Currency.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.referral.Currency.ValueCase = {
  VALUE_NOT_SET: 0,
  ORB: 1,
  ENRICHED_ORB: 2,
  BUTTER: 3
};

/**
 * @return {proto.referral.Currency.ValueCase}
 */
proto.referral.Currency.prototype.getValueCase = function() {
  return /** @type {proto.referral.Currency.ValueCase} */(jspb.Message.computeOneofCase(this, proto.referral.Currency.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Currency.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Currency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Currency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Currency.toObject = function(includeInstance, msg) {
  var f, obj = {
    orb: jspb.Message.getFieldWithDefault(msg, 1, 0),
    enrichedOrb: jspb.Message.getFieldWithDefault(msg, 2, 0),
    butter: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Currency}
 */
proto.referral.Currency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Currency;
  return proto.referral.Currency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Currency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Currency}
 */
proto.referral.Currency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrb(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnrichedOrb(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setButter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Currency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Currency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Currency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Currency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 orb = 1;
 * @return {number}
 */
proto.referral.Currency.prototype.getOrb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.referral.Currency} returns this
 */
proto.referral.Currency.prototype.setOrb = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.referral.Currency.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.referral.Currency} returns this
 */
proto.referral.Currency.prototype.clearOrb = function() {
  return jspb.Message.setOneofField(this, 1, proto.referral.Currency.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Currency.prototype.hasOrb = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 enriched_orb = 2;
 * @return {number}
 */
proto.referral.Currency.prototype.getEnrichedOrb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.referral.Currency} returns this
 */
proto.referral.Currency.prototype.setEnrichedOrb = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.referral.Currency.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.referral.Currency} returns this
 */
proto.referral.Currency.prototype.clearEnrichedOrb = function() {
  return jspb.Message.setOneofField(this, 2, proto.referral.Currency.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Currency.prototype.hasEnrichedOrb = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 butter = 3;
 * @return {number}
 */
proto.referral.Currency.prototype.getButter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.referral.Currency} returns this
 */
proto.referral.Currency.prototype.setButter = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.referral.Currency.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.referral.Currency} returns this
 */
proto.referral.Currency.prototype.clearButter = function() {
  return jspb.Message.setOneofField(this, 3, proto.referral.Currency.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Currency.prototype.hasButter = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Token.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Token.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Token} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Token.toObject = function(includeInstance, msg) {
  var f, obj = {
    configId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    level: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Token}
 */
proto.referral.Token.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Token;
  return proto.referral.Token.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Token} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Token}
 */
proto.referral.Token.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Token.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Token.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Token} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Token.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.referral.Token.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.referral.Token} returns this
 */
proto.referral.Token.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 level = 2;
 * @return {number}
 */
proto.referral.Token.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.referral.Token} returns this
 */
proto.referral.Token.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.referral.Inventory.prototype.toObject = function(opt_includeInstance) {
  return proto.referral.Inventory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.referral.Inventory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Inventory.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && referral_shared_pb.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.referral.Inventory}
 */
proto.referral.Inventory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.referral.Inventory;
  return proto.referral.Inventory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.referral.Inventory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.referral.Inventory}
 */
proto.referral.Inventory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new referral_shared_pb.UUID;
      reader.readMessage(value,referral_shared_pb.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.referral.Inventory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.referral.Inventory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.referral.Inventory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.referral.Inventory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      referral_shared_pb.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID id = 1;
 * @return {?proto.referral.UUID}
 */
proto.referral.Inventory.prototype.getId = function() {
  return /** @type{?proto.referral.UUID} */ (
    jspb.Message.getWrapperField(this, referral_shared_pb.UUID, 1));
};


/**
 * @param {?proto.referral.UUID|undefined} value
 * @return {!proto.referral.Inventory} returns this
*/
proto.referral.Inventory.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.referral.Inventory} returns this
 */
proto.referral.Inventory.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.referral.Inventory.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.referral);

},{"./referral.shared_pb.js":88,"./validate/validate_pb.js":91,"google-protobuf":3,"google-protobuf/google/protobuf/timestamp_pb.js":6}],91:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],92:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for refinery
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('./validate/validate_pb.js')
const proto = {};
proto.refinery = require('./refinery_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.refinery.RefineryServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.refinery.RefineryServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.refinery.GetStatus.Request,
 *   !proto.refinery.GetStatus.Response>}
 */
const methodDescriptor_RefineryService_GetStatus = new grpc.web.MethodDescriptor(
  '/refinery.RefineryService/GetStatus',
  grpc.web.MethodType.UNARY,
  proto.refinery.GetStatus.Request,
  proto.refinery.GetStatus.Response,
  /**
   * @param {!proto.refinery.GetStatus.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.refinery.GetStatus.Response.deserializeBinary
);


/**
 * @param {!proto.refinery.GetStatus.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.refinery.GetStatus.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.refinery.GetStatus.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.refinery.RefineryServiceClient.prototype.getStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/refinery.RefineryService/GetStatus',
      request,
      metadata || {},
      methodDescriptor_RefineryService_GetStatus,
      callback);
};


/**
 * @param {!proto.refinery.GetStatus.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.refinery.GetStatus.Response>}
 *     Promise that resolves to the response
 */
proto.refinery.RefineryServicePromiseClient.prototype.getStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/refinery.RefineryService/GetStatus',
      request,
      metadata || {},
      methodDescriptor_RefineryService_GetStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.refinery.CollectEnrichedOrbs.Request,
 *   !proto.refinery.CollectEnrichedOrbs.Response>}
 */
const methodDescriptor_RefineryService_CollectEnrichedOrbs = new grpc.web.MethodDescriptor(
  '/refinery.RefineryService/CollectEnrichedOrbs',
  grpc.web.MethodType.UNARY,
  proto.refinery.CollectEnrichedOrbs.Request,
  proto.refinery.CollectEnrichedOrbs.Response,
  /**
   * @param {!proto.refinery.CollectEnrichedOrbs.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.refinery.CollectEnrichedOrbs.Response.deserializeBinary
);


/**
 * @param {!proto.refinery.CollectEnrichedOrbs.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.refinery.CollectEnrichedOrbs.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.refinery.CollectEnrichedOrbs.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.refinery.RefineryServiceClient.prototype.collectEnrichedOrbs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/refinery.RefineryService/CollectEnrichedOrbs',
      request,
      metadata || {},
      methodDescriptor_RefineryService_CollectEnrichedOrbs,
      callback);
};


/**
 * @param {!proto.refinery.CollectEnrichedOrbs.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.refinery.CollectEnrichedOrbs.Response>}
 *     Promise that resolves to the response
 */
proto.refinery.RefineryServicePromiseClient.prototype.collectEnrichedOrbs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/refinery.RefineryService/CollectEnrichedOrbs',
      request,
      metadata || {},
      methodDescriptor_RefineryService_CollectEnrichedOrbs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.refinery.CancelRefining.Request,
 *   !proto.refinery.CancelRefining.Response>}
 */
const methodDescriptor_RefineryService_CancelRefining = new grpc.web.MethodDescriptor(
  '/refinery.RefineryService/CancelRefining',
  grpc.web.MethodType.UNARY,
  proto.refinery.CancelRefining.Request,
  proto.refinery.CancelRefining.Response,
  /**
   * @param {!proto.refinery.CancelRefining.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.refinery.CancelRefining.Response.deserializeBinary
);


/**
 * @param {!proto.refinery.CancelRefining.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.refinery.CancelRefining.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.refinery.CancelRefining.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.refinery.RefineryServiceClient.prototype.cancelRefining =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/refinery.RefineryService/CancelRefining',
      request,
      metadata || {},
      methodDescriptor_RefineryService_CancelRefining,
      callback);
};


/**
 * @param {!proto.refinery.CancelRefining.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.refinery.CancelRefining.Response>}
 *     Promise that resolves to the response
 */
proto.refinery.RefineryServicePromiseClient.prototype.cancelRefining =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/refinery.RefineryService/CancelRefining',
      request,
      metadata || {},
      methodDescriptor_RefineryService_CancelRefining);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.refinery.EnrichOrbs.Request,
 *   !proto.refinery.EnrichOrbs.Response>}
 */
const methodDescriptor_RefineryService_EnrichOrbs = new grpc.web.MethodDescriptor(
  '/refinery.RefineryService/EnrichOrbs',
  grpc.web.MethodType.UNARY,
  proto.refinery.EnrichOrbs.Request,
  proto.refinery.EnrichOrbs.Response,
  /**
   * @param {!proto.refinery.EnrichOrbs.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.refinery.EnrichOrbs.Response.deserializeBinary
);


/**
 * @param {!proto.refinery.EnrichOrbs.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.refinery.EnrichOrbs.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.refinery.EnrichOrbs.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.refinery.RefineryServiceClient.prototype.enrichOrbs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/refinery.RefineryService/EnrichOrbs',
      request,
      metadata || {},
      methodDescriptor_RefineryService_EnrichOrbs,
      callback);
};


/**
 * @param {!proto.refinery.EnrichOrbs.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.refinery.EnrichOrbs.Response>}
 *     Promise that resolves to the response
 */
proto.refinery.RefineryServicePromiseClient.prototype.enrichOrbs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/refinery.RefineryService/EnrichOrbs',
      request,
      metadata || {},
      methodDescriptor_RefineryService_EnrichOrbs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.refinery.SpeedUpRefining.Request,
 *   !proto.refinery.SpeedUpRefining.Response>}
 */
const methodDescriptor_RefineryService_SpeedUpRefining = new grpc.web.MethodDescriptor(
  '/refinery.RefineryService/SpeedUpRefining',
  grpc.web.MethodType.UNARY,
  proto.refinery.SpeedUpRefining.Request,
  proto.refinery.SpeedUpRefining.Response,
  /**
   * @param {!proto.refinery.SpeedUpRefining.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.refinery.SpeedUpRefining.Response.deserializeBinary
);


/**
 * @param {!proto.refinery.SpeedUpRefining.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.refinery.SpeedUpRefining.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.refinery.SpeedUpRefining.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.refinery.RefineryServiceClient.prototype.speedUpRefining =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/refinery.RefineryService/SpeedUpRefining',
      request,
      metadata || {},
      methodDescriptor_RefineryService_SpeedUpRefining,
      callback);
};


/**
 * @param {!proto.refinery.SpeedUpRefining.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.refinery.SpeedUpRefining.Response>}
 *     Promise that resolves to the response
 */
proto.refinery.RefineryServicePromiseClient.prototype.speedUpRefining =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/refinery.RefineryService/SpeedUpRefining',
      request,
      metadata || {},
      methodDescriptor_RefineryService_SpeedUpRefining);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.refinery.WipeHistory.Request,
 *   !proto.refinery.WipeHistory.Response>}
 */
const methodDescriptor_RefineryService_WipeHistory = new grpc.web.MethodDescriptor(
  '/refinery.RefineryService/WipeHistory',
  grpc.web.MethodType.UNARY,
  proto.refinery.WipeHistory.Request,
  proto.refinery.WipeHistory.Response,
  /**
   * @param {!proto.refinery.WipeHistory.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.refinery.WipeHistory.Response.deserializeBinary
);


/**
 * @param {!proto.refinery.WipeHistory.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.refinery.WipeHistory.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.refinery.WipeHistory.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.refinery.RefineryServiceClient.prototype.wipeHistory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/refinery.RefineryService/WipeHistory',
      request,
      metadata || {},
      methodDescriptor_RefineryService_WipeHistory,
      callback);
};


/**
 * @param {!proto.refinery.WipeHistory.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.refinery.WipeHistory.Response>}
 *     Promise that resolves to the response
 */
proto.refinery.RefineryServicePromiseClient.prototype.wipeHistory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/refinery.RefineryService/WipeHistory',
      request,
      metadata || {},
      methodDescriptor_RefineryService_WipeHistory);
};


module.exports = proto.refinery;


},{"./refinery_pb.js":93,"./validate/validate_pb.js":94,"grpc-web":7}],93:[function(require,module,exports){
// source: refinery.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.refinery.CancelRefining', null, global);
goog.exportSymbol('proto.refinery.CancelRefining.Request', null, global);
goog.exportSymbol('proto.refinery.CancelRefining.Response', null, global);
goog.exportSymbol('proto.refinery.CollectEnrichedOrbs', null, global);
goog.exportSymbol('proto.refinery.CollectEnrichedOrbs.Request', null, global);
goog.exportSymbol('proto.refinery.CollectEnrichedOrbs.Response', null, global);
goog.exportSymbol('proto.refinery.EnrichOrbs', null, global);
goog.exportSymbol('proto.refinery.EnrichOrbs.Request', null, global);
goog.exportSymbol('proto.refinery.EnrichOrbs.Response', null, global);
goog.exportSymbol('proto.refinery.GetStatus', null, global);
goog.exportSymbol('proto.refinery.GetStatus.Request', null, global);
goog.exportSymbol('proto.refinery.GetStatus.Response', null, global);
goog.exportSymbol('proto.refinery.SpeedUpRefining', null, global);
goog.exportSymbol('proto.refinery.SpeedUpRefining.Request', null, global);
goog.exportSymbol('proto.refinery.SpeedUpRefining.Response', null, global);
goog.exportSymbol('proto.refinery.Status', null, global);
goog.exportSymbol('proto.refinery.WipeHistory', null, global);
goog.exportSymbol('proto.refinery.WipeHistory.Request', null, global);
goog.exportSymbol('proto.refinery.WipeHistory.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.GetStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.GetStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.GetStatus.displayName = 'proto.refinery.GetStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.GetStatus.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.GetStatus.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.GetStatus.Request.displayName = 'proto.refinery.GetStatus.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.GetStatus.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.GetStatus.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.GetStatus.Response.displayName = 'proto.refinery.GetStatus.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.CollectEnrichedOrbs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.CollectEnrichedOrbs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.CollectEnrichedOrbs.displayName = 'proto.refinery.CollectEnrichedOrbs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.CollectEnrichedOrbs.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.CollectEnrichedOrbs.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.CollectEnrichedOrbs.Request.displayName = 'proto.refinery.CollectEnrichedOrbs.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.CollectEnrichedOrbs.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.CollectEnrichedOrbs.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.CollectEnrichedOrbs.Response.displayName = 'proto.refinery.CollectEnrichedOrbs.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.CancelRefining = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.CancelRefining, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.CancelRefining.displayName = 'proto.refinery.CancelRefining';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.CancelRefining.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.CancelRefining.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.CancelRefining.Request.displayName = 'proto.refinery.CancelRefining.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.CancelRefining.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.CancelRefining.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.CancelRefining.Response.displayName = 'proto.refinery.CancelRefining.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.EnrichOrbs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.EnrichOrbs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.EnrichOrbs.displayName = 'proto.refinery.EnrichOrbs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.EnrichOrbs.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.EnrichOrbs.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.EnrichOrbs.Request.displayName = 'proto.refinery.EnrichOrbs.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.EnrichOrbs.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.EnrichOrbs.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.EnrichOrbs.Response.displayName = 'proto.refinery.EnrichOrbs.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.SpeedUpRefining = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.SpeedUpRefining, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.SpeedUpRefining.displayName = 'proto.refinery.SpeedUpRefining';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.SpeedUpRefining.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.SpeedUpRefining.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.SpeedUpRefining.Request.displayName = 'proto.refinery.SpeedUpRefining.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.SpeedUpRefining.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.SpeedUpRefining.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.SpeedUpRefining.Response.displayName = 'proto.refinery.SpeedUpRefining.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.WipeHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.WipeHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.WipeHistory.displayName = 'proto.refinery.WipeHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.WipeHistory.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.WipeHistory.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.WipeHistory.Request.displayName = 'proto.refinery.WipeHistory.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.WipeHistory.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.WipeHistory.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.WipeHistory.Response.displayName = 'proto.refinery.WipeHistory.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.refinery.Status = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.refinery.Status, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.refinery.Status.displayName = 'proto.refinery.Status';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.GetStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.GetStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.GetStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.GetStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.GetStatus}
 */
proto.refinery.GetStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.GetStatus;
  return proto.refinery.GetStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.GetStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.GetStatus}
 */
proto.refinery.GetStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.GetStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.GetStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.GetStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.GetStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.GetStatus.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.GetStatus.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.GetStatus.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.GetStatus.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.GetStatus.Request}
 */
proto.refinery.GetStatus.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.GetStatus.Request;
  return proto.refinery.GetStatus.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.GetStatus.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.GetStatus.Request}
 */
proto.refinery.GetStatus.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.GetStatus.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.GetStatus.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.GetStatus.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.GetStatus.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.GetStatus.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.GetStatus.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.GetStatus.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.GetStatus.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = msg.getStatus()) && proto.refinery.Status.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.GetStatus.Response}
 */
proto.refinery.GetStatus.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.GetStatus.Response;
  return proto.refinery.GetStatus.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.GetStatus.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.GetStatus.Response}
 */
proto.refinery.GetStatus.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.refinery.Status;
      reader.readMessage(value,proto.refinery.Status.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.GetStatus.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.GetStatus.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.GetStatus.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.GetStatus.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.refinery.Status.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {?proto.refinery.Status}
 */
proto.refinery.GetStatus.Response.prototype.getStatus = function() {
  return /** @type{?proto.refinery.Status} */ (
    jspb.Message.getWrapperField(this, proto.refinery.Status, 1));
};


/**
 * @param {?proto.refinery.Status|undefined} value
 * @return {!proto.refinery.GetStatus.Response} returns this
*/
proto.refinery.GetStatus.Response.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.refinery.GetStatus.Response} returns this
 */
proto.refinery.GetStatus.Response.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.refinery.GetStatus.Response.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.CollectEnrichedOrbs.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.CollectEnrichedOrbs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.CollectEnrichedOrbs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CollectEnrichedOrbs.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.CollectEnrichedOrbs}
 */
proto.refinery.CollectEnrichedOrbs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.CollectEnrichedOrbs;
  return proto.refinery.CollectEnrichedOrbs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.CollectEnrichedOrbs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.CollectEnrichedOrbs}
 */
proto.refinery.CollectEnrichedOrbs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.CollectEnrichedOrbs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.CollectEnrichedOrbs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.CollectEnrichedOrbs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CollectEnrichedOrbs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.CollectEnrichedOrbs.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.CollectEnrichedOrbs.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.CollectEnrichedOrbs.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CollectEnrichedOrbs.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.CollectEnrichedOrbs.Request}
 */
proto.refinery.CollectEnrichedOrbs.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.CollectEnrichedOrbs.Request;
  return proto.refinery.CollectEnrichedOrbs.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.CollectEnrichedOrbs.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.CollectEnrichedOrbs.Request}
 */
proto.refinery.CollectEnrichedOrbs.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.CollectEnrichedOrbs.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.CollectEnrichedOrbs.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.CollectEnrichedOrbs.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CollectEnrichedOrbs.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.refinery.CollectEnrichedOrbs.Request.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.refinery.CollectEnrichedOrbs.Request} returns this
 */
proto.refinery.CollectEnrichedOrbs.Request.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.CollectEnrichedOrbs.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.CollectEnrichedOrbs.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.CollectEnrichedOrbs.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CollectEnrichedOrbs.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = msg.getStatus()) && proto.refinery.Status.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.CollectEnrichedOrbs.Response}
 */
proto.refinery.CollectEnrichedOrbs.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.CollectEnrichedOrbs.Response;
  return proto.refinery.CollectEnrichedOrbs.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.CollectEnrichedOrbs.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.CollectEnrichedOrbs.Response}
 */
proto.refinery.CollectEnrichedOrbs.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.refinery.Status;
      reader.readMessage(value,proto.refinery.Status.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.CollectEnrichedOrbs.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.CollectEnrichedOrbs.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.CollectEnrichedOrbs.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CollectEnrichedOrbs.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.refinery.Status.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {?proto.refinery.Status}
 */
proto.refinery.CollectEnrichedOrbs.Response.prototype.getStatus = function() {
  return /** @type{?proto.refinery.Status} */ (
    jspb.Message.getWrapperField(this, proto.refinery.Status, 1));
};


/**
 * @param {?proto.refinery.Status|undefined} value
 * @return {!proto.refinery.CollectEnrichedOrbs.Response} returns this
*/
proto.refinery.CollectEnrichedOrbs.Response.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.refinery.CollectEnrichedOrbs.Response} returns this
 */
proto.refinery.CollectEnrichedOrbs.Response.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.refinery.CollectEnrichedOrbs.Response.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.CancelRefining.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.CancelRefining.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.CancelRefining} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CancelRefining.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.CancelRefining}
 */
proto.refinery.CancelRefining.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.CancelRefining;
  return proto.refinery.CancelRefining.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.CancelRefining} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.CancelRefining}
 */
proto.refinery.CancelRefining.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.CancelRefining.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.CancelRefining.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.CancelRefining} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CancelRefining.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.CancelRefining.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.CancelRefining.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.CancelRefining.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CancelRefining.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.CancelRefining.Request}
 */
proto.refinery.CancelRefining.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.CancelRefining.Request;
  return proto.refinery.CancelRefining.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.CancelRefining.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.CancelRefining.Request}
 */
proto.refinery.CancelRefining.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.CancelRefining.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.CancelRefining.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.CancelRefining.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CancelRefining.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.refinery.CancelRefining.Request.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.refinery.CancelRefining.Request} returns this
 */
proto.refinery.CancelRefining.Request.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.CancelRefining.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.CancelRefining.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.CancelRefining.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CancelRefining.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = msg.getStatus()) && proto.refinery.Status.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.CancelRefining.Response}
 */
proto.refinery.CancelRefining.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.CancelRefining.Response;
  return proto.refinery.CancelRefining.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.CancelRefining.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.CancelRefining.Response}
 */
proto.refinery.CancelRefining.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.refinery.Status;
      reader.readMessage(value,proto.refinery.Status.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.CancelRefining.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.CancelRefining.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.CancelRefining.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.CancelRefining.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.refinery.Status.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {?proto.refinery.Status}
 */
proto.refinery.CancelRefining.Response.prototype.getStatus = function() {
  return /** @type{?proto.refinery.Status} */ (
    jspb.Message.getWrapperField(this, proto.refinery.Status, 1));
};


/**
 * @param {?proto.refinery.Status|undefined} value
 * @return {!proto.refinery.CancelRefining.Response} returns this
*/
proto.refinery.CancelRefining.Response.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.refinery.CancelRefining.Response} returns this
 */
proto.refinery.CancelRefining.Response.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.refinery.CancelRefining.Response.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.EnrichOrbs.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.EnrichOrbs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.EnrichOrbs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.EnrichOrbs.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.EnrichOrbs}
 */
proto.refinery.EnrichOrbs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.EnrichOrbs;
  return proto.refinery.EnrichOrbs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.EnrichOrbs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.EnrichOrbs}
 */
proto.refinery.EnrichOrbs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.EnrichOrbs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.EnrichOrbs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.EnrichOrbs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.EnrichOrbs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.EnrichOrbs.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.EnrichOrbs.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.EnrichOrbs.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.EnrichOrbs.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    orbsAmount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    requestId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.EnrichOrbs.Request}
 */
proto.refinery.EnrichOrbs.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.EnrichOrbs.Request;
  return proto.refinery.EnrichOrbs.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.EnrichOrbs.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.EnrichOrbs.Request}
 */
proto.refinery.EnrichOrbs.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrbsAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.EnrichOrbs.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.EnrichOrbs.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.EnrichOrbs.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.EnrichOrbs.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrbsAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 orbs_amount = 1;
 * @return {number}
 */
proto.refinery.EnrichOrbs.Request.prototype.getOrbsAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.refinery.EnrichOrbs.Request} returns this
 */
proto.refinery.EnrichOrbs.Request.prototype.setOrbsAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string request_id = 2;
 * @return {string}
 */
proto.refinery.EnrichOrbs.Request.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.refinery.EnrichOrbs.Request} returns this
 */
proto.refinery.EnrichOrbs.Request.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.EnrichOrbs.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.EnrichOrbs.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.EnrichOrbs.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.EnrichOrbs.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = msg.getStatus()) && proto.refinery.Status.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.EnrichOrbs.Response}
 */
proto.refinery.EnrichOrbs.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.EnrichOrbs.Response;
  return proto.refinery.EnrichOrbs.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.EnrichOrbs.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.EnrichOrbs.Response}
 */
proto.refinery.EnrichOrbs.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.refinery.Status;
      reader.readMessage(value,proto.refinery.Status.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.EnrichOrbs.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.EnrichOrbs.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.EnrichOrbs.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.EnrichOrbs.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.refinery.Status.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {?proto.refinery.Status}
 */
proto.refinery.EnrichOrbs.Response.prototype.getStatus = function() {
  return /** @type{?proto.refinery.Status} */ (
    jspb.Message.getWrapperField(this, proto.refinery.Status, 1));
};


/**
 * @param {?proto.refinery.Status|undefined} value
 * @return {!proto.refinery.EnrichOrbs.Response} returns this
*/
proto.refinery.EnrichOrbs.Response.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.refinery.EnrichOrbs.Response} returns this
 */
proto.refinery.EnrichOrbs.Response.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.refinery.EnrichOrbs.Response.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.SpeedUpRefining.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.SpeedUpRefining.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.SpeedUpRefining} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.SpeedUpRefining.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.SpeedUpRefining}
 */
proto.refinery.SpeedUpRefining.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.SpeedUpRefining;
  return proto.refinery.SpeedUpRefining.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.SpeedUpRefining} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.SpeedUpRefining}
 */
proto.refinery.SpeedUpRefining.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.SpeedUpRefining.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.SpeedUpRefining.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.SpeedUpRefining} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.SpeedUpRefining.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.SpeedUpRefining.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.SpeedUpRefining.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.SpeedUpRefining.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.SpeedUpRefining.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.SpeedUpRefining.Request}
 */
proto.refinery.SpeedUpRefining.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.SpeedUpRefining.Request;
  return proto.refinery.SpeedUpRefining.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.SpeedUpRefining.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.SpeedUpRefining.Request}
 */
proto.refinery.SpeedUpRefining.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.SpeedUpRefining.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.SpeedUpRefining.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.SpeedUpRefining.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.SpeedUpRefining.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.refinery.SpeedUpRefining.Request.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.refinery.SpeedUpRefining.Request} returns this
 */
proto.refinery.SpeedUpRefining.Request.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.SpeedUpRefining.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.SpeedUpRefining.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.SpeedUpRefining.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.SpeedUpRefining.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = msg.getStatus()) && proto.refinery.Status.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.SpeedUpRefining.Response}
 */
proto.refinery.SpeedUpRefining.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.SpeedUpRefining.Response;
  return proto.refinery.SpeedUpRefining.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.SpeedUpRefining.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.SpeedUpRefining.Response}
 */
proto.refinery.SpeedUpRefining.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.refinery.Status;
      reader.readMessage(value,proto.refinery.Status.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.SpeedUpRefining.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.SpeedUpRefining.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.SpeedUpRefining.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.SpeedUpRefining.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.refinery.Status.serializeBinaryToWriter
    );
  }
};


/**
 * optional Status status = 1;
 * @return {?proto.refinery.Status}
 */
proto.refinery.SpeedUpRefining.Response.prototype.getStatus = function() {
  return /** @type{?proto.refinery.Status} */ (
    jspb.Message.getWrapperField(this, proto.refinery.Status, 1));
};


/**
 * @param {?proto.refinery.Status|undefined} value
 * @return {!proto.refinery.SpeedUpRefining.Response} returns this
*/
proto.refinery.SpeedUpRefining.Response.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.refinery.SpeedUpRefining.Response} returns this
 */
proto.refinery.SpeedUpRefining.Response.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.refinery.SpeedUpRefining.Response.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.WipeHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.WipeHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.WipeHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.WipeHistory.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.WipeHistory}
 */
proto.refinery.WipeHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.WipeHistory;
  return proto.refinery.WipeHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.WipeHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.WipeHistory}
 */
proto.refinery.WipeHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.WipeHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.WipeHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.WipeHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.WipeHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.WipeHistory.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.WipeHistory.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.WipeHistory.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.WipeHistory.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.WipeHistory.Request}
 */
proto.refinery.WipeHistory.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.WipeHistory.Request;
  return proto.refinery.WipeHistory.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.WipeHistory.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.WipeHistory.Request}
 */
proto.refinery.WipeHistory.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.WipeHistory.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.WipeHistory.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.WipeHistory.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.WipeHistory.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.WipeHistory.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.WipeHistory.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.WipeHistory.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.WipeHistory.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.WipeHistory.Response}
 */
proto.refinery.WipeHistory.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.WipeHistory.Response;
  return proto.refinery.WipeHistory.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.WipeHistory.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.WipeHistory.Response}
 */
proto.refinery.WipeHistory.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.WipeHistory.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.WipeHistory.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.WipeHistory.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.WipeHistory.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.refinery.Status.prototype.toObject = function(opt_includeInstance) {
  return proto.refinery.Status.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.refinery.Status} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.Status.toObject = function(includeInstance, msg) {
  var f, obj = {
    inRefining: jspb.Message.getFieldWithDefault(msg, 1, 0),
    enrichedReadyToCollect: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nextOrbRefineAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    currentQueueFinishAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    butterToSpeedUp: jspb.Message.getFieldWithDefault(msg, 5, 0),
    requestId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    currentOrbBalance: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.refinery.Status}
 */
proto.refinery.Status.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.refinery.Status;
  return proto.refinery.Status.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.refinery.Status} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.refinery.Status}
 */
proto.refinery.Status.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInRefining(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnrichedReadyToCollect(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextOrbRefineAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentQueueFinishAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setButterToSpeedUp(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentOrbBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.refinery.Status.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.refinery.Status.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.refinery.Status} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.refinery.Status.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInRefining();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEnrichedReadyToCollect();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNextOrbRefineAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCurrentQueueFinishAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getButterToSpeedUp();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCurrentOrbBalance();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 in_refining = 1;
 * @return {number}
 */
proto.refinery.Status.prototype.getInRefining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.refinery.Status} returns this
 */
proto.refinery.Status.prototype.setInRefining = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 enriched_ready_to_collect = 2;
 * @return {number}
 */
proto.refinery.Status.prototype.getEnrichedReadyToCollect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.refinery.Status} returns this
 */
proto.refinery.Status.prototype.setEnrichedReadyToCollect = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 next_orb_refine_at = 3;
 * @return {number}
 */
proto.refinery.Status.prototype.getNextOrbRefineAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.refinery.Status} returns this
 */
proto.refinery.Status.prototype.setNextOrbRefineAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 current_queue_finish_at = 4;
 * @return {number}
 */
proto.refinery.Status.prototype.getCurrentQueueFinishAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.refinery.Status} returns this
 */
proto.refinery.Status.prototype.setCurrentQueueFinishAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 butter_to_speed_up = 5;
 * @return {number}
 */
proto.refinery.Status.prototype.getButterToSpeedUp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.refinery.Status} returns this
 */
proto.refinery.Status.prototype.setButterToSpeedUp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string request_id = 6;
 * @return {string}
 */
proto.refinery.Status.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.refinery.Status} returns this
 */
proto.refinery.Status.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 current_orb_balance = 7;
 * @return {number}
 */
proto.refinery.Status.prototype.getCurrentOrbBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.refinery.Status} returns this
 */
proto.refinery.Status.prototype.setCurrentOrbBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


goog.object.extend(exports, proto.refinery);

},{"./validate/validate_pb.js":94,"google-protobuf":3}],94:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],95:[function(require,module,exports){
// source: relay.shared.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('./validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.relay.Empty', null, global);
goog.exportSymbol('proto.relay.Event', null, global);
goog.exportSymbol('proto.relay.Timestamp', null, global);
goog.exportSymbol('proto.relay.UUID', null, global);
goog.exportSymbol('proto.relay.Version', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.relay.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.relay.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.relay.UUID.displayName = 'proto.relay.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.relay.Version = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.relay.Version, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.relay.Version.displayName = 'proto.relay.Version';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.relay.Timestamp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.relay.Timestamp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.relay.Timestamp.displayName = 'proto.relay.Timestamp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.relay.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.relay.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.relay.Event.displayName = 'proto.relay.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.relay.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.relay.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.relay.Empty.displayName = 'proto.relay.Empty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.relay.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.relay.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.relay.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.relay.UUID}
 */
proto.relay.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.relay.UUID;
  return proto.relay.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.relay.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.relay.UUID}
 */
proto.relay.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.relay.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.relay.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.relay.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.relay.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.relay.UUID} returns this
 */
proto.relay.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.relay.Version.prototype.toObject = function(opt_includeInstance) {
  return proto.relay.Version.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.relay.Version} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.Version.toObject = function(includeInstance, msg) {
  var f, obj = {
    major: jspb.Message.getFieldWithDefault(msg, 1, 0),
    minor: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.relay.Version}
 */
proto.relay.Version.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.relay.Version;
  return proto.relay.Version.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.relay.Version} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.relay.Version}
 */
proto.relay.Version.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMajor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMinor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.relay.Version.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.relay.Version.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.relay.Version} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.Version.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMajor();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMinor();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional uint32 major = 1;
 * @return {number}
 */
proto.relay.Version.prototype.getMajor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.relay.Version} returns this
 */
proto.relay.Version.prototype.setMajor = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 minor = 2;
 * @return {number}
 */
proto.relay.Version.prototype.getMinor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.relay.Version} returns this
 */
proto.relay.Version.prototype.setMinor = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.relay.Timestamp.prototype.toObject = function(opt_includeInstance) {
  return proto.relay.Timestamp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.relay.Timestamp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.Timestamp.toObject = function(includeInstance, msg) {
  var f, obj = {
    unixMilli: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.relay.Timestamp}
 */
proto.relay.Timestamp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.relay.Timestamp;
  return proto.relay.Timestamp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.relay.Timestamp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.relay.Timestamp}
 */
proto.relay.Timestamp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUnixMilli(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.relay.Timestamp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.relay.Timestamp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.relay.Timestamp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.Timestamp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnixMilli();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 unix_milli = 1;
 * @return {number}
 */
proto.relay.Timestamp.prototype.getUnixMilli = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.relay.Timestamp} returns this
 */
proto.relay.Timestamp.prototype.setUnixMilli = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.relay.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.relay.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.relay.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.Event.toObject = function(includeInstance, msg) {
  var f, obj = {
    version: (f = msg.getVersion()) && proto.relay.Version.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && proto.relay.Timestamp.toObject(includeInstance, f),
    id: (f = msg.getId()) && proto.relay.UUID.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    propertiesMap: (f = msg.getPropertiesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.relay.Event}
 */
proto.relay.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.relay.Event;
  return proto.relay.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.relay.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.relay.Event}
 */
proto.relay.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.relay.Version;
      reader.readMessage(value,proto.relay.Version.deserializeBinaryFromReader);
      msg.setVersion(value);
      break;
    case 2:
      var value = new proto.relay.Timestamp;
      reader.readMessage(value,proto.relay.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new proto.relay.UUID;
      reader.readMessage(value,proto.relay.UUID.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = msg.getPropertiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.relay.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.relay.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.relay.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.relay.Version.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.relay.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.relay.UUID.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPropertiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional Version version = 1;
 * @return {?proto.relay.Version}
 */
proto.relay.Event.prototype.getVersion = function() {
  return /** @type{?proto.relay.Version} */ (
    jspb.Message.getWrapperField(this, proto.relay.Version, 1));
};


/**
 * @param {?proto.relay.Version|undefined} value
 * @return {!proto.relay.Event} returns this
*/
proto.relay.Event.prototype.setVersion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.relay.Event} returns this
 */
proto.relay.Event.prototype.clearVersion = function() {
  return this.setVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.relay.Event.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Timestamp created_at = 2;
 * @return {?proto.relay.Timestamp}
 */
proto.relay.Event.prototype.getCreatedAt = function() {
  return /** @type{?proto.relay.Timestamp} */ (
    jspb.Message.getWrapperField(this, proto.relay.Timestamp, 2));
};


/**
 * @param {?proto.relay.Timestamp|undefined} value
 * @return {!proto.relay.Event} returns this
*/
proto.relay.Event.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.relay.Event} returns this
 */
proto.relay.Event.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.relay.Event.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UUID id = 3;
 * @return {?proto.relay.UUID}
 */
proto.relay.Event.prototype.getId = function() {
  return /** @type{?proto.relay.UUID} */ (
    jspb.Message.getWrapperField(this, proto.relay.UUID, 3));
};


/**
 * @param {?proto.relay.UUID|undefined} value
 * @return {!proto.relay.Event} returns this
*/
proto.relay.Event.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.relay.Event} returns this
 */
proto.relay.Event.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.relay.Event.prototype.hasId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.relay.Event.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.relay.Event} returns this
 */
proto.relay.Event.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * map<string, string> properties = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.relay.Event.prototype.getPropertiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.relay.Event} returns this
 */
proto.relay.Event.prototype.clearPropertiesMap = function() {
  this.getPropertiesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.relay.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.relay.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.relay.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.relay.Empty}
 */
proto.relay.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.relay.Empty;
  return proto.relay.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.relay.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.relay.Empty}
 */
proto.relay.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.relay.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.relay.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.relay.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.relay);

},{"./validate/validate_pb.js":96,"google-protobuf":3}],96:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],97:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for relay.web
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var relay_shared_pb = require('../relay.shared_pb.js')
const proto = {};
proto.relay = {};
proto.relay.web = require('./relay_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.relay.web.EventsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.relay.web.EventsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.relay.web.Push.Request,
 *   !proto.relay.Empty>}
 */
const methodDescriptor_Events_Push = new grpc.web.MethodDescriptor(
  '/relay.web.Events/Push',
  grpc.web.MethodType.UNARY,
  proto.relay.web.Push.Request,
  relay_shared_pb.Empty,
  /**
   * @param {!proto.relay.web.Push.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  relay_shared_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.relay.web.Push.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.relay.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.relay.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.relay.web.EventsClient.prototype.push =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/relay.web.Events/Push',
      request,
      metadata || {},
      methodDescriptor_Events_Push,
      callback);
};


/**
 * @param {!proto.relay.web.Push.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.relay.Empty>}
 *     Promise that resolves to the response
 */
proto.relay.web.EventsPromiseClient.prototype.push =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/relay.web.Events/Push',
      request,
      metadata || {},
      methodDescriptor_Events_Push);
};


module.exports = proto.relay.web;


},{"../relay.shared_pb.js":95,"../validate/validate_pb.js":96,"./relay_pb.js":98,"grpc-web":7}],98:[function(require,module,exports){
// source: web/relay.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var relay_shared_pb = require('../relay.shared_pb.js');
goog.object.extend(proto, relay_shared_pb);
goog.exportSymbol('proto.relay.web.Push', null, global);
goog.exportSymbol('proto.relay.web.Push.Request', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.relay.web.Push = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.relay.web.Push, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.relay.web.Push.displayName = 'proto.relay.web.Push';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.relay.web.Push.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.relay.web.Push.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.relay.web.Push.Request.displayName = 'proto.relay.web.Push.Request';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.relay.web.Push.prototype.toObject = function(opt_includeInstance) {
  return proto.relay.web.Push.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.relay.web.Push} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.web.Push.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.relay.web.Push}
 */
proto.relay.web.Push.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.relay.web.Push;
  return proto.relay.web.Push.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.relay.web.Push} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.relay.web.Push}
 */
proto.relay.web.Push.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.relay.web.Push.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.relay.web.Push.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.relay.web.Push} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.web.Push.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.relay.web.Push.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.relay.web.Push.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.relay.web.Push.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.web.Push.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    event: (f = msg.getEvent()) && relay_shared_pb.Event.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.relay.web.Push.Request}
 */
proto.relay.web.Push.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.relay.web.Push.Request;
  return proto.relay.web.Push.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.relay.web.Push.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.relay.web.Push.Request}
 */
proto.relay.web.Push.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new relay_shared_pb.Event;
      reader.readMessage(value,relay_shared_pb.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.relay.web.Push.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.relay.web.Push.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.relay.web.Push.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.relay.web.Push.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      relay_shared_pb.Event.serializeBinaryToWriter
    );
  }
};


/**
 * optional relay.Event event = 1;
 * @return {?proto.relay.Event}
 */
proto.relay.web.Push.Request.prototype.getEvent = function() {
  return /** @type{?proto.relay.Event} */ (
    jspb.Message.getWrapperField(this, relay_shared_pb.Event, 1));
};


/**
 * @param {?proto.relay.Event|undefined} value
 * @return {!proto.relay.web.Push.Request} returns this
*/
proto.relay.web.Push.Request.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.relay.web.Push.Request} returns this
 */
proto.relay.web.Push.Request.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.relay.web.Push.Request.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.relay.web);

},{"../relay.shared_pb.js":95,"../validate/validate_pb.js":96,"google-protobuf":3}],99:[function(require,module,exports){
// source: constants.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.room.GameServerParams', null, global);
goog.exportSymbol('proto.room.GameServerParams.BaseHP', null, global);
goog.exportSymbol('proto.room.GameServerParams.FireRate', null, global);
goog.exportSymbol('proto.room.GameServerParams.Gravity', null, global);
goog.exportSymbol('proto.room.GameServerParams.MagazineSize', null, global);
goog.exportSymbol('proto.room.GameServerParams.MovementSpeed', null, global);
goog.exportSymbol('proto.room.GameServerParams.RegenHPSpeed', null, global);
goog.exportSymbol('proto.room.GameServerParams.WeaponDamage', null, global);
goog.exportSymbol('proto.room.Mode', null, global);
goog.exportSymbol('proto.room.Region', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.GameServerParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.GameServerParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.GameServerParams.displayName = 'proto.room.GameServerParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.GameServerParams.prototype.toObject = function(opt_includeInstance) {
  return proto.room.GameServerParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.GameServerParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.GameServerParams.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.GameServerParams}
 */
proto.room.GameServerParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.GameServerParams;
  return proto.room.GameServerParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.GameServerParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.GameServerParams}
 */
proto.room.GameServerParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.GameServerParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.GameServerParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.GameServerParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.GameServerParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.room.GameServerParams.BaseHP = {
  HP50: 0,
  HP100: 1,
  HP200: 2
};

/**
 * @enum {number}
 */
proto.room.GameServerParams.RegenHPSpeed = {
  RHS05: 0,
  RHS1: 1,
  RHS2: 2
};

/**
 * @enum {number}
 */
proto.room.GameServerParams.MagazineSize = {
  MS05: 0,
  MS1: 1,
  MS2: 2
};

/**
 * @enum {number}
 */
proto.room.GameServerParams.MovementSpeed = {
  MOVS05: 0,
  MOVS1: 1,
  MOVS2: 2
};

/**
 * @enum {number}
 */
proto.room.GameServerParams.Gravity = {
  NORMAL: 0,
  LOW: 1,
  SPACE: 2
};

/**
 * @enum {number}
 */
proto.room.GameServerParams.FireRate = {
  R1: 0,
  R15: 1,
  R2: 2
};

/**
 * @enum {number}
 */
proto.room.GameServerParams.WeaponDamage = {
  WD1: 0,
  WD15: 1,
  WD2: 2
};

/**
 * @enum {number}
 */
proto.room.Mode = {
  BATTLE_ROYALE: 0,
  CAPTURE_THE_FLAG: 1,
  FREE_FOR_ALL: 2,
  TEAM_DEATH_MATCH: 3
};

/**
 * @enum {number}
 */
proto.room.Region = {
  EU: 0,
  NA: 1,
  SG: 2
};

goog.object.extend(exports, proto.room);

},{"google-protobuf":3}],100:[function(require,module,exports){
// source: player.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.room.Player', null, global);
goog.exportSymbol('proto.room.Player.Clan', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.Player.displayName = 'proto.room.Player';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.Player.Clan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.Player.Clan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.Player.Clan.displayName = 'proto.room.Player.Clan';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.room.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nicktail: jspb.Message.getFieldWithDefault(msg, 2, ""),
    level: jspb.Message.getFieldWithDefault(msg, 3, 0),
    clan: (f = msg.getClan()) && proto.room.Player.Clan.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 5, ""),
    avatar: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.Player}
 */
proto.room.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.Player;
  return proto.room.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.Player}
 */
proto.room.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNicktail(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    case 4:
      var value = new proto.room.Player.Clan;
      reader.readMessage(value,proto.room.Player.Clan.deserializeBinaryFromReader);
      msg.setClan(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNicktail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getClan();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.room.Player.Clan.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.Player.Clan.prototype.toObject = function(opt_includeInstance) {
  return proto.room.Player.Clan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.Player.Clan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Player.Clan.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    slug: jspb.Message.getFieldWithDefault(msg, 3, ""),
    uuid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.Player.Clan}
 */
proto.room.Player.Clan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.Player.Clan;
  return proto.room.Player.Clan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.Player.Clan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.Player.Clan}
 */
proto.room.Player.Clan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.Player.Clan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.Player.Clan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.Player.Clan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Player.Clan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.room.Player.Clan.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.Player.Clan} returns this
 */
proto.room.Player.Clan.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.room.Player.Clan.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Player.Clan} returns this
 */
proto.room.Player.Clan.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slug = 3;
 * @return {string}
 */
proto.room.Player.Clan.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Player.Clan} returns this
 */
proto.room.Player.Clan.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string uuid = 4;
 * @return {string}
 */
proto.room.Player.Clan.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Player.Clan} returns this
 */
proto.room.Player.Clan.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.room.Player.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Player} returns this
 */
proto.room.Player.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string nicktail = 2;
 * @return {string}
 */
proto.room.Player.prototype.getNicktail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Player} returns this
 */
proto.room.Player.prototype.setNicktail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 level = 3;
 * @return {number}
 */
proto.room.Player.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.Player} returns this
 */
proto.room.Player.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Clan clan = 4;
 * @return {?proto.room.Player.Clan}
 */
proto.room.Player.prototype.getClan = function() {
  return /** @type{?proto.room.Player.Clan} */ (
    jspb.Message.getWrapperField(this, proto.room.Player.Clan, 4));
};


/**
 * @param {?proto.room.Player.Clan|undefined} value
 * @return {!proto.room.Player} returns this
*/
proto.room.Player.prototype.setClan = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Player} returns this
 */
proto.room.Player.prototype.clearClan = function() {
  return this.setClan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Player.prototype.hasClan = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string id = 5;
 * @return {string}
 */
proto.room.Player.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Player} returns this
 */
proto.room.Player.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string avatar = 6;
 * @return {string}
 */
proto.room.Player.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Player} returns this
 */
proto.room.Player.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto.room);

},{"google-protobuf":3}],101:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for room
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var util_pb = require('./util_pb.js')

var player_pb = require('./player_pb.js')

var constants_pb = require('./constants_pb.js')
const proto = {};
proto.room = require('./room_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.room.RoomClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.room.RoomPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.room.CreateInfo,
 *   !proto.room.CreateInfo.Response>}
 */
const methodDescriptor_Room_Create = new grpc.web.MethodDescriptor(
  '/room.Room/Create',
  grpc.web.MethodType.UNARY,
  proto.room.CreateInfo,
  proto.room.CreateInfo.Response,
  /**
   * @param {!proto.room.CreateInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.room.CreateInfo.Response.deserializeBinary
);


/**
 * @param {!proto.room.CreateInfo} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.room.CreateInfo.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.room.CreateInfo.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.room.RoomClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/room.Room/Create',
      request,
      metadata || {},
      methodDescriptor_Room_Create,
      callback);
};


/**
 * @param {!proto.room.CreateInfo} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.room.CreateInfo.Response>}
 *     Promise that resolves to the response
 */
proto.room.RoomPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/room.Room/Create',
      request,
      metadata || {},
      methodDescriptor_Room_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.room.JoinInfo,
 *   !proto.room.Response>}
 */
const methodDescriptor_Room_Join = new grpc.web.MethodDescriptor(
  '/room.Room/Join',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.room.JoinInfo,
  proto.room.Response,
  /**
   * @param {!proto.room.JoinInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.room.Response.deserializeBinary
);


/**
 * @param {!proto.room.JoinInfo} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.room.Response>}
 *     The XHR Node Readable Stream
 */
proto.room.RoomClient.prototype.join =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/room.Room/Join',
      request,
      metadata || {},
      methodDescriptor_Room_Join);
};


/**
 * @param {!proto.room.JoinInfo} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.room.Response>}
 *     The XHR Node Readable Stream
 */
proto.room.RoomPromiseClient.prototype.join =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/room.Room/Join',
      request,
      metadata || {},
      methodDescriptor_Room_Join);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.room.ChangeRoomRequest,
 *   !proto.room.Empty>}
 */
const methodDescriptor_Room_ChangeRoom = new grpc.web.MethodDescriptor(
  '/room.Room/ChangeRoom',
  grpc.web.MethodType.UNARY,
  proto.room.ChangeRoomRequest,
  util_pb.Empty,
  /**
   * @param {!proto.room.ChangeRoomRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.room.ChangeRoomRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.room.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.room.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.room.RoomClient.prototype.changeRoom =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/room.Room/ChangeRoom',
      request,
      metadata || {},
      methodDescriptor_Room_ChangeRoom,
      callback);
};


/**
 * @param {!proto.room.ChangeRoomRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.room.Empty>}
 *     Promise that resolves to the response
 */
proto.room.RoomPromiseClient.prototype.changeRoom =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/room.Room/ChangeRoom',
      request,
      metadata || {},
      methodDescriptor_Room_ChangeRoom);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.room.KickInfo,
 *   !proto.room.Empty>}
 */
const methodDescriptor_Room_Kick = new grpc.web.MethodDescriptor(
  '/room.Room/Kick',
  grpc.web.MethodType.UNARY,
  proto.room.KickInfo,
  util_pb.Empty,
  /**
   * @param {!proto.room.KickInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.room.KickInfo} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.room.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.room.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.room.RoomClient.prototype.kick =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/room.Room/Kick',
      request,
      metadata || {},
      methodDescriptor_Room_Kick,
      callback);
};


/**
 * @param {!proto.room.KickInfo} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.room.Empty>}
 *     Promise that resolves to the response
 */
proto.room.RoomPromiseClient.prototype.kick =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/room.Room/Kick',
      request,
      metadata || {},
      methodDescriptor_Room_Kick);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.room.StartGame.Request,
 *   !proto.room.Empty>}
 */
const methodDescriptor_Room_StartGame = new grpc.web.MethodDescriptor(
  '/room.Room/StartGame',
  grpc.web.MethodType.UNARY,
  proto.room.StartGame.Request,
  util_pb.Empty,
  /**
   * @param {!proto.room.StartGame.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  util_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.room.StartGame.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.room.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.room.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.room.RoomClient.prototype.startGame =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/room.Room/StartGame',
      request,
      metadata || {},
      methodDescriptor_Room_StartGame,
      callback);
};


/**
 * @param {!proto.room.StartGame.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.room.Empty>}
 *     Promise that resolves to the response
 */
proto.room.RoomPromiseClient.prototype.startGame =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/room.Room/StartGame',
      request,
      metadata || {},
      methodDescriptor_Room_StartGame);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.room.Empty,
 *   !proto.room.ModeInfo>}
 */
const methodDescriptor_Room_GetModesInfo = new grpc.web.MethodDescriptor(
  '/room.Room/GetModesInfo',
  grpc.web.MethodType.UNARY,
  util_pb.Empty,
  proto.room.ModeInfo,
  /**
   * @param {!proto.room.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.room.ModeInfo.deserializeBinary
);


/**
 * @param {!proto.room.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.room.ModeInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.room.ModeInfo>|undefined}
 *     The XHR Node Readable Stream
 */
proto.room.RoomClient.prototype.getModesInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/room.Room/GetModesInfo',
      request,
      metadata || {},
      methodDescriptor_Room_GetModesInfo,
      callback);
};


/**
 * @param {!proto.room.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.room.ModeInfo>}
 *     Promise that resolves to the response
 */
proto.room.RoomPromiseClient.prototype.getModesInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/room.Room/GetModesInfo',
      request,
      metadata || {},
      methodDescriptor_Room_GetModesInfo);
};


module.exports = proto.room;


},{"./constants_pb.js":99,"./player_pb.js":100,"./room_pb.js":102,"./util_pb.js":104,"grpc-web":7}],102:[function(require,module,exports){
// source: room.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var util_pb = require('./util_pb.js');
goog.object.extend(proto, util_pb);
var player_pb = require('./player_pb.js');
goog.object.extend(proto, player_pb);
var constants_pb = require('./constants_pb.js');
goog.object.extend(proto, constants_pb);
goog.exportSymbol('proto.room.ChangeLeader', null, global);
goog.exportSymbol('proto.room.ChangeRoom', null, global);
goog.exportSymbol('proto.room.ChangeRoomRequest', null, global);
goog.exportSymbol('proto.room.Close', null, global);
goog.exportSymbol('proto.room.Close.Type', null, global);
goog.exportSymbol('proto.room.CreateInfo', null, global);
goog.exportSymbol('proto.room.CreateInfo.Response', null, global);
goog.exportSymbol('proto.room.Join', null, global);
goog.exportSymbol('proto.room.JoinInfo', null, global);
goog.exportSymbol('proto.room.KickInfo', null, global);
goog.exportSymbol('proto.room.Leave', null, global);
goog.exportSymbol('proto.room.ModeInfo', null, global);
goog.exportSymbol('proto.room.ModeMaps', null, global);
goog.exportSymbol('proto.room.Response', null, global);
goog.exportSymbol('proto.room.Response.MessageCase', null, global);
goog.exportSymbol('proto.room.RoomInfo', null, global);
goog.exportSymbol('proto.room.StartGame', null, global);
goog.exportSymbol('proto.room.StartGame.Request', null, global);
goog.exportSymbol('proto.room.StartInit', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.ModeMaps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.room.ModeMaps.repeatedFields_, null);
};
goog.inherits(proto.room.ModeMaps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.ModeMaps.displayName = 'proto.room.ModeMaps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.ModeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.room.ModeInfo.repeatedFields_, null);
};
goog.inherits(proto.room.ModeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.ModeInfo.displayName = 'proto.room.ModeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.CreateInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.CreateInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.CreateInfo.displayName = 'proto.room.CreateInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.CreateInfo.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.CreateInfo.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.CreateInfo.Response.displayName = 'proto.room.CreateInfo.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.KickInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.KickInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.KickInfo.displayName = 'proto.room.KickInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.JoinInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.JoinInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.JoinInfo.displayName = 'proto.room.JoinInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.StartGame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.StartGame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.StartGame.displayName = 'proto.room.StartGame';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.StartGame.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.StartGame.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.StartGame.Request.displayName = 'proto.room.StartGame.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.Join = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.room.Join.repeatedFields_, null);
};
goog.inherits(proto.room.Join, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.Join.displayName = 'proto.room.Join';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.Leave = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.Leave, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.Leave.displayName = 'proto.room.Leave';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.ChangeRoomRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.ChangeRoomRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.ChangeRoomRequest.displayName = 'proto.room.ChangeRoomRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.ChangeRoom = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.ChangeRoom, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.ChangeRoom.displayName = 'proto.room.ChangeRoom';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.Close = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.Close, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.Close.displayName = 'proto.room.Close';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.ChangeLeader = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.ChangeLeader, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.ChangeLeader.displayName = 'proto.room.ChangeLeader';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.StartInit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.StartInit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.StartInit.displayName = 'proto.room.StartInit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.room.Response.oneofGroups_);
};
goog.inherits(proto.room.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.Response.displayName = 'proto.room.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.RoomInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.RoomInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.RoomInfo.displayName = 'proto.room.RoomInfo';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.room.ModeMaps.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.ModeMaps.prototype.toObject = function(opt_includeInstance) {
  return proto.room.ModeMaps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.ModeMaps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ModeMaps.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    mapsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    matchcapacity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    teamcapacity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maxgametime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    targetkills: jspb.Message.getFieldWithDefault(msg, 6, 0),
    targetteamkills: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.ModeMaps}
 */
proto.room.ModeMaps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.ModeMaps;
  return proto.room.ModeMaps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.ModeMaps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.ModeMaps}
 */
proto.room.ModeMaps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.room.Mode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addMaps(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchcapacity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamcapacity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxgametime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTargetkills(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTargetteamkills(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.ModeMaps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.ModeMaps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.ModeMaps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ModeMaps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMapsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getMatchcapacity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTeamcapacity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMaxgametime();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTargetkills();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTargetteamkills();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional Mode mode = 1;
 * @return {!proto.room.Mode}
 */
proto.room.ModeMaps.prototype.getMode = function() {
  return /** @type {!proto.room.Mode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.room.Mode} value
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string maps = 2;
 * @return {!Array<string>}
 */
proto.room.ModeMaps.prototype.getMapsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.setMapsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.addMaps = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.clearMapsList = function() {
  return this.setMapsList([]);
};


/**
 * optional int32 matchCapacity = 3;
 * @return {number}
 */
proto.room.ModeMaps.prototype.getMatchcapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.setMatchcapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 teamCapacity = 4;
 * @return {number}
 */
proto.room.ModeMaps.prototype.getTeamcapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.setTeamcapacity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 maxGameTime = 5;
 * @return {number}
 */
proto.room.ModeMaps.prototype.getMaxgametime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.setMaxgametime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 targetKills = 6;
 * @return {number}
 */
proto.room.ModeMaps.prototype.getTargetkills = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.setTargetkills = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 targetTeamKills = 7;
 * @return {number}
 */
proto.room.ModeMaps.prototype.getTargetteamkills = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.ModeMaps} returns this
 */
proto.room.ModeMaps.prototype.setTargetteamkills = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.room.ModeInfo.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.ModeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.room.ModeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.ModeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ModeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    modemapsList: jspb.Message.toObjectList(msg.getModemapsList(),
    proto.room.ModeMaps.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.ModeInfo}
 */
proto.room.ModeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.ModeInfo;
  return proto.room.ModeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.ModeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.ModeInfo}
 */
proto.room.ModeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.room.ModeMaps;
      reader.readMessage(value,proto.room.ModeMaps.deserializeBinaryFromReader);
      msg.addModemaps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.ModeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.ModeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.ModeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ModeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModemapsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.room.ModeMaps.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ModeMaps modeMaps = 1;
 * @return {!Array<!proto.room.ModeMaps>}
 */
proto.room.ModeInfo.prototype.getModemapsList = function() {
  return /** @type{!Array<!proto.room.ModeMaps>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.room.ModeMaps, 1));
};


/**
 * @param {!Array<!proto.room.ModeMaps>} value
 * @return {!proto.room.ModeInfo} returns this
*/
proto.room.ModeInfo.prototype.setModemapsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.room.ModeMaps=} opt_value
 * @param {number=} opt_index
 * @return {!proto.room.ModeMaps}
 */
proto.room.ModeInfo.prototype.addModemaps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.room.ModeMaps, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.room.ModeInfo} returns this
 */
proto.room.ModeInfo.prototype.clearModemapsList = function() {
  return this.setModemapsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.CreateInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.room.CreateInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.CreateInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.CreateInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    region: jspb.Message.getFieldWithDefault(msg, 1, 0),
    map: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.CreateInfo}
 */
proto.room.CreateInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.CreateInfo;
  return proto.room.CreateInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.CreateInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.CreateInfo}
 */
proto.room.CreateInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.room.Region} */ (reader.readEnum());
      msg.setRegion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMap(value);
      break;
    case 3:
      var value = /** @type {!proto.room.Mode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.CreateInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.CreateInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.CreateInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.CreateInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegion();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMap();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.CreateInfo.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.room.CreateInfo.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.CreateInfo.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.CreateInfo.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timeout: jspb.Message.getFieldWithDefault(msg, 2, 0),
    maxplayers: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.CreateInfo.Response}
 */
proto.room.CreateInfo.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.CreateInfo.Response;
  return proto.room.CreateInfo.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.CreateInfo.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.CreateInfo.Response}
 */
proto.room.CreateInfo.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeout(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxplayers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.CreateInfo.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.CreateInfo.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.CreateInfo.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.CreateInfo.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimeout();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMaxplayers();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.room.CreateInfo.Response.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.CreateInfo.Response} returns this
 */
proto.room.CreateInfo.Response.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 timeout = 2;
 * @return {number}
 */
proto.room.CreateInfo.Response.prototype.getTimeout = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.CreateInfo.Response} returns this
 */
proto.room.CreateInfo.Response.prototype.setTimeout = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 maxPlayers = 3;
 * @return {number}
 */
proto.room.CreateInfo.Response.prototype.getMaxplayers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.CreateInfo.Response} returns this
 */
proto.room.CreateInfo.Response.prototype.setMaxplayers = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Region region = 1;
 * @return {!proto.room.Region}
 */
proto.room.CreateInfo.prototype.getRegion = function() {
  return /** @type {!proto.room.Region} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.room.Region} value
 * @return {!proto.room.CreateInfo} returns this
 */
proto.room.CreateInfo.prototype.setRegion = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string map = 2;
 * @return {string}
 */
proto.room.CreateInfo.prototype.getMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.CreateInfo} returns this
 */
proto.room.CreateInfo.prototype.setMap = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Mode mode = 3;
 * @return {!proto.room.Mode}
 */
proto.room.CreateInfo.prototype.getMode = function() {
  return /** @type {!proto.room.Mode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.room.Mode} value
 * @return {!proto.room.CreateInfo} returns this
 */
proto.room.CreateInfo.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.KickInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.room.KickInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.KickInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.KickInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.KickInfo}
 */
proto.room.KickInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.KickInfo;
  return proto.room.KickInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.KickInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.KickInfo}
 */
proto.room.KickInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.KickInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.KickInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.KickInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.KickInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string playerID = 1;
 * @return {string}
 */
proto.room.KickInfo.prototype.getPlayerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.KickInfo} returns this
 */
proto.room.KickInfo.prototype.setPlayerid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.JoinInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.room.JoinInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.JoinInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.JoinInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.JoinInfo}
 */
proto.room.JoinInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.JoinInfo;
  return proto.room.JoinInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.JoinInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.JoinInfo}
 */
proto.room.JoinInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.JoinInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.JoinInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.JoinInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.JoinInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string roomID = 1;
 * @return {string}
 */
proto.room.JoinInfo.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.JoinInfo} returns this
 */
proto.room.JoinInfo.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.StartGame.prototype.toObject = function(opt_includeInstance) {
  return proto.room.StartGame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.StartGame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.StartGame.toObject = function(includeInstance, msg) {
  var f, obj = {
    gameserverip: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roominfo: (f = msg.getRoominfo()) && proto.room.ChangeRoomRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.StartGame}
 */
proto.room.StartGame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.StartGame;
  return proto.room.StartGame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.StartGame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.StartGame}
 */
proto.room.StartGame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGameserverip(value);
      break;
    case 2:
      var value = new proto.room.ChangeRoomRequest;
      reader.readMessage(value,proto.room.ChangeRoomRequest.deserializeBinaryFromReader);
      msg.setRoominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.StartGame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.StartGame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.StartGame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.StartGame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameserverip();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoominfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.room.ChangeRoomRequest.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.StartGame.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.room.StartGame.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.StartGame.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.StartGame.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    repositoryBranch: jspb.Message.getFieldWithDefault(msg, 2, ""),
    releaseTag: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.StartGame.Request}
 */
proto.room.StartGame.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.StartGame.Request;
  return proto.room.StartGame.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.StartGame.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.StartGame.Request}
 */
proto.room.StartGame.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepositoryBranch(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.StartGame.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.StartGame.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.StartGame.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.StartGame.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRepositoryBranch();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReleaseTag();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string roomID = 1;
 * @return {string}
 */
proto.room.StartGame.Request.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.StartGame.Request} returns this
 */
proto.room.StartGame.Request.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string repository_branch = 2;
 * @return {string}
 */
proto.room.StartGame.Request.prototype.getRepositoryBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.StartGame.Request} returns this
 */
proto.room.StartGame.Request.prototype.setRepositoryBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string release_tag = 3;
 * @return {string}
 */
proto.room.StartGame.Request.prototype.getReleaseTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.StartGame.Request} returns this
 */
proto.room.StartGame.Request.prototype.setReleaseTag = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string gameserverIp = 1;
 * @return {string}
 */
proto.room.StartGame.prototype.getGameserverip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.StartGame} returns this
 */
proto.room.StartGame.prototype.setGameserverip = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ChangeRoomRequest roomInfo = 2;
 * @return {?proto.room.ChangeRoomRequest}
 */
proto.room.StartGame.prototype.getRoominfo = function() {
  return /** @type{?proto.room.ChangeRoomRequest} */ (
    jspb.Message.getWrapperField(this, proto.room.ChangeRoomRequest, 2));
};


/**
 * @param {?proto.room.ChangeRoomRequest|undefined} value
 * @return {!proto.room.StartGame} returns this
*/
proto.room.StartGame.prototype.setRoominfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.StartGame} returns this
 */
proto.room.StartGame.prototype.clearRoominfo = function() {
  return this.setRoominfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.StartGame.prototype.hasRoominfo = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.room.Join.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.Join.prototype.toObject = function(opt_includeInstance) {
  return proto.room.Join.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.Join} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Join.toObject = function(includeInstance, msg) {
  var f, obj = {
    playersingameList: jspb.Message.toObjectList(msg.getPlayersingameList(),
    player_pb.Player.toObject, includeInstance),
    player: (f = msg.getPlayer()) && player_pb.Player.toObject(includeInstance, f),
    roominfo: (f = msg.getRoominfo()) && proto.room.RoomInfo.toObject(includeInstance, f),
    region: jspb.Message.getFieldWithDefault(msg, 4, 0),
    map: jspb.Message.getFieldWithDefault(msg, 5, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 6, 0),
    timeout: jspb.Message.getFieldWithDefault(msg, 7, 0),
    leaderid: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.Join}
 */
proto.room.Join.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.Join;
  return proto.room.Join.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.Join} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.Join}
 */
proto.room.Join.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new player_pb.Player;
      reader.readMessage(value,player_pb.Player.deserializeBinaryFromReader);
      msg.addPlayersingame(value);
      break;
    case 2:
      var value = new player_pb.Player;
      reader.readMessage(value,player_pb.Player.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    case 3:
      var value = new proto.room.RoomInfo;
      reader.readMessage(value,proto.room.RoomInfo.deserializeBinaryFromReader);
      msg.setRoominfo(value);
      break;
    case 4:
      var value = /** @type {!proto.room.Region} */ (reader.readEnum());
      msg.setRegion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMap(value);
      break;
    case 6:
      var value = /** @type {!proto.room.Mode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeout(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeaderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.Join.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.Join.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.Join} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Join.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayersingameList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      player_pb.Player.serializeBinaryToWriter
    );
  }
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      player_pb.Player.serializeBinaryToWriter
    );
  }
  f = message.getRoominfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.room.RoomInfo.serializeBinaryToWriter
    );
  }
  f = message.getRegion();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getMap();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTimeout();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getLeaderid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * repeated Player playersInGame = 1;
 * @return {!Array<!proto.room.Player>}
 */
proto.room.Join.prototype.getPlayersingameList = function() {
  return /** @type{!Array<!proto.room.Player>} */ (
    jspb.Message.getRepeatedWrapperField(this, player_pb.Player, 1));
};


/**
 * @param {!Array<!proto.room.Player>} value
 * @return {!proto.room.Join} returns this
*/
proto.room.Join.prototype.setPlayersingameList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.room.Player=} opt_value
 * @param {number=} opt_index
 * @return {!proto.room.Player}
 */
proto.room.Join.prototype.addPlayersingame = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.room.Player, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.room.Join} returns this
 */
proto.room.Join.prototype.clearPlayersingameList = function() {
  return this.setPlayersingameList([]);
};


/**
 * optional Player player = 2;
 * @return {?proto.room.Player}
 */
proto.room.Join.prototype.getPlayer = function() {
  return /** @type{?proto.room.Player} */ (
    jspb.Message.getWrapperField(this, player_pb.Player, 2));
};


/**
 * @param {?proto.room.Player|undefined} value
 * @return {!proto.room.Join} returns this
*/
proto.room.Join.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Join} returns this
 */
proto.room.Join.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Join.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RoomInfo roomInfo = 3;
 * @return {?proto.room.RoomInfo}
 */
proto.room.Join.prototype.getRoominfo = function() {
  return /** @type{?proto.room.RoomInfo} */ (
    jspb.Message.getWrapperField(this, proto.room.RoomInfo, 3));
};


/**
 * @param {?proto.room.RoomInfo|undefined} value
 * @return {!proto.room.Join} returns this
*/
proto.room.Join.prototype.setRoominfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Join} returns this
 */
proto.room.Join.prototype.clearRoominfo = function() {
  return this.setRoominfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Join.prototype.hasRoominfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Region region = 4;
 * @return {!proto.room.Region}
 */
proto.room.Join.prototype.getRegion = function() {
  return /** @type {!proto.room.Region} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.room.Region} value
 * @return {!proto.room.Join} returns this
 */
proto.room.Join.prototype.setRegion = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string map = 5;
 * @return {string}
 */
proto.room.Join.prototype.getMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Join} returns this
 */
proto.room.Join.prototype.setMap = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Mode mode = 6;
 * @return {!proto.room.Mode}
 */
proto.room.Join.prototype.getMode = function() {
  return /** @type {!proto.room.Mode} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.room.Mode} value
 * @return {!proto.room.Join} returns this
 */
proto.room.Join.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 timeout = 7;
 * @return {number}
 */
proto.room.Join.prototype.getTimeout = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.Join} returns this
 */
proto.room.Join.prototype.setTimeout = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string leaderID = 8;
 * @return {string}
 */
proto.room.Join.prototype.getLeaderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Join} returns this
 */
proto.room.Join.prototype.setLeaderid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.Leave.prototype.toObject = function(opt_includeInstance) {
  return proto.room.Leave.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.Leave} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Leave.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.Leave}
 */
proto.room.Leave.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.Leave;
  return proto.room.Leave.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.Leave} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.Leave}
 */
proto.room.Leave.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlayerid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.Leave.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.Leave.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.Leave} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Leave.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string playerID = 1;
 * @return {string}
 */
proto.room.Leave.prototype.getPlayerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.Leave} returns this
 */
proto.room.Leave.prototype.setPlayerid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.ChangeRoomRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.room.ChangeRoomRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.ChangeRoomRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ChangeRoomRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    region: jspb.Message.getFieldWithDefault(msg, 1, 0),
    map: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    roominfo: (f = msg.getRoominfo()) && proto.room.RoomInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.ChangeRoomRequest}
 */
proto.room.ChangeRoomRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.ChangeRoomRequest;
  return proto.room.ChangeRoomRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.ChangeRoomRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.ChangeRoomRequest}
 */
proto.room.ChangeRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.room.Region} */ (reader.readEnum());
      msg.setRegion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMap(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 4:
      var value = /** @type {!proto.room.Mode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 5:
      var value = new proto.room.RoomInfo;
      reader.readMessage(value,proto.room.RoomInfo.deserializeBinaryFromReader);
      msg.setRoominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.ChangeRoomRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.ChangeRoomRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.ChangeRoomRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ChangeRoomRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegion();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMap();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getRoominfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.room.RoomInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional Region region = 1;
 * @return {!proto.room.Region}
 */
proto.room.ChangeRoomRequest.prototype.getRegion = function() {
  return /** @type {!proto.room.Region} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.room.Region} value
 * @return {!proto.room.ChangeRoomRequest} returns this
 */
proto.room.ChangeRoomRequest.prototype.setRegion = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string map = 2;
 * @return {string}
 */
proto.room.ChangeRoomRequest.prototype.getMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.ChangeRoomRequest} returns this
 */
proto.room.ChangeRoomRequest.prototype.setMap = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string roomID = 3;
 * @return {string}
 */
proto.room.ChangeRoomRequest.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.ChangeRoomRequest} returns this
 */
proto.room.ChangeRoomRequest.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Mode mode = 4;
 * @return {!proto.room.Mode}
 */
proto.room.ChangeRoomRequest.prototype.getMode = function() {
  return /** @type {!proto.room.Mode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.room.Mode} value
 * @return {!proto.room.ChangeRoomRequest} returns this
 */
proto.room.ChangeRoomRequest.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional RoomInfo roomInfo = 5;
 * @return {?proto.room.RoomInfo}
 */
proto.room.ChangeRoomRequest.prototype.getRoominfo = function() {
  return /** @type{?proto.room.RoomInfo} */ (
    jspb.Message.getWrapperField(this, proto.room.RoomInfo, 5));
};


/**
 * @param {?proto.room.RoomInfo|undefined} value
 * @return {!proto.room.ChangeRoomRequest} returns this
*/
proto.room.ChangeRoomRequest.prototype.setRoominfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.ChangeRoomRequest} returns this
 */
proto.room.ChangeRoomRequest.prototype.clearRoominfo = function() {
  return this.setRoominfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.ChangeRoomRequest.prototype.hasRoominfo = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.ChangeRoom.prototype.toObject = function(opt_includeInstance) {
  return proto.room.ChangeRoom.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.ChangeRoom} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ChangeRoom.toObject = function(includeInstance, msg) {
  var f, obj = {
    region: jspb.Message.getFieldWithDefault(msg, 1, 0),
    map: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    roominfo: (f = msg.getRoominfo()) && proto.room.RoomInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.ChangeRoom}
 */
proto.room.ChangeRoom.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.ChangeRoom;
  return proto.room.ChangeRoom.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.ChangeRoom} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.ChangeRoom}
 */
proto.room.ChangeRoom.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.room.Region} */ (reader.readEnum());
      msg.setRegion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMap(value);
      break;
    case 3:
      var value = /** @type {!proto.room.Mode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 4:
      var value = new proto.room.RoomInfo;
      reader.readMessage(value,proto.room.RoomInfo.deserializeBinaryFromReader);
      msg.setRoominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.ChangeRoom.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.ChangeRoom.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.ChangeRoom} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ChangeRoom.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegion();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMap();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRoominfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.room.RoomInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional Region region = 1;
 * @return {!proto.room.Region}
 */
proto.room.ChangeRoom.prototype.getRegion = function() {
  return /** @type {!proto.room.Region} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.room.Region} value
 * @return {!proto.room.ChangeRoom} returns this
 */
proto.room.ChangeRoom.prototype.setRegion = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string map = 2;
 * @return {string}
 */
proto.room.ChangeRoom.prototype.getMap = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.ChangeRoom} returns this
 */
proto.room.ChangeRoom.prototype.setMap = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Mode mode = 3;
 * @return {!proto.room.Mode}
 */
proto.room.ChangeRoom.prototype.getMode = function() {
  return /** @type {!proto.room.Mode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.room.Mode} value
 * @return {!proto.room.ChangeRoom} returns this
 */
proto.room.ChangeRoom.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional RoomInfo roomInfo = 4;
 * @return {?proto.room.RoomInfo}
 */
proto.room.ChangeRoom.prototype.getRoominfo = function() {
  return /** @type{?proto.room.RoomInfo} */ (
    jspb.Message.getWrapperField(this, proto.room.RoomInfo, 4));
};


/**
 * @param {?proto.room.RoomInfo|undefined} value
 * @return {!proto.room.ChangeRoom} returns this
*/
proto.room.ChangeRoom.prototype.setRoominfo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.ChangeRoom} returns this
 */
proto.room.ChangeRoom.prototype.clearRoominfo = function() {
  return this.setRoominfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.ChangeRoom.prototype.hasRoominfo = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.Close.prototype.toObject = function(opt_includeInstance) {
  return proto.room.Close.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.Close} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Close.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.Close}
 */
proto.room.Close.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.Close;
  return proto.room.Close.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.Close} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.Close}
 */
proto.room.Close.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.room.Close.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.Close.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.Close.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.Close} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Close.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.room.Close.Type = {
  TIMEOUT_EXPIRE: 0,
  KICK: 1
};

/**
 * optional Type type = 1;
 * @return {!proto.room.Close.Type}
 */
proto.room.Close.prototype.getType = function() {
  return /** @type {!proto.room.Close.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.room.Close.Type} value
 * @return {!proto.room.Close} returns this
 */
proto.room.Close.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.ChangeLeader.prototype.toObject = function(opt_includeInstance) {
  return proto.room.ChangeLeader.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.ChangeLeader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ChangeLeader.toObject = function(includeInstance, msg) {
  var f, obj = {
    leader: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.ChangeLeader}
 */
proto.room.ChangeLeader.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.ChangeLeader;
  return proto.room.ChangeLeader.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.ChangeLeader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.ChangeLeader}
 */
proto.room.ChangeLeader.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeader(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.ChangeLeader.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.ChangeLeader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.ChangeLeader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.ChangeLeader.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeader();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string leader = 1;
 * @return {string}
 */
proto.room.ChangeLeader.prototype.getLeader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.ChangeLeader} returns this
 */
proto.room.ChangeLeader.prototype.setLeader = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.StartInit.prototype.toObject = function(opt_includeInstance) {
  return proto.room.StartInit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.StartInit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.StartInit.toObject = function(includeInstance, msg) {
  var f, obj = {
    encodedsession: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.StartInit}
 */
proto.room.StartInit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.StartInit;
  return proto.room.StartInit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.StartInit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.StartInit}
 */
proto.room.StartInit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedsession(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.StartInit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.StartInit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.StartInit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.StartInit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncodedsession();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string encodedSession = 1;
 * @return {string}
 */
proto.room.StartInit.prototype.getEncodedsession = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.StartInit} returns this
 */
proto.room.StartInit.prototype.setEncodedsession = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.room.Response.oneofGroups_ = [[1,2,3,4,5,6,7]];

/**
 * @enum {number}
 */
proto.room.Response.MessageCase = {
  MESSAGE_NOT_SET: 0,
  STARTGAME: 1,
  JOIN: 2,
  LEAVE: 3,
  CHANGEROOM: 4,
  CLOSE: 5,
  CHANGELEADER: 6,
  STARTINIT: 7
};

/**
 * @return {proto.room.Response.MessageCase}
 */
proto.room.Response.prototype.getMessageCase = function() {
  return /** @type {proto.room.Response.MessageCase} */(jspb.Message.computeOneofCase(this, proto.room.Response.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.room.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    startgame: (f = msg.getStartgame()) && proto.room.StartGame.toObject(includeInstance, f),
    join: (f = msg.getJoin()) && proto.room.Join.toObject(includeInstance, f),
    leave: (f = msg.getLeave()) && proto.room.Leave.toObject(includeInstance, f),
    changeroom: (f = msg.getChangeroom()) && proto.room.ChangeRoom.toObject(includeInstance, f),
    close: (f = msg.getClose()) && proto.room.Close.toObject(includeInstance, f),
    changeleader: (f = msg.getChangeleader()) && proto.room.ChangeLeader.toObject(includeInstance, f),
    startinit: (f = msg.getStartinit()) && proto.room.StartInit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.Response}
 */
proto.room.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.Response;
  return proto.room.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.Response}
 */
proto.room.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.room.StartGame;
      reader.readMessage(value,proto.room.StartGame.deserializeBinaryFromReader);
      msg.setStartgame(value);
      break;
    case 2:
      var value = new proto.room.Join;
      reader.readMessage(value,proto.room.Join.deserializeBinaryFromReader);
      msg.setJoin(value);
      break;
    case 3:
      var value = new proto.room.Leave;
      reader.readMessage(value,proto.room.Leave.deserializeBinaryFromReader);
      msg.setLeave(value);
      break;
    case 4:
      var value = new proto.room.ChangeRoom;
      reader.readMessage(value,proto.room.ChangeRoom.deserializeBinaryFromReader);
      msg.setChangeroom(value);
      break;
    case 5:
      var value = new proto.room.Close;
      reader.readMessage(value,proto.room.Close.deserializeBinaryFromReader);
      msg.setClose(value);
      break;
    case 6:
      var value = new proto.room.ChangeLeader;
      reader.readMessage(value,proto.room.ChangeLeader.deserializeBinaryFromReader);
      msg.setChangeleader(value);
      break;
    case 7:
      var value = new proto.room.StartInit;
      reader.readMessage(value,proto.room.StartInit.deserializeBinaryFromReader);
      msg.setStartinit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartgame();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.room.StartGame.serializeBinaryToWriter
    );
  }
  f = message.getJoin();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.room.Join.serializeBinaryToWriter
    );
  }
  f = message.getLeave();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.room.Leave.serializeBinaryToWriter
    );
  }
  f = message.getChangeroom();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.room.ChangeRoom.serializeBinaryToWriter
    );
  }
  f = message.getClose();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.room.Close.serializeBinaryToWriter
    );
  }
  f = message.getChangeleader();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.room.ChangeLeader.serializeBinaryToWriter
    );
  }
  f = message.getStartinit();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.room.StartInit.serializeBinaryToWriter
    );
  }
};


/**
 * optional StartGame startGame = 1;
 * @return {?proto.room.StartGame}
 */
proto.room.Response.prototype.getStartgame = function() {
  return /** @type{?proto.room.StartGame} */ (
    jspb.Message.getWrapperField(this, proto.room.StartGame, 1));
};


/**
 * @param {?proto.room.StartGame|undefined} value
 * @return {!proto.room.Response} returns this
*/
proto.room.Response.prototype.setStartgame = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.room.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Response} returns this
 */
proto.room.Response.prototype.clearStartgame = function() {
  return this.setStartgame(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Response.prototype.hasStartgame = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Join join = 2;
 * @return {?proto.room.Join}
 */
proto.room.Response.prototype.getJoin = function() {
  return /** @type{?proto.room.Join} */ (
    jspb.Message.getWrapperField(this, proto.room.Join, 2));
};


/**
 * @param {?proto.room.Join|undefined} value
 * @return {!proto.room.Response} returns this
*/
proto.room.Response.prototype.setJoin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.room.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Response} returns this
 */
proto.room.Response.prototype.clearJoin = function() {
  return this.setJoin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Response.prototype.hasJoin = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Leave leave = 3;
 * @return {?proto.room.Leave}
 */
proto.room.Response.prototype.getLeave = function() {
  return /** @type{?proto.room.Leave} */ (
    jspb.Message.getWrapperField(this, proto.room.Leave, 3));
};


/**
 * @param {?proto.room.Leave|undefined} value
 * @return {!proto.room.Response} returns this
*/
proto.room.Response.prototype.setLeave = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.room.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Response} returns this
 */
proto.room.Response.prototype.clearLeave = function() {
  return this.setLeave(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Response.prototype.hasLeave = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ChangeRoom changeRoom = 4;
 * @return {?proto.room.ChangeRoom}
 */
proto.room.Response.prototype.getChangeroom = function() {
  return /** @type{?proto.room.ChangeRoom} */ (
    jspb.Message.getWrapperField(this, proto.room.ChangeRoom, 4));
};


/**
 * @param {?proto.room.ChangeRoom|undefined} value
 * @return {!proto.room.Response} returns this
*/
proto.room.Response.prototype.setChangeroom = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.room.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Response} returns this
 */
proto.room.Response.prototype.clearChangeroom = function() {
  return this.setChangeroom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Response.prototype.hasChangeroom = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Close close = 5;
 * @return {?proto.room.Close}
 */
proto.room.Response.prototype.getClose = function() {
  return /** @type{?proto.room.Close} */ (
    jspb.Message.getWrapperField(this, proto.room.Close, 5));
};


/**
 * @param {?proto.room.Close|undefined} value
 * @return {!proto.room.Response} returns this
*/
proto.room.Response.prototype.setClose = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.room.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Response} returns this
 */
proto.room.Response.prototype.clearClose = function() {
  return this.setClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Response.prototype.hasClose = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ChangeLeader changeLeader = 6;
 * @return {?proto.room.ChangeLeader}
 */
proto.room.Response.prototype.getChangeleader = function() {
  return /** @type{?proto.room.ChangeLeader} */ (
    jspb.Message.getWrapperField(this, proto.room.ChangeLeader, 6));
};


/**
 * @param {?proto.room.ChangeLeader|undefined} value
 * @return {!proto.room.Response} returns this
*/
proto.room.Response.prototype.setChangeleader = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.room.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Response} returns this
 */
proto.room.Response.prototype.clearChangeleader = function() {
  return this.setChangeleader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Response.prototype.hasChangeleader = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional StartInit startInit = 7;
 * @return {?proto.room.StartInit}
 */
proto.room.Response.prototype.getStartinit = function() {
  return /** @type{?proto.room.StartInit} */ (
    jspb.Message.getWrapperField(this, proto.room.StartInit, 7));
};


/**
 * @param {?proto.room.StartInit|undefined} value
 * @return {!proto.room.Response} returns this
*/
proto.room.Response.prototype.setStartinit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.room.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.Response} returns this
 */
proto.room.Response.prototype.clearStartinit = function() {
  return this.setStartinit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.Response.prototype.hasStartinit = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.RoomInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.room.RoomInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.RoomInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.RoomInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    basehp: jspb.Message.getFieldWithDefault(msg, 1, 0),
    regenhp: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    regenhpspeed: jspb.Message.getFieldWithDefault(msg, 3, 0),
    magazinesize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    movementspeed: jspb.Message.getFieldWithDefault(msg, 5, 0),
    friendlyfire: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    gravity: jspb.Message.getFieldWithDefault(msg, 7, 0),
    firerate: jspb.Message.getFieldWithDefault(msg, 8, 0),
    weapondamage: jspb.Message.getFieldWithDefault(msg, 9, 0),
    gunsight: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    enemyhp: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    playerhp: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    teamicon: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    scorehud: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    playernames: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    minimap: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    withbots: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.RoomInfo}
 */
proto.room.RoomInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.RoomInfo;
  return proto.room.RoomInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.RoomInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.RoomInfo}
 */
proto.room.RoomInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBasehp(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRegenhp(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRegenhpspeed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMagazinesize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMovementspeed(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFriendlyfire(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGravity(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFirerate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWeapondamage(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGunsight(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnemyhp(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlayerhp(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeamicon(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScorehud(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlayernames(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMinimap(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithbots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.RoomInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.RoomInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.RoomInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.RoomInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasehp();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRegenhp();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRegenhpspeed();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMagazinesize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMovementspeed();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getFriendlyfire();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getGravity();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getFirerate();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getWeapondamage();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getGunsight();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getEnemyhp();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getPlayerhp();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getTeamicon();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getScorehud();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getPlayernames();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getMinimap();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getWithbots();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional int32 baseHp = 1;
 * @return {number}
 */
proto.room.RoomInfo.prototype.getBasehp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setBasehp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool regenHp = 2;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getRegenhp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setRegenhp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int32 regenHpSpeed = 3;
 * @return {number}
 */
proto.room.RoomInfo.prototype.getRegenhpspeed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setRegenhpspeed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 magazineSize = 4;
 * @return {number}
 */
proto.room.RoomInfo.prototype.getMagazinesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setMagazinesize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 movementSpeed = 5;
 * @return {number}
 */
proto.room.RoomInfo.prototype.getMovementspeed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setMovementspeed = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool friendlyFire = 6;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getFriendlyfire = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setFriendlyfire = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 gravity = 7;
 * @return {number}
 */
proto.room.RoomInfo.prototype.getGravity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setGravity = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 fireRate = 8;
 * @return {number}
 */
proto.room.RoomInfo.prototype.getFirerate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setFirerate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 weaponDamage = 9;
 * @return {number}
 */
proto.room.RoomInfo.prototype.getWeapondamage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setWeapondamage = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool gunSight = 10;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getGunsight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setGunsight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool enemyHp = 11;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getEnemyhp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setEnemyhp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool playerHp = 12;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getPlayerhp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setPlayerhp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool teamIcon = 13;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getTeamicon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setTeamicon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool scoreHUD = 14;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getScorehud = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setScorehud = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool playerNames = 15;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getPlayernames = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setPlayernames = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool minimap = 16;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getMinimap = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setMinimap = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool withBots = 17;
 * @return {boolean}
 */
proto.room.RoomInfo.prototype.getWithbots = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.room.RoomInfo} returns this
 */
proto.room.RoomInfo.prototype.setWithbots = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


goog.object.extend(exports, proto.room);

},{"./constants_pb.js":99,"./player_pb.js":100,"./util_pb.js":104,"google-protobuf":3}],103:[function(require,module,exports){
// source: state.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var room_pb = require('./room_pb.js');
goog.object.extend(proto, room_pb);
goog.exportSymbol('proto.room.State', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.State = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.State, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.State.displayName = 'proto.room.State';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.State.prototype.toObject = function(opt_includeInstance) {
  return proto.room.State.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.State} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.State.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromplayerid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    toplayerid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    response: (f = msg.getResponse()) && room_pb.Response.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.State}
 */
proto.room.State.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.State;
  return proto.room.State.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.State} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.State}
 */
proto.room.State.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromplayerid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setToplayerid(value);
      break;
    case 3:
      var value = new room_pb.Response;
      reader.readMessage(value,room_pb.Response.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.State.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.State.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.State} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.State.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromplayerid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getToplayerid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      room_pb.Response.serializeBinaryToWriter
    );
  }
};


/**
 * optional string fromPlayerID = 1;
 * @return {string}
 */
proto.room.State.prototype.getFromplayerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.State} returns this
 */
proto.room.State.prototype.setFromplayerid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string toPlayerID = 2;
 * @return {string}
 */
proto.room.State.prototype.getToplayerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.room.State} returns this
 */
proto.room.State.prototype.setToplayerid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Response response = 3;
 * @return {?proto.room.Response}
 */
proto.room.State.prototype.getResponse = function() {
  return /** @type{?proto.room.Response} */ (
    jspb.Message.getWrapperField(this, room_pb.Response, 3));
};


/**
 * @param {?proto.room.Response|undefined} value
 * @return {!proto.room.State} returns this
*/
proto.room.State.prototype.setResponse = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.room.State} returns this
 */
proto.room.State.prototype.clearResponse = function() {
  return this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.room.State.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.room);

},{"./room_pb.js":102,"google-protobuf":3}],104:[function(require,module,exports){
// source: util.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.room.Empty', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.room.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.room.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.room.Empty.displayName = 'proto.room.Empty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.room.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.room.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.room.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.room.Empty}
 */
proto.room.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.room.Empty;
  return proto.room.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.room.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.room.Empty}
 */
proto.room.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.room.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.room.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.room.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.room.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.room);

},{"google-protobuf":3}],105:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for shards.public
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')
const proto = {};
proto.shards = {};
proto.shards.public = require('./shards_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.shards.public.ShardsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.shards.public.ShardsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.shards.public.GetRecipes.Request,
 *   !proto.shards.public.GetRecipes.Response>}
 */
const methodDescriptor_Shards_GetRecipes = new grpc.web.MethodDescriptor(
  '/shards.public.Shards/GetRecipes',
  grpc.web.MethodType.UNARY,
  proto.shards.public.GetRecipes.Request,
  proto.shards.public.GetRecipes.Response,
  /**
   * @param {!proto.shards.public.GetRecipes.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.shards.public.GetRecipes.Response.deserializeBinary
);


/**
 * @param {!proto.shards.public.GetRecipes.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.shards.public.GetRecipes.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.shards.public.GetRecipes.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.shards.public.ShardsClient.prototype.getRecipes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/shards.public.Shards/GetRecipes',
      request,
      metadata || {},
      methodDescriptor_Shards_GetRecipes,
      callback);
};


/**
 * @param {!proto.shards.public.GetRecipes.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.shards.public.GetRecipes.Response>}
 *     Promise that resolves to the response
 */
proto.shards.public.ShardsPromiseClient.prototype.getRecipes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/shards.public.Shards/GetRecipes',
      request,
      metadata || {},
      methodDescriptor_Shards_GetRecipes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.shards.public.Take.Request,
 *   !proto.shards.public.Take.Response>}
 */
const methodDescriptor_Shards_Take = new grpc.web.MethodDescriptor(
  '/shards.public.Shards/Take',
  grpc.web.MethodType.UNARY,
  proto.shards.public.Take.Request,
  proto.shards.public.Take.Response,
  /**
   * @param {!proto.shards.public.Take.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.shards.public.Take.Response.deserializeBinary
);


/**
 * @param {!proto.shards.public.Take.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.shards.public.Take.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.shards.public.Take.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.shards.public.ShardsClient.prototype.take =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/shards.public.Shards/Take',
      request,
      metadata || {},
      methodDescriptor_Shards_Take,
      callback);
};


/**
 * @param {!proto.shards.public.Take.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.shards.public.Take.Response>}
 *     Promise that resolves to the response
 */
proto.shards.public.ShardsPromiseClient.prototype.take =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/shards.public.Shards/Take',
      request,
      metadata || {},
      methodDescriptor_Shards_Take);
};


module.exports = proto.shards.public;


},{"../validate/validate_pb.js":107,"./shards_pb.js":106,"grpc-web":7}],106:[function(require,module,exports){
// source: public/shards.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.shards.public.GetRecipes', null, global);
goog.exportSymbol('proto.shards.public.GetRecipes.Request', null, global);
goog.exportSymbol('proto.shards.public.GetRecipes.Response', null, global);
goog.exportSymbol('proto.shards.public.Recipe', null, global);
goog.exportSymbol('proto.shards.public.Recipe.PaymentDetails', null, global);
goog.exportSymbol('proto.shards.public.Take', null, global);
goog.exportSymbol('proto.shards.public.Take.Request', null, global);
goog.exportSymbol('proto.shards.public.Take.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shards.public.GetRecipes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shards.public.GetRecipes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shards.public.GetRecipes.displayName = 'proto.shards.public.GetRecipes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shards.public.GetRecipes.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shards.public.GetRecipes.Request.repeatedFields_, null);
};
goog.inherits(proto.shards.public.GetRecipes.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shards.public.GetRecipes.Request.displayName = 'proto.shards.public.GetRecipes.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shards.public.GetRecipes.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shards.public.GetRecipes.Response.repeatedFields_, null);
};
goog.inherits(proto.shards.public.GetRecipes.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shards.public.GetRecipes.Response.displayName = 'proto.shards.public.GetRecipes.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shards.public.Recipe = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shards.public.Recipe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shards.public.Recipe.displayName = 'proto.shards.public.Recipe';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shards.public.Recipe.PaymentDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shards.public.Recipe.PaymentDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shards.public.Recipe.PaymentDetails.displayName = 'proto.shards.public.Recipe.PaymentDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shards.public.Take = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shards.public.Take, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shards.public.Take.displayName = 'proto.shards.public.Take';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shards.public.Take.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shards.public.Take.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shards.public.Take.Request.displayName = 'proto.shards.public.Take.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shards.public.Take.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shards.public.Take.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shards.public.Take.Response.displayName = 'proto.shards.public.Take.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shards.public.GetRecipes.prototype.toObject = function(opt_includeInstance) {
  return proto.shards.public.GetRecipes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shards.public.GetRecipes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.GetRecipes.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shards.public.GetRecipes}
 */
proto.shards.public.GetRecipes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shards.public.GetRecipes;
  return proto.shards.public.GetRecipes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shards.public.GetRecipes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shards.public.GetRecipes}
 */
proto.shards.public.GetRecipes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shards.public.GetRecipes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shards.public.GetRecipes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shards.public.GetRecipes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.GetRecipes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shards.public.GetRecipes.Request.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shards.public.GetRecipes.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.shards.public.GetRecipes.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shards.public.GetRecipes.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.GetRecipes.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shards.public.GetRecipes.Request}
 */
proto.shards.public.GetRecipes.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shards.public.GetRecipes.Request;
  return proto.shards.public.GetRecipes.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shards.public.GetRecipes.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shards.public.GetRecipes.Request}
 */
proto.shards.public.GetRecipes.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRecipes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shards.public.GetRecipes.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shards.public.GetRecipes.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shards.public.GetRecipes.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.GetRecipes.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string recipes = 1;
 * @return {!Array<string>}
 */
proto.shards.public.GetRecipes.Request.prototype.getRecipesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.shards.public.GetRecipes.Request} returns this
 */
proto.shards.public.GetRecipes.Request.prototype.setRecipesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.shards.public.GetRecipes.Request} returns this
 */
proto.shards.public.GetRecipes.Request.prototype.addRecipes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shards.public.GetRecipes.Request} returns this
 */
proto.shards.public.GetRecipes.Request.prototype.clearRecipesList = function() {
  return this.setRecipesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shards.public.GetRecipes.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shards.public.GetRecipes.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.shards.public.GetRecipes.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shards.public.GetRecipes.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.GetRecipes.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipesList: jspb.Message.toObjectList(msg.getRecipesList(),
    proto.shards.public.Recipe.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shards.public.GetRecipes.Response}
 */
proto.shards.public.GetRecipes.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shards.public.GetRecipes.Response;
  return proto.shards.public.GetRecipes.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shards.public.GetRecipes.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shards.public.GetRecipes.Response}
 */
proto.shards.public.GetRecipes.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.shards.public.Recipe;
      reader.readMessage(value,proto.shards.public.Recipe.deserializeBinaryFromReader);
      msg.addRecipes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shards.public.GetRecipes.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shards.public.GetRecipes.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shards.public.GetRecipes.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.GetRecipes.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.shards.public.Recipe.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Recipe recipes = 1;
 * @return {!Array<!proto.shards.public.Recipe>}
 */
proto.shards.public.GetRecipes.Response.prototype.getRecipesList = function() {
  return /** @type{!Array<!proto.shards.public.Recipe>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.shards.public.Recipe, 1));
};


/**
 * @param {!Array<!proto.shards.public.Recipe>} value
 * @return {!proto.shards.public.GetRecipes.Response} returns this
*/
proto.shards.public.GetRecipes.Response.prototype.setRecipesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.shards.public.Recipe=} opt_value
 * @param {number=} opt_index
 * @return {!proto.shards.public.Recipe}
 */
proto.shards.public.GetRecipes.Response.prototype.addRecipes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.shards.public.Recipe, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shards.public.GetRecipes.Response} returns this
 */
proto.shards.public.GetRecipes.Response.prototype.clearRecipesList = function() {
  return this.setRecipesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shards.public.Recipe.prototype.toObject = function(opt_includeInstance) {
  return proto.shards.public.Recipe.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shards.public.Recipe} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Recipe.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    configId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    initialLevel: jspb.Message.getFieldWithDefault(msg, 3, 0),
    currentShards: jspb.Message.getFieldWithDefault(msg, 4, 0),
    requiredShards: jspb.Message.getFieldWithDefault(msg, 5, 0),
    paymentDetails: (f = msg.getPaymentDetails()) && proto.shards.public.Recipe.PaymentDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shards.public.Recipe}
 */
proto.shards.public.Recipe.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shards.public.Recipe;
  return proto.shards.public.Recipe.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shards.public.Recipe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shards.public.Recipe}
 */
proto.shards.public.Recipe.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setInitialLevel(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCurrentShards(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRequiredShards(value);
      break;
    case 11:
      var value = new proto.shards.public.Recipe.PaymentDetails;
      reader.readMessage(value,proto.shards.public.Recipe.PaymentDetails.deserializeBinaryFromReader);
      msg.setPaymentDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shards.public.Recipe.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shards.public.Recipe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shards.public.Recipe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Recipe.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInitialLevel();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getCurrentShards();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getRequiredShards();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getPaymentDetails();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.shards.public.Recipe.PaymentDetails.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shards.public.Recipe.PaymentDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.shards.public.Recipe.PaymentDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shards.public.Recipe.PaymentDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Recipe.PaymentDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shards.public.Recipe.PaymentDetails}
 */
proto.shards.public.Recipe.PaymentDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shards.public.Recipe.PaymentDetails;
  return proto.shards.public.Recipe.PaymentDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shards.public.Recipe.PaymentDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shards.public.Recipe.PaymentDetails}
 */
proto.shards.public.Recipe.PaymentDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shards.public.Recipe.PaymentDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shards.public.Recipe.PaymentDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shards.public.Recipe.PaymentDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Recipe.PaymentDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 amount = 1;
 * @return {number}
 */
proto.shards.public.Recipe.PaymentDetails.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.shards.public.Recipe.PaymentDetails} returns this
 */
proto.shards.public.Recipe.PaymentDetails.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.shards.public.Recipe.PaymentDetails.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.shards.public.Recipe.PaymentDetails} returns this
 */
proto.shards.public.Recipe.PaymentDetails.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.shards.public.Recipe.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shards.public.Recipe} returns this
 */
proto.shards.public.Recipe.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.shards.public.Recipe.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.shards.public.Recipe} returns this
 */
proto.shards.public.Recipe.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 initial_level = 3;
 * @return {number}
 */
proto.shards.public.Recipe.prototype.getInitialLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.shards.public.Recipe} returns this
 */
proto.shards.public.Recipe.prototype.setInitialLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 current_shards = 4;
 * @return {number}
 */
proto.shards.public.Recipe.prototype.getCurrentShards = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.shards.public.Recipe} returns this
 */
proto.shards.public.Recipe.prototype.setCurrentShards = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 required_shards = 5;
 * @return {number}
 */
proto.shards.public.Recipe.prototype.getRequiredShards = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.shards.public.Recipe} returns this
 */
proto.shards.public.Recipe.prototype.setRequiredShards = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional PaymentDetails payment_details = 11;
 * @return {?proto.shards.public.Recipe.PaymentDetails}
 */
proto.shards.public.Recipe.prototype.getPaymentDetails = function() {
  return /** @type{?proto.shards.public.Recipe.PaymentDetails} */ (
    jspb.Message.getWrapperField(this, proto.shards.public.Recipe.PaymentDetails, 11));
};


/**
 * @param {?proto.shards.public.Recipe.PaymentDetails|undefined} value
 * @return {!proto.shards.public.Recipe} returns this
*/
proto.shards.public.Recipe.prototype.setPaymentDetails = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shards.public.Recipe} returns this
 */
proto.shards.public.Recipe.prototype.clearPaymentDetails = function() {
  return this.setPaymentDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shards.public.Recipe.prototype.hasPaymentDetails = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shards.public.Take.prototype.toObject = function(opt_includeInstance) {
  return proto.shards.public.Take.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shards.public.Take} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Take.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shards.public.Take}
 */
proto.shards.public.Take.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shards.public.Take;
  return proto.shards.public.Take.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shards.public.Take} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shards.public.Take}
 */
proto.shards.public.Take.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shards.public.Take.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shards.public.Take.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shards.public.Take} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Take.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shards.public.Take.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.shards.public.Take.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shards.public.Take.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Take.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shards.public.Take.Request}
 */
proto.shards.public.Take.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shards.public.Take.Request;
  return proto.shards.public.Take.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shards.public.Take.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shards.public.Take.Request}
 */
proto.shards.public.Take.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecipeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shards.public.Take.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shards.public.Take.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shards.public.Take.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Take.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string recipe_id = 1;
 * @return {string}
 */
proto.shards.public.Take.Request.prototype.getRecipeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shards.public.Take.Request} returns this
 */
proto.shards.public.Take.Request.prototype.setRecipeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shards.public.Take.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.shards.public.Take.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shards.public.Take.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Take.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shards.public.Take.Response}
 */
proto.shards.public.Take.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shards.public.Take.Response;
  return proto.shards.public.Take.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shards.public.Take.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shards.public.Take.Response}
 */
proto.shards.public.Take.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shards.public.Take.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shards.public.Take.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shards.public.Take.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shards.public.Take.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.shards.public.Take.Response.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.shards.public.Take.Response} returns this
 */
proto.shards.public.Take.Response.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.shards.public);

},{"../validate/validate_pb.js":107,"google-protobuf":3}],107:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],108:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for staking.public
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.staking = {};
proto.staking.public = require('./public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.staking.public.StakingClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.staking.public.StakingPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.staking.public.StakeItem.Request,
 *   !proto.staking.public.StakeItem.Response>}
 */
const methodDescriptor_Staking_StakeItem = new grpc.web.MethodDescriptor(
  '/staking.public.Staking/StakeItem',
  grpc.web.MethodType.UNARY,
  proto.staking.public.StakeItem.Request,
  proto.staking.public.StakeItem.Response,
  /**
   * @param {!proto.staking.public.StakeItem.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.staking.public.StakeItem.Response.deserializeBinary
);


/**
 * @param {!proto.staking.public.StakeItem.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.staking.public.StakeItem.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.staking.public.StakeItem.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.staking.public.StakingClient.prototype.stakeItem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/staking.public.Staking/StakeItem',
      request,
      metadata || {},
      methodDescriptor_Staking_StakeItem,
      callback);
};


/**
 * @param {!proto.staking.public.StakeItem.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.staking.public.StakeItem.Response>}
 *     Promise that resolves to the response
 */
proto.staking.public.StakingPromiseClient.prototype.stakeItem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/staking.public.Staking/StakeItem',
      request,
      metadata || {},
      methodDescriptor_Staking_StakeItem);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.staking.public.GetSlotStatus.Request,
 *   !proto.staking.public.GetSlotStatus.Response>}
 */
const methodDescriptor_Staking_GetSlotStatus = new grpc.web.MethodDescriptor(
  '/staking.public.Staking/GetSlotStatus',
  grpc.web.MethodType.UNARY,
  proto.staking.public.GetSlotStatus.Request,
  proto.staking.public.GetSlotStatus.Response,
  /**
   * @param {!proto.staking.public.GetSlotStatus.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.staking.public.GetSlotStatus.Response.deserializeBinary
);


/**
 * @param {!proto.staking.public.GetSlotStatus.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.staking.public.GetSlotStatus.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.staking.public.GetSlotStatus.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.staking.public.StakingClient.prototype.getSlotStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/staking.public.Staking/GetSlotStatus',
      request,
      metadata || {},
      methodDescriptor_Staking_GetSlotStatus,
      callback);
};


/**
 * @param {!proto.staking.public.GetSlotStatus.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.staking.public.GetSlotStatus.Response>}
 *     Promise that resolves to the response
 */
proto.staking.public.StakingPromiseClient.prototype.getSlotStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/staking.public.Staking/GetSlotStatus',
      request,
      metadata || {},
      methodDescriptor_Staking_GetSlotStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.staking.public.GetSlots.Request,
 *   !proto.staking.public.GetSlots.Response>}
 */
const methodDescriptor_Staking_GetSlots = new grpc.web.MethodDescriptor(
  '/staking.public.Staking/GetSlots',
  grpc.web.MethodType.UNARY,
  proto.staking.public.GetSlots.Request,
  proto.staking.public.GetSlots.Response,
  /**
   * @param {!proto.staking.public.GetSlots.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.staking.public.GetSlots.Response.deserializeBinary
);


/**
 * @param {!proto.staking.public.GetSlots.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.staking.public.GetSlots.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.staking.public.GetSlots.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.staking.public.StakingClient.prototype.getSlots =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/staking.public.Staking/GetSlots',
      request,
      metadata || {},
      methodDescriptor_Staking_GetSlots,
      callback);
};


/**
 * @param {!proto.staking.public.GetSlots.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.staking.public.GetSlots.Response>}
 *     Promise that resolves to the response
 */
proto.staking.public.StakingPromiseClient.prototype.getSlots =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/staking.public.Staking/GetSlots',
      request,
      metadata || {},
      methodDescriptor_Staking_GetSlots);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.staking.public.Unlock.Request,
 *   !proto.staking.public.Unlock.Response>}
 */
const methodDescriptor_Staking_Unlock = new grpc.web.MethodDescriptor(
  '/staking.public.Staking/Unlock',
  grpc.web.MethodType.UNARY,
  proto.staking.public.Unlock.Request,
  proto.staking.public.Unlock.Response,
  /**
   * @param {!proto.staking.public.Unlock.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.staking.public.Unlock.Response.deserializeBinary
);


/**
 * @param {!proto.staking.public.Unlock.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.staking.public.Unlock.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.staking.public.Unlock.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.staking.public.StakingClient.prototype.unlock =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/staking.public.Staking/Unlock',
      request,
      metadata || {},
      methodDescriptor_Staking_Unlock,
      callback);
};


/**
 * @param {!proto.staking.public.Unlock.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.staking.public.Unlock.Response>}
 *     Promise that resolves to the response
 */
proto.staking.public.StakingPromiseClient.prototype.unlock =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/staking.public.Staking/Unlock',
      request,
      metadata || {},
      methodDescriptor_Staking_Unlock);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.staking.public.SetSlotStatus.Request,
 *   !proto.staking.public.SetSlotStatus.Response>}
 */
const methodDescriptor_Staking_SetSlotStatus = new grpc.web.MethodDescriptor(
  '/staking.public.Staking/SetSlotStatus',
  grpc.web.MethodType.UNARY,
  proto.staking.public.SetSlotStatus.Request,
  proto.staking.public.SetSlotStatus.Response,
  /**
   * @param {!proto.staking.public.SetSlotStatus.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.staking.public.SetSlotStatus.Response.deserializeBinary
);


/**
 * @param {!proto.staking.public.SetSlotStatus.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.staking.public.SetSlotStatus.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.staking.public.SetSlotStatus.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.staking.public.StakingClient.prototype.setSlotStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/staking.public.Staking/SetSlotStatus',
      request,
      metadata || {},
      methodDescriptor_Staking_SetSlotStatus,
      callback);
};


/**
 * @param {!proto.staking.public.SetSlotStatus.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.staking.public.SetSlotStatus.Response>}
 *     Promise that resolves to the response
 */
proto.staking.public.StakingPromiseClient.prototype.setSlotStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/staking.public.Staking/SetSlotStatus',
      request,
      metadata || {},
      methodDescriptor_Staking_SetSlotStatus);
};


module.exports = proto.staking.public;


},{"../validate/validate_pb.js":110,"./public_pb.js":109,"google-protobuf/google/protobuf/timestamp_pb.js":6,"grpc-web":7}],109:[function(require,module,exports){
// source: public/public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.staking.public.Bonus', null, global);
goog.exportSymbol('proto.staking.public.Bonus.BonusType', null, global);
goog.exportSymbol('proto.staking.public.GetSlotStatus', null, global);
goog.exportSymbol('proto.staking.public.GetSlotStatus.Request', null, global);
goog.exportSymbol('proto.staking.public.GetSlotStatus.Response', null, global);
goog.exportSymbol('proto.staking.public.GetSlotStatus.Status', null, global);
goog.exportSymbol('proto.staking.public.GetSlots', null, global);
goog.exportSymbol('proto.staking.public.GetSlots.Request', null, global);
goog.exportSymbol('proto.staking.public.GetSlots.Response', null, global);
goog.exportSymbol('proto.staking.public.SetSlotStatus', null, global);
goog.exportSymbol('proto.staking.public.SetSlotStatus.Request', null, global);
goog.exportSymbol('proto.staking.public.SetSlotStatus.Response', null, global);
goog.exportSymbol('proto.staking.public.SetSlotStatus.Status', null, global);
goog.exportSymbol('proto.staking.public.Slot', null, global);
goog.exportSymbol('proto.staking.public.Slot.RateType', null, global);
goog.exportSymbol('proto.staking.public.Slot.Status', null, global);
goog.exportSymbol('proto.staking.public.SlotSet', null, global);
goog.exportSymbol('proto.staking.public.SlotSet.Details', null, global);
goog.exportSymbol('proto.staking.public.SlotSet.PaymentDetails', null, global);
goog.exportSymbol('proto.staking.public.StakeItem', null, global);
goog.exportSymbol('proto.staking.public.StakeItem.Request', null, global);
goog.exportSymbol('proto.staking.public.StakeItem.Response', null, global);
goog.exportSymbol('proto.staking.public.Unlock', null, global);
goog.exportSymbol('proto.staking.public.Unlock.Request', null, global);
goog.exportSymbol('proto.staking.public.Unlock.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.StakeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.StakeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.StakeItem.displayName = 'proto.staking.public.StakeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.StakeItem.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.StakeItem.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.StakeItem.Request.displayName = 'proto.staking.public.StakeItem.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.StakeItem.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.StakeItem.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.StakeItem.Response.displayName = 'proto.staking.public.StakeItem.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.GetSlots = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.GetSlots, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.GetSlots.displayName = 'proto.staking.public.GetSlots';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.GetSlots.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.GetSlots.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.GetSlots.Request.displayName = 'proto.staking.public.GetSlots.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.GetSlots.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.staking.public.GetSlots.Response.repeatedFields_, null);
};
goog.inherits(proto.staking.public.GetSlots.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.GetSlots.Response.displayName = 'proto.staking.public.GetSlots.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.Unlock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.Unlock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.Unlock.displayName = 'proto.staking.public.Unlock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.Unlock.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.Unlock.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.Unlock.Request.displayName = 'proto.staking.public.Unlock.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.Unlock.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.Unlock.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.Unlock.Response.displayName = 'proto.staking.public.Unlock.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.SlotSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.staking.public.SlotSet.repeatedFields_, null);
};
goog.inherits(proto.staking.public.SlotSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.SlotSet.displayName = 'proto.staking.public.SlotSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.SlotSet.PaymentDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.SlotSet.PaymentDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.SlotSet.PaymentDetails.displayName = 'proto.staking.public.SlotSet.PaymentDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.SlotSet.Details = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.SlotSet.Details, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.SlotSet.Details.displayName = 'proto.staking.public.SlotSet.Details';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.Slot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.staking.public.Slot.repeatedFields_, null);
};
goog.inherits(proto.staking.public.Slot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.Slot.displayName = 'proto.staking.public.Slot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.Bonus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.Bonus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.Bonus.displayName = 'proto.staking.public.Bonus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.SetSlotStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.SetSlotStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.SetSlotStatus.displayName = 'proto.staking.public.SetSlotStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.SetSlotStatus.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.SetSlotStatus.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.SetSlotStatus.Request.displayName = 'proto.staking.public.SetSlotStatus.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.SetSlotStatus.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.SetSlotStatus.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.SetSlotStatus.Response.displayName = 'proto.staking.public.SetSlotStatus.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.GetSlotStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.GetSlotStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.GetSlotStatus.displayName = 'proto.staking.public.GetSlotStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.GetSlotStatus.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.GetSlotStatus.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.GetSlotStatus.Request.displayName = 'proto.staking.public.GetSlotStatus.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.staking.public.GetSlotStatus.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.staking.public.GetSlotStatus.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.staking.public.GetSlotStatus.Response.displayName = 'proto.staking.public.GetSlotStatus.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.StakeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.StakeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.StakeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.StakeItem.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.StakeItem}
 */
proto.staking.public.StakeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.StakeItem;
  return proto.staking.public.StakeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.StakeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.StakeItem}
 */
proto.staking.public.StakeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.StakeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.StakeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.StakeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.StakeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.StakeItem.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.StakeItem.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.StakeItem.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.StakeItem.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotSetId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    slotNumber: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.StakeItem.Request}
 */
proto.staking.public.StakeItem.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.StakeItem.Request;
  return proto.staking.public.StakeItem.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.StakeItem.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.StakeItem.Request}
 */
proto.staking.public.StakeItem.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlotSetId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSlotNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.StakeItem.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.StakeItem.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.StakeItem.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.StakeItem.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotSetId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlotNumber();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.staking.public.StakeItem.Request.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.StakeItem.Request} returns this
 */
proto.staking.public.StakeItem.Request.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slot_set_id = 2;
 * @return {string}
 */
proto.staking.public.StakeItem.Request.prototype.getSlotSetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.StakeItem.Request} returns this
 */
proto.staking.public.StakeItem.Request.prototype.setSlotSetId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 slot_number = 3;
 * @return {number}
 */
proto.staking.public.StakeItem.Request.prototype.getSlotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.StakeItem.Request} returns this
 */
proto.staking.public.StakeItem.Request.prototype.setSlotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.StakeItem.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.StakeItem.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.StakeItem.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.StakeItem.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    slotId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.StakeItem.Response}
 */
proto.staking.public.StakeItem.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.StakeItem.Response;
  return proto.staking.public.StakeItem.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.StakeItem.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.StakeItem.Response}
 */
proto.staking.public.StakeItem.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSlotId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.StakeItem.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.StakeItem.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.StakeItem.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.StakeItem.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlotId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 slot_id = 1;
 * @return {number}
 */
proto.staking.public.StakeItem.Response.prototype.getSlotId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.StakeItem.Response} returns this
 */
proto.staking.public.StakeItem.Response.prototype.setSlotId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.staking.public.StakeItem.Response.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.StakeItem.Response} returns this
 */
proto.staking.public.StakeItem.Response.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.GetSlots.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.GetSlots.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.GetSlots} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlots.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.GetSlots}
 */
proto.staking.public.GetSlots.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.GetSlots;
  return proto.staking.public.GetSlots.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.GetSlots} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.GetSlots}
 */
proto.staking.public.GetSlots.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.GetSlots.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.GetSlots.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.GetSlots} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlots.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.GetSlots.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.GetSlots.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.GetSlots.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlots.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.GetSlots.Request}
 */
proto.staking.public.GetSlots.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.GetSlots.Request;
  return proto.staking.public.GetSlots.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.GetSlots.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.GetSlots.Request}
 */
proto.staking.public.GetSlots.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.GetSlots.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.GetSlots.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.GetSlots.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlots.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string event_id = 1;
 * @return {string}
 */
proto.staking.public.GetSlots.Request.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.GetSlots.Request} returns this
 */
proto.staking.public.GetSlots.Request.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.staking.public.GetSlots.Response.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.GetSlots.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.GetSlots.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.GetSlots.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlots.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    premiumCharacterRate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    lootCharacterRate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lootWeaponRate: jspb.Message.getFieldWithDefault(msg, 3, 0),
    setsList: jspb.Message.toObjectList(msg.getSetsList(),
    proto.staking.public.SlotSet.toObject, includeInstance),
    bonusesList: jspb.Message.toObjectList(msg.getBonusesList(),
    proto.staking.public.Bonus.toObject, includeInstance),
    specialCharacterRate: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.GetSlots.Response}
 */
proto.staking.public.GetSlots.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.GetSlots.Response;
  return proto.staking.public.GetSlots.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.GetSlots.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.GetSlots.Response}
 */
proto.staking.public.GetSlots.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPremiumCharacterRate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLootCharacterRate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLootWeaponRate(value);
      break;
    case 6:
      var value = new proto.staking.public.SlotSet;
      reader.readMessage(value,proto.staking.public.SlotSet.deserializeBinaryFromReader);
      msg.addSets(value);
      break;
    case 7:
      var value = new proto.staking.public.Bonus;
      reader.readMessage(value,proto.staking.public.Bonus.deserializeBinaryFromReader);
      msg.addBonuses(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSpecialCharacterRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.GetSlots.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.GetSlots.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.GetSlots.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlots.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPremiumCharacterRate();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLootCharacterRate();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLootWeaponRate();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.staking.public.SlotSet.serializeBinaryToWriter
    );
  }
  f = message.getBonusesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.staking.public.Bonus.serializeBinaryToWriter
    );
  }
  f = message.getSpecialCharacterRate();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int64 premium_character_rate = 1;
 * @return {number}
 */
proto.staking.public.GetSlots.Response.prototype.getPremiumCharacterRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.GetSlots.Response} returns this
 */
proto.staking.public.GetSlots.Response.prototype.setPremiumCharacterRate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 loot_character_rate = 2;
 * @return {number}
 */
proto.staking.public.GetSlots.Response.prototype.getLootCharacterRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.GetSlots.Response} returns this
 */
proto.staking.public.GetSlots.Response.prototype.setLootCharacterRate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 loot_weapon_rate = 3;
 * @return {number}
 */
proto.staking.public.GetSlots.Response.prototype.getLootWeaponRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.GetSlots.Response} returns this
 */
proto.staking.public.GetSlots.Response.prototype.setLootWeaponRate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated SlotSet sets = 6;
 * @return {!Array<!proto.staking.public.SlotSet>}
 */
proto.staking.public.GetSlots.Response.prototype.getSetsList = function() {
  return /** @type{!Array<!proto.staking.public.SlotSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.staking.public.SlotSet, 6));
};


/**
 * @param {!Array<!proto.staking.public.SlotSet>} value
 * @return {!proto.staking.public.GetSlots.Response} returns this
*/
proto.staking.public.GetSlots.Response.prototype.setSetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.staking.public.SlotSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.staking.public.SlotSet}
 */
proto.staking.public.GetSlots.Response.prototype.addSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.staking.public.SlotSet, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.staking.public.GetSlots.Response} returns this
 */
proto.staking.public.GetSlots.Response.prototype.clearSetsList = function() {
  return this.setSetsList([]);
};


/**
 * repeated Bonus bonuses = 7;
 * @return {!Array<!proto.staking.public.Bonus>}
 */
proto.staking.public.GetSlots.Response.prototype.getBonusesList = function() {
  return /** @type{!Array<!proto.staking.public.Bonus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.staking.public.Bonus, 7));
};


/**
 * @param {!Array<!proto.staking.public.Bonus>} value
 * @return {!proto.staking.public.GetSlots.Response} returns this
*/
proto.staking.public.GetSlots.Response.prototype.setBonusesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.staking.public.Bonus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.staking.public.Bonus}
 */
proto.staking.public.GetSlots.Response.prototype.addBonuses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.staking.public.Bonus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.staking.public.GetSlots.Response} returns this
 */
proto.staking.public.GetSlots.Response.prototype.clearBonusesList = function() {
  return this.setBonusesList([]);
};


/**
 * optional int64 special_character_rate = 8;
 * @return {number}
 */
proto.staking.public.GetSlots.Response.prototype.getSpecialCharacterRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.GetSlots.Response} returns this
 */
proto.staking.public.GetSlots.Response.prototype.setSpecialCharacterRate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.Unlock.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.Unlock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.Unlock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Unlock.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.Unlock}
 */
proto.staking.public.Unlock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.Unlock;
  return proto.staking.public.Unlock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.Unlock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.Unlock}
 */
proto.staking.public.Unlock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.Unlock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.Unlock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.Unlock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Unlock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.Unlock.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.Unlock.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.Unlock.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Unlock.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotSetId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.Unlock.Request}
 */
proto.staking.public.Unlock.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.Unlock.Request;
  return proto.staking.public.Unlock.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.Unlock.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.Unlock.Request}
 */
proto.staking.public.Unlock.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlotSetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.Unlock.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.Unlock.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.Unlock.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Unlock.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotSetId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.staking.public.Unlock.Request.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.Unlock.Request} returns this
 */
proto.staking.public.Unlock.Request.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slot_set_id = 2;
 * @return {string}
 */
proto.staking.public.Unlock.Request.prototype.getSlotSetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.Unlock.Request} returns this
 */
proto.staking.public.Unlock.Request.prototype.setSlotSetId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.Unlock.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.Unlock.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.Unlock.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Unlock.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.Unlock.Response}
 */
proto.staking.public.Unlock.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.Unlock.Response;
  return proto.staking.public.Unlock.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.Unlock.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.Unlock.Response}
 */
proto.staking.public.Unlock.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.Unlock.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.Unlock.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.Unlock.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Unlock.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.staking.public.SlotSet.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.SlotSet.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.SlotSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.SlotSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SlotSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotsList: jspb.Message.toObjectList(msg.getSlotsList(),
    proto.staking.public.Slot.toObject, includeInstance),
    details: (f = msg.getDetails()) && proto.staking.public.SlotSet.Details.toObject(includeInstance, f),
    paymentDetails: (f = msg.getPaymentDetails()) && proto.staking.public.SlotSet.PaymentDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.SlotSet}
 */
proto.staking.public.SlotSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.SlotSet;
  return proto.staking.public.SlotSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.SlotSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.SlotSet}
 */
proto.staking.public.SlotSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.staking.public.Slot;
      reader.readMessage(value,proto.staking.public.Slot.deserializeBinaryFromReader);
      msg.addSlots(value);
      break;
    case 3:
      var value = new proto.staking.public.SlotSet.Details;
      reader.readMessage(value,proto.staking.public.SlotSet.Details.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 4:
      var value = new proto.staking.public.SlotSet.PaymentDetails;
      reader.readMessage(value,proto.staking.public.SlotSet.PaymentDetails.deserializeBinaryFromReader);
      msg.setPaymentDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.SlotSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.SlotSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.SlotSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SlotSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.staking.public.Slot.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.staking.public.SlotSet.Details.serializeBinaryToWriter
    );
  }
  f = message.getPaymentDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.staking.public.SlotSet.PaymentDetails.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.SlotSet.PaymentDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.SlotSet.PaymentDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.SlotSet.PaymentDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SlotSet.PaymentDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 2, ""),
    unlockDurationText: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.SlotSet.PaymentDetails}
 */
proto.staking.public.SlotSet.PaymentDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.SlotSet.PaymentDetails;
  return proto.staking.public.SlotSet.PaymentDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.SlotSet.PaymentDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.SlotSet.PaymentDetails}
 */
proto.staking.public.SlotSet.PaymentDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnlockDurationText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.SlotSet.PaymentDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.SlotSet.PaymentDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.SlotSet.PaymentDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SlotSet.PaymentDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUnlockDurationText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint64 amount = 1;
 * @return {number}
 */
proto.staking.public.SlotSet.PaymentDetails.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.SlotSet.PaymentDetails} returns this
 */
proto.staking.public.SlotSet.PaymentDetails.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.staking.public.SlotSet.PaymentDetails.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.SlotSet.PaymentDetails} returns this
 */
proto.staking.public.SlotSet.PaymentDetails.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string unlock_duration_text = 3;
 * @return {string}
 */
proto.staking.public.SlotSet.PaymentDetails.prototype.getUnlockDurationText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.SlotSet.PaymentDetails} returns this
 */
proto.staking.public.SlotSet.PaymentDetails.prototype.setUnlockDurationText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.SlotSet.Details.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.SlotSet.Details.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.SlotSet.Details} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SlotSet.Details.toObject = function(includeInstance, msg) {
  var f, obj = {
    basePointsRate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    bonusPointsRate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    unlockedTill: (f = msg.getUnlockedTill()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.SlotSet.Details}
 */
proto.staking.public.SlotSet.Details.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.SlotSet.Details;
  return proto.staking.public.SlotSet.Details.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.SlotSet.Details} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.SlotSet.Details}
 */
proto.staking.public.SlotSet.Details.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBasePointsRate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBonusPointsRate(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUnlockedTill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.SlotSet.Details.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.SlotSet.Details.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.SlotSet.Details} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SlotSet.Details.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasePointsRate();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getBonusPointsRate();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getUnlockedTill();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 base_points_rate = 1;
 * @return {number}
 */
proto.staking.public.SlotSet.Details.prototype.getBasePointsRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.SlotSet.Details} returns this
 */
proto.staking.public.SlotSet.Details.prototype.setBasePointsRate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 bonus_points_rate = 2;
 * @return {number}
 */
proto.staking.public.SlotSet.Details.prototype.getBonusPointsRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.SlotSet.Details} returns this
 */
proto.staking.public.SlotSet.Details.prototype.setBonusPointsRate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp unlocked_till = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.staking.public.SlotSet.Details.prototype.getUnlockedTill = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.staking.public.SlotSet.Details} returns this
*/
proto.staking.public.SlotSet.Details.prototype.setUnlockedTill = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.staking.public.SlotSet.Details} returns this
 */
proto.staking.public.SlotSet.Details.prototype.clearUnlockedTill = function() {
  return this.setUnlockedTill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.staking.public.SlotSet.Details.prototype.hasUnlockedTill = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.staking.public.SlotSet.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.SlotSet} returns this
 */
proto.staking.public.SlotSet.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Slot slots = 2;
 * @return {!Array<!proto.staking.public.Slot>}
 */
proto.staking.public.SlotSet.prototype.getSlotsList = function() {
  return /** @type{!Array<!proto.staking.public.Slot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.staking.public.Slot, 2));
};


/**
 * @param {!Array<!proto.staking.public.Slot>} value
 * @return {!proto.staking.public.SlotSet} returns this
*/
proto.staking.public.SlotSet.prototype.setSlotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.staking.public.Slot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.staking.public.Slot}
 */
proto.staking.public.SlotSet.prototype.addSlots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.staking.public.Slot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.staking.public.SlotSet} returns this
 */
proto.staking.public.SlotSet.prototype.clearSlotsList = function() {
  return this.setSlotsList([]);
};


/**
 * optional Details details = 3;
 * @return {?proto.staking.public.SlotSet.Details}
 */
proto.staking.public.SlotSet.prototype.getDetails = function() {
  return /** @type{?proto.staking.public.SlotSet.Details} */ (
    jspb.Message.getWrapperField(this, proto.staking.public.SlotSet.Details, 3));
};


/**
 * @param {?proto.staking.public.SlotSet.Details|undefined} value
 * @return {!proto.staking.public.SlotSet} returns this
*/
proto.staking.public.SlotSet.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.staking.public.SlotSet} returns this
 */
proto.staking.public.SlotSet.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.staking.public.SlotSet.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PaymentDetails payment_details = 4;
 * @return {?proto.staking.public.SlotSet.PaymentDetails}
 */
proto.staking.public.SlotSet.prototype.getPaymentDetails = function() {
  return /** @type{?proto.staking.public.SlotSet.PaymentDetails} */ (
    jspb.Message.getWrapperField(this, proto.staking.public.SlotSet.PaymentDetails, 4));
};


/**
 * @param {?proto.staking.public.SlotSet.PaymentDetails|undefined} value
 * @return {!proto.staking.public.SlotSet} returns this
*/
proto.staking.public.SlotSet.prototype.setPaymentDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.staking.public.SlotSet} returns this
 */
proto.staking.public.SlotSet.prototype.clearPaymentDetails = function() {
  return this.setPaymentDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.staking.public.SlotSet.prototype.hasPaymentDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.staking.public.Slot.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.Slot.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.Slot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.Slot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Slot.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    baseRate: jspb.Message.getFieldWithDefault(msg, 3, 0),
    bonusRate: jspb.Message.getFieldWithDefault(msg, 4, 0),
    rateType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    bonusesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    id: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.Slot}
 */
proto.staking.public.Slot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.Slot;
  return proto.staking.public.Slot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.Slot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.Slot}
 */
proto.staking.public.Slot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    case 2:
      var value = /** @type {!proto.staking.public.Slot.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBaseRate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBonusRate(value);
      break;
    case 5:
      var value = /** @type {!proto.staking.public.Slot.RateType} */ (reader.readEnum());
      msg.setRateType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addBonuses(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.Slot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.Slot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.Slot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Slot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBaseRate();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getBonusRate();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getRateType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getBonusesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.staking.public.Slot.Status = {
  UNKNOWN_SLOT_STATUS: 0,
  STAKING: 1,
  STAKED: 2,
  UNSTAKING: 3
};

/**
 * @enum {number}
 */
proto.staking.public.Slot.RateType = {
  UNKNOWN_RATE_TYPE: 0,
  PREMIUM_CHARACTER: 1,
  LOOT_CHARACTER: 2,
  LOOT_WEAPON: 3,
  SPECIAL_CHARACTER: 4
};

/**
 * optional string item_id = 1;
 * @return {string}
 */
proto.staking.public.Slot.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Status status = 2;
 * @return {!proto.staking.public.Slot.Status}
 */
proto.staking.public.Slot.prototype.getStatus = function() {
  return /** @type {!proto.staking.public.Slot.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.staking.public.Slot.Status} value
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 base_rate = 3;
 * @return {number}
 */
proto.staking.public.Slot.prototype.getBaseRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.setBaseRate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 bonus_rate = 4;
 * @return {number}
 */
proto.staking.public.Slot.prototype.getBonusRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.setBonusRate = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional RateType rate_type = 5;
 * @return {!proto.staking.public.Slot.RateType}
 */
proto.staking.public.Slot.prototype.getRateType = function() {
  return /** @type {!proto.staking.public.Slot.RateType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.staking.public.Slot.RateType} value
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.setRateType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated string bonuses = 6;
 * @return {!Array<string>}
 */
proto.staking.public.Slot.prototype.getBonusesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.setBonusesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.addBonuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.clearBonusesList = function() {
  return this.setBonusesList([]);
};


/**
 * optional string id = 7;
 * @return {string}
 */
proto.staking.public.Slot.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.Slot} returns this
 */
proto.staking.public.Slot.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.Bonus.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.Bonus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.Bonus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Bonus.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    percent: jspb.Message.getFieldWithDefault(msg, 4, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    icon: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.Bonus}
 */
proto.staking.public.Bonus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.Bonus;
  return proto.staking.public.Bonus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.Bonus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.Bonus}
 */
proto.staking.public.Bonus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPercent(value);
      break;
    case 5:
      var value = /** @type {!proto.staking.public.Bonus.BonusType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.Bonus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.Bonus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.Bonus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.Bonus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPercent();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.staking.public.Bonus.BonusType = {
  UNKNOWN_BONUS_TYPE: 0,
  MAIN_BONUS: 1,
  LEVEL_BONUS: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.staking.public.Bonus.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.Bonus} returns this
 */
proto.staking.public.Bonus.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.staking.public.Bonus.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.Bonus} returns this
 */
proto.staking.public.Bonus.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.staking.public.Bonus.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.Bonus} returns this
 */
proto.staking.public.Bonus.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 percent = 4;
 * @return {number}
 */
proto.staking.public.Bonus.prototype.getPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.staking.public.Bonus} returns this
 */
proto.staking.public.Bonus.prototype.setPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional BonusType type = 5;
 * @return {!proto.staking.public.Bonus.BonusType}
 */
proto.staking.public.Bonus.prototype.getType = function() {
  return /** @type {!proto.staking.public.Bonus.BonusType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.staking.public.Bonus.BonusType} value
 * @return {!proto.staking.public.Bonus} returns this
 */
proto.staking.public.Bonus.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string icon = 6;
 * @return {string}
 */
proto.staking.public.Bonus.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.Bonus} returns this
 */
proto.staking.public.Bonus.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.SetSlotStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.SetSlotStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.SetSlotStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SetSlotStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.SetSlotStatus}
 */
proto.staking.public.SetSlotStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.SetSlotStatus;
  return proto.staking.public.SetSlotStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.SetSlotStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.SetSlotStatus}
 */
proto.staking.public.SetSlotStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.SetSlotStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.SetSlotStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.SetSlotStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SetSlotStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.staking.public.SetSlotStatus.Status = {
  UNKNOWN_SLOT_STATUS: 0,
  STAKING: 1,
  UNSTAKING: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.SetSlotStatus.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.SetSlotStatus.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.SetSlotStatus.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SetSlotStatus.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    transaction: jspb.Message.getFieldWithDefault(msg, 5, ""),
    id: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.SetSlotStatus.Request}
 */
proto.staking.public.SetSlotStatus.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.SetSlotStatus.Request;
  return proto.staking.public.SetSlotStatus.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.SetSlotStatus.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.SetSlotStatus.Request}
 */
proto.staking.public.SetSlotStatus.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {!proto.staking.public.SetSlotStatus.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransaction(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.SetSlotStatus.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.SetSlotStatus.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.SetSlotStatus.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SetSlotStatus.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTransaction();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional Status status = 4;
 * @return {!proto.staking.public.SetSlotStatus.Status}
 */
proto.staking.public.SetSlotStatus.Request.prototype.getStatus = function() {
  return /** @type {!proto.staking.public.SetSlotStatus.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.staking.public.SetSlotStatus.Status} value
 * @return {!proto.staking.public.SetSlotStatus.Request} returns this
 */
proto.staking.public.SetSlotStatus.Request.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string transaction = 5;
 * @return {string}
 */
proto.staking.public.SetSlotStatus.Request.prototype.getTransaction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.SetSlotStatus.Request} returns this
 */
proto.staking.public.SetSlotStatus.Request.prototype.setTransaction = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string id = 6;
 * @return {string}
 */
proto.staking.public.SetSlotStatus.Request.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.SetSlotStatus.Request} returns this
 */
proto.staking.public.SetSlotStatus.Request.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.SetSlotStatus.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.SetSlotStatus.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.SetSlotStatus.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SetSlotStatus.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.SetSlotStatus.Response}
 */
proto.staking.public.SetSlotStatus.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.SetSlotStatus.Response;
  return proto.staking.public.SetSlotStatus.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.SetSlotStatus.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.SetSlotStatus.Response}
 */
proto.staking.public.SetSlotStatus.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.SetSlotStatus.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.SetSlotStatus.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.SetSlotStatus.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.SetSlotStatus.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.GetSlotStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.GetSlotStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.GetSlotStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlotStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.GetSlotStatus}
 */
proto.staking.public.GetSlotStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.GetSlotStatus;
  return proto.staking.public.GetSlotStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.GetSlotStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.GetSlotStatus}
 */
proto.staking.public.GetSlotStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.GetSlotStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.GetSlotStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.GetSlotStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlotStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.staking.public.GetSlotStatus.Status = {
  UNKNOWN_SLOT_STATUS: 0,
  STAKING: 1,
  STAKED: 2,
  UNSTAKING: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.GetSlotStatus.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.GetSlotStatus.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.GetSlotStatus.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlotStatus.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.GetSlotStatus.Request}
 */
proto.staking.public.GetSlotStatus.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.GetSlotStatus.Request;
  return proto.staking.public.GetSlotStatus.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.GetSlotStatus.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.GetSlotStatus.Request}
 */
proto.staking.public.GetSlotStatus.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.GetSlotStatus.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.GetSlotStatus.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.GetSlotStatus.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlotStatus.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string id = 6;
 * @return {string}
 */
proto.staking.public.GetSlotStatus.Request.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.staking.public.GetSlotStatus.Request} returns this
 */
proto.staking.public.GetSlotStatus.Request.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.staking.public.GetSlotStatus.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.staking.public.GetSlotStatus.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.staking.public.GetSlotStatus.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlotStatus.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.staking.public.GetSlotStatus.Response}
 */
proto.staking.public.GetSlotStatus.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.staking.public.GetSlotStatus.Response;
  return proto.staking.public.GetSlotStatus.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.staking.public.GetSlotStatus.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.staking.public.GetSlotStatus.Response}
 */
proto.staking.public.GetSlotStatus.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.staking.public.GetSlotStatus.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.staking.public.GetSlotStatus.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.staking.public.GetSlotStatus.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.staking.public.GetSlotStatus.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.staking.public.GetSlotStatus.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional Status status = 1;
 * @return {!proto.staking.public.GetSlotStatus.Status}
 */
proto.staking.public.GetSlotStatus.Response.prototype.getStatus = function() {
  return /** @type {!proto.staking.public.GetSlotStatus.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.staking.public.GetSlotStatus.Status} value
 * @return {!proto.staking.public.GetSlotStatus.Response} returns this
 */
proto.staking.public.GetSlotStatus.Response.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


goog.object.extend(exports, proto.staking.public);

},{"../validate/validate_pb.js":110,"google-protobuf":3,"google-protobuf/google/protobuf/timestamp_pb.js":6}],110:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],111:[function(require,module,exports){
// source: entities/party.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var entities_party_player_pb = require('../entities/party_player_pb.js');
goog.object.extend(proto, entities_party_player_pb);
goog.exportSymbol('proto.entities.Party', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entities.Party = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entities.Party.repeatedFields_, null);
};
goog.inherits(proto.entities.Party, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entities.Party.displayName = 'proto.entities.Party';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entities.Party.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entities.Party.prototype.toObject = function(opt_includeInstance) {
  return proto.entities.Party.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entities.Party} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entities.Party.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    leaderId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    playersList: jspb.Message.toObjectList(msg.getPlayersList(),
    entities_party_player_pb.PartyPlayer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entities.Party}
 */
proto.entities.Party.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entities.Party;
  return proto.entities.Party.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entities.Party} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entities.Party}
 */
proto.entities.Party.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeaderId(value);
      break;
    case 4:
      var value = new entities_party_player_pb.PartyPlayer;
      reader.readMessage(value,entities_party_player_pb.PartyPlayer.deserializeBinaryFromReader);
      msg.addPlayers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entities.Party.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entities.Party.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entities.Party} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entities.Party.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getLeaderId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlayersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      entities_party_player_pb.PartyPlayer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.entities.Party.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entities.Party} returns this
 */
proto.entities.Party.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_public = 2;
 * @return {boolean}
 */
proto.entities.Party.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entities.Party} returns this
 */
proto.entities.Party.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string leader_id = 3;
 * @return {string}
 */
proto.entities.Party.prototype.getLeaderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entities.Party} returns this
 */
proto.entities.Party.prototype.setLeaderId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated PartyPlayer players = 4;
 * @return {!Array<!proto.entities.PartyPlayer>}
 */
proto.entities.Party.prototype.getPlayersList = function() {
  return /** @type{!Array<!proto.entities.PartyPlayer>} */ (
    jspb.Message.getRepeatedWrapperField(this, entities_party_player_pb.PartyPlayer, 4));
};


/**
 * @param {!Array<!proto.entities.PartyPlayer>} value
 * @return {!proto.entities.Party} returns this
*/
proto.entities.Party.prototype.setPlayersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.entities.PartyPlayer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entities.PartyPlayer}
 */
proto.entities.Party.prototype.addPlayers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.entities.PartyPlayer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entities.Party} returns this
 */
proto.entities.Party.prototype.clearPlayersList = function() {
  return this.setPlayersList([]);
};


goog.object.extend(exports, proto.entities);

},{"../entities/party_player_pb.js":112,"google-protobuf":3}],112:[function(require,module,exports){
// source: entities/party_player.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.entities.PartyPlayer', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entities.PartyPlayer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entities.PartyPlayer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entities.PartyPlayer.displayName = 'proto.entities.PartyPlayer';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entities.PartyPlayer.prototype.toObject = function(opt_includeInstance) {
  return proto.entities.PartyPlayer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entities.PartyPlayer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entities.PartyPlayer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isReady: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entities.PartyPlayer}
 */
proto.entities.PartyPlayer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entities.PartyPlayer;
  return proto.entities.PartyPlayer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entities.PartyPlayer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entities.PartyPlayer}
 */
proto.entities.PartyPlayer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsReady(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entities.PartyPlayer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entities.PartyPlayer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entities.PartyPlayer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entities.PartyPlayer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsReady();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.entities.PartyPlayer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entities.PartyPlayer} returns this
 */
proto.entities.PartyPlayer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_ready = 2;
 * @return {boolean}
 */
proto.entities.PartyPlayer.prototype.getIsReady = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entities.PartyPlayer} returns this
 */
proto.entities.PartyPlayer.prototype.setIsReady = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


goog.object.extend(exports, proto.entities);

},{"google-protobuf":3}],113:[function(require,module,exports){
// source: entities/player_match.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.entities.PlayerMatch', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entities.PlayerMatch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entities.PlayerMatch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entities.PlayerMatch.displayName = 'proto.entities.PlayerMatch';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entities.PlayerMatch.prototype.toObject = function(opt_includeInstance) {
  return proto.entities.PlayerMatch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entities.PlayerMatch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entities.PlayerMatch.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    matchId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entities.PlayerMatch}
 */
proto.entities.PlayerMatch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entities.PlayerMatch;
  return proto.entities.PlayerMatch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entities.PlayerMatch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entities.PlayerMatch}
 */
proto.entities.PlayerMatch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entities.PlayerMatch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entities.PlayerMatch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entities.PlayerMatch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entities.PlayerMatch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatchId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.entities.PlayerMatch.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entities.PlayerMatch} returns this
 */
proto.entities.PlayerMatch.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string match_id = 2;
 * @return {string}
 */
proto.entities.PlayerMatch.prototype.getMatchId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entities.PlayerMatch} returns this
 */
proto.entities.PlayerMatch.prototype.setMatchId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.entities);

},{"../validate/validate_pb.js":122,"google-protobuf":3}],114:[function(require,module,exports){
// source: entities/player.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.entities.Player', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entities.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entities.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entities.Player.displayName = 'proto.entities.Player';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entities.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.entities.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entities.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entities.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    nametail: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isGuest: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entities.Player}
 */
proto.entities.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entities.Player;
  return proto.entities.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entities.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entities.Player}
 */
proto.entities.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNametail(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGuest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entities.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entities.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entities.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entities.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNametail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsGuest();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.entities.Player.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entities.Player} returns this
 */
proto.entities.Player.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.entities.Player.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entities.Player} returns this
 */
proto.entities.Player.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nametail = 3;
 * @return {string}
 */
proto.entities.Player.prototype.getNametail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entities.Player} returns this
 */
proto.entities.Player.prototype.setNametail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_guest = 4;
 * @return {boolean}
 */
proto.entities.Player.prototype.getIsGuest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entities.Player} returns this
 */
proto.entities.Player.prototype.setIsGuest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


goog.object.extend(exports, proto.entities);

},{"google-protobuf":3}],115:[function(require,module,exports){
// source: public/event.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

goog.exportSymbol('proto.public.stream.Event', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.stream.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.stream.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.stream.Event.displayName = 'proto.public.stream.Event';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.stream.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.public.stream.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.stream.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.stream.Event.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    payload: msg.getPayload_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.stream.Event}
 */
proto.public.stream.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.stream.Event;
  return proto.public.stream.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.stream.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.stream.Event}
 */
proto.public.stream.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.stream.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.stream.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.stream.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.stream.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPayload_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.public.stream.Event.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.public.stream.Event} returns this
 */
proto.public.stream.Event.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes payload = 2;
 * @return {string}
 */
proto.public.stream.Event.prototype.getPayload = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes payload = 2;
 * This is a type-conversion wrapper around `getPayload()`
 * @return {string}
 */
proto.public.stream.Event.prototype.getPayload_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPayload()));
};


/**
 * optional bytes payload = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPayload()`
 * @return {!Uint8Array}
 */
proto.public.stream.Event.prototype.getPayload_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPayload()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.public.stream.Event} returns this
 */
proto.public.stream.Event.prototype.setPayload = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


goog.object.extend(exports, proto.public.stream);

},{"google-protobuf":3}],116:[function(require,module,exports){
// source: public/events/party.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var entities_party_pb = require('../../entities/party_pb.js');
goog.object.extend(proto, entities_party_pb);
goog.exportSymbol('proto.events.PartyCreated', null, global);
goog.exportSymbol('proto.events.PartyDeleted', null, global);
goog.exportSymbol('proto.events.PartyIsPublicChanged', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyCreated = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyCreated, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyCreated.displayName = 'proto.events.PartyCreated';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyDeleted = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyDeleted, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyDeleted.displayName = 'proto.events.PartyDeleted';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyIsPublicChanged = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyIsPublicChanged, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyIsPublicChanged.displayName = 'proto.events.PartyIsPublicChanged';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyCreated.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyCreated.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyCreated.toObject = function(includeInstance, msg) {
  var f, obj = {
    party: (f = msg.getParty()) && entities_party_pb.Party.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyCreated}
 */
proto.events.PartyCreated.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyCreated;
  return proto.events.PartyCreated.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyCreated}
 */
proto.events.PartyCreated.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_party_pb.Party;
      reader.readMessage(value,entities_party_pb.Party.deserializeBinaryFromReader);
      msg.setParty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyCreated.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyCreated.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyCreated.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParty();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_party_pb.Party.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.Party party = 1;
 * @return {?proto.entities.Party}
 */
proto.events.PartyCreated.prototype.getParty = function() {
  return /** @type{?proto.entities.Party} */ (
    jspb.Message.getWrapperField(this, entities_party_pb.Party, 1));
};


/**
 * @param {?proto.entities.Party|undefined} value
 * @return {!proto.events.PartyCreated} returns this
*/
proto.events.PartyCreated.prototype.setParty = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyCreated} returns this
 */
proto.events.PartyCreated.prototype.clearParty = function() {
  return this.setParty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyCreated.prototype.hasParty = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyDeleted.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyDeleted.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyDeleted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyDeleted.toObject = function(includeInstance, msg) {
  var f, obj = {
    party: (f = msg.getParty()) && entities_party_pb.Party.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyDeleted}
 */
proto.events.PartyDeleted.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyDeleted;
  return proto.events.PartyDeleted.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyDeleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyDeleted}
 */
proto.events.PartyDeleted.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_party_pb.Party;
      reader.readMessage(value,entities_party_pb.Party.deserializeBinaryFromReader);
      msg.setParty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyDeleted.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyDeleted.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyDeleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyDeleted.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParty();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_party_pb.Party.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.Party party = 1;
 * @return {?proto.entities.Party}
 */
proto.events.PartyDeleted.prototype.getParty = function() {
  return /** @type{?proto.entities.Party} */ (
    jspb.Message.getWrapperField(this, entities_party_pb.Party, 1));
};


/**
 * @param {?proto.entities.Party|undefined} value
 * @return {!proto.events.PartyDeleted} returns this
*/
proto.events.PartyDeleted.prototype.setParty = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyDeleted} returns this
 */
proto.events.PartyDeleted.prototype.clearParty = function() {
  return this.setParty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyDeleted.prototype.hasParty = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyIsPublicChanged.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyIsPublicChanged.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyIsPublicChanged} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyIsPublicChanged.toObject = function(includeInstance, msg) {
  var f, obj = {
    party: (f = msg.getParty()) && entities_party_pb.Party.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyIsPublicChanged}
 */
proto.events.PartyIsPublicChanged.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyIsPublicChanged;
  return proto.events.PartyIsPublicChanged.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyIsPublicChanged} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyIsPublicChanged}
 */
proto.events.PartyIsPublicChanged.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_party_pb.Party;
      reader.readMessage(value,entities_party_pb.Party.deserializeBinaryFromReader);
      msg.setParty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyIsPublicChanged.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyIsPublicChanged.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyIsPublicChanged} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyIsPublicChanged.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParty();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_party_pb.Party.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.Party party = 1;
 * @return {?proto.entities.Party}
 */
proto.events.PartyIsPublicChanged.prototype.getParty = function() {
  return /** @type{?proto.entities.Party} */ (
    jspb.Message.getWrapperField(this, entities_party_pb.Party, 1));
};


/**
 * @param {?proto.entities.Party|undefined} value
 * @return {!proto.events.PartyIsPublicChanged} returns this
*/
proto.events.PartyIsPublicChanged.prototype.setParty = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyIsPublicChanged} returns this
 */
proto.events.PartyIsPublicChanged.prototype.clearParty = function() {
  return this.setParty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyIsPublicChanged.prototype.hasParty = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.events);

},{"../../entities/party_pb.js":111,"google-protobuf":3}],117:[function(require,module,exports){
// source: public/events/party_player.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var entities_party_player_pb = require('../../entities/party_player_pb.js');
goog.object.extend(proto, entities_party_player_pb);
goog.exportSymbol('proto.events.PartyPlayerConnected', null, global);
goog.exportSymbol('proto.events.PartyPlayerDisconnected', null, global);
goog.exportSymbol('proto.events.PartyPlayerJoined', null, global);
goog.exportSymbol('proto.events.PartyPlayerKicked', null, global);
goog.exportSymbol('proto.events.PartyPlayerLeft', null, global);
goog.exportSymbol('proto.events.PartyPlayerReadyStateChanged', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyPlayerJoined = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyPlayerJoined, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyPlayerJoined.displayName = 'proto.events.PartyPlayerJoined';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyPlayerKicked = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyPlayerKicked, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyPlayerKicked.displayName = 'proto.events.PartyPlayerKicked';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyPlayerConnected = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyPlayerConnected, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyPlayerConnected.displayName = 'proto.events.PartyPlayerConnected';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyPlayerDisconnected = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyPlayerDisconnected, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyPlayerDisconnected.displayName = 'proto.events.PartyPlayerDisconnected';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyPlayerLeft = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyPlayerLeft, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyPlayerLeft.displayName = 'proto.events.PartyPlayerLeft';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PartyPlayerReadyStateChanged = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PartyPlayerReadyStateChanged, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PartyPlayerReadyStateChanged.displayName = 'proto.events.PartyPlayerReadyStateChanged';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyPlayerJoined.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyPlayerJoined.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyPlayerJoined} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerJoined.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && entities_party_player_pb.PartyPlayer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyPlayerJoined}
 */
proto.events.PartyPlayerJoined.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyPlayerJoined;
  return proto.events.PartyPlayerJoined.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyPlayerJoined} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyPlayerJoined}
 */
proto.events.PartyPlayerJoined.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_party_player_pb.PartyPlayer;
      reader.readMessage(value,entities_party_player_pb.PartyPlayer.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyPlayerJoined.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyPlayerJoined.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyPlayerJoined} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerJoined.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_party_player_pb.PartyPlayer.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.PartyPlayer player = 1;
 * @return {?proto.entities.PartyPlayer}
 */
proto.events.PartyPlayerJoined.prototype.getPlayer = function() {
  return /** @type{?proto.entities.PartyPlayer} */ (
    jspb.Message.getWrapperField(this, entities_party_player_pb.PartyPlayer, 1));
};


/**
 * @param {?proto.entities.PartyPlayer|undefined} value
 * @return {!proto.events.PartyPlayerJoined} returns this
*/
proto.events.PartyPlayerJoined.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyPlayerJoined} returns this
 */
proto.events.PartyPlayerJoined.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyPlayerJoined.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyPlayerKicked.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyPlayerKicked.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyPlayerKicked} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerKicked.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && entities_party_player_pb.PartyPlayer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyPlayerKicked}
 */
proto.events.PartyPlayerKicked.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyPlayerKicked;
  return proto.events.PartyPlayerKicked.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyPlayerKicked} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyPlayerKicked}
 */
proto.events.PartyPlayerKicked.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_party_player_pb.PartyPlayer;
      reader.readMessage(value,entities_party_player_pb.PartyPlayer.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyPlayerKicked.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyPlayerKicked.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyPlayerKicked} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerKicked.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_party_player_pb.PartyPlayer.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.PartyPlayer player = 1;
 * @return {?proto.entities.PartyPlayer}
 */
proto.events.PartyPlayerKicked.prototype.getPlayer = function() {
  return /** @type{?proto.entities.PartyPlayer} */ (
    jspb.Message.getWrapperField(this, entities_party_player_pb.PartyPlayer, 1));
};


/**
 * @param {?proto.entities.PartyPlayer|undefined} value
 * @return {!proto.events.PartyPlayerKicked} returns this
*/
proto.events.PartyPlayerKicked.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyPlayerKicked} returns this
 */
proto.events.PartyPlayerKicked.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyPlayerKicked.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyPlayerConnected.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyPlayerConnected.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyPlayerConnected} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerConnected.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && entities_party_player_pb.PartyPlayer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyPlayerConnected}
 */
proto.events.PartyPlayerConnected.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyPlayerConnected;
  return proto.events.PartyPlayerConnected.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyPlayerConnected} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyPlayerConnected}
 */
proto.events.PartyPlayerConnected.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_party_player_pb.PartyPlayer;
      reader.readMessage(value,entities_party_player_pb.PartyPlayer.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyPlayerConnected.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyPlayerConnected.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyPlayerConnected} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerConnected.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_party_player_pb.PartyPlayer.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.PartyPlayer player = 1;
 * @return {?proto.entities.PartyPlayer}
 */
proto.events.PartyPlayerConnected.prototype.getPlayer = function() {
  return /** @type{?proto.entities.PartyPlayer} */ (
    jspb.Message.getWrapperField(this, entities_party_player_pb.PartyPlayer, 1));
};


/**
 * @param {?proto.entities.PartyPlayer|undefined} value
 * @return {!proto.events.PartyPlayerConnected} returns this
*/
proto.events.PartyPlayerConnected.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyPlayerConnected} returns this
 */
proto.events.PartyPlayerConnected.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyPlayerConnected.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyPlayerDisconnected.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyPlayerDisconnected.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyPlayerDisconnected} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerDisconnected.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && entities_party_player_pb.PartyPlayer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyPlayerDisconnected}
 */
proto.events.PartyPlayerDisconnected.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyPlayerDisconnected;
  return proto.events.PartyPlayerDisconnected.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyPlayerDisconnected} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyPlayerDisconnected}
 */
proto.events.PartyPlayerDisconnected.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_party_player_pb.PartyPlayer;
      reader.readMessage(value,entities_party_player_pb.PartyPlayer.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyPlayerDisconnected.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyPlayerDisconnected.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyPlayerDisconnected} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerDisconnected.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_party_player_pb.PartyPlayer.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.PartyPlayer player = 1;
 * @return {?proto.entities.PartyPlayer}
 */
proto.events.PartyPlayerDisconnected.prototype.getPlayer = function() {
  return /** @type{?proto.entities.PartyPlayer} */ (
    jspb.Message.getWrapperField(this, entities_party_player_pb.PartyPlayer, 1));
};


/**
 * @param {?proto.entities.PartyPlayer|undefined} value
 * @return {!proto.events.PartyPlayerDisconnected} returns this
*/
proto.events.PartyPlayerDisconnected.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyPlayerDisconnected} returns this
 */
proto.events.PartyPlayerDisconnected.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyPlayerDisconnected.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyPlayerLeft.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyPlayerLeft.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyPlayerLeft} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerLeft.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && entities_party_player_pb.PartyPlayer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyPlayerLeft}
 */
proto.events.PartyPlayerLeft.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyPlayerLeft;
  return proto.events.PartyPlayerLeft.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyPlayerLeft} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyPlayerLeft}
 */
proto.events.PartyPlayerLeft.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_party_player_pb.PartyPlayer;
      reader.readMessage(value,entities_party_player_pb.PartyPlayer.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyPlayerLeft.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyPlayerLeft.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyPlayerLeft} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerLeft.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_party_player_pb.PartyPlayer.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.PartyPlayer player = 1;
 * @return {?proto.entities.PartyPlayer}
 */
proto.events.PartyPlayerLeft.prototype.getPlayer = function() {
  return /** @type{?proto.entities.PartyPlayer} */ (
    jspb.Message.getWrapperField(this, entities_party_player_pb.PartyPlayer, 1));
};


/**
 * @param {?proto.entities.PartyPlayer|undefined} value
 * @return {!proto.events.PartyPlayerLeft} returns this
*/
proto.events.PartyPlayerLeft.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyPlayerLeft} returns this
 */
proto.events.PartyPlayerLeft.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyPlayerLeft.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PartyPlayerReadyStateChanged.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PartyPlayerReadyStateChanged.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PartyPlayerReadyStateChanged} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerReadyStateChanged.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && entities_party_player_pb.PartyPlayer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PartyPlayerReadyStateChanged}
 */
proto.events.PartyPlayerReadyStateChanged.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PartyPlayerReadyStateChanged;
  return proto.events.PartyPlayerReadyStateChanged.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PartyPlayerReadyStateChanged} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PartyPlayerReadyStateChanged}
 */
proto.events.PartyPlayerReadyStateChanged.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new entities_party_player_pb.PartyPlayer;
      reader.readMessage(value,entities_party_player_pb.PartyPlayer.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PartyPlayerReadyStateChanged.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PartyPlayerReadyStateChanged.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PartyPlayerReadyStateChanged} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PartyPlayerReadyStateChanged.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      entities_party_player_pb.PartyPlayer.serializeBinaryToWriter
    );
  }
};


/**
 * optional entities.PartyPlayer player = 2;
 * @return {?proto.entities.PartyPlayer}
 */
proto.events.PartyPlayerReadyStateChanged.prototype.getPlayer = function() {
  return /** @type{?proto.entities.PartyPlayer} */ (
    jspb.Message.getWrapperField(this, entities_party_player_pb.PartyPlayer, 2));
};


/**
 * @param {?proto.entities.PartyPlayer|undefined} value
 * @return {!proto.events.PartyPlayerReadyStateChanged} returns this
*/
proto.events.PartyPlayerReadyStateChanged.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PartyPlayerReadyStateChanged} returns this
 */
proto.events.PartyPlayerReadyStateChanged.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PartyPlayerReadyStateChanged.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.events);

},{"../../entities/party_player_pb.js":112,"google-protobuf":3}],118:[function(require,module,exports){
// source: public/events/player.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var entities_player_pb = require('../../entities/player_pb.js');
goog.object.extend(proto, entities_player_pb);
var validate_validate_pb = require('../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.events.PlayerLoggedIn', null, global);
goog.exportSymbol('proto.events.PlayerLoggedIn.Player', null, global);
goog.exportSymbol('proto.events.PlayerLoggedOut', null, global);
goog.exportSymbol('proto.events.PlayerLoggedOut.Player', null, global);
goog.exportSymbol('proto.events.PlayerStreamClosed', null, global);
goog.exportSymbol('proto.events.PlayerStreamClosed.Player', null, global);
goog.exportSymbol('proto.events.PlayerStreamOpened', null, global);
goog.exportSymbol('proto.events.PlayerStreamOpened.Player', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PlayerStreamOpened = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PlayerStreamOpened, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PlayerStreamOpened.displayName = 'proto.events.PlayerStreamOpened';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PlayerStreamOpened.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PlayerStreamOpened.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PlayerStreamOpened.Player.displayName = 'proto.events.PlayerStreamOpened.Player';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PlayerStreamClosed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PlayerStreamClosed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PlayerStreamClosed.displayName = 'proto.events.PlayerStreamClosed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PlayerStreamClosed.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PlayerStreamClosed.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PlayerStreamClosed.Player.displayName = 'proto.events.PlayerStreamClosed.Player';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PlayerLoggedIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PlayerLoggedIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PlayerLoggedIn.displayName = 'proto.events.PlayerLoggedIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PlayerLoggedIn.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PlayerLoggedIn.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PlayerLoggedIn.Player.displayName = 'proto.events.PlayerLoggedIn.Player';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PlayerLoggedOut = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PlayerLoggedOut, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PlayerLoggedOut.displayName = 'proto.events.PlayerLoggedOut';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.PlayerLoggedOut.Player = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.PlayerLoggedOut.Player, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.PlayerLoggedOut.Player.displayName = 'proto.events.PlayerLoggedOut.Player';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PlayerStreamOpened.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PlayerStreamOpened.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PlayerStreamOpened} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerStreamOpened.toObject = function(includeInstance, msg) {
  var f, obj = {
    streamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    player: (f = msg.getPlayer()) && proto.events.PlayerStreamOpened.Player.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PlayerStreamOpened}
 */
proto.events.PlayerStreamOpened.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PlayerStreamOpened;
  return proto.events.PlayerStreamOpened.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PlayerStreamOpened} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PlayerStreamOpened}
 */
proto.events.PlayerStreamOpened.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamId(value);
      break;
    case 2:
      var value = new proto.events.PlayerStreamOpened.Player;
      reader.readMessage(value,proto.events.PlayerStreamOpened.Player.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PlayerStreamOpened.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PlayerStreamOpened.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PlayerStreamOpened} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerStreamOpened.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStreamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.events.PlayerStreamOpened.Player.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PlayerStreamOpened.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PlayerStreamOpened.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PlayerStreamOpened.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerStreamOpened.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isGuest: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PlayerStreamOpened.Player}
 */
proto.events.PlayerStreamOpened.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PlayerStreamOpened.Player;
  return proto.events.PlayerStreamOpened.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PlayerStreamOpened.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PlayerStreamOpened.Player}
 */
proto.events.PlayerStreamOpened.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGuest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PlayerStreamOpened.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PlayerStreamOpened.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PlayerStreamOpened.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerStreamOpened.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsGuest();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.events.PlayerStreamOpened.Player.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.events.PlayerStreamOpened.Player} returns this
 */
proto.events.PlayerStreamOpened.Player.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_guest = 4;
 * @return {boolean}
 */
proto.events.PlayerStreamOpened.Player.prototype.getIsGuest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.events.PlayerStreamOpened.Player} returns this
 */
proto.events.PlayerStreamOpened.Player.prototype.setIsGuest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string stream_id = 1;
 * @return {string}
 */
proto.events.PlayerStreamOpened.prototype.getStreamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.events.PlayerStreamOpened} returns this
 */
proto.events.PlayerStreamOpened.prototype.setStreamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Player player = 2;
 * @return {?proto.events.PlayerStreamOpened.Player}
 */
proto.events.PlayerStreamOpened.prototype.getPlayer = function() {
  return /** @type{?proto.events.PlayerStreamOpened.Player} */ (
    jspb.Message.getWrapperField(this, proto.events.PlayerStreamOpened.Player, 2));
};


/**
 * @param {?proto.events.PlayerStreamOpened.Player|undefined} value
 * @return {!proto.events.PlayerStreamOpened} returns this
*/
proto.events.PlayerStreamOpened.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PlayerStreamOpened} returns this
 */
proto.events.PlayerStreamOpened.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PlayerStreamOpened.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PlayerStreamClosed.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PlayerStreamClosed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PlayerStreamClosed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerStreamClosed.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && proto.events.PlayerStreamClosed.Player.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PlayerStreamClosed}
 */
proto.events.PlayerStreamClosed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PlayerStreamClosed;
  return proto.events.PlayerStreamClosed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PlayerStreamClosed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PlayerStreamClosed}
 */
proto.events.PlayerStreamClosed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.events.PlayerStreamClosed.Player;
      reader.readMessage(value,proto.events.PlayerStreamClosed.Player.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PlayerStreamClosed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PlayerStreamClosed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PlayerStreamClosed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerStreamClosed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.events.PlayerStreamClosed.Player.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PlayerStreamClosed.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PlayerStreamClosed.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PlayerStreamClosed.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerStreamClosed.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PlayerStreamClosed.Player}
 */
proto.events.PlayerStreamClosed.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PlayerStreamClosed.Player;
  return proto.events.PlayerStreamClosed.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PlayerStreamClosed.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PlayerStreamClosed.Player}
 */
proto.events.PlayerStreamClosed.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PlayerStreamClosed.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PlayerStreamClosed.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PlayerStreamClosed.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerStreamClosed.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.events.PlayerStreamClosed.Player.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.events.PlayerStreamClosed.Player} returns this
 */
proto.events.PlayerStreamClosed.Player.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Player player = 1;
 * @return {?proto.events.PlayerStreamClosed.Player}
 */
proto.events.PlayerStreamClosed.prototype.getPlayer = function() {
  return /** @type{?proto.events.PlayerStreamClosed.Player} */ (
    jspb.Message.getWrapperField(this, proto.events.PlayerStreamClosed.Player, 1));
};


/**
 * @param {?proto.events.PlayerStreamClosed.Player|undefined} value
 * @return {!proto.events.PlayerStreamClosed} returns this
*/
proto.events.PlayerStreamClosed.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PlayerStreamClosed} returns this
 */
proto.events.PlayerStreamClosed.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PlayerStreamClosed.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PlayerLoggedIn.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PlayerLoggedIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PlayerLoggedIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerLoggedIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && proto.events.PlayerLoggedIn.Player.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PlayerLoggedIn}
 */
proto.events.PlayerLoggedIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PlayerLoggedIn;
  return proto.events.PlayerLoggedIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PlayerLoggedIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PlayerLoggedIn}
 */
proto.events.PlayerLoggedIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.events.PlayerLoggedIn.Player;
      reader.readMessage(value,proto.events.PlayerLoggedIn.Player.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PlayerLoggedIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PlayerLoggedIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PlayerLoggedIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerLoggedIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.events.PlayerLoggedIn.Player.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PlayerLoggedIn.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PlayerLoggedIn.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PlayerLoggedIn.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerLoggedIn.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PlayerLoggedIn.Player}
 */
proto.events.PlayerLoggedIn.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PlayerLoggedIn.Player;
  return proto.events.PlayerLoggedIn.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PlayerLoggedIn.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PlayerLoggedIn.Player}
 */
proto.events.PlayerLoggedIn.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PlayerLoggedIn.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PlayerLoggedIn.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PlayerLoggedIn.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerLoggedIn.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.events.PlayerLoggedIn.Player.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.events.PlayerLoggedIn.Player} returns this
 */
proto.events.PlayerLoggedIn.Player.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Player player = 1;
 * @return {?proto.events.PlayerLoggedIn.Player}
 */
proto.events.PlayerLoggedIn.prototype.getPlayer = function() {
  return /** @type{?proto.events.PlayerLoggedIn.Player} */ (
    jspb.Message.getWrapperField(this, proto.events.PlayerLoggedIn.Player, 1));
};


/**
 * @param {?proto.events.PlayerLoggedIn.Player|undefined} value
 * @return {!proto.events.PlayerLoggedIn} returns this
*/
proto.events.PlayerLoggedIn.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PlayerLoggedIn} returns this
 */
proto.events.PlayerLoggedIn.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PlayerLoggedIn.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PlayerLoggedOut.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PlayerLoggedOut.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PlayerLoggedOut} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerLoggedOut.toObject = function(includeInstance, msg) {
  var f, obj = {
    player: (f = msg.getPlayer()) && proto.events.PlayerLoggedOut.Player.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PlayerLoggedOut}
 */
proto.events.PlayerLoggedOut.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PlayerLoggedOut;
  return proto.events.PlayerLoggedOut.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PlayerLoggedOut} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PlayerLoggedOut}
 */
proto.events.PlayerLoggedOut.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.events.PlayerLoggedOut.Player;
      reader.readMessage(value,proto.events.PlayerLoggedOut.Player.deserializeBinaryFromReader);
      msg.setPlayer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PlayerLoggedOut.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PlayerLoggedOut.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PlayerLoggedOut} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerLoggedOut.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.events.PlayerLoggedOut.Player.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.PlayerLoggedOut.Player.prototype.toObject = function(opt_includeInstance) {
  return proto.events.PlayerLoggedOut.Player.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PlayerLoggedOut.Player} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerLoggedOut.Player.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PlayerLoggedOut.Player}
 */
proto.events.PlayerLoggedOut.Player.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.PlayerLoggedOut.Player;
  return proto.events.PlayerLoggedOut.Player.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PlayerLoggedOut.Player} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PlayerLoggedOut.Player}
 */
proto.events.PlayerLoggedOut.Player.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.PlayerLoggedOut.Player.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.PlayerLoggedOut.Player.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PlayerLoggedOut.Player} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.PlayerLoggedOut.Player.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.events.PlayerLoggedOut.Player.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.events.PlayerLoggedOut.Player} returns this
 */
proto.events.PlayerLoggedOut.Player.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Player player = 1;
 * @return {?proto.events.PlayerLoggedOut.Player}
 */
proto.events.PlayerLoggedOut.prototype.getPlayer = function() {
  return /** @type{?proto.events.PlayerLoggedOut.Player} */ (
    jspb.Message.getWrapperField(this, proto.events.PlayerLoggedOut.Player, 1));
};


/**
 * @param {?proto.events.PlayerLoggedOut.Player|undefined} value
 * @return {!proto.events.PlayerLoggedOut} returns this
*/
proto.events.PlayerLoggedOut.prototype.setPlayer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.PlayerLoggedOut} returns this
 */
proto.events.PlayerLoggedOut.prototype.clearPlayer = function() {
  return this.setPlayer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.PlayerLoggedOut.prototype.hasPlayer = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.events);

},{"../../entities/player_pb.js":114,"../../validate/validate_pb.js":122,"google-protobuf":3}],119:[function(require,module,exports){
// source: public/events/quests_progress.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var entities_player_match_pb = require('../../entities/player_match_pb.js');
goog.object.extend(proto, entities_player_match_pb);
goog.exportSymbol('proto.events.GachaProgressReady', null, global);
goog.exportSymbol('proto.events.QuestsProgressReady', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.QuestsProgressReady = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.QuestsProgressReady, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.QuestsProgressReady.displayName = 'proto.events.QuestsProgressReady';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.events.GachaProgressReady = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.events.GachaProgressReady, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.events.GachaProgressReady.displayName = 'proto.events.GachaProgressReady';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.QuestsProgressReady.prototype.toObject = function(opt_includeInstance) {
  return proto.events.QuestsProgressReady.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.QuestsProgressReady} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.QuestsProgressReady.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerMatch: (f = msg.getPlayerMatch()) && entities_player_match_pb.PlayerMatch.toObject(includeInstance, f),
    hasProgress: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.QuestsProgressReady}
 */
proto.events.QuestsProgressReady.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.QuestsProgressReady;
  return proto.events.QuestsProgressReady.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.QuestsProgressReady} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.QuestsProgressReady}
 */
proto.events.QuestsProgressReady.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_player_match_pb.PlayerMatch;
      reader.readMessage(value,entities_player_match_pb.PlayerMatch.deserializeBinaryFromReader);
      msg.setPlayerMatch(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.QuestsProgressReady.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.QuestsProgressReady.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.QuestsProgressReady} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.QuestsProgressReady.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerMatch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_player_match_pb.PlayerMatch.serializeBinaryToWriter
    );
  }
  f = message.getHasProgress();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional entities.PlayerMatch player_match = 1;
 * @return {?proto.entities.PlayerMatch}
 */
proto.events.QuestsProgressReady.prototype.getPlayerMatch = function() {
  return /** @type{?proto.entities.PlayerMatch} */ (
    jspb.Message.getWrapperField(this, entities_player_match_pb.PlayerMatch, 1));
};


/**
 * @param {?proto.entities.PlayerMatch|undefined} value
 * @return {!proto.events.QuestsProgressReady} returns this
*/
proto.events.QuestsProgressReady.prototype.setPlayerMatch = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.QuestsProgressReady} returns this
 */
proto.events.QuestsProgressReady.prototype.clearPlayerMatch = function() {
  return this.setPlayerMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.QuestsProgressReady.prototype.hasPlayerMatch = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool has_progress = 2;
 * @return {boolean}
 */
proto.events.QuestsProgressReady.prototype.getHasProgress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.events.QuestsProgressReady} returns this
 */
proto.events.QuestsProgressReady.prototype.setHasProgress = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.events.GachaProgressReady.prototype.toObject = function(opt_includeInstance) {
  return proto.events.GachaProgressReady.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.GachaProgressReady} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.GachaProgressReady.toObject = function(includeInstance, msg) {
  var f, obj = {
    playerMatch: (f = msg.getPlayerMatch()) && entities_player_match_pb.PlayerMatch.toObject(includeInstance, f),
    hasProgress: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.GachaProgressReady}
 */
proto.events.GachaProgressReady.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.events.GachaProgressReady;
  return proto.events.GachaProgressReady.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.GachaProgressReady} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.GachaProgressReady}
 */
proto.events.GachaProgressReady.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entities_player_match_pb.PlayerMatch;
      reader.readMessage(value,entities_player_match_pb.PlayerMatch.deserializeBinaryFromReader);
      msg.setPlayerMatch(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.events.GachaProgressReady.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.events.GachaProgressReady.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.GachaProgressReady} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.events.GachaProgressReady.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlayerMatch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entities_player_match_pb.PlayerMatch.serializeBinaryToWriter
    );
  }
  f = message.getHasProgress();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional entities.PlayerMatch player_match = 1;
 * @return {?proto.entities.PlayerMatch}
 */
proto.events.GachaProgressReady.prototype.getPlayerMatch = function() {
  return /** @type{?proto.entities.PlayerMatch} */ (
    jspb.Message.getWrapperField(this, entities_player_match_pb.PlayerMatch, 1));
};


/**
 * @param {?proto.entities.PlayerMatch|undefined} value
 * @return {!proto.events.GachaProgressReady} returns this
*/
proto.events.GachaProgressReady.prototype.setPlayerMatch = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.events.GachaProgressReady} returns this
 */
proto.events.GachaProgressReady.prototype.clearPlayerMatch = function() {
  return this.setPlayerMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.events.GachaProgressReady.prototype.hasPlayerMatch = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool has_progress = 2;
 * @return {boolean}
 */
proto.events.GachaProgressReady.prototype.getHasProgress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.events.GachaProgressReady} returns this
 */
proto.events.GachaProgressReady.prototype.setHasProgress = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


goog.object.extend(exports, proto.events);

},{"../../entities/player_match_pb.js":113,"google-protobuf":3}],120:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for public.stream
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var public_event_pb = require('../public/event_pb.js')
const proto = {};
proto.public = {};
proto.public.stream = require('./stream.public_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.stream.StreamClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.public.stream.StreamPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.public.stream.SubscribeStream.Request,
 *   !proto.public.stream.Event>}
 */
const methodDescriptor_Stream_Subscribe = new grpc.web.MethodDescriptor(
  '/public.stream.Stream/Subscribe',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.public.stream.SubscribeStream.Request,
  public_event_pb.Event,
  /**
   * @param {!proto.public.stream.SubscribeStream.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  public_event_pb.Event.deserializeBinary
);


/**
 * @param {!proto.public.stream.SubscribeStream.Request} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.public.stream.Event>}
 *     The XHR Node Readable Stream
 */
proto.public.stream.StreamClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/public.stream.Stream/Subscribe',
      request,
      metadata || {},
      methodDescriptor_Stream_Subscribe);
};


/**
 * @param {!proto.public.stream.SubscribeStream.Request} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.public.stream.Event>}
 *     The XHR Node Readable Stream
 */
proto.public.stream.StreamPromiseClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/public.stream.Stream/Subscribe',
      request,
      metadata || {},
      methodDescriptor_Stream_Subscribe);
};


module.exports = proto.public.stream;


},{"../public/event_pb.js":115,"./stream.public_pb.js":121,"grpc-web":7}],121:[function(require,module,exports){
// source: public/stream.public.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var public_event_pb = require('../public/event_pb.js');
goog.object.extend(proto, public_event_pb);
goog.exportSymbol('proto.public.stream.SubscribeStream', null, global);
goog.exportSymbol('proto.public.stream.SubscribeStream.Request', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.stream.SubscribeStream = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.stream.SubscribeStream, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.stream.SubscribeStream.displayName = 'proto.public.stream.SubscribeStream';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.public.stream.SubscribeStream.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.public.stream.SubscribeStream.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.public.stream.SubscribeStream.Request.displayName = 'proto.public.stream.SubscribeStream.Request';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.stream.SubscribeStream.prototype.toObject = function(opt_includeInstance) {
  return proto.public.stream.SubscribeStream.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.stream.SubscribeStream} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.stream.SubscribeStream.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.stream.SubscribeStream}
 */
proto.public.stream.SubscribeStream.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.stream.SubscribeStream;
  return proto.public.stream.SubscribeStream.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.stream.SubscribeStream} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.stream.SubscribeStream}
 */
proto.public.stream.SubscribeStream.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.stream.SubscribeStream.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.stream.SubscribeStream.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.stream.SubscribeStream} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.stream.SubscribeStream.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.public.stream.SubscribeStream.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.public.stream.SubscribeStream.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.public.stream.SubscribeStream.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.stream.SubscribeStream.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.public.stream.SubscribeStream.Request}
 */
proto.public.stream.SubscribeStream.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.public.stream.SubscribeStream.Request;
  return proto.public.stream.SubscribeStream.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.public.stream.SubscribeStream.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.public.stream.SubscribeStream.Request}
 */
proto.public.stream.SubscribeStream.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.public.stream.SubscribeStream.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.public.stream.SubscribeStream.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.public.stream.SubscribeStream.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.public.stream.SubscribeStream.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.public.stream);

},{"../public/event_pb.js":115,"google-protobuf":3}],122:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],123:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for twitch
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.twitch = require('./twitch_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.twitch.TwitchClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.twitch.TwitchPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.twitch.StreamList>}
 */
const methodDescriptor_Twitch_GetActiveStreams = new grpc.web.MethodDescriptor(
  '/twitch.Twitch/GetActiveStreams',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.twitch.StreamList,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.twitch.StreamList.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.twitch.StreamList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.twitch.StreamList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.twitch.TwitchClient.prototype.getActiveStreams =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/twitch.Twitch/GetActiveStreams',
      request,
      metadata || {},
      methodDescriptor_Twitch_GetActiveStreams,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.twitch.StreamList>}
 *     Promise that resolves to the response
 */
proto.twitch.TwitchPromiseClient.prototype.getActiveStreams =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/twitch.Twitch/GetActiveStreams',
      request,
      metadata || {},
      methodDescriptor_Twitch_GetActiveStreams);
};


module.exports = proto.twitch;


},{"./twitch_pb.js":124,"google-protobuf/google/protobuf/empty_pb.js":5,"grpc-web":7}],124:[function(require,module,exports){
// source: twitch.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.twitch.Stream', null, global);
goog.exportSymbol('proto.twitch.StreamList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.twitch.StreamList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.twitch.StreamList.repeatedFields_, null);
};
goog.inherits(proto.twitch.StreamList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.twitch.StreamList.displayName = 'proto.twitch.StreamList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.twitch.Stream = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.twitch.Stream, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.twitch.Stream.displayName = 'proto.twitch.Stream';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.twitch.StreamList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.twitch.StreamList.prototype.toObject = function(opt_includeInstance) {
  return proto.twitch.StreamList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.twitch.StreamList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.twitch.StreamList.toObject = function(includeInstance, msg) {
  var f, obj = {
    streamsList: jspb.Message.toObjectList(msg.getStreamsList(),
    proto.twitch.Stream.toObject, includeInstance),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.twitch.StreamList}
 */
proto.twitch.StreamList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.twitch.StreamList;
  return proto.twitch.StreamList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.twitch.StreamList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.twitch.StreamList}
 */
proto.twitch.StreamList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.twitch.Stream;
      reader.readMessage(value,proto.twitch.Stream.deserializeBinaryFromReader);
      msg.addStreams(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.twitch.StreamList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.twitch.StreamList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.twitch.StreamList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.twitch.StreamList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStreamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.twitch.Stream.serializeBinaryToWriter
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated Stream streams = 1;
 * @return {!Array<!proto.twitch.Stream>}
 */
proto.twitch.StreamList.prototype.getStreamsList = function() {
  return /** @type{!Array<!proto.twitch.Stream>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.twitch.Stream, 1));
};


/**
 * @param {!Array<!proto.twitch.Stream>} value
 * @return {!proto.twitch.StreamList} returns this
*/
proto.twitch.StreamList.prototype.setStreamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.twitch.Stream=} opt_value
 * @param {number=} opt_index
 * @return {!proto.twitch.Stream}
 */
proto.twitch.StreamList.prototype.addStreams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.twitch.Stream, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.twitch.StreamList} returns this
 */
proto.twitch.StreamList.prototype.clearStreamsList = function() {
  return this.setStreamsList([]);
};


/**
 * optional int64 limit = 2;
 * @return {number}
 */
proto.twitch.StreamList.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.twitch.StreamList} returns this
 */
proto.twitch.StreamList.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.twitch.Stream.prototype.toObject = function(opt_includeInstance) {
  return proto.twitch.Stream.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.twitch.Stream} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.twitch.Stream.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userLogin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    title: jspb.Message.getFieldWithDefault(msg, 5, ""),
    viewerCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    startedAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
    duration: jspb.Message.getFieldWithDefault(msg, 8, 0),
    language: jspb.Message.getFieldWithDefault(msg, 9, ""),
    thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.twitch.Stream}
 */
proto.twitch.Stream.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.twitch.Stream;
  return proto.twitch.Stream.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.twitch.Stream} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.twitch.Stream}
 */
proto.twitch.Stream.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserLogin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setViewerCount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.twitch.Stream.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.twitch.Stream.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.twitch.Stream} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.twitch.Stream.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserLogin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getViewerCount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getStartedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.twitch.Stream.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.twitch.Stream.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_login = 3;
 * @return {string}
 */
proto.twitch.Stream.prototype.getUserLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setUserLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_name = 4;
 * @return {string}
 */
proto.twitch.Stream.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string title = 5;
 * @return {string}
 */
proto.twitch.Stream.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 viewer_count = 6;
 * @return {number}
 */
proto.twitch.Stream.prototype.getViewerCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setViewerCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string started_at = 7;
 * @return {string}
 */
proto.twitch.Stream.prototype.getStartedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setStartedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 duration = 8;
 * @return {number}
 */
proto.twitch.Stream.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string language = 9;
 * @return {string}
 */
proto.twitch.Stream.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string thumbnail_url = 10;
 * @return {string}
 */
proto.twitch.Stream.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.twitch.Stream} returns this
 */
proto.twitch.Stream.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


goog.object.extend(exports, proto.twitch);

},{"google-protobuf":3,"google-protobuf/google/protobuf/empty_pb.js":5}],125:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],126:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for wallets
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')
const proto = {};
proto.wallets = require('./wallets_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.wallets.ConnectServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.wallets.ConnectServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.wallets.BindWallet.Request,
 *   !proto.wallets.BindWallet.Response>}
 */
const methodDescriptor_ConnectService_BindWallet = new grpc.web.MethodDescriptor(
  '/wallets.ConnectService/BindWallet',
  grpc.web.MethodType.UNARY,
  proto.wallets.BindWallet.Request,
  proto.wallets.BindWallet.Response,
  /**
   * @param {!proto.wallets.BindWallet.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.wallets.BindWallet.Response.deserializeBinary
);


/**
 * @param {!proto.wallets.BindWallet.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.wallets.BindWallet.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.wallets.BindWallet.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.wallets.ConnectServiceClient.prototype.bindWallet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/wallets.ConnectService/BindWallet',
      request,
      metadata || {},
      methodDescriptor_ConnectService_BindWallet,
      callback);
};


/**
 * @param {!proto.wallets.BindWallet.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.wallets.BindWallet.Response>}
 *     Promise that resolves to the response
 */
proto.wallets.ConnectServicePromiseClient.prototype.bindWallet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/wallets.ConnectService/BindWallet',
      request,
      metadata || {},
      methodDescriptor_ConnectService_BindWallet);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.wallets.GetBoundWallet.Request,
 *   !proto.wallets.GetBoundWallet.Response>}
 */
const methodDescriptor_ConnectService_GetBoundWallet = new grpc.web.MethodDescriptor(
  '/wallets.ConnectService/GetBoundWallet',
  grpc.web.MethodType.UNARY,
  proto.wallets.GetBoundWallet.Request,
  proto.wallets.GetBoundWallet.Response,
  /**
   * @param {!proto.wallets.GetBoundWallet.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.wallets.GetBoundWallet.Response.deserializeBinary
);


/**
 * @param {!proto.wallets.GetBoundWallet.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.wallets.GetBoundWallet.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.wallets.GetBoundWallet.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.wallets.ConnectServiceClient.prototype.getBoundWallet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/wallets.ConnectService/GetBoundWallet',
      request,
      metadata || {},
      methodDescriptor_ConnectService_GetBoundWallet,
      callback);
};


/**
 * @param {!proto.wallets.GetBoundWallet.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.wallets.GetBoundWallet.Response>}
 *     Promise that resolves to the response
 */
proto.wallets.ConnectServicePromiseClient.prototype.getBoundWallet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/wallets.ConnectService/GetBoundWallet',
      request,
      metadata || {},
      methodDescriptor_ConnectService_GetBoundWallet);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.wallets.RegistryServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.wallets.RegistryServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.wallets.GetWallet.Request,
 *   !proto.wallets.GetWallet.Response>}
 */
const methodDescriptor_RegistryService_GetWallet = new grpc.web.MethodDescriptor(
  '/wallets.RegistryService/GetWallet',
  grpc.web.MethodType.UNARY,
  proto.wallets.GetWallet.Request,
  proto.wallets.GetWallet.Response,
  /**
   * @param {!proto.wallets.GetWallet.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.wallets.GetWallet.Response.deserializeBinary
);


/**
 * @param {!proto.wallets.GetWallet.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.wallets.GetWallet.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.wallets.GetWallet.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.wallets.RegistryServiceClient.prototype.getWallet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/wallets.RegistryService/GetWallet',
      request,
      metadata || {},
      methodDescriptor_RegistryService_GetWallet,
      callback);
};


/**
 * @param {!proto.wallets.GetWallet.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.wallets.GetWallet.Response>}
 *     Promise that resolves to the response
 */
proto.wallets.RegistryServicePromiseClient.prototype.getWallet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/wallets.RegistryService/GetWallet',
      request,
      metadata || {},
      methodDescriptor_RegistryService_GetWallet);
};


module.exports = proto.wallets;


},{"../validate/validate_pb.js":128,"./wallets_pb.js":127,"grpc-web":7}],127:[function(require,module,exports){
// source: v1/wallets.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.wallets.BindWallet', null, global);
goog.exportSymbol('proto.wallets.BindWallet.Request', null, global);
goog.exportSymbol('proto.wallets.BindWallet.Response', null, global);
goog.exportSymbol('proto.wallets.GetBoundWallet', null, global);
goog.exportSymbol('proto.wallets.GetBoundWallet.Request', null, global);
goog.exportSymbol('proto.wallets.GetBoundWallet.Response', null, global);
goog.exportSymbol('proto.wallets.GetWallet', null, global);
goog.exportSymbol('proto.wallets.GetWallet.Request', null, global);
goog.exportSymbol('proto.wallets.GetWallet.Response', null, global);
goog.exportSymbol('proto.wallets.UUID', null, global);
goog.exportSymbol('proto.wallets.Wallet', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.BindWallet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.BindWallet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.BindWallet.displayName = 'proto.wallets.BindWallet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.BindWallet.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.BindWallet.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.BindWallet.Request.displayName = 'proto.wallets.BindWallet.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.BindWallet.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.BindWallet.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.BindWallet.Response.displayName = 'proto.wallets.BindWallet.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.GetBoundWallet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.GetBoundWallet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.GetBoundWallet.displayName = 'proto.wallets.GetBoundWallet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.GetBoundWallet.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.GetBoundWallet.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.GetBoundWallet.Request.displayName = 'proto.wallets.GetBoundWallet.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.GetBoundWallet.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.GetBoundWallet.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.GetBoundWallet.Response.displayName = 'proto.wallets.GetBoundWallet.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.GetWallet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.GetWallet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.GetWallet.displayName = 'proto.wallets.GetWallet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.GetWallet.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.GetWallet.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.GetWallet.Request.displayName = 'proto.wallets.GetWallet.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.GetWallet.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.GetWallet.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.GetWallet.Response.displayName = 'proto.wallets.GetWallet.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.UUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.UUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.UUID.displayName = 'proto.wallets.UUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.Wallet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.Wallet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.Wallet.displayName = 'proto.wallets.Wallet';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.BindWallet.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.BindWallet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.BindWallet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.BindWallet.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.BindWallet}
 */
proto.wallets.BindWallet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.BindWallet;
  return proto.wallets.BindWallet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.BindWallet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.BindWallet}
 */
proto.wallets.BindWallet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.BindWallet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.BindWallet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.BindWallet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.BindWallet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.BindWallet.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.BindWallet.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.BindWallet.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.BindWallet.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    pubKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    signature: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.BindWallet.Request}
 */
proto.wallets.BindWallet.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.BindWallet.Request;
  return proto.wallets.BindWallet.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.BindWallet.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.BindWallet.Request}
 */
proto.wallets.BindWallet.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPubKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.BindWallet.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.BindWallet.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.BindWallet.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.BindWallet.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPubKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSignature();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string pub_key = 1;
 * @return {string}
 */
proto.wallets.BindWallet.Request.prototype.getPubKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wallets.BindWallet.Request} returns this
 */
proto.wallets.BindWallet.Request.prototype.setPubKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string signature = 2;
 * @return {string}
 */
proto.wallets.BindWallet.Request.prototype.getSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wallets.BindWallet.Request} returns this
 */
proto.wallets.BindWallet.Request.prototype.setSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.BindWallet.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.BindWallet.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.BindWallet.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.BindWallet.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.BindWallet.Response}
 */
proto.wallets.BindWallet.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.BindWallet.Response;
  return proto.wallets.BindWallet.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.BindWallet.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.BindWallet.Response}
 */
proto.wallets.BindWallet.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.BindWallet.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.BindWallet.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.BindWallet.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.BindWallet.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.GetBoundWallet.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.GetBoundWallet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.GetBoundWallet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetBoundWallet.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.GetBoundWallet}
 */
proto.wallets.GetBoundWallet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.GetBoundWallet;
  return proto.wallets.GetBoundWallet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.GetBoundWallet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.GetBoundWallet}
 */
proto.wallets.GetBoundWallet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.GetBoundWallet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.GetBoundWallet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.GetBoundWallet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetBoundWallet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.GetBoundWallet.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.GetBoundWallet.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.GetBoundWallet.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetBoundWallet.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.GetBoundWallet.Request}
 */
proto.wallets.GetBoundWallet.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.GetBoundWallet.Request;
  return proto.wallets.GetBoundWallet.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.GetBoundWallet.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.GetBoundWallet.Request}
 */
proto.wallets.GetBoundWallet.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.GetBoundWallet.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.GetBoundWallet.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.GetBoundWallet.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetBoundWallet.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.GetBoundWallet.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.GetBoundWallet.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.GetBoundWallet.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetBoundWallet.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    wallet: (f = msg.getWallet()) && proto.wallets.Wallet.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.GetBoundWallet.Response}
 */
proto.wallets.GetBoundWallet.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.GetBoundWallet.Response;
  return proto.wallets.GetBoundWallet.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.GetBoundWallet.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.GetBoundWallet.Response}
 */
proto.wallets.GetBoundWallet.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wallets.Wallet;
      reader.readMessage(value,proto.wallets.Wallet.deserializeBinaryFromReader);
      msg.setWallet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.GetBoundWallet.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.GetBoundWallet.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.GetBoundWallet.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetBoundWallet.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWallet();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wallets.Wallet.serializeBinaryToWriter
    );
  }
};


/**
 * optional Wallet wallet = 1;
 * @return {?proto.wallets.Wallet}
 */
proto.wallets.GetBoundWallet.Response.prototype.getWallet = function() {
  return /** @type{?proto.wallets.Wallet} */ (
    jspb.Message.getWrapperField(this, proto.wallets.Wallet, 1));
};


/**
 * @param {?proto.wallets.Wallet|undefined} value
 * @return {!proto.wallets.GetBoundWallet.Response} returns this
*/
proto.wallets.GetBoundWallet.Response.prototype.setWallet = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wallets.GetBoundWallet.Response} returns this
 */
proto.wallets.GetBoundWallet.Response.prototype.clearWallet = function() {
  return this.setWallet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wallets.GetBoundWallet.Response.prototype.hasWallet = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.GetWallet.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.GetWallet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.GetWallet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetWallet.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.GetWallet}
 */
proto.wallets.GetWallet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.GetWallet;
  return proto.wallets.GetWallet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.GetWallet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.GetWallet}
 */
proto.wallets.GetWallet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.GetWallet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.GetWallet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.GetWallet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetWallet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.GetWallet.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.GetWallet.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.GetWallet.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetWallet.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: (f = msg.getUserId()) && proto.wallets.UUID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.GetWallet.Request}
 */
proto.wallets.GetWallet.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.GetWallet.Request;
  return proto.wallets.GetWallet.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.GetWallet.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.GetWallet.Request}
 */
proto.wallets.GetWallet.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wallets.UUID;
      reader.readMessage(value,proto.wallets.UUID.deserializeBinaryFromReader);
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.GetWallet.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.GetWallet.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.GetWallet.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetWallet.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wallets.UUID.serializeBinaryToWriter
    );
  }
};


/**
 * optional UUID user_id = 1;
 * @return {?proto.wallets.UUID}
 */
proto.wallets.GetWallet.Request.prototype.getUserId = function() {
  return /** @type{?proto.wallets.UUID} */ (
    jspb.Message.getWrapperField(this, proto.wallets.UUID, 1));
};


/**
 * @param {?proto.wallets.UUID|undefined} value
 * @return {!proto.wallets.GetWallet.Request} returns this
*/
proto.wallets.GetWallet.Request.prototype.setUserId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wallets.GetWallet.Request} returns this
 */
proto.wallets.GetWallet.Request.prototype.clearUserId = function() {
  return this.setUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wallets.GetWallet.Request.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.GetWallet.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.GetWallet.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.GetWallet.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetWallet.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    wallet: (f = msg.getWallet()) && proto.wallets.Wallet.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.GetWallet.Response}
 */
proto.wallets.GetWallet.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.GetWallet.Response;
  return proto.wallets.GetWallet.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.GetWallet.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.GetWallet.Response}
 */
proto.wallets.GetWallet.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wallets.Wallet;
      reader.readMessage(value,proto.wallets.Wallet.deserializeBinaryFromReader);
      msg.setWallet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.GetWallet.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.GetWallet.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.GetWallet.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.GetWallet.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWallet();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wallets.Wallet.serializeBinaryToWriter
    );
  }
};


/**
 * optional Wallet wallet = 1;
 * @return {?proto.wallets.Wallet}
 */
proto.wallets.GetWallet.Response.prototype.getWallet = function() {
  return /** @type{?proto.wallets.Wallet} */ (
    jspb.Message.getWrapperField(this, proto.wallets.Wallet, 1));
};


/**
 * @param {?proto.wallets.Wallet|undefined} value
 * @return {!proto.wallets.GetWallet.Response} returns this
*/
proto.wallets.GetWallet.Response.prototype.setWallet = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wallets.GetWallet.Response} returns this
 */
proto.wallets.GetWallet.Response.prototype.clearWallet = function() {
  return this.setWallet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wallets.GetWallet.Response.prototype.hasWallet = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.UUID.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.UUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.UUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.UUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.UUID}
 */
proto.wallets.UUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.UUID;
  return proto.wallets.UUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.UUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.UUID}
 */
proto.wallets.UUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.UUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.UUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.UUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.UUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.wallets.UUID.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wallets.UUID} returns this
 */
proto.wallets.UUID.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.Wallet.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.Wallet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.Wallet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.Wallet.toObject = function(includeInstance, msg) {
  var f, obj = {
    pubKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.Wallet}
 */
proto.wallets.Wallet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.Wallet;
  return proto.wallets.Wallet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.Wallet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.Wallet}
 */
proto.wallets.Wallet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPubKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.Wallet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.Wallet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.Wallet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.Wallet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPubKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string pub_key = 1;
 * @return {string}
 */
proto.wallets.Wallet.prototype.getPubKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wallets.Wallet} returns this
 */
proto.wallets.Wallet.prototype.setPubKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 created_at = 2;
 * @return {number}
 */
proto.wallets.Wallet.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.wallets.Wallet} returns this
 */
proto.wallets.Wallet.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.wallets);

},{"../validate/validate_pb.js":128,"google-protobuf":3}],128:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}],129:[function(require,module,exports){
/**
 * @fileoverview gRPC-Web generated client stub for wallets.v2
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../validate/validate_pb.js')
const proto = {};
proto.wallets = {};
proto.wallets.v2 = require('./wallets_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.wallets.v2.ConnectServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.wallets.v2.ConnectServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.wallets.v2.GenerateChallengeForBind.Request,
 *   !proto.wallets.v2.GenerateChallengeForBind.Response>}
 */
const methodDescriptor_ConnectService_GenerateChallengeForBind = new grpc.web.MethodDescriptor(
  '/wallets.v2.ConnectService/GenerateChallengeForBind',
  grpc.web.MethodType.UNARY,
  proto.wallets.v2.GenerateChallengeForBind.Request,
  proto.wallets.v2.GenerateChallengeForBind.Response,
  /**
   * @param {!proto.wallets.v2.GenerateChallengeForBind.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.wallets.v2.GenerateChallengeForBind.Response.deserializeBinary
);


/**
 * @param {!proto.wallets.v2.GenerateChallengeForBind.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.wallets.v2.GenerateChallengeForBind.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.wallets.v2.GenerateChallengeForBind.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.wallets.v2.ConnectServiceClient.prototype.generateChallengeForBind =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/wallets.v2.ConnectService/GenerateChallengeForBind',
      request,
      metadata || {},
      methodDescriptor_ConnectService_GenerateChallengeForBind,
      callback);
};


/**
 * @param {!proto.wallets.v2.GenerateChallengeForBind.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.wallets.v2.GenerateChallengeForBind.Response>}
 *     Promise that resolves to the response
 */
proto.wallets.v2.ConnectServicePromiseClient.prototype.generateChallengeForBind =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/wallets.v2.ConnectService/GenerateChallengeForBind',
      request,
      metadata || {},
      methodDescriptor_ConnectService_GenerateChallengeForBind);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.wallets.v2.GenerateChallengeForUnbind.Request,
 *   !proto.wallets.v2.GenerateChallengeForUnbind.Response>}
 */
const methodDescriptor_ConnectService_GenerateChallengeForUnbind = new grpc.web.MethodDescriptor(
  '/wallets.v2.ConnectService/GenerateChallengeForUnbind',
  grpc.web.MethodType.UNARY,
  proto.wallets.v2.GenerateChallengeForUnbind.Request,
  proto.wallets.v2.GenerateChallengeForUnbind.Response,
  /**
   * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.wallets.v2.GenerateChallengeForUnbind.Response.deserializeBinary
);


/**
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.wallets.v2.GenerateChallengeForUnbind.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.wallets.v2.GenerateChallengeForUnbind.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.wallets.v2.ConnectServiceClient.prototype.generateChallengeForUnbind =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/wallets.v2.ConnectService/GenerateChallengeForUnbind',
      request,
      metadata || {},
      methodDescriptor_ConnectService_GenerateChallengeForUnbind,
      callback);
};


/**
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.wallets.v2.GenerateChallengeForUnbind.Response>}
 *     Promise that resolves to the response
 */
proto.wallets.v2.ConnectServicePromiseClient.prototype.generateChallengeForUnbind =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/wallets.v2.ConnectService/GenerateChallengeForUnbind',
      request,
      metadata || {},
      methodDescriptor_ConnectService_GenerateChallengeForUnbind);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.wallets.v2.UnbindWallet.Request,
 *   !proto.wallets.v2.UnbindWallet.Response>}
 */
const methodDescriptor_ConnectService_UnbindWallet = new grpc.web.MethodDescriptor(
  '/wallets.v2.ConnectService/UnbindWallet',
  grpc.web.MethodType.UNARY,
  proto.wallets.v2.UnbindWallet.Request,
  proto.wallets.v2.UnbindWallet.Response,
  /**
   * @param {!proto.wallets.v2.UnbindWallet.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.wallets.v2.UnbindWallet.Response.deserializeBinary
);


/**
 * @param {!proto.wallets.v2.UnbindWallet.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.wallets.v2.UnbindWallet.Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.wallets.v2.UnbindWallet.Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.wallets.v2.ConnectServiceClient.prototype.unbindWallet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/wallets.v2.ConnectService/UnbindWallet',
      request,
      metadata || {},
      methodDescriptor_ConnectService_UnbindWallet,
      callback);
};


/**
 * @param {!proto.wallets.v2.UnbindWallet.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.wallets.v2.UnbindWallet.Response>}
 *     Promise that resolves to the response
 */
proto.wallets.v2.ConnectServicePromiseClient.prototype.unbindWallet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/wallets.v2.ConnectService/UnbindWallet',
      request,
      metadata || {},
      methodDescriptor_ConnectService_UnbindWallet);
};


module.exports = proto.wallets.v2;


},{"../validate/validate_pb.js":131,"./wallets_pb.js":130,"grpc-web":7}],130:[function(require,module,exports){
// source: v2/wallets.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window; }).call(null);

var validate_validate_pb = require('../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.wallets.v2.GenerateChallengeForBind', null, global);
goog.exportSymbol('proto.wallets.v2.GenerateChallengeForBind.Request', null, global);
goog.exportSymbol('proto.wallets.v2.GenerateChallengeForBind.Response', null, global);
goog.exportSymbol('proto.wallets.v2.GenerateChallengeForUnbind', null, global);
goog.exportSymbol('proto.wallets.v2.GenerateChallengeForUnbind.Request', null, global);
goog.exportSymbol('proto.wallets.v2.GenerateChallengeForUnbind.Response', null, global);
goog.exportSymbol('proto.wallets.v2.UnbindWallet', null, global);
goog.exportSymbol('proto.wallets.v2.UnbindWallet.Request', null, global);
goog.exportSymbol('proto.wallets.v2.UnbindWallet.Response', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.GenerateChallengeForBind = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.GenerateChallengeForBind, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.GenerateChallengeForBind.displayName = 'proto.wallets.v2.GenerateChallengeForBind';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.GenerateChallengeForBind.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.GenerateChallengeForBind.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.GenerateChallengeForBind.Request.displayName = 'proto.wallets.v2.GenerateChallengeForBind.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.GenerateChallengeForBind.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.GenerateChallengeForBind.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.GenerateChallengeForBind.Response.displayName = 'proto.wallets.v2.GenerateChallengeForBind.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.GenerateChallengeForUnbind = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.GenerateChallengeForUnbind, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.GenerateChallengeForUnbind.displayName = 'proto.wallets.v2.GenerateChallengeForUnbind';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.GenerateChallengeForUnbind.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.GenerateChallengeForUnbind.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.GenerateChallengeForUnbind.Request.displayName = 'proto.wallets.v2.GenerateChallengeForUnbind.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.GenerateChallengeForUnbind.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.GenerateChallengeForUnbind.Response.displayName = 'proto.wallets.v2.GenerateChallengeForUnbind.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.UnbindWallet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.UnbindWallet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.UnbindWallet.displayName = 'proto.wallets.v2.UnbindWallet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.UnbindWallet.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.UnbindWallet.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.UnbindWallet.Request.displayName = 'proto.wallets.v2.UnbindWallet.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wallets.v2.UnbindWallet.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wallets.v2.UnbindWallet.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wallets.v2.UnbindWallet.Response.displayName = 'proto.wallets.v2.UnbindWallet.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.GenerateChallengeForBind.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.GenerateChallengeForBind.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.GenerateChallengeForBind} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForBind.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.GenerateChallengeForBind}
 */
proto.wallets.v2.GenerateChallengeForBind.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.GenerateChallengeForBind;
  return proto.wallets.v2.GenerateChallengeForBind.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.GenerateChallengeForBind} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.GenerateChallengeForBind}
 */
proto.wallets.v2.GenerateChallengeForBind.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.GenerateChallengeForBind.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.GenerateChallengeForBind.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.GenerateChallengeForBind} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForBind.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.GenerateChallengeForBind.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.GenerateChallengeForBind.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.GenerateChallengeForBind.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForBind.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.GenerateChallengeForBind.Request}
 */
proto.wallets.v2.GenerateChallengeForBind.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.GenerateChallengeForBind.Request;
  return proto.wallets.v2.GenerateChallengeForBind.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.GenerateChallengeForBind.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.GenerateChallengeForBind.Request}
 */
proto.wallets.v2.GenerateChallengeForBind.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.GenerateChallengeForBind.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.GenerateChallengeForBind.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.GenerateChallengeForBind.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForBind.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.GenerateChallengeForBind.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.GenerateChallengeForBind.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.GenerateChallengeForBind.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForBind.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    challenge: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expiresAt: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.GenerateChallengeForBind.Response}
 */
proto.wallets.v2.GenerateChallengeForBind.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.GenerateChallengeForBind.Response;
  return proto.wallets.v2.GenerateChallengeForBind.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.GenerateChallengeForBind.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.GenerateChallengeForBind.Response}
 */
proto.wallets.v2.GenerateChallengeForBind.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChallenge(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.GenerateChallengeForBind.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.GenerateChallengeForBind.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.GenerateChallengeForBind.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForBind.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChallenge();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpiresAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string challenge = 1;
 * @return {string}
 */
proto.wallets.v2.GenerateChallengeForBind.Response.prototype.getChallenge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wallets.v2.GenerateChallengeForBind.Response} returns this
 */
proto.wallets.v2.GenerateChallengeForBind.Response.prototype.setChallenge = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 expires_at = 2;
 * @return {number}
 */
proto.wallets.v2.GenerateChallengeForBind.Response.prototype.getExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.wallets.v2.GenerateChallengeForBind.Response} returns this
 */
proto.wallets.v2.GenerateChallengeForBind.Response.prototype.setExpiresAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.GenerateChallengeForUnbind.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.GenerateChallengeForUnbind.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForUnbind.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.GenerateChallengeForUnbind}
 */
proto.wallets.v2.GenerateChallengeForUnbind.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.GenerateChallengeForUnbind;
  return proto.wallets.v2.GenerateChallengeForUnbind.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.GenerateChallengeForUnbind}
 */
proto.wallets.v2.GenerateChallengeForUnbind.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.GenerateChallengeForUnbind.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.GenerateChallengeForUnbind.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForUnbind.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.GenerateChallengeForUnbind.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForUnbind.Request.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.GenerateChallengeForUnbind.Request}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.GenerateChallengeForUnbind.Request;
  return proto.wallets.v2.GenerateChallengeForUnbind.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.GenerateChallengeForUnbind.Request}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.GenerateChallengeForUnbind.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForUnbind.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.GenerateChallengeForUnbind.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    expiresAt: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.GenerateChallengeForUnbind.Response}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.GenerateChallengeForUnbind.Response;
  return proto.wallets.v2.GenerateChallengeForUnbind.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.GenerateChallengeForUnbind.Response}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.GenerateChallengeForUnbind.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.GenerateChallengeForUnbind.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpiresAt();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 expires_at = 1;
 * @return {number}
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response.prototype.getExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wallets.v2.GenerateChallengeForUnbind.Response} returns this
 */
proto.wallets.v2.GenerateChallengeForUnbind.Response.prototype.setExpiresAt = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.UnbindWallet.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.UnbindWallet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.UnbindWallet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.UnbindWallet.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.UnbindWallet}
 */
proto.wallets.v2.UnbindWallet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.UnbindWallet;
  return proto.wallets.v2.UnbindWallet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.UnbindWallet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.UnbindWallet}
 */
proto.wallets.v2.UnbindWallet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.UnbindWallet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.UnbindWallet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.UnbindWallet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.UnbindWallet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.UnbindWallet.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.UnbindWallet.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.UnbindWallet.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.UnbindWallet.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    challenge: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.UnbindWallet.Request}
 */
proto.wallets.v2.UnbindWallet.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.UnbindWallet.Request;
  return proto.wallets.v2.UnbindWallet.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.UnbindWallet.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.UnbindWallet.Request}
 */
proto.wallets.v2.UnbindWallet.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChallenge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.UnbindWallet.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.UnbindWallet.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.UnbindWallet.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.UnbindWallet.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChallenge();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string challenge = 1;
 * @return {string}
 */
proto.wallets.v2.UnbindWallet.Request.prototype.getChallenge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wallets.v2.UnbindWallet.Request} returns this
 */
proto.wallets.v2.UnbindWallet.Request.prototype.setChallenge = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wallets.v2.UnbindWallet.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.wallets.v2.UnbindWallet.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wallets.v2.UnbindWallet.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.UnbindWallet.Response.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wallets.v2.UnbindWallet.Response}
 */
proto.wallets.v2.UnbindWallet.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wallets.v2.UnbindWallet.Response;
  return proto.wallets.v2.UnbindWallet.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wallets.v2.UnbindWallet.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wallets.v2.UnbindWallet.Response}
 */
proto.wallets.v2.UnbindWallet.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wallets.v2.UnbindWallet.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wallets.v2.UnbindWallet.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wallets.v2.UnbindWallet.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wallets.v2.UnbindWallet.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.wallets.v2);

},{"../validate/validate_pb.js":131,"google-protobuf":3}],131:[function(require,module,exports){
arguments[4][13][0].apply(exports,arguments)
},{"dup":13}]},{},[61])(61)
});
